import Decimal from 'decimal.js';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigInt: { input: any; output: any; }
  Date: { input: any; output: any; }
  Decimal: { input: string; output: Decimal; }
  ISO8601Date: { input: string; output: Date; }
  ISO8601DateTime: { input: string; output: Date; }
  JSON: { input: any; output: any; }
  QuantityDecimal: { input: any; output: any; }
};

export type AbsoluteTime = {
  __typename?: 'AbsoluteTime';
  /** Datetime. */
  datetime: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of AccessWifiMutation */
export type AccessWifiMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Guest's email address */
  email: Scalars['String']['input'];
  /** ID of the microsite location */
  micrositeLocationId: Scalars['ID']['input'];
};

/** Autogenerated return type of AccessWifiMutation. */
export type AccessWifiMutationPayload = {
  __typename?: 'AccessWifiMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The contact record created/updated */
  contact?: Maybe<MicrositeContact>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']['output']>;
  /** WiFi configuration including network credentials */
  wifi?: Maybe<MicrositeWifi>;
};

/** A session for tracking account creation state during signup flows */
export type AccountCreationSession = {
  __typename?: 'AccountCreationSession';
  /** Business address for deferred microsite creation */
  businessAddress?: Maybe<Scalars['String']['output']>;
  /** Business name for deferred microsite creation */
  businessName?: Maybe<Scalars['String']['output']>;
  /** Completion timestamp */
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Creation timestamp */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** User email address */
  email?: Maybe<Scalars['String']['output']>;
  /** Auth0 user ID if existing user */
  existingAuth0UserId?: Maybe<Scalars['String']['output']>;
  /** User first name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Google Places API place ID for deferred microsite creation */
  googlePlaceId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** User last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Associated microsite location ID */
  micrositeLocationId?: Maybe<Scalars['ID']['output']>;
  /** Last update timestamp */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** URL-friendly slug for microsite */
  urlSlug?: Maybe<Scalars['String']['output']>;
};

/** Input for creating or updating an account creation session */
export type AccountCreationSessionInput = {
  /** Business address for deferred microsite creation */
  businessAddress?: InputMaybe<Scalars['String']['input']>;
  /** Business name for deferred microsite creation */
  businessName?: InputMaybe<Scalars['String']['input']>;
  /** Set to true to mark session as complete */
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  /** User email address */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Auth0 user ID if existing user */
  existingAuth0UserId?: InputMaybe<Scalars['String']['input']>;
  /** User first name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Google Places API place ID for deferred microsite creation */
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  /** Session ID for updates */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** User last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Associated microsite location ID */
  micrositeLocationId?: InputMaybe<Scalars['ID']['input']>;
  /** URL-friendly slug for microsite */
  urlSlug?: InputMaybe<Scalars['String']['input']>;
};

/** An account profile representing a location or entity on a platform */
export type AccountProfile = {
  __typename?: 'AccountProfile';
  /** Internal profile record ID */
  id: Scalars['ID']['output'];
  /** Platform identifier */
  platformId: Scalars['String']['output'];
  /** External profile ID from the platform */
  profileId: Scalars['String']['output'];
  /** Profile display name */
  profileName?: Maybe<Scalars['String']['output']>;
};

export type AccountsReceivableCollectionsStatus = {
  __typename?: 'AccountsReceivableCollectionsStatus';
  id: Scalars['ID']['output'];
  locationUuid: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type AccountsReceivableCompanyDashboard = {
  __typename?: 'AccountsReceivableCompanyDashboard';
  /** Reference date for aging bucket calculations */
  asOf: Scalars['ISO8601Date']['output'];
  /** Paginated company summaries */
  companies: AccountsReceivableCompanySummaryConnection;
  /** All company summaries without pagination, for CSV export */
  exportCompanies: Array<AccountsReceivableCompanySummary>;
  /** Link to the NetSuite A/R Aging Report */
  netsuiteAgingReportUrl: Scalars['String']['output'];
};


export type AccountsReceivableCompanyDashboardCompaniesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AccountsReceivableCompanySummary = {
  __typename?: 'AccountsReceivableCompanySummary';
  arAssignee?: Maybe<ArAssignableUser>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyUuid: Scalars['String']['output'];
  creditMemoOffsets: AccountsReceivableCreditOffsets;
  current: Money;
  customerPaymentOffsets: AccountsReceivableCreditOffsets;
  from1To30DaysPastDue: Money;
  from31To60DaysPastDue: Money;
  from61To90DaysPastDue: Money;
  over90DaysPastDue: Money;
  paymentIntentOffsets: AccountsReceivableCreditOffsets;
  totalDue: Money;
  totalPastDue: Money;
};

/** The connection type for AccountsReceivableCompanySummary. */
export type AccountsReceivableCompanySummaryConnection = {
  __typename?: 'AccountsReceivableCompanySummaryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AccountsReceivableCompanySummaryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<AccountsReceivableCompanySummary>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AccountsReceivableCompanySummaryEdge = {
  __typename?: 'AccountsReceivableCompanySummaryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AccountsReceivableCompanySummary>;
};

export type AccountsReceivableCreditOffsets = {
  __typename?: 'AccountsReceivableCreditOffsets';
  current: Money;
  from1To30DaysPastDue: Money;
  from31To60DaysPastDue: Money;
  from61To90DaysPastDue: Money;
  over90DaysPastDue: Money;
  totalDue: Money;
  totalPastDue: Money;
};

export type AccountsReceivableDashboard = {
  __typename?: 'AccountsReceivableDashboard';
  asOf: Scalars['ISO8601Date']['output'];
  companies: AccountsReceivableCompanySummaryConnection;
  exportCompanies: Array<AccountsReceivableCompanySummary>;
  exportLocations: Array<AccountsReceivableLocationSummary>;
  groupBy: AccountsReceivableGroupBy;
  locations: AccountsReceivableLocationSummaryConnection;
};


export type AccountsReceivableDashboardCompaniesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type AccountsReceivableDashboardLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum AccountsReceivableGroupBy {
  /** Group by parent company */
  Company = 'COMPANY',
  /** Group by individual location */
  Location = 'LOCATION'
}

export type AccountsReceivableInvoiceDetail = {
  __typename?: 'AccountsReceivableInvoiceDetail';
  amountRemaining: Money;
  dueDate: Scalars['ISO8601Date']['output'];
  externalOrderId?: Maybe<Scalars['String']['output']>;
  externalOrderPlatform?: Maybe<Scalars['String']['output']>;
  invoiceUuid: Scalars['String']['output'];
  /** Link to this invoice in NetSuite. */
  netsuiteInvoiceUrl: Scalars['String']['output'];
  netsuiteTransactionId: Scalars['String']['output'];
  pendingEarmarkAmount: Money;
  /** Link to the order detail page in the supply portal (Odeko-platform invoices only). */
  portalOrderDetailUrl?: Maybe<Scalars['String']['output']>;
  total: Money;
  transactionDate: Scalars['ISO8601Date']['output'];
  vendorName?: Maybe<Scalars['String']['output']>;
};

export type AccountsReceivableLocationDashboard = {
  __typename?: 'AccountsReceivableLocationDashboard';
  /** Reference date for aging bucket calculations */
  asOf: Scalars['ISO8601Date']['output'];
  /** All location summaries without pagination, for CSV export */
  exportLocations: Array<AccountsReceivableLocationSummary>;
  /** Paginated location summaries */
  locations: AccountsReceivableLocationSummaryConnection;
  /** Link to the NetSuite A/R Aging Report */
  netsuiteAgingReportUrl: Scalars['String']['output'];
};


export type AccountsReceivableLocationDashboardLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AccountsReceivableLocationSummary = {
  __typename?: 'AccountsReceivableLocationSummary';
  arAssignee?: Maybe<ArAssignableUser>;
  autoPay: Scalars['Boolean']['output'];
  autoStatement: Scalars['Boolean']['output'];
  collectionsStatus?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyUuid?: Maybe<Scalars['String']['output']>;
  creditMemoOffsets: AccountsReceivableCreditOffsets;
  current: Money;
  customerPaymentOffsets: AccountsReceivableCreditOffsets;
  from1To30DaysPastDue: Money;
  from31To60DaysPastDue: Money;
  from61To90DaysPastDue: Money;
  invoiceDetails: Array<AccountsReceivableInvoiceDetail>;
  locationName?: Maybe<Scalars['String']['output']>;
  locationUuid: Scalars['String']['output'];
  over90DaysPastDue: Money;
  paymentIntentOffsets: AccountsReceivableCreditOffsets;
  receivableNotes: Array<ReceivableNote>;
  totalDue: Money;
  totalPastDue: Money;
};

/** The connection type for AccountsReceivableLocationSummary. */
export type AccountsReceivableLocationSummaryConnection = {
  __typename?: 'AccountsReceivableLocationSummaryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AccountsReceivableLocationSummaryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<AccountsReceivableLocationSummary>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AccountsReceivableLocationSummaryEdge = {
  __typename?: 'AccountsReceivableLocationSummaryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AccountsReceivableLocationSummary>;
};

/** Autogenerated input type of AcknowledgeBackInStockNotificationMutation */
export type AcknowledgeBackInStockNotificationMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the back-in-stock subscription that triggered this notification */
  subscriptionId: Scalars['ID']['input'];
};

/** Autogenerated return type of AcknowledgeBackInStockNotificationMutation. */
export type AcknowledgeBackInStockNotificationMutationPayload = {
  __typename?: 'AcknowledgeBackInStockNotificationMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<UserError>>;
  notification?: Maybe<BackInStockNotification>;
};

/** Autogenerated input type of AcknowledgeConsumerOrder */
export type AcknowledgeConsumerOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Consumer order ID. */
  consumerOrderId: Scalars['ID']['input'];
  /**
   * Order's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int']['input'];
};

/** Autogenerated return type of AcknowledgeConsumerOrder */
export type AcknowledgeConsumerOrderPayload = {
  __typename?: 'AcknowledgeConsumerOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to acknowledge the order. */
  result: ConsumerOrderResult;
};

/** Autogenerated input type of AcknowledgeDeliveryInstructionReviewMutation */
export type AcknowledgeDeliveryInstructionReviewMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  instructionRevision: Scalars['String']['input'];
  redelivery?: InputMaybe<Scalars['Boolean']['input']>;
  stopId: Scalars['ID']['input'];
};

/** Autogenerated return type of AcknowledgeDeliveryInstructionReviewMutation. */
export type AcknowledgeDeliveryInstructionReviewMutationPayload = {
  __typename?: 'AcknowledgeDeliveryInstructionReviewMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  review?: Maybe<DeliveryInstructionReview>;
  userErrors: Array<UserError>;
};

export type AcquisitionConversion = {
  __typename?: 'AcquisitionConversion';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  netsuiteListId: Scalars['String']['output'];
};

export type ActiveMasterHomepage = {
  __typename?: 'ActiveMasterHomepage';
  endDate: Scalars['ISO8601Date']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  rows: Array<MasterHomepageRow>;
  startDate: Scalars['ISO8601Date']['output'];
};

export type ActualRouteSummary = {
  __typename?: 'ActualRouteSummary';
  /** Planned road distance in miles; null until computed */
  miles?: Maybe<Scalars['Float']['output']>;
  /** Stop count for this route */
  stops: Scalars['Int']['output'];
};

export type ActualRoutesSummary = {
  __typename?: 'ActualRoutesSummary';
  /** Average volume utilization per truck as a percentage */
  avgCubicUtilizationPercent?: Maybe<Scalars['Float']['output']>;
  /** Deliveries per route hour (total stops / driver hours) */
  dprh?: Maybe<Scalars['Float']['output']>;
  /** Sum of driver working time for routes that have completed; null if no routes have completed yet */
  driverHours?: Maybe<Scalars['Float']['output']>;
  /** Number of non-lobby dispatched routes */
  routeCount: Scalars['Int']['output'];
  /** Per-route stop count and planned distance */
  routes: Array<ActualRouteSummary>;
  /**
   * Sum of planned_distance_miles for routes that have a computed value, excluding
   * routes whose every delivery stop is Metrobi (third-party); null if no routes
   * have been computed yet
   */
  totalDistanceMiles?: Maybe<Scalars['Float']['output']>;
  /** Total stops across all dispatched routes */
  totalStops: Scalars['Int']['output'];
};

/** Autogenerated input type of AdHocAppointmentCreate */
export type AdHocAppointmentCreateInput = {
  /** Who's arriving — the one thing ops always has. */
  carrierName: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Notes or special instructions for the delivery. */
  comments?: InputMaybe<Scalars['String']['input']>;
  /** Email the booking confirmation is sent to. */
  confirmationEmail?: InputMaybe<Scalars['String']['input']>;
  /** Contact email for the delivery. */
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  /** Contact person for the delivery. */
  contactName?: InputMaybe<Scalars['String']['input']>;
  /** Contact phone for the delivery. */
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  /** How the delivery is prioritized. */
  deliveryType?: InputMaybe<DeliveryType>;
  freightType: FreightType;
  /** Carrier PRO (tracking) number. */
  proNumber?: InputMaybe<Scalars['String']['input']>;
  /** A known PO/TO reference. Omit for the PO-unknown path. */
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  /** Standard Carrier Alpha Code, if known. */
  scacCode?: InputMaybe<Scalars['String']['input']>;
  /** Date the freight ships, if known. */
  shipDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  slotStartsAt: Scalars['ISO8601DateTime']['input'];
  /** Truck or trailer number. */
  truckNumber?: InputMaybe<Scalars['String']['input']>;
  /** PO-unknown path only — links the booking to a NetSuite vendor if ops knows it. */
  vendorNetsuiteEntityInternalId?: InputMaybe<Scalars['String']['input']>;
  /** Required for the PO-unknown path; ignored otherwise (the confirmed reference's own warehouse is authoritative). */
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of AdHocAppointmentCreate. */
export type AdHocAppointmentCreatePayload = {
  __typename?: 'AdHocAppointmentCreatePayload';
  booking?: Maybe<DockBooking>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userErrors: Array<DockBookingError>;
};

export type AdHocAppointmentsNotAllowed = UserErrorInterface & {
  __typename?: 'AdHocAppointmentsNotAllowed';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** Input for adding an item to the cart. */
export type AddCartItemInput = {
  /** MenuItem ID */
  menuItemId: Scalars['ID']['input'];
  /** MenuItemSize ID */
  menuItemSizeId: Scalars['ID']['input'];
  /** List of cart item modifiers. */
  modifiers: Array<CartItemModifierInput>;
  /** Note. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Quantity */
  quantity: Scalars['Int']['input'];
  /** Expected unit price of MenuItemSize. Item will only be added if its current price matches the expected price. */
  unitPrice: MoneyInput;
};

/** Data that was provided as mutation input. */
export type AddCartItemInputEcho = {
  __typename?: 'AddCartItemInputEcho';
  /** MenuItem ID */
  menuItemId: Scalars['ID']['output'];
  /** MenuItemSize ID */
  menuItemSizeId: Scalars['ID']['output'];
  /** List of cart item modifiers. */
  modifiers: Array<CartItemModifierInputEcho>;
  /** Quantity */
  quantity: Scalars['Int']['output'];
  /** Expected unit price of MenuItemSize. Item will only be added if its current price matches the expected price. */
  unitPrice: Money;
};

/** Autogenerated input type of AddFavoriteConsumerOrder */
export type AddFavoriteConsumerOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Consumer order ID. */
  consumerOrderId: Scalars['ID']['input'];
  /** Icon. */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** Name. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AddFavoriteConsumerOrder */
export type AddFavoriteConsumerOrderPayload = {
  __typename?: 'AddFavoriteConsumerOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to add the favorite. */
  result: FavoriteConsumerOrderResult;
};

/** Autogenerated input type of AddItemsToCart */
export type AddItemsToCartInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Opaque token identifying a specific version of the cart. */
  fingerprint: Scalars['String']['input'];
  /** List of items to add to the cart. */
  items: Array<AddCartItemInput>;
};

/** Autogenerated return type of AddItemsToCart */
export type AddItemsToCartPayload = {
  __typename?: 'AddItemsToCartPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to add items to the cart. */
  result: CartResult;
};

/** Autogenerated input type of AddMicrositeMutation */
export type AddMicrositeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Google Config Doc for the microsite */
  googleDocUrl?: InputMaybe<Scalars['String']['input']>;
  /** Google Place ID to initialize microsite from */
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  /** Optional Odeko UUID of the microsite location */
  locationId?: InputMaybe<Scalars['ID']['input']>;
  /** Time zone for the microsite location */
  timeZone?: InputMaybe<MicrositeTimeZone>;
  /** Url ID (url param) of the microsite's url */
  urlId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddMicrositeMutation. */
export type AddMicrositeMutationPayload = {
  __typename?: 'AddMicrositeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  micrositeAdminLocation: MicrositeLocationAdmin;
};

export type Address = {
  __typename?: 'Address';
  /** The first line of the address */
  addressLine1: Scalars['String']['output'];
  /** The second line of the address */
  addressLine2?: Maybe<Scalars['String']['output']>;
  /** The state or province for the address i.e CA */
  adminDistrictLevel1: Scalars['String']['output'];
  /** @deprecated This field is deprecated, please use 'locality' instead. */
  city: Scalars['String']['output'];
  /** The country code for the address i.e US */
  countryCode: Scalars['String']['output'];
  /** The latitude of the address */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** The city for the address i.e New York */
  locality: Scalars['String']['output'];
  /** The longitude of the address */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** The postal code for the address i.e 91711 */
  postalCode: Scalars['String']['output'];
  /** @deprecated This field is deprecated, please use 'admin_district_level_1' instead. */
  state: Scalars['String']['output'];
};

export type Admin = {
  __typename?: 'Admin';
  email?: Maybe<Scalars['String']['output']>;
  hubspotOwnerId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type AgentArtifact = {
  __typename?: 'AgentArtifact';
  byteSize: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  metadata: Scalars['JSON']['output'];
  sha256: Scalars['String']['output'];
  textPreview?: Maybe<Scalars['String']['output']>;
};

export type AgentRun = {
  __typename?: 'AgentRun';
  artifacts: Array<AgentArtifact>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  engine: Scalars['String']['output'];
  engineSessionId?: Maybe<Scalars['String']['output']>;
  errorClass?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  lastHeartbeatAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  phase: Scalars['String']['output'];
  runtime: Scalars['String']['output'];
  startedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: Scalars['String']['output'];
  vendorSessionId?: Maybe<Scalars['String']['output']>;
};


export type AgentRunArtifactsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Structured analytics tags for Algolia search segmentation. */
export type AlgoliaAnalyticsTagInput = {
  /** Location UUID */
  locationId?: InputMaybe<Scalars['ID']['input']>;
  /** Platform identifier */
  platform?: InputMaybe<PlatformType>;
  /** Warehouse identifier (e.g., 'DEN1', 'NYC1') */
  warehouse?: InputMaybe<Scalars['String']['input']>;
  /** Warehouse UUID */
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};

export type AllowanceRecipient = Node & {
  __typename?: 'AllowanceRecipient';
  /** Email. */
  email: Scalars['String']['output'];
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID']['output'];
};

/** The connection type for AllowanceRecipient. */
export type AllowanceRecipientConnection = {
  __typename?: 'AllowanceRecipientConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AllowanceRecipientEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<AllowanceRecipient>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AllowanceRecipientEdge = {
  __typename?: 'AllowanceRecipientEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AllowanceRecipient>;
};

/** AllowanceRecipient sort criteria */
export type AllowanceRecipientOrderBy = {
  /** Email. */
  email?: InputMaybe<OrderByEnum>;
};

export type AlreadyReportedReason = UserErrorInterface & {
  __typename?: 'AlreadyReportedReason';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/**
 * Error indicating that an UpdateCartItems mutation failed due to ambiguity
 * introduced by the provided inputs. This can occur if two or more inputs are
 * given for the same cart item, or if an inputs lists the same modifier more than
 * once. Note that we take an all-or-nothing approach when updating cart items, so
 * any ambiguity will abort the entire operation.
 */
export type AmbiguousCartItemUpdates = Error & {
  __typename?: 'AmbiguousCartItemUpdates';
  /** First UpdateCartItemInput involved in the ambiguity. */
  head: UpdateCartItemInputEcho;
  /** A description of the error. */
  message: Scalars['String']['output'];
  /** List (possibly empty) of additional UpdateCartItemInput objects involved in the ambiguity. */
  tail: Array<UpdateCartItemInputEcho>;
};

export type ApplicableFeesItemInput = {
  id: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type ApplicableFeesSkuInput = {
  /** SKU ID */
  id: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

/** Autogenerated input type of ApplyReward */
export type ApplyRewardInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Opaque token identifying a specific version of the cart. */
  fingerprint: Scalars['String']['input'];
  /** Reward ID. */
  rewardId: Scalars['ID']['input'];
};

/** Autogenerated return type of ApplyReward */
export type ApplyRewardPayload = {
  __typename?: 'ApplyRewardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to apply reward. */
  result: CartResult;
};

/** Autogenerated input type of ApplyRoutingConfiguration */
export type ApplyRoutingConfigurationInput = {
  /** Whether Routific routes around toll roads. */
  avoidTolls?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether Routific balances workload across vehicles. */
  balance?: InputMaybe<Scalars['Boolean']['input']>;
  /** Length in minutes of the driver break. 0 is treated as omitted (nothing to set). */
  breakDurationMinutes?: InputMaybe<Scalars['Int']['input']>;
  /** How much of each truck's max capacity to route against, 1-100. 100 is the current configuration. */
  capacityPercent?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Per-cohort on/off + pinned truck counts + stop caps to persist. truckCount
   * pins the cohort's fleet; enabled (when sent) sets its on/off; maxStops (when
   * sent) sets its per-cohort stop cap (null clears it). Omit to leave the
   * warehouse's cohort configuration unchanged.
   */
  cohorts?: InputMaybe<Array<RoutingCohortInput>>;
  /** Driver shift length in hours. Keeps the shift start and sets the end to start + this many hours. */
  driverShiftHours?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Whether a cohort with no per-cohort stop cap falls back to 25 stops per
   * vehicle. True (default) caps at 25; false routes it uncapped. A set per-cohort
   * maxStops always binds regardless.
   */
  maxStopsPerVehicle?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether Routific minimizes the number of vehicles used. */
  minVehicles?: InputMaybe<Scalars['Boolean']['input']>;
  /** Allowed overtime in minutes. 0 means none. */
  overtimeMinutes?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Routing rule overrides to persist, keyed by rule id, e.g. {
   * "frozen_items_first": { "enabled": true, "hours": 1 } }. Omit to leave the
   * warehouse's rules unchanged.
   */
  rules?: InputMaybe<Scalars['JSON']['input']>;
  /** Whether Routific optimizes for shortest distance rather than time. */
  shortestDistance?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the nightly 3PD (Metrobi) auto-marking sweep runs for this warehouse. */
  thirdPartyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Per-vehicle-type fleet composition (count + capacity percent) to persist. Only
   * honored when multi-fleet is enabled for the warehouse; ignored otherwise. Omit
   * to leave the fleet composition unchanged; an empty list clears it.
   */
  vehicles?: InputMaybe<Array<FleetVehicleInput>>;
  /** Routific visit-balance coefficient (>= 0). 0 disables balancing by coefficient. */
  visitBalanceCoefficient?: InputMaybe<Scalars['Float']['input']>;
  /** Warehouse whose standing configuration to write. */
  warehouseId: Scalars['ID']['input'];
};

/** Autogenerated return type of ApplyRoutingConfiguration. */
export type ApplyRoutingConfigurationPayload = {
  __typename?: 'ApplyRoutingConfigurationPayload';
  /** True when the apply ran without error (including a no-op re-apply). */
  applied: Scalars['Boolean']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userErrors: Array<RoutingConfigurationError>;
};

export type AppointmentInPast = UserErrorInterface & {
  __typename?: 'AppointmentInPast';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of ApproveCutoffDiscrepancy */
export type ApproveCutoffDiscrepancyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationsVendorId: Scalars['ID']['input'];
};

/** Autogenerated return type of ApproveCutoffDiscrepancy. */
export type ApproveCutoffDiscrepancyPayload = {
  __typename?: 'ApproveCutoffDiscrepancyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  cutoffDiscrepancyApproval?: Maybe<CutoffDiscrepancyApproval>;
  errors: Array<UserError>;
};

export type ArAssignableUser = {
  __typename?: 'ArAssignableUser';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export type ArAssignment = {
  __typename?: 'ArAssignment';
  assignedByUuid?: Maybe<Scalars['String']['output']>;
  assigneeUuid: Scalars['String']['output'];
  companyUuid: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ArtworkUpload = {
  __typename?: 'ArtworkUpload';
  key: Scalars['String']['output'];
  publicUrl: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Autogenerated input type of AssignCustomerTagMutation */
export type AssignCustomerTagMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Odeko UUID of the location to tag. */
  locationId: Scalars['ID']['input'];
  /** Id of the tag to apply, as returned by CustomerTag.id. */
  tagId: Scalars['ID']['input'];
};

/** Autogenerated return type of AssignCustomerTagMutation. */
export type AssignCustomerTagMutationPayload = {
  __typename?: 'AssignCustomerTagMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  location?: Maybe<Location>;
};

export type AssociateBadgePayload = {
  __typename?: 'AssociateBadgePayload';
  /** ARMHR employee code, for display. Not part of the QR payload. */
  associateId: Scalars['String']['output'];
  /** WarehouseAssociate id. */
  employeeId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /**
   * Newline-delimited badge QR contents: RF-SMART login and password (when a
   * credential exists) stacked above the associate's id (the employeeId uuid),
   * which is always the last line and is the identity the public self-* operations
   * accept. Carries a live password — handle accordingly.
   */
  payload: Scalars['String']['output'];
};

export type Attachment = {
  __typename?: 'Attachment';
  attachmentCategory: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  objectKey: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Autogenerated input type of AttachmentUrlPresignerCreate */
export type AttachmentUrlPresignerCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AttachmentUrlPresignerCreate. */
export type AttachmentUrlPresignerCreatePayload = {
  __typename?: 'AttachmentUrlPresignerCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  objectKey?: Maybe<Scalars['String']['output']>;
  presignedReadUrl?: Maybe<Scalars['String']['output']>;
  presignedUrl?: Maybe<Scalars['String']['output']>;
  userErrors: Array<PresignerError>;
};

export type AuditLog = {
  __typename?: 'AuditLog';
  causedBy: AuditLogCausedBy;
  changeType: AuditLogChangeType;
  date: Scalars['ISO8601DateTime']['output'];
  field: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  itemId?: Maybe<Scalars['ID']['output']>;
  newValue: Scalars['String']['output'];
  objectId: Scalars['String']['output'];
  objectType: Scalars['String']['output'];
  oldValue: Scalars['String']['output'];
  user?: Maybe<User>;
};

export enum AuditLogCausedBy {
  Graphql = 'GRAPHQL',
  Job = 'JOB',
  Kafka = 'KAFKA',
  User = 'USER',
  UserImport = 'USER_IMPORT'
}

export enum AuditLogChangeType {
  Delete = 'DELETE',
  New = 'NEW',
  Set = 'SET'
}

export type AuditLogConnection = {
  __typename?: 'AuditLogConnection';
  edges: Array<Maybe<AuditLogEdge>>;
  nodes: Array<Maybe<AuditLog>>;
  pageInfo: PageInfo;
};

export type AuditLogEdge = {
  __typename?: 'AuditLogEdge';
  cursor: Scalars['String']['output'];
  node: AuditLog;
};

export type AuditLogInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type AuditLogObjectInput = {
  id: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export enum AuditLogSortOrder {
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC'
}

export type AuditReputation = {
  __typename?: 'AuditReputation';
  googleLocationId: Scalars['String']['output'];
  last7Days: TimePeriod;
  last14Days: TimePeriod;
  last30Days: TimePeriod;
  rating: Rating;
  reviewSentiments: ReviewSentiments;
  reviews: Array<Review>;
  timeseries: Array<TimeseriesEntry>;
};

/** Underlying audited model a changeHistory event came from. */
export enum AuditResourceKind {
  /** Versions on the line-level reason rows attached to the OrderLine. */
  LineLevelDeliveryIssue = 'LINE_LEVEL_DELIVERY_ISSUE',
  /** Versions on the OrderLine row itself (delivered_quantity, fulfillment_quantity, recovery_quantity once it lands). */
  OrderLine = 'ORDER_LINE'
}

export type AuthorizeUrl = {
  __typename?: 'AuthorizeUrl';
  url: Scalars['String']['output'];
};

export type AutomatedRoutingExclusion = {
  __typename?: 'AutomatedRoutingExclusion';
  /** The location associated with the excluded stop */
  locationId: Scalars['ID']['output'];
  /** The location name captured when the run input was built */
  locationName?: Maybe<Scalars['String']['output']>;
  reason: AutomatedRoutingExclusionReason;
  /** The delivery route stop excluded from this run */
  stopId: Scalars['ID']['output'];
};

export enum AutomatedRoutingExclusionReason {
  /** The location had automated routing turned off when this run's input was built. */
  AutomatedRoutingDisabled = 'automated_routing_disabled'
}

export type AutomatedRoutingPending = UserErrorInterface & {
  __typename?: 'AutomatedRoutingPending';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type AutomaticDiscount = {
  __typename?: 'AutomaticDiscount';
  /** Discount applied from this automatic discount */
  discount: Money;
  /** Voucherify ID of automatic discount */
  id: Scalars['String']['output'];
  /** Name of the automatic discount in Voucherify */
  name: Scalars['String']['output'];
  /** The number of times the automatic discount can be redeemed (or null, if unlimited). */
  redemptionsAvailable?: Maybe<Scalars['Int']['output']>;
};

export type AvailabilityInterval = {
  /** Lower bound. */
  lowerBound: Scalars['ISO8601DateTime']['output'];
  /** Upper bound. */
  upperBound: Scalars['ISO8601DateTime']['output'];
};

/** A delivery day available for delivery for a location */
export type AvailableDeliveryDay = {
  __typename?: 'AvailableDeliveryDay';
  /** The day name (e.g., "Monday", "Tuesday") */
  dayName: Scalars['String']['output'];
  /** The day of the week as an integer (0=Sunday, 1=Monday, ..., 6=Saturday) */
  dayOfWeek: Scalars['Int']['output'];
  /** Lead time in days from order to delivery */
  leadTime: Scalars['Int']['output'];
  /** The next available delivery date for this day/vendor combination */
  nextDeliveryDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Order deadline time for this delivery day (e.g., "10:00"), also known as the order cutoff time */
  orderDeadline: Scalars['String']['output'];
  /** The vendor associated with this delivery day */
  vendor: Vendor;
};

export type AvailableInterval = AvailabilityInterval & {
  __typename?: 'AvailableInterval';
  /** Lower bound. */
  lowerBound: Scalars['ISO8601DateTime']['output'];
  /** Upper bound. */
  upperBound: Scalars['ISO8601DateTime']['output'];
};

export type BackInStockNotification = {
  __typename?: 'BackInStockNotification';
  acknowledgedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  backInStockAt: Scalars['ISO8601DateTime']['output'];
  desiredQuantity: Scalars['Int']['output'];
  item: SupplyItem;
  /** The location's SKU for the notification's product, if one exists. */
  sku?: Maybe<Sku>;
  subscription: BackInStockSubscription;
  user: User;
};

export type BackInStockSubscription = {
  __typename?: 'BackInStockSubscription';
  backInStockAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  desiredQuantity: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  item: SupplyItem;
  notificationAcknowledgedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
};

/**
 * Error indicating that a mutation failed due to a bad payment processor request.
 * This occurs when expired, unsupported, or otherwise invalid payment details are
 * provided. The request should not be retried until the problem is corrected.
 */
export type BadPaymentProcessorRequestError = Error & {
  __typename?: 'BadPaymentProcessorRequestError';
  /** A code characterizing the type of error. */
  code: Scalars['String']['output'];
  /** A description of the error. */
  message: Scalars['String']['output'];
};

export type BankAccount = {
  __typename?: 'BankAccount';
  bankName: Scalars['String']['output'];
  /**
   * Locations for which this payment method is currently the default. Lists every
   * such location, including ones the viewer is not individually assigned to, so a
   * caller can state the true scope of removing the method. Empty when the method
   * is nobody's default.
   */
  defaultForLocations: Array<PaymentMethodDefaultLocation>;
  id: Scalars['ID']['output'];
  last4: Scalars['String']['output'];
  lastPaymentError?: Maybe<PaymentError>;
};

export type BaseBrandedItem = {
  /** Colors that are available for the item */
  baseBrandedItemColors: Array<BaseBrandedItemColor>;
  /** Quantity ranges that differentiate price breaks for the item */
  baseBrandedItemQuantityRanges: Array<BaseBrandedItemQuantityRange>;
  baseColor?: Maybe<Color>;
  bottomLayerColor?: Maybe<Color>;
  /** Artwork options for the item */
  brandedItemArtworks: Array<BrandedItemArtwork>;
  category: Category;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrls: Array<Scalars['String']['output']>;
  itemSizeLabel?: Maybe<Scalars['String']['output']>;
  materialType?: Maybe<Scalars['String']['output']>;
  maxOrderQty?: Maybe<Scalars['Int']['output']>;
  minOrderQty: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  printingMethod: PrintingMethod;
  purchaseMultiple: Scalars['Int']['output'];
  salesUnit: Unit;
  shape?: Maybe<Scalars['String']['output']>;
  subcategory: Category;
  wallType?: Maybe<Scalars['String']['output']>;
  /** Warehouses the item is available in */
  warehouseBaseBrandedItems: Array<WarehouseBaseBrandedItem>;
};

export type BaseBrandedItemColor = {
  __typename?: 'BaseBrandedItemColor';
  centsPerSaleUnit?: Maybe<Scalars['Int']['output']>;
  color: Color;
  hexCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
};

export type BaseBrandedItemColorInput = {
  /** The cents price of the color per sale unit */
  centsPerSaleUnit?: InputMaybe<Scalars['Int']['input']>;
  /** the id of the color to be used in base branded item color */
  id: Scalars['ID']['input'];
};

export type BaseBrandedItemInput = {
  /** Base color of the item */
  baseColor?: InputMaybe<Scalars['ID']['input']>;
  /** Bottom layer color of the item */
  bottomLayerColor?: InputMaybe<Scalars['ID']['input']>;
  /** Item's category */
  category: Scalars['ID']['input'];
  /** Colors that are available for the item, including color price */
  colors: Array<BaseBrandedItemColorInput>;
  /** Description of item */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Images for item */
  imageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Size label of the item (e.g. '16oz', '10-24oz') */
  itemSizeLabel?: InputMaybe<Scalars['String']['input']>;
  /** Material type of the item (e.g. 'Compostable') */
  materialType?: InputMaybe<Scalars['String']['input']>;
  maxOrderQty?: InputMaybe<Scalars['Int']['input']>;
  minOrderQty: Scalars['Int']['input'];
  /** Name of the base branded item */
  name: Scalars['String']['input'];
  purchaseMultiple: Scalars['Int']['input'];
  /** Quantity ranges that differentiate price breaks for the item */
  quantityRanges: Array<BaseBrandedItemQuantityRangeInput>;
  /** Units item sold in */
  salesUnit: Scalars['ID']['input'];
  /** Shape of the item */
  shape?: InputMaybe<Scalars['String']['input']>;
  /** Item's subcategory */
  subcategory: Scalars['ID']['input'];
  /** Wall type of the item (e.g. 'Double Wall') */
  wallType?: InputMaybe<Scalars['String']['input']>;
  /** Warehouses the item is available in */
  warehouses: Array<WarehouseBaseBrandedItemInput>;
};

export type BaseBrandedItemQuantityRange = {
  __typename?: 'BaseBrandedItemQuantityRange';
  endQuantity?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  startQuantity: Scalars['Int']['output'];
};

export type BaseBrandedItemQuantityRangeInput = {
  endQuantity?: InputMaybe<Scalars['Int']['input']>;
  startQuantity: Scalars['Int']['input'];
};

/** Autogenerated input type of BatchOnboardInProgressCustomersMutation */
export type BatchOnboardInProgressCustomersMutationInput = {
  acquisitionConversionId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Onboard exactly these records. Selecting a failed record is the decision to retry it. */
  inProgressCustomerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Cap on how many records the run will onboard. Absent, it drains every eligible record. */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of BatchOnboardInProgressCustomersMutation. */
export type BatchOnboardInProgressCustomersMutationPayload = {
  __typename?: 'BatchOnboardInProgressCustomersMutationPayload';
  batchOnboardRun?: Maybe<BatchOnboardRun>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Records handed off on the first tick. */
  enqueuedCount?: Maybe<Scalars['Int']['output']>;
  errors: Array<Scalars['String']['output']>;
  /** Eligible records the later ticks will pick up. */
  remainingEligibleCount?: Maybe<Scalars['Int']['output']>;
  /** A stalled run this one retired on the way in. */
  retiredRun?: Maybe<BatchOnboardRun>;
};

/** One triggered batch of in-progress customers moving from ready to onboarded. */
export type BatchOnboardRun = {
  __typename?: 'BatchOnboardRun';
  finished: Scalars['Boolean']['output'];
  /** Set once every record the run handed off has left the pipeline, or when an operator stopped it. */
  finishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  requestedBy: Scalars['String']['output'];
  /** How many records the run set out to onboard. */
  requestedCount: Scalars['Int']['output'];
  /** Unfinished with no tick inside the staleness window: its schedule was lost. Retire it, or start a new run over it. */
  stalled: Scalars['Boolean']['output'];
  startedAt: Scalars['ISO8601DateTime']['output'];
};

export type BatchedDeposit = Node & {
  __typename?: 'BatchedDeposit';
  /** Gross earnings for the period, in cents */
  earnedSubtotalCents?: Maybe<Scalars['Int']['output']>;
  /** Currency code of gross earnings */
  earnedSubtotalCurrency: Scalars['String']['output'];
  /** Memo describing the deposit */
  externalMemo?: Maybe<Scalars['String']['output']>;
  /** End of the period deposits were batched for */
  for: Scalars['ISO8601Date']['output'];
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID']['output'];
  /** Transaction id last fetched from the payment processor */
  lastKnownTransactionId?: Maybe<Scalars['String']['output']>;
  /** Transaction status last fetched from the payment processor */
  lastKnownTransactionStatus?: Maybe<Scalars['String']['output']>;
  /** Merchant deposits were batched for */
  merchant: Merchant;
  /** Amount deducted to pay down merchant's outstanding balance, in cents */
  outstandingCents?: Maybe<Scalars['Int']['output']>;
  /** Currency code of amount deducted */
  outstandingCurrency: Scalars['String']['output'];
  /** Type of period deposits were batched for */
  period: BatchedDepositPeriodEnum;
  /** When the deposit was submitted to the payment processor */
  submittedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Net amount deposited in merchant's account, in cents */
  totalCents?: Maybe<Scalars['Int']['output']>;
  /** Currency code of net amount */
  totalCurrency: Scalars['String']['output'];
};

/** The connection type for BatchedDeposit. */
export type BatchedDepositConnection = {
  __typename?: 'BatchedDepositConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BatchedDepositEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<BatchedDeposit>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type BatchedDepositEdge = {
  __typename?: 'BatchedDepositEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<BatchedDeposit>;
};

/** BatchedDeposit sort criteria */
export type BatchedDepositOrderBy = {
  /** End of the period deposits were batched for */
  for?: InputMaybe<OrderByEnum>;
};

/** BatchedDeposit period values */
export enum BatchedDepositPeriodEnum {
  /** Deposits batched daily */
  Daily = 'daily',
  /** Single, non-recurring batch */
  OneOff = 'one_off',
  /** Deposits batched weekly */
  Weekly = 'weekly'
}

/** A per-bay grid-unit offset that nudges one bay off its computed run cell within a source-backed group. */
export type BayOffset = {
  __typename?: 'BayOffset';
  /** Bay number within the group (stable across bay_order flip). */
  bay: Scalars['Int']['output'];
  /** Grid cells to shift the bay horizontally. */
  dx: Scalars['Int']['output'];
  /** Grid cells to shift the bay vertically. */
  dy: Scalars['Int']['output'];
};

/** A per-bay grid-unit offset to persist. A bay with no entry sits at its computed run cell. */
export type BayOffsetInput = {
  /** Bay number within the group. */
  bay: Scalars['Int']['input'];
  /** Grid cells to shift the bay horizontally. */
  dx: Scalars['Int']['input'];
  /** Grid cells to shift the bay vertically. */
  dy: Scalars['Int']['input'];
};

export type BillingDetails = {
  __typename?: 'BillingDetails';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum BillingStatus {
  BelowMinimumCharge = 'BELOW_MINIMUM_CHARGE',
  ExceededFailureLimit = 'EXCEEDED_FAILURE_LIMIT',
  ExceededMaximumCharge = 'EXCEEDED_MAXIMUM_CHARGE',
  InconsistentData = 'INCONSISTENT_DATA',
  Ok = 'OK',
  TerminalError = 'TERMINAL_ERROR',
  TransientError = 'TRANSIENT_ERROR'
}

/** Interpreted bin family. `unrecognized` is the explicit fallback for names we can't parse. */
export enum BinFamily {
  Bulk = 'BULK',
  Endcap = 'ENDCAP',
  Rack = 'RACK',
  Special = 'SPECIAL',
  Staging = 'STAGING',
  Unrecognized = 'UNRECOGNIZED'
}

/** An ordered group of interpreted bins — an aisle for racks/end-caps, or a single family group (e.g. ABULK). */
export type BinGroup = {
  __typename?: 'BinGroup';
  bins: Array<InterpretedBin>;
  family: BinFamily;
  /** Aisle letter for racks/end-caps; the family token otherwise (e.g. ABULK, DOCK). */
  key: Scalars['String']['output'];
};

export enum BinTransferCommandStatus {
  CreatedAwaitingConfirmation = 'CREATED_AWAITING_CONFIRMATION',
  Dispatching = 'DISPATCHING',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Published = 'PUBLISHED',
  ReconciliationNeeded = 'RECONCILIATION_NEEDED',
  Succeeded = 'SUCCEEDED',
  Superseded = 'SUPERSEDED'
}

export type BlankNote = UserErrorInterface & {
  __typename?: 'BlankNote';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type BrandedItemArtwork = {
  __typename?: 'BrandedItemArtwork';
  artworkUri: Scalars['String']['output'];
  colorNotes?: Maybe<Scalars['String']['output']>;
  company: Company;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
};

export enum BrandedItemCatalogStatus {
  InCatalog = 'in_catalog',
  NotInCatalog = 'not_in_catalog'
}

export type BrandedItemDeal = {
  __typename?: 'BrandedItemDeal';
  brandedItemDealItems: Array<BrandedItemDealItem>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  discountPercent: Scalars['Int']['output'];
  hubspotDealId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  location: Location;
  status: Scalars['String']['output'];
  subtotal: Money;
};

export type BrandedItemDealInput = {
  /** Branded item deal items */
  brandedItemDealItems: Array<BrandedItemDealItemInput>;
  /** Hubspot deal id */
  hubspotDealId?: InputMaybe<Scalars['String']['input']>;
  /** Is doordash deal */
  isDoordash?: InputMaybe<Scalars['Boolean']['input']>;
  /** Location uuid of the branded item deal */
  locationUuid: Scalars['String']['input'];
  /** Status of the branded item deal */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Subtotal of the branded item deal */
  subtotal: MoneyInput;
};

export type BrandedItemDealItem = {
  __typename?: 'BrandedItemDealItem';
  customBrandedItem: CustomBrandedItem;
  id: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
};

export type BrandedItemDealItemInput = {
  /** Custom branded item */
  customBrandedItem: CustomBrandedItemInput;
  /** Quantity of the branded item */
  quantity: Scalars['Int']['input'];
};

/** Autogenerated input type of BulkCreateSupplierInvoiceComparisonRows */
export type BulkCreateSupplierInvoiceComparisonRowsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comparisonId: Scalars['ID']['input'];
  rows: Array<SupplierInvoiceComparisonParsedRowInput>;
};

/** Autogenerated return type of BulkCreateSupplierInvoiceComparisonRows. */
export type BulkCreateSupplierInvoiceComparisonRowsPayload = {
  __typename?: 'BulkCreateSupplierInvoiceComparisonRowsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  rowMappings: Array<SupplierInvoiceComparisonRowMapping>;
  supplierInvoiceComparison?: Maybe<SupplierInvoiceComparison>;
};

export type BulkItemError = UserErrorInterface & {
  __typename?: 'BulkItemError';
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type BulkUpdateDeprecated = UserErrorInterface & {
  __typename?: 'BulkUpdateDeprecated';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of BulkUpdateRouteStopsDeliveryInfo */
export type BulkUpdateRouteStopsDeliveryInfoInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Delivery route id. */
  deliveryRouteId: Scalars['ID']['input'];
  /** Whether to send email notifications for delivered orders. */
  triggerEmail?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of BulkUpdateRouteStopsDeliveryInfo. */
export type BulkUpdateRouteStopsDeliveryInfoPayload = {
  __typename?: 'BulkUpdateRouteStopsDeliveryInfoPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  route?: Maybe<Route>;
  userErrors: Array<RouteError>;
};

/** Autogenerated input type of BulkUpsertZipcodeDeliveryRules */
export type BulkUpsertZipcodeDeliveryRulesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The per-weekday rules to apply. Days not present are removed from each zipcode. */
  deliveryRules: Array<ZipcodeDeliveryRuleInput>;
  /** An optional delivery window to apply to every zipcode. */
  deliveryWindow?: InputMaybe<ZipcodeDeliveryWindowInput>;
  /** The zipcodes to apply the delivery rules to */
  zipcodes: Array<Scalars['String']['input']>;
};

/** Autogenerated return type of BulkUpsertZipcodeDeliveryRules. */
export type BulkUpsertZipcodeDeliveryRulesPayload = {
  __typename?: 'BulkUpsertZipcodeDeliveryRulesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  results: Array<BulkZipcodeDeliveryRuleResult>;
};

export type BulkZipcodeDeliveryRuleResult = {
  __typename?: 'BulkZipcodeDeliveryRuleResult';
  /** Errors for this zipcode, if any */
  errors: Array<UserError>;
  /** Whether the rules were applied to this zipcode */
  success: Scalars['Boolean']['output'];
  /** The zipcode this result is for */
  zipcode: Scalars['String']['output'];
};

export type Business = Node & {
  __typename?: 'Business';
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID']['output'];
};

/** Input of a Business Search */
export type BusinessSearchInput = {
  /** Globally unique ID */
  id: Scalars['ID']['input'];
};

export type BuyNowPayLater = {
  __typename?: 'BuyNowPayLater';
  borrower: BuyNowPayLaterBorrower;
  /**
   * Locations for which this payment method is currently the default. Lists every
   * such location, including ones the viewer is not individually assigned to, so a
   * caller can state the true scope of removing the method. Empty when the method
   * is nobody's default.
   */
  defaultForLocations: Array<PaymentMethodDefaultLocation>;
  id: Scalars['ID']['output'];
  lastPaymentError?: Maybe<PaymentError>;
  lender: Scalars['String']['output'];
};

export type BuyNowPayLaterBorrower = {
  __typename?: 'BuyNowPayLaterBorrower';
  obfuscatedEmail: Scalars['String']['output'];
};

export type ByRating = {
  __typename?: 'ByRating';
  r1: Scalars['Int']['output'];
  r2: Scalars['Int']['output'];
  r3: Scalars['Int']['output'];
  r4: Scalars['Int']['output'];
  r5: Scalars['Int']['output'];
};

export type CalculateShippingSkuInput = {
  /** Numeric SKU ID */
  id: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

/** Autogenerated input type of CancelOrderMutation */
export type CancelOrderMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the order to cancel */
  orderId: Scalars['ID']['input'];
};

/** Autogenerated return type of CancelOrderMutation. */
export type CancelOrderMutationPayload = {
  __typename?: 'CancelOrderMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  success: Scalars['Boolean']['output'];
};

export type CandidateDockWindow = {
  __typename?: 'CandidateDockWindow';
  dock: Dock;
  /** How far over the window's cap one more booking would push it. <= 0 means the window still has room. */
  overCapBy: Scalars['Int']['output'];
  window: DockWindow;
};

export type CarrierNameRequired = UserErrorInterface & {
  __typename?: 'CarrierNameRequired';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** Shopping cart */
export type Cart = {
  __typename?: 'Cart';
  /** Consumer app user service fee. */
  appUserServiceFee: Money;
  /** Items in the cart. */
  cartItems: Array<CartItem>;
  /** Delivery fee. */
  deliveryFee: Money;
  /** Opaque token identifying a specific version of the cart. */
  fingerprint: Scalars['String']['output'];
  /**
   * Merchant. When the cart is empty, this field is null. When the cart contains
   * one or more items, this field reflects the merchant who sells those items.
   * Note that the cart cannot contain items from multiple merchants.
   */
  merchant?: Maybe<Merchant>;
  /** Pickup schedule. Null if cart is empty. */
  pickupSchedule?: Maybe<PickupSchedule>;
  /** Reward. */
  reward?: Maybe<Reward>;
  /** Reward value. */
  rewardValue: Money;
  /** Subtotal. */
  subtotal: Money;
  /** Tax. */
  tax: Money;
  /** Tip. */
  tip: Money;
  /** Total. */
  total: Money;
};


/** Shopping cart */
export type CartPickupScheduleArgs = {
  asOf?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Result of a Cart mutation that failed due to a concurrently running checkout request. */
export type CartCheckoutInFlightError = Error & {
  __typename?: 'CartCheckoutInFlightError';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Item in shopping cart. */
export type CartItem = Node & {
  __typename?: 'CartItem';
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID']['output'];
  /** Menu item. Null if the merchant has removed the item from their menu. */
  menuItem?: Maybe<MenuItem>;
  /** Menu item size. Null if the merchant removed the size from their menu. */
  menuItemSize?: Maybe<MenuItemSize>;
  /** Cart item modifiers. */
  modifiers: Array<CartItemModifier>;
  /** Note. */
  note?: Maybe<Scalars['String']['output']>;
  /** Quantity. */
  quantity: Scalars['Int']['output'];
  /** Unit price for menu item size (not including modifiers). */
  unitPrice: Money;
};

/** Cart item modifier. */
export type CartItemModifier = Node & {
  __typename?: 'CartItemModifier';
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID']['output'];
  /** Menu item modifier group. Null if the merchant has removed the group from their menu. */
  menuItemModifierGroup?: Maybe<MenuItemModifierGroup>;
  /** Menu item modifier option. Null if the merchant has removed the option from their menu. */
  menuItemModifierOption?: Maybe<MenuItemModifierOption>;
  /** Quantity. */
  quantity: Scalars['Int']['output'];
  /** Unit price for menu item modifier option. */
  unitPrice: Money;
};

/**
 * Error indicating that a mutation failed because an item in the cart references a
 * modifier group that could not be found on the menu. This can occur if the menu
 * has changed since the item was added to the cart.
 */
export type CartItemModifierGroupNotFound = Error & {
  __typename?: 'CartItemModifierGroupNotFound';
  /** ID of the menu item modifier group that could not be found. */
  menuItemModifierGroupId: Scalars['ID']['output'];
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Input for a cart item modifier. */
export type CartItemModifierInput = {
  /** MenuItemModifierGroup ID */
  menuItemModifierGroupId: Scalars['ID']['input'];
  /** MenuItemModifierOption ID */
  menuItemModifierOptionId: Scalars['ID']['input'];
  /** Quantity */
  quantity: Scalars['Int']['input'];
  /** Expected unit price of modifier. Modifier will only be added if its current price matches the expected price. */
  unitPrice: MoneyInput;
};

/** Data that was provided as mutation input. */
export type CartItemModifierInputEcho = {
  __typename?: 'CartItemModifierInputEcho';
  /** MenuItemModifierGroup ID */
  menuItemModifierGroupId: Scalars['ID']['output'];
  /** MenuItemModifierOption ID */
  menuItemModifierOptionId: Scalars['ID']['output'];
  /** Quantity */
  quantity: Scalars['Int']['output'];
  /** Expected unit price of modifier. Modifier will only be added if its current price matches the expected price. */
  unitPrice: Money;
};

/**
 * Error indicating that a mutation failed because an item in the cart references a
 * modifier option that could not be found on the menu. This can occur if the menu
 * has changed since the item was added to the cart.
 */
export type CartItemModifierOptionNotFound = Error & {
  __typename?: 'CartItemModifierOptionNotFound';
  /** ID of the menu item modifier option that could not be found. */
  menuItemModifierOptionId: Scalars['ID']['output'];
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Error indicating that a Cart mutation failed to add an item. */
export type CartItemNotAdded = Error & {
  __typename?: 'CartItemNotAdded';
  /**
   * AddCartItemInput data that caused the error. Note that we take an
   * all-or-nothing approach when adding items to the cart, so one failed item
   * aborts the entire operation.
   */
  input: AddCartItemInputEcho;
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Error indicating that a mutation failed because an item is not available at the requested pickup time. */
export type CartItemNotAvailable = Error & {
  __typename?: 'CartItemNotAvailable';
  /** Menu item. */
  menuItem: MenuItem;
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Error indicating that a Cart mutation failed to update an item. */
export type CartItemNotUpdated = Error & {
  __typename?: 'CartItemNotUpdated';
  /**
   * UpdateCartItemInput data that caused the error. Note that we take an
   * all-or-nothing approach to updating items in the cart, so one failed item
   * aborts the entire operation.
   */
  input: UpdateCartItemInputEcho;
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/**
 * Error indicating that a mutation failed because an item in the cart references a
 * size that could not be found on the menu. This can occur if the menu has changed
 * since the item was added to the cart.
 */
export type CartItemSizeNotFound = Error & {
  __typename?: 'CartItemSizeNotFound';
  /** ID of the menu item size that could not be found. */
  menuItemSizeId: Scalars['ID']['output'];
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/**
 * Error indicating that a mutation failed because an item in the cart could not be
 * found on the menu. This can occur if the menu has changed since the item was
 * added to the cart.
 */
export type CartMenuItemNotFound = Error & {
  __typename?: 'CartMenuItemNotFound';
  /** ID of the menu item that could not be found. */
  menuItemId: Scalars['ID']['output'];
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Result of a Cart mutation that failed due to items from multiple merchants. */
export type CartMerchantMismatchError = Error & {
  __typename?: 'CartMerchantMismatchError';
  /** Relevant menu item IDs grouped by merchant. */
  byMerchant: Array<MenuItemsForMerchant>;
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Error indicating that a Cart mutation failed to save the cart. */
export type CartNotSaved = Error & {
  __typename?: 'CartNotSaved';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Result of a Cart mutation that failed because no available pickup times could be found. */
export type CartPickupUnavailableError = Error & {
  __typename?: 'CartPickupUnavailableError';
  /** A description of the error. */
  message: Scalars['String']['output'];
  /** Pickup schedule. */
  pickupSchedule: PickupSchedule;
};

/** Cart mutation result. */
export type CartResult = CartSuccess | ErrorsResult;

/** Result of a successful Cart mutation. */
export type CartSuccess = {
  __typename?: 'CartSuccess';
  /** Resulting cart. */
  cart: Cart;
};

export type CatalogFilter = {
  __typename?: 'CatalogFilter';
  itemTags: ItemTagConnection;
};


export type CatalogFilterItemTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ItemTagFiltersInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<Array<InputMaybe<ItemTagSortOrder>>>;
};

export type CatalogFilterSelectedInput = {
  catalogStatus?: InputMaybe<CatalogStatus>;
  categories?: InputMaybe<Array<InputMaybe<ItemsCategoryInput>>>;
  subcategories?: InputMaybe<Array<InputMaybe<ItemsSubcategoryInput>>>;
  warehouses?: InputMaybe<Array<ItemsWarehouseInput>>;
};

export type CatalogHomepageComponent = CollectionBanner | CollectionCarousel | CollectionHighlightCarousel;

export type CatalogHomepageEntry = {
  __typename?: 'CatalogHomepageEntry';
  component: CatalogHomepageComponent;
  position: Scalars['String']['output'];
};

export enum CatalogStatus {
  InCatalog = 'IN_CATALOG',
  NotInCatalog = 'NOT_IN_CATALOG'
}

export enum CategoriesFilter {
  TopLevel = 'TOP_LEVEL'
}

export enum CategoriesSortOrder {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  PositionAsc = 'POSITION_ASC',
  PositionDesc = 'POSITION_DESC',
  PositionTreeAsc = 'POSITION_TREE_ASC',
  PositionTreeDesc = 'POSITION_TREE_DESC'
}

export type Category = {
  __typename?: 'Category';
  /** Markets where something is stocked under this category, as either its category or its subcategory. */
  activeWarehouses: Array<CollectionsHomepageEntryWarehouse>;
  /**
   * The banner to show above this category's product listings in the given market.
   *
   * Null when neither this category nor any ancestor has a banner configured for
   * that market, and also when the nearest configured banner is missing creative or
   * a destination and so cannot be rendered.
   */
  bannerDetails?: Maybe<CategoryBannerDetails>;
  /**
   * Markets with a banner configured on this category. Not narrowed to
   * `activeWarehouses`: a banner outlives the last item in a market, and a banner
   * configured somewhere the category no longer reaches is worth seeing rather
   * than hiding.
   */
  bannerWarehouses: Array<CollectionsHomepageEntryWarehouse>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdBy: Scalars['String']['output'];
  /**
   * Whether this category's banner carries a shared creative — the one every market
   * falls back to for whatever it does not set itself.
   *
   * True means the markets absent from `bannerWarehouses` are covered rather than
   * unconfigured. Not a market list, because it is narrowed to no market: even a
   * market with its own entry still inherits every field that entry leaves out.
   */
  hasBannerDefaultCreative: Scalars['Boolean']['output'];
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   * Fetch the number of items in the category. If the category was queried within
   * the scope of a Location, items belonging to vendors that don't support the
   * location will be omitted.
   */
  itemCount: Scalars['Int']['output'];
  /**
   * Same as itemCount, but implicitly filters to the warehouse of the Location the
   * category was accessed through. Raises an error if the category was not fetched
   * within the scope of a Location.
   */
  itemCountForLocation: Scalars['Int']['output'];
  /**
   * Fetch items in the category. If the category was queried within the scope of
   * a Location, items belonging to vendors that don't support the location will be
   * omitted.
   */
  items: ItemConnection;
  name: Scalars['String']['output'];
  parentCategory?: Maybe<Category>;
  position?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  subcategories: Array<Category>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};


export type CategoryBannerDetailsArgs = {
  warehouseId: Scalars['ID']['input'];
};


export type CategoryItemCountArgs = {
  catalogStatus?: InputMaybe<CatalogStatus>;
  filters?: InputMaybe<ItemsFiltersInput>;
  warehouses?: InputMaybe<Array<ItemsWarehouseInput>>;
};


export type CategoryItemCountForLocationArgs = {
  catalogStatus?: InputMaybe<CatalogStatus>;
  filters?: InputMaybe<ItemsFiltersInput>;
};


export type CategoryItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ItemsFiltersInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  itemTypes?: InputMaybe<Array<InputMaybe<ItemType>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Array<InputMaybe<ItemsSortOrder>>>;
  vendors?: InputMaybe<Array<InputMaybe<ItemsVendorInput>>>;
  warehouses?: InputMaybe<Array<InputMaybe<ItemsWarehouseInput>>>;
};


export type CategorySubcategoriesArgs = {
  sortOrder?: InputMaybe<Array<InputMaybe<CategoriesSortOrder>>>;
};

/** The creative a banner falls back to, shaped like a market's entry without the market. */
export type CategoryBannerDefaultAttributes = {
  __typename?: 'CategoryBannerDefaultAttributes';
  /** An image key, not a URL — the same value `upsertCategoryBanner` accepts. */
  desktopImage?: Maybe<Scalars['String']['output']>;
  destinationRef?: Maybe<Scalars['String']['output']>;
  destinationType?: Maybe<CategoryBannerDestinationType>;
  mobileImage?: Maybe<Scalars['String']['output']>;
  shippingBehavior?: Maybe<CategoryBannerShippingBehavior>;
  shippingDesktopImage?: Maybe<Scalars['String']['output']>;
  shippingMobileImage?: Maybe<Scalars['String']['output']>;
};

/**
 * The creative every market inherits. Both images are required: a default has
 * nothing above it to inherit from, so a half-configured one would leave every
 * market it covers showing nothing.
 */
export type CategoryBannerDefaultInput = {
  desktopImage: Scalars['String']['input'];
  /**
   * Interpreted according to destinationType; a collection slug when COLLECTION.
   * Omit it for a banner that is shown but does not link anywhere.
   */
  destinationRef?: InputMaybe<Scalars['String']['input']>;
  destinationType?: InputMaybe<CategoryBannerDestinationType>;
  mobileImage: Scalars['String']['input'];
  shippingBehavior?: InputMaybe<CategoryBannerShippingBehavior>;
  /** Required when shippingBehavior is OVERRIDE, ignored otherwise. */
  shippingDesktopImage?: InputMaybe<Scalars['String']['input']>;
  /** Required when shippingBehavior is OVERRIDE, ignored otherwise. */
  shippingMobileImage?: InputMaybe<Scalars['String']['input']>;
};

/** What a category banner's destinationRef points at. */
export enum CategoryBannerDestinationType {
  Collection = 'COLLECTION',
  /** A /catalog/collection/<slug> or /catalog/item/<uuid> path, relative to the viewer's location, in destinationRef. */
  InternalPath = 'INTERNAL_PATH'
}

/**
 * A per-market banner shown above the product listings on a category or
 * subcategory page.
 */
export type CategoryBannerDetails = {
  __typename?: 'CategoryBannerDetails';
  desktopImageUrl: Scalars['String']['output'];
  /** Interpreted according to destinationType; a collection slug when COLLECTION. */
  destinationRef?: Maybe<Scalars['String']['output']>;
  /** Null together with destinationRef, on a banner that is shown but not clickable. */
  destinationType?: Maybe<CategoryBannerDestinationType>;
  mobileImageUrl: Scalars['String']['output'];
  shippingBehavior: CategoryBannerShippingBehavior;
  shippingDesktopImageUrl?: Maybe<Scalars['String']['output']>;
  shippingMobileImageUrl?: Maybe<Scalars['String']['output']>;
  /**
   * The category this banner is configured on, which may be an ancestor of the one
   * queried. Distinguishes an inherited banner from one set on the category itself.
   */
  sourceCategoryId: Scalars['ID']['output'];
};

export type CategoryBannerError = {
  __typename?: 'CategoryBannerError';
  code?: Maybe<Scalars['String']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/**
 * The banner configured on a category, as the admin tool needs it back to edit.
 *
 * Distinct from `Category.bannerDetails`, which serves the storefront: that field
 * resolves inheritance and returns public URLs for a single market, neither of
 * which a form can round-trip. This returns the banner configured on this category
 * alone, one entry per market, holding the image keys the upsert mutation takes.
 */
export type CategoryBannerForEdit = {
  __typename?: 'CategoryBannerForEdit';
  category: Category;
  /** Null when this category has no banner of its own. */
  categoryBannerId?: Maybe<Scalars['ID']['output']>;
  /** The creative every market inherits unless it carries its own; null when there is none. */
  defaultCreative?: Maybe<CategoryBannerDefaultAttributes>;
  /**
   * One entry per market the banner is configured for. Markets absent here are the
   * ones an upsert would remove, so a form must send back exactly the markets it
   * means to keep.
   */
  warehouses: Array<CategoryBannerWarehouseAttributes>;
};

export type CategoryBannerPayload = {
  __typename?: 'CategoryBannerPayload';
  categoryBannerId?: Maybe<Scalars['ID']['output']>;
  errors: Array<CategoryBannerError>;
  /**
   * Markets whose creative this call removed, because they were left out of
   * `warehouseIds`. Lets a caller tell a partial list apart from a no-op save.
   */
  removedWarehouseIds?: Maybe<Array<Scalars['ID']['output']>>;
};

/**
 * How a category banner behaves for shipping locations. Applied by the client
 * rather than resolved here: shipping is a property of a location, and a single
 * warehouse serves both shipping and delivery locations.
 */
export enum CategoryBannerShippingBehavior {
  /** Shipping locations do not see this banner at all. */
  Hide = 'HIDE',
  /** Shipping locations see the default creative. */
  Inherit = 'INHERIT',
  /** Shipping locations see the shipping-specific creative. */
  Override = 'OVERRIDE'
}

export type CategoryBannerWarehouseAttributes = {
  __typename?: 'CategoryBannerWarehouseAttributes';
  /** An image key, not a URL — the same value `upsertCategoryBanner` accepts. */
  desktopImage?: Maybe<Scalars['String']['output']>;
  destinationRef?: Maybe<Scalars['String']['output']>;
  destinationType?: Maybe<CategoryBannerDestinationType>;
  /**
   * Whether this market has been hidden outright. False is the ordinary state, and is not the same
   * as having no creative: a market with neither falls back to `defaultCreative`, while a hidden one
   * shows nothing.
   */
  hidden: Scalars['Boolean']['output'];
  mobileImage?: Maybe<Scalars['String']['output']>;
  shippingBehavior?: Maybe<CategoryBannerShippingBehavior>;
  shippingDesktopImage?: Maybe<Scalars['String']['output']>;
  shippingMobileImage?: Maybe<Scalars['String']['output']>;
  warehouse: CollectionsHomepageEntryWarehouse;
};

/** The creative and behaviour for one market. */
export type CategoryBannerWarehouseInput = {
  /** Required unless this market is hidden. */
  desktopImage?: InputMaybe<Scalars['String']['input']>;
  /**
   * Interpreted according to destinationType; a collection slug when COLLECTION.
   * Omit it for a banner that is shown but does not link anywhere.
   */
  destinationRef?: InputMaybe<Scalars['String']['input']>;
  destinationType?: InputMaybe<CategoryBannerDestinationType>;
  /**
   * Hides the banner in this market outright: nobody there sees one, and the lookup stops here
   * rather than falling through to an ancestor category. Distinct from `shippingBehavior: HIDE`,
   * which only narrows the audience to shoppers who are not shipping.
   *
   * A hidden market needs no creative of its own — the usual case is hiding one that was inheriting
   * `defaultCreative` and has none — which is why the two images are optional here and required
   * everywhere else. Creative sent alongside it is still stored, so un-hiding restores it.
   */
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Required unless this market is hidden. */
  mobileImage?: InputMaybe<Scalars['String']['input']>;
  shippingBehavior?: InputMaybe<CategoryBannerShippingBehavior>;
  /** Required when shippingBehavior is OVERRIDE, ignored otherwise. */
  shippingDesktopImage?: InputMaybe<Scalars['String']['input']>;
  /** Required when shippingBehavior is OVERRIDE, ignored otherwise. */
  shippingMobileImage?: InputMaybe<Scalars['String']['input']>;
  warehouseId: Scalars['ID']['input'];
};

export type CategorySpendDetail = {
  __typename?: 'CategorySpendDetail';
  categoryId: Scalars['ID']['output'];
  categoryName: Scalars['String']['output'];
  /**
   * Projected category spend for this location (= location.spend_90d × warehouse
   * category_share_pct / 100). Drives the new expansion opportunity calculation.
   */
  expectedSpendCents: Scalars['Int']['output'];
  gapCents: Scalars['Int']['output'];
  locationSpendCents: Scalars['Int']['output'];
  /** @deprecated Use expected_spend_cents. Median is retained for one release for sales context, will be removed once expected-spend numbers are validated by reps. */
  warehouseMedianCents: Scalars['Int']['output'];
};

export enum CategoryType {
  Branded = 'BRANDED',
  Supply = 'SUPPLY'
}

/** Kind of paper_trail audit event surfaced in changeHistory. */
export enum ChangeEventKind {
  /** A new audited row was inserted. */
  Create = 'CREATE',
  /** An audited row was deleted. */
  Destroy = 'DESTROY',
  /** An audited column on an existing row was changed. */
  Update = 'UPDATE'
}

export enum ChannelEnum {
  /** Mobile Android app */
  MobileAndroid = 'mobile_android',
  /** Mobile iOS app */
  MobileIos = 'mobile_ios',
  /** Web browser */
  Web = 'web'
}

/** Chat Messages represents a message created by a user or a system */
export type ChatMessage = {
  __typename?: 'ChatMessage';
  /** Body represents the main body of the chat message */
  body: Scalars['String']['output'];
  /** Created At represents the time the message was recorded by the system */
  createdAt: Scalars['Date']['output'];
  /** ID of the chat message */
  id: Scalars['ID']['output'];
  /** Metadata represents any metadata relevant to the chat message, this may be from the user perspective or system */
  metadata?: Maybe<Scalars['String']['output']>;
  /** Role represents the initiator of the chat message, this will typically be `user`, 'ai' or `system` */
  role?: Maybe<Scalars['String']['output']>;
};

/** A check-in entry */
export type CheckInEntry = {
  __typename?: 'CheckInEntry';
  /** When the guest checked in */
  checkedInAt: Scalars['ISO8601DateTime']['output'];
  /** Email address of the guest */
  email: Scalars['String']['output'];
  /** Unique identifier for the entry */
  id: Scalars['ID']['output'];
  /** Whether the guest won */
  won: Scalars['Boolean']['output'];
};

export type CheckInNotAllowed = UserErrorInterface & {
  __typename?: 'CheckInNotAllowed';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** Statistics for check-in entries */
export type CheckInStats = {
  __typename?: 'CheckInStats';
  /** Number of check-in entries today */
  dailyEntries: Scalars['Int']['output'];
  /** Remaining winners available today (null if unlimited) */
  dailyRemaining?: Maybe<Scalars['Int']['output']>;
  /** Number of winners today */
  dailyWinners: Scalars['Int']['output'];
  /** Total number of check-in entries */
  totalEntries: Scalars['Int']['output'];
  /** Remaining winners available overall (null if unlimited) */
  totalRemaining?: Maybe<Scalars['Int']['output']>;
  /** Total number of winners */
  totalWinners: Scalars['Int']['output'];
};

export type CheckInStatus = {
  __typename?: 'CheckInStatus';
  /** Whether the daily winner limit has been reached */
  dailyLimitReached: Scalars['Boolean']['output'];
  hasCheckedInToday: Scalars['Boolean']['output'];
  /** When the user can next check in (only present if already checked in today) */
  nextCheckInAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether the total winner limit has been reached */
  totalLimitReached: Scalars['Boolean']['output'];
};

export type CheckinItemInput = {
  itemId: Scalars['ID']['input'];
  receivedQty: Scalars['Float']['input'];
  vendorPriceTotalCents: Scalars['Int']['input'];
};

/** Autogenerated input type of CheckinOrderVendorReceiving */
export type CheckinOrderVendorReceivingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  items: Array<CheckinItemInput>;
  nightEnd: Scalars['ISO8601Date']['input'];
  vendorId: Scalars['ID']['input'];
  warehouseId: Scalars['ID']['input'];
};

/** Autogenerated return type of CheckinOrderVendorReceiving. */
export type CheckinOrderVendorReceivingPayload = {
  __typename?: 'CheckinOrderVendorReceivingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  orderVendorReceivings?: Maybe<Array<OrderVendorReceiving>>;
  userErrors: Array<UserError>;
};

/** Autogenerated input type of Checkout */
export type CheckoutInput = {
  /**
   * Desired pickup time, expressed in absolute terms. Checkout will only proceed
   * if this is available pickup time according to the merchant's schedule and
   * respect's the merchant's minimum notice setting. Either this argument or the
   * relativePickupTime argument must be specified, but not both.
   */
  absolutePickupTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Curbside color. */
  curbsideColor?: InputMaybe<Scalars['String']['input']>;
  /** Curbside make. */
  curbsideMake?: InputMaybe<Scalars['String']['input']>;
  /** Curbside model. */
  curbsideModel?: InputMaybe<Scalars['String']['input']>;
  /** Whether order is for curbside pickup. */
  curbsidePickup?: InputMaybe<Scalars['Boolean']['input']>;
  /** Delivery detail. */
  deliveryDetail?: InputMaybe<DeliveryDetailInput>;
  /** Email address to send receipt to. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Opaque token identifying a specific version of the cart. */
  fingerprint: Scalars['String']['input'];
  /** Customer name to attach to the order. */
  name: Scalars['String']['input'];
  /**
   * Payment method. Checkout will only proceed if cart's calculated prices using
   * this payment method match the prices of the cart version identified by fingerprint.
   */
  paymentMethod: PaymentMethod;
  /** Client app platform. */
  platform: ClientAppPlatform;
  /**
   * Desired pickup time, expressed relative to the current time. Checkout will
   * only proceed if this is available pickup time according to the merchant's
   * schedule and respect's the merchant's minimum notice setting. Either this
   * argument or the absolutePickupTime argument must be specified, but not both.
   */
  relativePickupTime?: InputMaybe<RelativeTimeInput>;
  /** Square card id. Required if using the "square_card_id" payment method. */
  squareCardId?: InputMaybe<Scalars['String']['input']>;
  /** Square card nonce. Required if using the "square_card_nonce" payment method. */
  squareCardNonce?: InputMaybe<Scalars['String']['input']>;
  /** Whether order is "to go" (i.e. takeout/takeaway). */
  toGo: Scalars['Boolean']['input'];
};

/** Autogenerated return type of Checkout */
export type CheckoutPayload = {
  __typename?: 'CheckoutPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to process checkout. */
  result: CheckoutResult;
};

/** Checkout mutation result. */
export type CheckoutResult = CheckoutSuccess | ErrorsResult;

/** Result of a successful checkout mutation. */
export type CheckoutSuccess = {
  __typename?: 'CheckoutSuccess';
  /** Fresh cart info. */
  cart: Cart;
  /** Earned reward, applicable to a future order. */
  earnedReward?: Maybe<Reward>;
  /** Resulting consumer order. */
  order: ConsumerOrder;
};

/** Autogenerated input type of ClaimReward */
export type ClaimRewardInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Reward code. */
  code: Scalars['String']['input'];
};

/** Autogenerated return type of ClaimReward */
export type ClaimRewardPayload = {
  __typename?: 'ClaimRewardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to claim reward. */
  result: RewardResult;
};

/** Client app platform values. */
export enum ClientAppPlatform {
  /** Android. */
  Android = 'android',
  /** Apple (iOS). */
  Apple = 'apple',
  /** Web. */
  Web = 'web'
}

export type Collection = {
  __typename?: 'Collection';
  aggregation?: Maybe<CollectionAggregationType>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /**
   * Fetch items in the collection. If the collection was queried within the scope
   * of a Location, items belonging to vendors that don't support the location will
   * be omitted.
   */
  items: ItemConnection;
  name?: Maybe<Scalars['String']['output']>;
  promoName?: Maybe<Scalars['String']['output']>;
  /**
   * Load warehouse-specific properties needed to display this collection's
   * promotion page.
   */
  promoPageDetails?: Maybe<PromoPageDetails>;
  reference?: Maybe<CollectionReference>;
  referenceId?: Maybe<Scalars['ID']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CollectionType>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  updatedBy?: Maybe<Scalars['ISO8601DateTime']['output']>;
};


export type CollectionItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ItemsFiltersInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Array<InputMaybe<ItemsSortOrder>>>;
};


export type CollectionPromoPageDetailsArgs = {
  warehouseId: Scalars['ID']['input'];
};

export enum CollectionAggregationType {
  Manual = 'MANUAL',
  Tag = 'TAG',
  Vendor = 'VENDOR'
}

export type CollectionBanner = {
  __typename?: 'CollectionBanner';
  collection: Collection;
  warehouseAttributes?: Maybe<CollectionBannerWarehouseAttributes>;
};


export type CollectionBannerWarehouseAttributesArgs = {
  warehouseId: Scalars['ID']['input'];
};

export enum CollectionBannerFontStyle {
  Dark = 'DARK',
  Light = 'LIGHT'
}

export type CollectionBannerWarehouseAttributes = {
  __typename?: 'CollectionBannerWarehouseAttributes';
  desktopImageUrl: Scalars['String']['output'];
  fontStyle: CollectionBannerFontStyle;
  mobileImageUrl: Scalars['String']['output'];
};

export type CollectionCarousel = {
  __typename?: 'CollectionCarousel';
  collection: Collection;
  enabledForWarehouse: Scalars['Boolean']['output'];
};


export type CollectionCarouselEnabledForWarehouseArgs = {
  warehouseId: Scalars['ID']['input'];
};

export type CollectionHighlightCarousel = {
  __typename?: 'CollectionHighlightCarousel';
  collection: Collection;
  warehouseAttributes?: Maybe<CollectionHighlightCarouselWarehouseAttributes>;
};


export type CollectionHighlightCarouselWarehouseAttributesArgs = {
  warehouseId: Scalars['ID']['input'];
};

export type CollectionHighlightCarouselWarehouseAttributes = {
  __typename?: 'CollectionHighlightCarouselWarehouseAttributes';
  imageUrl: Scalars['String']['output'];
};

export type CollectionPromoSetupError = {
  __typename?: 'CollectionPromoSetupError';
  code?: Maybe<Scalars['String']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export enum CollectionReference {
  Item = 'ITEM',
  Promotion = 'PROMOTION'
}

export type CollectionSetupDisplayRule = {
  __typename?: 'CollectionSetupDisplayRule';
  componentId: Scalars['ID']['output'];
  componentType: HomepageCollectionComponentType;
  endDate: Scalars['ISO8601Date']['output'];
  position: Scalars['String']['output'];
  ruleId: Scalars['ID']['output'];
  startDate: Scalars['ISO8601Date']['output'];
  warehouseIds: Array<Scalars['ID']['output']>;
  warehouses: Array<CollectionsHomepageEntryWarehouse>;
};

export type CollectionSetupForEdit = {
  __typename?: 'CollectionSetupForEdit';
  collection: Collection;
  displayRules: Array<CollectionSetupDisplayRule>;
  homepageComponents: Array<CollectionSetupHomepageComponent>;
  itemIds: Array<Scalars['ID']['output']>;
  promoPageId?: Maybe<Scalars['ID']['output']>;
  promoPageWarehouses: Array<CollectionSetupPromoPageWarehouseAttributes>;
};

export type CollectionSetupHomepageComponent = {
  __typename?: 'CollectionSetupHomepageComponent';
  componentId: Scalars['ID']['output'];
  componentType: HomepageCollectionComponentType;
  warehouseAttributes: Array<CollectionSetupHomepageComponentWarehouseAttributes>;
};

export type CollectionSetupHomepageComponentWarehouseAttributes = {
  __typename?: 'CollectionSetupHomepageComponentWarehouseAttributes';
  desktopImage?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  fontStyle?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  mobileImage?: Maybe<Scalars['String']['output']>;
  warehouse: CollectionsHomepageEntryWarehouse;
};

export type CollectionSetupPromoPageWarehouseAttributes = {
  __typename?: 'CollectionSetupPromoPageWarehouseAttributes';
  customDescription?: Maybe<Scalars['String']['output']>;
  customName?: Maybe<Scalars['String']['output']>;
  desktopHeroImage?: Maybe<Scalars['String']['output']>;
  isVisibleMarket?: Maybe<Scalars['Boolean']['output']>;
  mobileHeroImage?: Maybe<Scalars['String']['output']>;
  shippingDesktopHeroImage?: Maybe<Scalars['String']['output']>;
  shippingMobileHeroImage?: Maybe<Scalars['String']['output']>;
  warehouse: CollectionsHomepageEntryWarehouse;
};

export enum CollectionType {
  Bundle = 'BUNDLE',
  OutOfStockRecommendation = 'OUT_OF_STOCK_RECOMMENDATION',
  Promotion = 'PROMOTION',
  SimilarItems = 'SIMILAR_ITEMS'
}

export type CollectionsHomepageEntry = {
  __typename?: 'CollectionsHomepageEntry';
  collection: Collection;
  configuredWarehouseCount: Scalars['Int']['output'];
  enabledWarehouseCount: Scalars['Int']['output'];
  endDate: Scalars['ISO8601Date']['output'];
  ruleId: Scalars['ID']['output'];
  startDate: Scalars['ISO8601Date']['output'];
  warehouseIds: Array<Scalars['ID']['output']>;
  warehouses: Array<CollectionsHomepageEntryWarehouse>;
};

export type CollectionsHomepageEntryWarehouse = {
  __typename?: 'CollectionsHomepageEntryWarehouse';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CollectionsHomepageRow = {
  __typename?: 'CollectionsHomepageRow';
  activeNow: Array<CollectionsHomepageEntry>;
  position: Scalars['String']['output'];
  scheduled: Array<CollectionsHomepageEntry>;
};

export type CollectionsPageEntry = {
  __typename?: 'CollectionsPageEntry';
  collection: Collection;
  configuredWarehouseCount: Scalars['Int']['output'];
  warehouseIds: Array<Scalars['ID']['output']>;
  warehouses: Array<CollectionsHomepageEntryWarehouse>;
};

export type Color = {
  __typename?: 'Color';
  hexCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
};

export type Company = {
  __typename?: 'Company';
  /** ISO 3166-2 alpha-2 code. */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** Whether this company is an enterprise company or not. */
  enterprise?: Maybe<Scalars['Boolean']['output']>;
  /**
   * How many of this company's kept locations are excluded from automatic
   * application of credit memos, overpayments and unapplied Odeko payments.
   */
  fundApplicationExcludedLocationsCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** List of locations (almost always, brick-and-mortar cafes for this company.) */
  locations: Array<Location>;
  /**
   * Number of locations in this company. Unlike `locations`, readable by viewers
   * who only hold a subset of the company's locations.
   */
  locationsCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /**
   * ISO 3166-2 subdivision code. For US based companies, this is the US State of
   * the first cafe location created in our systems for that company.
   */
  regionCode?: Maybe<Scalars['String']['output']>;
  /** List of users associated to this company. */
  users: Array<User>;
};

/** The connection type for Company. */
export type CompanyConnection = {
  __typename?: 'CompanyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CompanyEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Company>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of records in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CompanyEdge = {
  __typename?: 'CompanyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Company>;
};

/** Autogenerated input type of CompleteActionMutation */
export type CompleteActionMutationInput = {
  action: PlatformActions;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The UUID of the Odeko Location to try and match against the Google Business Profile */
  locationUuid?: InputMaybe<Scalars['ID']['input']>;
  platformId: PlatformIds;
  queryString: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
  /** The URL slug of the microsite location to match against the Google Business Profile */
  urlSlug?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CompleteActionMutation. */
export type CompleteActionMutationPayload = {
  __typename?: 'CompleteActionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  connection: Connection;
};

/** Autogenerated input type of CompleteConsumerAppReferral */
export type CompleteConsumerAppReferralInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Referral link URL */
  url: Scalars['String']['input'];
};

/** Autogenerated return type of CompleteConsumerAppReferral */
export type CompleteConsumerAppReferralPayload = {
  __typename?: 'CompleteConsumerAppReferralPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to complete the consumer app referral */
  result: CompleteConsumerAppReferralResult;
};

/** Result of attempting to complete a consumer app referral. */
export type CompleteConsumerAppReferralResult = ConsumerAppReferralSuccess | ErrorsResult;

/** Autogenerated input type of CompleteStripeCheckoutSessionMutation */
export type CompleteStripeCheckoutSessionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Optional microsite location ID to associate and trigger signage order creation */
  micrositeLocationId?: InputMaybe<Scalars['ID']['input']>;
  /** Stripe checkout session ID (cs_xxx) */
  stripeCheckoutSessionId: Scalars['String']['input'];
};

/** Autogenerated return type of CompleteStripeCheckoutSessionMutation. */
export type CompleteStripeCheckoutSessionMutationPayload = {
  __typename?: 'CompleteStripeCheckoutSessionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']['output']>;
  /** Updated Stripe checkout session */
  stripeCheckoutSession?: Maybe<StripeCheckoutSession>;
};

/** Autogenerated input type of CompleteSubscriptionSessionMutation */
export type CompleteSubscriptionSessionMutationInput = {
  /** Auth0 ID of a newly created user to associate with microsite */
  auth0UserId?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the subscription session to complete */
  subscriptionSessionId: Scalars['ID']['input'];
};

/** Autogenerated return type of CompleteSubscriptionSessionMutation. */
export type CompleteSubscriptionSessionMutationPayload = {
  __typename?: 'CompleteSubscriptionSessionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']['output']>;
  /** Completed subscription session */
  subscriptionSession?: Maybe<SubscriptionSession>;
};

/** Autogenerated input type of CompleteSupplierInvoiceUpload */
export type CompleteSupplierInvoiceUploadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  signedBlobId: Scalars['String']['input'];
  supplierInvoiceId: Scalars['ID']['input'];
};

/** Autogenerated return type of CompleteSupplierInvoiceUpload. */
export type CompleteSupplierInvoiceUploadPayload = {
  __typename?: 'CompleteSupplierInvoiceUploadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  supplierInvoice?: Maybe<SupplierInvoice>;
};

export type CompletedCustomerPickupStop = UserErrorInterface & {
  __typename?: 'CompletedCustomerPickupStop';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
  stopIds: Array<Scalars['ID']['output']>;
};

/** One completed in-progress customer, as Ops reconciles it against their master list. */
export type CompletedOnboardingRow = {
  __typename?: 'CompletedOnboardingRow';
  city?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyUuid?: Maybe<Scalars['ID']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  /** The location onboarding produced, existing or newly created. */
  locationUuid?: Maybe<Scalars['ID']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  /** The id generated at ingest; the key this row joins on. */
  uniqueId?: Maybe<Scalars['String']['output']>;
  userEmail?: Maybe<Scalars['String']['output']>;
  userFirstName?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
  userLastName?: Maybe<Scalars['String']['output']>;
};

/** Configuration info */
export type Config = Node & {
  __typename?: 'Config';
  /** Oldest supported consumer Android app */
  consumerAndroidForceVersion: Scalars['String']['output'];
  /** Latest consumer Android app */
  consumerAndroidLatestVersion: Scalars['String']['output'];
  /** Oldest supported consumer iOS app */
  consumerIosForceVersion: Scalars['String']['output'];
  /** Latest consumer iOS app */
  consumerIosLatestVersion: Scalars['String']['output'];
  /** When this edition of the config was added to the database */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Position in chronological sequence of configs */
  edition: Scalars['Int']['output'];
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID']['output'];
  /** Oldest supported merchant Amazon app */
  merchantAmazonForceVersion: Scalars['String']['output'];
  /** Latest merchant Amazon app */
  merchantAmazonLatestVersion: Scalars['String']['output'];
  /** Oldest supported merchant Android app */
  merchantAndroidForceVersion: Scalars['String']['output'];
  /** Latest merchant Android app */
  merchantAndroidLatestVersion: Scalars['String']['output'];
  /** Oldest supported merchant iOS app */
  merchantIosForceVersion: Scalars['String']['output'];
  /** Latest merchant iOS app */
  merchantIosLatestVersion: Scalars['String']['output'];
  /** Upgrade message shown to merchants with an Odeko-provided tablet */
  merchantTabletUpgradeMessage?: Maybe<Scalars['String']['output']>;
  /** Date when tablet upgrade message starts appearing */
  merchantTabletUpgradeStartDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** @deprecated Each edition of the config is immutable, so an update generates a new edition */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Attributes for creating a config */
export type ConfigAttributes = {
  /** Oldest supported consumer Android app */
  consumerAndroidForceVersion: Scalars['String']['input'];
  /** Latest consumer Android app */
  consumerAndroidLatestVersion: Scalars['String']['input'];
  /** Oldest supported consumer iOS app */
  consumerIosForceVersion: Scalars['String']['input'];
  /** Latest consumer iOS app */
  consumerIosLatestVersion: Scalars['String']['input'];
  /** Oldest supported merchant Amazon app */
  merchantAmazonForceVersion: Scalars['String']['input'];
  /** Latest merchant Amazon app */
  merchantAmazonLatestVersion: Scalars['String']['input'];
  /** Oldest supported merchant Android app */
  merchantAndroidForceVersion: Scalars['String']['input'];
  /** Latest merchant Android app */
  merchantAndroidLatestVersion: Scalars['String']['input'];
  /** Oldest supported merchant iOS app */
  merchantIosForceVersion: Scalars['String']['input'];
  /** Latest merchant iOS app */
  merchantIosLatestVersion: Scalars['String']['input'];
  /** Upgrade message shown to merchants with an Odeko-provided tablet */
  merchantTabletUpgradeMessage?: InputMaybe<Scalars['String']['input']>;
  /** Date when tablet upgrade message starts appearing */
  merchantTabletUpgradeStartDate?: InputMaybe<Scalars['String']['input']>;
};

/** The connection type for Config. */
export type ConfigConnection = {
  __typename?: 'ConfigConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ConfigEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Config>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ConfigEdge = {
  __typename?: 'ConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Config>;
};

/** Config sort criteria */
export type ConfigOrderBy = {
  /** Position in chronological sequence of configs */
  edition?: InputMaybe<OrderByEnum>;
};

/** Config mutation result */
export type ConfigResult = ConfigSuccess | InvalidConfigError | StaleConfigError;

/** Result of a successful Config mutation */
export type ConfigSuccess = {
  __typename?: 'ConfigSuccess';
  /** Resulting config */
  config: Config;
};

export type ConfigureFulfillmentWarehouse = {
  __typename?: 'ConfigureFulfillmentWarehouse';
  /** The warehouse that is configured to fulfill the item. */
  warehouse: Warehouse;
};

export type ConfigureFulfillmentWarehouseInput = {
  warehouseId: Scalars['ID']['input'];
};

/** Autogenerated input type of ConfirmPutawayPallet */
export type ConfirmPutawayPalletInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Destination bin NetSuite internal id. Provide this or destinationBinName, not both. */
  destinationBinInternalId?: InputMaybe<Scalars['String']['input']>;
  /** Destination bin display name, as printed on the bin label. Provide this or destinationBinInternalId, not both. */
  destinationBinName?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey: Scalars['ID']['input'];
  /** Quantity to move, in the item's NetSuite stock unit, as a decimal string such as "15.0". Defaults to one full pallet. */
  stockUnitQuantity?: InputMaybe<Scalars['String']['input']>;
  /** WarehouseTask id from the warehouseTasks query. */
  taskId: Scalars['ID']['input'];
};

/** Autogenerated return type of ConfirmPutawayPallet. */
export type ConfirmPutawayPalletPayload = {
  __typename?: 'ConfirmPutawayPalletPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  command?: Maybe<WarehouseBinTransferCommand>;
  userErrors: Array<UserError>;
};

/** Autogenerated input type of ConfirmSquareOrderSuggestionMutation */
export type ConfirmSquareOrderSuggestionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Square Terminal device ID for checkout */
  deviceId: Scalars['String']['input'];
  /** The order suggestion ID to confirm */
  suggestionId: Scalars['ID']['input'];
};

/** Autogenerated return type of ConfirmSquareOrderSuggestionMutation. */
export type ConfirmSquareOrderSuggestionMutationPayload = {
  __typename?: 'ConfirmSquareOrderSuggestionMutationPayload';
  /** The created Terminal checkout */
  checkout?: Maybe<TerminalCheckout>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']['output']>;
  /** The created Square order */
  order?: Maybe<SquareOrder>;
};

/** Autogenerated input type of ConnectLocationCreditKeyAccountMutation */
export type ConnectLocationCreditKeyAccountMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** UUID for the Location */
  locationUuid: Scalars['String']['input'];
};

/** Autogenerated return type of ConnectLocationCreditKeyAccountMutation. */
export type ConnectLocationCreditKeyAccountMutationPayload = {
  __typename?: 'ConnectLocationCreditKeyAccountMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  paymentMethod?: Maybe<BuyNowPayLater>;
};

export type Connection = {
  __typename?: 'Connection';
  isConnected: Scalars['Boolean']['output'];
  platformId: PlatformIds;
  profiles: Array<Profile>;
  selectedProfile?: Maybe<Profile>;
  /** The email address the user used to connect this platform */
  userEmail?: Maybe<Scalars['String']['output']>;
};

export type ConsumerAppReferral = {
  __typename?: 'ConsumerAppReferral';
  /** Reward granted to the referred user. */
  referredReward?: Maybe<Reward>;
};

/** Error indicating an invalid consumer app referral. */
export type ConsumerAppReferralInvalid = Error & {
  __typename?: 'ConsumerAppReferralInvalid';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

export type ConsumerAppReferralLink = {
  __typename?: 'ConsumerAppReferralLink';
  /** URL */
  url: Scalars['String']['output'];
};

/** Error indicating invalid consumer app referral link. */
export type ConsumerAppReferralLinkInvalid = Error & {
  __typename?: 'ConsumerAppReferralLinkInvalid';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Error indicating that a consumer app referral link could not be found. */
export type ConsumerAppReferralLinkNotFound = Error & {
  __typename?: 'ConsumerAppReferralLinkNotFound';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Error indicating that a consumer app referral link mutation failed to save the consumer app referral link. */
export type ConsumerAppReferralLinkNotSaved = Error & {
  __typename?: 'ConsumerAppReferralLinkNotSaved';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Result of successfully mutating a consumer app referral link. */
export type ConsumerAppReferralLinkSuccess = {
  __typename?: 'ConsumerAppReferralLinkSuccess';
  /** Consumer app referral link. */
  consumerAppReferralLink: ConsumerAppReferralLink;
};

/** Error indicating that a consumer app referral mutation failed to save the referral. */
export type ConsumerAppReferralNotSaved = Error & {
  __typename?: 'ConsumerAppReferralNotSaved';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Result of successfully mutating a consumer app referral. */
export type ConsumerAppReferralSuccess = {
  __typename?: 'ConsumerAppReferralSuccess';
  /** Consumer app referral. */
  consumerAppReferral: ConsumerAppReferral;
};

/** Consumer app user. */
export type ConsumerAppUser = Node & {
  __typename?: 'ConsumerAppUser';
  /** Accepts promotional emails. */
  acceptsPromotionalEmails: Scalars['Boolean']['output'];
  /** The primary key from the database. */
  databaseId: Scalars['Int']['output'];
  /** Email. */
  email?: Maybe<Scalars['String']['output']>;
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID']['output'];
  /** Whether this is a guest account. */
  isGuestAccount: Scalars['Boolean']['output'];
  /** Merchant can contact. */
  merchantCanContact?: Maybe<Scalars['Boolean']['output']>;
  /** Phone number. */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Total discount received on orders so far. */
  totalMoneySaved: Money;
  /** Username. */
  username?: Maybe<Scalars['String']['output']>;
};

/** Consumer app user Firebase login result. */
export type ConsumerAppUserFirebaseLoginResult = ConsumerAppUserFirebaseLoginSuccess | ErrorsResult;

/** Result of a successful consumer app user login from Firebase. */
export type ConsumerAppUserFirebaseLoginSuccess = {
  __typename?: 'ConsumerAppUserFirebaseLoginSuccess';
  /** Logged in consumer app user. */
  consumerAppUser: ConsumerAppUser;
  /** Session info. */
  session: JwtSession;
};

/** Error indicating invalid consumer app user attributes. */
export type ConsumerAppUserInvalid = Error & {
  __typename?: 'ConsumerAppUserInvalid';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Error indicating that a consumer app user mutation failed to save the consumer app user. */
export type ConsumerAppUserNotSaved = Error & {
  __typename?: 'ConsumerAppUserNotSaved';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Consumer app user mutation result. */
export type ConsumerAppUserResult = ConsumerAppUserSuccess | ErrorsResult;

/** Result of a successful consumer app user mutation. */
export type ConsumerAppUserSuccess = {
  __typename?: 'ConsumerAppUserSuccess';
  /** Resulting consumer app user. */
  consumerAppUser: ConsumerAppUser;
};

/** Consumer order. */
export type ConsumerOrder = Node & {
  __typename?: 'ConsumerOrder';
  /** When the order was marked complete. */
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Service fee paid by customer. */
  consumerAppUserServiceFee: Money;
  /** Created at datetime. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Curbside arrived. */
  curbsideArrived: Scalars['Boolean']['output'];
  /** When customer reported curbside arrival. */
  curbsideArrivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Curbside color. */
  curbsideColor?: Maybe<Scalars['String']['output']>;
  /** Curbside make. */
  curbsideMake?: Maybe<Scalars['String']['output']>;
  /** Curbside model. */
  curbsideModel?: Maybe<Scalars['String']['output']>;
  /** Curbside pickup. */
  curbsidePickup: Scalars['Boolean']['output'];
  /** Customer name. */
  customerName?: Maybe<Scalars['String']['output']>;
  /** Customer phone number. Null if unset or if the customer has opted not to allow merchants to contact them. */
  customerPhone?: Maybe<Scalars['String']['output']>;
  /** The primary key from the database. */
  databaseId: Scalars['Int']['output'];
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID']['output'];
  /** Line-items. */
  lineItems: Array<ConsumerOrderLineItem>;
  /** Order's current lock version, providing concurrency control and protection against stale updates. */
  lockVersion: Scalars['Int']['output'];
  /** Merchant. */
  merchant: Merchant;
  /** When merchant acknowledged the order. */
  merchantAcknowledgedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the order was marked picked-up. */
  pickedUpAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Scheduled pickup datetime. */
  pickupTime: Scalars['ISO8601DateTime']['output'];
  /** When the order was marked ready. */
  readiedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Refund info. */
  refundInfo: ConsumerRefundInfo;
  /** Discount applied by reward. */
  rewardValue: Money;
  /** Subtotal. */
  subtotal: Money;
  /** Tax. Based on subtotal - rewardValue. */
  tax: Money;
  /** Tip. */
  tip: Money;
  /** Total (subtotal - rewardValue + tax + tip + consumerAppUserServiceFee + deliveryFee). */
  total: Money;
};

/**
 * Result of attempting to create a full refund for a consumer order that
 * has already been refunded, either partially or fully. If the order has
 * only been partially refunded, clients desiring to refund the remaining
 * refundable amount should call createPartialConsumerRefund rather than
 * createFullConsumerRefund.
 */
export type ConsumerOrderAlreadyRefunded = Error & {
  __typename?: 'ConsumerOrderAlreadyRefunded';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Autogenerated input type of ConsumerOrderComplete */
export type ConsumerOrderCompleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Consumer order ID. */
  consumerOrderId: Scalars['ID']['input'];
  /**
   * Order's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int']['input'];
};

/** Autogenerated return type of ConsumerOrderComplete */
export type ConsumerOrderCompletePayload = {
  __typename?: 'ConsumerOrderCompletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to mark the order complete. */
  result: ConsumerOrderResult;
};

/** The connection type for ConsumerOrder. */
export type ConsumerOrderConnection = {
  __typename?: 'ConsumerOrderConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ConsumerOrderEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ConsumerOrder>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ConsumerOrderEdge = {
  __typename?: 'ConsumerOrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ConsumerOrder>;
};

/** Consumer order line-item. */
export type ConsumerOrderLineItem = Node & {
  __typename?: 'ConsumerOrderLineItem';
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID']['output'];
  /** Item name. */
  itemName: Scalars['String']['output'];
  /** Item quantity. */
  itemQuantity: Scalars['Int']['output'];
  /** Item size. */
  itemSize: Scalars['String']['output'];
  /** Modifiers. */
  modifiers: Array<ConsumerOrderLineItemModifier>;
  /** Note. */
  note?: Maybe<Scalars['String']['output']>;
  /** Submenu name. */
  submenuName?: Maybe<Scalars['String']['output']>;
  /** Subtotal. */
  subtotal: Money;
  /** Tax rate expressed as a percentage. */
  taxRate?: Maybe<Scalars['Float']['output']>;
  /** Unit price, not including modifiers. */
  unitPrice: Money;
};

/** Consumer order line-item modifier. */
export type ConsumerOrderLineItemModifier = Node & {
  __typename?: 'ConsumerOrderLineItemModifier';
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID']['output'];
  /** Modifier group name. */
  modifierGroupName: Scalars['String']['output'];
  /** Modifier option name. */
  modifierOptionName: Scalars['String']['output'];
  /** Quantity. */
  quantity: Scalars['Int']['output'];
  /** Unit price. */
  unitPrice: Money;
};

/** Autogenerated input type of ConsumerOrderPickedUp */
export type ConsumerOrderPickedUpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Consumer order ID. */
  consumerOrderId: Scalars['ID']['input'];
  /**
   * Order's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int']['input'];
};

/** Autogenerated return type of ConsumerOrderPickedUp */
export type ConsumerOrderPickedUpPayload = {
  __typename?: 'ConsumerOrderPickedUpPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to mark the order picked-up. */
  result: ConsumerOrderResult;
};

/** Autogenerated input type of ConsumerOrderReady */
export type ConsumerOrderReadyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Consumer order ID. */
  consumerOrderId: Scalars['ID']['input'];
  /**
   * Order's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int']['input'];
};

/** Autogenerated return type of ConsumerOrderReady */
export type ConsumerOrderReadyPayload = {
  __typename?: 'ConsumerOrderReadyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to ready the order. */
  result: ConsumerOrderResult;
};

/** Consumer order mutation result. */
export type ConsumerOrderResult = ConsumerOrderSuccess | ErrorsResult;

/** Sort criteria for a collection of consumer orders. */
export type ConsumerOrderSortCriteria = {
  /** Direction to sort in. */
  direction: SortDirection;
  /** Field to sort by. */
  field: ConsumerOrderSortField;
};

/** Fields by which consumer orders connection can be sorted. */
export enum ConsumerOrderSortField {
  /** Sort consumer orders by creation time. */
  CreatedAt = 'CREATED_AT',
  /** Sort consumer orders by pickup time. */
  PickupTime = 'PICKUP_TIME'
}

/** Result of a successful consumer order mutation. */
export type ConsumerOrderSuccess = {
  __typename?: 'ConsumerOrderSuccess';
  /** Resulting consumer order. */
  consumerOrder: ConsumerOrder;
};

export type ConsumerPostOrderSurvey = {
  __typename?: 'ConsumerPostOrderSurvey';
  /** Datetime after which the consumer post-order survey should be displayed. */
  displayAfter: Scalars['ISO8601DateTime']['output'];
  /** The order for which the consumer post-order survey should be displayed. */
  order: ConsumerOrder;
};

/**
 * Refund Info. Due to partial refunds, it's possible to submit multiple refunds
 * for a given order. This refund info object describes the cumulative effect of
 * all the refunds that have been processed.
 */
export type ConsumerRefundInfo = {
  __typename?: 'ConsumerRefundInfo';
  /** Customer refunded fee. */
  customerRefundedFee: Money;
  /** Customer refunded subtotal. */
  customerRefundedSubtotal: Money;
  /** Customer refunded tax. */
  customerRefundedTax: Money;
  /** Customer refunded tip. */
  customerRefundedTip: Money;
  /** Customer refunded total. */
  customerRefundedTotal: Money;
  /** Customer refunded reward. */
  customerRewardValue: Money;
  /**
   * Collection describing which item units (and associated modifier units) have
   * been refunded, and which have not yet been refunded.
   */
  items: Array<ConsumerRefundInfoItem>;
};

/**
 * Refund information about a single item and its modifiers. Note that a
 * ConsumerOrderLineItem with itemQuantity N will have N distinct RefundInfoItems.
 */
export type ConsumerRefundInfoItem = {
  __typename?: 'ConsumerRefundInfoItem';
  /** Item name. */
  itemName: Scalars['String']['output'];
  /** Item size. */
  itemSize: Scalars['String']['output'];
  /** ID of the associated ConsumerOrderLineItem. */
  lineItemId: Scalars['ID']['output'];
  /** Collection describing which of the item's associated modifiers have been refunded, and which have not yet been refunded. */
  modifiers: Array<ConsumerRefundInfoItemModifier>;
  /** Whether the item has been refunded. */
  refunded: Scalars['Boolean']['output'];
  /** Unit price, not including modifiers. */
  unitPrice: Money;
};

/**
 * Refund information about a single item modifier. Note that a
 * ConsumerOrderLineItemModifier with quantity N will have N distinct
 * RefundInfoItemModifiers.
 */
export type ConsumerRefundInfoItemModifier = {
  __typename?: 'ConsumerRefundInfoItemModifier';
  /** ID of the associated ConsumerOrderLineItemModifier. */
  lineItemModifierId: Scalars['ID']['output'];
  /** Modifier group name. */
  modifierGroupName: Scalars['String']['output'];
  /** Modifier option name. */
  modifierOptionName: Scalars['String']['output'];
  /** Whether the modifier has been refunded. */
  refunded: Scalars['Boolean']['output'];
  /** Unit price. */
  unitPrice: Money;
};

/** Consumer refund calculation result. */
export type ConsumerRefundInfoResult = ConsumerRefundInfoSuccess | ErrorsResult;

/** Result of a successful consumer refund calculation. */
export type ConsumerRefundInfoSuccess = {
  __typename?: 'ConsumerRefundInfoSuccess';
  /** Resulting refund info. */
  refundInfo: ConsumerRefundInfo;
};

/** Input for refunding a single unit of a ConsumerOrderLineItem. */
export type ConsumerRefundItemInput = {
  /**
   * How many not-yet-refunded units of the line item exist prior to applying the
   * requested mutation. This must equal the number of ConsumerRefundInfoItem
   * elements that identify the line item and have refunded = false (see
   * ConsumerOrder.refundInfo.items). If the provided count is incorrect, the
   * server will assume the request was made based on outdated information and will
   * respond with an appropriate error.
   */
  currentCount: Scalars['Int']['input'];
  /** ID of the associated ConsumerOrderLineItem. */
  lineItemId: Scalars['ID']['input'];
};

/** Input for refunding a single unit of a ConsumerOrderLineItemModifier. */
export type ConsumerRefundModifierInput = {
  /**
   * How many not-yet-refunded units of the item modifier exist prior to applying
   * the requested mutation. This must equal the number of
   * ConsumerRefundInfoItemModifier elements that identify the item modifier and
   * have refunded = false (see ConsumerOrder.refundInfo.items.modifiers). If the
   * provided count is incorrect, the server will assume the request was made based
   * on outdated information and will respond with an appropriate error.
   */
  currentCount: Scalars['Int']['input'];
  /** ID of the associated ConsumerOrderLineItemModifier. */
  lineItemModifierId: Scalars['ID']['input'];
};

export type ContactDetailsRequired = UserErrorInterface & {
  __typename?: 'ContactDetailsRequired';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type ConversionBreakdown = {
  __typename?: 'ConversionBreakdown';
  /** Number of bookings made through booking links */
  bookings: Scalars['Int']['output'];
  /** Number of conversions from phone calls */
  calls: Scalars['Int']['output'];
  /** Number of conversions from direction requests */
  directions: Scalars['Int']['output'];
  /** Number of conversions from menu clicks */
  menuClicks: Scalars['Int']['output'];
  /** Number of conversions from website clicks */
  websiteClicks: Scalars['Int']['output'];
};

export type ConversionMetrics = {
  __typename?: 'ConversionMetrics';
  /** Daily breakdown of conversion metrics */
  dailyBreakdown: Array<DailyConversion>;
  /** Total breakdown of conversion metrics by type for a given date range */
  totalBreakdown: ConversionBreakdown;
  /** Total number of conversions across all types for a given date range */
  totalConversions: Scalars['Int']['output'];
};

export type CountRatings = {
  __typename?: 'CountRatings';
  byRating: ByRating;
  total: Scalars['Int']['output'];
};

/** PROTOTYPE input for how much was counted and where. */
export type CountingEventInput = {
  /**
   * PROTOTYPE if counted using a location's custom counting unit, its id. If null,
   * the current Odeko sales unit will be recorded instead.
   */
  locationCountingUnitId?: InputMaybe<Scalars['ID']['input']>;
  /** PROTOTYPE if present, the location storage area containing the quantity recorded. */
  locationStorageAreaId?: InputMaybe<Scalars['ID']['input']>;
  /** PROTOTYPE how many units were counted */
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

export type CouponStatus = {
  __typename?: 'CouponStatus';
  /** Discount applied from this coupon */
  discount?: Maybe<Money>;
  /** Reason why the coupon is invalid (or null). */
  reason?: Maybe<Scalars['String']['output']>;
  /** The number of times the coupon can be redeemed (or null, if unlimited). */
  redemptionsAvailable?: Maybe<Scalars['Int']['output']>;
  /** Whether the coupon is valid or not. */
  valid: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateBrandedItemDealMutation */
export type CreateBrandedItemDealMutationInput = {
  /** Branded item deal attributes */
  brandedItemDeal: BrandedItemDealInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateBrandedItemDealMutation. */
export type CreateBrandedItemDealMutationPayload = {
  __typename?: 'CreateBrandedItemDealMutationPayload';
  brandedItemDeal?: Maybe<BrandedItemDeal>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
};

export type CreateCollectionPromoSetupInput = {
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  description: Scalars['String']['input'];
  desktopHeroImage: Scalars['String']['input'];
  itemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  mobileHeroImage: Scalars['String']['input'];
  name: Scalars['String']['input'];
  ordered?: InputMaybe<Scalars['Boolean']['input']>;
  promoName: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  warehouseIds: Array<Scalars['ID']['input']>;
};

export type CreateCollectionPromoSetupPayload = {
  __typename?: 'CreateCollectionPromoSetupPayload';
  collectionId?: Maybe<Scalars['ID']['output']>;
  errors: Array<CollectionPromoSetupError>;
  invalidItemIds: Array<Scalars['ID']['output']>;
  promoPageId?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of CreateCountingEventMutation */
export type CreateCountingEventMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** PROTOTYPE quantity counted */
  countingEventInput: CountingEventInput;
  /** PROTOTYPE id of the inventory LocationItem being counted. */
  locationItemId: Scalars['ID']['input'];
  /**
   * PROTOTYPE id of the LocationStockCount session. It is an error if there is a
   * current session and this argument is omitted. If there is no current session,
   * a new one is created.
   */
  stockCountId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateCountingEventMutation. */
export type CreateCountingEventMutationPayload = {
  __typename?: 'CreateCountingEventMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** PROTOTYPE the recorded count. */
  currentCount?: Maybe<CurrentCount>;
  /** PROTOTYPE the location Stock Count session recorded by the count. */
  currentStockCount?: Maybe<LocationStockCount>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateCustomIngredientMutation */
export type CreateCustomIngredientMutationInput = {
  /** Brand name of the ingredient */
  brand?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** UUID for the Location */
  locationId: Scalars['ID']['input'];
  /** Name of the ingredient */
  name: Scalars['String']['input'];
  /** Price purchased at */
  purchasePrice: MoneyInput;
  /** Unit purchased at */
  purchaseUnit: Scalars['ID']['input'];
  /** Purchased from */
  purchaseVendor?: InputMaybe<Scalars['String']['input']>;
  /** Quantity portion of item size */
  sizeQuantity: Scalars['Float']['input'];
  /** Unit portion of item size */
  sizeUnit: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateCustomIngredientMutation. */
export type CreateCustomIngredientMutationPayload = {
  __typename?: 'CreateCustomIngredientMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  customIngredient?: Maybe<CustomIngredient>;
  errors: Array<UserError>;
};

/** Autogenerated input type of CreateCustomerTagImportMutation */
export type CreateCustomerTagImportMutationInput = {
  /** Size of the file in bytes. At most 10485760. */
  byteSize: Scalars['Int']['input'];
  /** Base64 MD5 of the file, as ActiveStorage's direct upload expects. */
  checksum: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contentType: Scalars['String']['input'];
  /** The name of the file being uploaded, as the browser reports it. */
  originalFilename: Scalars['String']['input'];
};

/** Autogenerated return type of CreateCustomerTagImportMutation. */
export type CreateCustomerTagImportMutationPayload = {
  __typename?: 'CreateCustomerTagImportMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  customerTagImport?: Maybe<CustomerTagImport>;
  errors: Array<Scalars['String']['output']>;
  /** Hand back to startCustomerTagImport once the PUT succeeds. */
  signedBlobId?: Maybe<Scalars['String']['output']>;
  /** Send every one of these with the PUT, or storage refuses it. */
  uploadHeaders: Array<CustomerTagImportUploadHeader>;
  /** PUT the file here. Expires, so upload promptly. */
  uploadUrl?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateCustomerTagMutation */
export type CreateCustomerTagMutationInput = {
  /** What kind of audience the tag describes: when a location takes delivery, where it is, or what it sells. */
  category: CustomerTagCategoryEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Display name for the new tag, e.g. "Brooklyn / Queens". Its slug is derived from this and cannot be changed later. */
  name: Scalars['String']['input'];
};

/** Autogenerated return type of CreateCustomerTagMutation. */
export type CreateCustomerTagMutationPayload = {
  __typename?: 'CreateCustomerTagMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  customerTag?: Maybe<CustomerTag>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateDeliveryOverrideRuleMutation */
export type CreateDeliveryOverrideRuleMutationInput = {
  /** Which locations a `group` override reaches. Required for `group`, rejected otherwise. */
  audience?: InputMaybe<DeliveryOverrideAudienceInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Block, substitute, or allow the day. Omit for an attribute-only override. */
  dayAction?: InputMaybe<DeliveryOverrideDayActionEnum>;
  /** The date the override applies to. */
  deliveryDate: Scalars['ISO8601Date']['input'];
  /** Override the order lead time (days) for this date only. */
  leadTime?: InputMaybe<Scalars['Int']['input']>;
  /** Location UUID. Required for `lva` and `location` overrides; omitted for `group` and `vendor`; rejected for `market`. */
  locationId?: InputMaybe<Scalars['ID']['input']>;
  /** Override the order cutoff ("HH:MM") for this date only. */
  orderDeadline?: InputMaybe<Scalars['String']['input']>;
  /** Applies to a group or vendor rule that names a vendor. Defaults from the day action: block -> ALL, otherwise LVA_ONLY. */
  reachMode?: InputMaybe<DeliveryOverrideReachModeEnum>;
  /** The grain the override targets. Defaults to a single location+vendor. */
  scope?: InputMaybe<DeliveryOverrideScopeEnum>;
  /** The make-up delivery date. Required when dayAction is `substitute`. */
  substituteDeliveryDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /**
   * Vendor UUID. Required for `lva` and `vendor` overrides, omitted for a
   * `location` one. Optional for a `group`: omit it to reach every vendor serving
   * the audience. Rejected for `market`, which always reaches every vendor.
   */
  vendorId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Warehouse UUID. The market the override applies in; omit to reach every
   * market. Must be the market its location sits in when the override names one.
   * Required for `market`.
   */
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateDeliveryOverrideRuleMutation. */
export type CreateDeliveryOverrideRuleMutationPayload = {
  __typename?: 'CreateDeliveryOverrideRuleMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deliveryOverrideRule?: Maybe<DeliveryOverrideRule>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated input type of CreateDirectStripeCheckoutSessionMutation */
export type CreateDirectStripeCheckoutSessionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Customer email (required if not authenticated) */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Human-readable integer ID of the pricing package (pricing_package_id field) */
  integerPricingPackageId: Scalars['Int']['input'];
  /**
   * Complete URL for Stripe checkout return redirect. After checkout the user is
   * redirected back to this URL with a query param `stripe_checkout_session_id`.
   */
  returnPath: Scalars['String']['input'];
  /** Sign color (required if material is not wood) */
  signColor?: InputMaybe<Scalars['String']['input']>;
  /** Sign material (required if pricing package requires kit) */
  signMaterial?: InputMaybe<Scalars['String']['input']>;
  /** Use Stripe Elements (custom ui_mode) instead of embedded checkout */
  useElements?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of CreateDirectStripeCheckoutSessionMutation. */
export type CreateDirectStripeCheckoutSessionMutationPayload = {
  __typename?: 'CreateDirectStripeCheckoutSessionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Stripe client secret for checkout */
  clientSecret?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']['output']>;
  /** ID of the created StripeCheckoutSession */
  stripeCheckoutSessionId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateExternalBaseBrandedItemMutation */
export type CreateExternalBaseBrandedItemMutationInput = {
  /** Base item attributes */
  baseBrandedItem: BaseBrandedItemInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deliveryPrice: MoneyInput;
  /** External item's procurement vendor */
  procurementVendor: Scalars['ID']['input'];
  /** Variants of the item that are offered */
  variants: Array<ExternalBaseBrandedItemVariantInput>;
};

/** Autogenerated return type of CreateExternalBaseBrandedItemMutation. */
export type CreateExternalBaseBrandedItemMutationPayload = {
  __typename?: 'CreateExternalBaseBrandedItemMutationPayload';
  baseBrandedItem?: Maybe<BaseBrandedItem>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
};

/** Autogenerated input type of CreateExternalDeliveryMutation */
export type CreateExternalDeliveryMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Order id denoting the order that should be delivered via the 3rd party delivery partner. */
  orderId: Scalars['ID']['input'];
  /** The number of containers used to pack the order. */
  totalContainers: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateExternalDeliveryMutation. */
export type CreateExternalDeliveryMutationPayload = {
  __typename?: 'CreateExternalDeliveryMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<UserError>>;
  externalDelivery?: Maybe<ExternalDelivery>;
};

/** Autogenerated input type of CreateFieldServiceZipcodeMutation */
export type CreateFieldServiceZipcodeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The warehouse uuid (the federated Warehouse.id) to serve this zip code from. */
  warehouseId: Scalars['ID']['input'];
  /** A 5-digit zip code, e.g. "02134". Leading zeros are significant and preserved. */
  zipCode: Scalars['String']['input'];
};

/** Autogenerated return type of CreateFieldServiceZipcodeMutation. */
export type CreateFieldServiceZipcodeMutationPayload = {
  __typename?: 'CreateFieldServiceZipcodeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  fieldServiceZipcode?: Maybe<FieldServiceZipcode>;
};

/** Autogenerated input type of CreateFullConsumerRefund */
export type CreateFullConsumerRefundInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Consumer order ID. */
  consumerOrderId: Scalars['ID']['input'];
  /**
   * Order's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateFullConsumerRefund */
export type CreateFullConsumerRefundPayload = {
  __typename?: 'CreateFullConsumerRefundPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to create a full consumer refund. */
  result: ConsumerOrderResult;
};

/** Autogenerated input type of CreateGameMutation */
export type CreateGameMutationInput = {
  /** Whether the game is active */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Description of the game */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Additional game metadata */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Name of the game */
  name: Scalars['String']['input'];
  /** URL-friendly identifier */
  slug: Scalars['String']['input'];
};

/** Autogenerated return type of CreateGameMutation. */
export type CreateGameMutationPayload = {
  __typename?: 'CreateGameMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']['output']>;
  /** The created game */
  game?: Maybe<Game>;
};

export type CreateHomepageComponentInput = {
  collectionId: Scalars['ID']['input'];
  componentId?: InputMaybe<Scalars['ID']['input']>;
  desktopImage?: InputMaybe<Scalars['String']['input']>;
  displayRule?: InputMaybe<HomepageDisplayRuleUpsertInput>;
  fontStyle?: InputMaybe<Scalars['String']['input']>;
  highlightImage?: InputMaybe<Scalars['String']['input']>;
  mobileImage?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  rowId?: InputMaybe<Scalars['ID']['input']>;
  warehouseIds: Array<Scalars['ID']['input']>;
};

export type CreateHomepageComponentPayload = {
  __typename?: 'CreateHomepageComponentPayload';
  componentId?: Maybe<Scalars['ID']['output']>;
  componentType?: Maybe<HomepageCollectionComponentType>;
  errors: Array<HomepageComponentError>;
  ruleId?: Maybe<Scalars['ID']['output']>;
};

export type CreateHomepageDisplayRuleInput = {
  componentId: Scalars['ID']['input'];
  endDate: Scalars['String']['input'];
  position: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  warehouseIds: Array<Scalars['ID']['input']>;
};

export type CreateHomepageDisplayRulePayload = {
  __typename?: 'CreateHomepageDisplayRulePayload';
  errors: Array<HomepageDisplayRuleError>;
  ruleId?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of CreateHubspotLead */
export type CreateHubspotLeadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  hubspotOwnerId?: InputMaybe<Scalars['String']['input']>;
  leadName?: InputMaybe<Scalars['String']['input']>;
  leadType?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateHubspotLead. */
export type CreateHubspotLeadPayload = {
  __typename?: 'CreateHubspotLeadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  leadId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateInHouseBaseBrandedItemMutation */
export type CreateInHouseBaseBrandedItemMutationInput = {
  /** Base item attributes */
  baseBrandedItem: BaseBrandedItemInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** In-house item's associated supply item */
  supplyItem: Scalars['ID']['input'];
  /** Variants of the item that are offered */
  variants: Array<InHouseBaseBrandedItemVariantInput>;
};

/** Autogenerated return type of CreateInHouseBaseBrandedItemMutation. */
export type CreateInHouseBaseBrandedItemMutationPayload = {
  __typename?: 'CreateInHouseBaseBrandedItemMutationPayload';
  baseBrandedItem?: Maybe<BaseBrandedItem>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
};

/** Autogenerated input type of CreateLeaderboardMutation */
export type CreateLeaderboardMutationInput = {
  /** Whether the leaderboard is active */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Slug of the game */
  gameSlug: Scalars['String']['input'];
  /** Type of leaderboard */
  leaderboardType?: InputMaybe<LeaderboardTypeEnum>;
  /** Additional leaderboard metadata */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** ID of the microsite location */
  micrositeLocationId: Scalars['ID']['input'];
  /** Name of the leaderboard */
  name: Scalars['String']['input'];
  /** When the leaderboard resets */
  resetSchedule?: InputMaybe<Scalars['String']['input']>;
  /** How scores are aggregated */
  scoreOperator?: InputMaybe<ScoreOperatorEnum>;
  /** URL-friendly identifier */
  slug: Scalars['String']['input'];
  /** How scores are sorted */
  sortOrder?: InputMaybe<SortOrderEnum>;
};

/** Autogenerated return type of CreateLeaderboardMutation. */
export type CreateLeaderboardMutationPayload = {
  __typename?: 'CreateLeaderboardMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']['output']>;
  /** The created leaderboard */
  leaderboard?: Maybe<Leaderboard>;
};

/** Autogenerated input type of CreateLocationMutation */
export type CreateLocationMutationInput = {
  /** Street address line 1 */
  addressLine1: Scalars['String']['input'];
  /** Street address line 2 (apt, suite, etc.) */
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** City / locality */
  city: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Required for admin actors; ignored for customer-role actors. */
  companyOdekoUuid?: InputMaybe<Scalars['ID']['input']>;
  /** ISO 3166-1 alpha-2 country code (default US) */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** County / admin district level 2 */
  county?: InputMaybe<Scalars['String']['input']>;
  /** Odeko display name for the location */
  displayName: Scalars['String']['input'];
  /** Google Places place_id for the address */
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  /** Latitude in decimal degrees */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  /** Longitude in decimal degrees */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /** Postal / ZIP code */
  postalCode: Scalars['String']['input'];
  /** State / admin district (ISO 3166-2 subdivision code) */
  state: Scalars['String']['input'];
  /** UTC offset in minutes from Google Places (used to derive Olson timezone) */
  utcOffsetMinutes?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of CreateLocationMutation. */
export type CreateLocationMutationPayload = {
  __typename?: 'CreateLocationMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  location?: Maybe<Location>;
};

/** Autogenerated input type of CreateLocationVendorAssociationMutation */
export type CreateLocationVendorAssociationMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Location UUID */
  locationUuid: Scalars['ID']['input'];
  /** Vendor UUID */
  vendorUuid: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateLocationVendorAssociationMutation. */
export type CreateLocationVendorAssociationMutationPayload = {
  __typename?: 'CreateLocationVendorAssociationMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<UserError>>;
  lvaExisted?: Maybe<Scalars['Boolean']['output']>;
  succeeded: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateMarketingToolsManagerMutation */
export type CreateMarketingToolsManagerMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The email address for the marketing tools manager */
  email: Scalars['String']['input'];
  /** The first name of the marketing tools manager */
  firstName: Scalars['String']['input'];
  /** The last name of the marketing tools manager */
  lastName: Scalars['String']['input'];
  /** The password for the marketing tools manager (optional - will generate if not provided) */
  password?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateMarketingToolsManagerMutation. */
export type CreateMarketingToolsManagerMutationPayload = {
  __typename?: 'CreateMarketingToolsManagerMutationPayload';
  /**
   * The Auth0 user ID of the created marketing tools manager. Useful in contexts
   * like a sign up flow where we may be prohibited from returning the full user object.
   */
  auth0UserId?: Maybe<Scalars['String']['output']>;
  authorization?: Maybe<SigninAuthorization>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  credentials?: Maybe<SigninCredentials>;
  errors: Array<UserError>;
  user?: Maybe<User>;
};

/** Autogenerated input type of CreateMenu */
export type CreateMenuInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Odeko uuid for the merchant */
  merchantUuid: Scalars['ID']['input'];
  /** Name of the menu */
  name: Scalars['String']['input'];
  /** The order of the menu in the UI. If omitted, the menu will be appended to the end of the merchant's menus. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of CreateMenuItem */
export type CreateMenuItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Description. */
  description: Scalars['String']['input'];
  /** Whether the menu item is hot. */
  isHot?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of the menu item */
  name: Scalars['String']['input'];
  /** Sizes of menu items. */
  sizes: Array<MenuItemSizeInput>;
  /** The order of the menu item in the UI. If omitted, the menu item will be appended to the end of the submenu's items. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  /** Submenu ID */
  submenuId: Scalars['ID']['input'];
  /** Tax rate expressed as a percentage. If omitted, taxes will be calculated based on the rate set on the menu or merchant. */
  taxRate?: InputMaybe<Scalars['Float']['input']>;
};

/** Autogenerated return type of CreateMenuItem */
export type CreateMenuItemPayload = {
  __typename?: 'CreateMenuItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of creating menu */
  result: MenuItemResult;
};

/** Autogenerated return type of CreateMenu */
export type CreateMenuPayload = {
  __typename?: 'CreateMenuPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of creating menu */
  result: MenuResult;
};

/** Autogenerated input type of CreateMicrositeLocationMutation */
export type CreateMicrositeLocationMutationInput = {
  /** Business address (optional, used for geocoding timezone) */
  businessAddress?: InputMaybe<Scalars['String']['input']>;
  /** Business name (required if google_place_id not provided) */
  businessName?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Google Places API place ID (mutually exclusive with business_name) */
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  /** Stripe checkout session ID to associate with the microsite */
  stripeCheckoutSessionId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateMicrositeLocationMutation. */
export type CreateMicrositeLocationMutationPayload = {
  __typename?: 'CreateMicrositeLocationMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']['output']>;
  /** The created microsite location */
  micrositeLocation?: Maybe<MicrositeLocation>;
};

/** Autogenerated input type of CreateOrderReconciliationAttachmentUploadRequestMutation */
export type CreateOrderReconciliationAttachmentUploadRequestMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateOrderReconciliationAttachmentUploadRequestMutation. */
export type CreateOrderReconciliationAttachmentUploadRequestMutationPayload = {
  __typename?: 'CreateOrderReconciliationAttachmentUploadRequestMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  objectKey?: Maybe<Scalars['String']['output']>;
  presignedUrl?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateOrderReconciliationMutation */
export type CreateOrderReconciliationMutationInput = {
  /**
   * Attachments keys related to the reconciliation (e.g images, videos, etc.).
   * Attachment ids must be generated via
   * CreateOrderReconciliationAttachmentUploadRequestMutation
   */
  attachmentsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Additional description for the reconciliation */
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID of the item to reconcile */
  itemId: Scalars['ID']['input'];
  /** ID of the order to reconcile */
  orderId: Scalars['ID']['input'];
  /** UUID of the order line to reconcile. When provided with feature flag enabled, supersedes item_id lookup */
  orderLineId?: InputMaybe<Scalars['ID']['input']>;
  /** Reasons for reconciliation (e.g., Missing Item, Wrong Item, etc.) */
  reasons: Array<OrderReconciliationReasonEnum>;
  /** The reconciled quantity for the order */
  reconciledQuantity: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateOrderReconciliationMutation. */
export type CreateOrderReconciliationMutationPayload = {
  __typename?: 'CreateOrderReconciliationMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<UserError>>;
  reconciledOrderLine?: Maybe<ReconciledOrderLine>;
};

/** Autogenerated input type of CreatePartialConsumerRefund */
export type CreatePartialConsumerRefundInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Consumer order ID. */
  consumerOrderId: Scalars['ID']['input'];
  /**
   * Order's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int']['input'];
  /** Collection describing the item units to be refunded. */
  refundItemInputs: Array<ConsumerRefundItemInput>;
  /** Collection describing the modifier units to be refunded. */
  refundModifierInputs: Array<ConsumerRefundModifierInput>;
};

/** Autogenerated return type of CreatePartialConsumerRefund */
export type CreatePartialConsumerRefundPayload = {
  __typename?: 'CreatePartialConsumerRefundPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to create a partial consumer refund. */
  result: ConsumerOrderResult;
};

/** Autogenerated input type of CreateReceivableNote */
export type CreateReceivableNoteInput = {
  authorEmail: Scalars['String']['input'];
  body: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  locationUuid: Scalars['String']['input'];
};

/** Autogenerated return type of CreateReceivableNote. */
export type CreateReceivableNotePayload = {
  __typename?: 'CreateReceivableNotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  receivableNote?: Maybe<ReceivableNote>;
};

/** Autogenerated input type of CreateSalesTaxEstimateMutation */
export type CreateSalesTaxEstimateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Date. Defaults to current date in vendor's time zone. */
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Line items */
  lines: Array<SalesTaxLineInput>;
  /** Location UUID */
  locationId: Scalars['ID']['input'];
  /** Vendor UUID */
  vendorId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateSalesTaxEstimateMutation. */
export type CreateSalesTaxEstimateMutationPayload = {
  __typename?: 'CreateSalesTaxEstimateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<UserError>>;
  salesTaxEstimate?: Maybe<SalesTaxEstimate>;
};

/** Autogenerated input type of CreateSignPurchaseCheckoutSessionMutation */
export type CreateSignPurchaseCheckoutSessionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the microsite location to associate with the sign purchase */
  micrositeLocationId: Scalars['ID']['input'];
  /** Initial quantity of signs (minimum 1, default 1) */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Complete URL for Stripe checkout return redirect */
  returnPath: Scalars['String']['input'];
  /** Sign color (required if material is not wood) */
  signColor?: InputMaybe<Scalars['String']['input']>;
  /** Sign material */
  signMaterial: Scalars['String']['input'];
  /** Use Stripe Elements (custom ui_mode) instead of embedded checkout */
  useElements?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of CreateSignPurchaseCheckoutSessionMutation. */
export type CreateSignPurchaseCheckoutSessionMutationPayload = {
  __typename?: 'CreateSignPurchaseCheckoutSessionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Stripe client secret for checkout */
  clientSecret?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']['output']>;
  /** ID of the created StripeCheckoutSession */
  stripeCheckoutSessionId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateSquareOrderSuggestionFromTranscriptMutation */
export type CreateSquareOrderSuggestionFromTranscriptMutationInput = {
  /** The external profile ID (entityId) for the Square connection */
  accountProfileId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The voice transcript containing the customer's order */
  transcript: Scalars['String']['input'];
};

/** Autogenerated return type of CreateSquareOrderSuggestionFromTranscriptMutation. */
export type CreateSquareOrderSuggestionFromTranscriptMutationPayload = {
  __typename?: 'CreateSquareOrderSuggestionFromTranscriptMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']['output']>;
  /** The created order suggestion */
  orderSuggestion?: Maybe<SquareOrderSuggestion>;
};

/** Autogenerated input type of CreateStorageAreaMutation */
export type CreateStorageAreaMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** PROTOTYPE The Odeko UUID of the location. */
  locationId: Scalars['ID']['input'];
  /** PROTOTYPE The name of the storage area in the location. */
  name: Scalars['String']['input'];
};

/** Autogenerated return type of CreateStorageAreaMutation. */
export type CreateStorageAreaMutationPayload = {
  __typename?: 'CreateStorageAreaMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  storageArea?: Maybe<LocationStorageArea>;
};

/** Autogenerated input type of CreateStripeCheckoutSessionMutation */
export type CreateStripeCheckoutSessionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Custom return URL for Stripe checkout (will append stripe_checkout_session_id parameter) */
  returnUrl?: InputMaybe<Scalars['String']['input']>;
  /** ID of existing subscription session */
  subscriptionSessionId: Scalars['ID']['input'];
  /** Use Stripe Elements (custom ui_mode) instead of embedded checkout */
  useElements?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of CreateStripeCheckoutSessionMutation. */
export type CreateStripeCheckoutSessionMutationPayload = {
  __typename?: 'CreateStripeCheckoutSessionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Stripe client secret for embedded checkout */
  clientSecret?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateSubmenu */
export type CreateSubmenuInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Menu ID */
  menuId: Scalars['ID']['input'];
  /** Name of the menu */
  name: Scalars['String']['input'];
  /** The order of the menu in the UI. If omitted, the menu will be appended to the end of the merchant's menus. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of CreateSubmenu */
export type CreateSubmenuPayload = {
  __typename?: 'CreateSubmenuPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of creating menu */
  result: SubmenuResult;
};

/** Autogenerated input type of CreateSupplierInvoiceComparison */
export type CreateSupplierInvoiceComparisonInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  prospectiveLocationAddress?: InputMaybe<Scalars['String']['input']>;
  prospectiveLocationName?: InputMaybe<Scalars['String']['input']>;
  warehouseId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateSupplierInvoiceComparison. */
export type CreateSupplierInvoiceComparisonPayload = {
  __typename?: 'CreateSupplierInvoiceComparisonPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  supplierInvoiceComparison?: Maybe<SupplierInvoiceComparison>;
};

/** Autogenerated input type of CreateSupplierInvoice */
export type CreateSupplierInvoiceInput = {
  byteSize: Scalars['Int']['input'];
  checksum: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contentType: Scalars['String']['input'];
  externalSupplierId?: InputMaybe<Scalars['ID']['input']>;
  externalSupplierName?: InputMaybe<Scalars['String']['input']>;
  invoiceDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  originalFilename: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  supplierInvoiceComparisonId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateSupplierInvoice. */
export type CreateSupplierInvoicePayload = {
  __typename?: 'CreateSupplierInvoicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  signedBlobId?: Maybe<Scalars['String']['output']>;
  supplierInvoice?: Maybe<SupplierInvoice>;
  supplierInvoiceComparison?: Maybe<SupplierInvoiceComparison>;
  uploadHeaders: Array<DirectUploadHeader>;
  uploadUrl?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateUserMicrositeLocation */
export type CreateUserMicrositeLocationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Integer ID of the pricing package to associate with the user */
  integerPricingPackageId?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the microsite location to associate with the user */
  micrositeLocationId: Scalars['ID']['input'];
  /** Auth0 ID of the user to associate with the microsite */
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateUserMicrositeLocation. */
export type CreateUserMicrositeLocationPayload = {
  __typename?: 'CreateUserMicrositeLocationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userMicrositeLocation: UserMicrositeLocation;
};

/** Autogenerated input type of CreateUserMutation */
export type CreateUserMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Required for admin actors; ignored for customer-role actors. */
  companyOdekoUuid?: InputMaybe<Scalars['ID']['input']>;
  /** The email address for the new user */
  email: Scalars['String']['input'];
  /** The first name of the new user */
  firstName: Scalars['String']['input'];
  /** The last name of the new user */
  lastName: Scalars['String']['input'];
  /** Odeko UUIDs of the locations the new user should have access to */
  locationOdekoUuids: Array<Scalars['String']['input']>;
  /** Optional phone number for the new user */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** The role to assign to the new user */
  role: Scalars['String']['input'];
};

/** Autogenerated return type of CreateUserMutation. */
export type CreateUserMutationPayload = {
  __typename?: 'CreateUserMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  user?: Maybe<User>;
};

/** Autogenerated input type of CreateWorkThread */
export type CreateWorkThreadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

/** Autogenerated return type of CreateWorkThread. */
export type CreateWorkThreadPayload = {
  __typename?: 'CreateWorkThreadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  event?: Maybe<WorkThreadEvent>;
  workThread?: Maybe<WorkThread>;
};

/**
 * A group that refers to a credit application, i.e. a credit amount that was
 * partially or fully applied to an invoice from a given credit memo.
 */
export type CreditApplication = PaymentInvoiceGroup & {
  __typename?: 'CreditApplication';
  /**
   * Invoices in the group. This collection, although not paginated, is expressed
   * as a connection type in order to include the amount of payment associated with
   * each invoice via PaymentEarmark/PaymentUsage edge info.
   */
  invoices: FinancialTransactionConnection;
  /** Credit amount applied to a given invoice. */
  paymentAmount: Money;
  /** Date on which the credit was applied. */
  paymentDate: Scalars['ISO8601Date']['output'];
};

export type CreditCard = {
  __typename?: 'CreditCard';
  billingDetails: BillingDetails;
  brand: Scalars['String']['output'];
  /**
   * Locations for which this payment method is currently the default. Lists every
   * such location, including ones the viewer is not individually assigned to, so a
   * caller can state the true scope of removing the method. Empty when the method
   * is nobody's default.
   */
  defaultForLocations: Array<PaymentMethodDefaultLocation>;
  expMonth: Scalars['Int']['output'];
  expYear: Scalars['Int']['output'];
  /** Stripe card funding type: credit, debit, prepaid or unknown */
  funding?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  last4: Scalars['String']['output'];
  lastPaymentError?: Maybe<PaymentError>;
};

/** Edge connecting a credit-memo to the invoice from which credit was issued. */
export type CreditIssuance = FinancialTransactionEdgeInfo & {
  __typename?: 'CreditIssuance';
  _?: Maybe<Scalars['String']['output']>;
};

/** Error indicating that a Credit Key account could not be found. */
export type CreditKeyAccountNotFound = Error & {
  __typename?: 'CreditKeyAccountNotFound';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Error indicating that the Credit Key account is not usable. */
export type CreditKeyAccountNotUsable = Error & {
  __typename?: 'CreditKeyAccountNotUsable';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Edge connecting a credit-memo to a transaction (e.g. invoice) on which credit was used. */
export type CreditUsage = FinancialTransactionEdgeInfo & {
  __typename?: 'CreditUsage';
  _?: Maybe<Scalars['String']['output']>;
  /** Amount of credit used. */
  amount: Money;
  /** Date on which credit was used. */
  date: Scalars['ISO8601Date']['output'];
};

/** Error indicating that curbside pickup cannot be requested because merchant has not enabled curbside pickup. */
export type CurbsidePickupNotEnabled = Error & {
  __typename?: 'CurbsidePickupNotEnabled';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

export enum Currency {
  Usd = 'USD'
}

/** PROTOTYPE For a location item and stock count session, return the latest count. */
export type CurrentCount = {
  __typename?: 'CurrentCount';
  /** PROTOTYPE when the quantity was recorded. */
  countedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * PROTOTYPE if counted using a custom LocationCountingUnit, that unit.null if an
   * Odeko sales unit was used instead. In that case, salesUnitId is present.
   */
  locationCountingUnit?: Maybe<LocationCountingUnit>;
  /**
   * PROTOTYPE id of the stock count session. Included so that together with
   * stock_count_id, this is normalizeable by Apollo Client.
   */
  locationItemId: Scalars['ID']['output'];
  /** PROTOTYPE the value entered for the count. May be null. */
  quantity?: Maybe<Scalars['Float']['output']>;
  /**
   * PROTOTYPE if counted using the Odeko sales unit, the id of that unit.null if a
   * customer LocationCountingUnit was used instead. In that case,
   * locationCountingUnit is present.
   */
  salesUnitId?: Maybe<Scalars['ID']['output']>;
  /**
   * PROTOTYPE id of the LocationStockCount session. Included so that together with
   * location_item_id, this type is normalizeable by Apollo Client.
   */
  stockCountId: Scalars['ID']['output'];
};

export type CustomBrandedItem = {
  __typename?: 'CustomBrandedItem';
  baseBrandedItem: BaseBrandedItem;
  brandedItemArtwork?: Maybe<BrandedItemArtwork>;
  color: Color;
  /** Price that the color associated with the item was charged at per case */
  colorPricePerUnit: Money;
  id: Scalars['ID']['output'];
  /** Price that we sold the item at */
  salesPrice: Money;
  /** One time cost to setup the item for the customer */
  setupFee: Money;
};

export type CustomBrandedItemInput = {
  /** Base branded item id */
  baseBrandedItemId: Scalars['ID']['input'];
  /** Branded item artwork id */
  brandedItemArtworkId?: InputMaybe<Scalars['ID']['input']>;
  /** Color id */
  colorId: Scalars['ID']['input'];
  /** Price that we charge for Color per sales unit */
  colorPricePerUnit: MoneyInput;
  /** Price that we sold the item at */
  salesPrice: MoneyInput;
  /** One time cost to setup the item for the customer */
  setupFee: MoneyInput;
};

export type CustomIngredient = {
  __typename?: 'CustomIngredient';
  brand: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  purchasePrice: Money;
  purchaseUnit: Unit;
  purchaseVendor?: Maybe<Scalars['String']['output']>;
  sizeQuantity: Scalars['Float']['output'];
  sizeUnit: Unit;
};

export type CustomPrice = {
  __typename?: 'CustomPrice';
  customPrice: Money;
  item: SupplyItem;
  location: Location;
};

/** Provide basic information about a raw CustomerCsvUpload. Each row of a CustomerCsvUpload generates an InProgressCustomer. */
export type CustomerCsvUpload = {
  __typename?: 'CustomerCsvUpload';
  /** The filename (basename and extension) of the uploaded CSV. */
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

/** An edge in a connection. */
export type CustomerLocationEdge = {
  __typename?: 'CustomerLocationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Location>;
};

/** The connection type for Location. */
export type CustomerLocationsConnection = {
  __typename?: 'CustomerLocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CustomerLocationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Location>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of records in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type CustomerLocationsInput = {
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};

export type CustomerTag = {
  __typename?: 'CustomerTag';
  /** How many locations currently carry this tag. */
  assignedLocationCount: Scalars['Int']['output'];
  /** For an auto-generated tag, the rule that decides which locations carry it. */
  autoDefinition?: Maybe<Scalars['JSON']['output']>;
  /** What kind of audience this tag describes: when a location takes delivery, where it is, or what it sells. */
  category: CustomerTagCategoryEnum;
  /** When the tag was deleted, or null if it is still live. */
  deletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** The tag's display name, e.g. "Brooklyn / Queens". */
  name: Scalars['String']['output'];
  /** Governance namespace the tag belongs to (e.g. "operations"). */
  scope: Scalars['String']['output'];
  /** Unique, stable identifier used when targeting the tag. */
  slug: Scalars['String']['output'];
  /** Whether the tag is maintained manually or auto-generated. */
  source: CustomerTagSourceEnum;
};

export type CustomerTagAssignment = {
  __typename?: 'CustomerTagAssignment';
  /** When the tag was applied to this location. */
  assignedAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The tag itself. */
  tag: CustomerTag;
};

export enum CustomerTagCategoryEnum {
  /** Location-based audiences (e.g. a city, state, or region). */
  Geography = 'GEOGRAPHY',
  /** Product-based audiences (e.g. fresh pastry). */
  Product = 'PRODUCT',
  /** Routing-cohort audiences (e.g. a delivery route or zone). */
  Routing = 'ROUTING',
  /** Time-of-delivery audiences (e.g. day vs. night). */
  Timing = 'TIMING'
}

/** The connection type for CustomerTag. */
export type CustomerTagConnection = {
  __typename?: 'CustomerTagConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CustomerTagEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CustomerTag>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of records in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerTagEdge = {
  __typename?: 'CustomerTagEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CustomerTag>;
};

/** Locations carrying a set of customer tags. */
export type CustomerTagFilterInput = {
  /** Ids of the tags, as returned by CustomerTag.id. Deleted tags contribute no locations. */
  ids: Array<Scalars['ID']['input']>;
  /** Whether a location must carry every one of these tags or just one of them. Defaults to carrying any. */
  matchMode?: InputMaybe<CustomerTagMatchModeEnum>;
};

/** A bulk customer-tag CSV upload, and the record of what it did. */
export type CustomerTagImport = {
  __typename?: 'CustomerTagImport';
  /** Rows that resulted in a tag being applied or withdrawn. */
  appliedRowCount: Scalars['Int']['output'];
  /** Stores whose tags actually changed, which is fewer than appliedRowCount when a file names one store on several rows. */
  changedLocationCount: Scalars['Int']['output'];
  /** One entry per refused row: row, odekoUuid, tagSlug, action, message. */
  errorRows: Array<Scalars['JSON']['output']>;
  /** Rows refused. Matches the length of errorRows. */
  failedRowCount: Scalars['Int']['output'];
  /**
   * Why the import stopped when no single row was to blame — an unreadable file, a
   * missing header, a missing upload. Row-level refusals leave this null and
   * appear in errorRows instead.
   */
  failureReason?: Maybe<Scalars['String']['output']>;
  /** The name the file was uploaded under. */
  filename: Scalars['String']['output'];
  /** Whether the import has stopped, and polling can stop with it. */
  finished: Scalars['Boolean']['output'];
  finishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** Data rows read from the file, excluding the header. */
  rowCount: Scalars['Int']['output'];
  startedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: CustomerTagImportStatusEnum;
};

export enum CustomerTagImportStatusEnum {
  /** Tag changes are being written. */
  Applying = 'APPLYING',
  /** Finished, though individual rows may still have been refused. */
  Completed = 'COMPLETED',
  /** Stopped without finishing. */
  Failed = 'FAILED',
  /** Created, but the file has not arrived yet. */
  Pending = 'PENDING',
  /** The file has arrived and is waiting to be picked up. */
  Uploaded = 'UPLOADED',
  /** The file is being checked; nothing has been written. */
  Validating = 'VALIDATING'
}

/** A header the browser must send with its upload request. */
export type CustomerTagImportUploadHeader = {
  __typename?: 'CustomerTagImportUploadHeader';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum CustomerTagMatchModeEnum {
  /** A location matches only if it carries every one of the tags. */
  All = 'ALL',
  /** A location matches if it carries at least one of the tags. */
  Any = 'ANY'
}

export enum CustomerTagSortFieldEnum {
  /** How many locations currently carry the tag. */
  AssignedLocationCount = 'ASSIGNED_LOCATION_COUNT',
  /** The tag's category. */
  Category = 'CATEGORY',
  /** The tag's display name. */
  Name = 'NAME',
  /** The tag's slug. */
  Slug = 'SLUG',
  /** How the tag is maintained. */
  Source = 'SOURCE'
}

/** Orders the customer tag catalog. Ties fall back to name, then to creation order. */
export type CustomerTagSortInput = {
  direction?: InputMaybe<SortDirectionEnum>;
  field: CustomerTagSortFieldEnum;
};

export enum CustomerTagSourceEnum {
  /** Derived automatically from vendor/catalog data. */
  Auto = 'AUTO',
  /** Assigned by a person. */
  Manual = 'MANUAL'
}

/** A single vendor/LVA delivery rule, for eyeballing the cutoff baseline. */
export type CutoffDeliveryRule = {
  __typename?: 'CutoffDeliveryRule';
  /** Delivery weekday, e.g. "Monday". */
  deliveryDay: Scalars['String']['output'];
  /** Lead time in days from cutoff to delivery. */
  leadTimeDays?: Maybe<Scalars['Int']['output']>;
  /** Order deadline (cutoff) time of day, e.g. "12:00". */
  orderDeadline?: Maybe<Scalars['String']['output']>;
};

export type CutoffDiscrepancyApproval = {
  __typename?: 'CutoffDiscrepancyApproval';
  /** The approved location's full address (line1, line2, city, state, ZIP). */
  address?: Maybe<Scalars['String']['output']>;
  approvedAt: Scalars['ISO8601DateTime']['output'];
  approvedBy?: Maybe<Scalars['String']['output']>;
  /** The LVA's own delivery rules. */
  deliveryRules: Array<CutoffDeliveryRule>;
  id: Scalars['ID']['output'];
  locationId: Scalars['ID']['output'];
  locationName?: Maybe<Scalars['String']['output']>;
  /** The approved location-vendor association (LVA). */
  locationsVendorId: Scalars['ID']['output'];
  lvaFingerprint: Scalars['String']['output'];
  /** The vendor's standing delivery rules (LVA ignored) — the baseline. */
  vendorDeliveryRules: Array<CutoffDeliveryRule>;
  /** The LVA's vendor id (links to the vendor admin page). */
  vendorId: Scalars['ID']['output'];
  vendorName: Scalars['String']['output'];
};

/** An order whose cutoff (due_at) has drifted from the vendor's delivery rules. */
export type CutoffDiscrepancyOrder = {
  __typename?: 'CutoffDiscrepancyOrder';
  /** The order location's full address (line1, line2, city, state, ZIP). */
  address?: Maybe<Scalars['String']['output']>;
  /** The order's stored cutoff (due_at). */
  dueAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The order's location id (nil when the order has no location) — keys the approve action. */
  locationId?: Maybe<Scalars['ID']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  /** The location/vendor LVAs and their rules. */
  locationVendorAssociations: Array<CutoffLocationVendorAssociation>;
  /**
   * The flagged order, as a federated reference. LDS resolves the route name +
   * stop number (Lobby bucket until routed) the stage-gate table displays.
   */
  order: Order;
  orderNumber: Scalars['ID']['output'];
  /** Why the order was flagged. */
  reason: CutoffDiscrepancyReasonEnum;
  /** The vendor's standing delivery rules (LVA ignored) — the baseline. */
  vendorDeliveryRules: Array<CutoffDeliveryRule>;
  /** The order's vendor id (links to the vendor admin page). */
  vendorId: Scalars['ID']['output'];
};

/** Why an order's cutoff (due_at) is flagged as drifted from the vendor baseline. */
export enum CutoffDiscrepancyReasonEnum {
  /**
   * The vendor's ZIP-override config is ambiguous for this location (multiple
   * overrides apply), so a baseline cutoff could not be resolved.
   */
  AmbiguousDeliveryRule = 'AMBIGUOUS_DELIVERY_RULE',
  /** due_at falls on a different date than the vendor's standard cutoff. */
  CutoffDateShift = 'CUTOFF_DATE_SHIFT',
  /** due_at is earlier than the vendor's standard cutoff for this day. */
  CutoffEarlier = 'CUTOFF_EARLIER',
  /** due_at is later than the vendor's standard cutoff for this day. */
  CutoffLater = 'CUTOFF_LATER',
  /**
   * The order's location is missing (discarded or never set), so no cutoff
   * baseline can be resolved. Surfaced for data cleanup, not a cutoff drift.
   */
  MissingLocation = 'MISSING_LOCATION',
  /** The order lands on a weekday the vendor has no standing delivery rule for. */
  NoDeliveryRule = 'NO_DELIVERY_RULE'
}

/**
 * Cutoff stage-gate report for a warehouse + delivery date: the count of orders
 * whose due_at differs from the vendor delivery-rule baseline, plus those orders.
 */
export type CutoffDiscrepancyReport = {
  __typename?: 'CutoffDiscrepancyReport';
  discrepancyCount: Scalars['Int']['output'];
  orders: Array<CutoffDiscrepancyOrder>;
  /**
   * Orders in the Cutoff gate population for the warehouse + delivery date:
   * local-fulfillment (parcel/pallet shipping excluded), non-canceled orders with
   * positive unit quantity.
   */
  totalOrderCount: Scalars['Int']['output'];
};

/** A location-vendor association (LVA) and its delivery rules. */
export type CutoffLocationVendorAssociation = {
  __typename?: 'CutoffLocationVendorAssociation';
  deliveryRules: Array<CutoffDeliveryRule>;
  id: Scalars['ID']['output'];
  vendorName: Scalars['String']['output'];
};

export type DailyConversion = {
  __typename?: 'DailyConversion';
  /** Number of booking conversions */
  bookings: Scalars['Int']['output'];
  /** Number of phone call conversions */
  calls: Scalars['Int']['output'];
  date: Scalars['ISO8601Date']['output'];
  /** Number of direction request conversions */
  directions: Scalars['Int']['output'];
  /** Number of menu click conversions */
  menuClicks: Scalars['Int']['output'];
  /** Total number of conversions for the day */
  total: Scalars['Int']['output'];
  /** Number of website click conversions */
  websiteClicks: Scalars['Int']['output'];
};

export type DailyDeliveryExists = UserErrorInterface & {
  __typename?: 'DailyDeliveryExists';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type DailyImpression = {
  __typename?: 'DailyImpression';
  date: Scalars['ISO8601Date']['output'];
  desktopMaps: Scalars['Int']['output'];
  desktopSearch: Scalars['Int']['output'];
  mobileMaps: Scalars['Int']['output'];
  mobileSearch: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

/** Range of dates */
export type DateRangeInput = {
  /** Lower bound (inclusive) of the range */
  lowerBound?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Upper bound of the range */
  upperBound?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Whether upper bound is included in the range */
  upperInclusive: Scalars['Boolean']['input'];
};

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

/** The values representing each day of the week. */
export enum DayOfWeekEnum {
  /** Friday. */
  Fri = 'fri',
  /** Monday. */
  Mon = 'mon',
  /** Saturday. */
  Sat = 'sat',
  /** Sunday. */
  Sun = 'sun',
  /** Thursday. */
  Thu = 'thu',
  /** Tuesday. */
  Tue = 'tue',
  /** Wednesday. */
  Wed = 'wed'
}

export type DayOfWeekQrScanCount = {
  __typename?: 'DayOfWeekQrScanCount';
  dayOfWeek: DayOfWeek;
  /** Total number of scans that occurred on this day of week. */
  scanCount: Scalars['Int']['output'];
};

/** Autogenerated input type of DeleteArAssignment */
export type DeleteArAssignmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyUuid: Scalars['String']['input'];
};

/** Autogenerated return type of DeleteArAssignment. */
export type DeleteArAssignmentPayload = {
  __typename?: 'DeleteArAssignmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteCategoryBannerInput = {
  categoryId: Scalars['ID']['input'];
};

export type DeleteCollectionPromoSetupInput = {
  collectionId: Scalars['ID']['input'];
};

export type DeleteCollectionPromoSetupPayload = {
  __typename?: 'DeleteCollectionPromoSetupPayload';
  errors: Array<CollectionPromoSetupError>;
};

/** Autogenerated input type of DeleteCustomerTagMutation */
export type DeleteCustomerTagMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Id of the tag to delete, as returned by CustomerTag.id. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteCustomerTagMutation. */
export type DeleteCustomerTagMutationPayload = {
  __typename?: 'DeleteCustomerTagMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  customerTag?: Maybe<CustomerTag>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of DeleteDeliveryOverrideRuleMutation */
export type DeleteDeliveryOverrideRuleMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the override to withdraw. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteDeliveryOverrideRuleMutation. */
export type DeleteDeliveryOverrideRuleMutationPayload = {
  __typename?: 'DeleteDeliveryOverrideRuleMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deliveryOverrideRule?: Maybe<DeliveryOverrideRule>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated input type of DeleteFieldServiceZipcodeMutation */
export type DeleteFieldServiceZipcodeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Id of the field service zip code to delete, as returned by FieldServiceZipcode.id. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteFieldServiceZipcodeMutation. */
export type DeleteFieldServiceZipcodeMutationPayload = {
  __typename?: 'DeleteFieldServiceZipcodeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  fieldServiceZipcode?: Maybe<FieldServiceZipcode>;
};

/** Autogenerated input type of DeleteLocationAccountsReceivableCollectionsStatus */
export type DeleteLocationAccountsReceivableCollectionsStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationUuid: Scalars['String']['input'];
};

/** Autogenerated return type of DeleteLocationAccountsReceivableCollectionsStatus. */
export type DeleteLocationAccountsReceivableCollectionsStatusPayload = {
  __typename?: 'DeleteLocationAccountsReceivableCollectionsStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of DeleteLocationPaymentMethodMutation */
export type DeleteLocationPaymentMethodMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** UUID for the Location */
  locationUuid: Scalars['String']['input'];
  /** Payment method id */
  paymentMethodId: Scalars['String']['input'];
  /**
   * Payment method type. If omitted, we will attempt retrieve payment method info
   * from Stripe using the payment_method_id, and determine type by the response
   * data. If the payment method does not use Stripe, the paymentMethodType must be specified.
   */
  paymentMethodType?: InputMaybe<PaymentMethodTypeEnum>;
};

/** Autogenerated return type of DeleteLocationPaymentMethodMutation. */
export type DeleteLocationPaymentMethodMutationPayload = {
  __typename?: 'DeleteLocationPaymentMethodMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  paymentMethod?: Maybe<LocationPaymentMethod>;
};

/** Autogenerated input type of DeleteLocationPhoneNumberMutation */
export type DeleteLocationPhoneNumberMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** UUID for the Location */
  locationUuid: Scalars['String']['input'];
  /** Type of the phone number */
  phoneType: LocationPhoneTypeEnum;
};

/** Autogenerated return type of DeleteLocationPhoneNumberMutation. */
export type DeleteLocationPhoneNumberMutationPayload = {
  __typename?: 'DeleteLocationPhoneNumberMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type DeleteMasterHomepageInput = {
  id: Scalars['ID']['input'];
};

export type DeleteMasterHomepagePayload = {
  __typename?: 'DeleteMasterHomepagePayload';
  errors: Array<MasterHomepageError>;
};

export type DeleteMasterHomepageRowComponentInput = {
  componentId: Scalars['ID']['input'];
  rowId: Scalars['ID']['input'];
};

export type DeleteMasterHomepageRowComponentPayload = {
  __typename?: 'DeleteMasterHomepageRowComponentPayload';
  errors: Array<MasterHomepageError>;
};

/** Autogenerated input type of DeleteMicrositeMenuItem */
export type DeleteMicrositeMenuItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the Menu Item to delete. */
  menuItemId: Scalars['ID']['input'];
  /** ID of the Microsite Location to which the Menu Item belongs. */
  micrositeLocationId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteMicrositeMenuItem. */
export type DeleteMicrositeMenuItemPayload = {
  __typename?: 'DeleteMicrositeMenuItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedMenuItem?: Maybe<MicrositeMenuItem>;
};

/** Autogenerated input type of DeleteReceivableNote */
export type DeleteReceivableNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteReceivableNote. */
export type DeleteReceivableNotePayload = {
  __typename?: 'DeleteReceivableNotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of DeleteRoutificScenario */
export type DeleteRoutificScenarioInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Id of the scenario run to delete. */
  scenarioId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteRoutificScenario. */
export type DeleteRoutificScenarioPayload = {
  __typename?: 'DeleteRoutificScenarioPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Id of the deleted scenario run. Null on error. */
  deletedScenarioId?: Maybe<Scalars['ID']['output']>;
  userErrors: Array<RoutingImportPlanError>;
};

/** Autogenerated input type of DeleteS3File */
export type DeleteS3FileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  filePath: Scalars['String']['input'];
  /** The ID of the microsite location this image belongs to */
  micrositeLocationId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteS3File. */
export type DeleteS3FilePayload = {
  __typename?: 'DeleteS3FilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedFilePath?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteSquareCard */
export type DeleteSquareCardInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Square card id. */
  squareCardId: Scalars['String']['input'];
};

/** Autogenerated return type of DeleteSquareCard */
export type DeleteSquareCardPayload = {
  __typename?: 'DeleteSquareCardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to delete Square card. */
  result: WalletResult;
};

/** Autogenerated input type of DeleteUserMicrositeLocationMutation */
export type DeleteUserMicrositeLocationMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the microsite location */
  micrositeLocationId: Scalars['ID']['input'];
  /** Auth0 ID of the user */
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteUserMicrositeLocationMutation. */
export type DeleteUserMicrositeLocationMutationPayload = {
  __typename?: 'DeleteUserMicrositeLocationMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteZipcodeDeliveryRule */
export type DeleteZipcodeDeliveryRuleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Delivery rule day, 0-6, 0 denotes Sunday */
  deliveryDay: Scalars['Int']['input'];
  /** The Zipcode to upsert a delivery rule for */
  zipcode: Scalars['String']['input'];
};

/** Autogenerated return type of DeleteZipcodeDeliveryRule. */
export type DeleteZipcodeDeliveryRulePayload = {
  __typename?: 'DeleteZipcodeDeliveryRulePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
};

/** Autogenerated input type of DeleteZipcodeMutation */
export type DeleteZipcodeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  warehouseId: Scalars['ID']['input'];
  zipcodeIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of DeleteZipcodeMutation. */
export type DeleteZipcodeMutationPayload = {
  __typename?: 'DeleteZipcodeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
};

export type Delivery = {
  __typename?: 'Delivery';
  /** The time the driver arrived at the stop */
  arrivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  attachments?: Maybe<Array<Attachment>>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  compostCollectedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  compostCollectionRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Every geofence enter/exit crossing recorded for the stop, oldest first (admin only; empty list for other callers). */
  crossingEvents: Array<StopCrossingEvent>;
  deliveryNote?: Maybe<Scalars['String']['output']>;
  deliveryStatus: DeliveryStatus;
  /** stop status used in the DMP */
  deliveryStatusDmp: DeliveryStatusDmp;
  deliveryStatusDriver: DeliveryStatusDriver;
  /** The time the driver departed from the stop */
  departedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  donationCollectedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  donationRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Seconds the driver was stopped (departed_at - arrived_at), or null if either is missing */
  dwellSeconds?: Maybe<Scalars['Int']['output']>;
  hasRepeatedAccessIssues: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isFirstDelivery: Scalars['Boolean']['output'];
  issues?: Maybe<Array<Issue>>;
  location?: Maybe<Location>;
  orders?: Maybe<Array<Order>>;
  /** Previous two deliveries */
  previousDeliveries: Array<Delivery>;
  /** returns the date of their last delivery */
  previousDeliveryDate?: Maybe<Scalars['String']['output']>;
  /**
   * This stop's order on a third-party provider, from the newest dispatch that has
   * a row for it. Null for a stop no provider has been given.
   */
  providerDelivery?: Maybe<ProviderDelivery>;
  /** Redelivery stop */
  redeliveryStop?: Maybe<Redelivery>;
  reminderMessage?: Maybe<Scalars['String']['output']>;
  /** Repeated access issue descriptions */
  repeatedAccessIssues: Array<Scalars['String']['output']>;
  /** The latest time the driver was detected leaving the stop again after completion, if they returned */
  returnedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** How many times the driver returned to the stop after completing it */
  revisitCount: Scalars['Int']['output'];
  route: Route;
  /** Represent stop predictive metrics based on route optimization. */
  routingEstimates?: Maybe<StopEstimates>;
  sequenceNumber?: Maybe<Scalars['String']['output']>;
  /** Additional tasks for the driver, authored by a GM or generated automatically, oldest first. */
  tasks?: Maybe<Array<DeliveryRouteStopTask>>;
  /** Total volume of this stop */
  totalVolume?: Maybe<Scalars['Float']['output']>;
  /** Total weight of this stop */
  totalWeight?: Maybe<Scalars['Float']['output']>;
  upsellNote?: Maybe<Scalars['String']['output']>;
  viewedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Enter/exit crossings paired into visits with per-visit dwell, oldest first (admin only; empty list for other callers). */
  visits: Array<StopVisit>;
};

/** Autogenerated input type of DeliveryCompletedUpdate */
export type DeliveryCompletedUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  completed: Scalars['Boolean']['input'];
  /** Delivery route stop id. */
  deliveryRouteStopId: Scalars['ID']['input'];
  redelivery?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of DeliveryCompletedUpdate. */
export type DeliveryCompletedUpdatePayload = {
  __typename?: 'DeliveryCompletedUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deliveryRouteStop?: Maybe<DeliveryStop>;
  userErrors: Array<DeliveryRouteStopError>;
};

export type DeliveryDatePoNumber = {
  __typename?: 'DeliveryDatePoNumber';
  deliveryDate: Scalars['ISO8601Date']['output'];
  poNumber: Scalars['String']['output'];
};

export type DeliveryDatePoNumberInput = {
  deliveryDate: Scalars['ISO8601Date']['input'];
  poNumber: Scalars['String']['input'];
};

/** Error indicating that the requested delivery date cannot take a delivery. */
export type DeliveryDateUnavailableError = Error & {
  __typename?: 'DeliveryDateUnavailableError';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Input for specifying delivery details. */
export type DeliveryDetailInput = {
  /** City. */
  city: Scalars['String']['input'];
  /** Notes. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Postal code. */
  postalCode: Scalars['String']['input'];
  /** State. */
  state: Scalars['String']['input'];
  /** Street address. */
  streetAddress: Scalars['String']['input'];
};

export type DeliveryFee = FeeInterface & {
  __typename?: 'DeliveryFee';
  /** The threshold amount in cents at which the fee is applied. */
  feeThresholds: Array<FeeThreshold>;
  id: Scalars['ID']['output'];
  /** Indicates if the fee is active or not. */
  isActive: Scalars['Boolean']['output'];
  odekoUuid: Scalars['ID']['output'];
  /** The amount of the delivery fee in cents. */
  warehouseFeeAmountCents: Scalars['Int']['output'];
  /** Unique identifier of the warehouse associated with this delivery fee. */
  warehouseId: Scalars['ID']['output'];
};

export type DeliveryForAddress = {
  __typename?: 'DeliveryForAddress';
  type?: Maybe<DeliveryForAddressEnum>;
  warehouse?: Maybe<Warehouse>;
};

export enum DeliveryForAddressEnum {
  LocalDelivery = 'local_delivery',
  Shipping = 'shipping',
  Unknown = 'unknown'
}

export type DeliveryInstructionReview = {
  __typename?: 'DeliveryInstructionReview';
  acknowledgedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  deliveryDate: Scalars['ISO8601Date']['output'];
  id: Scalars['ID']['output'];
};

export type DeliveryInstructionReviewStatus = {
  __typename?: 'DeliveryInstructionReviewStatus';
  deliveryDate: Scalars['ISO8601Date']['output'];
  enabled: Scalars['Boolean']['output'];
  review?: Maybe<DeliveryInstructionReview>;
  timeZone: Scalars['String']['output'];
};

export type DeliveryInstructionTranslation = {
  __typename?: 'DeliveryInstructionTranslation';
  id: Scalars['ID']['output'];
  sourceHash: Scalars['String']['output'];
  targetLanguage: Scalars['String']['output'];
  translatedText: Scalars['String']['output'];
  translationId: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type DeliveryInstructionTranslationError = {
  __typename?: 'DeliveryInstructionTranslationError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/** Error indicating that delivery instructions are missing. */
export type DeliveryInstructionsMissingError = Error & {
  __typename?: 'DeliveryInstructionsMissingError';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

export enum DeliveryIssue {
  AccessIssueSafetyConcern = 'access_issue_safety_concern',
  AccessIssueSecurity = 'access_issue_security',
  AlarmIssueDifficultToFind = 'alarm_issue_difficult_to_find',
  AlarmIssueInaccurateInstructions = 'alarm_issue_inaccurate_instructions',
  AlarmTriggered = 'alarm_triggered',
  CafePartnerStoreHours = 'cafe_partner_store_hours',
  CompostNoRoomInVan = 'compost_no_room_in_van',
  DamagedInTransit = 'damaged_in_transit',
  DeliveryInstructionsInaccurate = 'delivery_instructions_inaccurate',
  DeliveryInstructionsInaccurateNonRefrigeratedItems = 'delivery_instructions_inaccurate_non_refrigerated_items',
  DeliveryInstructionsInaccurateRefrigeratedItems = 'delivery_instructions_inaccurate_refrigerated_items',
  DeliveryIssueNoRoomInFridge = 'delivery_issue_no_room_in_fridge',
  DeliveryIssueSafetyConcern = 'delivery_issue_safety_concern',
  DeliveryIssueSpillDamageToStore = 'delivery_issue_spill_damage_to_store',
  DeliveryIssueUnableToAccessFridge = 'delivery_issue_unable_to_access_fridge',
  /** @deprecated Deprecated - No longer supported */
  DeliveryNoteCompletedByAnotherDriver = 'delivery_note_completed_by_another_driver',
  /** @deprecated Deprecated - No longer supported */
  DeliveryNoteCustomerPutAwayProduct = 'delivery_note_customer_put_away_product',
  /** @deprecated Deprecated - No longer supported */
  DeliveryNoteOther = 'delivery_note_other',
  KegReturn = 'keg_return',
  KeyIssueBrokenKey = 'key_issue_broken_key',
  KeyIssueDoesNotWork = 'key_issue_does_not_work',
  KeyIssueLeftAtWarehouse = 'key_issue_left_at_warehouse',
  KeyIssueNotAtWarehouse = 'key_issue_not_at_warehouse',
  LockboxIssueInvalidCode = 'lockbox_issue_invalid_code',
  LockboxIssueKeyNotPresent = 'lockbox_issue_key_not_present',
  LockboxIssueNotFound = 'lockbox_issue_not_found',
  /** @deprecated Deprecated - No longer supported */
  MissingItemVendorSelectItem = 'missing_item_vendor_select_item',
  MissingItemWarehouseSelectItem = 'missing_item_warehouse_select_item',
  MissingItemWrongItem = 'missing_item_wrong_item',
  NoOrderAtVendor = 'no_order_at_vendor',
  NoPickUpAvailableCompost = 'no_pick_up_available_compost',
  NoPickUpAvailableDonation = 'no_pick_up_available_donation',
  NoPickUpAvailableReturn = 'no_pick_up_available_return',
  NoPickUpAvailableTransfer = 'no_pick_up_available_transfer',
  NoPickUpAvailableVendor = 'no_pick_up_available_vendor',
  /** @deprecated Deprecated - No longer supported */
  Other = 'other',
  /** @deprecated Deprecated - No longer supported */
  OtherCompost = 'other_compost',
  /** @deprecated Deprecated - No longer supported */
  OtherDonation = 'other_donation',
  PestOrRodents = 'pest_or_rodents',
  UnableToAccessLocation = 'unable_to_access_location',
  WeatherIssue = 'weather_issue'
}

/** Autogenerated input type of DeliveryIssueCreate */
export type DeliveryIssueCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Delivery route stop id. */
  deliveryRouteStopId: Scalars['ID']['input'];
  /** Additional details on the delivery issue */
  note: Scalars['String']['input'];
  /** Order id. */
  orderId?: InputMaybe<Scalars['ID']['input']>;
  redelivery?: InputMaybe<Scalars['Boolean']['input']>;
  /** Type of the delivery issue. */
  type: DeliveryIssue;
};

/** Autogenerated return type of DeliveryIssueCreate. */
export type DeliveryIssueCreatePayload = {
  __typename?: 'DeliveryIssueCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  issue?: Maybe<Issue>;
  userErrors: Array<DeliveryIssueError>;
};

/** Autogenerated input type of DeliveryIssueDelete */
export type DeliveryIssueDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Delivery issue id. */
  id: Scalars['ID']['input'];
  redelivery?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of DeliveryIssueDelete. */
export type DeliveryIssueDeletePayload = {
  __typename?: 'DeliveryIssueDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userErrors: Array<DeliveryIssueError>;
};

export type DeliveryIssueDuplicate = UserErrorInterface & {
  __typename?: 'DeliveryIssueDuplicate';
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** Delivery issue possible errors */
export type DeliveryIssueError = DeliveryIssueDuplicate | DeliveryIssueNotFound | OrderNotFound;

export type DeliveryIssueNotFound = UserErrorInterface & {
  __typename?: 'DeliveryIssueNotFound';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of DeliveryIssueUpdate */
export type DeliveryIssueUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Delivery issue id. */
  id: Scalars['ID']['input'];
  /** Additional details on the delivery issue */
  note: Scalars['String']['input'];
  /** Type of the delivery issue. */
  type: DeliveryIssue;
};

/** Autogenerated return type of DeliveryIssueUpdate. */
export type DeliveryIssueUpdatePayload = {
  __typename?: 'DeliveryIssueUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  issue: Issue;
  userErrors: Array<DeliveryIssueError>;
};

export type DeliveryItemInput = {
  /** The uuid of the item. */
  itemId: Scalars['ID']['input'];
  /** The unit cost of the item. */
  unitCost: MoneyInput;
  /** The amount of items ordered. */
  unitQuantity: Scalars['Int']['input'];
};

export enum DeliveryMethodEnum {
  /** Local delivery */
  Delivery = 'delivery',
  /** Shipped via pallet (for heavier orders) */
  PalletShipping = 'pallet_shipping',
  /** Shipped via parcel (for lighter orders) */
  ParcelShipping = 'parcel_shipping',
  /** Local pick-up */
  PickUp = 'pick_up'
}

export type DeliveryOverrideAffectedDeliveries = {
  __typename?: 'DeliveryOverrideAffectedDeliveries';
  /** Every delivery the block would affect. Null when the export could not be produced. */
  deliveries?: Maybe<Array<DeliveryOverrideAffectedDelivery>>;
  /**
   * Why this export could not be produced (invalid draft, or over the size cap).
   * Empty when it could be. While it is non-empty, `deliveries` is null.
   */
  errors: Array<UserError>;
};

export type DeliveryOverrideAffectedDelivery = {
  __typename?: 'DeliveryOverrideAffectedDelivery';
  deliveryDate: Scalars['ISO8601Date']['output'];
  kind: DeliveryOverrideAffectedKindEnum;
  /** Non-zero lines only. ORDER: the order's lines. STANDING: the lines generation would still add. */
  lines: Array<DeliveryOverrideAffectedLine>;
  /** Location business_name. */
  locationName: Scalars['String']['output'];
  /** Location odeko_uuid. */
  locationUuid: Scalars['ID']['output'];
  /** orders.netsuite_transaction_id. Null when unsynced, and always null for STANDING. */
  netsuiteOrderNumber?: Maybe<Scalars['String']['output']>;
  /** orders.id. Null for STANDING (no order row yet). */
  orderNumber?: Maybe<Scalars['ID']['output']>;
  /** Null for STANDING (no order row yet). */
  orderUuid?: Maybe<Scalars['ID']['output']>;
  status: DeliveryOverrideAffectedStatusEnum;
  /** Vendor uuid. */
  vendorId: Scalars['ID']['output'];
  /** Vendor display name (Vendor#display_name). */
  vendorName: Scalars['String']['output'];
  /**
   * The vendor's own warehouse name, when it is one of Odeko's warehouses
   * (Vendor#warehouse); null otherwise. Odeko's warehouse vendors share a display
   * name, so this is what tells them apart (mirrors Vendor#label).
   */
  vendorWarehouseName?: Maybe<Scalars['String']['output']>;
};

export enum DeliveryOverrideAffectedKindEnum {
  /** An order that already exists on this date. */
  Order = 'ORDER',
  /** A standing delivery the generator has not created yet. */
  Standing = 'STANDING'
}

export type DeliveryOverrideAffectedLine = {
  __typename?: 'DeliveryOverrideAffectedLine';
  /** Sku display_name. */
  itemName: Scalars['String']['output'];
  /** Sku item_uuid. */
  itemUuid?: Maybe<Scalars['ID']['output']>;
  /** Unit quantity (cases/units as ordered), not the raw item count. */
  quantity: Scalars['Int']['output'];
};

export enum DeliveryOverrideAffectedStatusEnum {
  /** Currently being sent. Not cancelled by a block. */
  Sending = 'SENDING',
  /** Sending failed. Not cancelled by a block. */
  SendingFailed = 'SENDING_FAILED',
  /** Already sent to the vendor. Not cancelled by a block. */
  Sent = 'SENT',
  /** No order exists yet; generation would still create this. */
  Standing = 'STANDING',
  /** Not yet sent to the vendor. A block would cancel this. */
  Unsent = 'UNSENT'
}

export type DeliveryOverrideAudienceInput = {
  /** Location UUIDs, naming the audience outright. */
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Customer tag ids. Reaches the locations carrying them. */
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Whether a location must carry any of the tags or all of them. */
  tagMatchMode?: InputMaybe<DeliveryOverrideTagMatchModeEnum>;
};

export enum DeliveryOverrideAudienceKindEnum {
  /** Every location in a market, described by the market alone. Older rules only; new ones use the market scope. */
  Market = 'MARKET',
  /** Hand-picked locations, named outright. */
  Named = 'NAMED',
  /** Every location carrying the audience's tags, within its market. */
  Tags = 'TAGS'
}

export type DeliveryOverrideCutoffBuffer = {
  __typename?: 'DeliveryOverrideCutoffBuffer';
  /** How much earlier, in seconds. Always positive: a vendor with no buffer is not listed. */
  seconds: Scalars['Int']['output'];
  /** The vendor whose cutoff is treated earlier. */
  vendor: Vendor;
};

export enum DeliveryOverrideDayActionEnum {
  /** Add a one-off delivery on a date with no scheduled run (requires a lead time and order deadline). */
  Add = 'add',
  /** Re-open a day a less-specific rule closed. */
  Allow = 'allow',
  /** Close the delivery day for this location and vendor. */
  Block = 'block',
  /** Move the delivery to a make-up date (requires a substitute delivery date). */
  Substitute = 'substitute'
}

/** Which locations a delivery override should reach. */
export type DeliveryOverrideLocationFiltersInput = {
  /**
   * Matches a location's businessName or its id, case-insensitively. The name is
   * matched whole, so a term spanning the company and location parts still finds it.
   */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Locations carrying these tags. */
  tags?: InputMaybe<CustomerTagFilterInput>;
  /** Locations served by one of these warehouses (the federated Warehouse.id). */
  warehouseIds: Array<Scalars['ID']['input']>;
};

export type DeliveryOverrideOverlap = {
  __typename?: 'DeliveryOverrideOverlap';
  /** How many of the proposed audience's locations it covers. */
  locationCount: Scalars['Int']['output'];
  /** The rule already covering these locations on this date. */
  rule: DeliveryOverrideRule;
};

export type DeliveryOverridePreview = {
  __typename?: 'DeliveryOverridePreview';
  /**
   * Unsent orders this would cancel. Zero for any action other than `block`, zero
   * while order cancellation is disabled, and excludes orders spared by a more
   * specific allow. Null when the override could not be created.
   */
  cancelledOrderCount?: Maybe<Scalars['Int']['output']>;
  /**
   * Vendors whose order cutoff is treated earlier than the one this override sets,
   * and by how much (for example, manually sent orders close hours before it).
   * Only vendors with a buffer at one of these locations are listed, the largest
   * where a vendor's agreements differ. Empty when the override sets no cutoff.
   * Unlike the counts above it is still answered while `errors` is non-empty.
   */
  cutoffBuffers: Array<DeliveryOverrideCutoffBuffer>;
  /**
   * Why this override could not be created as described, in the same shape
   * createDeliveryOverrideRule returns. Empty when it can be. While it is
   * non-empty the counts below are null, but not `cutoffBuffers`, which is still answered.
   */
  errors: Array<UserError>;
  /**
   * Audience locations the reach mode excluded. N of M reached is locationCount
   * over locationCount + excludedLocationCount. Zero while reach limiting is
   * disabled. Null when the override could not be created, for vendor-less group
   * rules, vendor scope, other grains and warehouse vendors.
   */
  excludedLocationCount?: Maybe<Scalars['Int']['output']>;
  /** How many locations are reached after the reach mode is applied. Null when the override could not be created. */
  locationCount?: Maybe<Scalars['Int']['output']>;
  /**
   * The overlapping rule that would decide the day instead of this one, or null
   * when nothing does — including when the draft sets no day action and so is not
   * contesting the day. Decided per location, so this is non-null when any one of
   * them resolves away from the draft, even if the rest take it; the rule returned
   * is the most specific of those deciding. Always one of `overlaps`. Answered
   * here rather than left to the caller, so nobody has to re-derive the engine's
   * grain and severity ordering to know whether a draft will take effect. Null
   * when the override could not be created.
   */
  outrankedBy?: Maybe<DeliveryOverrideOverlap>;
  /**
   * How many of the reached locations resolve away from the draft. Zero when it
   * takes effect everywhere. Not `outrankedBy.locationCount`, which counts every
   * location the winning rule covers whether the draft loses there or not. Null
   * when the override could not be created.
   */
  outrankedLocationCount?: Maybe<Scalars['Int']['output']>;
  /**
   * Rules already covering some of these locations on this date, most specific
   * first. A snapshot — a location that joins an audience later can newly fall
   * under both. Null when the override could not be created.
   */
  overlaps?: Maybe<Array<DeliveryOverrideOverlap>>;
  /**
   * Vendor-carrying rules that change one vendor's day apart from what the reached
   * locations' spanning rules alone would decide. Empty when the draft itself
   * names a vendor, or sets no day action. Null when the override could not be created.
   */
  vendorExceptions?: Maybe<Array<DeliveryOverrideVendorException>>;
};

export enum DeliveryOverrideReachModeEnum {
  /** Every location the audience reaches. */
  All = 'ALL',
  /** Only locations the vendor serves. */
  LvaOnly = 'LVA_ONLY'
}

/** A date-scoped delivery override for a location, and optionally a single vendor. */
export type DeliveryOverrideRule = {
  __typename?: 'DeliveryOverrideRule';
  /** How a `group` override's audience was written: hand-picked locations, tags, or a whole market. Null for every other scope. */
  audienceKind?: Maybe<DeliveryOverrideAudienceKindEnum>;
  /** The tags a `group` override's audience targets. Empty for every other audience. */
  audienceTags: Array<Maybe<CustomerTag>>;
  /**
   * How many orders this override has already cancelled. Counted from the
   * cancellation records themselves, and recording one is best-effort, so this is
   * a floor rather than a settled total. Withdrawing the override does not restore these orders.
   */
  cancelledOrderCount: Scalars['Int']['output'];
  /**
   * Vendors whose order cutoff is treated earlier than the one this rule sets, and
   * by how much. Empty when the rule sets no cutoff. The same answer
   * `deliveryOverridePreview` gives a draft.
   */
  cutoffBuffers: Array<DeliveryOverrideCutoffBuffer>;
  /** The day-presence change, or null for an attribute-only override. */
  dayAction?: Maybe<DeliveryOverrideDayActionEnum>;
  /** The date the override applies to. */
  deliveryDate: Scalars['ISO8601Date']['output'];
  /** Stable public identifier for the override. */
  id: Scalars['ID']['output'];
  /** Overridden order lead time in days. */
  leadTime?: Maybe<Scalars['Int']['output']>;
  /** The location the override applies to. Null for a vendor-wide override, which spans every location the vendor delivers to. */
  location?: Maybe<Location>;
  /**
   * Location UUID the override applies to.
   * @deprecated Use `location { id }`. Reachable through the federated `location` field.
   */
  locationId?: Maybe<Scalars['ID']['output']>;
  /** Overridden order cutoff as "HH:MM". */
  orderDeadline?: Maybe<Scalars['String']['output']>;
  /**
   * The rule deciding the day instead of this one on at least one of its
   * locations, or null when this rule takes effect everywhere it reaches. Always
   * one of `overlaps`.
   */
  outrankedBy?: Maybe<DeliveryOverrideOverlap>;
  /**
   * Other rules covering some of this rule's locations on its date, most specific
   * first. Each `locationCount` is how many of this rule's locations that rule
   * covers. The same answer `deliveryOverridePreview` gives a draft.
   */
  overlaps: Array<DeliveryOverrideOverlap>;
  /**
   * Who a group or vendor rule naming a vendor reaches. Null for other rules and
   * for vendor rules saved before the mode existed; legacy group rules with a
   * vendor and no stored mode read ALL.
   */
  reachMode?: Maybe<DeliveryOverrideReachModeEnum>;
  /**
   * How many locations this override currently reaches, inside the market it
   * applies in. Resolved when asked rather than stored, so a tag-described
   * audience reflects who carries the tag now.
   */
  reachedLocationCount: Scalars['Int']['output'];
  /**
   * The locations this override currently reaches, inside the market it applies
   * in, ordered by business name. Set only for a `group` override -- every other
   * scope either names its one location directly or has none to enumerate. Its
   * total always matches `reachedLocationCount`.
   */
  reachedLocations?: Maybe<ReachedLocationsConnection>;
  /** The grain the override targets. */
  scope: DeliveryOverrideRuleScopeEnum;
  /** The make-up delivery date for a substitute override. */
  substituteDeliveryDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Whether a location needs any or all of `audienceTags`. Null when there are none. */
  tagMatchMode?: Maybe<DeliveryOverrideTagMatchModeEnum>;
  /**
   * The vendor the override applies to. Null when the override spans every vendor
   * — a location-wide one, or a group naming an audience but no vendor.
   */
  vendor?: Maybe<Vendor>;
  /**
   * Vendor-carrying rules that change one vendor's day apart from what this rule
   * decides for its locations. Empty when this rule itself names a vendor, or sets no day action.
   */
  vendorExceptions: Array<DeliveryOverrideVendorException>;
  /**
   * Vendor UUID the override applies to. Null when the override spans every vendor
   * — a location-wide one, or a group naming an audience but no vendor.
   * @deprecated Use `vendor { id }`.
   */
  vendorId?: Maybe<Scalars['ID']['output']>;
  /**
   * The market the override applies in. Null when it applies in every market — a
   * vendor-wide closure that is not confined to one.
   */
  warehouse?: Maybe<Warehouse>;
};


/** A date-scoped delivery override for a location, and optionally a single vendor. */
export type DeliveryOverrideRuleReachedLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** An edge in a connection. */
export type DeliveryOverrideRuleEdge = {
  __typename?: 'DeliveryOverrideRuleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeliveryOverrideRule>;
};

export enum DeliveryOverrideRuleScopeEnum {
  /** An audience of locations. */
  Group = 'group',
  /** One location, across all of its vendors. */
  Location = 'location',
  /** One location and vendor. */
  Lva = 'lva',
  /** Every location in one market, for every vendor. */
  Market = 'market',
  /** One vendor, across every location it delivers to. */
  Vendor = 'vendor'
}

/** The connection type for DeliveryOverrideRule. */
export type DeliveryOverrideRulesConnection = {
  __typename?: 'DeliveryOverrideRulesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeliveryOverrideRuleEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<DeliveryOverrideRule>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of records in the connection. */
  totalCount: Scalars['Int']['output'];
};

export enum DeliveryOverrideScopeEnum {
  /** An audience of locations for one vendor. */
  Group = 'group',
  /** One location, across all of its vendors. */
  Location = 'location',
  /** One location and vendor. */
  Lva = 'lva',
  /** Every location in one market, for every vendor. Ranks lowest of all; requires `warehouseId`. */
  Market = 'market',
  /** One vendor, across every store it delivers to. Narrow it with `warehouseId`. */
  Vendor = 'vendor'
}

export enum DeliveryOverrideTagMatchModeEnum {
  /** A location matches only if it carries every one of the tags. */
  All = 'ALL',
  /** A location matches if it carries at least one of the tags. */
  Any = 'ANY'
}

export enum DeliveryOverrideVendorEffectEnum {
  /** The draft would hold here on its own, but this vendor-specific rule decides the day for that vendor instead. */
  DecidesForVendor = 'decides_for_vendor',
  /** The draft would lose here on its own, but this vendor-specific rule restores the draft's action for that vendor. */
  RestoresForVendor = 'restores_for_vendor'
}

export type DeliveryOverrideVendorException = {
  __typename?: 'DeliveryOverrideVendorException';
  /** Whether this rule decides the vendor's day away from the draft, or restores the draft's action for that vendor. */
  effect: DeliveryOverrideVendorEffectEnum;
  /** How many of the proposed audience's locations this exception covers. */
  locationCount: Scalars['Int']['output'];
  /** The vendor-carrying rule that decides or restores the day for this vendor. */
  rule: DeliveryOverrideRule;
};

export type DeliveryPriceError = Error & {
  __typename?: 'DeliveryPriceError';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

export type DeliveryPriceInput = {
  /** The channel from which the order originated. */
  channel?: InputMaybe<ChannelEnum>;
  /** An optional coupon code to be applied on the delivery. */
  couponCode?: InputMaybe<Scalars['String']['input']>;
  /** The delivery date. */
  deliveryDate: Scalars['ISO8601Date']['input'];
  /** The method of delivery. */
  deliveryMethod?: InputMaybe<DeliveryMethodEnum>;
  /** The weight of the order. */
  deliveryWeight?: InputMaybe<Scalars['Float']['input']>;
  /** The items ordered in the delivery. */
  items?: InputMaybe<Array<DeliveryItemInput>>;
  /** The location ID for the delivery. */
  locationId: Scalars['ID']['input'];
  /** The cost to ship the delivery. This is not included in the subtotal. */
  shippingCost?: InputMaybe<MoneyInput>;
  /** The delivery price before any discounts. */
  subtotal: MoneyInput;
};

export type DeliveryPriceResult = DeliveryPriceSuccess | ErrorsResult;

export type DeliveryPriceSuccess = {
  __typename?: 'DeliveryPriceSuccess';
  /** Any automatic discounts the delivery is applicable for */
  automaticDiscounts?: Maybe<Array<AutomaticDiscount>>;
  /** The coupon status after validation. */
  couponStatus?: Maybe<CouponStatus>;
  /** Indicates if promotions are unavailable due to Voucherify infrastructure failures */
  hasInfrastructureIssues: Scalars['Boolean']['output'];
  /** Indicates if any promotion could not be applied (infrastructure failures or business rules) */
  hasPromotionIssues: Scalars['Boolean']['output'];
  /** User-friendly message to display when promotions have issues */
  promotionIssueMessage?: Maybe<Scalars['String']['output']>;
  /** The delivery price before any discounts. */
  subtotal: Money;
  /** The delivery price after discounts. */
  total: Money;
  /** The calculated total discount on a delivery. */
  totalDiscount: Money;
};

/** Autogenerated input type of DeliveryRouteCreate */
export type DeliveryRouteCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Delivery route name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Delivery Route night end. */
  nightEnd: Scalars['ISO8601Date']['input'];
  redelivery?: InputMaybe<Scalars['Boolean']['input']>;
  /** Warehouse id. */
  warehouseId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeliveryRouteCreate. */
export type DeliveryRouteCreatePayload = {
  __typename?: 'DeliveryRouteCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  route?: Maybe<Route>;
  userErrors: Array<RouteError>;
};

/** Autogenerated input type of DeliveryRouteStopAttachmentCreate */
export type DeliveryRouteStopAttachmentCreateInput = {
  attachmentCategory?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Delivery route stop id. */
  deliveryRouteStopId: Scalars['ID']['input'];
  objectKey: Scalars['String']['input'];
  redelivery?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of DeliveryRouteStopAttachmentCreate. */
export type DeliveryRouteStopAttachmentCreatePayload = {
  __typename?: 'DeliveryRouteStopAttachmentCreatePayload';
  attachment?: Maybe<Attachment>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userErrors: Array<DeliveryRouteStopError>;
};

/** Autogenerated input type of DeliveryRouteStopAttachmentDelete */
export type DeliveryRouteStopAttachmentDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Delivery route stop id. */
  deliveryRouteStopId: Scalars['ID']['input'];
  objectKey: Scalars['String']['input'];
  redelivery?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of DeliveryRouteStopAttachmentDelete. */
export type DeliveryRouteStopAttachmentDeletePayload = {
  __typename?: 'DeliveryRouteStopAttachmentDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userErrors: Array<DeliveryRouteStopError>;
};

/** Autogenerated input type of DeliveryRouteStopCompostCollectedUpdate */
export type DeliveryRouteStopCompostCollectedUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  collected: Scalars['Boolean']['input'];
  /** Delivery route stop id. */
  deliveryRouteStopId: Scalars['ID']['input'];
  redelivery?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of DeliveryRouteStopCompostCollectedUpdate. */
export type DeliveryRouteStopCompostCollectedUpdatePayload = {
  __typename?: 'DeliveryRouteStopCompostCollectedUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userErrors: Array<DeliveryRouteStopError>;
};

/** Autogenerated input type of DeliveryRouteStopDeliveryNoteUpdate */
export type DeliveryRouteStopDeliveryNoteUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Delivery note for the stop. */
  deliveryNote: Scalars['String']['input'];
  redelivery?: InputMaybe<Scalars['Boolean']['input']>;
  /** Delivery route stop id. */
  stopId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeliveryRouteStopDeliveryNoteUpdate. */
export type DeliveryRouteStopDeliveryNoteUpdatePayload = {
  __typename?: 'DeliveryRouteStopDeliveryNoteUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userErrors: Array<DeliveryRouteStopError>;
};

/** Autogenerated input type of DeliveryRouteStopDonationCollectedUpdate */
export type DeliveryRouteStopDonationCollectedUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  collected: Scalars['Boolean']['input'];
  /** Delivery route stop id. */
  deliveryRouteStopId: Scalars['ID']['input'];
  redelivery?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of DeliveryRouteStopDonationCollectedUpdate. */
export type DeliveryRouteStopDonationCollectedUpdatePayload = {
  __typename?: 'DeliveryRouteStopDonationCollectedUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userErrors: Array<DeliveryRouteStopError>;
};

/** Delivery route stop possible error types */
export type DeliveryRouteStopError = CompletedCustomerPickupStop | InvalidNightEnd | MetrobiAssignmentBlocked | NonCustomerPickupStops | NonMovableStops | PickupRoutingDisabled | ProviderRouteGuarded | UncountedLineTrackedOrders | UnresolvedTasks;

/** Autogenerated input type of DeliveryRouteStopReminderUpdate */
export type DeliveryRouteStopReminderUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Driver reminder message for the stop. */
  message: Scalars['String']['input'];
  /** Delivery route stop id. */
  stopId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeliveryRouteStopReminderUpdate. */
export type DeliveryRouteStopReminderUpdatePayload = {
  __typename?: 'DeliveryRouteStopReminderUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  stop?: Maybe<DeliveryStop>;
  userErrors: Array<DeliveryRouteStopError>;
};

export type DeliveryRouteStopTask = {
  __typename?: 'DeliveryRouteStopTask';
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Task instructions for the driver (max 500 chars). */
  details: Scalars['String']['output'];
  /** Driver's explanation, present when the task is incomplete. */
  driverNote?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** When the driver marked the task complete or incomplete. */
  resolvedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: DeliveryRouteStopTaskStatus;
};

/** Autogenerated input type of DeliveryRouteStopTaskCreate */
export type DeliveryRouteStopTaskCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Task text (max 500 chars). */
  details: Scalars['String']['input'];
  /** Delivery route stop id. */
  stopId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeliveryRouteStopTaskCreate. */
export type DeliveryRouteStopTaskCreatePayload = {
  __typename?: 'DeliveryRouteStopTaskCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  task?: Maybe<DeliveryRouteStopTask>;
  userErrors: Array<DeliveryRouteStopTaskError>;
};

/** Autogenerated input type of DeliveryRouteStopTaskDelete */
export type DeliveryRouteStopTaskDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Task id. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeliveryRouteStopTaskDelete. */
export type DeliveryRouteStopTaskDeletePayload = {
  __typename?: 'DeliveryRouteStopTaskDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userErrors: Array<DeliveryRouteStopTaskError>;
};

/** Route stop task possible error types */
export type DeliveryRouteStopTaskError = InvalidNightEnd | TaskAlreadyResolved | TaskNotFound | TaskNoteRequired;

export enum DeliveryRouteStopTaskResolution {
  /** Driver marked the task done */
  Complete = 'complete',
  /** Driver marked the task not done; a driver note explains why */
  Incomplete = 'incomplete'
}

export type DeliveryRouteStopTaskResolutionInput = {
  /** Driver's explanation for this task; required when status is incomplete. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** complete or incomplete. */
  status: DeliveryRouteStopTaskResolution;
  /** The task being resolved. */
  taskId: Scalars['ID']['input'];
};

export enum DeliveryRouteStopTaskStatus {
  /** Driver marked the task done */
  Complete = 'complete',
  /** GM created the task; the driver has not resolved it yet */
  Created = 'created',
  /** Driver marked the task not done; a driver note explains why */
  Incomplete = 'incomplete'
}

/** Autogenerated input type of DeliveryRouteStopTaskUpdate */
export type DeliveryRouteStopTaskUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Task text (max 500 chars). */
  details: Scalars['String']['input'];
  /** Task id. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeliveryRouteStopTaskUpdate. */
export type DeliveryRouteStopTaskUpdatePayload = {
  __typename?: 'DeliveryRouteStopTaskUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  task?: Maybe<DeliveryRouteStopTask>;
  userErrors: Array<DeliveryRouteStopTaskError>;
};

/** Autogenerated input type of DeliveryRouteStopTasksResolve */
export type DeliveryRouteStopTasksResolveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** One entry per task on the stop, each carrying its own note. */
  resolutions: Array<DeliveryRouteStopTaskResolutionInput>;
  /** Delivery route stop id. */
  stopId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeliveryRouteStopTasksResolve. */
export type DeliveryRouteStopTasksResolvePayload = {
  __typename?: 'DeliveryRouteStopTasksResolvePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  tasks?: Maybe<Array<DeliveryRouteStopTask>>;
  userErrors: Array<DeliveryRouteStopTaskError>;
};

/** Autogenerated input type of DeliveryRouteStopUpsellNoteUpdate */
export type DeliveryRouteStopUpsellNoteUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  redelivery?: InputMaybe<Scalars['Boolean']['input']>;
  /** Delivery route stop id. */
  stopId: Scalars['ID']['input'];
  /** Upsell note for the stop. */
  upsellNote: Scalars['String']['input'];
};

/** Autogenerated return type of DeliveryRouteStopUpsellNoteUpdate. */
export type DeliveryRouteStopUpsellNoteUpdatePayload = {
  __typename?: 'DeliveryRouteStopUpsellNoteUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userErrors: Array<DeliveryRouteStopError>;
};

/** Autogenerated input type of DeliveryRouteStopViewedAtUpdate */
export type DeliveryRouteStopViewedAtUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** delivery route stop id. */
  deliveryRouteStopId: Scalars['ID']['input'];
  redelivery?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of DeliveryRouteStopViewedAtUpdate. */
export type DeliveryRouteStopViewedAtUpdatePayload = {
  __typename?: 'DeliveryRouteStopViewedAtUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deliveryRouteStop?: Maybe<DeliveryStop>;
  userErrors: Array<DeliveryRouteStopError>;
};

export type DeliveryRule = {
  __typename?: 'DeliveryRule';
  deliveryDay: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  leadTime: Scalars['Int']['output'];
  orderDeadline: Scalars['String']['output'];
};

export enum DeliveryStatus {
  /** delivery route stop is marked completed and has no issues and all orders delivered */
  Done = 'done',
  /**
   * delivery route stop has at least one delivery issue or at least one order is not marked
   * delivered.
   */
  Error = 'error',
  /** Delivery route stop has not been viewed by a driver */
  New = 'new'
}

export enum DeliveryStatusDmp {
  /** Location stop is marked as completed and all orders have been delivered */
  Delivered = 'delivered',
  /** Vendor stop has not been collected. Location stop has not been delivered yet */
  InTransit = 'in_transit',
  /** only returned if a stop is not a vendor stop or a location stop. Should never happen */
  NotAvailable = 'not_available',
  /** Vendor stop is marked as collected but all orders are not collected */
  NotPickedUp = 'not_picked_up',
  /** Location stop is marked as completed and has at least one order partially delivered */
  PartiallyDelivered = 'partially_delivered',
  /** Vendor stop is marked as collected but all some orders are marked as collected and some not collected */
  PartiallyPickedUp = 'partially_picked_up',
  /** Vendor stop is marked as collected and all orders are marked as collected */
  PickedUp = 'picked_up',
  /** Location stop is marked as completed and has at least one order undelivered */
  Undelivered = 'undelivered'
}

export enum DeliveryStatusDriver {
  /** delivery route stop is marked completed and has no issues and all orders delivered */
  Done = 'done',
  /**
   * stop has at least one delivery issue or at least one order is not marked
   * delivered or at least one order has less delivered quantities than fulfilled
   */
  Error = 'error',
  /** Delivery route stop has not been viewed by a driver */
  New = 'new'
}

/** Delivery stop */
export type DeliveryStop = Delivery | PickUp;

/** Autogenerated input type of DeliveryStopsMoveToRoute */
export type DeliveryStopsMoveToRouteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  redelivery?: InputMaybe<Scalars['Boolean']['input']>;
  /** Delivery route id you would like to move the stops to. */
  routeId: Scalars['ID']['input'];
  /** ID of the stop you would like to move. */
  stopIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of DeliveryStopsMoveToRoute. */
export type DeliveryStopsMoveToRoutePayload = {
  __typename?: 'DeliveryStopsMoveToRoutePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  updatedRoutes?: Maybe<Array<Route>>;
  userErrors: Array<DeliveryRouteStopError>;
};

/** Autogenerated input type of DeliveryStopsReorder */
export type DeliveryStopsReorderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The sequence number you would like to move your stop to on the specified route. */
  destinationSequenceNumber: Scalars['Int']['input'];
  redelivery?: InputMaybe<Scalars['Boolean']['input']>;
  /** Delivery route id. */
  routeId: Scalars['ID']['input'];
  /** Stop id you would like to move. */
  stopId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeliveryStopsReorder. */
export type DeliveryStopsReorderPayload = {
  __typename?: 'DeliveryStopsReorderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  route?: Maybe<Route>;
  userErrors: Array<DeliveryRouteStopError>;
};

/** How a delivery is prioritized by the carrier. */
export enum DeliveryType {
  /** Expedited delivery. */
  Expedited = 'EXPEDITED',
  /** Guaranteed delivery. */
  Guaranteed = 'GUARANTEED',
  /** Standard delivery. */
  StandardDelivery = 'STANDARD_DELIVERY'
}

export type DepartNotAllowed = UserErrorInterface & {
  __typename?: 'DepartNotAllowed';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of DeprioritizeLocation */
export type DeprioritizeLocationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

/** Autogenerated return type of DeprioritizeLocation. */
export type DeprioritizeLocationPayload = {
  __typename?: 'DeprioritizeLocationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  locationDeprioritization?: Maybe<LocationDeprioritization>;
};

export type DirectUploadHeader = {
  __typename?: 'DirectUploadHeader';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type DiscontinueWarehouseInput = {
  discontinueItem: Scalars['Boolean']['input'];
  discontinueSample: Scalars['Boolean']['input'];
  replacementItemId?: InputMaybe<Scalars['ID']['input']>;
  warehouseId: Scalars['ID']['input'];
};

export type DispatchNotAllowed = UserErrorInterface & {
  __typename?: 'DispatchNotAllowed';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type DispatchProfileIncomplete = UserErrorInterface & {
  __typename?: 'DispatchProfileIncomplete';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of DispatchProviderRoute */
export type DispatchProviderRouteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The provider's id of the quote to dispatch against, from Route.providerDispatch.quotes. */
  quoteId: Scalars['String']['input'];
  /** The marked route to dispatch. */
  routeId: Scalars['ID']['input'];
};

/** Autogenerated return type of DispatchProviderRoute. */
export type DispatchProviderRoutePayload = {
  __typename?: 'DispatchProviderRoutePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  route?: Maybe<Route>;
  userErrors: Array<ThirdPartyDispatchError>;
};

export type Dock = {
  __typename?: 'Dock';
  active: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Booking windows, sorted, non-overlapping. */
  windows: Array<DockWindow>;
};

export type DockBooking = {
  __typename?: 'DockBooking';
  /**
   * When this booking's current slot/dock was last set — re-stamped on every
   * amend. Compare against created_at with a threshold, not strict equality — the
   * two are stamped separately and differ by a few microseconds even on a
   * never-amended booking.
   */
  bookedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether this is a purchase order, transfer order, or non-inventory vendor delivery. */
  bookingKind: DockBookingKind;
  carrierName?: Maybe<Scalars['String']['output']>;
  /** Notes or special instructions for the delivery. */
  comments?: Maybe<Scalars['String']['output']>;
  /** Email the booking confirmation is sent to. */
  confirmationEmail?: Maybe<Scalars['String']['output']>;
  /** Appointment reference for confirmations. */
  confirmationNumber?: Maybe<Scalars['String']['output']>;
  /** Contact email for the delivery. */
  contactEmail?: Maybe<Scalars['String']['output']>;
  /** Contact person for the delivery. */
  contactName?: Maybe<Scalars['String']['output']>;
  /** Contact phone for the delivery. */
  contactPhone?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** How the delivery is prioritized. */
  deliveryType?: Maybe<DeliveryType>;
  dock?: Maybe<Dock>;
  expectedDate?: Maybe<Scalars['ISO8601Date']['output']>;
  freightType?: Maybe<FreightType>;
  id: Scalars['ID']['output'];
  /** Source warehouse a transfer order is arriving from, matched by reference number; null for non-transfer bookings. */
  originName?: Maybe<Scalars['String']['output']>;
  /** Number of pallets on the shipment. */
  palletCount?: Maybe<Scalars['Int']['output']>;
  /** Carrier PRO (tracking) number. */
  proNumber?: Maybe<Scalars['String']['output']>;
  referenceNumber: Scalars['String']['output'];
  /** The prior booking this one recovered from after a no-show or cancellation, if any. */
  rescheduledFrom?: Maybe<DockBooking>;
  /** The later booking that recovered this one after a no-show or cancellation, if any. */
  rescheduledTo?: Maybe<DockBooking>;
  /** Standard Carrier Alpha Code. */
  scacCode?: Maybe<Scalars['String']['output']>;
  /** Date the freight ships (distinct from the appointment date). */
  shipDate?: Maybe<Scalars['ISO8601Date']['output']>;
  slotEndsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Slot in warehouse-local time. */
  slotLabel?: Maybe<Scalars['String']['output']>;
  slotStartsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * Who created this booking — the carrier-facing flow, or ops (standing/ad-hoc).
   * Combine with booking_kind to tell a PO-known ad-hoc booking apart from an
   * ordinary carrier one, since both share booking_kind PURCHASE_ORDER.
   */
  source: DockBookingSource;
  status: DockBookingStatus;
  /**
   * Secret token embedded in the driver's booking link.
   * @deprecated Unused since inbound-appointment (PO-based lookup); slated for removal.
   */
  token: Scalars['String']['output'];
  /** Truck or trailer number. */
  truckNumber?: Maybe<Scalars['String']['output']>;
  /** Vendor/entity on the PO matched by reference number, if any. */
  vendorName?: Maybe<Scalars['String']['output']>;
  /** Physical arrivals this booking's cargo turned up on, oldest first. */
  visits: Array<DockVisit>;
  /** Shipment weight in pounds. */
  weightLbs?: Maybe<Scalars['Float']['output']>;
  /** Slot length in minutes once booked (null until a freight type is set). */
  windowMinutes?: Maybe<Scalars['Int']['output']>;
};

export type DockBookingAlreadyCompleted = UserErrorInterface & {
  __typename?: 'DockBookingAlreadyCompleted';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type DockBookingAlreadyMissed = UserErrorInterface & {
  __typename?: 'DockBookingAlreadyMissed';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of DockBookingCancel */
export type DockBookingCancelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dockBookingId: Scalars['ID']['input'];
};

/** Autogenerated return type of DockBookingCancel. */
export type DockBookingCancelPayload = {
  __typename?: 'DockBookingCancelPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  dockBooking?: Maybe<DockBooking>;
  userErrors: Array<DockBookingError>;
};

/** Dock booking possible error types */
export type DockBookingError = AdHocAppointmentsNotAllowed | AppointmentInPast | CarrierNameRequired | CheckInNotAllowed | ContactDetailsRequired | DailyDeliveryExists | DepartNotAllowed | DockBookingAlreadyCompleted | DockBookingAlreadyMissed | DockBookingNotBooked | DockBookingNotFound | DockBookingWarehouseNotFound | DockCapacityInvalid | DockInUse | DockNotFound | DockOverrideCodeInactive | DockReassignNotAllowed | DockRecoveryNotAllowed | DockSlotUnavailable | DockVisitNotFound | OverrideCodeIssueConflict | OverrideCodeNotFound | OverrideVendorNotFound | ShipDateRequired | WithinLeadTime;

export enum DockBookingKind {
  /** An ops-created one-off appointment with no PO on file. */
  AdHoc = 'AD_HOC',
  /** A code-authorized non-inventory vendor delivery (no PO/TO). */
  NonInventory = 'NON_INVENTORY',
  /** A purchase-order delivery from a vendor. */
  PurchaseOrder = 'PURCHASE_ORDER',
  /** A recurring standing-appointment occurrence. */
  Standing = 'STANDING',
  /** An inbound transfer order from another warehouse. */
  TransferOrder = 'TRANSFER_ORDER'
}

/** Autogenerated input type of DockBookingMarkMissed */
export type DockBookingMarkMissedInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dockBookingId: Scalars['ID']['input'];
};

/** Autogenerated return type of DockBookingMarkMissed. */
export type DockBookingMarkMissedPayload = {
  __typename?: 'DockBookingMarkMissedPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  dockBooking?: Maybe<DockBooking>;
  userErrors: Array<DockBookingError>;
};

export type DockBookingNotBooked = UserErrorInterface & {
  __typename?: 'DockBookingNotBooked';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type DockBookingNotFound = UserErrorInterface & {
  __typename?: 'DockBookingNotFound';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of DockBookingOpsCheckIn */
export type DockBookingOpsCheckInInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dockBookingId: Scalars['ID']['input'];
  /** Trailer the driver actually arrived with. Optional; falls back to what's on file. */
  truckNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DockBookingOpsCheckIn. */
export type DockBookingOpsCheckInPayload = {
  __typename?: 'DockBookingOpsCheckInPayload';
  booking?: Maybe<DockBooking>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userErrors: Array<DockBookingError>;
  visit?: Maybe<DockVisit>;
};

export enum DockBookingSource {
  /** Created through the public, carrier-facing booking flow. */
  Carrier = 'CARRIER',
  /** Created by ops — a standing appointment or an ad-hoc appointment. */
  Ops = 'OPS'
}

export enum DockBookingStatus {
  Booked = 'BOOKED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Missed = 'MISSED',
  Pending = 'PENDING'
}

export type DockBookingWarehouseNotFound = UserErrorInterface & {
  __typename?: 'DockBookingWarehouseNotFound';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type DockCapacityInvalid = UserErrorInterface & {
  __typename?: 'DockCapacityInvalid';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of DockCreate */
export type DockCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  warehouseId: Scalars['ID']['input'];
  windows: Array<DockWindowInput>;
};

/** Autogenerated return type of DockCreate. */
export type DockCreatePayload = {
  __typename?: 'DockCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  dock?: Maybe<Dock>;
  userErrors: Array<DockBookingError>;
};

/** Autogenerated input type of DockDelete */
export type DockDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dockId: Scalars['ID']['input'];
};

/** Autogenerated return type of DockDelete. */
export type DockDeletePayload = {
  __typename?: 'DockDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedDockId?: Maybe<Scalars['ID']['output']>;
  userErrors: Array<DockBookingError>;
};

export type DockInUse = UserErrorInterface & {
  __typename?: 'DockInUse';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type DockNotFound = UserErrorInterface & {
  __typename?: 'DockNotFound';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type DockOverrideCode = {
  __typename?: 'DockOverrideCode';
  active: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Identity of the admin who issued the code. */
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  netsuiteInternalId: Scalars['String']['output'];
  vendorName?: Maybe<Scalars['String']['output']>;
};

export type DockOverrideCodeInactive = UserErrorInterface & {
  __typename?: 'DockOverrideCodeInactive';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of DockOverrideCodeIssue */
export type DockOverrideCodeIssueInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  netsuiteInternalId: Scalars['String']['input'];
};

/** Autogenerated return type of DockOverrideCodeIssue. */
export type DockOverrideCodeIssuePayload = {
  __typename?: 'DockOverrideCodeIssuePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  dockOverrideCode?: Maybe<DockOverrideCode>;
  userErrors: Array<DockBookingError>;
};

/** Autogenerated input type of DockOverrideCodeRevoke */
export type DockOverrideCodeRevokeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DockOverrideCodeRevoke. */
export type DockOverrideCodeRevokePayload = {
  __typename?: 'DockOverrideCodeRevokePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  dockOverrideCode?: Maybe<DockOverrideCode>;
  userErrors: Array<DockBookingError>;
};

export type DockReassignNotAllowed = UserErrorInterface & {
  __typename?: 'DockReassignNotAllowed';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type DockRecoveryNotAllowed = UserErrorInterface & {
  __typename?: 'DockRecoveryNotAllowed';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type DockSlotUnavailable = UserErrorInterface & {
  __typename?: 'DockSlotUnavailable';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of DockUpdate */
export type DockUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dockId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  windows?: InputMaybe<Array<DockWindowInput>>;
};

/** Autogenerated return type of DockUpdate. */
export type DockUpdatePayload = {
  __typename?: 'DockUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  dock?: Maybe<Dock>;
  userErrors: Array<DockBookingError>;
};

/** A truck's physical stay at the dock, as opposed to the appointment it was keeping. */
export type DockVisit = {
  __typename?: 'DockVisit';
  /** The dock-approach buffer used to compute detentionSeconds, frozen alongside it. */
  approachBufferMinutesApplied?: Maybe<Scalars['Int']['output']>;
  /** The delivery this visit was opened against. */
  booking?: Maybe<DockBooking>;
  /** Every DockBooking currently linked to this visit's manifest, oldest-linked first. */
  bookings: Array<DockBooking>;
  /** When the driver checked in. */
  checkedInAt: Scalars['ISO8601DateTime']['output'];
  /** How the check-in was recorded. Null for visits recorded before this was tracked. */
  checkedInVia?: Maybe<DockVisitCheckedInVia>;
  /** When ops marked the truck away. Null while it is still on site. */
  departedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** How the departure was recorded. Null while open, and for visits departed before this was tracked. */
  departedVia?: Maybe<DockVisitDepartedVia>;
  /**
   * Time beyond the free allowance, measured from the later of check-in or the
   * appointment's own start (so an early arrival isn't charged for time before its
   * window opened), frozen at departure. Null while open, and permanently null for
   * freight_type "other" (no confirmed threshold).
   */
  detentionSeconds?: Maybe<Scalars['Int']['output']>;
  /** Dock the truck was placed on. Null when none was free at check-in. */
  dock?: Maybe<Dock>;
  /** Time on site, set once both ends are observed and null until then. */
  dwellSeconds?: Maybe<Scalars['Int']['output']>;
  /**
   * The LTL/FTL free-dwell threshold used to compute detentionSeconds, frozen
   * alongside it so a later policy change doesn't reclassify this visit.
   */
  freeDwellMinutesApplied?: Maybe<Scalars['Int']['output']>;
  /** Snapshotted at check-in. */
  freightType?: Maybe<FreightType>;
  id: Scalars['ID']['output'];
  /**
   * Every DockBooking in this visit's same-truck group (same warehouse, expected
   * date, and SCAC, LTL only) — whether or not each one is linked to this visit
   * yet. Compare against `bookings` to see what's outstanding. Empty for FTL/OTHER
   * visits, which are always exactly one booking.
   */
  manifestGroupBookings: Array<DockBooking>;
  /** Standard Carrier Alpha Code, snapshotted at check-in. */
  scacCode?: Maybe<Scalars['String']['output']>;
  /** End of the frozen appointment window; see slotStartsAt. */
  slotEndsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Appointment window this arrival was measured against, frozen at check-in so a later amendment cannot rewrite it. */
  slotStartsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Trailer number given at check-in: what turned up, as against what the carrier declared when booking. */
  truckNumber?: Maybe<Scalars['String']['output']>;
};

export enum DockVisitCheckedInVia {
  /** A kiosk's own dockId. */
  Kiosk = 'KIOSK',
  /** Ops, directly from the admin board — no reference typed. */
  Ops = 'OPS',
  /** A warehouse placard's warehouseId. */
  Placard = 'PLACARD'
}

/** Autogenerated input type of DockVisitDepart */
export type DockVisitDepartInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dockVisitId: Scalars['ID']['input'];
};

/** Autogenerated return type of DockVisitDepart. */
export type DockVisitDepartPayload = {
  __typename?: 'DockVisitDepartPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  dockVisit?: Maybe<DockVisit>;
  userErrors: Array<DockBookingError>;
};

export enum DockVisitDepartedVia {
  /** An ops kiosk/admin tap. */
  Ops = 'OPS',
  /** The overnight auto-close sweep. */
  Sweep = 'SWEEP'
}

export type DockVisitNotFound = UserErrorInterface & {
  __typename?: 'DockVisitNotFound';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of DockVisitReassignDock */
export type DockVisitReassignDockInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dockId: Scalars['ID']['input'];
  dockVisitId: Scalars['ID']['input'];
};

/** Autogenerated return type of DockVisitReassignDock. */
export type DockVisitReassignDockPayload = {
  __typename?: 'DockVisitReassignDockPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  dockVisit?: Maybe<DockVisit>;
  userErrors: Array<DockBookingError>;
};

export type DockWindow = {
  __typename?: 'DockWindow';
  /** Warehouse-local wall clock, e.g. "13:00". */
  closeTime: Scalars['String']['output'];
  /** Max full trucks (FTL/other) this window takes; 0 = blocked. */
  ftlMax: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** Max LTL trucks (distinct carriers) this window takes; 0 = blocked. */
  ltlMax: Scalars['Int']['output'];
  /** Warehouse-local wall clock, e.g. "10:00". */
  openTime: Scalars['String']['output'];
};

export type DockWindowInput = {
  /** e.g. "13:00" */
  closeTime: Scalars['String']['input'];
  /** Max full trucks (FTL/other) this window takes; omitted/null = 0 (blocked). */
  ftlMax?: InputMaybe<Scalars['Int']['input']>;
  /** Max LTL trucks (distinct carriers) this window takes; omitted/null = 0 (blocked). */
  ltlMax?: InputMaybe<Scalars['Int']['input']>;
  /** e.g. "10:00" */
  openTime: Scalars['String']['input'];
};

export type DockWindowNotFound = UserErrorInterface & {
  __typename?: 'DockWindowNotFound';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type Driver = {
  __typename?: 'Driver';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** A single timestamped driver location fix on a route's breadcrumb trail. */
export type DriverLocationPing = {
  __typename?: 'DriverLocationPing';
  /** Horizontal accuracy in meters, when available. */
  accuracy?: Maybe<Scalars['Float']['output']>;
  /** Heading in degrees (0-360), when available. */
  heading?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  /** WGS84 latitude of the fix. */
  latitude: Scalars['Float']['output'];
  /** WGS84 longitude of the fix. */
  longitude: Scalars['Float']['output'];
  /** Device fix time. */
  occurredAt: Scalars['ISO8601DateTime']['output'];
  /** Speed in m/s, when available. */
  speed?: Maybe<Scalars['Float']['output']>;
};

export type DriverLocationPingInput = {
  /** Horizontal accuracy in meters, when available. */
  accuracy?: InputMaybe<Scalars['Float']['input']>;
  /** Heading in degrees (0-360), when available. */
  heading?: InputMaybe<Scalars['Float']['input']>;
  /** WGS84 latitude of the fix. */
  latitude: Scalars['Float']['input'];
  /** WGS84 longitude of the fix. */
  longitude: Scalars['Float']['input'];
  /** Device fix time; the ordering/dedupe key. */
  occurredAt: Scalars['ISO8601DateTime']['input'];
  /** Speed in m/s, when available. */
  speed?: InputMaybe<Scalars['Float']['input']>;
};

export type DriverLocationTrailInput = {
  /** Window start (inclusive). */
  from?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Delivery route id. */
  routeId: Scalars['ID']['input'];
  /** Window end (inclusive). */
  to?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Driver safety acknowledgement metadata and content. */
export type DriverSafetyAcknowledgement = {
  __typename?: 'DriverSafetyAcknowledgement';
  acknowledgementCopy: Scalars['String']['output'];
  acknowledgementText: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  driverAcknowledgementsCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  publishOn: Scalars['ISO8601Date']['output'];
  status: DriverSafetyAcknowledgementStatus;
};

/** Autogenerated input type of DriverSafetyAcknowledgementAcknowledge */
export type DriverSafetyAcknowledgementAcknowledgeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Driver safety acknowledgement ID. */
  driverSafetyAcknowledgementId: Scalars['ID']['input'];
};

/** Autogenerated return type of DriverSafetyAcknowledgementAcknowledge. */
export type DriverSafetyAcknowledgementAcknowledgePayload = {
  __typename?: 'DriverSafetyAcknowledgementAcknowledgePayload';
  acknowledgement?: Maybe<DriverSafetyAcknowledgement>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userErrors: Array<UserError>;
};

/** Autogenerated input type of DriverSafetyAcknowledgementCreate */
export type DriverSafetyAcknowledgementCreateInput = {
  acknowledgementCopy: Scalars['String']['input'];
  acknowledgementText: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  publishOn: Scalars['ISO8601Date']['input'];
};

/** Autogenerated return type of DriverSafetyAcknowledgementCreate. */
export type DriverSafetyAcknowledgementCreatePayload = {
  __typename?: 'DriverSafetyAcknowledgementCreatePayload';
  acknowledgement?: Maybe<DriverSafetyAcknowledgement>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userErrors: Array<UserError>;
};

/** Autogenerated input type of DriverSafetyAcknowledgementDelete */
export type DriverSafetyAcknowledgementDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Driver safety acknowledgement ID. */
  driverSafetyAcknowledgementId: Scalars['ID']['input'];
};

/** Autogenerated return type of DriverSafetyAcknowledgementDelete. */
export type DriverSafetyAcknowledgementDeletePayload = {
  __typename?: 'DriverSafetyAcknowledgementDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedId?: Maybe<Scalars['ID']['output']>;
  userErrors: Array<UserError>;
};

/** Driver safety acknowledgement status. */
export enum DriverSafetyAcknowledgementStatus {
  Published = 'published',
  Scheduled = 'scheduled'
}

/** Autogenerated input type of DriverSafetyAcknowledgementUpdate */
export type DriverSafetyAcknowledgementUpdateInput = {
  acknowledgementCopy: Scalars['String']['input'];
  acknowledgementText: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Driver safety acknowledgement ID. */
  driverSafetyAcknowledgementId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  publishOn: Scalars['ISO8601Date']['input'];
};

/** Autogenerated return type of DriverSafetyAcknowledgementUpdate. */
export type DriverSafetyAcknowledgementUpdatePayload = {
  __typename?: 'DriverSafetyAcknowledgementUpdatePayload';
  acknowledgement?: Maybe<DriverSafetyAcknowledgement>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userErrors: Array<UserError>;
};

/**
 * Error indicating that a mutation whose input requires a collection of unique
 * elements failed because the provided collection contained duplicates.
 */
export type DuplicateInputError = Error & {
  __typename?: 'DuplicateInputError';
  /** ID of duplicate element. */
  id: Scalars['ID']['output'];
  /** A description of the error. */
  message: Scalars['String']['output'];
};

export type DuplicateMasterHomepageInput = {
  endDate: Scalars['ISO8601Date']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  startDate: Scalars['ISO8601Date']['input'];
};

export type DuplicateMasterHomepagePayload = {
  __typename?: 'DuplicateMasterHomepagePayload';
  errors: Array<MasterHomepageError>;
  masterHomepage?: Maybe<MasterHomepageListItem>;
};

export enum EditPermissionForViewerEnum {
  /** Target's role is above what the viewer may edit */
  BlockedByRole = 'BLOCKED_BY_ROLE',
  /** Viewer may edit this user normally */
  Editable = 'EDITABLE',
  /** Target holds a location the viewer lacks */
  RestrictedLocation = 'RESTRICTED_LOCATION'
}

/** Error indicating the requested email address is already in use. */
export type EmailAlreadyTaken = Error & {
  __typename?: 'EmailAlreadyTaken';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

export type EmailValidationResult = {
  __typename?: 'EmailValidationResult';
  /** Error message if validation fails */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Whether the email is valid for signup */
  isValid: Scalars['Boolean']['output'];
};

/** Error indicating an empty cart caused an operation to fail. */
export type EmptyCartError = Error & {
  __typename?: 'EmptyCartError';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

export type EquipmentOrderLineInput = {
  /** The brand of the equipment ordered. */
  brand: Scalars['String']['input'];
  /** The model/name of the equipment ordered. */
  model: Scalars['String']['input'];
  /** The cost of the base machine */
  modelPriceCents: Scalars['Int']['input'];
  /** A list of model-specific option name, value pairs */
  options: Array<EquipmentOrderLineOptionInput>;
  /** The quantity ordered. */
  quantity: Scalars['Int']['input'];
  /** The subtotal cost of the quantity x machine with options */
  subtotalCents: Scalars['Int']['input'];
};

export type EquipmentOrderLineOptionInput = {
  /** The model-specific name of the option. */
  name: Scalars['String']['input'];
  /** The price of the selected suboption. */
  priceCents: Scalars['Int']['input'];
  /** The selected suboption for the option. */
  value: Scalars['String']['input'];
};

/** The name of the ERP platform. Currently only NetSuite is supported. */
export enum ErpPlatform {
  Netsuite = 'NETSUITE'
}

/** The name of an ERP record type, as understood by the ERP. */
export enum ErpRecord {
  Item = 'ITEM',
  SalesOrder = 'SALES_ORDER'
}

/** Error. */
export type Error = {
  /** A description of the error. */
  message: Scalars['String']['output'];
};

export type ErrorUpdatingItemPrices = Error & {
  __typename?: 'ErrorUpdatingItemPrices';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Collection of one or more errors. */
export type Errors = {
  __typename?: 'Errors';
  /** First error. */
  head: Error;
  /** List (possibly empty) of additional errors. */
  tail: Array<Error>;
};

/** Result of an operation that failed due to one or more errors. */
export type ErrorsResult = {
  __typename?: 'ErrorsResult';
  /** Non-empty collection of errors that occurred. */
  errors: Errors;
};

/** Autogenerated input type of EscalateStopsToProvider */
export type EscalateStopsToProviderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The night the stops are on, today or tomorrow. */
  nightEnd: Scalars['ISO8601Date']['input'];
  /** When the courier should collect. Omitted or null means ASAP at push time. */
  pickupAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** The provider to send the stops to. */
  provider: ThirdPartyProvider;
  /** The stops to escalate, 1 to 50. */
  stopIds: Array<Scalars['ID']['input']>;
  /** The warehouse the stops belong to. */
  warehouseId: Scalars['ID']['input'];
};

/** Autogenerated return type of EscalateStopsToProvider. */
export type EscalateStopsToProviderPayload = {
  __typename?: 'EscalateStopsToProviderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  route?: Maybe<Route>;
  userErrors: Array<ThirdPartyDispatchError>;
};

export type EtasStatus = {
  __typename?: 'EtasStatus';
  /** When the most recent usable ETA calculation ran. Null if none has run. */
  lastCalculatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The RoutificRun id of the most recent usable ETA calculation. Null if none has run. */
  lastCalculatedRunId?: Maybe<Scalars['ID']['output']>;
  /** Why the ETAs are stale. Null when not stale. */
  reason?: Maybe<EtasStatusReason>;
  /** True when the applied ETAs no longer reflect the current dispatched stop layout. */
  stale: Scalars['Boolean']['output'];
};

/** Why the plan's ETAs are considered stale. Drives the timeline warning copy. */
export enum EtasStatusReason {
  /** No usable etas_only run exists yet for this warehouse + night. */
  NeverCalculated = 'NEVER_CALCULATED',
  /** A reoptimize/re-sequence run happened after the last ETA calculation, so the applied ETAs predate it. */
  ReoptimizedSince = 'REOPTIMIZED_SINCE',
  /** Stops were moved (route reassignment or resequencing) after the last ETA calculation. */
  StopsMovedSince = 'STOPS_MOVED_SINCE'
}

export type ExpectedPurchaseOrder = {
  __typename?: 'ExpectedPurchaseOrder';
  /** PO due date, if any. */
  dueDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** PO transaction (order) date, if any. */
  orderDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** PO status from NetSuite. */
  status?: Maybe<Scalars['String']['output']>;
  /** PO number. */
  tranId: Scalars['String']['output'];
  /** Vendor/entity on the PO. */
  vendorName?: Maybe<Scalars['String']['output']>;
  /** Receiving warehouse. */
  warehouseName?: Maybe<Scalars['String']['output']>;
};

export type ExpectedTransferOrder = {
  __typename?: 'ExpectedTransferOrder';
  /** TO due date, if any. */
  dueDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** TO transaction (order) date, if any. */
  orderDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Source ("From") warehouse the transfer ships from. */
  originName?: Maybe<Scalars['String']['output']>;
  /** TO status from NetSuite. */
  status?: Maybe<Scalars['String']['output']>;
  /** TO number. */
  tranId: Scalars['String']['output'];
  /** Destination (receiving) warehouse. */
  warehouseName?: Maybe<Scalars['String']['output']>;
};

export type ExternalBaseBrandedItem = BaseBrandedItem & {
  __typename?: 'ExternalBaseBrandedItem';
  /** Colors that are available for the item */
  baseBrandedItemColors: Array<BaseBrandedItemColor>;
  /** Quantity ranges that differentiate price breaks for the item */
  baseBrandedItemQuantityRanges: Array<BaseBrandedItemQuantityRange>;
  baseColor?: Maybe<Color>;
  bottomLayerColor?: Maybe<Color>;
  /** Artwork options for the item */
  brandedItemArtworks: Array<BrandedItemArtwork>;
  category: Category;
  /** Price that we charge for delivery of this item */
  deliveryPrice: Money;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrls: Array<Scalars['String']['output']>;
  itemSizeLabel?: Maybe<Scalars['String']['output']>;
  materialType?: Maybe<Scalars['String']['output']>;
  maxOrderQty?: Maybe<Scalars['Int']['output']>;
  minOrderQty: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  printingMethod: PrintingMethod;
  procurementVendor: ProcurementVendor;
  purchaseMultiple: Scalars['Int']['output'];
  salesUnit: Unit;
  shape?: Maybe<Scalars['String']['output']>;
  subcategory: Category;
  variants: Array<ExternalBaseBrandedItemVariant>;
  wallType?: Maybe<Scalars['String']['output']>;
  /** Warehouses the item is available in */
  warehouseBaseBrandedItems: Array<WarehouseBaseBrandedItem>;
};

export type ExternalBaseBrandedItemVariant = {
  __typename?: 'ExternalBaseBrandedItemVariant';
  color?: Maybe<Color>;
  endQuantity?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** Price that we sell this variant of the item at */
  salesPrice: Money;
  /** One time cost to setup the item for the customer */
  setupFee: Money;
  startQuantity: Scalars['Int']['output'];
  warehouse: Warehouse;
};

export type ExternalBaseBrandedItemVariantInput = {
  /** Color that differentiates this variant */
  color?: InputMaybe<Scalars['ID']['input']>;
  /** Quantity range that differentiates price breaks for this variant */
  quantityRange: BaseBrandedItemQuantityRangeInput;
  salesPrice: MoneyInput;
  setupFee: MoneyInput;
  /** Warehouse that differentiates this variant */
  warehouse: Scalars['ID']['input'];
};

export type ExternalDelivery = {
  __typename?: 'ExternalDelivery';
  /** The number of containers used when packing the delivery */
  containerCount?: Maybe<Scalars['Int']['output']>;
  /** If present, the estimated time the delivery is expected to be delivered */
  estimatedDeliveryTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** If present, the estimated time the delivery will be picked up */
  estimatedPickupTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  trackingUrl?: Maybe<Scalars['String']['output']>;
};

export type ExternalSupplier = {
  __typename?: 'ExternalSupplier';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  odekoUuid: Scalars['ID']['output'];
};

/** The connection type for ExternalSupplier. */
export type ExternalSupplierConnection = {
  __typename?: 'ExternalSupplierConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ExternalSupplierEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ExternalSupplier>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ExternalSupplierEdge = {
  __typename?: 'ExternalSupplierEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ExternalSupplier>;
};

/** Kind of free-floating facility shape. */
export enum FacilityElementType {
  Arrow = 'ARROW',
  Dock = 'DOCK',
  Label = 'LABEL',
  Room = 'ROOM',
  Wall = 'WALL',
  Zone = 'ZONE'
}

/** Favorite consumer order. */
export type FavoriteConsumerOrder = Node & {
  __typename?: 'FavoriteConsumerOrder';
  /** Icon. */
  icon?: Maybe<Scalars['String']['output']>;
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID']['output'];
  /** Name. */
  name?: Maybe<Scalars['String']['output']>;
  /** Consumer order. */
  order: ConsumerOrder;
};

/** Favorite consumer order mutation result. */
export type FavoriteConsumerOrderResult = ErrorsResult | FavoriteConsumerOrderSuccess;

/** Result of a successful favorite consumer order mutation. */
export type FavoriteConsumerOrderSuccess = {
  __typename?: 'FavoriteConsumerOrderSuccess';
  /** Resulting favorite consumer order. */
  favoriteConsumerOrder: FavoriteConsumerOrder;
};

export type Fee = {
  __typename?: 'Fee';
  feeType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  odekoUuid: Scalars['ID']['output'];
  warehouseFeeAmountCents: Scalars['Int']['output'];
  warehouseFeeAmountPercent?: Maybe<Scalars['Float']['output']>;
  warehouseId: Scalars['ID']['output'];
};

export type FeeExemption = {
  __typename?: 'FeeExemption';
  fee: Fee;
  id: Scalars['ID']['output'];
};

export type FeeExemptionList = {
  __typename?: 'FeeExemptionList';
  fee: FeeInterface;
  id: Scalars['ID']['output'];
};

export type FeeInterface = {
  /** The threshold amount in cents at which the fee is applied. */
  feeThresholds: Array<FeeThreshold>;
  id: Scalars['ID']['output'];
  /** Indicates if the fee is active or not. */
  isActive: Scalars['Boolean']['output'];
  odekoUuid: Scalars['ID']['output'];
};

export type FeeThreshold = {
  __typename?: 'FeeThreshold';
  /** The amount of the fee in cents. */
  amountCents?: Maybe<Scalars['Int']['output']>;
  /** The percentage amount of the fee if applicable. */
  amountPercent?: Maybe<Scalars['Float']['output']>;
  /** The type of fee associated with this threshold. */
  feeType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The maximum order amount in cents at which the fee is applied. */
  maxOrderAmountCents: Scalars['Int']['output'];
  /** The minimum order amount in cents at which the fee is applied. */
  minOrderAmountCents: Scalars['Int']['output'];
  /** The type of fee threshold. */
  thresholdType?: Maybe<Scalars['String']['output']>;
};

export type FieldServiceZipcode = {
  __typename?: 'FieldServiceZipcode';
  id: Scalars['ID']['output'];
  /** The 5-digit zip code served for Field Service, e.g. "02134". */
  zipCode: Scalars['String']['output'];
};

export type FiltersArrayInput = {
  op: FiltersArrayOps;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export enum FiltersArrayOps {
  Contain = 'CONTAIN',
  Equal = 'EQUAL',
  NotContain = 'NOT_CONTAIN'
}

export type FiltersBooleanInput = {
  op: FiltersBooleanOps;
  value: Array<InputMaybe<Scalars['Boolean']['input']>>;
};

export enum FiltersBooleanOps {
  Equal = 'EQUAL',
  NotEqual = 'NOT_EQUAL'
}

export type FiltersCatalogStatusInput = {
  op: FiltersEnumOps;
  value: Array<InputMaybe<CatalogStatus>>;
};

export type FiltersDateInput = {
  op: FiltersNumberOps;
  value: Array<InputMaybe<Scalars['ISO8601DateTime']['input']>>;
};

export enum FiltersEnumOps {
  Contain = 'CONTAIN',
  Equal = 'EQUAL',
  NotContain = 'NOT_CONTAIN',
  NotEqual = 'NOT_EQUAL'
}

export type FiltersFloatInput = {
  op: FiltersNumberOps;
  value: Array<InputMaybe<Scalars['Float']['input']>>;
};

export type FiltersIntInput = {
  op: FiltersNumberOps;
  value: Array<InputMaybe<Scalars['Int']['input']>>;
};

export type FiltersInventoryCheckBehaviorInput = {
  op: FiltersEnumOps;
  value: Array<InputMaybe<InventoryCheckBehavior>>;
};

export type FiltersItemTagDisplayAsInput = {
  op: FiltersEnumOps;
  value: Array<InputMaybe<ItemTagDisplayAs>>;
};

export type FiltersItemTypeInput = {
  op: FiltersEnumOps;
  value: Array<InputMaybe<ItemType>>;
};

export type FiltersMoneyInput = {
  currency: Scalars['String']['input'];
  op: FiltersNumberOps;
  value: Array<InputMaybe<Scalars['Float']['input']>>;
};

export enum FiltersNumberOps {
  Contain = 'CONTAIN',
  Equal = 'EQUAL',
  GreaterThan = 'GREATER_THAN',
  GreaterThanEqual = 'GREATER_THAN_EQUAL',
  LessThan = 'LESS_THAN',
  LessThanEqual = 'LESS_THAN_EQUAL',
  NotContain = 'NOT_CONTAIN',
  NotEqual = 'NOT_EQUAL',
  Range = 'RANGE'
}

export type FiltersPerishabilityInput = {
  op: FiltersEnumOps;
  value: Array<InputMaybe<Perishability>>;
};

export type FiltersRefrigerationStateInput = {
  op: FiltersEnumOps;
  value: Array<InputMaybe<RefrigerationState>>;
};

export type FiltersStandingOrderBehaviorInput = {
  op: FiltersEnumOps;
  value: Array<InputMaybe<StandingOrderBehavior>>;
};

export type FiltersStringInput = {
  op: FiltersStringOps;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export enum FiltersStringOps {
  Contain = 'CONTAIN',
  Equal = 'EQUAL',
  GreaterThan = 'GREATER_THAN',
  GreaterThanEqual = 'GREATER_THAN_EQUAL',
  Ilike = 'ILIKE',
  LessThan = 'LESS_THAN',
  LessThanEqual = 'LESS_THAN_EQUAL',
  Like = 'LIKE',
  NotContain = 'NOT_CONTAIN',
  NotEqual = 'NOT_EQUAL'
}

export type FiltersTransitMethodInput = {
  op: FiltersEnumOps;
  value: Array<InputMaybe<TransitMethod>>;
};

export enum FinancialStatementEmailFrequencyTypeEnum {
  /** On every other Monday at 5:30 AM EST */
  Biweekly = 'BIWEEKLY',
  /** On the 1st day of every month at 5:30 AM EST */
  Monthly = 'MONTHLY',
  /** Never */
  Never = 'NEVER',
  /** On every Monday at 5:30 AM EST */
  Weekly = 'WEEKLY'
}

export type FinancialStatementPreferences = {
  __typename?: 'FinancialStatementPreferences';
  appliedToAllLocations: Scalars['Boolean']['output'];
  billingContactEmails: Array<Scalars['String']['output']>;
  emailFrequency: FinancialStatementEmailFrequencyTypeEnum;
};

export type FinancialTransaction = {
  id: Scalars['ID']['output'];
  platformRecordId: Scalars['ID']['output'];
  relatives: FinancialTransactionConnection;
  transactionDate: Scalars['ISO8601Date']['output'];
};

/** The connection type for FinancialTransaction. */
export type FinancialTransactionConnection = {
  __typename?: 'FinancialTransactionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FinancialTransactionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<FinancialTransaction>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** Date filter for FinancialTransactions using inclusive ranges. */
export type FinancialTransactionDateRangeInput = {
  /** Results from this date, inclusive. (YYYY-MM-DD) */
  from: Scalars['ISO8601Date']['input'];
  /** Results up to this date, inclusive. (YYYY-MM-DD) */
  to: Scalars['ISO8601Date']['input'];
};

/** An edge in a connection. */
export type FinancialTransactionEdge = {
  __typename?: 'FinancialTransactionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** Additional info about the meaning of this edge. */
  info: FinancialTransactionEdgeInfo;
  /** The item at the end of the edge. */
  node?: Maybe<FinancialTransaction>;
};

/** Info about a FinancialTransactionEdge. */
export type FinancialTransactionEdgeInfo = {
  _?: Maybe<Scalars['String']['output']>;
};

/** Set fleet composition possible errors */
export type FleetCompositionError = FleetCompositionNotEnabled | FleetCompositionWarehouseNotFound | InvalidFleetComposition;

export type FleetCompositionNotEnabled = UserErrorInterface & {
  __typename?: 'FleetCompositionNotEnabled';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type FleetCompositionWarehouseNotFound = UserErrorInterface & {
  __typename?: 'FleetCompositionWarehouseNotFound';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type FleetVehicle = {
  __typename?: 'FleetVehicle';
  /** Percent of this type's full capacity to route against. An integer 1–100, defaulting to 100. */
  capacityPercent: Scalars['Int']['output'];
  /** How many trucks of this type the warehouse routes with */
  count: Scalars['Int']['output'];
  /** Per-truck volume capacity, in cubic inches */
  maxVolume: Scalars['Int']['output'];
  /** Per-truck weight capacity, in pounds */
  maxWeight: Scalars['Int']['output'];
  /** The vehicle type, e.g. "Box Truck" */
  vehicleType: Scalars['String']['output'];
};

/**
 * One vehicle type in a warehouse's fleet: the type, how many trucks of it to
 * route with, and what percent of its capacity to fill.
 */
export type FleetVehicleInput = {
  /** Percent of this type's full capacity to route against. An integer 1–100, defaulting to 100. */
  capacityPercent?: InputMaybe<Scalars['Int']['input']>;
  /** How many trucks of this type the warehouse routes with. A non-negative integer. */
  count: Scalars['Int']['input'];
  /** The vehicle type, e.g. "Box Truck". Must be one of the warehouse's vehicle types. */
  vehicleType: Scalars['String']['input'];
};

export enum FreightType {
  /** Full Truckload — a hard appointment; >15 min late is a work-in ($100 fee). */
  Ftl = 'FTL',
  /** Less Than Truckload — a 3-hour delivery window. */
  Ltl = 'LTL',
  /** Other — a fixed 2-hour delivery window. */
  Other = 'OTHER'
}

export type FuelSurcharge = FeeInterface & {
  __typename?: 'FuelSurcharge';
  /** The threshold amount in cents at which the fee is applied. */
  feeThresholds: Array<FeeThreshold>;
  id: Scalars['ID']['output'];
  /** Indicates if the fee is active or not. */
  isActive: Scalars['Boolean']['output'];
  odekoUuid: Scalars['ID']['output'];
  /** The amount of the fuel surcharge fee in cents. */
  warehouseFeeAmountCents: Scalars['Int']['output'];
  /** Unique identifier of the warehouse associated with this fuel surcharge fee. */
  warehouseId: Scalars['ID']['output'];
};

export type FulfillmentWarehouse = {
  __typename?: 'FulfillmentWarehouse';
  distanceFromLocation?: Maybe<Scalars['Float']['output']>;
  estimatedNextShippingDeliveryRange?: Maybe<ShippingEstimateDeliveryRange>;
  warehouse: Warehouse;
};

/** The fund application exclusion state to set for one location. */
export type FundApplicationExclusionInput = {
  /** Whether the location is excluded from automatic fund application. */
  excluded: Scalars['Boolean']['input'];
  /** The location's odeko UUID, as federated on Location.id. */
  locationId: Scalars['ID']['input'];
};

/** A game that can have leaderboards */
export type Game = {
  __typename?: 'Game';
  /** Whether the game is active */
  active: Scalars['Boolean']['output'];
  /** Active leaderboards for this game */
  activeLeaderboards: Array<Leaderboard>;
  /** When the game was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description of the game */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the game */
  id: Scalars['ID']['output'];
  /** Leaderboards for this game */
  leaderboards: Array<Leaderboard>;
  /** Additional game metadata */
  metadata: Scalars['JSON']['output'];
  /** Name of the game */
  name: Scalars['String']['output'];
  /** URL-friendly identifier */
  slug: Scalars['String']['output'];
  /** When the game was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type GenerateItemDescriptionInput = {
  brandName?: InputMaybe<Scalars['String']['input']>;
  existingDescription?: InputMaybe<Scalars['String']['input']>;
  itemName: Scalars['String']['input'];
  upcCode?: InputMaybe<Scalars['String']['input']>;
  userInstructions?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateItemDescriptionResult = {
  __typename?: 'GenerateItemDescriptionResult';
  description?: Maybe<Scalars['String']['output']>;
  /** When success=false: error description. When success=true: optional informational message. */
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of GenerateOrderQuantitiesMutation */
export type GenerateOrderQuantitiesMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** PROTOTYPE for record keeping, a nominal delivery date to record. */
  minimalDeliveryDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** PROTOTYPE id of the LocationStockCount session to use. */
  stockCountId: Scalars['ID']['input'];
};

/** Autogenerated return type of GenerateOrderQuantitiesMutation. */
export type GenerateOrderQuantitiesMutationPayload = {
  __typename?: 'GenerateOrderQuantitiesMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  /** PROTOTYPE the quantities generated. */
  generatedOrderQuantities: Array<GeneratedOrderQuantity>;
};

/** Autogenerated input type of GeneratePresignedUrlMutation */
export type GeneratePresignedUrlMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of GeneratePresignedUrlMutation. */
export type GeneratePresignedUrlMutationPayload = {
  __typename?: 'GeneratePresignedUrlMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  objectKey?: Maybe<Scalars['String']['output']>;
  presignedReadUrl?: Maybe<Scalars['String']['output']>;
  presignedUrl?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of GenerateUploadSignature */
export type GenerateUploadSignatureInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the microsite location this media belongs to */
  micrositeLocationId: Scalars['ID']['input'];
};

/** Autogenerated return type of GenerateUploadSignature. */
export type GenerateUploadSignaturePayload = {
  __typename?: 'GenerateUploadSignaturePayload';
  /** Comma-separated list of allowed file formats */
  allowedFormats: Scalars['String']['output'];
  /** Cloudinary API key */
  apiKey: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Cloudinary cloud name */
  cloudName: Scalars['String']['output'];
  /** Target folder path in Cloudinary */
  folder: Scalars['String']['output'];
  /** The signature for authenticated upload */
  signature: Scalars['String']['output'];
  /** Unix timestamp used in signature */
  timestamp: Scalars['Int']['output'];
};

/** PROTOTYPE GeneratedOrderQuantity representation */
export type GeneratedOrderQuantity = {
  __typename?: 'GeneratedOrderQuantity';
  /** PROTOTYPE the counting event from which this generated order quantity was derived. */
  countingEvent: CurrentCount;
  /** PROTOTYPE a user identifier for the user responsible for generating the order. Likely an Auth0 ID. */
  generatedBy?: Maybe<Scalars['String']['output']>;
  /** PROTOTYPE id of the GeneratedOrderQuantity. */
  id: Scalars['ID']['output'];
  /**
   * PROTOTYPE if supplied for record keeping at time of creation, the minimum
   * delivery date of the order in which the generated quantity may be used.
   */
  minimumDeliveryDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** PROTOTYPE the Odeko UUID the reified order. */
  orderId?: Maybe<Scalars['ID']['output']>;
  /** PROTOTYPE the Odeko UUID the reified order line. */
  orderLineId?: Maybe<Scalars['ID']['output']>;
  /** PROTOTYPE the quantity of the reified order. */
  orderedQuantity?: Maybe<Scalars['Float']['output']>;
  /** PROTOTYPE the the LocationItem's par value at the time this quantity was generated. */
  parValue: Scalars['Float']['output'];
  /** PROTOTYPE the quantity to order in the sales unit recorded at the time of genreation. */
  quantity: Scalars['Float']['output'];
  /** PROTOTYPE the sales unit for the quantity. */
  salesUnitId: Scalars['ID']['output'];
  /** PROTOTYPE sku_id of the quantity was generated for. */
  skuId: Scalars['ID']['output'];
};

/** Geographic coordinates */
export type GeographicCoordinates = {
  /** Latitude */
  latitude: Scalars['Float']['input'];
  /** Longitude */
  longitude: Scalars['Float']['input'];
};

/** Circular geospatial region */
export type GeospatialCircle = {
  /** Center point */
  center: GeographicCoordinates;
  /** Radius, in miles */
  radius: Scalars['Int']['input'];
};

/** Interface to information for a Google Place. The interface is based on business-portal's GooglePlaceDetails wrapper library. */
export type GooglePlace = {
  __typename?: 'GooglePlace';
  addressLine1: Scalars['String']['output'];
  addressLine2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  placeId: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

/** A guest player profile */
export type GuestProfile = {
  __typename?: 'GuestProfile';
  /** When the profile was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Unique identifier for the profile */
  id: Scalars['ID']['output'];
  /** Leaderboard entries for this guest */
  leaderboardEntries: Array<LeaderboardEntry>;
  /** When the profile was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Display name for the player */
  username: Scalars['String']['output'];
};

export enum HomepageCollectionComponentType {
  CollectionBanner = 'COLLECTION_BANNER',
  CollectionCarousel = 'COLLECTION_CAROUSEL',
  CollectionHighlightCarousel = 'COLLECTION_HIGHLIGHT_CAROUSEL',
  CollectionPromoPage = 'COLLECTION_PROMO_PAGE'
}

export type HomepageComponentError = {
  __typename?: 'HomepageComponentError';
  code?: Maybe<Scalars['String']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type HomepageDisplayRuleError = {
  __typename?: 'HomepageDisplayRuleError';
  code?: Maybe<Scalars['String']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type HomepageDisplayRuleUpsertInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  ruleId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  warehouseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type HourOfDayQrScanCount = {
  __typename?: 'HourOfDayQrScanCount';
  /** Hour of day (0 to 23) */
  hourOfDay: Scalars['Int']['output'];
  /** Total number of scans that occurred during this hour of day. */
  scanCount: Scalars['Int']['output'];
};

export type HubspotLead = {
  __typename?: 'HubspotLead';
  id: Scalars['ID']['output'];
  isClosed?: Maybe<Scalars['Boolean']['output']>;
  leadName?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['String']['output']>;
  stage?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ImportPriceRulesCsv */
export type ImportPriceRulesCsvInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Uploaded CSV parsed to a comma-separated string (with newlines) */
  csvContents: Scalars['String']['input'];
};

/** Autogenerated return type of ImportPriceRulesCsv. */
export type ImportPriceRulesCsvPayload = {
  __typename?: 'ImportPriceRulesCsvPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors that occured during the CSV upload */
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

export type ImportProcurementInput = {
  itemId: Scalars['ID']['input'];
  procurementVendorId: Scalars['ID']['input'];
  purchasePrice?: InputMaybe<MoneyInput>;
  warehouseId: Scalars['ID']['input'];
};

export type ImpressionBreakdown = {
  __typename?: 'ImpressionBreakdown';
  desktopMaps: Scalars['Int']['output'];
  desktopSearch: Scalars['Int']['output'];
  mobileMaps: Scalars['Int']['output'];
  mobileSearch: Scalars['Int']['output'];
};

export type InHouseBaseBrandedItem = BaseBrandedItem & {
  __typename?: 'InHouseBaseBrandedItem';
  /** Colors that are available for the item */
  baseBrandedItemColors: Array<BaseBrandedItemColor>;
  /** Quantity ranges that differentiate price breaks for the item */
  baseBrandedItemQuantityRanges: Array<BaseBrandedItemQuantityRange>;
  baseColor?: Maybe<Color>;
  bottomLayerColor?: Maybe<Color>;
  /** Artwork options for the item */
  brandedItemArtworks: Array<BrandedItemArtwork>;
  category: Category;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrls: Array<Scalars['String']['output']>;
  itemSizeLabel?: Maybe<Scalars['String']['output']>;
  materialType?: Maybe<Scalars['String']['output']>;
  maxOrderQty?: Maybe<Scalars['Int']['output']>;
  minOrderQty: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  printingMethod: PrintingMethod;
  purchaseMultiple: Scalars['Int']['output'];
  salesUnit: Unit;
  shape?: Maybe<Scalars['String']['output']>;
  subcategory: Category;
  supplyItem: SupplyItem;
  /** The enabled variants for this item */
  variants: Array<InHouseBaseBrandedItemVariant>;
  wallType?: Maybe<Scalars['String']['output']>;
  /** Warehouses the item is available in */
  warehouseBaseBrandedItems: Array<WarehouseBaseBrandedItem>;
};

export type InHouseBaseBrandedItemVariant = {
  __typename?: 'InHouseBaseBrandedItemVariant';
  id: Scalars['ID']['output'];
  salesPrice: Money;
  warehouse: Warehouse;
};

export type InHouseBaseBrandedItemVariantInput = {
  salesPrice: MoneyInput;
  /** Warehouse that differentiates this variant */
  warehouse: Scalars['ID']['input'];
};

export type InProgressCustomer = {
  __typename?: 'InProgressCustomer';
  acquisitionConversion: Scalars['String']['output'];
  /** The foreign key to the customer in the system belonging to the Acquisiton Conversion, also known as the M&A Source. */
  acquisitionConversionId?: Maybe<Scalars['String']['output']>;
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  adminDistrictLevel1?: Maybe<Scalars['String']['output']>;
  /** The run that last picked this record up, if any. */
  batchOnboardRun?: Maybe<BatchOnboardRun>;
  companyName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** reference to the file and row of the CustomerCsvUpload */
  customerCsvUpload: CustomerCsvUpload;
  /** zero-based row number from which this record was generated. The first row after the csv header is row zero. */
  customerCsvUploadRow: Scalars['Int']['output'];
  customerType?: Maybe<InProgressCustomerCustomer>;
  duplicateLocations: Array<Location>;
  existingCompany?: Maybe<Company>;
  existingLocation?: Maybe<Location>;
  existingUser?: Maybe<User>;
  fullAddress?: Maybe<Scalars['String']['output']>;
  googlePlace?: Maybe<GooglePlace>;
  /** AUTOMATION when google_place was set by a job, or a user id if the google_place_id was set by an admin. */
  googlePlaceSetBy?: Maybe<Scalars['String']['output']>;
  /**
   * A ready record carrying an error from its last attempt. An acquisition drain
   * skips it until it is fixed or explicitly re-selected.
   */
  hasOnboardingError: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Onboarding for longer than the staleness window: its job died. Not retried automatically. */
  isStuck: Scalars['Boolean']['output'];
  /**
   * If an error occurred during asynchronous onboarding, and the status of this
   * record is not COMPLETE, the object representing the latest reported error.
   */
  latestOnboardingError?: Maybe<InProgressCustomerOnboardingError>;
  locality?: Maybe<Scalars['String']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  /** When present, indicates one or more issues need addressing before the InProgressCustomer can start to be onboarded. */
  notReadyReasons?: Maybe<InProgressCustomerNotReadyReasons>;
  /** The company and user information from the CSV (eg from the first paper_trail version of the record. */
  originalInfo?: Maybe<InProgressCustomerOriginalInfo>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  shippingWarehouse?: Maybe<Warehouse>;
  status: InProgressCustomerStatus;
  terms?: Maybe<Scalars['Int']['output']>;
  /** A unique identifier for the InProgressCustomer. */
  uniqueId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userEmail?: Maybe<Scalars['String']['output']>;
  userFirstName?: Maybe<Scalars['String']['output']>;
  userFullName?: Maybe<Scalars['String']['output']>;
  userLastName?: Maybe<Scalars['String']['output']>;
  userRole?: Maybe<Scalars['String']['output']>;
};

/**
 * Where one acquisition's in-progress customers stand right now, and the rows
 * behind the two CSVs Ops reconciles against their master list.
 */
export type InProgressCustomerAcquisitionSummary = {
  __typename?: 'InProgressCustomerAcquisitionSummary';
  /** The run in progress, if any. */
  activeRun?: Maybe<BatchOnboardRun>;
  completeCount: Scalars['Int']['output'];
  /** Ready records an acquisition drain would pick up: no unresolved error. */
  eligibleCount: Scalars['Int']['output'];
  /** Every completed record, unpaginated, for the CSV Ops reconciles against their master list. */
  exportCompleted: Array<CompletedOnboardingRow>;
  /** Every record still ready, with its error where there is one. Unpaginated, for the companion CSV. */
  exportOutstanding: Array<OutstandingOnboardingRow>;
  /** Ready records carrying an error from their last attempt. */
  failedCount: Scalars['Int']['output'];
  /** Still in review; not yet ready. */
  inProgressCount: Scalars['Int']['output'];
  /** The most recently finished run. */
  lastRun?: Maybe<BatchOnboardRun>;
  /** Being worked right now. */
  onboardingCount: Scalars['Int']['output'];
  /** Eligible records the active run has picked up but not yet worked. */
  queuedCount: Scalars['Int']['output'];
  /** Onboarding past the staleness window: the job died. Needs a human. */
  stuckCount: Scalars['Int']['output'];
};

/** The connection type for InProgressCustomer. */
export type InProgressCustomerConnection = {
  __typename?: 'InProgressCustomerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InProgressCustomerEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<InProgressCustomer>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of records in the connection. */
  totalCount: Scalars['Int']['output'];
};

export enum InProgressCustomerCustomer {
  LocalDelivery = 'LOCAL_DELIVERY',
  PickUp = 'PICK_UP',
  Shipping = 'SHIPPING'
}

/** An edge in a connection. */
export type InProgressCustomerEdge = {
  __typename?: 'InProgressCustomerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<InProgressCustomer>;
};

/** Set of available fields to update to help complete an InProgressCustomer. */
export type InProgressCustomerInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  customerType?: InputMaybe<InProgressCustomerCustomer>;
  existingCompanyUuid?: InputMaybe<Scalars['String']['input']>;
  existingLocationUuid?: InputMaybe<Scalars['String']['input']>;
  existingUserUuid?: InputMaybe<Scalars['String']['input']>;
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  locationName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** When customer_type is shipping, set the shipping warehouse. */
  shippingWarehouseId?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<Scalars['Int']['input']>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userFirstName?: InputMaybe<Scalars['String']['input']>;
  userFullName?: InputMaybe<Scalars['String']['input']>;
  userLastName?: InputMaybe<Scalars['String']['input']>;
  userRole?: InputMaybe<Scalars['String']['input']>;
};

export type InProgressCustomerNotReadyReasons = {
  __typename?: 'InProgressCustomerNotReadyReasons';
  company?: Maybe<Scalars['String']['output']>;
  customerType?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['String']['output']>;
  userEmail?: Maybe<Scalars['String']['output']>;
  userFirstName?: Maybe<Scalars['String']['output']>;
  userLastName?: Maybe<Scalars['String']['output']>;
  userRole?: Maybe<Scalars['String']['output']>;
};

/** The time (created_at) and reason that an attempt to (asynchronously) onboard an InProgressCustomer failed. */
export type InProgressCustomerOnboardingError = {
  __typename?: 'InProgressCustomerOnboardingError';
  createdAt: Scalars['ISO8601DateTime']['output'];
  reason: Scalars['String']['output'];
};

export type InProgressCustomerOriginalInfo = {
  __typename?: 'InProgressCustomerOriginalInfo';
  companyName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  userEmail?: Maybe<Scalars['String']['output']>;
  userFirstName?: Maybe<Scalars['String']['output']>;
  userLastName?: Maybe<Scalars['String']['output']>;
  userRole?: Maybe<Scalars['String']['output']>;
};

export enum InProgressCustomerStatus {
  /** Onboarding is complete. */
  Complete = 'COMPLETE',
  /** More information is needed in order to start onboarding the InProgressCustomer. */
  InProgress = 'IN_PROGRESS',
  /** The InProgressCustomer is in the process of being onboarded (asynchronously, ususally). */
  Onboarding = 'ONBOARDING',
  /** All needed needed information is present to start onboarding the InProgressCustomer. */
  Ready = 'READY'
}

/** Filters for search for InProgressCustomers */
export type InProgressCustomersSearchInput = {
  acquisitionConversion?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Search by company name, address, or unique_id */
  searchString?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InProgressCustomerStatus>>;
};

export enum IngredientTypeEnum {
  CustomIngredient = 'CustomIngredient',
  ItemIngredient = 'ItemIngredient'
}

/** Autogenerated input type of InitializeMarketingToolsSignupMutation */
export type InitializeMarketingToolsSignupMutationInput = {
  /** Business name from Google Places (optional) */
  businessName?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Context for the subscription session (defaults to 'signup') */
  context?: InputMaybe<Scalars['String']['input']>;
  /** User email address (can be provided later via update) */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Google Location name for linking to existing GoogleLocation */
  googleLocationName?: InputMaybe<Scalars['String']['input']>;
  /** Google Places API place ID */
  googlePlaceId: Scalars['String']['input'];
  /** Optional pricing package ID (1, 2, 3, etc.) */
  pricingPackageId?: InputMaybe<Scalars['Int']['input']>;
  /** Frontend origin URL for return navigation */
  returnOrigin: Scalars['String']['input'];
  /** Physical sign color preference (optional) */
  signColor?: InputMaybe<Scalars['String']['input']>;
  /** Physical sign material preference (optional if kit not purchased) */
  signMaterial?: InputMaybe<Scalars['String']['input']>;
  /** URL-friendly slug for microsite */
  urlSlug: Scalars['String']['input'];
};

/** Autogenerated return type of InitializeMarketingToolsSignupMutation. */
export type InitializeMarketingToolsSignupMutationPayload = {
  __typename?: 'InitializeMarketingToolsSignupMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']['output']>;
  /** Created subscription session */
  subscriptionSession?: Maybe<SubscriptionSession>;
};

/** Autogenerated input type of InitiateTerminalPairingMutation */
export type InitiateTerminalPairingMutationInput = {
  /** Account profile ID (external profile_id) */
  accountProfileId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Square location ID. If omitted, auto-selects when account has one active location */
  locationId?: InputMaybe<Scalars['ID']['input']>;
  /** Optional name for the terminal */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of InitiateTerminalPairingMutation. */
export type InitiateTerminalPairingMutationPayload = {
  __typename?: 'InitiateTerminalPairingMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The device code for pairing */
  deviceCode?: Maybe<SquareDeviceCode>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']['output']>;
};

/** Range of Ints */
export type IntRangeInput = {
  /** Lower bound (inclusive) of the range */
  lowerBound?: InputMaybe<Scalars['Int']['input']>;
  /** Upper bound of the range */
  upperBound?: InputMaybe<Scalars['Int']['input']>;
  /** Whether upper bound is included in the range */
  upperInclusive: Scalars['Boolean']['input'];
};

export type InternalDeliveryInstructions = {
  __typename?: 'InternalDeliveryInstructions';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  imageKeys?: Maybe<Array<Scalars['String']['output']>>;
  imageUrls?: Maybe<Array<Scalars['String']['output']>>;
  location: Location;
  note?: Maybe<Scalars['String']['output']>;
  /** Opaque ID for translating this instruction */
  translationId: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** A warehouse bin interpreted from its name plus the structured NetSuite columns. */
export type InterpretedBin = {
  __typename?: 'InterpretedBin';
  aisle?: Maybe<Scalars['String']['output']>;
  bay?: Maybe<Scalars['Int']['output']>;
  bulkBin?: Maybe<Scalars['Boolean']['output']>;
  family: BinFamily;
  fullPalletPosition?: Maybe<Scalars['Boolean']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  netsuiteInternalId: Scalars['String']['output'];
  section?: Maybe<Scalars['Int']['output']>;
  /** From the temperature_name column, never parsed from the name. */
  temperature?: Maybe<Scalars['String']['output']>;
};

/** Error indicating a provided cart input value was invalid. */
export type InvalidCartInputError = Error & {
  __typename?: 'InvalidCartInputError';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Error indicating invalid config attributes */
export type InvalidConfigError = {
  __typename?: 'InvalidConfigError';
  /** The specific errors */
  errors: Array<UserError>;
};

export type InvalidDeliveredQuantity = UserErrorInterface & {
  __typename?: 'InvalidDeliveredQuantity';
  /** The delivered_quantity value the client tried to write. */
  attempted: Scalars['Int']['output'];
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** The order line whose delivered_quantity write was rejected. */
  orderLineId: Scalars['ID']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type InvalidFleetComposition = UserErrorInterface & {
  __typename?: 'InvalidFleetComposition';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type InvalidFulfillmentQuantity = UserErrorInterface & {
  __typename?: 'InvalidFulfillmentQuantity';
  /** The fulfillment_quantity value the client tried to write. */
  attempted: Scalars['Int']['output'];
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** The order line whose fulfillment_quantity write was rejected. */
  orderLineId: Scalars['ID']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type InvalidHeaderReasonCode = UserErrorInterface & {
  __typename?: 'InvalidHeaderReasonCode';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type InvalidNightEnd = UserErrorInterface & {
  __typename?: 'InvalidNightEnd';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type InvalidParameterOverrides = UserErrorInterface & {
  __typename?: 'InvalidParameterOverrides';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type InvalidRules = UserErrorInterface & {
  __typename?: 'InvalidRules';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type InvalidShift = UserErrorInterface & {
  __typename?: 'InvalidShift';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type InvalidStopTypeForHeaderReason = UserErrorInterface & {
  __typename?: 'InvalidStopTypeForHeaderReason';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type InvalidSubReasonForReasonCode = UserErrorInterface & {
  __typename?: 'InvalidSubReasonForReasonCode';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export enum InventoryCheckBehavior {
  Check = 'CHECK',
  Skip = 'SKIP'
}

/** PROTOTYPE describes a skus inventory information. */
export type InventoryInfo = {
  __typename?: 'InventoryInfo';
  /**
   * PROTOTYPE If blank, the par value is counted in Odeko sales units. If present,
   * the par value is counted in this counting unit.
   */
  countingUnit?: Maybe<LocationCountingUnit>;
  /** PROTOTYPE ideal stock level, in counting units or sales units, for the Cafe location after ordering. */
  parValue: Scalars['Float']['output'];
  /** PROTOTYPE where the sku's stock is stored in the Cafe location. */
  storageArea?: Maybe<LocationStorageArea>;
};

/** Extension of InventoryItem type to include associated ERP Reference fields */
export type InventoryItem = SupplyItem & {
  __typename?: 'InventoryItem';
  /**
   * The item's scannable barcodes from RF-SMART, each carrying the pack level it identifies.
   * A barcode with no unit is still scannable but cannot name a quantity unit.
   */
  barcodes: Array<ItemBarcode>;
  brand?: Maybe<ItemBrand>;
  /** @deprecated Use brand */
  brandName: Scalars['String']['output'];
  /** (Package Height x Package Width x Package Length)/DIM factor */
  caseDimensionalWeightLbs?: Maybe<Scalars['Float']['output']>;
  caseHeightInches?: Maybe<Scalars['Float']['output']>;
  caseLengthInches?: Maybe<Scalars['Float']['output']>;
  caseVolumeCuInches?: Maybe<Scalars['Float']['output']>;
  caseWeightLbs?: Maybe<Scalars['Float']['output']>;
  caseWidthInches?: Maybe<Scalars['Float']['output']>;
  casesPerLayer?: Maybe<Scalars['Int']['output']>;
  casesPerPallet?: Maybe<Scalars['Int']['output']>;
  catalogStatus: CatalogStatus;
  category: Category;
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Drives pricing with carriers like FedEx.
   * This data is uploaded from Cubiscan dimensioning device to optimize shipping costs.
   */
  dimensionalFactor?: Maybe<Scalars['Float']['output']>;
  dimensioned?: Maybe<Scalars['Boolean']['output']>;
  /** (Package Height x Package Width x Package Length)/DIM factor */
  eachDimensionalWeightLbs?: Maybe<Scalars['Float']['output']>;
  eachHeightInches?: Maybe<Scalars['Float']['output']>;
  eachLengthInches?: Maybe<Scalars['Float']['output']>;
  eachVolumeCuInches?: Maybe<Scalars['Float']['output']>;
  eachWeightLbs?: Maybe<Scalars['Float']['output']>;
  eachWidthInches?: Maybe<Scalars['Float']['output']>;
  erpPlatform?: Maybe<ErpPlatform>;
  erpRecordId?: Maybe<Scalars['ID']['output']>;
  erpRecordType?: Maybe<ErpRecord>;
  erpRecordUrl?: Maybe<Scalars['String']['output']>;
  /** Denotes if the item should be included in the picking labels or not. */
  excludedFromPickingLabels: Scalars['Boolean']['output'];
  /** True if the item has its own image. When false and imgUrl is present, the image is a fallback from the category icon. */
  hasOwnImage: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  imgUrl?: Maybe<Scalars['String']['output']>;
  inactivatedOn?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * The product-level out-of-stock-check setting. Read `inventoryCheckBehavior` on the warehouse
   * association instead, at all times: this value is not market-scoped, so once any market is
   * given a setting of its own it stops answering for that market.
   */
  inventoryCheckBehavior?: Maybe<InventoryCheckBehavior>;
  isSerialized: Scalars['Boolean']['output'];
  /**
   * True when a shipping location can't order this item: it is refrigerated or frozen, or its
   * category or subcategory is Pastry or Baked Goods.
   */
  isShippingRestricted: Scalars['Boolean']['output'];
  itemLocationsCustomPrice?: Maybe<Array<ItemLocationCustomPrice>>;
  /** @deprecated Use size */
  itemSize?: Maybe<Scalars['String']['output']>;
  layersPerPallet?: Maybe<Scalars['Int']['output']>;
  locationShelfLifeDays?: Maybe<Scalars['Int']['output']>;
  manufacturedType?: Maybe<ManufacturedType>;
  /** Whether this item uses market pricing (price set at fulfillment time) */
  marketPrice: Scalars['Boolean']['output'];
  /**
   * The most units, in the sale unit, that one location may order of this item across all its orders.
   * Null means no limit.
   */
  maxQuantityPerLocation?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  nmfc?: Maybe<Scalars['String']['output']>;
  palletWeightLbs?: Maybe<Scalars['Float']['output']>;
  perishability?: Maybe<Perishability>;
  /**
   * True when this item is currently a leading New Items pin — i.e. it won its slot in the resolved
   * result set. Reflects what shoppers see: an item filtered out of the result reads as not pinned.
   * Flag-gated; false when the new-item-pinning flag is off or the item isn't pinned.
   */
  pinned: Scalars['Boolean']['output'];
  /** The absolute carousel slot this item actually rendered at when pinned; null when not pinned. */
  pinnedPosition?: Maybe<Scalars['Int']['output']>;
  procurementRecords: Array<Procurement>;
  /**
   * Drives the storefront's "Sponsored" label. True for Algolia rule-promoted results and — behind the
   * new-item-pinning flag — for a sponsored New Items pin. A sponsored pin is distinguishable from an
   * Algolia promo by `pinned` (a sponsored pin is `promoted && pinned`).
   */
  promoted: Scalars['Boolean']['output'];
  purchasePrice: Money;
  purchaseUnit: Unit;
  refrigerationState?: Maybe<RefrigerationState>;
  saleUnit: Unit;
  /** The most of this item's sample one location may ever order. Null means no limit, or no sample. */
  sampleMaxQuantityPerLocation?: Maybe<Scalars['Int']['output']>;
  sampleUnit?: Maybe<Unit>;
  sampleUpcCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  shelfLifeDays?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<ItemSize>;
  /**
   * The product-level standing-order setting. Read `standingOrderBehavior` on the warehouse
   * association instead, at all times: this value is not market-scoped, so once any market is
   * given a setting of its own it stops answering for that market.
   */
  standingOrderBehavior: StandingOrderBehavior;
  stockUnit?: Maybe<Unit>;
  subcategory?: Maybe<Category>;
  /**
   * The item's curated substitution overrides (source-side), highest priority first. Procurement's
   * editable layer that ranks above the rule engine's dynamic recommendations.
   */
  substitutionOverrides: Array<SubstitutionOverride>;
  /**
   * Procurement preview of ranked substitutes for this item. With no `warehouseId`, ranks by
   * attribute/dietary match quality only (availability ignored) — the "are these good substitutes?"
   * view. With a `warehouseId`, returns the in-stock list a customer in that market would actually get.
   * Curated overrides rank first. Procurement surface — the customer path uses `InventoryWarehouseAssociation.substitutionCandidates`.
   */
  substitutionPreview: Array<SupplyItem>;
  tags: Array<ItemTag>;
  transitMethod?: Maybe<TransitMethod>;
  upcCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  vendorCode?: Maybe<Scalars['String']['output']>;
  warehouseAssociation?: Maybe<Array<Maybe<InventoryWarehouseAssociation>>>;
};


/** Extension of InventoryItem type to include associated ERP Reference fields */
export type InventoryItemSubstitutionPreviewArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};


/** Extension of InventoryItem type to include associated ERP Reference fields */
export type InventoryItemTagsArgs = {
  withDiscardedAt?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Extension of InventoryItem type to include associated ERP Reference fields */
export type InventoryItemWarehouseAssociationArgs = {
  filters?: InputMaybe<InventoryWarehouseAssociationFiltersInput>;
  warehouseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type InventoryItemInput = {
  brand?: InputMaybe<Scalars['ID']['input']>;
  brandName: Scalars['String']['input'];
  caseHeightInches?: InputMaybe<Scalars['Float']['input']>;
  caseLengthInches?: InputMaybe<Scalars['Float']['input']>;
  caseWeightLbs?: InputMaybe<Scalars['Float']['input']>;
  caseWidthInches?: InputMaybe<Scalars['Float']['input']>;
  casesPerLayer?: InputMaybe<Scalars['Int']['input']>;
  catalogStatus: CatalogStatus;
  category: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  dimensionalFactor?: InputMaybe<Scalars['Float']['input']>;
  dimensioned?: InputMaybe<Scalars['Boolean']['input']>;
  eachHeightInches?: InputMaybe<Scalars['Float']['input']>;
  eachLengthInches?: InputMaybe<Scalars['Float']['input']>;
  eachWeightLbs?: InputMaybe<Scalars['Float']['input']>;
  eachWidthInches?: InputMaybe<Scalars['Float']['input']>;
  imgUrl?: InputMaybe<Scalars['String']['input']>;
  inventoryCheckBehavior?: InputMaybe<InventoryCheckBehavior>;
  isSerialized?: InputMaybe<Scalars['Boolean']['input']>;
  itemSize?: InputMaybe<Scalars['String']['input']>;
  layersPerPallet?: InputMaybe<Scalars['Int']['input']>;
  locationShelfLifeDays?: InputMaybe<Scalars['Int']['input']>;
  marketPrice?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The most units, in the sale unit, that one location may order of this item across all its orders.
   * Omit to keep the current value; null removes the limit. At least 1.
   */
  maxQuantityPerLocation?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  nmfc?: InputMaybe<Scalars['String']['input']>;
  palletWeightLbs?: InputMaybe<Scalars['Float']['input']>;
  perishability?: InputMaybe<Perishability>;
  procurementRecords?: InputMaybe<Array<ProcurementInput>>;
  purchasePrice: MoneyInput;
  purchaseUnit: Scalars['ID']['input'];
  refrigerationState?: InputMaybe<RefrigerationState>;
  saleUnit: Scalars['ID']['input'];
  /**
   * The most of this item's sample one location may ever order. Omit to keep the current value; null
   * removes the limit. At least 1, and only with a sampleUnit.
   */
  sampleMaxQuantityPerLocation?: InputMaybe<Scalars['Int']['input']>;
  sampleUnit?: InputMaybe<Scalars['ID']['input']>;
  sampleUpcCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shelfLifeDays?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<SizeInput>;
  standingOrderBehavior: StandingOrderBehavior;
  stockUnit?: InputMaybe<Scalars['ID']['input']>;
  subcategory?: InputMaybe<Scalars['ID']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  transitMethod?: InputMaybe<TransitMethod>;
  upcCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vendorCode?: InputMaybe<Scalars['String']['input']>;
  warehouseAssociation?: InputMaybe<Array<InputMaybe<InventoryWarehouseAssociationInput>>>;
};

/** PROTOTYPE Inventory Service 2's notion of a 'Location Item'. NOTE: unrelated to IMS location items. */
export type InventoryLocationItem = {
  __typename?: 'InventoryLocationItem';
  /**
   * PROTOTYPE If blank, the par value is counted in Odeko sales units. If present,
   * the par value is counted in this counting unit.
   */
  countingUnit?: Maybe<LocationCountingUnit>;
  /** PROTOTYPE id of this object in inventory-service-2. */
  id: Scalars['ID']['output'];
  /** PROTOTYPE id of the item in inventory-service-2. */
  itemId: Scalars['ID']['output'];
  /** PROTOTYPE Odeko UUID of the associated location. */
  locationId: Scalars['ID']['output'];
  /** PROTOTYPE if the item is an Odeko Item, its IMS Item Id. */
  odekoItemId?: Maybe<Scalars['ID']['output']>;
  /** PROTOTYPE ideal stock level, in counting units or sales units, for the Cafe location after ordering. */
  parValue: Scalars['Float']['output'];
  /** PROTOTYPE if an Odeko Item, it's sku id from so-api. */
  skuId?: Maybe<Scalars['ID']['output']>;
  /** PROTOTYPE where the sku's stock is stored in the Cafe location. */
  storageArea?: Maybe<LocationStorageArea>;
};

/**
 * Inventory items are items we procure from some vendor and ship from our warehouse.
 * They are *stored* in the warehouse.
 */
export type InventoryWarehouseAssociation = {
  __typename?: 'InventoryWarehouseAssociation';
  configuredFulfillmentWarehouses: Array<ConfigureFulfillmentWarehouse>;
  /**
   * Wording authored for this product in this market, or null when nothing was authored and the
   * message is derived from `orderability`. Exposed so an editor can show and change what was written;
   * clients rendering a catalog want `orderabilityMessage` instead.
   */
  customOrderabilityMessage?: Maybe<Scalars['String']['output']>;
  /** True when the item has been continuously out of stock for 14+ days at this warehouse. */
  customerFacingOutOfStock: Scalars['Boolean']['output'];
  /**
   * Days the item has left in the 60-day "new" window at this warehouse; null once it has aged out.
   * Mirrors `isNew` (both derive from the item's activation date).
   */
  daysRemainingAsNew?: Maybe<Scalars['Int']['output']>;
  fulfillmentWarehouses: Array<FulfillmentWarehouse>;
  hasSample?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether the out-of-stock check runs for this product in this market, or is skipped. A market that
   * has not been given a value of its own carries the item-level field of the same name. Inventory
   * items only — a non-inventory product has no stock to check.
   */
  inventoryCheckBehavior: InventoryCheckBehavior;
  isNew: Scalars['Boolean']['output'];
  item: InventoryItem;
  landedCost?: Maybe<Money>;
  /**
   * Next available delivery date for this item from the location's own (home)
   * warehouse. Returns null when the association is for any other warehouse — e.g.
   * an item fulfilled from a different warehouse under global fulfillment — or
   * when the location is disabled.
   */
  nextDeliveryDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /**
   * Whether this product is ready to sell in this market. A product that is not orderable still appears
   * in the catalog — it simply cannot be added to an order.
   */
  orderability: Orderability;
  /**
   * Wording to show in place of add-to-cart, or null when the product can be ordered. Taken from
   * `customOrderabilityMessage` when one is authored, and otherwise derived from `orderability`, so
   * both ordering apps say the same thing and changing it needs no client release.
   */
  orderabilityMessage?: Maybe<Scalars['String']['output']>;
  /**
   * When the item first went out of stock at this warehouse.
   * Null if currently in stock or if OOS check is bypassed.
   */
  outOfStockSince?: Maybe<Scalars['ISO8601DateTime']['output']>;
  procurementVendor?: Maybe<ProcurementVendor>;
  salePrice?: Maybe<Money>;
  sample?: Maybe<SupplyItem>;
  /**
   * Whether this product can be ordered on a standing order in this market. A market that has not been
   * given a value of its own carries the item-level field of the same name.
   */
  standingOrderBehavior: StandingOrderBehavior;
  /**
   * Ranked substitute items for this item when it is out of stock at this warehouse, computed by the
   * IMS rule engine from catalog attributes, dietary tags, curated overrides, and the local
   * availability snapshot. The warehouse is this association's warehouse, so no argument is needed.
   * Ships dark behind a per-warehouse flag — returns an empty list when the engine is disabled here.
   *
   * Pass `requestedQuantity` — the quantity the customer is ordering — to return only substitutes the
   * warehouse holds enough of to cover the whole order line. Availability alone only means at least
   * one unit exists, which is not the same as being able to fill the order. Omit it and no quantity
   * rule is applied.
   */
  substitutionCandidates: Array<SupplyItem>;
  warehouse: Warehouse;
};


/**
 * Inventory items are items we procure from some vendor and ship from our warehouse.
 * They are *stored* in the warehouse.
 */
export type InventoryWarehouseAssociationFulfillmentWarehousesArgs = {
  locationUuid?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * Inventory items are items we procure from some vendor and ship from our warehouse.
 * They are *stored* in the warehouse.
 */
export type InventoryWarehouseAssociationNextDeliveryDateArgs = {
  locationId: Scalars['ID']['input'];
};


/**
 * Inventory items are items we procure from some vendor and ship from our warehouse.
 * They are *stored* in the warehouse.
 */
export type InventoryWarehouseAssociationSalePriceArgs = {
  locationMembershipStatusTier?: InputMaybe<PsLocationMembershipStatusTier>;
  locationMembershipTier?: InputMaybe<LocationMembershipTier>;
};


/**
 * Inventory items are items we procure from some vendor and ship from our warehouse.
 * They are *stored* in the warehouse.
 */
export type InventoryWarehouseAssociationSubstitutionCandidatesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  requestedQuantity?: InputMaybe<Scalars['Int']['input']>;
};

export type InventoryWarehouseAssociationFiltersInput = {
  procurementVendorId?: InputMaybe<FiltersStringInput>;
  warehouseId?: InputMaybe<FiltersStringInput>;
};

export type InventoryWarehouseAssociationInput = {
  configuredFulfillmentWarehouses?: InputMaybe<Array<ConfigureFulfillmentWarehouseInput>>;
  /** Wording to show instead of what `orderability` implies. Omit to leave unchanged; null to clear. */
  customOrderabilityMessage?: InputMaybe<Scalars['String']['input']>;
  hasSample?: InputMaybe<Scalars['Boolean']['input']>;
  /** Omit to leave unchanged. A market the product was not in before starts off, except on a product being created, where it takes the item-level field of the same name. */
  inventoryCheckBehavior?: InputMaybe<InventoryCheckBehavior>;
  /** Defaults to ORDERABLE when omitted; omit to leave an existing value unchanged. */
  orderability?: InputMaybe<Orderability>;
  procurementVendorId?: InputMaybe<Scalars['ID']['input']>;
  salePrice?: InputMaybe<MoneyInput>;
  /** Omit to leave unchanged. A market the product was not in before starts off, except on a product being created, where it takes the item-level field of the same name. */
  standingOrderBehavior?: InputMaybe<StandingOrderBehavior>;
  warehouseId: Scalars['ID']['input'];
};

export type InvoiceMatchCandidate = {
  __typename?: 'InvoiceMatchCandidate';
  item: SupplyItem;
};

export type InvoiceMatchCandidatesInput = {
  identifiers?: InputMaybe<Array<InvoiceMatchIdentifierInput>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchQuery: Scalars['String']['input'];
  warehouseId: Scalars['ID']['input'];
};

export type InvoiceMatchCandidatesResult = {
  __typename?: 'InvoiceMatchCandidatesResult';
  candidates: Array<InvoiceMatchCandidate>;
};

export type InvoiceMatchIdentifierInput = {
  type?: InputMaybe<InvoiceMatchIdentifierType>;
  value: Scalars['String']['input'];
};

export enum InvoiceMatchIdentifierType {
  Sku = 'SKU',
  Unknown = 'UNKNOWN',
  Upc = 'UPC'
}

export type IsPastWarehouseCutOffTimeInput = {
  dateTime: Scalars['ISO8601DateTime']['input'];
  warehouseId: Scalars['ID']['input'];
};

export type IsRoutesSyncEnabledInput = {
  nightEnd: Scalars['ISO8601Date']['input'];
  warehouseId: Scalars['ID']['input'];
};

export type Issue = {
  __typename?: 'Issue';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ItemBarcode = {
  __typename?: 'ItemBarcode';
  code: Scalars['String']['output'];
  packLevel: ItemBarcodePackLevel;
  unit?: Maybe<Unit>;
};

export type ItemBarcodeMatch = {
  __typename?: 'ItemBarcodeMatch';
  barcode: ItemBarcode;
  item: InventoryItem;
};

export enum ItemBarcodePackLevel {
  Case = 'CASE',
  Each = 'EACH',
  Pallet = 'PALLET',
  Unknown = 'UNKNOWN'
}

export type ItemBrand = {
  __typename?: 'ItemBrand';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ItemBrandConnection = {
  __typename?: 'ItemBrandConnection';
  edges: Array<Maybe<ItemBrandEdge>>;
  nodes: Array<Maybe<ItemBrand>>;
  pageInfo: PageInfo;
};

export type ItemBrandCreateInput = {
  name: Scalars['String']['input'];
};

export type ItemBrandCreatePayload = {
  __typename?: 'ItemBrandCreatePayload';
  created: Scalars['Boolean']['output'];
  errors: Array<ItemBrandError>;
  itemBrand?: Maybe<ItemBrand>;
};

export type ItemBrandDeleteInput = {
  id: Scalars['ID']['input'];
};

export type ItemBrandDeletePayload = {
  __typename?: 'ItemBrandDeletePayload';
  errors: Array<ItemBrandError>;
};

export type ItemBrandEdge = {
  __typename?: 'ItemBrandEdge';
  cursor: Scalars['String']['output'];
  node: ItemBrand;
};

export type ItemBrandError = {
  __typename?: 'ItemBrandError';
  message: Scalars['String']['output'];
};

export type ItemBrandUpdateInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type ItemBrandUpdatePayload = {
  __typename?: 'ItemBrandUpdatePayload';
  errors: Array<ItemBrandError>;
  itemBrand?: Maybe<ItemBrand>;
};

export type ItemBrandsFiltersInput = {
  id?: InputMaybe<FiltersStringInput>;
  name?: InputMaybe<FiltersStringInput>;
};

export enum ItemBrandsSortOrder {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

/** Relay-style cursor-based pagination structure for Categories */
export type ItemConnection = {
  __typename?: 'ItemConnection';
  edges: Array<Maybe<ItemEdge>>;
  nodes: Array<Maybe<SupplyItem>>;
  pageInfo: PageInfo;
  /**
   * Algolia query identifier for tracking search analytics.
   * Required for sending click and conversion events to Algolia Insights.
   * Null for non-Algolia searches.
   */
  queryID?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type ItemDeliveryInstructions = {
  __typename?: 'ItemDeliveryInstructions';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  imageKeys?: Maybe<Array<Scalars['String']['output']>>;
  imageUrls?: Maybe<Array<Scalars['String']['output']>>;
  location: Location;
  note?: Maybe<Scalars['String']['output']>;
  /** Opaque ID for translating this instruction */
  translationId: Scalars['ID']['output'];
  type?: Maybe<ItemDeliveryInstructionsType>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum ItemDeliveryInstructionsType {
  NonRefrigerated = 'non_refrigerated',
  Refrigerated = 'refrigerated'
}

export type ItemEdge = {
  __typename?: 'ItemEdge';
  cursor: Scalars['String']['output'];
  node: SupplyItem;
};

export type ItemLocationCustomPrice = {
  __typename?: 'ItemLocationCustomPrice';
  customPrice: Money;
  itemId: Scalars['ID']['output'];
  location: Location;
  priceRuleId?: Maybe<Scalars['ID']['output']>;
};

export type ItemPricesResult = ErrorsResult | ItemPricesSuccess;

export type ItemPricesSuccess = {
  __typename?: 'ItemPricesSuccess';
  itemLocationCustomPrices: Array<ItemLocationCustomPrice>;
  updatedItemsCount: Scalars['Int']['output'];
  updatedLocationsCount: Scalars['Int']['output'];
  updatedLocationsItemsCount: Scalars['Int']['output'];
  updatedWarehouseCount: Scalars['Int']['output'];
  updatedWarehouseItemsCount: Scalars['Int']['output'];
};

export type ItemRecommendationConnection = {
  __typename?: 'ItemRecommendationConnection';
  edges: Array<Maybe<ItemEdge>>;
  nodes: Array<Maybe<SupplyItem>>;
  pageInfo: PageInfo;
};

export type ItemRecommendationFiltersInput = {
  categoryId?: InputMaybe<FiltersStringInput>;
  /** When true, restricts to items a shipping location can order, as ItemsFiltersInput.isShipping does. */
  isShipping?: InputMaybe<Scalars['Boolean']['input']>;
  parentCategoryId?: InputMaybe<FiltersStringInput>;
  refrigerationState?: InputMaybe<FiltersRefrigerationStateInput>;
  saleUnitWeightLbs?: InputMaybe<FiltersFloatInput>;
};

export enum ItemRecommendationType {
  Complementary = 'COMPLEMENTARY',
  FrequentlyBoughtTogether = 'FREQUENTLY_BOUGHT_TOGETHER',
  TrendingItems = 'TRENDING_ITEMS'
}

/** Measure of a unit of the item, e.g. 12 oz, 0.5 gallon. Can be in weight, volume, or if none of those, then just "each" */
export type ItemSize = {
  __typename?: 'ItemSize';
  /** string format of the quantity + unit -- 12 ounce */
  label: Scalars['String']['output'];
  /** 0.5 or 12 in the example */
  quantity: Scalars['Float']['output'];
  /** gallon or ounce in the example */
  unit: Unit;
};

/** Item lifecycle status used to filter items by their inactive state. */
export enum ItemStatusFilter {
  Active = 'ACTIVE',
  All = 'ALL',
  Inactive = 'INACTIVE'
}

export type ItemTag = {
  __typename?: 'ItemTag';
  badgeUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdBy: Scalars['String']['output'];
  discardedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  displayAs: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  itemCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  parentTag?: Maybe<ItemTag>;
  pivot?: Maybe<Array<ItemTagPivot>>;
  position: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  visibleInCatalog: Scalars['Boolean']['output'];
};

export type ItemTagConnection = {
  __typename?: 'ItemTagConnection';
  edges: Array<Maybe<ItemTagEdge>>;
  nodes: Array<Maybe<ItemTag>>;
  pageInfo: PageInfo;
};

export enum ItemTagDisplayAs {
  Badge = 'BADGE',
  Text = 'TEXT'
}

export type ItemTagEdge = {
  __typename?: 'ItemTagEdge';
  cursor: Scalars['String']['output'];
  node: ItemTag;
};

export type ItemTagFiltersInput = {
  createdAt?: InputMaybe<FiltersDateInput>;
  createdBy?: InputMaybe<FiltersStringInput>;
  discardedAt?: InputMaybe<FiltersDateInput>;
  displayAs?: InputMaybe<FiltersItemTagDisplayAsInput>;
  id?: InputMaybe<FiltersStringInput>;
  name?: InputMaybe<FiltersStringInput>;
  parentTagId?: InputMaybe<FiltersStringInput>;
  parentTagName?: InputMaybe<FiltersStringInput>;
  slug?: InputMaybe<FiltersStringInput>;
  updatedAt?: InputMaybe<FiltersDateInput>;
  updatedBy?: InputMaybe<FiltersStringInput>;
  visibleInCatalog?: InputMaybe<FiltersBooleanInput>;
};

export type ItemTagInput = {
  badgeUrl?: InputMaybe<Scalars['String']['input']>;
  discardedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  name: Scalars['String']['input'];
  parentTag?: InputMaybe<Scalars['ID']['input']>;
  position: Scalars['Int']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  visibleInCatalog: Scalars['Boolean']['input'];
};

export type ItemTagPivot = {
  __typename?: 'ItemTagPivot';
  createdAt: Scalars['ISO8601DateTime']['output'];
  discardedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  itemId: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum ItemTagSortOrder {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DisplayAsAsc = 'DISPLAY_AS_ASC',
  DisplayAsDesc = 'DISPLAY_AS_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  PositionAsc = 'POSITION_ASC',
  PositionDesc = 'POSITION_DESC',
  PositionTreeAsc = 'POSITION_TREE_ASC',
  PositionTreeDesc = 'POSITION_TREE_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum ItemType {
  Inventory = 'INVENTORY',
  NonInventory = 'NON_INVENTORY'
}

export type ItemsCategoryInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ItemsFiltersInput = {
  brandName?: InputMaybe<FiltersStringInput>;
  caseHeightInches?: InputMaybe<FiltersFloatInput>;
  caseLengthInches?: InputMaybe<FiltersFloatInput>;
  caseWeightLbs?: InputMaybe<FiltersFloatInput>;
  caseWidthInches?: InputMaybe<FiltersFloatInput>;
  catalogStatus?: InputMaybe<FiltersCatalogStatusInput>;
  categoryId?: InputMaybe<FiltersStringInput>;
  createdAt?: InputMaybe<FiltersDateInput>;
  createdBy?: InputMaybe<FiltersStringInput>;
  /**
   * When true, excludes items that have been out of stock for 14+ days at a fulfillment warehouse.
   * When false or omitted, all items are returned.
   */
  customerFacingOutOfStock?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<FiltersStringInput>;
  dimensionalFactor?: InputMaybe<FiltersFloatInput>;
  discontinuedOn?: InputMaybe<FiltersDateInput>;
  eachHeightInches?: InputMaybe<FiltersFloatInput>;
  eachLengthInches?: InputMaybe<FiltersFloatInput>;
  eachWeightLbs?: InputMaybe<FiltersFloatInput>;
  eachWidthInches?: InputMaybe<FiltersFloatInput>;
  fulfillmentWarehouseIds?: InputMaybe<FiltersArrayInput>;
  /** Whether the item has missing content (no description or no custom image). */
  hasMissingContent?: InputMaybe<FiltersBooleanInput>;
  id?: InputMaybe<FiltersStringInput>;
  imgUrl?: InputMaybe<FiltersStringInput>;
  inventoryCheckBehavior?: InputMaybe<FiltersInventoryCheckBehaviorInput>;
  /**
   * The item was activated within the last 90-days or otherwise age specified by
   * Item Management's WA_IS_NEW_WITHIN_DAYS.
   */
  isNew?: InputMaybe<FiltersBooleanInput>;
  /**
   * When true, restricts to items a shipping location can order: a positive ship weight, not
   * refrigerated or frozen, and not in the Pastry or Baked Goods category or subcategory.
   */
  isShipping?: InputMaybe<Scalars['Boolean']['input']>;
  itemSize?: InputMaybe<FiltersStringInput>;
  itemSizeQuantity?: InputMaybe<FiltersFloatInput>;
  itemSizeUnitId?: InputMaybe<FiltersStringInput>;
  /** Filter by item lifecycle status: ACTIVE = active only, INACTIVE = inactive only, ALL = both. Omitted = both (no filter). */
  itemStatus?: InputMaybe<ItemStatusFilter>;
  locationShelfLifeDays?: InputMaybe<FiltersIntInput>;
  minItemsPerOrder?: InputMaybe<FiltersIntInput>;
  name?: InputMaybe<FiltersStringInput>;
  /**
   * Filters items that have been out of stock across all fulfillment warehouses
   * for at least the specified number of days. Items with an OOS bypass reason
   * are not considered out of stock.
   * Use with GREATER_THAN_EQUAL to exclude items OOS for N+ days.
   */
  outOfStockForDays?: InputMaybe<FiltersIntInput>;
  perishability?: InputMaybe<FiltersPerishabilityInput>;
  procurementVendorId?: InputMaybe<FiltersStringInput>;
  purchaseMultiple?: InputMaybe<FiltersFloatInput>;
  purchasePrice?: InputMaybe<FiltersMoneyInput>;
  purchaseUnitId?: InputMaybe<FiltersStringInput>;
  refrigerationState?: InputMaybe<FiltersRefrigerationStateInput>;
  saleUnitId?: InputMaybe<FiltersStringInput>;
  saleUnitWeightLbs?: InputMaybe<FiltersFloatInput>;
  shelfLifeDays?: InputMaybe<FiltersIntInput>;
  standingOrderBehavior?: InputMaybe<FiltersStandingOrderBehaviorInput>;
  stockUnitId?: InputMaybe<FiltersStringInput>;
  subcategoryId?: InputMaybe<FiltersStringInput>;
  tagId?: InputMaybe<FiltersStringInput>;
  transitMethod?: InputMaybe<FiltersTransitMethodInput>;
  type?: InputMaybe<FiltersItemTypeInput>;
  upcCodes?: InputMaybe<FiltersStringInput>;
  updatedAt?: InputMaybe<FiltersDateInput>;
  updatedBy?: InputMaybe<FiltersStringInput>;
  vendorCode?: InputMaybe<FiltersStringInput>;
  vendorId?: InputMaybe<FiltersStringInput>;
  warehouseId?: InputMaybe<FiltersStringInput>;
};

export enum ItemsSortOrder {
  /**
   * Requires a filter that joins the warehouse association (e.g. isNew or warehouseId), which is
   * where the activation date lives; ordering by it without one errors.
   */
  ActivationDateAsc = 'ACTIVATION_DATE_ASC',
  /**
   * Requires a filter that joins the warehouse association (e.g. isNew or warehouseId), which is
   * where the activation date lives; ordering by it without one errors.
   */
  ActivationDateDesc = 'ACTIVATION_DATE_DESC',
  BrandAsc = 'BRAND_ASC',
  BrandDesc = 'BRAND_DESC',
  CategoryAsc = 'CATEGORY_ASC',
  CategoryDesc = 'CATEGORY_DESC',
  CategoryPositionAsc = 'CATEGORY_POSITION_ASC',
  CategoryPositionDesc = 'CATEGORY_POSITION_DESC',
  /** Requires a collection filter. */
  CollectionPositionAsc = 'COLLECTION_POSITION_ASC',
  /** Requires a collection filter. */
  CollectionPositionDesc = 'COLLECTION_POSITION_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  SubcategoryAsc = 'SUBCATEGORY_ASC',
  SubcategoryDesc = 'SUBCATEGORY_DESC',
  SubcategoryPositionAsc = 'SUBCATEGORY_POSITION_ASC',
  SubcategoryPositionDesc = 'SUBCATEGORY_POSITION_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type ItemsSubcategoryInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ItemsVendorInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ItemsWarehouseInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** JWT session. */
export type JwtSession = {
  __typename?: 'JwtSession';
  /** Access token. */
  access: Scalars['String']['output'];
  /** Access token expiration. */
  accessExpiresAt: Scalars['String']['output'];
  /** CSRF token. */
  csrf: Scalars['String']['output'];
  /** Refresh token. */
  refresh: Scalars['String']['output'];
  /** Refresh token expiration. */
  refreshExpiresAt: Scalars['String']['output'];
};

/** How a source-backed group's bins are arranged within the placement. */
export enum LayoutArrangement {
  OddEven = 'ODD_EVEN',
  Sequential = 'SEQUENTIAL'
}

/** Direction a source-backed group's bays are numbered within the placement. */
export enum LayoutBayOrder {
  HighLow = 'HIGH_LOW',
  LowHigh = 'LOW_HIGH'
}

/** Whether a placement is a source-backed bin group or a free-floating facility shape. */
export enum LayoutPlacementKind {
  /** A free-floating shape (wall/dock/room/zone/arrow/label) with no source behind it. */
  Facility = 'FACILITY',
  /** A bin group placed by its interpretation key (family + groupKey). */
  SourceGroup = 'SOURCE_GROUP'
}

/** Machine-readable reason a layout save was rejected. */
export enum LayoutSaveErrorCode {
  /** The submitted revision no longer matches the stored draft; reload and retry. */
  StaleRevision = 'STALE_REVISION'
}

/** A leaderboard for tracking scores in a game */
export type Leaderboard = {
  __typename?: 'Leaderboard';
  /** Whether the leaderboard is active */
  active: Scalars['Boolean']['output'];
  /** When the leaderboard was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Total number of entries in this leaderboard */
  entryCount: Scalars['Int']['output'];
  /** The game this leaderboard belongs to */
  game: Game;
  /** Unique identifier for the leaderboard */
  id: Scalars['ID']['output'];
  /** All entries in this leaderboard */
  leaderboardEntries: Array<LeaderboardEntry>;
  /** Type of leaderboard */
  leaderboardType: LeaderboardTypeEnum;
  /** Additional leaderboard metadata */
  metadata: Scalars['JSON']['output'];
  /** The microsite location this leaderboard belongs to */
  micrositeLocation: MicrositeLocation;
  /** Name of the leaderboard */
  name: Scalars['String']['output'];
  /** When the leaderboard resets */
  resetSchedule?: Maybe<Scalars['String']['output']>;
  /** How scores are aggregated */
  scoreOperator: ScoreOperatorEnum;
  /** URL-friendly identifier */
  slug: Scalars['String']['output'];
  /** How scores are sorted */
  sortOrder: SortOrderEnum;
  /** Top entries in this leaderboard */
  topEntries: Array<LeaderboardEntry>;
  /** When the leaderboard was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


/** A leaderboard for tracking scores in a game */
export type LeaderboardTopEntriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** An entry in a leaderboard */
export type LeaderboardEntry = {
  __typename?: 'LeaderboardEntry';
  /** When the score was achieved */
  achievedAt: Scalars['ISO8601DateTime']['output'];
  /** When the entry was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Unique identifier for the entry */
  id: Scalars['ID']['output'];
  /** Whether this is the player's best score */
  isBestForPlayer: Scalars['Boolean']['output'];
  /** The leaderboard this entry belongs to */
  leaderboard: Leaderboard;
  /** Additional entry metadata */
  metadata: Scalars['JSON']['output'];
  /** Current rank in the leaderboard */
  rank?: Maybe<Scalars['Int']['output']>;
  /** The player's score */
  score: Scalars['Int']['output'];
  /** Secondary score for tiebreaking */
  subscore?: Maybe<Scalars['Int']['output']>;
  /** When the entry was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Display name for the player */
  username: Scalars['String']['output'];
};

/** Type of leaderboard */
export enum LeaderboardTypeEnum {
  /** Challenge leaderboard (special events) */
  Challenge = 'CHALLENGE',
  /** Daily leaderboard (resets daily) */
  Daily = 'DAILY',
  /** Monthly leaderboard (resets monthly) */
  Monthly = 'MONTHLY',
  /** Overall leaderboard (no time restrictions) */
  Overall = 'OVERALL',
  /** Weekly leaderboard (resets weekly) */
  Weekly = 'WEEKLY'
}

export type LineLevelDeliveryIssue = {
  __typename?: 'LineLevelDeliveryIssue';
  createdAt: Scalars['ISO8601DateTime']['output'];
  deliveryRouteStopId?: Maybe<Scalars['ID']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isHeaderReason: Scalars['Boolean']['output'];
  orderLineId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
  reasonCode: LineLevelDeliveryIssueReasonCode;
  redeliveryStopId?: Maybe<Scalars['ID']['output']>;
  subReasonCode?: Maybe<DeliveryIssue>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of LineLevelDeliveryIssueApplyHeaderReason */
export type LineLevelDeliveryIssueApplyHeaderReasonInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Must be one of access_issue or route_not_complete. */
  reasonCode: LineLevelDeliveryIssueReasonCode;
  /** Delivery route stop id. */
  stopId: Scalars['ID']['input'];
};

/** Autogenerated return type of LineLevelDeliveryIssueApplyHeaderReason. */
export type LineLevelDeliveryIssueApplyHeaderReasonPayload = {
  __typename?: 'LineLevelDeliveryIssueApplyHeaderReasonPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  lineLevelIssues?: Maybe<Array<LineLevelDeliveryIssue>>;
  userErrors: Array<LineLevelDeliveryIssueError>;
};

/** Autogenerated input type of LineLevelDeliveryIssueDelete */
export type LineLevelDeliveryIssueDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Line-level delivery issue id. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of LineLevelDeliveryIssueDelete. */
export type LineLevelDeliveryIssueDeletePayload = {
  __typename?: 'LineLevelDeliveryIssueDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userErrors: Array<LineLevelDeliveryIssueError>;
};

/** Line-level delivery issue possible errors */
export type LineLevelDeliveryIssueError = AlreadyReportedReason | InvalidHeaderReasonCode | InvalidStopTypeForHeaderReason | InvalidSubReasonForReasonCode | LineLevelDeliveryIssueNotFound | LineLevelDeliveryIssueValidationError | OrderLineNotFound | OrderLineNotOnStop | RouteEnded | StopHasNoFulfilledLines | StopHasNoOrderLines;

export type LineLevelDeliveryIssueNotFound = UserErrorInterface & {
  __typename?: 'LineLevelDeliveryIssueNotFound';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** NetSuite-aligned reason codes for line-level delivery issues (customlist_reason_code_deliver) */
export enum LineLevelDeliveryIssueReasonCode {
  AccessIssue = 'access_issue',
  Damaged = 'damaged',
  LostMissing = 'lost_missing',
  Other = 'other',
  QaExpired = 'qa_expired',
  RejectedRefusal = 'rejected_refusal',
  RouteNotComplete = 'route_not_complete',
  WrongItem = 'wrong_item'
}

/** Autogenerated input type of LineLevelDeliveryIssueReport */
export type LineLevelDeliveryIssueReportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** OrderLine id (UUID). */
  orderLineId: Scalars['ID']['input'];
  /** Number of units attributed to this reason; must be > 0. */
  quantity: Scalars['Int']['input'];
  /** High-level NS-aligned reason code. */
  reasonCode: LineLevelDeliveryIssueReasonCode;
  redelivery?: InputMaybe<Scalars['Boolean']['input']>;
  /** Delivery route stop id, or redelivery stop id when redelivery is true. */
  stopId: Scalars['ID']['input'];
  /** Sub-reason code (must be in the whitelist for the reason_code). */
  subReasonCode?: InputMaybe<DeliveryIssue>;
};

/** Autogenerated return type of LineLevelDeliveryIssueReport. */
export type LineLevelDeliveryIssueReportPayload = {
  __typename?: 'LineLevelDeliveryIssueReportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  lineLevelIssue?: Maybe<LineLevelDeliveryIssue>;
  userErrors: Array<LineLevelDeliveryIssueError>;
};

/** Autogenerated input type of LineLevelDeliveryIssueUpdate */
export type LineLevelDeliveryIssueUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Line-level delivery issue id. */
  id: Scalars['ID']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  reasonCode?: InputMaybe<LineLevelDeliveryIssueReasonCode>;
  subReasonCode?: InputMaybe<DeliveryIssue>;
};

/** Autogenerated return type of LineLevelDeliveryIssueUpdate. */
export type LineLevelDeliveryIssueUpdatePayload = {
  __typename?: 'LineLevelDeliveryIssueUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  lineLevelIssue?: Maybe<LineLevelDeliveryIssue>;
  userErrors: Array<LineLevelDeliveryIssueError>;
};

export type LineLevelDeliveryIssueValidationError = UserErrorInterface & {
  __typename?: 'LineLevelDeliveryIssueValidationError';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type ListingImpressions = {
  __typename?: 'ListingImpressions';
  dailyBreakdown: Array<DailyImpression>;
  totalBreakdown: ImpressionBreakdown;
  totalImpressions: Scalars['Int']['output'];
};

export type Location = {
  __typename?: 'Location';
  /** Get a list of fees active for a location. */
  activeFeesList: Array<FeeInterface>;
  /** Returns the names of the location's active services as of the current date. */
  activeServices: Array<Scalars['String']['output']>;
  address: Address;
  adequatelyPaid: Scalars['Boolean']['output'];
  /**
   * Get a list of fees that could apply to a location's potential order.
   * @deprecated Replaced by applicable_fees_list to provide a more flexible interface-based approach.
   */
  applicableFees: Array<Fee>;
  /**
   * Get a list of fees that could apply to a location's potential order based on
   * delivery date, payment method and order total.
   */
  applicableFeesList: Array<FeeInterface>;
  /** Whether our backend systems will charge invoices as they become due, using the location's default payment method. */
  automaticallyChargeInvoices: Scalars['Boolean']['output'];
  autopayNeedsSetup: Scalars['Boolean']['output'];
  /** @deprecated Use `automaticallyChargeInvoices` instead. */
  autopayRequired: Scalars['Boolean']['output'];
  autopaySet: Scalars['Boolean']['output'];
  /** Get available delivery days for this location based on vendor associations and delivery rules. */
  availableDeliveryDays: Array<AvailableDeliveryDay>;
  businessName: Scalars['String']['output'];
  /** Calculate shipping cost and estimated delivery dates for a potential order. */
  calculateShipping: ShippingEstimate;
  /**
   * Same as Query.catalogFilters, but doesn't include items from this location's
   * unsupported vendors in ItemTag.itemCount. Warehouse filter still must be
   * explicitly provided.
   */
  catalogFilters?: Maybe<CatalogFilter>;
  /**
   * Returns categories for the location's warehouse. Note that items and item
   * counts for the returned categories will exclude items belonging to vendors
   * that don't support the location.
   */
  categories: Array<Category>;
  collection: Collection;
  company?: Maybe<Company>;
  /** PROTOTYPE list of the location's custom counting units. */
  countingUnits: Array<LocationCountingUnit>;
  countryCode: Scalars['String']['output'];
  county: Scalars['String']['output'];
  /** View credit memos for this location, sorted by transaction date in descending order. */
  creditMemos: NetsuiteCreditMemoConnection;
  /** PROTOTYPE returns the current in-progress Stock Count, if any. */
  currentStockCount?: Maybe<LocationStockCount>;
  customIngredients: Array<CustomIngredient>;
  /** Get the location's items that have a custom price. */
  customPrices: Array<CustomPrice>;
  /** Whether this location's customer collects their order at the warehouse instead of receiving a delivery. */
  customerPickup: Scalars['Boolean']['output'];
  /** Customer-segmentation tags currently assigned to this location. */
  customerTags: Array<CustomerTagAssignment>;
  defaultPaymentMethod?: Maybe<LocationPaymentMethod>;
  /**
   * boolean indicating if the location gets deliveries within store hours. Note
   * scheduled_delivery_time_source is the actual source of truth for how delivery
   * times are calculated.
   */
  deliverWithinStoreHours: Scalars['Boolean']['output'];
  /** any delivery date PO Numbers requested for the location */
  deliveryDatePoNumbers: Array<DeliveryDatePoNumber>;
  displayAddress: Scalars['String']['output'];
  /** Whether this location or its company is excluded from third-party delivery. */
  effectivelyExcluded: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  encryptedLocationId?: Maybe<Scalars['String']['output']>;
  /** Whether this location enforces item scanning for deliveries. */
  enforceItemScanning: Scalars['Boolean']['output'];
  equipmentServicingAvailable: Scalars['Boolean']['output'];
  /** Check if a feature flag is enabled for this location. */
  featureFlagEnabled: Scalars['Boolean']['output'];
  /**
   * Get a list of fee exemptions for a location.
   * @deprecated Replaced by fee_exemptions_list to use the new FeeInterface type.
   */
  feeExemptions: Array<FeeExemption>;
  /** Get a list of fee exemptions for a location. */
  feeExemptionsList: Array<FeeExemptionList>;
  financialStatementPreferences?: Maybe<FinancialStatementPreferences>;
  financialTransaction?: Maybe<FinancialTransaction>;
  formattedAddress: Scalars['String']['output'];
  /**
   * Whether this location is excluded from automatic application of credit memos,
   * overpayments and unapplied Odeko payments to its open invoices.
   */
  fundApplicationExcluded: Scalars['Boolean']['output'];
  /** If a location is enabled for global fulfillment */
  globalFulfillmentEnabled: Scalars['Boolean']['output'];
  globalFulfillmentMode: LocationGlobalFulfillmentModeEnum;
  globalFulfillmentShippingWarehouse?: Maybe<Warehouse>;
  /** Whether the location has credit memos. */
  hasCreditMemos: Scalars['Boolean']['output'];
  hasDeliveries: Scalars['Boolean']['output'];
  hasDeliveryInstructions: Scalars['Boolean']['output'];
  hasOrders: Scalars['Boolean']['output'];
  hasShippingInstructions: Scalars['Boolean']['output'];
  hasSkus: Scalars['Boolean']['output'];
  hubspotCompanyId?: Maybe<Scalars['String']['output']>;
  hubspotLead?: Maybe<HubspotLead>;
  id: Scalars['ID']['output'];
  includeInAutomatedRouting?: Maybe<Scalars['Boolean']['output']>;
  internalDeliveryInstructions?: Maybe<Array<InternalDeliveryInstructions>>;
  /** View Odeko invoices for this location, sorted by transaction date in descending order. */
  invoices: NetsuiteInvoiceConnection;
  isDoordash: Scalars['Boolean']['output'];
  /** Check if survey is complete */
  isSurveyComplete: Scalars['Boolean']['output'];
  itemDeliveryInstructions?: Maybe<Array<ItemDeliveryInstructions>>;
  /**
   * Similar to User.availableItemById, but returns a LocationItemDetails object
   * that provides more direct access to item attributes applicable to this
   * Location.
   */
  itemDetails?: Maybe<LocationItemDetails>;
  itemRecommendations: ItemRecommendationConnection;
  items: ItemConnection;
  keyId: Scalars['String']['output'];
  /**
   * Returns balance powered via legacy systems.
   * @deprecated Use totalUnpaidBalance, upcomingBalance or overdueBalance instead.
   */
  legacyBalanceCents: Scalars['Int']['output'];
  /**
   * Returns pending cents powered via legacy systems.
   * @deprecated Use totalUnpaidBalance, upcomingBalance or overdueBalance instead.
   */
  legacyPendingCents: Scalars['Int']['output'];
  locationAccessInstructions?: Maybe<Array<LocationAccessInstructions>>;
  locationDeliveryWindow: LocationDeliveryWindows;
  locationEntranceInstructions?: Maybe<Array<LocationEntranceInstructions>>;
  /** Whether this location is explicitly excluded from third-party delivery. */
  locationExcluded: Scalars['Boolean']['output'];
  membershipStatus: LocationMembershipStatus;
  /** @deprecated Deprecated - use membership_status */
  membershipTier: LocationMembershipTier;
  name: Scalars['String']['output'];
  netsuiteInternalId?: Maybe<Scalars['ID']['output']>;
  /** Get a Netsuite transactions filtered */
  netsuiteTransactions?: Maybe<Array<NetsuiteTransaction>>;
  /**
   * The location's New Items, paginated. Behaves identically to
   * items(filters: { isNew: { op: EQUAL, value: [true] } }): the same 60-day
   * activation window, the same new-item priority ordering, and the same
   * updatedAt-descending fallback. This is the single shared entry point that the
   * storefront carousel and View All both read, so their ordering can never drift.
   * isNew is forced on by the resolver; callers may still pass other filters (e.g.
   * the shipping-customer filters saleUnitWeightLbs / refrigerationState).
   */
  newItems: ItemConnection;
  /** Get next available delivery dates for all vendors at this location */
  nextAvailableDeliveryDates: Array<NextAvailableDeliveryDate>;
  /**
   * Details about the next payment that automatic billing would charge. Null if
   * there is no next charge (e.g. if there are no unpaid invoices, if the location
   * has automatic billing disabled, etc.).
   */
  nextCharge?: Maybe<PaymentUpcoming>;
  nickname: Scalars['String']['output'];
  onboardingStatus: Scalars['String']['output'];
  /** The amount of Money that the location needs to pay eventually, not including the amounts past due. */
  openBalance?: Maybe<Money>;
  openingHours?: Maybe<Array<OpeningHour>>;
  /**
   * Groups of paid or partially-paid invoices. The payment may have succeeded or
   * be pending; never failed. These invoices are grouped by payment. Due to
   * partial payments, a given invoice may be present in multiple groups. A null
   * value means that the feature is off; an empty array means that there is no data.
   */
  paidInvoiceGroups?: Maybe<PaymentInvoiceGroupConnection>;
  /** The amount of Money that the location should have paid earlier. */
  pastDueBalance?: Maybe<Money>;
  paymentMethods: Array<LocationPaymentMethod>;
  /** The location's current payment terms, in days. 0 means due on receipt. Null if braavos does not know this location yet. */
  paymentTermsDays?: Maybe<Scalars['Int']['output']>;
  phoneNumbers: Array<PhoneNumber>;
  postalCode?: Maybe<Scalars['String']['output']>;
  /** Whether this location opts in to printable delivery sheets when ops prints sheets for a night. */
  printDeliverySheetEnabled: Scalars['Boolean']['output'];
  promotionPages: PromotionPageConnection;
  punchoutCatalogEnabled: Scalars['Boolean']['output'];
  purchaseHistoryRecommendations: PurchaseHistoryRecommendationConnection;
  /** Whether or not the location is ready for terms. */
  readyForTerms?: Maybe<Scalars['Boolean']['output']>;
  /** Error info if (and only if) last payment attempt failed. */
  recentPaymentError?: Maybe<PaymentError>;
  recipes: Array<Recipe>;
  recipientPhoneNumber: RecipientPhoneNumber;
  /** The routing cohort this location belongs to. */
  routingCohort?: Maybe<RoutingCohort>;
  scheduledDeliveryTimeSource: ScheduledDeliveryTimeSourceEnum;
  /**
   * The service time for this location. This is the time it takes to perform a
   * delivery at this location. This is used to calculate the total time for a
   * delivery route.
   */
  serviceTime?: Maybe<Scalars['Int']['output']>;
  /** Active customer-facing services for this location. */
  services: Array<Scalars['String']['output']>;
  shippingInstructions?: Maybe<ShippingInstructions>;
  shippingMethods?: Maybe<Array<LocationShippingMethodEnum>>;
  showOnboardingSurvey: Scalars['Boolean']['output'];
  signedUpForEquipmentServicing: Scalars['Boolean']['output'];
  signedUpForSupply: Scalars['Boolean']['output'];
  skus: Array<Sku>;
  /** Standing order items for a specific day of the week, or all days if not specified */
  standingOrderItems: Array<StandingOrderSku>;
  state: Scalars['String']['output'];
  /** PROTOTYPE returns the list of the location's Stock Counts. */
  stockCounts: Array<LocationStockCount>;
  /** PROTOTYPE list of the location's storage or stock areas. */
  storageAreas: Array<LocationStorageArea>;
  storeHoursConfirmed: Scalars['Boolean']['output'];
  supplyReady: Scalars['Boolean']['output'];
  /** Survey responses at Location or Company level */
  survey?: Maybe<Survey>;
  timeZone: Scalars['String']['output'];
  /** This is a temporary value is for verification purposes only! */
  totalPendingTransactions?: Maybe<Money>;
  /**
   * The sum of all payments made towards this location's Odeko invoices that are
   * still processing. Does not include credit applications.
   */
  totalProcessingPayments: Money;
  /** The total spend from so-api orders in the given range, by delivery date */
  totalSpendCents: Scalars['Int']['output'];
  /** The amount of money that the location has in credits and unapplied payments. */
  totalUnappliedFunds: Money;
  /** The amount of Money that the location owes us in total. Null means feature is off, $0 means no balance. */
  totalUnpaidBalance?: Maybe<Money>;
  /**
   * This location's transaction-sync situation, for the internal tool that
   * refreshes a location's records from NetSuite. Never null: a location with no
   * history reports that it has none.
   */
  transactionSync: TransactionSync;
  /**
   * Groups of unpaid or partially-unpaid invoices. These invoices may be grouped
   * by payment due date. A null value means that the feature is off; an empty
   * collection means that there is no data.
   *
   * NOTE: Pagination arguments are currently ignored. We plan on addressing this in a future iteration.
   */
  unpaidInvoiceGroups?: Maybe<PaymentInvoiceGroupConnection>;
  /** Returns vendors that will not deliver to this location. */
  unsupportedVendors: Array<Vendor>;
  /** Users who have access to this location (company owners and location-assigned users). */
  users: Array<User>;
  /** Number of users who have access to this location. */
  usersCount: Scalars['Int']['output'];
  warehouse: Warehouse;
  /** Warehouse delivery rules apply to this location. */
  warehouseDeliveryRules: Array<DeliveryRule>;
};


export type LocationApplicableFeesArgs = {
  deliveryDate: Scalars['ISO8601Date']['input'];
  skus: Array<ApplicableFeesSkuInput>;
  warehouseUuid?: InputMaybe<Scalars['ID']['input']>;
};


export type LocationApplicableFeesListArgs = {
  deliveryDate: Scalars['ISO8601Date']['input'];
  items?: InputMaybe<Array<ApplicableFeesItemInput>>;
  paymentMethodType?: InputMaybe<PaymentMethodTypeEnum>;
  skus: Array<ApplicableFeesSkuInput>;
  warehouseUuid?: InputMaybe<Scalars['ID']['input']>;
};


export type LocationCalculateShippingArgs = {
  skus: Array<CalculateShippingSkuInput>;
  warehouseUuid?: InputMaybe<Scalars['ID']['input']>;
};


export type LocationCatalogFiltersArgs = {
  itemCountFilters?: InputMaybe<ItemsFiltersInput>;
  selected?: InputMaybe<CatalogFilterSelectedInput>;
};


export type LocationCategoriesArgs = {
  filter?: InputMaybe<CategoriesFilter>;
  forType?: InputMaybe<CategoryType>;
  sortOrder?: InputMaybe<Array<InputMaybe<CategoriesSortOrder>>>;
};


export type LocationCollectionArgs = {
  referenceId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<CollectionType>;
};


export type LocationCreditMemosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  filter?: InputMaybe<LocationCreditMemosFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type LocationDeliveryDatePoNumbersArgs = {
  startingFrom?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type LocationFeatureFlagEnabledArgs = {
  flagName: Scalars['String']['input'];
};


export type LocationFinancialTransactionArgs = {
  id: Scalars['ID']['input'];
};


export type LocationInvoicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  filter?: InputMaybe<LocationInvoicesFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type LocationIsSurveyCompleteArgs = {
  surveyLevel: SurveyLevelEnum;
  surveyName: Scalars['String']['input'];
};


export type LocationItemDetailsArgs = {
  itemId: Scalars['ID']['input'];
};


export type LocationItemRecommendationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deliveryDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  excludeItemIds?: InputMaybe<Array<Scalars['String']['input']>>;
  filters?: InputMaybe<ItemRecommendationFiltersInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  itemIds?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxRecommendations?: InputMaybe<Scalars['Int']['input']>;
  type: ItemRecommendationType;
  warehouses: Array<Scalars['String']['input']>;
};


export type LocationItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  analyticsTags?: InputMaybe<AlgoliaAnalyticsTagInput>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ItemsFiltersInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Array<InputMaybe<ItemsSortOrder>>>;
};


export type LocationNetsuiteTransactionsArgs = {
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  transactionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  vendorName?: InputMaybe<Scalars['String']['input']>;
};


export type LocationNewItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<NewItemsFiltersInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type LocationNextAvailableDeliveryDatesArgs = {
  daysAhead?: InputMaybe<Scalars['Int']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type LocationNextChargeArgs = {
  paymentMethodId: Scalars['String']['input'];
};


export type LocationOpenBalanceArgs = {
  asOf?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};


export type LocationPaidInvoiceGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateFilter?: InputMaybe<FinancialTransactionDateRangeInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type LocationPastDueBalanceArgs = {
  asOf?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};


export type LocationPromotionPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PromotionPageFiltersInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Array<InputMaybe<PromotionPageSortOrder>>>;
};


export type LocationPurchaseHistoryRecommendationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deliveryDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  excludeItemIds?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isRefillDue?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  minDistinctMonthsOrdered?: InputMaybe<Scalars['Int']['input']>;
  predictabilityLevels?: InputMaybe<Array<PredictabilityLevel>>;
  warehouses: Array<Scalars['String']['input']>;
};


export type LocationRecentPaymentErrorArgs = {
  asOf?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};


export type LocationStandingOrderItemsArgs = {
  dayOfWeek?: InputMaybe<Scalars['Int']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type LocationSurveyArgs = {
  surveyLevel: SurveyLevelEnum;
  surveyName: Scalars['String']['input'];
};


export type LocationTotalSpendCentsArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  startDate: Scalars['ISO8601Date']['input'];
};


export type LocationUnpaidInvoiceGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateFilter?: InputMaybe<FinancialTransactionDateRangeInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationAccessInstructions = {
  __typename?: 'LocationAccessInstructions';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  imageKeys?: Maybe<Array<Scalars['String']['output']>>;
  imageUrls?: Maybe<Array<Scalars['String']['output']>>;
  installed?: Maybe<Scalars['Boolean']['output']>;
  location: Location;
  note?: Maybe<Scalars['String']['output']>;
  /** Opaque ID for translating this instruction */
  translationId: Scalars['ID']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/**
 * A run of location assignments or removals on one item by one user. Locations are assigned one per
 * request, so a run is every change that user made without pausing for more than two minutes.
 */
export type LocationChangeGroup = {
  __typename?: 'LocationChangeGroup';
  /** `NEW` when the locations were added, `DELETE` when they were removed */
  changeType: AuditLogChangeType;
  endedAt: Scalars['ISO8601DateTime']['output'];
  /** The locations that were added or removed, oldest change first */
  locationIds: Array<Scalars['ID']['output']>;
  startedAt: Scalars['ISO8601DateTime']['output'];
  /** Who made the changes, or null when nobody did (a system write) */
  user?: Maybe<User>;
};

export type LocationChangeGroupConnection = {
  __typename?: 'LocationChangeGroupConnection';
  edges: Array<Maybe<LocationChangeGroupEdge>>;
  nodes: Array<Maybe<LocationChangeGroup>>;
  pageInfo: PageInfo;
};

export type LocationChangeGroupEdge = {
  __typename?: 'LocationChangeGroupEdge';
  cursor: Scalars['String']['output'];
  node: LocationChangeGroup;
};

/** The connection type for Location. */
export type LocationConnection = {
  __typename?: 'LocationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LocationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Location>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of records in the connection. */
  totalCount: Scalars['Int']['output'];
};

/**
 * PROTOTYPE describes a custom location counting unit. Items may be counted in
 * units of these, or they may be counted using the item's associated Odeko sales unit.
 */
export type LocationCountingUnit = {
  __typename?: 'LocationCountingUnit';
  /** PROTOTYPE The id of the base unit. */
  baseUnitId: Scalars['ID']['output'];
  /** PROTOTYPE number of base units in this counting unit. */
  conversionRate: Scalars['Int']['output'];
  /** PROTOTYPE id of the counting unit. */
  id: Scalars['ID']['output'];
  /** PROTOTYPE Odeko UUID of the associated location. */
  locationId: Scalars['ID']['output'];
  /** PROTOTYPE name of the counting unit. */
  name: Scalars['String']['output'];
};

export enum LocationCreditMemosFilter {
  /** Credit memos used in full. */
  Applied = 'APPLIED',
  /** Credit memos that have been used, but there is a remaining credit balance. */
  PartiallyApplied = 'PARTIALLY_APPLIED',
  /** Credit memos that haven't yet been used. */
  Unapplied = 'UNAPPLIED'
}

export type LocationDeliveryWindows = {
  __typename?: 'LocationDeliveryWindows';
  /** End time in HH:MM format. */
  endTime: Scalars['String']['output'];
  /** Start time in HH:MM format. */
  startTime: Scalars['String']['output'];
};

export type LocationDeprioritization = {
  __typename?: 'LocationDeprioritization';
  deprioritizedAt: Scalars['ISO8601DateTime']['output'];
  deprioritizedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  locationId: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
};

/** An edge in a connection. */
export type LocationEdge = {
  __typename?: 'LocationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Location>;
};

export type LocationEntranceInstructions = {
  __typename?: 'LocationEntranceInstructions';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  imageKeys?: Maybe<Array<Scalars['String']['output']>>;
  imageUrls?: Maybe<Array<Scalars['String']['output']>>;
  location: Location;
  note?: Maybe<Scalars['String']['output']>;
  /** Opaque ID for translating this instruction */
  translationId: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  videoKeys?: Maybe<Array<Scalars['String']['output']>>;
  videoUrls?: Maybe<Array<Scalars['String']['output']>>;
};

/** Location update error types */
export type LocationError = LocationsNotFound | RecentDeliveriesPresent;

export enum LocationGlobalFulfillmentModeEnum {
  NotEnabled = 'not_enabled',
  SingleShippingOrder = 'single_shipping_order',
  SplitOrder = 'split_order'
}

/** Autogenerated input type of LocationIncludeInAutomatedRoutingUpdate */
export type LocationIncludeInAutomatedRoutingUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  includeInAutomatedRouting: Scalars['Boolean']['input'];
  locationId: Scalars['ID']['input'];
};

/** Autogenerated return type of LocationIncludeInAutomatedRoutingUpdate. */
export type LocationIncludeInAutomatedRoutingUpdatePayload = {
  __typename?: 'LocationIncludeInAutomatedRoutingUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  includeInAutomatedRouting: Scalars['Boolean']['output'];
};

export enum LocationInvoicesFilter {
  /** Invoices that have had a credit applied towards their balance. */
  CreditApplied = 'CREDIT_APPLIED',
  /** Invoices that are paid in full or will be by pending payments. */
  Paid = 'PAID',
  /** Invoices that are not paid in full, excluding those that will be by pending payments. */
  Unpaid = 'UNPAID'
}

export type LocationItem = {
  __typename?: 'LocationItem';
  itemId: Scalars['ID']['output'];
  locationId: Scalars['ID']['output'];
};

/**
 * A wrapper around a SupplyItem that provides more direct access to attributes of
 * the SupplyItem that are applicable to a specific Location, allowing for more
 * efficient queries and less client-side data processing.
 */
export type LocationItemDetails = {
  __typename?: 'LocationItemDetails';
  /**
   * An InventoryItem's warehouse association for the Location's Warehouse. May be
   * null if the item is not sold at that warehouse or if it is a NonInventoryItem.
   */
  inventoryWarehouseAssociation?: Maybe<InventoryWarehouseAssociation>;
  /** The full details of the SupplyItem. */
  item: SupplyItem;
  /**
   * A NonInventoryItem's warehouse association for the Location's Warehouse. May
   * be null if the item is not sold at that warehouse, the vendor does not sell to
   * the Location, or the item is an InventoryItem.
   */
  nonInventoryWarehouseAssociation?: Maybe<NonInventoryWarehouseAssociation>;
};

/** Input needed for allowing custom items to be enabled in the catalog, for a location */
export type LocationItemInput = {
  /** The uuid of the catalog item */
  itemId: Scalars['ID']['input'];
  /** The uuid of the location's odeko_uuid */
  locationId: Scalars['ID']['input'];
};

export type LocationMembershipStatus = {
  __typename?: 'LocationMembershipStatus';
  tier: LocationMembershipStatusTier;
  /** Is today's date on or after the trial start date, and before the end date? */
  trialActive: Scalars['Boolean']['output'];
  /** The number of days from the the first order until the trial ends. */
  trialDaysFromFirstOrder: Scalars['Int']['output'];
  /** The date that the location's trial ends. When checking if a location is on a trial, this is an exclusive boundary. */
  trialEndDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The date that the location's trial begins. When checking if a location is on a trial, this is an inclusive boundary. */
  trialStartDate?: Maybe<Scalars['ISO8601Date']['output']>;
};

export enum LocationMembershipStatusTier {
  /** Required minimum spend, no discounts, standard order cut-off time */
  Basic = 'basic',
  /** No minimum spend, no discounts, standard order cut-off time */
  Bronze = 'bronze',
  /** Displays spend tracker. No minimum spend, no discounts, standarded cut-off time. */
  ConsideringMembership = 'considering_membership',
  /** Excluded from the Membership Tier rules */
  Exclude = 'exclude',
  /** No minimum spend, higher discount, later order cut-off time */
  Gold = 'gold',
  /** No minimum spend, lower discount, standard order cut-off time */
  Silver = 'silver'
}

export enum LocationMembershipTier {
  /** Required minimum spend, no discounts, standard order cut-off time */
  Basic = 'basic',
  /** Displays spend tracker. No minimum spend, no discounts, standarded cut-off time. */
  ConsideringMembership = 'considering_membership',
  /** Excluded from the Membership Tier rules */
  Exclude = 'exclude',
  /** No minimum spend, higher discount, later order cut-off time */
  Gold = 'gold',
  /** No minimum spend, lower discount, standard order cut-off time */
  Silver = 'silver'
}

export type LocationOrderDateInput = {
  deliveryDate: Scalars['ISO8601Date']['input'];
  vendors: Array<LocationOrderVendorInput>;
};

export type LocationOrderError = {
  __typename?: 'LocationOrderError';
  message: Scalars['String']['output'];
};

export type LocationOrderFeeInput = {
  amountCents?: InputMaybe<Scalars['Int']['input']>;
  amountPercent?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['ID']['input'];
};

export type LocationOrderItemInput = {
  /** Item UUID (product.uuid / sku.item_uuid) — not the SKU's numeric database ID */
  id: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type LocationOrderResult = {
  __typename?: 'LocationOrderResult';
  deliveryDate: Scalars['ISO8601Date']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  previousTotalCents: Scalars['Int']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  vendor: Vendor;
};

export type LocationOrderVendorInput = {
  couponCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  fees?: InputMaybe<Array<LocationOrderFeeInput>>;
  items: Array<LocationOrderItemInput>;
  salesTaxEstimateId?: InputMaybe<Scalars['ID']['input']>;
  vendorId: Scalars['ID']['input'];
};

/** Error indicating that the location is ineligible for ordering. */
export type LocationOrderingIneligibleError = Error & {
  __typename?: 'LocationOrderingIneligibleError';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Error indicating that the location is not enabled for ordering. */
export type LocationOrderingNotEnabledError = Error & {
  __typename?: 'LocationOrderingNotEnabledError';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** The connection type for Order. */
export type LocationOrdersConnection = {
  __typename?: 'LocationOrdersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrderEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Order>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of records in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type LocationOrdersInput = {
  id: Scalars['ID']['input'];
};

/** The connection type for Order. */
export type LocationPastOrdersConnection = {
  __typename?: 'LocationPastOrdersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrderEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Order>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of records in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type LocationPastOrdersInput = {
  id: Scalars['ID']['input'];
};

export type LocationPaymentMethod = BankAccount | BuyNowPayLater | CreditCard;

export enum LocationPhoneTypeEnum {
  /** Location phone number that can be used to resolve order issues */
  OrderContact = 'order_contact'
}

/** Narrows the locations a viewer can see. The filters apply together, and with the name search alongside them. */
export type LocationSearchFiltersInput = {
  /** Locations carrying these tags. An empty id list is a no-op. */
  tags?: InputMaybe<CustomerTagFilterInput>;
  /**
   * Matches a location's businessName or its id, case-insensitively. Scoped to
   * this argument on purpose: `name` is shared with several other apps, and an id
   * is a substring of hex that collides with ordinary search terms.
   */
  term?: InputMaybe<Scalars['String']['input']>;
  /** Locations served by one of these warehouses (the federated Warehouse.id). An empty list is a no-op. */
  warehouseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum LocationShippingMethodEnum {
  LocalDelivery = 'local_delivery',
  PalletShipping = 'pallet_shipping',
  ParcelShipping = 'parcel_shipping'
}

/**
 * PROTOTYPE delineates a 'Stock Count', which is an activity with a beginning time
 * and an ending time during which some inventory counts are entered for a
 * location. It's like a session.
 */
export type LocationStockCount = {
  __typename?: 'LocationStockCount';
  /** PROTOTYPE number of LocationItems that were counted in this session. */
  countedItems: Scalars['Int']['output'];
  /** PROTOTYPE when the session was started. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** PROTOTYPE an identifier for the user who started the session. */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** PROTOTYPE id of the LocationInventorySession. */
  id: Scalars['ID']['output'];
  /** PROTOTYPE the latest count for each item counted in this Stock Count session. */
  latestItemCounts: Array<CurrentCount>;
  /** PROTOTYPE Odeko UUID of the associated location. */
  locationId: Scalars['ID']['output'];
  /** PROTOTYPE when the session was submitted. */
  submittedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** PROTOTYPE an identifier for the user who submitted the session. */
  submittedBy?: Maybe<Scalars['String']['output']>;
  /** PROTOTYPE the number of LocationItems that may be counted in this session. */
  totalItems: Scalars['Int']['output'];
  /** PROTOTYPE when the session or one of its counts was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** PROTOTYPE names an area withing a Cafe location where stock is kept. */
export type LocationStorageArea = {
  __typename?: 'LocationStorageArea';
  /** PROTOTYPE id of a storage area withing a Cafe location. */
  id: Scalars['ID']['output'];
  /** PROTOTYPE Odeko UUID of the associated location. */
  locationId: Scalars['ID']['output'];
  /** PROTOTYPE name of a storage area within a Cafe location. */
  name: Scalars['String']['output'];
};

export type LocationUpcomingOrdersInput = {
  id: Scalars['ID']['input'];
};

/** Autogenerated input type of LocationsCustomerPickupUpdate */
export type LocationsCustomerPickupUpdateInput = {
  /**
   * Flag the locations even though some recently took a delivery on a driven
   * route. Without it such a request is rejected and nothing is written, so ops
   * sees the list first.
   */
  acknowledgeRecentDeliveries?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customerPickup: Scalars['Boolean']['input'];
  locationIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of LocationsCustomerPickupUpdate. */
export type LocationsCustomerPickupUpdatePayload = {
  __typename?: 'LocationsCustomerPickupUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  locations: Array<Location>;
  /**
   * Requested ids with no matching location in this service. Reported rather than
   * silently dropped: a location exists here only after the location sync, so an
   * id can be valid upstream and still be unknown to this service.
   */
  notFoundLocationIds: Array<Scalars['ID']['output']>;
  userErrors: Array<LocationError>;
};

/** Autogenerated input type of LocationsEnforceItemScanningUpdate */
export type LocationsEnforceItemScanningUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  enforceItemScanning: Scalars['Boolean']['input'];
  locationIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of LocationsEnforceItemScanningUpdate. */
export type LocationsEnforceItemScanningUpdatePayload = {
  __typename?: 'LocationsEnforceItemScanningUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  locations: Array<Location>;
};

export enum LocationsFilter {
  HasFieldService = 'has_field_service',
  HasRetail = 'has_retail',
  HasSupply = 'has_supply'
}

/** Autogenerated input type of LocationsIncludeInAutomatedRoutingUpdate */
export type LocationsIncludeInAutomatedRoutingUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  includeInAutomatedRouting: Scalars['Boolean']['input'];
  locationIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of LocationsIncludeInAutomatedRoutingUpdate. */
export type LocationsIncludeInAutomatedRoutingUpdatePayload = {
  __typename?: 'LocationsIncludeInAutomatedRoutingUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  locations: Array<Location>;
};

export type LocationsNotFound = UserErrorInterface & {
  __typename?: 'LocationsNotFound';
  errorCode: Scalars['String']['output'];
  locationIds: Array<Scalars['ID']['output']>;
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of LocationsPrintDeliverySheetEnabledUpdate */
export type LocationsPrintDeliverySheetEnabledUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationIds: Array<Scalars['ID']['input']>;
  printDeliverySheetEnabled: Scalars['Boolean']['input'];
};

/** Autogenerated return type of LocationsPrintDeliverySheetEnabledUpdate. */
export type LocationsPrintDeliverySheetEnabledUpdatePayload = {
  __typename?: 'LocationsPrintDeliverySheetEnabledUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  locations: Array<Location>;
};

/** Autogenerated input type of LocationsServiceTimeUpdate */
export type LocationsServiceTimeUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationIds: Array<Scalars['ID']['input']>;
  serviceTime: Scalars['Int']['input'];
};

/** Autogenerated return type of LocationsServiceTimeUpdate. */
export type LocationsServiceTimeUpdatePayload = {
  __typename?: 'LocationsServiceTimeUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  locations: Array<Location>;
};

/** Autogenerated input type of LocationsThirdPartyExclusionUpdate */
export type LocationsThirdPartyExclusionUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationExcluded: Scalars['Boolean']['input'];
  locationIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of LocationsThirdPartyExclusionUpdate. */
export type LocationsThirdPartyExclusionUpdatePayload = {
  __typename?: 'LocationsThirdPartyExclusionUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  locations: Array<Location>;
  userErrors: Array<LocationError>;
};

/** Autogenerated input type of LogSalesOutreach */
export type LogSalesOutreachInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  outcome: Scalars['String']['input'];
};

/** Autogenerated return type of LogSalesOutreach. */
export type LogSalesOutreachPayload = {
  __typename?: 'LogSalesOutreachPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  salesOutreachLog?: Maybe<SalesOutreachLog>;
};

/** Autogenerated input type of LoginConsumerAppUserFromFirebase */
export type LoginConsumerAppUserFromFirebaseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Email to assign if registering a new account. Must be non-null if registering a new account. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Firebase ID (the "localId" received from www.googleapis.com/identitytoolkit/v3/relyingparty/getAccountInfo). */
  fbId: Scalars['String']['input'];
  /** Firebase token to assign if registering a new account. */
  fbToken?: InputMaybe<Scalars['String']['input']>;
  /** Whether this should be registered as a guest account, if registering a new account. Defaults to false. */
  isGuestAccount?: InputMaybe<Scalars['Boolean']['input']>;
  /** Phone number to assign if registering a new account. */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** ID received when verifying phone number. Must be included if a non-null "phoneNumber" is specified. */
  phoneVerificationId?: InputMaybe<Scalars['ID']['input']>;
  /** Username to assign if registering a new account. Must be non-null if registering a new account. */
  username?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of LoginConsumerAppUserFromFirebase */
export type LoginConsumerAppUserFromFirebasePayload = {
  __typename?: 'LoginConsumerAppUserFromFirebasePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to login. */
  result: ConsumerAppUserFirebaseLoginResult;
};

/** A guest who has signed up for a mailing list */
export type MailingListGuest = {
  __typename?: 'MailingListGuest';
  createdAt: Scalars['ISO8601DateTime']['output'];
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  micrositeLocationId: Scalars['ID']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of MakeCreditKeyChargeMutation */
export type MakeCreditKeyChargeMutationInput = {
  /** Total amount to be charged, in cents. */
  amountCents: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Optionally specify an idempotency key to prevent duplicate charges. */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  /** Location UUID */
  locationUuid: Scalars['String']['input'];
  /**
   * Payment method ID. This should identify a Credit Key account the location has
   * already connected as an available payment method.
   */
  paymentMethodId: Scalars['String']['input'];
};

/** Autogenerated return type of MakeCreditKeyChargeMutation. */
export type MakeCreditKeyChargeMutationPayload = {
  __typename?: 'MakeCreditKeyChargeMutationPayload';
  charge?: Maybe<OdekoPaymentIntent>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** A manual (GM-triggered) Routific run mode. */
export enum ManualRoutificRunMode {
  /** Recalculate ETAs/metrics for the current routes without changing assignment or order. */
  EtasOnly = 'etas_only',
  /** Re-optimize the stop order within each route, keeping each stop on its vehicle. */
  ReSequence = 're_sequence'
}

export enum ManufacturedType {
  CustomBrandedItem = 'CUSTOM_BRANDED_ITEM'
}

/** Autogenerated input type of MarkCustomerPickupStopsComplete */
export type MarkCustomerPickupStopsCompleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDs of the customer-pickup bucket stops to mark picked up. */
  stopIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of MarkCustomerPickupStopsComplete. */
export type MarkCustomerPickupStopsCompletePayload = {
  __typename?: 'MarkCustomerPickupStopsCompletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The customer-pickup bucket routes the completed stops belong to, for refreshing the tab. */
  routes?: Maybe<Array<Route>>;
  userErrors: Array<DeliveryRouteStopError>;
};

/** Autogenerated input type of MarkItemsAsBulkPickedMutation */
export type MarkItemsAsBulkPickedMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A boolean value to set the bulk status of the items */
  isBulkedPicked: Scalars['Boolean']['input'];
  /** A list of item ids e.g uuids */
  itemIds: Array<Scalars['ID']['input']>;
  /** Unique identifier for the warehouse e.g uuid */
  warehouseId: Scalars['ID']['input'];
};

/** Autogenerated return type of MarkItemsAsBulkPickedMutation. */
export type MarkItemsAsBulkPickedMutationPayload = {
  __typename?: 'MarkItemsAsBulkPickedMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  userErrors: Array<BulkItemError>;
};

/** Autogenerated input type of MarkRouteForProvider */
export type MarkRouteForProviderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** When the courier should collect. Omitted or null means ASAP at push time. */
  pickupAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** The provider to mark the route for. */
  provider: ThirdPartyProvider;
  /** The route to mark. */
  routeId: Scalars['ID']['input'];
};

/** Autogenerated return type of MarkRouteForProvider. */
export type MarkRouteForProviderPayload = {
  __typename?: 'MarkRouteForProviderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  route?: Maybe<Route>;
  userErrors: Array<ThirdPartyDispatchError>;
};

export type MarketingQrCode = {
  __typename?: 'MarketingQrCode';
  /** SVG download URL for the QR code */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  micrositeLocation?: Maybe<MicrositeLocation>;
  /** PNG download URL for the QR code (generated on first access) */
  pngDownloadUrl?: Maybe<Scalars['String']['output']>;
  /** Final destination, without the utmMedium. */
  redirectUrl?: Maybe<Scalars['String']['output']>;
  sequenceNumber: Scalars['ID']['output'];
  staticUrl: Scalars['String']['output'];
  /** E.g. sign, coaster, etc. */
  utmMedium?: Maybe<Scalars['String']['output']>;
};

export type MarketingQrCodeBulkUpdateResult = {
  __typename?: 'MarketingQrCodeBulkUpdateResult';
  /** Any errors that occured */
  errors: Array<Scalars['String']['output']>;
  qrCode?: Maybe<MarketingQrCode>;
  rowNumber: Scalars['Int']['output'];
};

/** The connection type for MarketingQrCode. */
export type MarketingQrCodeConnection = {
  __typename?: 'MarketingQrCodeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MarketingQrCodeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<MarketingQrCode>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of records in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MarketingQrCodeEdge = {
  __typename?: 'MarketingQrCodeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<MarketingQrCode>;
};

export type MarketingQrScan = {
  __typename?: 'MarketingQrScan';
  /** Final destination, without the utmMedium. */
  redirectUrl?: Maybe<Scalars['String']['output']>;
  /** E.g. sign, coaster, etc. */
  utmMedium?: Maybe<Scalars['String']['output']>;
};

export type MasterHomepage = {
  __typename?: 'MasterHomepage';
  endDate: Scalars['ISO8601Date']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  rows: Array<MasterHomepageRow>;
  startDate: Scalars['ISO8601Date']['output'];
};

export type MasterHomepageError = {
  __typename?: 'MasterHomepageError';
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type MasterHomepageFilterInput = {
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  warehouseId: Scalars['ID']['input'];
};

export type MasterHomepageListItem = {
  __typename?: 'MasterHomepageListItem';
  endDate: Scalars['ISO8601Date']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  startDate: Scalars['ISO8601Date']['output'];
};

export type MasterHomepageRow = {
  __typename?: 'MasterHomepageRow';
  components: Array<MasterHomepageRowComponent>;
  id: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
  structureType: MasterHomepageRowStructureType;
};

export type MasterHomepageRowComponent = {
  __typename?: 'MasterHomepageRowComponent';
  catalogComponentId: Scalars['ID']['output'];
  collection?: Maybe<Collection>;
  collectionId: Scalars['ID']['output'];
  componentType: MasterHomepageRowStructureType;
  desktopImage?: Maybe<Scalars['String']['output']>;
  desktopImageUrl?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['ISO8601Date']['output'];
  fontStyle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  mobileImage?: Maybe<Scalars['String']['output']>;
  mobileImageUrl?: Maybe<Scalars['String']['output']>;
  sortOrder: Scalars['Int']['output'];
  startDate: Scalars['ISO8601Date']['output'];
  warehouseIds: Array<Scalars['ID']['output']>;
};

export enum MasterHomepageRowStructureType {
  CollectionBanner = 'collectionBanner',
  CollectionCarousel = 'collectionCarousel',
  CollectionHighlightCarousel = 'collectionHighlightCarousel',
  NewItemsCarousel = 'newItemsCarousel',
  TrendingItemsCarousel = 'trendingItemsCarousel'
}

/** Menu. */
export type Menu = Node & {
  __typename?: 'Menu';
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID']['output'];
  /** Menu's current lock version, providing concurrency control and protection against stale updates. */
  lockVersion: Scalars['Int']['output'];
  /** Name. */
  name: Scalars['String']['output'];
  /** The order of the menu in the UI. */
  sortOrder: Scalars['Int']['output'];
  /** Submenus. */
  submenus: Array<Submenu>;
  /** Visibility. */
  visibility: Visibility;
};

/** Menu item. */
export type MenuItem = Node & {
  __typename?: 'MenuItem';
  /** Description. */
  description: Scalars['String']['output'];
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID']['output'];
  /** Menu item's current lock version, providing concurrency control and protection against stale updates. */
  lockVersion: Scalars['Int']['output'];
  /** Modifier groups for the menu item. */
  menuItemModifierGroups: Array<MenuItemModifierGroup>;
  /** Menu item sizes. */
  menuItemSizes: Array<MenuItemSize>;
  /** Name. */
  name: Scalars['String']['output'];
  /** The order of the menu item in the UI. */
  sortOrder: Scalars['Int']['output'];
  /** UUID. */
  uuid: Scalars['ID']['output'];
  /** Visibility. */
  visibility: Visibility;
};

/** Menu item modifier group. */
export type MenuItemModifierGroup = Node & {
  __typename?: 'MenuItemModifierGroup';
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID']['output'];
  /** Maximum selections. */
  maximumSelections?: Maybe<Scalars['Int']['output']>;
  /** Menu item modifier options for this group. */
  menuItemModifierOptions: Array<MenuItemModifierOption>;
  /** Minimum selections. */
  minimumSelections: Scalars['Int']['output'];
  /** Name. */
  name: Scalars['String']['output'];
};

/** Menu item modifier option. */
export type MenuItemModifierOption = Node & {
  __typename?: 'MenuItemModifierOption';
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID']['output'];
  /** Name. */
  name: Scalars['String']['output'];
  /** Price. */
  price: Money;
};

/** MenuItem mutation result. */
export type MenuItemResult = ErrorsResult | MenuItemSuccess;

/** Menu item size. */
export type MenuItemSize = Node & {
  __typename?: 'MenuItemSize';
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID']['output'];
  /** Name. */
  name: Scalars['String']['output'];
  /** Unit price. */
  price: Money;
  /** UUID. */
  uuid: Scalars['ID']['output'];
};

/** Input for a menu item size. */
export type MenuItemSizeInput = {
  /** Name of the size */
  name: Scalars['String']['input'];
  /** Price */
  price: MoneyInput;
  /** UUID. Include this when updating an existing size. */
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

/** Result of a successful menu-item mutation. */
export type MenuItemSuccess = {
  __typename?: 'MenuItemSuccess';
  /** Resulting menu-item. */
  menuItem: MenuItem;
};

export type MenuItemsForMerchant = {
  __typename?: 'MenuItemsForMerchant';
  /** List of relevant menu items belonging to merchant. */
  menuItems: Array<MenuItem>;
  /** Merchant. */
  merchant: Merchant;
};

/** Result of mutating a list of menu items. */
export type MenuItemsResult = ErrorsResult | MenuItemsSuccess;

/** Result of successfully mutating a list of menu items. */
export type MenuItemsSuccess = {
  __typename?: 'MenuItemsSuccess';
  /** Resulting menu-items. */
  menuItems: Array<MenuItem>;
};

/** Menu mutation result. */
export type MenuResult = ErrorsResult | MenuSuccess;

/** Result of a successful menu mutation. */
export type MenuSuccess = {
  __typename?: 'MenuSuccess';
  /** Resulting menu. */
  menu: Menu;
};

/** Result of mutating a list of menus. */
export type MenusResult = ErrorsResult | MenusSuccess;

/** Result of successfully mutating a list of menus. */
export type MenusSuccess = {
  __typename?: 'MenusSuccess';
  /** Resulting menus. */
  menus: Array<Menu>;
};

/** Merchant. */
export type Merchant = Node & {
  __typename?: 'Merchant';
  /** Top-level company the merchant belongs to. */
  business: Business;
  /** Cover photo URLs. */
  coverPhotoUrls: Array<Scalars['String']['output']>;
  /** Whether curbside pickup is offered. */
  curbsidePickup: Scalars['Boolean']['output'];
  /** The primary key from the database. */
  databaseId: Scalars['Int']['output'];
  /** Display address */
  displayAddress: Scalars['String']['output'];
  /** Full address */
  fullAddress: Scalars['String']['output'];
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID']['output'];
  /** Latitude. */
  latitude: Scalars['Float']['output'];
  /** Merchant's current lock version, providing concurrency control and protection against stale updates. */
  lockVersion: Scalars['Int']['output'];
  /** Logo URL. */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** Longitude. */
  longitude: Scalars['Float']['output'];
  /** Menus. */
  menus: Array<Menu>;
  /** Minimum notice an order can be placed in advance of its pickup time. */
  minimumNotice: RelativeTime;
  /** Modifier groups. */
  modifierGroups: Array<ModifierGroup>;
  /** Name */
  name: Scalars['String']['output'];
  /** In-app notification sound */
  notificationSound: Scalars['String']['output'];
  /** Hours of operation in merchant's time zone. Order pickup times cannot be outside the bounds described by these hours. */
  operatingHours: Array<OperatingHoursForDayOfWeek>;
  /** Operating status info. */
  operatingStatus: MerchantOperatingStatus;
  /** Maximum number of days an order can be placed in advance of its pickup time. */
  orderAheadNumDays: Scalars['Int']['output'];
  /** Order queue. */
  orderQueue: OrderQueue;
  /** Phone number. */
  phone?: Maybe<Scalars['String']['output']>;
  /** @deprecated See the minimumNotice field instead. */
  pickupDelayMinutes: Scalars['Int']['output'];
  /** Pickup text. */
  pickupText?: Maybe<Scalars['String']['output']>;
  /** Street address */
  streetAddress: Scalars['String']['output'];
  /** Time zone. */
  timezone: Scalars['String']['output'];
  /** Whether tips are enabled. */
  tipsEnabled: Scalars['Boolean']['output'];
};


/** Merchant. */
export type MerchantMenusArgs = {
  includeEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Merchant. */
export type MerchantOrderQueueArgs = {
  asOf?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Merchant app viewer information. */
export type MerchantAppUser = {
  __typename?: 'MerchantAppUser';
  /** Email. Null if client authenticated using Auth0. Such clients should get the email from the Auth0-issued ID token instead. */
  email?: Maybe<Scalars['String']['output']>;
  /** Fetches a merchant given its ID */
  merchant?: Maybe<Merchant>;
  /** Merchants the current user is authorized to access */
  merchants: MerchantConnection;
};


/** Merchant app viewer information. */
export type MerchantAppUserMerchantArgs = {
  id: Scalars['ID']['input'];
};


/** Merchant app viewer information. */
export type MerchantAppUserMerchantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Error indicating that a mutation failed because the merchant is closed at the requested time. */
export type MerchantClosureError = Error & {
  __typename?: 'MerchantClosureError';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

export type MerchantClosureInterval = AvailabilityInterval & {
  __typename?: 'MerchantClosureInterval';
  /** Lower bound. */
  lowerBound: Scalars['ISO8601DateTime']['output'];
  /** Upper bound. */
  upperBound: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for Merchant. */
export type MerchantConnection = {
  __typename?: 'MerchantConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MerchantEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Merchant>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type MerchantEdge = {
  __typename?: 'MerchantEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Merchant>;
};

/** Error indicating that a mutation failed because the merchant is not active. */
export type MerchantNotActive = Error & {
  __typename?: 'MerchantNotActive';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Input for updating a merchant's operating hours on day. */
export type MerchantOperatingHoursForDayOfWeekInput = {
  /** Operating hours intervals. May spill over into the following day. */
  intervals: Array<OperatingHoursIntervalInput>;
};

/** Merchant operating status info. */
export type MerchantOperatingStatus = {
  __typename?: 'MerchantOperatingStatus';
  /** Most-recently saved status. */
  lastSavedStatus: MerchantStatusEnum;
  /** Next closing time. */
  nextClose?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Next opening time. */
  nextOpen?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Merchant mutation result. */
export type MerchantResult = ErrorsResult | MerchantSuccess;

/** The possible states a merchant's status can return */
export enum MerchantStatusEnum {
  /** Busy. */
  Busy = 'busy',
  /** Closed. */
  Closed = 'closed',
  /** Open. */
  Open = 'open'
}

/** Result of a successful merchant mutation. */
export type MerchantSuccess = {
  __typename?: 'MerchantSuccess';
  /** Resulting merchant. */
  merchant: Merchant;
};

/**
 * Meta advertising identifiers observed in the browser during signup, used to
 * attribute the signup to the ad click that produced it.
 */
export type MetaTrackingInput = {
  /** Identifier shared with the browser's conversion event so Meta counts the two as one conversion rather than two. */
  eventId?: InputMaybe<Scalars['String']['input']>;
  /** URL of the page the signup was completed on. */
  eventSourceUrl?: InputMaybe<Scalars['String']['input']>;
  /** Value of the _fbc cookie, or one derived from the fbclid parameter on the landing URL, identifying the ad click. */
  fbc?: InputMaybe<Scalars['String']['input']>;
  /** Value of the _fbp cookie, which the Meta Pixel sets to identify the browser. */
  fbp?: InputMaybe<Scalars['String']['input']>;
};

export type MetrobiAssignmentBlocked = UserErrorInterface & {
  __typename?: 'MetrobiAssignmentBlocked';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  offenders: Array<MetrobiExcludedStop>;
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** A selected stop whose location or company is excluded from Metrobi. */
export type MetrobiExcludedStop = {
  __typename?: 'MetrobiExcludedStop';
  address?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  locationId: Scalars['ID']['output'];
  stopId: Scalars['ID']['output'];
};

/** Represents an action that can be performed on a microsite location. */
export type MicrositeAction = {
  __typename?: 'MicrositeAction';
  /** URL of the background image */
  backgroundImageUrl?: Maybe<Scalars['String']['output']>;
  /** Background color of the button for the action */
  buttonBackgroundColor?: Maybe<Scalars['String']['output']>;
  /** Text color of the action button */
  buttonTextColor?: Maybe<Scalars['String']['output']>;
  /** Content to be displayed in the modal or link, if applicable */
  content?: Maybe<Scalars['String']['output']>;
  /** How the action should be displayed, e.g., 'modal', 'link' etc. */
  displayType?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the action */
  id: Scalars['ID']['output'];
  /** Name of the action */
  name?: Maybe<Scalars['String']['output']>;
  /** Boolean to determine if the link should be opened in a new window */
  openInNewWindow?: Maybe<Scalars['Boolean']['output']>;
  /** URL to perform the action, like a WiFi login page or review page */
  url?: Maybe<Scalars['String']['output']>;
};

export type MicrositeActionInput = {
  backgroundImageUrl?: InputMaybe<Scalars['String']['input']>;
  buttonBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  buttonTextColor?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  displayType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  openInNewWindow: Scalars['Boolean']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type MicrositeActionsInput = {
  actions?: InputMaybe<Array<MicrositeActionInput>>;
  visible: Scalars['Boolean']['input'];
};

export type MicrositeAdInfoInput = {
  /** Image URL for the WiFi/Restroom ad */
  adImageUrl: Scalars['String']['input'];
  /** Link to the WiFi/Restroom ad */
  adLink: Scalars['String']['input'];
};

/** Represents a barista profile for a microsite location. */
export type MicrositeBaristaProfile = {
  __typename?: 'MicrositeBaristaProfile';
  /** Barista link address: Link address for the barista */
  baristaLinkAddress?: Maybe<Scalars['String']['output']>;
  /** Barista link title: Title for the barista's link */
  baristaLinkTitle?: Maybe<Scalars['String']['output']>;
  /** Blurb or bio: Text about the barista */
  bio?: Maybe<Scalars['String']['output']>;
  /** First name: name of the barista */
  firstName: Scalars['String']['output'];
  /** Unique identifier for the barista profile */
  id: Scalars['ID']['output'];
  /** Image url: Url of the image of the barista */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Pronouns: Pronouns of the barista */
  pronouns?: Maybe<Scalars['String']['output']>;
};

export type MicrositeBusinessProfileInput = {
  businessAddress?: InputMaybe<Scalars['String']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  fridayHours?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  /** Logo URL. This can be any URL. */
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  mondayHours?: InputMaybe<Scalars['String']['input']>;
  saturdayHours?: InputMaybe<Scalars['String']['input']>;
  sundayHours?: InputMaybe<Scalars['String']['input']>;
  thursdayHours?: InputMaybe<Scalars['String']['input']>;
  tuesdayHours?: InputMaybe<Scalars['String']['input']>;
  wednesdayHours?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a calendar event for a microsite location. */
export type MicrositeCalendarEvent = {
  __typename?: 'MicrositeCalendarEvent';
  /** Copy for the action button associated with the event */
  actionButtonCopy?: Maybe<Scalars['String']['output']>;
  /** Date of the calendar event */
  date: Scalars['ISO8601Date']['output'];
  /** Description of the calendar event */
  description?: Maybe<Scalars['String']['output']>;
  /** The address to display for the event */
  displayAddress: Scalars['String']['output'];
  /** End time of the calendar event (HH:MM format) */
  endTime?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the calendar event */
  id: Scalars['ID']['output'];
  /** URL of the image associated with the calendar event */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Google Maps URL for the event location */
  locationUrl?: Maybe<Scalars['String']['output']>;
  /** Link for RSVPing to the calendar event */
  rsvpLink?: Maybe<Scalars['String']['output']>;
  /** Start time of the calendar event (HH:MM format) */
  time?: Maybe<Scalars['String']['output']>;
  /** Title of the calendar event */
  title: Scalars['String']['output'];
};

export type MicrositeCalendarEventItemInput = {
  buttonCopy?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['ISO8601Date']['input'];
  description: Scalars['String']['input'];
  displayAddress: Scalars['String']['input'];
  /** End time in HH:MM format (optional) */
  endTime?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  locationUrl?: InputMaybe<Scalars['String']['input']>;
  rsvpLink?: InputMaybe<Scalars['String']['input']>;
  /** Start time in HH:MM format */
  time?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type MicrositeCalendarEventsInput = {
  events?: InputMaybe<Array<MicrositeCalendarEventItemInput>>;
  visible: Scalars['Boolean']['input'];
};

/** Check-in to win module configuration */
export type MicrositeCheckInConfig = {
  __typename?: 'MicrositeCheckInConfig';
  /** Description of the prize/contest */
  description?: Maybe<Scalars['String']['output']>;
  /** When the module was last disabled */
  disabledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether the module is currently enabled */
  enabled: Scalars['Boolean']['output'];
  /** When the module was last enabled */
  enabledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** URL to view the check-in contacts in the unified contacts sheet */
  googleSheetUrl?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the config */
  id: Scalars['ID']['output'];
  /** URL of the prize image */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Maximum total winners allowed (nil = unlimited) */
  maxTotalWinners?: Maybe<Scalars['Int']['output']>;
  /** Maximum winners allowed per day (nil = unlimited) */
  maxWinnersPerDay?: Maybe<Scalars['Int']['output']>;
  /** The microsite location this config belongs to */
  micrositeLocationId: Scalars['ID']['output'];
  /** Name of the prize */
  prizeName: Scalars['String']['output'];
  /** When terms were accepted */
  termsAcceptedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Title of the check-in module */
  title: Scalars['String']['output'];
  /** Probability of winning (0.0 to 1.0) */
  winProbability: Scalars['Float']['output'];
};

export type MicrositeCheckInInput = {
  /** Description of the prize/contest */
  description?: InputMaybe<Scalars['String']['input']>;
  /** URL of the prize image */
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  /** Maximum total winners allowed (null = unlimited) */
  maxTotalWinners?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum winners allowed per day (null = unlimited) */
  maxWinnersPerDay?: InputMaybe<Scalars['Int']['input']>;
  /** Name of the prize */
  prizeName: Scalars['String']['input'];
  /** When terms were accepted */
  termsAcceptedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Title of the check-in module */
  title: Scalars['String']['input'];
  /** Whether the check-in to win module is visible on the microsite */
  visible: Scalars['Boolean']['input'];
  /** Probability of winning (0.0 to 1.0) */
  winProbability: Scalars['Float']['input'];
};

export type MicrositeCoffeeGrindInput = {
  visible: Scalars['Boolean']['input'];
};

/** A guest contact for a microsite location */
export type MicrositeContact = {
  __typename?: 'MicrositeContact';
  createdAt: Scalars['ISO8601DateTime']['output'];
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  micrositeLocationId: Scalars['ID']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type MicrositeContactInput = {
  /** Business contact email address */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Business contact phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Whether the contact module is visible on the microsite */
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MicrositeCuppyInput = {
  visible: Scalars['Boolean']['input'];
};

export type MicrositeLocation = {
  __typename?: 'MicrositeLocation';
  /** List of actions available for the microsite location. */
  actions: Array<MicrositeAction>;
  /** List of barista profiles associated with the microsite location. */
  baristaProfiles: Array<MicrositeBaristaProfile>;
  /** List of calendar events for the microsite location. */
  calendarEvents: Array<MicrositeCalendarEvent>;
  /** Check-in configuration for the microsite location. */
  checkInConfig?: Maybe<MicrositeCheckInConfig>;
  /** Business contact email for the microsite location. */
  contactEmail?: Maybe<Scalars['String']['output']>;
  /** Business contact phone number for the microsite location. */
  contactPhone?: Maybe<Scalars['String']['output']>;
  /** The current poll for the microsite location, if any. */
  currentPoll?: Maybe<MicrositePoll>;
  /** All current active polls for the microsite location. */
  currentPolls: Array<MicrositePoll>;
  /** List of enabled modules for the microsite location. */
  enabledModules: Array<MicrositeModule>;
  /** Operating hours for Friday. */
  fridayHours?: Maybe<Scalars['String']['output']>;
  /** Link to the Google reviews for the microsite location. */
  googleReviewLink?: Maybe<Scalars['String']['output']>;
  /** URL to the unified contacts Google Sheet for this location. */
  googleSheetUrl?: Maybe<Scalars['String']['output']>;
  /** The URL of the hero image for the microsite location. */
  heroImageUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  /** The URL of the logo for the microsite location. */
  logoUrl?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  /** Mailing list configuration for the microsite location. */
  mailingList?: Maybe<MicrositeMailingList>;
  /** Media sections for the microsite location. */
  mediaSections: Array<MicrositeMediaSection>;
  /** List of menu items associated with the microsite location. */
  menuItems: Array<MicrositeMenuItem>;
  /** List of messages associated with the microsite location. */
  messages: Array<MicrositeMessage>;
  /** Operating hours for Monday. */
  mondayHours?: Maybe<Scalars['String']['output']>;
  /** Photobooth configuration for the microsite location. */
  photoboothConfig?: Maybe<MicrositePhotoboothConfig>;
  /** List of all polls associated with the microsite location. */
  polls: Array<MicrositePoll>;
  /** List of posts associated with the microsite location. */
  posts: Array<MicrositePost>;
  /** The QR code for this microsite location. */
  qrCode?: Maybe<MarketingQrCode>;
  /** List of relevant reviews for the microsite location. */
  relevantReviews?: Maybe<Array<MicrositeRelevantReview>>;
  /** Restroom code information for the microsite location. */
  restroomCode?: Maybe<MicrositeRestroom>;
  /** Operating hours for Saturday. */
  saturdayHours?: Maybe<Scalars['String']['output']>;
  /** The subtitle of the microsite location. */
  siteSubtitle?: Maybe<Scalars['String']['output']>;
  /** The title of the microsite location. */
  siteTitle?: Maybe<Scalars['String']['output']>;
  /** List of social media platforms associated with the microsite location. */
  socialPlatforms: Array<MicrositeSocialPlatform>;
  /** Suggestion box configuration for the microsite location. */
  suggestionConfig?: Maybe<MicrositeSuggestionConfig>;
  /** Operating hours for Sunday. */
  sundayHours?: Maybe<Scalars['String']['output']>;
  /** The title for the team profile section if the module is enabled */
  teamProfileSectionTitle?: Maybe<Scalars['String']['output']>;
  /** Theme information for the microsite location. */
  theme?: Maybe<MicrositeTheme>;
  /** The theme color for the microsite location. */
  themeColor?: Maybe<Scalars['String']['output']>;
  /** Operating hours for Thursday. */
  thursdayHours?: Maybe<Scalars['String']['output']>;
  timeZone: MicrositeTimeZone;
  /** Operating hours for Tuesday. */
  tuesdayHours?: Maybe<Scalars['String']['output']>;
  urlId: Scalars['String']['output'];
  /** Operating hours for Wednesday. */
  wednesdayHours?: Maybe<Scalars['String']['output']>;
  /** WiFi information for the microsite location. */
  wifiInfo?: Maybe<MicrositeWifi>;
};

/** An admin-only view of a microsite location */
export type MicrositeLocationAdmin = {
  __typename?: 'MicrositeLocationAdmin';
  /** Stream for the config document of the microsite location */
  configDocStream?: Maybe<Stream>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Google Doc ID for the microsite location */
  googleDocId?: Maybe<Scalars['String']['output']>;
  /** Google Doc URL for the microsite location */
  googleDocUrl?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the microsite location */
  id: Scalars['ID']['output'];
  /** UUID of the onboarded location, if the microsite is for an onboarded location */
  locationUuid?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** URL parameter value for the microsite location, like 'birch-14th' in `/microsite/birch-14th` */
  urlId: Scalars['ID']['output'];
};

/** The connection type for MicrositeLocationAdmin. */
export type MicrositeLocationAdminConnection = {
  __typename?: 'MicrositeLocationAdminConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MicrositeLocationAdminEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<MicrositeLocationAdmin>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of records in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MicrositeLocationAdminEdge = {
  __typename?: 'MicrositeLocationAdminEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<MicrositeLocationAdmin>;
};

/** Configuration and metadata for a microsite mailing list */
export type MicrositeMailingList = {
  __typename?: 'MicrositeMailingList';
  buttonText?: Maybe<Scalars['String']['output']>;
  collectEmail?: Maybe<Scalars['Boolean']['output']>;
  collectFirstName?: Maybe<Scalars['Boolean']['output']>;
  collectLastName?: Maybe<Scalars['Boolean']['output']>;
  collectPhoneNumber?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  googleSheetId?: Maybe<Scalars['String']['output']>;
  /** URL to view the mailing list Google Sheet */
  googleSheetUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  micrositeLocationId: Scalars['ID']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type MicrositeMailingListInput = {
  /** Text displayed on the submit button */
  buttonText?: InputMaybe<Scalars['String']['input']>;
  /** Whether to collect email address from guests */
  collectEmail: Scalars['Boolean']['input'];
  /** Whether to collect first name from guests */
  collectFirstName: Scalars['Boolean']['input'];
  /** Whether to collect last name from guests */
  collectLastName: Scalars['Boolean']['input'];
  /** Whether to collect phone number from guests */
  collectPhoneNumber: Scalars['Boolean']['input'];
  /** URL of the image displayed with the mailing list form */
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  /** Subtitle text displayed on the mailing list form */
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** Title text displayed on the mailing list form */
  title: Scalars['String']['input'];
  /** Whether the mailing list module is visible on the microsite */
  visible: Scalars['Boolean']['input'];
};

/** Input for updating the media module */
export type MicrositeMediaInput = {
  /** Media sections to create/update. Sections not included will be deleted. */
  sections?: InputMaybe<Array<MicrositeMediaSectionInput>>;
  /** Whether the media module is visible */
  visible: Scalars['Boolean']['input'];
};

/** Represents an individual media item (image or video) within a media section. */
export type MicrositeMediaItem = {
  __typename?: 'MicrositeMediaItem';
  /** Alt text for accessibility */
  altText?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the media item */
  id: Scalars['ID']['output'];
  /** Type of media: 'image' or 'video' */
  mediaType: Scalars['String']['output'];
  /** Display order within the section (0-indexed) */
  position: Scalars['Int']['output'];
  /** URL to the media file */
  url: Scalars['String']['output'];
};

/** Input for an individual media item (image or video) */
export type MicrositeMediaItemInput = {
  /** Alt text for accessibility */
  altText?: InputMaybe<Scalars['String']['input']>;
  /** ID of existing item to update. Omit for new items. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Type of media: 'image' or 'video' */
  mediaType: Scalars['String']['input'];
  /** URL to the media file */
  url: Scalars['String']['input'];
};

/** Represents a media section (block) containing images or videos for a microsite location. */
export type MicrositeMediaSection = {
  __typename?: 'MicrositeMediaSection';
  /** Unique identifier for the media section */
  id: Scalars['ID']['output'];
  /** Media items within this section, ordered by position */
  mediaItems: Array<MicrositeMediaItem>;
  /** Title of the media section */
  title: Scalars['String']['output'];
};

/** Input for a media section (block) */
export type MicrositeMediaSectionInput = {
  /** ID of existing section to update. Omit for new sections. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Media items within this section. Items not included will be deleted. */
  items?: InputMaybe<Array<MicrositeMediaItemInput>>;
  /** Title for the media section */
  title: Scalars['String']['input'];
};

/** Represents a menu item for a microsite location. */
export type MicrositeMenuItem = {
  __typename?: 'MicrositeMenuItem';
  /** Category of the menu item */
  category?: Maybe<Scalars['String']['output']>;
  /** Description of the menu item */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the menu item */
  id: Scalars['ID']['output'];
  /** Image URL for the menu item */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Name of the menu item */
  name?: Maybe<Scalars['String']['output']>;
  /** Indicates if the menu item is popular */
  popular?: Maybe<Scalars['Boolean']['output']>;
  /** Price of the menu item in US cents */
  priceUsCents?: Maybe<Scalars['Int']['output']>;
  /** Weather categories applicable to the menu item */
  weatherCategories: Array<Scalars['String']['output']>;
};

export type MicrositeMenuItemInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Required for updates, leave blank for creates. */
  id?: InputMaybe<Scalars['ID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  popular?: InputMaybe<Scalars['Boolean']['input']>;
  priceUsCents?: InputMaybe<Scalars['Int']['input']>;
  weatherCategories?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Represents a message that can be sent to a microsite location. */
export type MicrositeMessage = {
  __typename?: 'MicrositeMessage';
  /** Unique identifier for the message */
  id: Scalars['ID']['output'];
  ip?: Maybe<Scalars['String']['output']>;
  /** Content of the message */
  message?: Maybe<Scalars['String']['output']>;
  /** Timestamp of when the message was updated in MTS */
  timestamp?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** The type of module that can be enabled for a microsite location. */
export enum MicrositeModule {
  Actions = 'ACTIONS',
  BaristaProfiles = 'BARISTA_PROFILES',
  CalendarEvents = 'CALENDAR_EVENTS',
  CheckInToWin = 'CHECK_IN_TO_WIN',
  CoffeeGrind = 'COFFEE_GRIND',
  Contact = 'CONTACT',
  Cuppy = 'CUPPY',
  MailingList = 'MAILING_LIST',
  Media = 'MEDIA',
  Photobooth = 'PHOTOBOOTH',
  PollOfTheDay = 'POLL_OF_THE_DAY',
  RelevantReviews = 'RELEVANT_REVIEWS',
  Restroom = 'RESTROOM',
  Socials = 'SOCIALS',
  SuggestedMenu = 'SUGGESTED_MENU',
  SuggestionBox = 'SUGGESTION_BOX',
  Wifi = 'WIFI'
}

/** Photobooth module configuration */
export type MicrositePhotoboothConfig = {
  __typename?: 'MicrositePhotoboothConfig';
  /** Custom button text for the photobooth */
  buttonText?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the config */
  id: Scalars['ID']['output'];
  /** URL of the module header image */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** URL of the prompt image for AI generation */
  promptImageUrl?: Maybe<Scalars['String']['output']>;
  /** Custom prompt text for AI image generation */
  promptText?: Maybe<Scalars['String']['output']>;
};

export type MicrositePhotoboothInput = {
  /** Custom button text for the photobooth */
  buttonText?: InputMaybe<Scalars['String']['input']>;
  /** URL of the module header image */
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  /** URL of the prompt image for AI generation */
  promptImageUrl?: InputMaybe<Scalars['String']['input']>;
  /** Custom prompt text for AI image generation */
  promptText?: InputMaybe<Scalars['String']['input']>;
  /** Whether the photobooth module is visible on the microsite */
  visible: Scalars['Boolean']['input'];
};

export type MicrositePoll = {
  __typename?: 'MicrositePoll';
  /** @deprecated Use 'answers' field instead */
  answer1: Scalars['String']['output'];
  /** @deprecated Use 'answers' field instead */
  answer2: Scalars['String']['output'];
  answers: Array<MicrositePollAnswerObject>;
  endDate: Scalars['ISO8601Date']['output'];
  id: Scalars['ID']['output'];
  question: Scalars['String']['output'];
  startDate: Scalars['ISO8601Date']['output'];
  /** @deprecated Use 'answers' field instead */
  votes1: Scalars['Int']['output'];
  /** @deprecated Use 'answers' field instead */
  votes2: Scalars['Int']['output'];
};

export enum MicrositePollAnswer {
  /** The first answer option for the poll */
  Answer1 = 'ANSWER1',
  /** The second answer option for the poll */
  Answer2 = 'ANSWER2'
}

export type MicrositePollAnswerInput = {
  /** ID for existing answers (omit for new answers) */
  id?: InputMaybe<Scalars['ID']['input']>;
  text: Scalars['String']['input'];
};

export type MicrositePollAnswerObject = {
  __typename?: 'MicrositePollAnswerObject';
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  votes: Scalars['Int']['output'];
};

export type MicrositePollItemInput = {
  /** Array of poll answers (use this for new frontend) */
  answers?: InputMaybe<Array<MicrositePollAnswerInput>>;
  endDate: Scalars['ISO8601Date']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  question: Scalars['String']['input'];
  startDate: Scalars['ISO8601Date']['input'];
};

export type MicrositePollsInput = {
  polls?: InputMaybe<Array<MicrositePollItemInput>>;
  visible: Scalars['Boolean']['input'];
};

/** Represents a post on a microsite location from the location's management, for instance about an upcoming event. */
export type MicrositePost = {
  __typename?: 'MicrositePost';
  /** Body content of the post */
  body?: Maybe<Scalars['String']['output']>;
  /** Date of the post */
  date?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Unique identifier for the post */
  id: Scalars['ID']['output'];
  /** Title of the post */
  title?: Maybe<Scalars['String']['output']>;
  /** URL for the CTA of the post */
  url?: Maybe<Scalars['String']['output']>;
};

export type MicrositeRelevantReview = {
  __typename?: 'MicrositeRelevantReview';
  /** Date when the review was written. */
  date?: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  /** Name of the reviewer. */
  name?: Maybe<Scalars['String']['output']>;
  /** URL of the reviewer's profile image. */
  profileImage?: Maybe<Scalars['String']['output']>;
  /** Rating given by the reviewer. */
  rating?: Maybe<Scalars['Int']['output']>;
  /** Content of the review. */
  review?: Maybe<Scalars['String']['output']>;
  /** Subtitle or additional information about the reviewer. */
  subtitle?: Maybe<Scalars['String']['output']>;
};

export type MicrositeRelevantReviewInput = {
  googleReviewLink: Scalars['String']['input'];
  reviews?: InputMaybe<Array<MicrositeRelevantReviewItemInput>>;
};

export type MicrositeRelevantReviewItemInput = {
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  profileImageUrl?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  review?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
};

export type MicrositeRelevantReviewsModuleInput = {
  visible: Scalars['Boolean']['input'];
};

export type MicrositeRestroom = {
  __typename?: 'MicrositeRestroom';
  adImage?: Maybe<Scalars['String']['output']>;
  adLink?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type MicrositeRestroomInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  visible: Scalars['Boolean']['input'];
};

export type MicrositeScansData = {
  __typename?: 'MicrositeScansData';
  businessName?: Maybe<Scalars['String']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  last7Days: MicrositeScansTimePeriod;
  last14Days: MicrositeScansTimePeriod;
  last30Days: MicrositeScansTimePeriod;
};

export type MicrositeScansTimePeriod = {
  __typename?: 'MicrositeScansTimePeriod';
  /** Percent change in scan count since the previous period. Null if the previous period had no scans. */
  percentChange?: Maybe<Scalars['Float']['output']>;
  /** Total number of scans that occurred during the time period, summed across all QR codes tied to the microsite location. */
  scanCount: Scalars['Int']['output'];
};

/** Represents a social platform associated with a microsite location. */
export type MicrositeSocialPlatform = {
  __typename?: 'MicrositeSocialPlatform';
  /** Icon URL for the social platform */
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Name of the social platform */
  name?: Maybe<Scalars['String']['output']>;
  /** URL of the social platform */
  url?: Maybe<Scalars['String']['output']>;
};

export type MicrositeSocialPlatformInput = {
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type MicrositeSocialsInput = {
  socialPlatforms?: InputMaybe<Array<MicrositeSocialPlatformInput>>;
  visible: Scalars['Boolean']['input'];
};

export type MicrositeSuggestedMenuInput = {
  visible: Scalars['Boolean']['input'];
};

/** Suggestion box module configuration */
export type MicrositeSuggestionConfig = {
  __typename?: 'MicrositeSuggestionConfig';
  /** Whether anonymous submissions are allowed */
  allowAnonymous: Scalars['Boolean']['output'];
  /** Description of the suggestion box */
  description?: Maybe<Scalars['String']['output']>;
  /** Google Sheet ID for submissions */
  googleSheetId?: Maybe<Scalars['String']['output']>;
  /** URL to view the suggestion box contacts in the unified contacts sheet */
  googleSheetUrl?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the config */
  id: Scalars['ID']['output'];
  /** URL of the suggestion box image */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Subtitle of the suggestion box */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Title of the suggestion box */
  title?: Maybe<Scalars['String']['output']>;
};

export type MicrositeSuggestionConfigInput = {
  /** Whether anonymous submissions are allowed */
  allowAnonymous: Scalars['Boolean']['input'];
  /** Description of the suggestion box */
  description?: InputMaybe<Scalars['String']['input']>;
  /** URL of the header image */
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  /** Subtitle of the suggestion box module */
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** Title of the suggestion box module */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Whether the suggestion box module is visible on the microsite */
  visible: Scalars['Boolean']['input'];
};

/** A suggestion box submission entry */
export type MicrositeSuggestionEntry = {
  __typename?: 'MicrositeSuggestionEntry';
  /** Email of the submitter (if provided) */
  contactEmail?: Maybe<Scalars['String']['output']>;
  /** Name of the submitter (if provided) */
  contactName?: Maybe<Scalars['String']['output']>;
  /** When the suggestion was submitted */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The feedback text submitted */
  feedback: Scalars['String']['output'];
  /** Unique identifier for the entry */
  id: Scalars['ID']['output'];
  /** Whether the submission was anonymous */
  isAnonymous: Scalars['Boolean']['output'];
  /** AI-classified sentiment (positive, negative, neutral) */
  sentiment: Scalars['String']['output'];
  /** Confidence score from 0.0 to 1.0 */
  sentimentScore: Scalars['Float']['output'];
};

export type MicrositeTeamProfileItemInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  linkTitle?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pictureUrl?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
};

export type MicrositeTeamProfilesInput = {
  profiles?: InputMaybe<Array<MicrositeTeamProfileItemInput>>;
  /** Title for the team profile section */
  title?: InputMaybe<Scalars['String']['input']>;
  visible: Scalars['Boolean']['input'];
};

export type MicrositeTheme = {
  __typename?: 'MicrositeTheme';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  primaryColor?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  tertiaryColor?: Maybe<Scalars['String']['output']>;
  textColor?: Maybe<Scalars['String']['output']>;
};

export type MicrositeThemeInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  tertiaryColor?: InputMaybe<Scalars['String']['input']>;
  textColor?: InputMaybe<Scalars['String']['input']>;
};

/** Enum for our standard US zones. */
export enum MicrositeTimeZone {
  AmericaAnchorage = 'AMERICA_ANCHORAGE',
  AmericaBoise = 'AMERICA_BOISE',
  AmericaChicago = 'AMERICA_CHICAGO',
  AmericaDenver = 'AMERICA_DENVER',
  AmericaLosAngeles = 'AMERICA_LOS_ANGELES',
  AmericaNewYork = 'AMERICA_NEW_YORK',
  AmericaPhoenix = 'AMERICA_PHOENIX',
  PacificHonolulu = 'PACIFIC_HONOLULU'
}

/** A Microsite Time Zone Option. Use to build select lists of time zones. */
export type MicrositeTimeZoneOption = {
  __typename?: 'MicrositeTimeZoneOption';
  label: Scalars['String']['output'];
  value: MicrositeTimeZone;
};

export type MicrositeUrlValidationResult = {
  __typename?: 'MicrositeUrlValidationResult';
  /** Error message if validation fails */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Whether the microsite URL is available */
  isValid: Scalars['Boolean']['output'];
};

export type MicrositeWifi = {
  __typename?: 'MicrositeWifi';
  adImage?: Maybe<Scalars['String']['output']>;
  adLink?: Maybe<Scalars['String']['output']>;
  disclaimerText?: Maybe<Scalars['String']['output']>;
  emailFormHeaderText?: Maybe<Scalars['String']['output']>;
  /** URL to view the WiFi contacts in the unified contacts sheet */
  googleSheetUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  networkName?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  requireEmailForAccess: Scalars['Boolean']['output'];
};

export type MicrositeWifiInput = {
  disclaimerText?: InputMaybe<Scalars['String']['input']>;
  emailFormHeaderText?: InputMaybe<Scalars['String']['input']>;
  networkName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  requireEmailForAccess?: InputMaybe<Scalars['Boolean']['input']>;
  visible: Scalars['Boolean']['input'];
};

/** Sort direction for microsites */
export enum MicrositesSortDirection {
  /** Ascending, nulls last. */
  Asc = 'ASC',
  /** Descending, nulls first. */
  Desc = 'DESC'
}

/** Sort key for microsites */
export enum MicrositesSortKey {
  /** Sort by created_at */
  CreatedAt = 'CREATED_AT',
  /** Sort by url_id */
  UrlId = 'URL_ID'
}

export type MismatchedOrderLine = {
  __typename?: 'MismatchedOrderLine';
  deliveredQuantity?: Maybe<Scalars['Int']['output']>;
  fulfillmentQuantity?: Maybe<Scalars['Int']['output']>;
  orderLineId: Scalars['ID']['output'];
  recoveryQuantity?: Maybe<Scalars['Int']['output']>;
};

export type MissingQtyDelivered = UserErrorInterface & {
  __typename?: 'MissingQtyDelivered';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** Error indicating that a modifier group's minimum/maximum selection bounds were violated. */
export type ModifierBoundsViolation = Error & {
  __typename?: 'ModifierBoundsViolation';
  /** MenuItemModifierGroup. */
  menuItemModifierGroup: MenuItemModifierGroup;
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Modifier Group. */
export type ModifierGroup = {
  __typename?: 'ModifierGroup';
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID']['output'];
  /** Modifier Group's current lock version, providing concurrency control and protection against stale updates. */
  lockVersion: Scalars['Int']['output'];
  modifierOptions: Array<ModifierOption>;
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  /** Visibility. */
  visibility: Visibility;
};

/** Modifier Group mutation result. */
export type ModifierGroupResult = ErrorsResult | ModifierGroupSuccess;

/** Result of a successful modifier group mutation. */
export type ModifierGroupSuccess = {
  __typename?: 'ModifierGroupSuccess';
  /** Resulting modifier group. */
  modifierGroup: ModifierGroup;
};

/** Result of mutating a list of modifier-groups. */
export type ModifierGroupsResult = ErrorsResult | ModifierGroupsSuccess;

/** Result of successfully mutating a list of modifier groups. */
export type ModifierGroupsSuccess = {
  __typename?: 'ModifierGroupsSuccess';
  /** Resulting modifier groups. */
  modifierGroups: Array<ModifierGroup>;
};

/** Modifier Group individual options. */
export type ModifierOption = {
  __typename?: 'ModifierOption';
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID']['output'];
  /** Modifier Option's current lock version, providing concurrency control and protection against stale updates. */
  lockVersion: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  /** Visibility. */
  visibility: Visibility;
};

/** Modifier Option mutation result. */
export type ModifierOptionResult = ErrorsResult | ModifierOptionSuccess;

/** Result of a successful modifier option mutation. */
export type ModifierOptionSuccess = {
  __typename?: 'ModifierOptionSuccess';
  /** Resulting modifier option. */
  modifierOption: ModifierOption;
};

/** Result of mutating a list of modifier-options. */
export type ModifierOptionsResult = ErrorsResult | ModifierOptionsSuccess;

/** Result of successfully mutating a list of modifier options. */
export type ModifierOptionsSuccess = {
  __typename?: 'ModifierOptionsSuccess';
  /** Resulting modifier options. */
  modifierOptions: Array<ModifierOption>;
};

/** Money. */
export type Money = {
  __typename?: 'Money';
  /** The monetary value, represented with two or four decimal digits of precision. */
  amount?: Maybe<Scalars['Decimal']['output']>;
  /** Cents. */
  cents: Scalars['Int']['output'];
  currency: Currency;
  /** International 3-letter currency code (e.g. "USD") as defined by the ISO 4217 standard. */
  currencyISO: Scalars['String']['output'];
};

export type MoneyInput = {
  /** The monetary value, represented with two or four decimal digits of precision. */
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  /** Cents. */
  cents: Scalars['Int']['input'];
  /** International 3-letter currency code (e.g. "USD") as defined by the ISO 4217 standard. */
  currencyISO: Scalars['String']['input'];
};

/** Autogenerated input type of MoveDeliveryStopsToCustomerPickup */
export type MoveDeliveryStopsToCustomerPickupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDs of the delivery stops to move into the customer-pickup bucket. */
  stopIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of MoveDeliveryStopsToCustomerPickup. */
export type MoveDeliveryStopsToCustomerPickupPayload = {
  __typename?: 'MoveDeliveryStopsToCustomerPickupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  updatedRoutes?: Maybe<Array<Route>>;
  userErrors: Array<DeliveryRouteStopError>;
};

/**
 * Error indicating that a mutation failed because cart prices need to be
 * recalculated. This can occur when attempting to checkout with a different
 * payment method than was used during the last price calculation (since payment
 * method can affect service fees), or if an item or modifier has changed price
 * since being added to the cart.
 */
export type MustRecalculateCartPrices = Error & {
  __typename?: 'MustRecalculateCartPrices';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Submit email to access WiFi credentials */
  accessWifi?: Maybe<AccessWifiMutationPayload>;
  acknowledgeBackInStockNotification?: Maybe<AcknowledgeBackInStockNotificationMutationPayload>;
  /** Acknowledge a consumer order */
  acknowledgeConsumerOrder?: Maybe<AcknowledgeConsumerOrderPayload>;
  acknowledgeDeliveryInstructionReview?: Maybe<AcknowledgeDeliveryInstructionReviewMutationPayload>;
  /** Marks the provided driver safety acknowledgement as acknowledged by the current driver. */
  acknowledgeDriverSafetyAcknowledgement?: Maybe<DriverSafetyAcknowledgementAcknowledgePayload>;
  /**
   * Creates a one-off ops appointment — against a known PO (which moves that PO's
   * existing booking if it already has one elsewhere) or, with no PO on file, a
   * minimum-info walk-in booking.
   */
  adHocAppointmentCreate?: Maybe<AdHocAppointmentCreatePayload>;
  /** Add a favorite consumer order. */
  addFavoriteConsumerOrder?: Maybe<AddFavoriteConsumerOrderPayload>;
  /** Add items to cart. */
  addItemsToCart?: Maybe<AddItemsToCartPayload>;
  /** Add a new microsite. */
  addMicrositeLocation?: Maybe<AddMicrositeMutationPayload>;
  /**
   * Applies a stop-wide header reason to every order line on a delivery route
   * stop. Replaces all existing line-level reasons on the stop with one row per
   * line carrying is_header_reason=true and quantity=fulfillment_quantity, then
   * zeros delivered_quantity on every line. Header is delivery-only (no redelivery support).
   */
  applyHeaderReasonToStopLineLevelDeliveryIssue?: Maybe<LineLevelDeliveryIssueApplyHeaderReasonPayload>;
  /** Apply a reward. */
  applyReward?: Maybe<ApplyRewardPayload>;
  /**
   * Persists a scenario's routing parameters as the warehouse's standing
   * configuration. Persist-only — no run is triggered; the next
   * scheduled/triggered run consumes the config. Admin-only and gated by a
   * per-warehouse pilot flag.
   */
  applyRoutingConfiguration?: Maybe<ApplyRoutingConfigurationPayload>;
  approveCutoffDiscrepancy?: Maybe<ApproveCutoffDiscrepancyPayload>;
  assignCustomerTag?: Maybe<AssignCustomerTagMutationPayload>;
  attachmentUrlPresigner?: Maybe<AttachmentUrlPresignerCreatePayload>;
  /** Starts a paced batch onboarding run over one acquisition's ready customers. */
  batchOnboardInProgressCustomers?: Maybe<BatchOnboardInProgressCustomersMutationPayload>;
  bulkCreateSupplierInvoiceComparisonRows: BulkCreateSupplierInvoiceComparisonRowsPayload;
  /** Bulk update delivery status for all orders in a delivery route */
  bulkUpdateRouteStopsDeliveryInfo?: Maybe<BulkUpdateRouteStopsDeliveryInfoPayload>;
  bulkUpsertZipcodeDeliveryRules?: Maybe<BulkUpsertZipcodeDeliveryRulesPayload>;
  /** Cancel an order */
  cancelOrderMutation?: Maybe<CancelOrderMutationPayload>;
  /** Persists vendor receiving check-in data: received quantities and vendor prices per item */
  checkinOrderVendorReceiving?: Maybe<CheckinOrderVendorReceivingPayload>;
  /** Process checkout */
  checkout?: Maybe<CheckoutPayload>;
  /** Claim reward. */
  claimReward?: Maybe<ClaimRewardPayload>;
  /** Complete a consumer app referral. */
  completeConsumerAppReferral?: Maybe<CompleteConsumerAppReferralPayload>;
  /** Complete a Stripe checkout session, optionally triggering signage order creation */
  completeStripeCheckoutSession?: Maybe<CompleteStripeCheckoutSessionMutationPayload>;
  /** Complete subscription session by creating microsite and associations */
  completeSubscriptionSession?: Maybe<CompleteSubscriptionSessionMutationPayload>;
  completeSupplierInvoiceUpload: CompleteSupplierInvoiceUploadPayload;
  /** Confirm an order's delivery review and clear it for billing */
  confirmOrderReview?: Maybe<OrderReviewConfirmPayload>;
  /** Accepts a putaway command for durable asynchronous processing. */
  confirmPutawayPallet?: Maybe<ConfirmPutawayPalletPayload>;
  /** Confirm an order suggestion, creating a Square order and Terminal checkout */
  confirmSquareOrderSuggestion?: Maybe<ConfirmSquareOrderSuggestionMutationPayload>;
  /** Connect a Credit Key account to the location */
  connectLocationCreditKeyAccount?: Maybe<ConnectLocationCreditKeyAccountMutationPayload>;
  /** Mark a consumer order complete */
  consumerOrderComplete?: Maybe<ConsumerOrderCompletePayload>;
  /** Mark a consumer order picked-up */
  consumerOrderPickedUp?: Maybe<ConsumerOrderPickedUpPayload>;
  /** Mark a consumer order ready */
  consumerOrderReady?: Maybe<ConsumerOrderReadyPayload>;
  createBrandedItemDeal?: Maybe<CreateBrandedItemDealMutationPayload>;
  createCollectionPromoSetup?: Maybe<CreateCollectionPromoSetupPayload>;
  /** PROTOTYPE mutation to store a current count and (possibly) start a new LocationStockCount session */
  createCountingEvent?: Maybe<CreateCountingEventMutationPayload>;
  createCustomIngredient?: Maybe<CreateCustomIngredientMutationPayload>;
  createCustomerTag?: Maybe<CreateCustomerTagMutationPayload>;
  /** Reserves a customer-tag CSV import and returns where to upload the file. */
  createCustomerTagImport?: Maybe<CreateCustomerTagImportMutationPayload>;
  /** Author an individual (location + vendor) date-scoped delivery override. */
  createDeliveryOverrideRule?: Maybe<CreateDeliveryOverrideRuleMutationPayload>;
  /** Add attachment to a delivery route stop */
  createDeliveryRouteStopAttachment?: Maybe<DeliveryRouteStopAttachmentCreatePayload>;
  /** Create Stripe checkout session directly (without subscription session) */
  createDirectStripeCheckoutSession?: Maybe<CreateDirectStripeCheckoutSessionMutationPayload>;
  /** Create a driver safety acknowledgement */
  createDriverSafetyAcknowledgement?: Maybe<DriverSafetyAcknowledgementCreatePayload>;
  createExternalBaseBrandedItem?: Maybe<CreateExternalBaseBrandedItemMutationPayload>;
  /**
   * Schedules an external delivery with a 3rd party delivery partner.
   * @deprecated use upsertExternalDeliveryMutation instead
   */
  createExternalDeliveryMutation?: Maybe<CreateExternalDeliveryMutationPayload>;
  createFieldServiceZipcode?: Maybe<CreateFieldServiceZipcodeMutationPayload>;
  /** Create a full refund for a consumer order */
  createFullConsumerRefund?: Maybe<CreateFullConsumerRefundPayload>;
  /** Create a new game */
  createGame?: Maybe<CreateGameMutationPayload>;
  createHomepageComponent?: Maybe<CreateHomepageComponentPayload>;
  createHomepageDisplayRule?: Maybe<CreateHomepageDisplayRulePayload>;
  /** Create a HubSpot lead for a location in the New stage */
  createHubspotLead?: Maybe<CreateHubspotLeadPayload>;
  createInHouseBaseBrandedItem?: Maybe<CreateInHouseBaseBrandedItemMutationPayload>;
  createInventoryItem?: Maybe<SupplyItem>;
  createItemBrand?: Maybe<ItemBrandCreatePayload>;
  createItemTag?: Maybe<ItemTag>;
  /** Create a new leaderboard for a game */
  createLeaderboard?: Maybe<CreateLeaderboardMutationPayload>;
  /** Create a new location with Supply auto-enabled and publish upsert event */
  createLocation?: Maybe<CreateLocationMutationPayload>;
  /** Create an lva for a location and vendor */
  createLocationVendorAssociation?: Maybe<CreateLocationVendorAssociationMutationPayload>;
  createMarketingToolsManager?: Maybe<CreateMarketingToolsManagerMutationPayload>;
  /** Create a menu for the merchant */
  createMenu?: Maybe<CreateMenuPayload>;
  /** Create a menu item for the submenu */
  createMenuItem?: Maybe<CreateMenuItemPayload>;
  /** Create a microsite location from Google Place ID or business name/address */
  createMicrositeLocation?: Maybe<CreateMicrositeLocationMutationPayload>;
  createNonInventoryItem?: Maybe<SupplyItem>;
  createOrderReconciliationAttachmentUploadRequestMutation?: Maybe<CreateOrderReconciliationAttachmentUploadRequestMutationPayload>;
  createOrderReconciliationMutation?: Maybe<CreateOrderReconciliationMutationPayload>;
  /** Create a partial refund for a consumer order */
  createPartialConsumerRefund?: Maybe<CreatePartialConsumerRefundPayload>;
  createReceivableNote?: Maybe<CreateReceivableNotePayload>;
  /** Creates redelivery stops */
  createRedeliveryStops?: Maybe<RedeliveryStopCreatePayload>;
  /** Add an additional task for the driver to a delivery route stop */
  createRouteStopTask?: Maybe<DeliveryRouteStopTaskCreatePayload>;
  createSalesTaxEstimate?: Maybe<CreateSalesTaxEstimateMutationPayload>;
  /** Create a Stripe checkout session for purchasing additional signs */
  createSignPurchaseCheckoutSession?: Maybe<CreateSignPurchaseCheckoutSessionMutationPayload>;
  /** Parse a voice transcript and create an order suggestion for review */
  createSquareOrderSuggestionFromTranscript?: Maybe<CreateSquareOrderSuggestionFromTranscriptMutationPayload>;
  /** PROTOTYPE mutation to create a new storage area for a location. */
  createStorageArea?: Maybe<CreateStorageAreaMutationPayload>;
  /** Create Stripe checkout session for existing subscription session */
  createStripeCheckoutSession?: Maybe<CreateStripeCheckoutSessionMutationPayload>;
  /** Create a submenu under the menu */
  createSubmenu?: Maybe<CreateSubmenuPayload>;
  createSupplierInvoice: CreateSupplierInvoicePayload;
  createSupplierInvoiceComparison: CreateSupplierInvoiceComparisonPayload;
  /** Create a new user with Auth0 identity and location access */
  createUser?: Maybe<CreateUserMutationPayload>;
  /** Associate a user with a microsite location. This is used to check that a user has permission to edit a microsite. */
  createUserMicrositeLocation?: Maybe<CreateUserMicrositeLocationPayload>;
  /** Stores a pre-trip or post-trip vehicle inspection report. */
  createVehicleInspectionReport?: Maybe<VehicleInspectionReportCreatePayload>;
  /** Creates a delivery route for a warehouse */
  createWarehouseDeliveryRoute?: Maybe<DeliveryRouteCreatePayload>;
  createWorkThread?: Maybe<CreateWorkThreadPayload>;
  deleteArAssignment?: Maybe<DeleteArAssignmentPayload>;
  deleteCategoryBanner?: Maybe<CategoryBannerPayload>;
  deleteCollectionPromoSetup?: Maybe<DeleteCollectionPromoSetupPayload>;
  deleteCustomerTag?: Maybe<DeleteCustomerTagMutationPayload>;
  /** Removes a delivery issue for a delivery route stop */
  deleteDeliveryIssue?: Maybe<DeliveryIssueDeletePayload>;
  /**
   * Withdraw a delivery override so it stops applying. Does not restore the orders
   * it already cancelled, and cancels no further orders.
   */
  deleteDeliveryOverrideRule?: Maybe<DeleteDeliveryOverrideRuleMutationPayload>;
  /** Delete delivery route stop attachment */
  deleteDeliveryRouteStopAttachment?: Maybe<DeliveryRouteStopAttachmentDeletePayload>;
  /** Delete a driver safety acknowledgement */
  deleteDriverSafetyAcknowledgement?: Maybe<DriverSafetyAcknowledgementDeletePayload>;
  deleteFieldServiceZipcode?: Maybe<DeleteFieldServiceZipcodeMutationPayload>;
  deleteItemBrand?: Maybe<ItemBrandDeletePayload>;
  /** Removes a line-level delivery reason */
  deleteLineLevelDeliveryIssue?: Maybe<LineLevelDeliveryIssueDeletePayload>;
  deleteLocationAccountsReceivableCollectionsStatus?: Maybe<DeleteLocationAccountsReceivableCollectionsStatusPayload>;
  /** Delete the payment method associated with the customer of this location */
  deleteLocationPaymentMethod?: Maybe<DeleteLocationPaymentMethodMutationPayload>;
  deleteLocationPhoneNumber?: Maybe<DeleteLocationPhoneNumberMutationPayload>;
  deleteMasterHomepage?: Maybe<DeleteMasterHomepagePayload>;
  deleteMasterHomepageRowComponent?: Maybe<DeleteMasterHomepageRowComponentPayload>;
  /** Delete a menu item from a microsite. */
  deleteMicrositeMenuItem?: Maybe<DeleteMicrositeMenuItemPayload>;
  deleteReceivableNote?: Maybe<DeleteReceivableNotePayload>;
  /** Delete a redelivery stop */
  deleteRedeliveryStop?: Maybe<RedeliveryStopDeletePayload>;
  /** Remove an unresolved additional task from a delivery route stop */
  deleteRouteStopTask?: Maybe<DeliveryRouteStopTaskDeletePayload>;
  /**
   * Hard-deletes a scenario run, the cleanup mechanism for the 50-run-per-plan
   * cap. Observe the result via RoutingImportPlan.scenarios.
   */
  deleteRoutificScenario?: Maybe<DeleteRoutificScenarioPayload>;
  /** Delete a file from S3 storage. */
  deleteS3File?: Maybe<DeleteS3FilePayload>;
  /** Delete Square card. */
  deleteSquareCard?: Maybe<DeleteSquareCardPayload>;
  /** Remove a user's association with a microsite location */
  deleteUserMicrositeLocation?: Maybe<DeleteUserMicrositeLocationMutationPayload>;
  deleteZipcode?: Maybe<DeleteZipcodeMutationPayload>;
  deleteZipcodeDeliveryRule?: Maybe<DeleteZipcodeDeliveryRulePayload>;
  /** Mark a delivery as completed for a delivery route stop */
  deliveryCompleted?: Maybe<DeliveryCompletedUpdatePayload>;
  /**
   * Update the sequence numbers of a routes delivery stops. This is typically used
   * when users want to change the order of the stops on their delivey route.
   */
  deliveryStopsReorder?: Maybe<DeliveryStopsReorderPayload>;
  deprioritizeLocation?: Maybe<DeprioritizeLocationPayload>;
  discontinueWarehouseItem?: Maybe<SupplyItem>;
  /**
   * Dispatches a quoted third-party route against one of its quotes (epic
   * sc-66318). The dispatch reads dispatched until the provider confirms, then
   * in_progress. An expired quote, or one the provider refuses, is returned as a
   * userError and the route stays quoted.
   */
  dispatchProviderRoute?: Maybe<DispatchProviderRoutePayload>;
  /** Cancels a booking on the driver's behalf (internal). */
  dockBookingCancel?: Maybe<DockBookingCancelPayload>;
  /** Marks a booked appointment as a no-show (internal). */
  dockBookingMarkMissed?: Maybe<DockBookingMarkMissedPayload>;
  /**
   * Internal: record that a booking's truck has arrived, identified directly by
   * its booking id — no reference typed. Lets ops check in from the admin board
   * instead of depending on a driver receiving/relaying a confirmation number or
   * PO. Idempotent — calling it again for the same delivery returns the arrival
   * already recorded.
   */
  dockBookingOpsCheckIn?: Maybe<DockBookingOpsCheckInPayload>;
  /** Creates a dock for a warehouse. */
  dockCreate?: Maybe<DockCreatePayload>;
  /** Deletes a dock. Fails with DockInUse if it has upcoming bookings. */
  dockDelete?: Maybe<DockDeletePayload>;
  /**
   * Issue a dock override code to a warehouse-only vendor. If the vendor already
   * has an active code, it is revoked and a fresh one minted — existing deliveries are preserved.
   */
  dockOverrideCodeIssue?: Maybe<DockOverrideCodeIssuePayload>;
  /**
   * Revoke an active dock override code. The code can no longer authenticate or
   * create bookings; existing bookings are left untouched.
   */
  dockOverrideCodeRevoke?: Maybe<DockOverrideCodeRevokePayload>;
  /** Renames a dock, replaces its booking windows, or enables/disables it. */
  dockUpdate?: Maybe<DockUpdatePayload>;
  /**
   * Closes a checked-in truck's visit from an internal admin surface (e.g. the
   * Dock Manager board), identified directly by the visit's own id. Same effect as
   * the kiosk's Departed screen — measures how long the truck was on site.
   * Idempotent — an arrival already closed keeps the departure time first recorded.
   */
  dockVisitDepart?: Maybe<DockVisitDepartPayload>;
  /**
   * Moves a checked-in truck to a different dock (internal) — e.g. its assigned
   * door is occupied when it arrives. The booking's own scheduled dock is
   * untouched; only where the truck physically is changes.
   */
  dockVisitReassignDock?: Maybe<DockVisitReassignDockPayload>;
  duplicateMasterHomepage?: Maybe<DuplicateMasterHomepagePayload>;
  /**
   * Sends stops with issues to a third-party provider as one-off deliveries (epic
   * sc-66318). Creates one new route for the warehouse and night holding a
   * redelivery stop per selected stop, marks it for the provider and queues the
   * push. Refuses, creating nothing, when any selected stop fails a rule; the
   * error names every such stop.
   */
  escalateStopsToProvider?: Maybe<EscalateStopsToProviderPayload>;
  /** Generate signed parameters for direct Cloudinary upload. */
  generateCloudinaryUploadSignature?: Maybe<GenerateUploadSignaturePayload>;
  /**
   * Generate or refine AI description for item.
   * - No existingDescription: generates fresh description from item info + Google Search.
   * - existingDescription + userInstructions: refines the existing description.
   * - existingDescription without userInstructions: regenerates fresh.
   */
  generateItemDescription: GenerateItemDescriptionResult;
  /** PROTOTYPE for a given Stock Count session, generate order quantities. */
  generateOrderQuantities?: Maybe<GenerateOrderQuantitiesMutationPayload>;
  generatePresignedS3Url?: Maybe<GeneratePresignedUrlMutationPayload>;
  importPriceRulesCsv: ImportPriceRulesCsvPayload;
  importProcurementRecords?: Maybe<Scalars['Boolean']['output']>;
  /** Initialize marketing tools signup session */
  initializeMarketingToolsSignup?: Maybe<InitializeMarketingToolsSignupMutationPayload>;
  /** Initiate pairing for a Square Terminal by creating a device code */
  initiateTerminalPairing?: Maybe<InitiateTerminalPairingMutationPayload>;
  logSalesOutreach?: Maybe<LogSalesOutreachPayload>;
  /** Login consumer app user using a Firebase ID. */
  loginConsumerAppUserFromFirebase?: Maybe<LoginConsumerAppUserFromFirebasePayload>;
  /** Make a one-time charge to a location's Credit Key account */
  makeCreditKeyCharge?: Maybe<MakeCreditKeyChargeMutationPayload>;
  /** Marks a delivery as having donation collected and sets a timestamp */
  markCompostCollected?: Maybe<DeliveryRouteStopCompostCollectedUpdatePayload>;
  /**
   * Complete a selection of customer-pickup bucket stops (mark picked up). Each
   * stop's orders are delivered at fulfilled quantity and the stop is completed
   * and viewed, the same way whole-bucket bulk complete works. A stop that is not
   * on a customer-pickup route, or one whose collected vendor order is
   * line-tracked with no fulfillment quantities, is rejected and nothing is written.
   */
  markCustomerPickupStopsComplete?: Maybe<MarkCustomerPickupStopsCompletePayload>;
  /** Marks a delivery as having donation collected and sets a timestamp */
  markDonationCollected?: Maybe<DeliveryRouteStopDonationCollectedUpdatePayload>;
  /** Sets the bulk picking status warehouse items */
  markItemsAsBulkPicked?: Maybe<MarkItemsAsBulkPickedMutationPayload>;
  /** Marks an order as delivered */
  markOrderDelivered?: Maybe<OrderDeliveredUpdatePayload>;
  /**
   * Marks a GM-built route as executed by a third-party provider (epic sc-66318).
   * Validates the provider is available to the warehouse and the route is
   * markable, then creates the dispatch record and queues the push, which creates
   * the provider's orders and route and requests quotes. The dispatch status
   * reports how far it got.
   */
  markRouteForProvider?: Maybe<MarkRouteForProviderPayload>;
  /**
   * Move delivery stops into their night's customer-pickup bucket, creating the
   * bucket if that night does not have one yet. Enforces the same warehouse and
   * night-end-lock rules as DeliveryStopsMoveToRoute. Never writes an order's
   * deliveryMethod: bucket membership is the route, not the delivery method.
   */
  moveDeliveryStopsToCustomerPickup?: Maybe<MoveDeliveryStopsToCustomerPickupPayload>;
  /** Move delivery stops from their current routes to specified route and update associated Vendor pick ups accordingly  */
  moveDeliveryStopsToRoute?: Maybe<DeliveryStopsMoveToRoutePayload>;
  /** Marks an order as collected/fulfilled */
  orderCollected?: Maybe<OrderCollectedUpdatePayload>;
  /** Performs out of stock checks for a list of items */
  performOutOfStockChecks?: Maybe<PerformOutOfStockChecksMutationPayload>;
  /** Pin an item as the queue leader at a position across every market it's currently new in, in one all-or-nothing action. Studio-only. */
  pinItemAcrossMarkets: PinItemAcrossMarketsPayload;
  pingifyBraavos: Scalars['String']['output'];
  /** PROTOTYPE mutation to exchange a code for a token and store credentials and platform account & profile info */
  platformCompleteAction?: Maybe<CompleteActionMutationPayload>;
  pricingServicePingify: PricingServicePingifyPayload;
  /** Supervisor assigns an associate to a process path now. */
  processPathAssign?: Maybe<ProcessPathAssignPayload>;
  /** Admin provisions an agency (temp-staff) associate; returns their generated badge code. */
  processPathAssociateCreate?: Maybe<ProcessPathAssociateCreatePayload>;
  /**
   * Admin deactivates/reactivates an agency (temp-staff) associate. ARMHR-sourced
   * rows are refused. Deactivating removes the associate from the active roster,
   * closes any open time, and returns a held RF-SMART pool account to the
   * warehouse pool (password unrotated), but does NOT disable their badge at the kiosk.
   */
  processPathAssociateSetStatus?: Maybe<ProcessPathAssociateSetStatusPayload>;
  /**
   * Clears a coverage-target cell: reverts to the system suggestion when one
   * exists, otherwise empties the cell. Distinct from asserting an explicit zero.
   */
  processPathClearCoverageTarget?: Maybe<ProcessPathClearCoverageTargetPayload>;
  /** Supervisor clocks an associate in for their shift. */
  processPathClockIn?: Maybe<ProcessPathClockInPayload>;
  /** Supervisor clocks an associate out, ending their shift and any open segment. */
  processPathClockOut?: Maybe<ProcessPathClockOutPayload>;
  /** Adds a path to the global catalog, available at the creating warehouse only. */
  processPathCreate?: Maybe<ProcessPathCreatePayload>;
  /** Sets the global left-to-right order of catalog paths. */
  processPathReorder?: Maybe<ProcessPathReorderPayload>;
  /** Supervisor manual insert of a (typically back-dated) segment. */
  processPathSegmentCreate?: Maybe<ProcessPathSegmentCreatePayload>;
  /** Supervisor deletes a logged segment. */
  processPathSegmentDelete?: Maybe<ProcessPathSegmentDeletePayload>;
  /** Supervisor correction of a logged segment (path / start / end). */
  processPathSegmentEdit?: Maybe<ProcessPathSegmentEditPayload>;
  /** Associate self-assigns to a process path. */
  processPathSelfAssign?: Maybe<ProcessPathSelfAssignPayload>;
  /** Associate clocks themselves in for their shift. */
  processPathSelfClockIn?: Maybe<ProcessPathSelfClockInPayload>;
  /** Associate clocks themselves out, ending their shift and any open segment. */
  processPathSelfClockOut?: Maybe<ProcessPathSelfClockOutPayload>;
  /** Associate ends their current process-path segment. */
  processPathSelfUnassign?: Maybe<ProcessPathSelfUnassignPayload>;
  /** Toggles whether a catalog path is available at a given warehouse. */
  processPathSetAvailability?: Maybe<ProcessPathSetAvailabilityPayload>;
  /**
   * Sets the admin-entered target labour hours for a path on a day. 0 is stored as
   * an asserted zero; use ProcessPathClearCoverageTarget to clear the cell.
   */
  processPathSetCoverageTarget?: Maybe<ProcessPathSetCoverageTargetPayload>;
  /** Ends an associate's current process-path segment. */
  processPathUnassign?: Maybe<ProcessPathUnassignPayload>;
  /** Edits a catalog path's global attributes (label/category/colour/order). */
  processPathUpdate?: Maybe<ProcessPathUpdatePayload>;
  /**
   * Records a human verdict (approved/rejected) on an AI-generated output — e.g.
   * 👍/👎 on a suggested reply — attributed to the calling user. Upserts per
   * assessment + user + interaction, so re-voting replaces the prior verdict.
   */
  procurementAiFeedbackSubmit?: Maybe<ProcurementAiFeedbackSubmitPayload>;
  /**
   * Stores an AI status assessment for a PO tracking (append-only, with
   * provenance) and lets ApplyAssessment decide whether it moves tracking_status:
   * monotonic transitions at high/medium confidence apply; anything else is held
   * with needs_reply. Callers never write status directly.
   */
  procurementAssessmentSubmit?: Maybe<ProcurementAssessmentSubmitPayload>;
  procurementCorrespondenceCommand?: Maybe<ProcurementCorrespondenceCommandPayload>;
  /**
   * Idempotently ingests one mailbox thread with its messages and attachment
   * metadata, keyed on Gmail ids — whole threads are re-delivered on every pass,
   * so re-upserts are no-ops that report only genuinely new messages. Primary
   * ingestion calls Procurement::EmailIngestService in-process (LDS mailbox
   * poller); this mutation is the ops/manual entry point.
   */
  procurementEmailThreadUpsert?: Maybe<ProcurementEmailThreadUpsertPayload>;
  /**
   * Records the last processed Gmail historyId for a mailbox — the ingest poller's
   * resume point, advanced only after a full pass persists.
   */
  procurementMailboxCursorSet?: Maybe<ProcurementMailboxCursorSetPayload>;
  /** Logs an offline conversation (phone / in person) into a PO's timeline, attributed to the calling user. */
  procurementPoNoteCreate?: Maybe<ProcurementPoNoteCreatePayload>;
  /** Assigns the calling user (Auth0 sub from the request JWT) to a PO tracking row. */
  procurementPoTrackingAssign?: Maybe<ProcurementPoTrackingAssignPayload>;
  /**
   * Idempotently creates the tool-owned tracking row for a NetSuite purchase order
   * (by PO number / tranId) and links its procurement vendor. Master data stays on
   * the NetSuite projection.
   */
  procurementPoTrackingEnsure?: Maybe<ProcurementPoTrackingEnsurePayload>;
  /**
   * Human corrections to a PO tracking row: delivery type, vendor link,
   * needs-reply flag. Deliberately cannot set tracking_status — status changes
   * only through the audited assessment/override paths.
   */
  procurementPoTrackingUpdate?: Maybe<ProcurementPoTrackingUpdatePayload>;
  /**
   * Human status override — any transition allowed (humans correct AI mistakes
   * backward), always recorded as an audited status event with the actor.
   */
  procurementStatusOverride?: Maybe<ProcurementStatusOverridePayload>;
  /**
   * Human assignment from the unmatched queue: creates a manual, confirmed link
   * between a thread and a PO tracking, recording the assigner.
   */
  procurementThreadAssignToPo?: Maybe<ProcurementThreadAssignToPoPayload>;
  /** Human confirmation of an AI-proposed link from the unmatched queue. */
  procurementThreadLinkConfirm?: Maybe<ProcurementThreadLinkConfirmPayload>;
  /**
   * Links an ingested thread to a PO tracking (both addressed by their
   * source-system ids — the AI matcher speaks Gmail thread ids and PO numbers).
   * subject_po_number/pdf_extract sources auto-confirm; ai_inference stays
   * proposed in the unmatched queue until a human confirms.
   */
  procurementThreadLinkCreate?: Maybe<ProcurementThreadLinkCreatePayload>;
  /**
   * Sets a thread's triage state: unmatched (PO-like, human queue), dismissed, or
   * ignored (non-PO noise, purged after retention). matched only ever happens
   * through link creation/confirmation. Accepts either the thread id (human queue)
   * or the Gmail thread id. Always recorded as a human triage against the caller's
   * Auth0 sub — the AI triages in-process, not through this mutation.
   */
  procurementThreadTriageSet?: Maybe<ProcurementThreadTriageSetPayload>;
  /**
   * Creates a procurement vendor, or updates one by id. Creation matches on
   * normalized name, so re-submitting an existing vendor's name updates that
   * vendor instead of duplicating it.
   */
  procurementTrackingVendorUpsert?: Maybe<ProcurementTrackingVendorUpsertPayload>;
  /** Public: cancel a delivery's booking, identified by its PO (reference number). */
  publicDockBookingCancel?: Maybe<PublicDockBookingCancelPayload>;
  /**
   * Public: book (or amend) a delivery's dock time, identified by its PO
   * (reference number). The scheduler chooses the freight type (it drives slot
   * length) and must supply SCAC, weight, pallet count, contact name/phone/email
   * and ship date; carrier name and the remaining details are optional.
   */
  publicDockBookingSubmit?: Maybe<PublicDockBookingSubmitPayload>;
  /**
   * Public: record that the driver for this delivery has arrived at the dock,
   * identified by the confirmation number on their email or by the PO. Idempotent
   * — calling it again for the same delivery returns the arrival already recorded.
   */
  publicDockCheckIn?: Maybe<PublicDockCheckInPayload>;
  /**
   * Public: ops records that the truck for this delivery has left the dock,
   * identified by the confirmation number on its email or by the PO. Closes the
   * arrival and measures how long the truck was on site. Idempotent — an arrival
   * already closed keeps the departure time first recorded.
   */
  publicDockDepart?: Maybe<PublicDockDepartPayload>;
  /** Change one of the code vendor's existing deliveries. */
  publicOverrideBookingAmend?: Maybe<PublicOverrideBookingAmendPayload>;
  /** Cancel one of the code vendor's deliveries. */
  publicOverrideBookingCancel?: Maybe<PublicOverrideBookingCancelPayload>;
  /** Book a new delivery for the code's vendor at a chosen warehouse. */
  publicOverrideBookingCreate?: Maybe<PublicOverrideBookingCreatePayload>;
  /** Create or update a review response on Google Business Profile */
  publishReviewResponse?: Maybe<ReviewResponse>;
  /** Create or update a review response on Google Business Profile using Google location name */
  publishReviewResponseGbp?: Maybe<ReviewResponse>;
  /** Rebuild the cart from a past order. */
  rebuildCartFromPastOrder?: Maybe<RebuildCartFromPastOrderPayload>;
  /**
   * Recalculate cart prices appropriately for a specific payment method (which can
   * affect fees), using up-to-date menu prices. Items and/or modifiers whose
   * prices have changed since being added to the cart will reflect latest price info.
   */
  recalculateCartPrices?: Maybe<RecalculateCartPricesPayload>;
  /** Records a batch of timestamped driver location fixes for an active route's breadcrumb trail. */
  recordDriverLocationPings?: Maybe<RecordDriverLocationPingsPayload>;
  /** Accepts a manual Bin Transfer of one lot, from any active bin, for durable asynchronous processing. */
  recordManualBinTransfer?: Maybe<RecordManualBinTransferPayload>;
  /**
   * Records one trip of a replenishment task as a Bin Transfer, for durable
   * asynchronous processing. Call it again for the same taskId as the associate
   * pulls from successive bins.
   */
  recordReplenishmentPick?: Maybe<RecordReplenishmentPickPayload>;
  /** Empty the cart. */
  removeAllFromCart?: Maybe<RemoveAllFromCartPayload>;
  removeCustomerTag?: Maybe<RemoveCustomerTagMutationPayload>;
  /** Remove a favorite consumer order. */
  removeFavoriteConsumerOrder?: Maybe<RemoveFavoriteConsumerOrderPayload>;
  /** Remove items from cart. */
  removeItemsFromCart?: Maybe<RemoveItemsFromCartPayload>;
  removeLocationItem?: Maybe<Scalars['Boolean']['output']>;
  /** Remove an item's New Items pin from a market. Studio-only. */
  removeNewItemPin: NewItemPinPayload;
  /** Remove reward. */
  removeReward?: Maybe<RemoveRewardPayload>;
  /** Remove a curated substitution override by id. Procurement-only. */
  removeSubstitutionOverride: SubstitutionOverridePayload;
  /** Reopens a completed route by clearing its completion time, so its stops can be edited again. */
  reopenRoute?: Maybe<RouteReopenPayload>;
  /** Replace a market's full set of New Items pins in one shot. Studio-only. */
  reorderNewItemPins: NewItemPinsPayload;
  /** Reports a delivery issue for a delivery route stop */
  reportDeliveryIssue?: Maybe<DeliveryIssueCreatePayload>;
  /** Reports a line-level delivery reason on an order line for a delivery or redelivery stop */
  reportLineLevelDeliveryIssue?: Maybe<LineLevelDeliveryIssueReportPayload>;
  /** Report phone number verification code. */
  reportPhoneNumberVerification?: Maybe<ReportPhoneNumberVerificationPayload>;
  /**
   * Records why an associate couldn't put a task away. The reason is kept for
   * metrics and bin-data review; nothing about the task itself changes.
   */
  reportPutawayException?: Maybe<ReportPutawayExceptionPayload>;
  /**
   * Records that an associate reported the item master's pallet build as wrong.
   * The correction applied to their putaway session only; the record lets a
   * reviewer decide whether IMS should change.
   */
  reportPutawayPalletBuildCorrection?: Maybe<ReportPutawayPalletBuildCorrectionPayload>;
  /** Request an S3 upload URL for a file. The file must then be uploaded using a PUT request. */
  requestS3Upload?: Maybe<RequestS3UploadPayload>;
  /** Order the free sample of an item for a location, delivered on the given date */
  requestSample?: Maybe<RequestSampleMutationPayload>;
  requestSupplierInvoiceReadUrl: RequestSupplierInvoiceReadUrlPayload;
  /**
   * Requests fresh quotes for a marked route that is not dispatched yet,
   * optionally at a new pickup time (epic sc-66318 D8). The dispatch returns to
   * quoting and its quotes are replaced when the provider answers; the provider's
   * orders are not changed.
   */
  requoteProviderRoute?: Maybe<RequoteProviderRoutePayload>;
  /** Driver resolves every additional task on a stop (complete/incomplete), each with its own note */
  resolveRouteStopTasks?: Maybe<DeliveryRouteStopTasksResolvePayload>;
  restoreLocation?: Maybe<RestoreLocationPayload>;
  /** Admin assigns a pool RF-SMART account to an associate, optionally rotating its password; returns metadata only. */
  rfsmartCredentialAssign?: Maybe<RfsmartCredentialAssignPayload>;
  /** Admin cancels a pending RF-SMART removal request. Provide exactly one of employeeId or credentialId. */
  rfsmartCredentialRemovalCancel?: Maybe<RfsmartCredentialRemovalCancelPayload>;
  /**
   * Admin records a pending RF-SMART removal as done; erases the stored password,
   * keeps the row as history. Provide exactly one of employeeId or credentialId.
   */
  rfsmartCredentialRemovalComplete?: Maybe<RfsmartCredentialRemovalCompletePayload>;
  /**
   * Admin flags an active RF-SMART credential for manual removal in RF-SMART.
   * Provide exactly one of employeeId or credentialId.
   */
  rfsmartCredentialRemovalRequest?: Maybe<RfsmartCredentialRemovalRequestPayload>;
  /** Admin sets or rotates an associate's RF-SMART credential; returns metadata only. */
  rfsmartCredentialSet?: Maybe<RfsmartCredentialSetPayload>;
  /** Admin adds a pool RF-SMART account to a warehouse, corrects its login, or rotates its password; returns metadata only. */
  rfsmartCredentialSetPool?: Maybe<RfsmartCredentialSetPoolPayload>;
  /** Admin returns a pool RF-SMART account to the pool; pool credentials only. */
  rfsmartCredentialUnassign?: Maybe<RfsmartCredentialUnassignPayload>;
  /** Assigns one of the warehouse's shifts to a routing cohort, or clears it (null). */
  routingCohortShiftAssign?: Maybe<RoutingCohortShiftAssignPayload>;
  /**
   * Ask NetSuite to republish the records this location's retained comparison
   * flagged. Requires AR team access: any other caller gets a FORBIDDEN error and
   * no payload. A sync refreshes what a comparison found, so it needs one made
   * today that found something to fix and nothing else running; anything else is
   * refused with the reason in errors and location null, never queued. On success
   * the sync is in flight: read location.transactionSync to follow it.
   */
  runTransactionSync?: Maybe<RunTransactionSyncPayload>;
  /**
   * Ask for a fresh comparison of one location's records against NetSuite.
   * Requires AR team access: any other caller gets a FORBIDDEN error and no
   * payload. Never queues — a location with an audit or a sync already in flight
   * is refused, with the reason in errors and location null. On success the audit
   * has been requested, not finished: read location.transactionSync to follow it.
   */
  runTransactionSyncAudit?: Maybe<RunTransactionSyncAuditPayload>;
  /** Save referral link for the current consumer app user. */
  saveConsumerAppReferralLink?: Maybe<SaveConsumerAppReferralLinkPayload>;
  saveMasterHomepageRows?: Maybe<SaveMasterHomepageRowsPayload>;
  /**
   * Sets or updates the GM-facing display name on a scenario run. Idempotent — the
   * same mutation names a run at creation and renames it later. Observe the result
   * via RoutingImportPlan.scenarios.
   */
  saveRoutificScenario?: Maybe<SaveRoutificScenarioPayload>;
  /** Batch marks orders as collected and updates fulfillment quantities for all orders from a vendor in one transaction */
  saveVendorAllocation?: Maybe<SaveVendorAllocationPayload>;
  /** Scan a marketing QR code. */
  scanMarketingQrCode?: Maybe<ScanMarketingQrCodeMutationPayload>;
  sendAlignmentMessage?: Maybe<SendAlignmentMessagePayload>;
  sendBrandedPaperQuestionEmail?: Maybe<SendBrandedPaperQuestionEmailMutationPayload>;
  /** Send a chat message */
  sendChatMessage?: Maybe<Array<Maybe<ChatMessage>>>;
  sendEquipmentCheckoutEmail?: Maybe<SendEquipmentCheckoutEmailMutationPayload>;
  sendEquipmentQuestionEmail?: Maybe<SendEquipmentQuestionEmailMutationPayload>;
  /** Set a payment method as default across all eligible locations for the user */
  setDefaultPaymentMethodForLocations?: Maybe<SetDefaultPaymentMethodForLocationsMutationPayload>;
  setFinancialStatementPreferences?: Maybe<SetFinancialStatementPreferencesMutationPayload>;
  /**
   * Upserts a warehouse's fleet composition — per vehicle type, how many trucks it
   * routes with — onto its routing configuration, creating the configuration if
   * absent. Per-type counts are caller-set; per-truck capacities come from the
   * warehouse's vehicle types. Admin-only and gated by a per-warehouse pilot flag.
   */
  setFleetComposition?: Maybe<SetFleetCompositionPayload>;
  /**
   * Set which locations are excluded from automatic fund application.
   * All-or-nothing: on success, locations contains every input location (excluded
   * and included alike) in input order; if any input location id is unknown,
   * nothing is written, locations is null, and errors says which ids were unknown.
   */
  setFundApplicationExclusions?: Maybe<SetFundApplicationExclusionsPayload>;
  setInvoiceExternalSupplier: SetInvoiceExternalSupplierPayload;
  /** Mark an item inactive or reactivate it; blocking reasons are returned in the payload's `errors`. */
  setItemInactive: SetItemInactivePayload;
  /** Set merchant operating hours */
  setMerchantOperatingHours?: Maybe<SetMerchantOperatingHoursPayload>;
  /** Set tip. */
  setTip?: Maybe<SetTipPayload>;
  signup?: Maybe<SignupMutationPayload>;
  /** Creates a standing appointment rule and immediately materializes its full date range into bookings. */
  standingAppointmentCreate?: Maybe<StandingAppointmentCreatePayload>;
  /**
   * Resolves one date that failed batch materialization by booking it into a
   * window ops is deliberately pushing over cap. Defaults to the least-over-cap
   * candidate window; pass dockWindowId (from standingAppointmentCandidateWindows)
   * to pick a specific one instead.
   */
  standingAppointmentResolveFailedDate?: Maybe<StandingAppointmentResolveFailedDatePayload>;
  /**
   * Edits a standing appointment's effective_until — the only editable field.
   * Shortening it cancels every not-yet-arrived booking now outside the range;
   * extending it books the newly-covered dates (created_bookings/failed_dates),
   * the same success/failure split as creation.
   */
  standingAppointmentUpdateEffectiveUntil?: Maybe<StandingAppointmentUpdateEffectiveUntilPayload>;
  /** Attaches an uploaded customer-tag CSV to its import and hands it off for processing. */
  startCustomerTagImport?: Maybe<StartCustomerTagImportMutationPayload>;
  /** Start phone number verification. */
  startPhoneNumberVerification?: Maybe<StartPhoneNumberVerificationPayload>;
  /** Retires a batch onboarding run. Nothing further is handed off; records already in flight complete on their own. */
  stopBatchOnboardRun?: Maybe<StopBatchOnboardRunMutationPayload>;
  /** Submit a check-in entry for a chance to win */
  submitCheckIn?: Maybe<SubmitCheckInMutationPayload>;
  /** Submit guest information to a microsite mailing list */
  submitMailingList?: Maybe<SubmitMailingListMutationPayload>;
  submitPurchaseHistoryFeedback: SubmitPurchaseHistoryFeedbackPayload;
  /** Submit a score to a leaderboard (public for game integration) */
  submitScore?: Maybe<SubmitScoreMutationPayload>;
  /** PROTOTYPE mutation submit (eg finish/end) an in-progress LocationStockCount session. */
  submitStockCount?: Maybe<SubmitStockCountMutationPayload>;
  /** Submit a suggestion or feedback with AI sentiment analysis */
  submitSuggestion?: Maybe<SubmitSuggestionMutationPayload>;
  /** Delete all items in the user's supply cart at the given location. Idempotent. */
  supplyClearCart?: Maybe<SupplyClearCartPayload>;
  /** Remove an item from the user's supply cart at the given location. Idempotent. */
  supplyRemoveCartItem?: Maybe<SupplyRemoveCartItemPayload>;
  /** Add or update an item in the user's supply cart at the given location. Quantity is absolute. */
  supplyUpsertCartItem?: Maybe<SupplyUpsertCartItemPayload>;
  /** Temporary scaffolding to help with initial rollout of microsites. */
  syncMicrositeConfig?: Maybe<SyncMicrositeConfigMutationPayload>;
  /** Updates viewed_at time stamp for a delivery route stop */
  touchDeliveryRouteStop?: Maybe<DeliveryRouteStopViewedAtUpdatePayload>;
  /**
   * Transform product image: remove background, standardize, enhance.
   * Accepts an S3 URL from signedUploadImageByKey (e.g., "https://s3.amazonaws.com/bucket/tmp/uuid.png").
   */
  transformProductImage: TransformProductImageResult;
  /** Translate an instruction note into Spanish, reusing the saved translation while its source text is unchanged. */
  translateDeliveryInstruction?: Maybe<TranslateDeliveryInstructionMutationPayload>;
  /** Enqueue the HubSpot rep assignment sync job on demand */
  triggerHubspotRepSync?: Maybe<TriggerHubspotRepSyncPayload>;
  /**
   * Triggers a manual (GM) Routific run for a warehouse and night in the given
   * mode. The run is processed asynchronously; observe it via
   * RoutingImportPlan.manualRoutificRuns.
   */
  triggerManualRoutificRun?: Maybe<TriggerManualRoutificRunPayload>;
  /** Initiates synchronization of routes and stops, triggering Kafka events. */
  triggerRoutesSync?: Maybe<TriggerRoutesSyncPayload>;
  /**
   * Triggers a proposed (scenario) Routific run for a warehouse and night. The run
   * never touches dispatched routes; observe it via RoutingImportPlan.scenarios.
   */
  triggerRoutificScenarioRun?: Maybe<TriggerRoutificScenarioRunPayload>;
  /** Turn off supply for a Location. Writes to NetSuite (custentity_supply_signed_up) and updates local caches. */
  turnOffLocationSupply?: Maybe<TurnOffLocationSupplyMutationPayload>;
  unapproveCutoffDiscrepancy?: Maybe<UnapproveCutoffDiscrepancyPayload>;
  /**
   * Undoes a recorded replenishment trip by dispatching a new opposite-direction
   * Bin Transfer. Any associate can undo a replenishment trip, however long ago it
   * was recorded, once it has been confirmed, so it is not instant.
   */
  undoReplenishmentPick?: Maybe<UndoReplenishmentPickPayload>;
  /**
   * Reverts a route marked for a third-party provider back to a GM-built generic
   * route (epic sc-66318). Allowed after a failed push and from quoting until the
   * route is dispatched. The call makes no request to the provider and never waits
   * on it: the route is reverted at once and a background sweep deletes the
   * provider's draft route and orders within minutes. Refused while the push is
   * running ("push in progress, retry shortly").
   */
  unmarkRouteProvider?: Maybe<UnmarkRouteProviderPayload>;
  /** Delete the user's incomplete subscription for this item at this location, if such a subscription exists. */
  unsubscribeFromBackInStockNotification?: Maybe<UnsubscribeFromBackInStockNotificationMutationPayload>;
  /** Updates stop arrived_at time */
  updateArrivedAtStopTime?: Maybe<UpdateArrivedAtStopTimePayload>;
  updateBrandedItemDeal?: Maybe<UpdateBrandedItemDealMutationPayload>;
  /** Update the selected size/quantity/note/modifiers on specific cart items. */
  updateCartItems?: Maybe<UpdateCartItemsPayload>;
  /** Update app config */
  updateConfig?: Maybe<UpdateConfigPayload>;
  /** Update current consumer app user. */
  updateCurrentConsumerAppUser?: Maybe<UpdateCurrentConsumerAppUserPayload>;
  /** Update current consumer app user phone number. */
  updateCurrentConsumerAppUserPhoneNumber?: Maybe<UpdateCurrentConsumerAppUserPhoneNumberPayload>;
  updateCustomIngredient?: Maybe<UpdateCustomIngredientMutationPayload>;
  updateCustomerTag?: Maybe<UpdateCustomerTagMutationPayload>;
  /** Update a delivery issue for a delivery route stop */
  updateDeliveryIssue?: Maybe<DeliveryIssueUpdatePayload>;
  /** Updates stop departed_at time */
  updateDepartedAtStopTime?: Maybe<UpdateDepartedAtStopTimePayload>;
  /** Update a driver safety acknowledgement */
  updateDriverSafetyAcknowledgement?: Maybe<DriverSafetyAcknowledgementUpdatePayload>;
  updateExternalBaseBrandedItem?: Maybe<UpdateExternalBaseBrandedItemMutationPayload>;
  /** PROTOTYPE store reified order information for the orders created from GeneratedOrderQuantities. */
  updateGeneratedOrderQuantities?: Maybe<UpdateGeneratedOrderQuantitiesMutationPayload>;
  /** Update a guest player's username */
  updateGuestUsername?: Maybe<UpdateGuestUsernameMutationPayload>;
  updateHomepageDisplayRules?: Maybe<UpdateHomepageDisplayRulesPayload>;
  updateInHouseBaseBrandedItem?: Maybe<UpdateInHouseBaseBrandedItemMutationPayload>;
  updateInProgressCustomer?: Maybe<UpdateInProgressCustomerMutationPayload>;
  updateInventoryItem?: Maybe<SupplyItem>;
  updateItemBrand?: Maybe<ItemBrandUpdatePayload>;
  /**
   * Correct how an inventory item builds a pallet. `casesPerPallet` is derived as
   * `casesPerLayer * layersPerPallet` and so is not accepted here; read it back off the returned item.
   * Narrow on purpose: warehouse associates may fix a pallet build without the broader item write access
   * `updateInventoryItem` carries.
   */
  updateItemPalletConfiguration: UpdateItemPalletConfigurationPayload;
  updateItemPrices: UpdateItemPricesPayload;
  updateItemTag?: Maybe<ItemTag>;
  /** Updates a line-level delivery reason. Pass `subReasonCode: null` explicitly to clear the field; omit to leave unchanged. */
  updateLineLevelDeliveryIssue?: Maybe<LineLevelDeliveryIssueUpdatePayload>;
  /**
   * Update the boolean that determines if a stop should be included in the
   * automated routing for that warehouse. True means the location will get routed.
   * False means the location will remain in the lobby.
   */
  updateLocationIncludeInAutomatedRouting?: Maybe<LocationIncludeInAutomatedRoutingUpdatePayload>;
  updateLocationOpeningHours?: Maybe<UpdateLocationOpeningHoursMutationPayload>;
  updateLocationOpeningHoursFromGoogle?: Maybe<UpdateLocationOpeningHoursFromGooglePayload>;
  /** PROTOTYPE mutation to manually associate a platform's profile with a particular Odeko location */
  updateLocationPlatformProfile?: Maybe<UpdateLocationPlatformProfileMutationPayload>;
  /**
   * Update the boolean marking locations as warehouse-pickup customers. True means
   * the customer collects their order at the warehouse instead of receiving a delivery.
   */
  updateLocationsCustomerPickup?: Maybe<LocationsCustomerPickupUpdatePayload>;
  /** Update deliver_within_store_hours field for multiple locations */
  updateLocationsDeliverWithinStoreHours?: Maybe<UpdateLocationsDeliverWithinStoreHoursMutationPayload>;
  /** Update the boolean that determines if a stop should enforce item scanning for an array of locations. */
  updateLocationsEnforceItemScanning?: Maybe<LocationsEnforceItemScanningUpdatePayload>;
  /**
   * Update the boolean that determines if a stop should be included in the
   * automated routing for that warehouse for an array of locations. True means the
   * location will get routed. False means the location will remain in the lobby.
   */
  updateLocationsIncludeInAutomatedRouting?: Maybe<LocationsIncludeInAutomatedRoutingUpdatePayload>;
  /** Update the boolean that determines if a location opts in to printable delivery sheets for an array of locations. */
  updateLocationsPrintDeliverySheetEnabled?: Maybe<LocationsPrintDeliverySheetEnabledUpdatePayload>;
  /** Updates the associated routing cohort for a list of locations. */
  updateLocationsRoutingCohort?: Maybe<UpdateLocationsRoutingCohortMutationPayload>;
  /**
   * Update the service time for an array of locations. The service time is the
   * time it takes to perform a delivery at a location. This is used to calculate
   * the total time for a delivery route.
   */
  updateLocationsServiceTime?: Maybe<LocationsServiceTimeUpdatePayload>;
  /** Set the location-owned third-party delivery exclusion for one or more locations. */
  updateLocationsThirdPartyExclusion?: Maybe<LocationsThirdPartyExclusionUpdatePayload>;
  /** Update a marketing QR code. */
  updateMarketingQrCode?: Maybe<UpdateMarketingQrCodeMutationPayload>;
  /** Update marketing QR codes from CSV. */
  updateMarketingQrCodesFromCsv?: Maybe<UpdateMarketingQrCodesFromCsvMutationPayload>;
  /** Update a menu-item's saved visibility */
  updateMenuItemSavedVisibility?: Maybe<UpdateMenuItemSavedVisibilityPayload>;
  /** Update menu-items sort order */
  updateMenuItemsSortOrder?: Maybe<UpdateMenuItemsSortOrderPayload>;
  /** Update a menu's saved visibility */
  updateMenuSavedVisibility?: Maybe<UpdateMenuSavedVisibilityPayload>;
  /** Update menus sort order */
  updateMenusSortOrder?: Maybe<UpdateMenusSortOrderPayload>;
  /** Update merchant curbsidePickup */
  updateMerchantCurbsidePickup?: Maybe<UpdateMerchantCurbsidePickupPayload>;
  /** Update the notification sound used by merchant app */
  updateMerchantNotificationSound?: Maybe<UpdateMerchantNotificationSoundPayload>;
  /** Update merchant pickupText */
  updateMerchantPickupText?: Maybe<UpdateMerchantPickupTextPayload>;
  /** Update merchant status */
  updateMerchantStatus?: Maybe<UpdateMerchantStatusPayload>;
  /** Update the ad information for a microsite location. */
  updateMicrositeAdInfo?: Maybe<UpdateMicrositeAdInfoPayload>;
  /** Update the details of an existing microsite (eg its configuration). */
  updateMicrositeLocation?: Maybe<UpdateMicrositeMutationPayload>;
  /** Specify a total ordering for the modules of a microsite location, regardless of visibility. */
  updateMicrositeModulesOrder?: Maybe<UpdateMicrositeModulesOrderPayload>;
  /** Update a modifier group saved visibility */
  updateModifierGroupSavedVisibility?: Maybe<UpdateModifierGroupSavedVisibilityPayload>;
  /** Update modifier-groups sort order */
  updateModifierGroupsSortOrder?: Maybe<UpdateModifierGroupsSortOrderPayload>;
  /** Update a modifier option saved visibility */
  updateModifierOptionSavedVisibility?: Maybe<UpdateModifierOptionSavedVisibilityPayload>;
  /** Update modifier-options sort order */
  updateModifierOptionsSortOrder?: Maybe<UpdateModifierOptionsSortOrderPayload>;
  updateNonInventoryItem?: Maybe<SupplyItem>;
  /** PROTOTYPE mutation to update an Odeko Items par value, storage area, or counting unit */
  updateOdekoItemInventory?: Maybe<UpdateOdekoItemInventoryMutationPayload>;
  /** Update the delivery method for order(s). */
  updateOrderDeliveryMethod?: Maybe<UpdateOrderDeliveryMethodMutationPayload>;
  /**
   * GM-only: set the delivered_quantity on an order line during DMP review. Must
   * be >= 0 (over-delivery is allowed). The note is required and flows into the
   * paper_trail version metadata. Distinct from the driver-path
   * updateOrderQuantityDelivered mutation, which bulk-updates an order's lines
   * with mark-delivered side effects.
   */
  updateOrderLineDeliveredQuantity?: Maybe<OrderLineDeliveredQuantityUpdatePayload>;
  /**
   * GM-only: set the fulfillment_quantity on an order line during DMP review. Must
   * be >= 0 (over-fulfillment is allowed). The note is required and flows into the
   * paper_trail version metadata. For market-priced lines, the
   * purchase_price_cents and selling_price_cents are recalculated automatically
   * from the order_vendor_receiving record — same logic as the driver path. This
   * path is intentionally exempt from any future post-Route-End lock added to the
   * driver/sync paths.
   */
  updateOrderLineFulfillmentQuantity?: Maybe<OrderLineFulfillmentQuantityUpdatePayload>;
  /**
   * GM-only: set the recovery_quantity on an order line during DMP review. Valid
   * range is [0, max(fulfillment_quantity - delivered_quantity, 0)] — the cap is
   * clamped at 0 so over-delivered lines can still record a no-recovery decision.
   * The note is required and flows into the paper_trail version metadata.
   */
  updateOrderLineRecoveryQuantity?: Maybe<OrderLineRecoveryQuantityUpdatePayload>;
  /** Update the quantity delivered for each order line of an order */
  updateOrderQuantityDelivered?: Maybe<OrderQuantityDeliveredUpdatePayload>;
  /** Add or update warehouse note for an order */
  updateOrderWarehouseNote?: Maybe<OrderWarehouseNoteUpdatePayload>;
  /** Create association between a platform's profile and a microsite location */
  updatePlatformMicrositeLocation?: Maybe<UpdatePlatformMicrositeLocationMutationPayload>;
  updateReceivableNote?: Maybe<UpdateReceivableNotePayload>;
  /** Assigns driver to a route */
  updateRouteDetails?: Maybe<RouteDetailsUpdatePayload>;
  /** Update a route origin */
  updateRouteOrigin?: Maybe<RouteOriginUpdatePayload>;
  /** Add or update route stop delivery note */
  updateRouteStopDeliveryNote?: Maybe<DeliveryRouteStopDeliveryNoteUpdatePayload>;
  /** Add or update route stop driver reminder message */
  updateRouteStopDriverReminder?: Maybe<DeliveryRouteStopReminderUpdatePayload>;
  /** Edit an unresolved additional task on a delivery route stop */
  updateRouteStopTask?: Maybe<DeliveryRouteStopTaskUpdatePayload>;
  /** Add or update route stop upsell note */
  updateRouteStopUpsellNote?: Maybe<DeliveryRouteStopUpsellNoteUpdatePayload>;
  /** Updates delivery route assigned vehicle. */
  updateRouteTruck?: Maybe<RouteTruckUpdatePayload>;
  /** Update truck count for a routing import plan */
  updateRoutingImportPlanTruckCount?: Maybe<RoutingImportPlanTruckCountUpdatePayload>;
  updateSoApiRoutingImportPlanTruckCount?: Maybe<UpdateSoApiRoutingImportPlanTruckCountMutationPayload>;
  /** Update an order suggestion's line items (replaces all existing line items) */
  updateSquareOrderSuggestion?: Maybe<UpdateSquareOrderSuggestionMutationPayload>;
  /** Append transcript to an order suggestion and re-parse via GPT */
  updateSquareOrderSuggestionFromTranscript?: Maybe<UpdateSquareOrderSuggestionFromTranscriptMutationPayload>;
  /** Updates route start time */
  updateStartRouteTime?: Maybe<StartRouteTimeUpdatePayload>;
  /** Updates route completion time */
  updateStopRouteTime?: Maybe<StopRouteTimeUpdatePayload>;
  /** Update a submenu's saved visibility */
  updateSubmenuSavedVisibility?: Maybe<UpdateSubmenuSavedVisibilityPayload>;
  /** Update submenus sort order */
  updateSubmenusSortOrder?: Maybe<UpdateSubmenusSortOrderPayload>;
  /** Update an existing subscription session with additional details (email, sign options, etc.) */
  updateSubscriptionSession?: Maybe<UpdateSubscriptionSessionMutationPayload>;
  /** Update an existing user's profile, role, or location access */
  updateUser?: Maybe<UpdateUserMutationPayload>;
  updateUserNotificationPreferences?: Maybe<UpdateUserNotificationPreferencesMutationPayload>;
  /** Records the time the driver returned to the warehouse (geofence entry) */
  updateWarehouseArrivedAtRouteTime?: Maybe<UpdateWarehouseArrivedAtRouteTimePayload>;
  /** Records the time the driver departed the warehouse (geofence exit) */
  updateWarehouseDepartedAtRouteTime?: Maybe<UpdateWarehouseDepartedAtRouteTimePayload>;
  updateWarehousesLeadTime?: Maybe<UpdateWarehousesLeadTimeMutationPayload>;
  uploadArtwork?: Maybe<UploadArtworkMutationPayload>;
  uploadArtworkForItem?: Maybe<UploadArtworkForItemMutationPayload>;
  /** Create or update an account creation session */
  upsertAccountCreationSession?: Maybe<UpsertAccountCreationSessionPayload>;
  upsertAdminOrderItemMutation?: Maybe<UpsertAdminOrderItemMutationPayload>;
  upsertArAssignment?: Maybe<UpsertArAssignmentPayload>;
  upsertBackInStockSubscription?: Maybe<UpsertBackInStockSubscriptionMutationPayload>;
  upsertCategoryBanner?: Maybe<CategoryBannerPayload>;
  upsertDeliveryDatePoNumbers?: Maybe<UpsertDeliveryDatePoNumbersMutationPayload>;
  /** Creates or updates an external delivery with a 3rd party delivery partner. */
  upsertExternalDeliveryMutation?: Maybe<UpsertExternalDeliveryMutationPayload>;
  upsertExternalSupplier: UpsertExternalSupplierPayload;
  upsertLocationAccountsReceivableCollectionsStatus?: Maybe<UpsertLocationAccountsReceivableCollectionsStatusPayload>;
  upsertLocationItem?: Maybe<LocationItem>;
  /** Create or update orders for a location across one or more delivery dates */
  upsertLocationOrders?: Maybe<UpsertLocationOrdersMutationPayload>;
  upsertLocationPhoneNumber?: Maybe<UpsertLocationPhoneNumberMutationPayload>;
  upsertMasterHomepage?: Maybe<UpsertMasterHomepagePayload>;
  /**
   * Create or update a guestbook message for a microsite location. This is a
   * public mutation that allows users to leave messages on the microsite.
   */
  upsertMicrositeGuestbookMessage?: Maybe<UpsertMicrositeGuestbookMessageMutationPayload>;
  /** Create or update a menu item for a microsite location. */
  upsertMicrositeMenuItem?: Maybe<UpsertMicrositeMenuItemPayload>;
  /** Pin an item to an absolute New Items slot for a market (re-pinning moves the item). Studio-only. */
  upsertNewItemPin: NewItemPinPayload;
  /** Create or update an order for a location */
  upsertOrderMutation?: Maybe<UpsertOrderMutationPayload>;
  upsertRecipe?: Maybe<UpsertRecipeMutationPayload>;
  upsertShippingInstructions?: Maybe<UpsertShippingInstructionsMutationPayload>;
  /** Pin or re-pin a curated substitute for an item; idempotent on the (source, substitute) pair. Procurement-only. */
  upsertSubstitutionOverride: SubstitutionOverridePayload;
  upsertSurvey?: Maybe<UpsertSurveyMutationPayload>;
  upsertWarehouseZipcodes?: Maybe<UpsertWarehouseZipcodesPayload>;
  upsertZipcodeDeliveryRule?: Maybe<UpsertZipcodeDeliveryRulePayload>;
  upsertZipcodeDeliveryWindow?: Maybe<UpsertZipcodeDeliveryWindowPayload>;
  /** Validate Stripe checkout session and complete subscription session for magic-portal flow */
  validateAndCompleteSubscriptionSession?: Maybe<ValidateAndCompleteSubscriptionSessionMutationPayload>;
  /** Validate Stripe checkout session status and update subscription session */
  validateSubscriptionSessionCheckout?: Maybe<ValidateSubscriptionSessionCheckoutMutationPayload>;
  voteMicrositePoll?: Maybe<VoteMicrositePollMutationPayload>;
  /** Admin revokes an associate's current badge (advances badge_version); the badge must be reprinted. */
  warehouseAssociateBadgeRevoke?: Maybe<WarehouseAssociateBadgeRevokePayload>;
  /** Save a warehouse's layout draft. Send the loaded revision back; a stale revision is rejected in userErrors. */
  warehouseLayoutSave?: Maybe<WarehouseLayoutSavePayload>;
  /** Creates a shift (and its breaks) for a warehouse. */
  warehouseShiftCreate?: Maybe<WarehouseShiftCreatePayload>;
  /** Deletes a warehouse shift and its breaks. */
  warehouseShiftDelete?: Maybe<WarehouseShiftDeletePayload>;
  /** Updates a shift's type/times and, when breaks are given, replaces its breaks wholesale. */
  warehouseShiftUpdate?: Maybe<WarehouseShiftUpdatePayload>;
  /** Sets the weekdays a warehouse is closed for dock booking, replacing the full set. */
  warehouseUpdateClosedDays?: Maybe<WarehouseUpdateClosedDaysPayload>;
  /**
   * Sets the warehouse's declared daily truck ceiling per freight (can't go below
   * the admin min or the docks' current allocation).
   */
  warehouseUpdateDailyCapacity?: Maybe<WarehouseUpdateDailyCapacityPayload>;
};


export type MutationAccessWifiArgs = {
  input: AccessWifiMutationInput;
};


export type MutationAcknowledgeBackInStockNotificationArgs = {
  input: AcknowledgeBackInStockNotificationMutationInput;
};


export type MutationAcknowledgeConsumerOrderArgs = {
  input: AcknowledgeConsumerOrderInput;
};


export type MutationAcknowledgeDeliveryInstructionReviewArgs = {
  input: AcknowledgeDeliveryInstructionReviewMutationInput;
};


export type MutationAcknowledgeDriverSafetyAcknowledgementArgs = {
  input: DriverSafetyAcknowledgementAcknowledgeInput;
};


export type MutationAdHocAppointmentCreateArgs = {
  input: AdHocAppointmentCreateInput;
};


export type MutationAddFavoriteConsumerOrderArgs = {
  input: AddFavoriteConsumerOrderInput;
};


export type MutationAddItemsToCartArgs = {
  input: AddItemsToCartInput;
};


export type MutationAddMicrositeLocationArgs = {
  input: AddMicrositeMutationInput;
};


export type MutationApplyHeaderReasonToStopLineLevelDeliveryIssueArgs = {
  input: LineLevelDeliveryIssueApplyHeaderReasonInput;
};


export type MutationApplyRewardArgs = {
  input: ApplyRewardInput;
};


export type MutationApplyRoutingConfigurationArgs = {
  input: ApplyRoutingConfigurationInput;
};


export type MutationApproveCutoffDiscrepancyArgs = {
  input: ApproveCutoffDiscrepancyInput;
};


export type MutationAssignCustomerTagArgs = {
  input: AssignCustomerTagMutationInput;
};


export type MutationAttachmentUrlPresignerArgs = {
  input: AttachmentUrlPresignerCreateInput;
};


export type MutationBatchOnboardInProgressCustomersArgs = {
  input: BatchOnboardInProgressCustomersMutationInput;
};


export type MutationBulkCreateSupplierInvoiceComparisonRowsArgs = {
  input: BulkCreateSupplierInvoiceComparisonRowsInput;
};


export type MutationBulkUpdateRouteStopsDeliveryInfoArgs = {
  input: BulkUpdateRouteStopsDeliveryInfoInput;
};


export type MutationBulkUpsertZipcodeDeliveryRulesArgs = {
  input: BulkUpsertZipcodeDeliveryRulesInput;
};


export type MutationCancelOrderMutationArgs = {
  input: CancelOrderMutationInput;
};


export type MutationCheckinOrderVendorReceivingArgs = {
  input: CheckinOrderVendorReceivingInput;
};


export type MutationCheckoutArgs = {
  input: CheckoutInput;
};


export type MutationClaimRewardArgs = {
  input: ClaimRewardInput;
};


export type MutationCompleteConsumerAppReferralArgs = {
  input: CompleteConsumerAppReferralInput;
};


export type MutationCompleteStripeCheckoutSessionArgs = {
  input: CompleteStripeCheckoutSessionMutationInput;
};


export type MutationCompleteSubscriptionSessionArgs = {
  input: CompleteSubscriptionSessionMutationInput;
};


export type MutationCompleteSupplierInvoiceUploadArgs = {
  input: CompleteSupplierInvoiceUploadInput;
};


export type MutationConfirmOrderReviewArgs = {
  input: OrderReviewConfirmInput;
};


export type MutationConfirmPutawayPalletArgs = {
  input: ConfirmPutawayPalletInput;
};


export type MutationConfirmSquareOrderSuggestionArgs = {
  input: ConfirmSquareOrderSuggestionMutationInput;
};


export type MutationConnectLocationCreditKeyAccountArgs = {
  input: ConnectLocationCreditKeyAccountMutationInput;
};


export type MutationConsumerOrderCompleteArgs = {
  input: ConsumerOrderCompleteInput;
};


export type MutationConsumerOrderPickedUpArgs = {
  input: ConsumerOrderPickedUpInput;
};


export type MutationConsumerOrderReadyArgs = {
  input: ConsumerOrderReadyInput;
};


export type MutationCreateBrandedItemDealArgs = {
  input: CreateBrandedItemDealMutationInput;
};


export type MutationCreateCollectionPromoSetupArgs = {
  input: CreateCollectionPromoSetupInput;
};


export type MutationCreateCountingEventArgs = {
  input: CreateCountingEventMutationInput;
};


export type MutationCreateCustomIngredientArgs = {
  input: CreateCustomIngredientMutationInput;
};


export type MutationCreateCustomerTagArgs = {
  input: CreateCustomerTagMutationInput;
};


export type MutationCreateCustomerTagImportArgs = {
  input: CreateCustomerTagImportMutationInput;
};


export type MutationCreateDeliveryOverrideRuleArgs = {
  input: CreateDeliveryOverrideRuleMutationInput;
};


export type MutationCreateDeliveryRouteStopAttachmentArgs = {
  input: DeliveryRouteStopAttachmentCreateInput;
};


export type MutationCreateDirectStripeCheckoutSessionArgs = {
  input: CreateDirectStripeCheckoutSessionMutationInput;
};


export type MutationCreateDriverSafetyAcknowledgementArgs = {
  input: DriverSafetyAcknowledgementCreateInput;
};


export type MutationCreateExternalBaseBrandedItemArgs = {
  input: CreateExternalBaseBrandedItemMutationInput;
};


export type MutationCreateExternalDeliveryMutationArgs = {
  input: CreateExternalDeliveryMutationInput;
};


export type MutationCreateFieldServiceZipcodeArgs = {
  input: CreateFieldServiceZipcodeMutationInput;
};


export type MutationCreateFullConsumerRefundArgs = {
  input: CreateFullConsumerRefundInput;
};


export type MutationCreateGameArgs = {
  input: CreateGameMutationInput;
};


export type MutationCreateHomepageComponentArgs = {
  input: CreateHomepageComponentInput;
};


export type MutationCreateHomepageDisplayRuleArgs = {
  input: CreateHomepageDisplayRuleInput;
};


export type MutationCreateHubspotLeadArgs = {
  input: CreateHubspotLeadInput;
};


export type MutationCreateInHouseBaseBrandedItemArgs = {
  input: CreateInHouseBaseBrandedItemMutationInput;
};


export type MutationCreateInventoryItemArgs = {
  item: InventoryItemInput;
};


export type MutationCreateItemBrandArgs = {
  input: ItemBrandCreateInput;
};


export type MutationCreateItemTagArgs = {
  tag: ItemTagInput;
};


export type MutationCreateLeaderboardArgs = {
  input: CreateLeaderboardMutationInput;
};


export type MutationCreateLocationArgs = {
  input: CreateLocationMutationInput;
};


export type MutationCreateLocationVendorAssociationArgs = {
  input: CreateLocationVendorAssociationMutationInput;
};


export type MutationCreateMarketingToolsManagerArgs = {
  input: CreateMarketingToolsManagerMutationInput;
};


export type MutationCreateMenuArgs = {
  input: CreateMenuInput;
};


export type MutationCreateMenuItemArgs = {
  input: CreateMenuItemInput;
};


export type MutationCreateMicrositeLocationArgs = {
  input: CreateMicrositeLocationMutationInput;
};


export type MutationCreateNonInventoryItemArgs = {
  item: NonInventoryItemInput;
};


export type MutationCreateOrderReconciliationAttachmentUploadRequestMutationArgs = {
  input: CreateOrderReconciliationAttachmentUploadRequestMutationInput;
};


export type MutationCreateOrderReconciliationMutationArgs = {
  input: CreateOrderReconciliationMutationInput;
};


export type MutationCreatePartialConsumerRefundArgs = {
  input: CreatePartialConsumerRefundInput;
};


export type MutationCreateReceivableNoteArgs = {
  input: CreateReceivableNoteInput;
};


export type MutationCreateRedeliveryStopsArgs = {
  input: RedeliveryStopCreateInput;
};


export type MutationCreateRouteStopTaskArgs = {
  input: DeliveryRouteStopTaskCreateInput;
};


export type MutationCreateSalesTaxEstimateArgs = {
  input: CreateSalesTaxEstimateMutationInput;
};


export type MutationCreateSignPurchaseCheckoutSessionArgs = {
  input: CreateSignPurchaseCheckoutSessionMutationInput;
};


export type MutationCreateSquareOrderSuggestionFromTranscriptArgs = {
  input: CreateSquareOrderSuggestionFromTranscriptMutationInput;
};


export type MutationCreateStorageAreaArgs = {
  input: CreateStorageAreaMutationInput;
};


export type MutationCreateStripeCheckoutSessionArgs = {
  input: CreateStripeCheckoutSessionMutationInput;
};


export type MutationCreateSubmenuArgs = {
  input: CreateSubmenuInput;
};


export type MutationCreateSupplierInvoiceArgs = {
  input: CreateSupplierInvoiceInput;
};


export type MutationCreateSupplierInvoiceComparisonArgs = {
  input: CreateSupplierInvoiceComparisonInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserMutationInput;
};


export type MutationCreateUserMicrositeLocationArgs = {
  input: CreateUserMicrositeLocationInput;
};


export type MutationCreateVehicleInspectionReportArgs = {
  input: VehicleInspectionReportCreateInput;
};


export type MutationCreateWarehouseDeliveryRouteArgs = {
  input: DeliveryRouteCreateInput;
};


export type MutationCreateWorkThreadArgs = {
  input: CreateWorkThreadInput;
};


export type MutationDeleteArAssignmentArgs = {
  input: DeleteArAssignmentInput;
};


export type MutationDeleteCategoryBannerArgs = {
  input: DeleteCategoryBannerInput;
};


export type MutationDeleteCollectionPromoSetupArgs = {
  input: DeleteCollectionPromoSetupInput;
};


export type MutationDeleteCustomerTagArgs = {
  input: DeleteCustomerTagMutationInput;
};


export type MutationDeleteDeliveryIssueArgs = {
  input: DeliveryIssueDeleteInput;
};


export type MutationDeleteDeliveryOverrideRuleArgs = {
  input: DeleteDeliveryOverrideRuleMutationInput;
};


export type MutationDeleteDeliveryRouteStopAttachmentArgs = {
  input: DeliveryRouteStopAttachmentDeleteInput;
};


export type MutationDeleteDriverSafetyAcknowledgementArgs = {
  input: DriverSafetyAcknowledgementDeleteInput;
};


export type MutationDeleteFieldServiceZipcodeArgs = {
  input: DeleteFieldServiceZipcodeMutationInput;
};


export type MutationDeleteItemBrandArgs = {
  input: ItemBrandDeleteInput;
};


export type MutationDeleteLineLevelDeliveryIssueArgs = {
  input: LineLevelDeliveryIssueDeleteInput;
};


export type MutationDeleteLocationAccountsReceivableCollectionsStatusArgs = {
  input: DeleteLocationAccountsReceivableCollectionsStatusInput;
};


export type MutationDeleteLocationPaymentMethodArgs = {
  input: DeleteLocationPaymentMethodMutationInput;
};


export type MutationDeleteLocationPhoneNumberArgs = {
  input: DeleteLocationPhoneNumberMutationInput;
};


export type MutationDeleteMasterHomepageArgs = {
  input: DeleteMasterHomepageInput;
};


export type MutationDeleteMasterHomepageRowComponentArgs = {
  input: DeleteMasterHomepageRowComponentInput;
};


export type MutationDeleteMicrositeMenuItemArgs = {
  input: DeleteMicrositeMenuItemInput;
};


export type MutationDeleteReceivableNoteArgs = {
  input: DeleteReceivableNoteInput;
};


export type MutationDeleteRedeliveryStopArgs = {
  input: RedeliveryStopDeleteInput;
};


export type MutationDeleteRouteStopTaskArgs = {
  input: DeliveryRouteStopTaskDeleteInput;
};


export type MutationDeleteRoutificScenarioArgs = {
  input: DeleteRoutificScenarioInput;
};


export type MutationDeleteS3FileArgs = {
  input: DeleteS3FileInput;
};


export type MutationDeleteSquareCardArgs = {
  input: DeleteSquareCardInput;
};


export type MutationDeleteUserMicrositeLocationArgs = {
  input: DeleteUserMicrositeLocationMutationInput;
};


export type MutationDeleteZipcodeArgs = {
  input: DeleteZipcodeMutationInput;
};


export type MutationDeleteZipcodeDeliveryRuleArgs = {
  input: DeleteZipcodeDeliveryRuleInput;
};


export type MutationDeliveryCompletedArgs = {
  input: DeliveryCompletedUpdateInput;
};


export type MutationDeliveryStopsReorderArgs = {
  input: DeliveryStopsReorderInput;
};


export type MutationDeprioritizeLocationArgs = {
  input: DeprioritizeLocationInput;
};


export type MutationDiscontinueWarehouseItemArgs = {
  id: Scalars['ID']['input'];
  input: Array<InputMaybe<DiscontinueWarehouseInput>>;
};


export type MutationDispatchProviderRouteArgs = {
  input: DispatchProviderRouteInput;
};


export type MutationDockBookingCancelArgs = {
  input: DockBookingCancelInput;
};


export type MutationDockBookingMarkMissedArgs = {
  input: DockBookingMarkMissedInput;
};


export type MutationDockBookingOpsCheckInArgs = {
  input: DockBookingOpsCheckInInput;
};


export type MutationDockCreateArgs = {
  input: DockCreateInput;
};


export type MutationDockDeleteArgs = {
  input: DockDeleteInput;
};


export type MutationDockOverrideCodeIssueArgs = {
  input: DockOverrideCodeIssueInput;
};


export type MutationDockOverrideCodeRevokeArgs = {
  input: DockOverrideCodeRevokeInput;
};


export type MutationDockUpdateArgs = {
  input: DockUpdateInput;
};


export type MutationDockVisitDepartArgs = {
  input: DockVisitDepartInput;
};


export type MutationDockVisitReassignDockArgs = {
  input: DockVisitReassignDockInput;
};


export type MutationDuplicateMasterHomepageArgs = {
  input: DuplicateMasterHomepageInput;
};


export type MutationEscalateStopsToProviderArgs = {
  input: EscalateStopsToProviderInput;
};


export type MutationGenerateCloudinaryUploadSignatureArgs = {
  input: GenerateUploadSignatureInput;
};


export type MutationGenerateItemDescriptionArgs = {
  input: GenerateItemDescriptionInput;
};


export type MutationGenerateOrderQuantitiesArgs = {
  input: GenerateOrderQuantitiesMutationInput;
};


export type MutationGeneratePresignedS3UrlArgs = {
  input: GeneratePresignedUrlMutationInput;
};


export type MutationImportPriceRulesCsvArgs = {
  input: ImportPriceRulesCsvInput;
};


export type MutationImportProcurementRecordsArgs = {
  input: Array<ImportProcurementInput>;
};


export type MutationInitializeMarketingToolsSignupArgs = {
  input: InitializeMarketingToolsSignupMutationInput;
};


export type MutationInitiateTerminalPairingArgs = {
  input: InitiateTerminalPairingMutationInput;
};


export type MutationLogSalesOutreachArgs = {
  input: LogSalesOutreachInput;
};


export type MutationLoginConsumerAppUserFromFirebaseArgs = {
  input: LoginConsumerAppUserFromFirebaseInput;
};


export type MutationMakeCreditKeyChargeArgs = {
  input: MakeCreditKeyChargeMutationInput;
};


export type MutationMarkCompostCollectedArgs = {
  input: DeliveryRouteStopCompostCollectedUpdateInput;
};


export type MutationMarkCustomerPickupStopsCompleteArgs = {
  input: MarkCustomerPickupStopsCompleteInput;
};


export type MutationMarkDonationCollectedArgs = {
  input: DeliveryRouteStopDonationCollectedUpdateInput;
};


export type MutationMarkItemsAsBulkPickedArgs = {
  input: MarkItemsAsBulkPickedMutationInput;
};


export type MutationMarkOrderDeliveredArgs = {
  input: OrderDeliveredUpdateInput;
};


export type MutationMarkRouteForProviderArgs = {
  input: MarkRouteForProviderInput;
};


export type MutationMoveDeliveryStopsToCustomerPickupArgs = {
  input: MoveDeliveryStopsToCustomerPickupInput;
};


export type MutationMoveDeliveryStopsToRouteArgs = {
  input: DeliveryStopsMoveToRouteInput;
};


export type MutationOrderCollectedArgs = {
  input: OrderCollectedUpdateInput;
};


export type MutationPerformOutOfStockChecksArgs = {
  input: PerformOutOfStockChecksMutationInput;
};


export type MutationPinItemAcrossMarketsArgs = {
  input: PinItemAcrossMarketsInput;
};


export type MutationPlatformCompleteActionArgs = {
  input: CompleteActionMutationInput;
};


export type MutationPricingServicePingifyArgs = {
  input: PricingServicePingifyInput;
};


export type MutationProcessPathAssignArgs = {
  input: ProcessPathAssignInput;
};


export type MutationProcessPathAssociateCreateArgs = {
  input: ProcessPathAssociateCreateInput;
};


export type MutationProcessPathAssociateSetStatusArgs = {
  input: ProcessPathAssociateSetStatusInput;
};


export type MutationProcessPathClearCoverageTargetArgs = {
  input: ProcessPathClearCoverageTargetInput;
};


export type MutationProcessPathClockInArgs = {
  input: ProcessPathClockInInput;
};


export type MutationProcessPathClockOutArgs = {
  input: ProcessPathClockOutInput;
};


export type MutationProcessPathCreateArgs = {
  input: ProcessPathCreateInput;
};


export type MutationProcessPathReorderArgs = {
  input: ProcessPathReorderInput;
};


export type MutationProcessPathSegmentCreateArgs = {
  input: ProcessPathSegmentCreateInput;
};


export type MutationProcessPathSegmentDeleteArgs = {
  input: ProcessPathSegmentDeleteInput;
};


export type MutationProcessPathSegmentEditArgs = {
  input: ProcessPathSegmentEditInput;
};


export type MutationProcessPathSelfAssignArgs = {
  input: ProcessPathSelfAssignInput;
};


export type MutationProcessPathSelfClockInArgs = {
  input: ProcessPathSelfClockInInput;
};


export type MutationProcessPathSelfClockOutArgs = {
  input: ProcessPathSelfClockOutInput;
};


export type MutationProcessPathSelfUnassignArgs = {
  input: ProcessPathSelfUnassignInput;
};


export type MutationProcessPathSetAvailabilityArgs = {
  input: ProcessPathSetAvailabilityInput;
};


export type MutationProcessPathSetCoverageTargetArgs = {
  input: ProcessPathSetCoverageTargetInput;
};


export type MutationProcessPathUnassignArgs = {
  input: ProcessPathUnassignInput;
};


export type MutationProcessPathUpdateArgs = {
  input: ProcessPathUpdateInput;
};


export type MutationProcurementAiFeedbackSubmitArgs = {
  input: ProcurementAiFeedbackSubmitInput;
};


export type MutationProcurementAssessmentSubmitArgs = {
  input: ProcurementAssessmentSubmitInput;
};


export type MutationProcurementCorrespondenceCommandArgs = {
  input: ProcurementCorrespondenceCommandInput;
};


export type MutationProcurementEmailThreadUpsertArgs = {
  input: ProcurementEmailThreadUpsertInput;
};


export type MutationProcurementMailboxCursorSetArgs = {
  input: ProcurementMailboxCursorSetInput;
};


export type MutationProcurementPoNoteCreateArgs = {
  input: ProcurementPoNoteCreateInput;
};


export type MutationProcurementPoTrackingAssignArgs = {
  input: ProcurementPoTrackingAssignInput;
};


export type MutationProcurementPoTrackingEnsureArgs = {
  input: ProcurementPoTrackingEnsureInput;
};


export type MutationProcurementPoTrackingUpdateArgs = {
  input: ProcurementPoTrackingUpdateInput;
};


export type MutationProcurementStatusOverrideArgs = {
  input: ProcurementStatusOverrideInput;
};


export type MutationProcurementThreadAssignToPoArgs = {
  input: ProcurementThreadAssignToPoInput;
};


export type MutationProcurementThreadLinkConfirmArgs = {
  input: ProcurementThreadLinkConfirmInput;
};


export type MutationProcurementThreadLinkCreateArgs = {
  input: ProcurementThreadLinkCreateInput;
};


export type MutationProcurementThreadTriageSetArgs = {
  input: ProcurementThreadTriageSetInput;
};


export type MutationProcurementTrackingVendorUpsertArgs = {
  input: ProcurementTrackingVendorUpsertInput;
};


export type MutationPublicDockBookingCancelArgs = {
  input: PublicDockBookingCancelInput;
};


export type MutationPublicDockBookingSubmitArgs = {
  input: PublicDockBookingSubmitInput;
};


export type MutationPublicDockCheckInArgs = {
  input: PublicDockCheckInInput;
};


export type MutationPublicDockDepartArgs = {
  input: PublicDockDepartInput;
};


export type MutationPublicOverrideBookingAmendArgs = {
  input: PublicOverrideBookingAmendInput;
};


export type MutationPublicOverrideBookingCancelArgs = {
  input: PublicOverrideBookingCancelInput;
};


export type MutationPublicOverrideBookingCreateArgs = {
  input: PublicOverrideBookingCreateInput;
};


export type MutationPublishReviewResponseArgs = {
  input: PublishReviewResponseMutationInput;
};


export type MutationPublishReviewResponseGbpArgs = {
  input: PublishReviewResponseGbpMutationInput;
};


export type MutationRebuildCartFromPastOrderArgs = {
  input: RebuildCartFromPastOrderInput;
};


export type MutationRecalculateCartPricesArgs = {
  input: RecalculateCartPricesInput;
};


export type MutationRecordDriverLocationPingsArgs = {
  input: RecordDriverLocationPingsInput;
};


export type MutationRecordManualBinTransferArgs = {
  input: RecordManualBinTransferInput;
};


export type MutationRecordReplenishmentPickArgs = {
  input: RecordReplenishmentPickInput;
};


export type MutationRemoveAllFromCartArgs = {
  input: RemoveAllFromCartInput;
};


export type MutationRemoveCustomerTagArgs = {
  input: RemoveCustomerTagMutationInput;
};


export type MutationRemoveFavoriteConsumerOrderArgs = {
  input: RemoveFavoriteConsumerOrderInput;
};


export type MutationRemoveItemsFromCartArgs = {
  input: RemoveItemsFromCartInput;
};


export type MutationRemoveLocationItemArgs = {
  input: LocationItemInput;
};


export type MutationRemoveNewItemPinArgs = {
  input: RemoveNewItemPinInput;
};


export type MutationRemoveRewardArgs = {
  input: RemoveRewardInput;
};


export type MutationRemoveSubstitutionOverrideArgs = {
  input: RemoveSubstitutionOverrideInput;
};


export type MutationReopenRouteArgs = {
  input: RouteReopenInput;
};


export type MutationReorderNewItemPinsArgs = {
  input: ReorderNewItemPinsInput;
};


export type MutationReportDeliveryIssueArgs = {
  input: DeliveryIssueCreateInput;
};


export type MutationReportLineLevelDeliveryIssueArgs = {
  input: LineLevelDeliveryIssueReportInput;
};


export type MutationReportPhoneNumberVerificationArgs = {
  input: ReportPhoneNumberVerificationInput;
};


export type MutationReportPutawayExceptionArgs = {
  input: ReportPutawayExceptionInput;
};


export type MutationReportPutawayPalletBuildCorrectionArgs = {
  input: ReportPutawayPalletBuildCorrectionInput;
};


export type MutationRequestS3UploadArgs = {
  input: RequestS3UploadInput;
};


export type MutationRequestSampleArgs = {
  input: RequestSampleMutationInput;
};


export type MutationRequestSupplierInvoiceReadUrlArgs = {
  input: RequestSupplierInvoiceReadUrlInput;
};


export type MutationRequoteProviderRouteArgs = {
  input: RequoteProviderRouteInput;
};


export type MutationResolveRouteStopTasksArgs = {
  input: DeliveryRouteStopTasksResolveInput;
};


export type MutationRestoreLocationArgs = {
  input: RestoreLocationInput;
};


export type MutationRfsmartCredentialAssignArgs = {
  input: RfsmartCredentialAssignInput;
};


export type MutationRfsmartCredentialRemovalCancelArgs = {
  input: RfsmartCredentialRemovalCancelInput;
};


export type MutationRfsmartCredentialRemovalCompleteArgs = {
  input: RfsmartCredentialRemovalCompleteInput;
};


export type MutationRfsmartCredentialRemovalRequestArgs = {
  input: RfsmartCredentialRemovalRequestInput;
};


export type MutationRfsmartCredentialSetArgs = {
  input: RfsmartCredentialSetInput;
};


export type MutationRfsmartCredentialSetPoolArgs = {
  input: RfsmartCredentialSetPoolInput;
};


export type MutationRfsmartCredentialUnassignArgs = {
  input: RfsmartCredentialUnassignInput;
};


export type MutationRoutingCohortShiftAssignArgs = {
  input: RoutingCohortShiftAssignInput;
};


export type MutationRunTransactionSyncArgs = {
  input: RunTransactionSyncInput;
};


export type MutationRunTransactionSyncAuditArgs = {
  input: RunTransactionSyncAuditInput;
};


export type MutationSaveConsumerAppReferralLinkArgs = {
  input: SaveConsumerAppReferralLinkInput;
};


export type MutationSaveMasterHomepageRowsArgs = {
  input: SaveMasterHomepageRowsInput;
};


export type MutationSaveRoutificScenarioArgs = {
  input: SaveRoutificScenarioInput;
};


export type MutationSaveVendorAllocationArgs = {
  input: SaveVendorAllocationInput;
};


export type MutationScanMarketingQrCodeArgs = {
  input: ScanMarketingQrCodeMutationInput;
};


export type MutationSendAlignmentMessageArgs = {
  input: SendAlignmentMessageInput;
};


export type MutationSendBrandedPaperQuestionEmailArgs = {
  input: SendBrandedPaperQuestionEmailMutationInput;
};


export type MutationSendChatMessageArgs = {
  input: SendChatMessageInput;
};


export type MutationSendEquipmentCheckoutEmailArgs = {
  input: SendEquipmentCheckoutEmailMutationInput;
};


export type MutationSendEquipmentQuestionEmailArgs = {
  input: SendEquipmentQuestionEmailMutationInput;
};


export type MutationSetDefaultPaymentMethodForLocationsArgs = {
  input: SetDefaultPaymentMethodForLocationsMutationInput;
};


export type MutationSetFinancialStatementPreferencesArgs = {
  input: SetFinancialStatementPreferencesMutationInput;
};


export type MutationSetFleetCompositionArgs = {
  input: SetFleetCompositionInput;
};


export type MutationSetFundApplicationExclusionsArgs = {
  input: SetFundApplicationExclusionsInput;
};


export type MutationSetInvoiceExternalSupplierArgs = {
  input: SetInvoiceExternalSupplierInput;
};


export type MutationSetItemInactiveArgs = {
  id: Scalars['ID']['input'];
  inactive: Scalars['Boolean']['input'];
};


export type MutationSetMerchantOperatingHoursArgs = {
  input: SetMerchantOperatingHoursInput;
};


export type MutationSetTipArgs = {
  input: SetTipInput;
};


export type MutationSignupArgs = {
  input: SignupMutationInput;
};


export type MutationStandingAppointmentCreateArgs = {
  input: StandingAppointmentCreateInput;
};


export type MutationStandingAppointmentResolveFailedDateArgs = {
  input: StandingAppointmentResolveFailedDateInput;
};


export type MutationStandingAppointmentUpdateEffectiveUntilArgs = {
  input: StandingAppointmentUpdateEffectiveUntilInput;
};


export type MutationStartCustomerTagImportArgs = {
  input: StartCustomerTagImportMutationInput;
};


export type MutationStartPhoneNumberVerificationArgs = {
  input: StartPhoneNumberVerificationInput;
};


export type MutationStopBatchOnboardRunArgs = {
  input: StopBatchOnboardRunMutationInput;
};


export type MutationSubmitCheckInArgs = {
  input: SubmitCheckInMutationInput;
};


export type MutationSubmitMailingListArgs = {
  input: SubmitMailingListMutationInput;
};


export type MutationSubmitPurchaseHistoryFeedbackArgs = {
  input: SubmitPurchaseHistoryFeedbackInput;
};


export type MutationSubmitScoreArgs = {
  input: SubmitScoreMutationInput;
};


export type MutationSubmitStockCountArgs = {
  input: SubmitStockCountMutationInput;
};


export type MutationSubmitSuggestionArgs = {
  input: SubmitSuggestionMutationInput;
};


export type MutationSupplyClearCartArgs = {
  input: SupplyClearCartInput;
};


export type MutationSupplyRemoveCartItemArgs = {
  input: SupplyRemoveCartItemInput;
};


export type MutationSupplyUpsertCartItemArgs = {
  input: SupplyUpsertCartItemInput;
};


export type MutationSyncMicrositeConfigArgs = {
  input: SyncMicrositeConfigMutationInput;
};


export type MutationTouchDeliveryRouteStopArgs = {
  input: DeliveryRouteStopViewedAtUpdateInput;
};


export type MutationTransformProductImageArgs = {
  input: TransformProductImageInput;
};


export type MutationTranslateDeliveryInstructionArgs = {
  input: TranslateDeliveryInstructionMutationInput;
};


export type MutationTriggerHubspotRepSyncArgs = {
  input: TriggerHubspotRepSyncInput;
};


export type MutationTriggerManualRoutificRunArgs = {
  input: TriggerManualRoutificRunInput;
};


export type MutationTriggerRoutesSyncArgs = {
  input: TriggerRoutesSyncInput;
};


export type MutationTriggerRoutificScenarioRunArgs = {
  input: TriggerRoutificScenarioRunInput;
};


export type MutationTurnOffLocationSupplyArgs = {
  input: TurnOffLocationSupplyMutationInput;
};


export type MutationUnapproveCutoffDiscrepancyArgs = {
  input: UnapproveCutoffDiscrepancyInput;
};


export type MutationUndoReplenishmentPickArgs = {
  input: UndoReplenishmentPickInput;
};


export type MutationUnmarkRouteProviderArgs = {
  input: UnmarkRouteProviderInput;
};


export type MutationUnsubscribeFromBackInStockNotificationArgs = {
  input: UnsubscribeFromBackInStockNotificationMutationInput;
};


export type MutationUpdateArrivedAtStopTimeArgs = {
  input: UpdateArrivedAtStopTimeInput;
};


export type MutationUpdateBrandedItemDealArgs = {
  input: UpdateBrandedItemDealMutationInput;
};


export type MutationUpdateCartItemsArgs = {
  input: UpdateCartItemsInput;
};


export type MutationUpdateConfigArgs = {
  input: UpdateConfigInput;
};


export type MutationUpdateCurrentConsumerAppUserArgs = {
  input: UpdateCurrentConsumerAppUserInput;
};


export type MutationUpdateCurrentConsumerAppUserPhoneNumberArgs = {
  input: UpdateCurrentConsumerAppUserPhoneNumberInput;
};


export type MutationUpdateCustomIngredientArgs = {
  input: UpdateCustomIngredientMutationInput;
};


export type MutationUpdateCustomerTagArgs = {
  input: UpdateCustomerTagMutationInput;
};


export type MutationUpdateDeliveryIssueArgs = {
  input: DeliveryIssueUpdateInput;
};


export type MutationUpdateDepartedAtStopTimeArgs = {
  input: UpdateDepartedAtStopTimeInput;
};


export type MutationUpdateDriverSafetyAcknowledgementArgs = {
  input: DriverSafetyAcknowledgementUpdateInput;
};


export type MutationUpdateExternalBaseBrandedItemArgs = {
  input: UpdateExternalBaseBrandedItemMutationInput;
};


export type MutationUpdateGeneratedOrderQuantitiesArgs = {
  input: UpdateGeneratedOrderQuantitiesMutationInput;
};


export type MutationUpdateGuestUsernameArgs = {
  input: UpdateGuestUsernameMutationInput;
};


export type MutationUpdateHomepageDisplayRulesArgs = {
  input: UpdateHomepageDisplayRulesInput;
};


export type MutationUpdateInHouseBaseBrandedItemArgs = {
  input: UpdateInHouseBaseBrandedItemMutationInput;
};


export type MutationUpdateInProgressCustomerArgs = {
  input: UpdateInProgressCustomerMutationInput;
};


export type MutationUpdateInventoryItemArgs = {
  id: Scalars['ID']['input'];
  item: InventoryItemInput;
};


export type MutationUpdateItemBrandArgs = {
  input: ItemBrandUpdateInput;
};


export type MutationUpdateItemPalletConfigurationArgs = {
  casesPerLayer: Scalars['Int']['input'];
  itemId: Scalars['ID']['input'];
  layersPerPallet: Scalars['Int']['input'];
};


export type MutationUpdateItemPricesArgs = {
  input: UpdateItemPricesInput;
};


export type MutationUpdateItemTagArgs = {
  id: Scalars['ID']['input'];
  tag: ItemTagInput;
};


export type MutationUpdateLineLevelDeliveryIssueArgs = {
  input: LineLevelDeliveryIssueUpdateInput;
};


export type MutationUpdateLocationIncludeInAutomatedRoutingArgs = {
  input: LocationIncludeInAutomatedRoutingUpdateInput;
};


export type MutationUpdateLocationOpeningHoursArgs = {
  input: UpdateLocationOpeningHoursMutationInput;
};


export type MutationUpdateLocationOpeningHoursFromGoogleArgs = {
  input: UpdateLocationOpeningHoursFromGoogleInput;
};


export type MutationUpdateLocationPlatformProfileArgs = {
  input: UpdateLocationPlatformProfileMutationInput;
};


export type MutationUpdateLocationsCustomerPickupArgs = {
  input: LocationsCustomerPickupUpdateInput;
};


export type MutationUpdateLocationsDeliverWithinStoreHoursArgs = {
  input: UpdateLocationsDeliverWithinStoreHoursMutationInput;
};


export type MutationUpdateLocationsEnforceItemScanningArgs = {
  input: LocationsEnforceItemScanningUpdateInput;
};


export type MutationUpdateLocationsIncludeInAutomatedRoutingArgs = {
  input: LocationsIncludeInAutomatedRoutingUpdateInput;
};


export type MutationUpdateLocationsPrintDeliverySheetEnabledArgs = {
  input: LocationsPrintDeliverySheetEnabledUpdateInput;
};


export type MutationUpdateLocationsRoutingCohortArgs = {
  input: UpdateLocationsRoutingCohortMutationInput;
};


export type MutationUpdateLocationsServiceTimeArgs = {
  input: LocationsServiceTimeUpdateInput;
};


export type MutationUpdateLocationsThirdPartyExclusionArgs = {
  input: LocationsThirdPartyExclusionUpdateInput;
};


export type MutationUpdateMarketingQrCodeArgs = {
  input: UpdateMarketingQrCodeMutationInput;
};


export type MutationUpdateMarketingQrCodesFromCsvArgs = {
  input: UpdateMarketingQrCodesFromCsvMutationInput;
};


export type MutationUpdateMenuItemSavedVisibilityArgs = {
  input: UpdateMenuItemSavedVisibilityInput;
};


export type MutationUpdateMenuItemsSortOrderArgs = {
  input: UpdateMenuItemsSortOrderInput;
};


export type MutationUpdateMenuSavedVisibilityArgs = {
  input: UpdateMenuSavedVisibilityInput;
};


export type MutationUpdateMenusSortOrderArgs = {
  input: UpdateMenusSortOrderInput;
};


export type MutationUpdateMerchantCurbsidePickupArgs = {
  input: UpdateMerchantCurbsidePickupInput;
};


export type MutationUpdateMerchantNotificationSoundArgs = {
  input: UpdateMerchantNotificationSoundInput;
};


export type MutationUpdateMerchantPickupTextArgs = {
  input: UpdateMerchantPickupTextInput;
};


export type MutationUpdateMerchantStatusArgs = {
  input: UpdateMerchantStatusInput;
};


export type MutationUpdateMicrositeAdInfoArgs = {
  input: UpdateMicrositeAdInfoInput;
};


export type MutationUpdateMicrositeLocationArgs = {
  input: UpdateMicrositeMutationInput;
};


export type MutationUpdateMicrositeModulesOrderArgs = {
  input: UpdateMicrositeModulesOrderInput;
};


export type MutationUpdateModifierGroupSavedVisibilityArgs = {
  input: UpdateModifierGroupSavedVisibilityInput;
};


export type MutationUpdateModifierGroupsSortOrderArgs = {
  input: UpdateModifierGroupsSortOrderInput;
};


export type MutationUpdateModifierOptionSavedVisibilityArgs = {
  input: UpdateModifierOptionSavedVisibilityInput;
};


export type MutationUpdateModifierOptionsSortOrderArgs = {
  input: UpdateModifierOptionsSortOrderInput;
};


export type MutationUpdateNonInventoryItemArgs = {
  id: Scalars['ID']['input'];
  item: NonInventoryItemInput;
};


export type MutationUpdateOdekoItemInventoryArgs = {
  input: UpdateOdekoItemInventoryMutationInput;
};


export type MutationUpdateOrderDeliveryMethodArgs = {
  input: UpdateOrderDeliveryMethodMutationInput;
};


export type MutationUpdateOrderLineDeliveredQuantityArgs = {
  input: OrderLineDeliveredQuantityUpdateInput;
};


export type MutationUpdateOrderLineFulfillmentQuantityArgs = {
  input: OrderLineFulfillmentQuantityUpdateInput;
};


export type MutationUpdateOrderLineRecoveryQuantityArgs = {
  input: OrderLineRecoveryQuantityUpdateInput;
};


export type MutationUpdateOrderQuantityDeliveredArgs = {
  input: OrderQuantityDeliveredUpdateInput;
};


export type MutationUpdateOrderWarehouseNoteArgs = {
  input: OrderWarehouseNoteUpdateInput;
};


export type MutationUpdatePlatformMicrositeLocationArgs = {
  input: UpdatePlatformMicrositeLocationMutationInput;
};


export type MutationUpdateReceivableNoteArgs = {
  input: UpdateReceivableNoteInput;
};


export type MutationUpdateRouteDetailsArgs = {
  input: RouteDetailsUpdateInput;
};


export type MutationUpdateRouteOriginArgs = {
  input: RouteOriginUpdateInput;
};


export type MutationUpdateRouteStopDeliveryNoteArgs = {
  input: DeliveryRouteStopDeliveryNoteUpdateInput;
};


export type MutationUpdateRouteStopDriverReminderArgs = {
  input: DeliveryRouteStopReminderUpdateInput;
};


export type MutationUpdateRouteStopTaskArgs = {
  input: DeliveryRouteStopTaskUpdateInput;
};


export type MutationUpdateRouteStopUpsellNoteArgs = {
  input: DeliveryRouteStopUpsellNoteUpdateInput;
};


export type MutationUpdateRouteTruckArgs = {
  input: RouteTruckUpdateInput;
};


export type MutationUpdateRoutingImportPlanTruckCountArgs = {
  input: RoutingImportPlanTruckCountUpdateInput;
};


export type MutationUpdateSoApiRoutingImportPlanTruckCountArgs = {
  input: UpdateSoApiRoutingImportPlanTruckCountMutationInput;
};


export type MutationUpdateSquareOrderSuggestionArgs = {
  input: UpdateSquareOrderSuggestionMutationInput;
};


export type MutationUpdateSquareOrderSuggestionFromTranscriptArgs = {
  input: UpdateSquareOrderSuggestionFromTranscriptMutationInput;
};


export type MutationUpdateStartRouteTimeArgs = {
  input: StartRouteTimeUpdateInput;
};


export type MutationUpdateStopRouteTimeArgs = {
  input: StopRouteTimeUpdateInput;
};


export type MutationUpdateSubmenuSavedVisibilityArgs = {
  input: UpdateSubmenuSavedVisibilityInput;
};


export type MutationUpdateSubmenusSortOrderArgs = {
  input: UpdateSubmenusSortOrderInput;
};


export type MutationUpdateSubscriptionSessionArgs = {
  input: UpdateSubscriptionSessionMutationInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserMutationInput;
};


export type MutationUpdateUserNotificationPreferencesArgs = {
  input: UpdateUserNotificationPreferencesMutationInput;
};


export type MutationUpdateWarehouseArrivedAtRouteTimeArgs = {
  input: UpdateWarehouseArrivedAtRouteTimeInput;
};


export type MutationUpdateWarehouseDepartedAtRouteTimeArgs = {
  input: UpdateWarehouseDepartedAtRouteTimeInput;
};


export type MutationUpdateWarehousesLeadTimeArgs = {
  input: UpdateWarehousesLeadTimeMutationInput;
};


export type MutationUploadArtworkArgs = {
  input: UploadArtworkMutationInput;
};


export type MutationUploadArtworkForItemArgs = {
  input: UploadArtworkForItemMutationInput;
};


export type MutationUpsertAccountCreationSessionArgs = {
  input: UpsertAccountCreationSessionInput;
};


export type MutationUpsertAdminOrderItemMutationArgs = {
  input: UpsertAdminOrderItemMutationInput;
};


export type MutationUpsertArAssignmentArgs = {
  input: UpsertArAssignmentInput;
};


export type MutationUpsertBackInStockSubscriptionArgs = {
  input: UpsertBackInStockSubscriptionMutationInput;
};


export type MutationUpsertCategoryBannerArgs = {
  input: UpsertCategoryBannerInput;
};


export type MutationUpsertDeliveryDatePoNumbersArgs = {
  input: UpsertDeliveryDatePoNumbersMutationInput;
};


export type MutationUpsertExternalDeliveryMutationArgs = {
  input: UpsertExternalDeliveryMutationInput;
};


export type MutationUpsertExternalSupplierArgs = {
  input: UpsertExternalSupplierInput;
};


export type MutationUpsertLocationAccountsReceivableCollectionsStatusArgs = {
  input: UpsertLocationAccountsReceivableCollectionsStatusInput;
};


export type MutationUpsertLocationItemArgs = {
  input: LocationItemInput;
};


export type MutationUpsertLocationOrdersArgs = {
  input: UpsertLocationOrdersMutationInput;
};


export type MutationUpsertLocationPhoneNumberArgs = {
  input: UpsertLocationPhoneNumberMutationInput;
};


export type MutationUpsertMasterHomepageArgs = {
  input: UpsertMasterHomepageInput;
};


export type MutationUpsertMicrositeGuestbookMessageArgs = {
  input: UpsertMicrositeGuestbookMessageMutationInput;
};


export type MutationUpsertMicrositeMenuItemArgs = {
  input: UpsertMicrositeMenuItemInput;
};


export type MutationUpsertNewItemPinArgs = {
  input: UpsertNewItemPinInput;
};


export type MutationUpsertOrderMutationArgs = {
  input: UpsertOrderMutationInput;
};


export type MutationUpsertRecipeArgs = {
  input: UpsertRecipeMutationInput;
};


export type MutationUpsertShippingInstructionsArgs = {
  input: UpsertShippingInstructionsMutationInput;
};


export type MutationUpsertSubstitutionOverrideArgs = {
  input: UpsertSubstitutionOverrideInput;
};


export type MutationUpsertSurveyArgs = {
  input: UpsertSurveyMutationInput;
};


export type MutationUpsertWarehouseZipcodesArgs = {
  input: UpsertWarehouseZipcodesInput;
};


export type MutationUpsertZipcodeDeliveryRuleArgs = {
  input: UpsertZipcodeDeliveryRuleInput;
};


export type MutationUpsertZipcodeDeliveryWindowArgs = {
  input: UpsertZipcodeDeliveryWindowInput;
};


export type MutationValidateAndCompleteSubscriptionSessionArgs = {
  input: ValidateAndCompleteSubscriptionSessionMutationInput;
};


export type MutationValidateSubscriptionSessionCheckoutArgs = {
  input: ValidateSubscriptionSessionCheckoutMutationInput;
};


export type MutationVoteMicrositePollArgs = {
  input: VoteMicrositePollMutationInput;
};


export type MutationWarehouseAssociateBadgeRevokeArgs = {
  input: WarehouseAssociateBadgeRevokeInput;
};


export type MutationWarehouseLayoutSaveArgs = {
  input: WarehouseLayoutSaveInput;
};


export type MutationWarehouseShiftCreateArgs = {
  input: WarehouseShiftCreateInput;
};


export type MutationWarehouseShiftDeleteArgs = {
  input: WarehouseShiftDeleteInput;
};


export type MutationWarehouseShiftUpdateArgs = {
  input: WarehouseShiftUpdateInput;
};


export type MutationWarehouseUpdateClosedDaysArgs = {
  input: WarehouseUpdateClosedDaysInput;
};


export type MutationWarehouseUpdateDailyCapacityArgs = {
  input: WarehouseUpdateDailyCapacityInput;
};

export type NetsuiteCreditMemo = FinancialTransaction & {
  __typename?: 'NetsuiteCreditMemo';
  /** The amount of credit used, excluding pending transactions. */
  amountPaid: Money;
  /** The amount of credit available for use, excluding pending transactions. */
  amountRemaining: Money;
  /** Invoices to which current credit was applied. */
  applicableInvoices: Array<NetsuiteInvoice>;
  id: Scalars['ID']['output'];
  issuedDate: Scalars['ISO8601Date']['output'];
  netsuiteTransactionNumber: Scalars['String']['output'];
  pdf?: Maybe<Scalars['String']['output']>;
  platformRecordId: Scalars['ID']['output'];
  relatives: FinancialTransactionConnection;
  /** Total credits issued */
  total: Money;
  transactionDate: Scalars['ISO8601Date']['output'];
};

/** The connection type for NetsuiteCreditMemo. */
export type NetsuiteCreditMemoConnection = {
  __typename?: 'NetsuiteCreditMemoConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NetsuiteCreditMemoEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<NetsuiteCreditMemo>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type NetsuiteCreditMemoEdge = {
  __typename?: 'NetsuiteCreditMemoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** Additional info about the meaning of this edge. */
  info: FinancialTransactionEdgeInfo;
  /** The item at the end of the edge. */
  node?: Maybe<NetsuiteCreditMemo>;
};

export type NetsuiteCustomerPayment = FinancialTransaction & {
  __typename?: 'NetsuiteCustomerPayment';
  id: Scalars['ID']['output'];
  platformRecordId: Scalars['ID']['output'];
  relatives: FinancialTransactionConnection;
  transactionDate: Scalars['ISO8601Date']['output'];
};

export type NetsuiteCustomerRefund = FinancialTransaction & {
  __typename?: 'NetsuiteCustomerRefund';
  id: Scalars['ID']['output'];
  platformRecordId: Scalars['ID']['output'];
  relatives: FinancialTransactionConnection;
  transactionDate: Scalars['ISO8601Date']['output'];
};

export type NetsuiteInvoice = FinancialTransaction & {
  __typename?: 'NetsuiteInvoice';
  /** The sum of all completed payments and credit applications put towards this invoice. */
  completedAmountPaid: Money;
  /** True if a credit has been successfully applied to this invoice. */
  creditApplied: Scalars['Boolean']['output'];
  discountTotal: Money;
  dueDate: Scalars['ISO8601Date']['output'];
  fulfillmentDate: Scalars['ISO8601Date']['output'];
  id: Scalars['ID']['output'];
  netsuiteSalesOrderReference?: Maybe<NetsuiteSalesOrderReference>;
  netsuiteTransactionNumber: Scalars['String']['output'];
  order?: Maybe<Order>;
  /**
   * Payment terms, in days, for this invoice: the terms copied onto its Odeko
   * supply order when the order was placed. Null when no terms were copied,
   * including invoices from platforms other than Odeko.
   */
  paymentTermsDays?: Maybe<Scalars['Int']['output']>;
  pdf?: Maybe<Scalars['String']['output']>;
  platformRecordId: Scalars['ID']['output'];
  relatives: FinancialTransactionConnection;
  shippingCost: Money;
  subtotal: Money;
  tax: Money;
  total: Money;
  /** The sum of all payments and credit applications put towards this invoice, including those that are still pending. */
  totalAmountPaid: Money;
  totalAmountRemaining: Money;
  /** The sum of all credits successfully applied to this invoice. */
  totalCreditsApplied: Money;
  totalCreditsIssued: Money;
  transactionDate: Scalars['ISO8601Date']['output'];
  vendorName?: Maybe<Scalars['String']['output']>;
};

/** The connection type for NetsuiteInvoice. */
export type NetsuiteInvoiceConnection = {
  __typename?: 'NetsuiteInvoiceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NetsuiteInvoiceEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<NetsuiteInvoice>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type NetsuiteInvoiceEdge = {
  __typename?: 'NetsuiteInvoiceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** Additional info about the meaning of this edge. */
  info: FinancialTransactionEdgeInfo;
  /** The item at the end of the edge. */
  node?: Maybe<NetsuiteInvoice>;
};

export type NetsuiteJournalEntryLine = FinancialTransaction & {
  __typename?: 'NetsuiteJournalEntryLine';
  id: Scalars['ID']['output'];
  platformRecordId: Scalars['ID']['output'];
  relatives: FinancialTransactionConnection;
  transactionDate: Scalars['ISO8601Date']['output'];
};

export type NetsuiteSalesOrderReference = {
  __typename?: 'NetsuiteSalesOrderReference';
  externalOrder?: Maybe<OrderReference>;
  netsuiteInternalId: Scalars['ID']['output'];
  transactionNumber: Scalars['String']['output'];
};

export type NetsuiteTransaction = {
  __typename?: 'NetsuiteTransaction';
  createdAt: Scalars['ISO8601Date']['output'];
  date: Scalars['ISO8601Date']['output'];
  id: Scalars['ID']['output'];
  location: Location;
  order?: Maybe<Order>;
  pdfS3Key?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  totalPriceCents: Scalars['String']['output'];
  transactionType: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601Date']['output'];
  vendor?: Maybe<Vendor>;
};

export type NetsuiteVendor = {
  __typename?: 'NetsuiteVendor';
  /** Customer-facing name; may differ from the legal name and is also matched by search. */
  displayName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  netsuiteInternalId: Scalars['String']['output'];
};

/** One market's New Items pin state for an item being considered for cross-market pinning. */
export type NewItemMarketEligibility = {
  __typename?: 'NewItemMarketEligibility';
  /** The slot this item currently occupies in this market's New Items queue, or null if it isn't pinned here. Compared to the target position, this shows whether a cross-market pin would add it (null), move it (a different slot), or leave it in place (the same slot). */
  currentPosition?: Maybe<Scalars['Int']['output']>;
  /** The current queue leader at the target position in this market, if any — what a cross-market pin would demote to a fallback candidate. Null if the position is unoccupied there, or this item already leads it. */
  existingPin?: Maybe<NewItemPin>;
  warehouse: Warehouse;
};

/**
 * A merchandising pin elevating an item to an absolute slot in a market's New Items carousel. Backed by
 * the surface-agnostic `merchandisepin` store (surface = NEW_ITEMS).
 */
export type NewItemPin = {
  __typename?: 'NewItemPin';
  /** Days the item has left as new; null once it has aged out of the 60-day window. */
  daysRemainingAsNew?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** True when the item is still new (within the 60-day window) AND in stock — i.e. currently surfacing. */
  isActive: Scalars['Boolean']['output'];
  item: SupplyItem;
  /** Absolute carousel slot (ascending). */
  position: Scalars['Int']['output'];
  /** True when this pin is a sponsored (paid) placement; false for internal merchandising/seasonal pins. */
  sponsored: Scalars['Boolean']['output'];
  /** Succession order within a position (auto-sequenced); the first eligible member leads the slot. */
  subrank: Scalars['Int']['output'];
};

export type NewItemPinError = {
  __typename?: 'NewItemPinError';
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type NewItemPinPayload = {
  __typename?: 'NewItemPinPayload';
  errors: Array<NewItemPinError>;
  newItemPin?: Maybe<NewItemPin>;
};

export type NewItemPinsPayload = {
  __typename?: 'NewItemPinsPayload';
  errors: Array<NewItemPinError>;
  newItemPins: Array<NewItemPin>;
};

/**
 * Filters accepted by Location.newItems (and, later, User.newItems). A deliberately
 * curated, intent-based input — not a raw subset of ItemsFiltersInput. Two facts that
 * *define* the New Items set are forced by the resolver and so are absent here: `isNew`
 * (the 60-day activation window) and `catalogStatus` (always in-catalog). Callers express
 * shipping eligibility as a single `isShipping` flag rather than hand-building the
 * underlying weight/refrigeration filters; the resolver expands it.
 */
export type NewItemsFiltersInput = {
  /** When true, excludes items out of stock for 14+ days at a fulfillment warehouse. */
  customerFacingOutOfStock?: InputMaybe<Scalars['Boolean']['input']>;
  /** Non-global-fulfillment locations scope to their assigned fulfillment warehouse. */
  fulfillmentWarehouseIds?: InputMaybe<FiltersArrayInput>;
  /**
   * When true, restricts to items shippable to a shipping customer, as
   * ItemsFiltersInput.isShipping does.
   */
  isShipping?: InputMaybe<Scalars['Boolean']['input']>;
  /** Punchout catalogs restrict to inventory items. */
  type?: InputMaybe<FiltersItemTypeInput>;
  /** The market the New Items are scoped to. */
  warehouseId?: InputMaybe<FiltersStringInput>;
};

/** A specific delivery date available for a vendor at a location */
export type NextAvailableDeliveryDate = {
  __typename?: 'NextAvailableDeliveryDate';
  /** The delivery date */
  date: Scalars['ISO8601Date']['output'];
  /** The exact datetime orders must be placed by */
  orderByDate: Scalars['ISO8601DateTime']['output'];
  /** Order deadline time (e.g., '10:00') */
  orderDeadline: Scalars['String']['output'];
  /** The vendor for this delivery date */
  vendor: Vendor;
};

/** An object with an ID. */
export type Node = {
  /** ID of the object. */
  id: Scalars['ID']['output'];
};

export type NonCustomerPickupStops = UserErrorInterface & {
  __typename?: 'NonCustomerPickupStops';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
  stopIds: Array<Scalars['ID']['output']>;
};

/** Extension of NonInventoryItem type to include associated ERP Reference fields */
export type NonInventoryItem = SupplyItem & {
  __typename?: 'NonInventoryItem';
  brand?: Maybe<ItemBrand>;
  /** @deprecated Use brand */
  brandName: Scalars['String']['output'];
  /** (Package Height x Package Width x Package Length)/DIM factor */
  caseDimensionalWeightLbs?: Maybe<Scalars['Float']['output']>;
  caseHeightInches?: Maybe<Scalars['Float']['output']>;
  caseLengthInches?: Maybe<Scalars['Float']['output']>;
  caseVolumeCuInches?: Maybe<Scalars['Float']['output']>;
  caseWeightLbs?: Maybe<Scalars['Float']['output']>;
  caseWidthInches?: Maybe<Scalars['Float']['output']>;
  casesPerLayer?: Maybe<Scalars['Int']['output']>;
  casesPerPallet?: Maybe<Scalars['Int']['output']>;
  catalogStatus: CatalogStatus;
  category: Category;
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Drives pricing with carriers like FedEx.
   * This data is uploaded from Cubiscan dimensioning device to optimize shipping costs.
   */
  dimensionalFactor?: Maybe<Scalars['Float']['output']>;
  dimensioned?: Maybe<Scalars['Boolean']['output']>;
  discontinuedOn?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** (Package Height x Package Width x Package Length)/DIM factor */
  eachDimensionalWeightLbs?: Maybe<Scalars['Float']['output']>;
  eachHeightInches?: Maybe<Scalars['Float']['output']>;
  eachLengthInches?: Maybe<Scalars['Float']['output']>;
  eachVolumeCuInches?: Maybe<Scalars['Float']['output']>;
  eachWeightLbs?: Maybe<Scalars['Float']['output']>;
  eachWidthInches?: Maybe<Scalars['Float']['output']>;
  erpPlatform?: Maybe<ErpPlatform>;
  erpRecordId?: Maybe<Scalars['ID']['output']>;
  erpRecordType?: Maybe<ErpRecord>;
  erpRecordUrl?: Maybe<Scalars['String']['output']>;
  /** Denotes if the item should be included in the picking labels or not. */
  excludedFromPickingLabels: Scalars['Boolean']['output'];
  /** True if the item has its own image. When false and imgUrl is present, the image is a fallback from the category icon. */
  hasOwnImage: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  imgUrl?: Maybe<Scalars['String']['output']>;
  inactivatedOn?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * True when a shipping location can't order this item: it is refrigerated or frozen, or its
   * category or subcategory is Pastry or Baked Goods.
   */
  isShippingRestricted: Scalars['Boolean']['output'];
  itemLocationsCustomPrice?: Maybe<Array<ItemLocationCustomPrice>>;
  /** @deprecated Use size */
  itemSize?: Maybe<Scalars['String']['output']>;
  layersPerPallet?: Maybe<Scalars['Int']['output']>;
  /** Whether this item uses market pricing (price set at fulfillment time) */
  marketPrice: Scalars['Boolean']['output'];
  /** The markup percentage applied to vendor cost to compute selling price for market-priced items */
  markupPercentage?: Maybe<Scalars['Float']['output']>;
  /**
   * The most units, in the sale unit, that one location may order of this item across all its orders.
   * Null means no limit.
   */
  maxQuantityPerLocation?: Maybe<Scalars['Int']['output']>;
  minItemsPerOrder?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  nmfc?: Maybe<Scalars['String']['output']>;
  palletWeightLbs?: Maybe<Scalars['Float']['output']>;
  /**
   * True when this item is currently a leading New Items pin — i.e. it won its slot in the resolved
   * result set. Reflects what shoppers see: an item filtered out of the result reads as not pinned.
   * Flag-gated; false when the new-item-pinning flag is off or the item isn't pinned.
   */
  pinned: Scalars['Boolean']['output'];
  /** The absolute carousel slot this item actually rendered at when pinned; null when not pinned. */
  pinnedPosition?: Maybe<Scalars['Int']['output']>;
  /**
   * Drives the storefront's "Sponsored" label. True for Algolia rule-promoted results and — behind the
   * new-item-pinning flag — for a sponsored New Items pin. A sponsored pin is distinguishable from an
   * Algolia promo by `pinned` (a sponsored pin is `promoted && pinned`).
   */
  promoted: Scalars['Boolean']['output'];
  purchaseMultiple: Scalars['Int']['output'];
  purchasePrice: Money;
  refrigerationState?: Maybe<RefrigerationState>;
  saleUnit: Unit;
  /** The most of this item's sample one location may ever order. Null means no limit, or no sample. */
  sampleMaxQuantityPerLocation?: Maybe<Scalars['Int']['output']>;
  sampleUnit?: Maybe<Unit>;
  size?: Maybe<ItemSize>;
  /**
   * The product-level standing-order setting. Read `standingOrderBehavior` on the warehouse
   * association instead, at all times: this value is not market-scoped, so once any market is
   * given a setting of its own it stops answering for that market.
   */
  standingOrderBehavior: StandingOrderBehavior;
  subcategory?: Maybe<Category>;
  /**
   * The item's curated substitution overrides (source-side), highest priority first. Procurement's
   * editable layer that ranks above the rule engine's dynamic recommendations.
   */
  substitutionOverrides: Array<SubstitutionOverride>;
  /**
   * Procurement preview of ranked substitutes for this item. With no `warehouseId`, ranks by
   * attribute/dietary match quality only (availability ignored) — the "are these good substitutes?"
   * view. With a `warehouseId`, returns the in-stock list a customer in that market would actually get.
   * Curated overrides rank first. Procurement surface — the customer path uses `InventoryWarehouseAssociation.substitutionCandidates`.
   */
  substitutionPreview: Array<SupplyItem>;
  tags: Array<ItemTag>;
  transitMethod?: Maybe<TransitMethod>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  vendorCode?: Maybe<Scalars['String']['output']>;
  warehouseAssociation?: Maybe<Array<Maybe<NonInventoryWarehouseAssociation>>>;
};


/** Extension of NonInventoryItem type to include associated ERP Reference fields */
export type NonInventoryItemSubstitutionPreviewArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};


/** Extension of NonInventoryItem type to include associated ERP Reference fields */
export type NonInventoryItemTagsArgs = {
  withDiscardedAt?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Extension of NonInventoryItem type to include associated ERP Reference fields */
export type NonInventoryItemWarehouseAssociationArgs = {
  filters?: InputMaybe<NonInventoryWarehouseAssociationFiltersInput>;
  warehouseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type NonInventoryItemInput = {
  brand?: InputMaybe<Scalars['ID']['input']>;
  brandName: Scalars['String']['input'];
  caseHeightInches?: InputMaybe<Scalars['Float']['input']>;
  caseLengthInches?: InputMaybe<Scalars['Float']['input']>;
  caseWeightLbs?: InputMaybe<Scalars['Float']['input']>;
  caseWidthInches?: InputMaybe<Scalars['Float']['input']>;
  casesPerLayer?: InputMaybe<Scalars['Int']['input']>;
  catalogStatus: CatalogStatus;
  category: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  dimensionalFactor?: InputMaybe<Scalars['Float']['input']>;
  dimensioned?: InputMaybe<Scalars['Boolean']['input']>;
  eachHeightInches?: InputMaybe<Scalars['Float']['input']>;
  eachLengthInches?: InputMaybe<Scalars['Float']['input']>;
  eachWeightLbs?: InputMaybe<Scalars['Float']['input']>;
  eachWidthInches?: InputMaybe<Scalars['Float']['input']>;
  imgUrl?: InputMaybe<Scalars['String']['input']>;
  itemSize?: InputMaybe<Scalars['String']['input']>;
  layersPerPallet?: InputMaybe<Scalars['Int']['input']>;
  marketPrice?: InputMaybe<Scalars['Boolean']['input']>;
  markupPercentage?: InputMaybe<Scalars['Float']['input']>;
  /**
   * The most units, in the sale unit, that one location may order of this item across all its orders.
   * Omit to keep the current value; null removes the limit. At least 1.
   */
  maxQuantityPerLocation?: InputMaybe<Scalars['Int']['input']>;
  minItemsPerOrder?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  nmfc?: InputMaybe<Scalars['String']['input']>;
  palletWeightLbs?: InputMaybe<Scalars['Float']['input']>;
  purchaseMultiple: Scalars['Int']['input'];
  purchasePrice: MoneyInput;
  refrigerationState?: InputMaybe<RefrigerationState>;
  saleUnit: Scalars['ID']['input'];
  /**
   * The most of this item's sample one location may ever order. Omit to keep the current value; null
   * removes the limit. At least 1, and only with a sampleUnit.
   */
  sampleMaxQuantityPerLocation?: InputMaybe<Scalars['Int']['input']>;
  sampleUnit?: InputMaybe<Scalars['ID']['input']>;
  size?: InputMaybe<SizeInput>;
  standingOrderBehavior: StandingOrderBehavior;
  subcategory?: InputMaybe<Scalars['ID']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  transitMethod?: InputMaybe<TransitMethod>;
  vendorCode?: InputMaybe<Scalars['String']['input']>;
  warehouseAssociation?: InputMaybe<Array<InputMaybe<NonInventoryWarehouseAssociationInput>>>;
};

export type NonInventoryVendor = {
  __typename?: 'NonInventoryVendor';
  /** The vendor's current active override code, or null if none is active. */
  activeOverrideCode?: Maybe<DockOverrideCode>;
  /** Customer-facing name; may differ from the legal name and is also matched by search. */
  displayName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  netsuiteInternalId: Scalars['String']['output'];
};

/**
 * NonInventory items are picked up from vendors while out on delivery.
 * A driver is *dispatched* from a warehouse to pick up and deliver the item.
 */
export type NonInventoryWarehouseAssociation = {
  __typename?: 'NonInventoryWarehouseAssociation';
  configuredFulfillmentWarehouses: Array<ConfigureFulfillmentWarehouse>;
  /**
   * Wording authored for this product in this market, or null when nothing was authored and the
   * message is derived from `orderability`. Exposed so an editor can show and change what was written;
   * clients rendering a catalog want `orderabilityMessage` instead.
   */
  customOrderabilityMessage?: Maybe<Scalars['String']['output']>;
  /** True when the item has been continuously out of stock for 14+ days at this warehouse. */
  customerFacingOutOfStock: Scalars['Boolean']['output'];
  /**
   * Days the item has left in the 60-day "new" window at this warehouse; null once it has aged out.
   * Mirrors `isNew` (both derive from the item's activation date).
   */
  daysRemainingAsNew?: Maybe<Scalars['Int']['output']>;
  fulfillmentWarehouses: Array<FulfillmentWarehouse>;
  hasSample?: Maybe<Scalars['Boolean']['output']>;
  isNew: Scalars['Boolean']['output'];
  item: NonInventoryItem;
  landedCost?: Maybe<Money>;
  /**
   * Next available delivery date for this item from the location's own (home)
   * warehouse. Returns null when the association is for any other warehouse — e.g.
   * an item fulfilled from a different warehouse under global fulfillment — or
   * when the location is disabled.
   */
  nextDeliveryDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /**
   * Whether this product is ready to sell in this market. A product that is not orderable still appears
   * in the catalog — it simply cannot be added to an order.
   */
  orderability: Orderability;
  /**
   * Wording to show in place of add-to-cart, or null when the product can be ordered. Taken from
   * `customOrderabilityMessage` when one is authored, and otherwise derived from `orderability`, so
   * both ordering apps say the same thing and changing it needs no client release.
   */
  orderabilityMessage?: Maybe<Scalars['String']['output']>;
  /**
   * When the item first went out of stock at this warehouse.
   * Null if currently in stock or if OOS check is bypassed.
   */
  outOfStockSince?: Maybe<Scalars['ISO8601DateTime']['output']>;
  salePrice?: Maybe<Money>;
  sample?: Maybe<SupplyItem>;
  /**
   * Whether this product can be ordered on a standing order in this market. A market that has not been
   * given a value of its own carries the item-level field of the same name.
   */
  standingOrderBehavior: StandingOrderBehavior;
  vendor?: Maybe<Vendor>;
  warehouse: Warehouse;
};


/**
 * NonInventory items are picked up from vendors while out on delivery.
 * A driver is *dispatched* from a warehouse to pick up and deliver the item.
 */
export type NonInventoryWarehouseAssociationFulfillmentWarehousesArgs = {
  locationUuid?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * NonInventory items are picked up from vendors while out on delivery.
 * A driver is *dispatched* from a warehouse to pick up and deliver the item.
 */
export type NonInventoryWarehouseAssociationNextDeliveryDateArgs = {
  locationId: Scalars['ID']['input'];
};


/**
 * NonInventory items are picked up from vendors while out on delivery.
 * A driver is *dispatched* from a warehouse to pick up and deliver the item.
 */
export type NonInventoryWarehouseAssociationSalePriceArgs = {
  locationMembershipStatusTier?: InputMaybe<PsLocationMembershipStatusTier>;
  locationMembershipTier?: InputMaybe<LocationMembershipTier>;
};

export type NonInventoryWarehouseAssociationFiltersInput = {
  vendorId?: InputMaybe<FiltersStringInput>;
  warehouseId?: InputMaybe<FiltersStringInput>;
};

export type NonInventoryWarehouseAssociationInput = {
  configuredFulfillmentWarehouses?: InputMaybe<Array<ConfigureFulfillmentWarehouseInput>>;
  /** Wording to show instead of what `orderability` implies. Omit to leave unchanged; null to clear. */
  customOrderabilityMessage?: InputMaybe<Scalars['String']['input']>;
  hasSample?: InputMaybe<Scalars['Boolean']['input']>;
  /** Defaults to ORDERABLE when omitted; omit to leave an existing value unchanged. */
  orderability?: InputMaybe<Orderability>;
  salePrice?: InputMaybe<MoneyInput>;
  /** Omit to leave unchanged. A market the product was not in before starts off, except on a product being created, where it takes the item-level field of the same name. */
  standingOrderBehavior?: InputMaybe<StandingOrderBehavior>;
  vendorId: Scalars['ID']['input'];
  warehouseId: Scalars['ID']['input'];
};

/** A selected stop that cannot be moved into the customer-pickup bucket, and why. */
export type NonMovableStop = {
  __typename?: 'NonMovableStop';
  reason: Scalars['String']['output'];
  stopId: Scalars['ID']['output'];
};

export type NonMovableStops = UserErrorInterface & {
  __typename?: 'NonMovableStops';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  offenders: Array<NonMovableStop>;
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** Error indicating that a mutation failed because the requested pickup time did not satisfy merchant's minimum notice. */
export type NotEnoughNotice = Error & {
  __typename?: 'NotEnoughNotice';
  /** A description of the error. */
  message: Scalars['String']['output'];
  /** Minimum notice an order can be placed in advance of its pickup time. */
  minimumNotice: RelativeTime;
};

/** Error indicating a partial refund was attempted without specifying any items or modifiers to refund. */
export type NothingToRefund = Error & {
  __typename?: 'NothingToRefund';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/**
 * Error indicating that a mutation failed because its inputs included an object
 * from a collection other than the expected collection.
 */
export type ObjectFromOutsideCollection = Error & {
  __typename?: 'ObjectFromOutsideCollection';
  /** ID of the object. */
  id: Scalars['ID']['output'];
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Error indicating that an object could not be found with the ID provided by an input argument. */
export type ObjectNotFound = Error & {
  __typename?: 'ObjectNotFound';
  /** ID that caused the error. */
  id: Scalars['ID']['output'];
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Error indicating that mutation failed to save an object. */
export type ObjectNotSaved = Error & {
  __typename?: 'ObjectNotSaved';
  /** ID of the object that failed to save. */
  id?: Maybe<Scalars['ID']['output']>;
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/**
 * Error indicating that a mutation whose input requires a complete collection
 * failed because an object was omitted from the collection.
 */
export type ObjectOmittedFromCollection = Error & {
  __typename?: 'ObjectOmittedFromCollection';
  /** ID of the omitted object. */
  id: Scalars['ID']['output'];
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** PROTOTYPE Inventory Info for Odeko Items for a Location. */
export type OdekoItemInventoryInput = {
  /**
   * PROTOTYPE the id of the base unit of Odeko item's sale unit. This must be
   * included even if location_counting_unit_id is present.
   */
  baseUnitId: Scalars['ID']['input'];
  /**
   * PROTOTYPE The number of base units contained in the Odeko item's sale unit.
   * This must be included even if location_counting_unit_id is present.
   */
  conversionRate: Scalars['Float']['input'];
  /**
   * PROTOTYPE When provided, the location will count using this custom counting
   * unit. When empty, the location will count using the Odeko sales unit.
   */
  locationCountingUnitId?: InputMaybe<Scalars['ID']['input']>;
  /** PROTOTYPE Where in the Cafe the location is stored */
  locationStorageAreaId?: InputMaybe<Scalars['ID']['input']>;
  /** PROTOTYPE the par value to set for this iten in this Cafe location. */
  parValue: Scalars['Float']['input'];
  /** PROTOTYPE the id of the Odeko item's sale unit. This must be included even if location_counting_unit_id is present. */
  salesUnitId: Scalars['ID']['input'];
  skuId: Scalars['ID']['input'];
};

export type OdekoPaymentIntent = FinancialTransaction & {
  __typename?: 'OdekoPaymentIntent';
  id: Scalars['ID']['output'];
  platformRecordId: Scalars['ID']['output'];
  relatives: FinancialTransactionConnection;
  transactionDate: Scalars['ISO8601Date']['output'];
};

export type OpeningHour = {
  __typename?: 'OpeningHour';
  /** Opening time in HH:MM:SS format and in the timezone of the location */
  closeTime: Scalars['String']['output'];
  /** Day of the week in text format i.e Sunday, Monday, etc. */
  dayName: Scalars['String']['output'];
  /** Day of the week (0-6), where 0 is Sunday and 6 is Saturday */
  dayOfWeek: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** Opening time in HH:MM:SS format and in the timezone of the location */
  openTime: Scalars['String']['output'];
};

export type OpeningHoursDayInput = {
  /** Closing time in HH:MM:SS format expressed in the timezone of the location */
  closeTime: Scalars['String']['input'];
  /** Day of the week (0-6), where 0 is Sunday and 6 is Saturday */
  dayOfWeek: Scalars['Int']['input'];
  /** Opening time in HH:MM:SS format expressed in the timezone of the location */
  openTime: Scalars['String']['input'];
};

export type OperatingHoursBound = {
  __typename?: 'OperatingHoursBound';
  /** Day of week. */
  dayOfWeek: DayOfWeekEnum;
  /** Time of day in HH:MM:SS format. */
  timeOfDay: Scalars['String']['output'];
};

/** Input for an operating hours bound. */
export type OperatingHoursBoundInput = {
  /** Day of week. */
  dayOfWeek: DayOfWeekEnum;
  /** Time of day in HH:MM:SS format. */
  timeOfDay: Scalars['String']['input'];
};

export type OperatingHoursForDayOfWeek = {
  __typename?: 'OperatingHoursForDayOfWeek';
  /** Operating hours intervals. May spill over into a subsequent day. */
  intervals: Array<OperatingHoursInterval>;
  /** Operating day of week. */
  operatingDay: DayOfWeekEnum;
};

export type OperatingHoursInterval = {
  __typename?: 'OperatingHoursInterval';
  /** Lower bound. */
  lowerBound: OperatingHoursBound;
  /** Upper bound. */
  upperBound: OperatingHoursBound;
};

/** Input for an operating hours interval. */
export type OperatingHoursIntervalInput = {
  /** Lower bound. */
  lowerBound: OperatingHoursBoundInput;
  /** Upper bound. */
  upperBound: OperatingHoursBoundInput;
};

/** Extension of a Supply Order to include associated ERP Reference fields */
export type Order = {
  __typename?: 'Order';
  /** Fees applied to an order. */
  appliedFees: Array<OrderFee>;
  autoGenerated: Scalars['Boolean']['output'];
  /** The automatic discount codes applied to the order. */
  automaticDiscountCodes?: Maybe<Array<Scalars['String']['output']>>;
  canCancel: Scalars['Boolean']['output'];
  canReportIssue: Scalars['Boolean']['output'];
  collectedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The coupon codes applied to the order. */
  couponCodes?: Maybe<Array<Scalars['String']['output']>>;
  deliveredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  deliveryDate: Scalars['ISO8601Date']['output'];
  deliveryMethod: OrderDeliveryMethodEnum;
  deliveryStatus: OrderDeliveryStatus;
  dueAt: Scalars['ISO8601DateTime']['output'];
  erpPlatform?: Maybe<ErpPlatform>;
  erpRecordId?: Maybe<Scalars['ID']['output']>;
  erpRecordType?: Maybe<ErpRecord>;
  erpRecordUrl?: Maybe<Scalars['String']['output']>;
  erpTransactionId?: Maybe<Scalars['String']['output']>;
  estimatedShippingDeliveryDateRange?: Maybe<ShippingEstimateDeliveryRange>;
  /** Provides external delivery information when an order is actively being delivered by a third party. */
  externalDelivery?: Maybe<ExternalDelivery>;
  /**
   * True while the order is held for delivery review (a delivered vs fulfilled
   * line delta). Set when a delta appears and cleared at route completion or
   * review confirmation once no delta remains — keeps the order in the DMP review
   * queue until then.
   */
  flaggedForReview: Scalars['Boolean']['output'];
  fulfillmentStatus: Scalars['String']['output'];
  hasStandingOrderForDay: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  invoice?: Maybe<FinancialTransaction>;
  isCancelled: Scalars['Boolean']['output'];
  issues?: Maybe<Array<Issue>>;
  itemLevelTracking: Scalars['Boolean']['output'];
  location: Location;
  orderDate: Scalars['ISO8601Date']['output'];
  orderEvents: Array<OrderEvent>;
  orderLines: Array<OrderLine>;
  orderNumber: Scalars['ID']['output'];
  partiallyDelivered: Scalars['Boolean']['output'];
  poNumber?: Maybe<Scalars['String']['output']>;
  /** Server-derived recovery state for DMP queue rendering. See OrderRecoveryStatus for value semantics. */
  recoveryStatus: OrderRecoveryStatus;
  /**
   * True once a redelivery has been completed for the order. The DMP uses it to
   * re-open a completed-but-short redelivery as a plain, reviewable order (no
   * missed-deadline state).
   */
  redeliveryAttempted: Scalars['Boolean']['output'];
  /**
   * Server-derived review-by deadline: when the order auto-confirms if no GM
   * reviews it, in the warehouse's local time. Anchored on route completion. Null
   * when no deadline applies. DMP renders only.
   */
  reviewBy?: Maybe<Scalars['ISO8601DateTime']['output']>;
  reviewConfirmedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Server-derived review state for DMP queue rendering. See OrderReviewStatus for value semantics. */
  reviewStatus: OrderReviewStatus;
  /**
   * The completion instant of the order's delivery route, mirroring the anchor
   * review_by is built on. Route-grain: every order sharing a completed bucket
   * carries the same instant, not a per-order delivery time. Null unless
   * routeCompletionState is complete.
   */
  routeCompletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * Server-derived delivery-route completion state. See OrderRouteCompletionState
   * for value semantics, including why it is route-grain and not monotonic.
   */
  routeCompletionState: OrderRouteCompletionState;
  /**
   * Name of the route the order is on for its warehouse + delivery date (the Lobby
   * bucket until it's routed; nil when it has no stop).
   */
  routeName?: Maybe<Scalars['String']['output']>;
  scheduledDeliveryTime?: Maybe<ScheduledDeliveryTime>;
  /** Cost of shipping only; does not include the cost of items. */
  shippingCostCents: Scalars['Int']['output'];
  /** The order's 1-indexed stop position on that route (sequence_number + 1; nil when it has no stop). */
  stopNumber?: Maybe<Scalars['Int']['output']>;
  stops?: Maybe<Array<DeliveryStop>>;
  /** Current cost of goods sold for active order lines, expressed in cents and potentially fractional after unit conversion. */
  totalCogsCents: Scalars['Float']['output'];
  /** Sum of total_cost_cents across all active order lines. */
  totalCostCents: Scalars['Int']['output'];
  /** Sum of applied fee amounts. */
  totalFeesCents: Scalars['Int']['output'];
  totalItemQuantity: Scalars['Int']['output'];
  /** Sum of billed weight for market-priced lines and ordered weight for other active lines. */
  totalWeightLb: Scalars['Float']['output'];
  /** @deprecated Use external delivery field instead. */
  trackingUrl?: Maybe<Scalars['String']['output']>;
  vendor: Vendor;
  warehouseNote?: Maybe<Scalars['String']['output']>;
};

export enum OrderActorTypeEnum {
  /** Action taken by an automated process or background job */
  System = 'system',
  /** Action taken by a human user */
  User = 'user'
}

export type OrderAllocationInput = {
  collected: Scalars['Boolean']['input'];
  orderId: Scalars['ID']['input'];
  orderLines?: InputMaybe<Array<OrderLineAllocationInput>>;
};

/** Accepted orderBy values */
export enum OrderByEnum {
  /** Ascending, nulls last */
  Asc = 'asc',
  /** Descending, nulls first */
  Desc = 'desc'
}

export enum OrderChannelEnum {
  /** Order created or updated via Android mobile app */
  MobileAndroid = 'MOBILE_ANDROID',
  /** Order created or updated via iOS mobile app */
  MobileIos = 'MOBILE_IOS',
  /** Order created via web admin tools */
  WebAdminTools = 'WEB_ADMIN_TOOLS',
  /** Order created or updated via web portal */
  WebPortal = 'WEB_PORTAL',
  /** Order created via internal management interface */
  WebSoApi = 'WEB_SO_API',
  /** Order auto-generated from standing order */
  WebStandingOrders = 'WEB_STANDING_ORDERS'
}

/** Autogenerated input type of OrderCollectedUpdate */
export type OrderCollectedUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Denotes if the order was collected */
  collected: Scalars['Boolean']['input'];
  /** Order id. */
  orderId: Scalars['ID']['input'];
  /** Order lines containing the fulfillment quantity */
  orderLines?: InputMaybe<Array<OrderLinesFulfillmentInput>>;
};

/** Autogenerated return type of OrderCollectedUpdate. */
export type OrderCollectedUpdatePayload = {
  __typename?: 'OrderCollectedUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  orderLines?: Maybe<Array<OrderLine>>;
  userErrors: Array<OrderError>;
};

/** Autogenerated input type of OrderDeliveredUpdate */
export type OrderDeliveredUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Denotes if the order was delivered */
  delivered: Scalars['Boolean']['input'];
  /** Order id. */
  orderId: Scalars['ID']['input'];
  redelivery?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of OrderDeliveredUpdate. */
export type OrderDeliveredUpdatePayload = {
  __typename?: 'OrderDeliveredUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userErrors: Array<OrderError>;
};

export enum OrderDeliveryMethodEnum {
  /** Delivered via Burq (for external deliveries) */
  BurqDelivery = 'burq_delivery',
  /** Local delivery */
  Delivery = 'delivery',
  /** Delivered via DoorDash (for external deliveries) */
  DoordashDelivery = 'doordash_delivery',
  /** Delivered via Metrobi (for external deliveries) */
  MetrobiDelivery = 'metrobi_delivery',
  /** Shipped via pallet (for heavier orders) */
  PalletShipping = 'pallet_shipping',
  /** Shipped via parcel (for lighter orders) */
  ParcelShipping = 'parcel_shipping',
  /** Local pick-up */
  PickUp = 'pick_up',
  /** Delivered via Roadie using a Roadie crossdock (for external deliveries) */
  RoadieCrossdock = 'roadie_crossdock',
  /** Delivered via Roadie (for external deliveries) */
  RoadieDelivery = 'roadie_delivery'
}

export enum OrderDeliveryStatus {
  /** order has a delivered_at value and all order line deliveried quantities equal the ordered quantity */
  Delivered = 'delivered',
  /** order has been fulfilled or collected and will be delivered soon */
  InTransit = 'in_transit',
  /** order has order lines and the order lines quanitities are greater than 0 but do not equal the order quantity */
  PartiallyDelivered = 'partially_delivered',
  /**
   * for orders with order lines: order has a delivered_at value but the quantity
   * of all order lines are zero. For orders with no order lines the stop has been
   * completed but the order does not have a delivered_at timestamp
   */
  Undelivered = 'undelivered',
  /** order has not been fulfilled or collected yet */
  Unfulfilled = 'unfulfilled'
}

/** An edge in a connection. */
export type OrderEdge = {
  __typename?: 'OrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Order>;
};

/** Order possible error types */
export type OrderError = BlankNote | InvalidDeliveredQuantity | InvalidFulfillmentQuantity | MissingQtyDelivered | OrderLineNotFound | OrderNotEligibleForReview | OrderNotFound | RecoveryQuantityOutOfRange | ReviewConfirmationMismatch | RouteEnded;

export type OrderEvent = {
  __typename?: 'OrderEvent';
  actor?: Maybe<OrderEventActor>;
  actorType: OrderActorTypeEnum;
  changes: Array<OrderEventLine>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  eventContext?: Maybe<Scalars['String']['output']>;
  eventType: OrderEventKindEnum;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
};

export type OrderEventActor = {
  __typename?: 'OrderEventActor';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isOdekoEmployee: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export enum OrderEventKindEnum {
  /** Order activated */
  Activated = 'activated',
  /** Order cancelled or discarded */
  Cancelled = 'cancelled',
  /** Order confirmed */
  Confirmed = 'confirmed',
  /** Cancelled order restored */
  Reinstated = 'reinstated',
  /** Order modified */
  Updated = 'updated',
  /** Order voided */
  Void = 'void'
}

export type OrderEventLine = {
  __typename?: 'OrderEventLine';
  afterQty?: Maybe<Scalars['Int']['output']>;
  beforeQty?: Maybe<Scalars['Int']['output']>;
  changed: Scalars['Boolean']['output'];
  itemsPerLot?: Maybe<Scalars['Int']['output']>;
  quantityType?: Maybe<Scalars['String']['output']>;
  skuName: Scalars['String']['output'];
  unitCostCents?: Maybe<Scalars['Int']['output']>;
};

export type OrderFee = {
  __typename?: 'OrderFee';
  /** The amount of the fee in cents applied to the order. */
  feeAmountCents: Scalars['Int']['output'];
  /** Unique identifier of the fee associated with the order. */
  feeId: Scalars['ID']['output'];
  /** The type of fee applied to the order. */
  feeType: Scalars['String']['output'];
};

export type OrderLine = {
  __typename?: 'OrderLine';
  basePriceCents: Scalars['Int']['output'];
  /** Denotes if the item is picked in bulk item at the warehouse. */
  bulkPickedItem: Scalars['Boolean']['output'];
  /**
   * Per-line audit log for the DMP review-detail page (admin role only; empty list
   * for other callers). Events are sorted chronologically (oldest first).
   */
  changeHistory: Array<OrderLineChangeEvent>;
  deliveredQuantity?: Maybe<Scalars['Int']['output']>;
  fractional: Scalars['Boolean']['output'];
  fulfillmentQuantity?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isMarketPriced: Scalars['Boolean']['output'];
  isPounds: Scalars['Boolean']['output'];
  itemsPerLot: Scalars['Int']['output'];
  /** Line-level delivery issues recorded for this order line on the given stop. */
  lineLevelDeliveryIssues: Array<LineLevelDeliveryIssue>;
  newestReconciledOrderLine?: Maybe<ReconciledOrderLine>;
  odekoPerksDiscountCents?: Maybe<Scalars['Int']['output']>;
  order: Order;
  orderUnitQuantity: Scalars['Int']['output'];
  orderedWeightLb?: Maybe<Scalars['Float']['output']>;
  originalOrderUnitQuantity: Scalars['Int']['output'];
  priceDiscountCents?: Maybe<Scalars['Int']['output']>;
  purchasePriceCents?: Maybe<Scalars['Int']['output']>;
  quantityType: Scalars['String']['output'];
  /**
   * Units the GM scheduled for re-delivery during DMP review. NULL = not yet
   * decided; 0 = decided no recovery; N>0 = recover N.
   */
  recoveryQuantity?: Maybe<Scalars['Int']['output']>;
  sellingPriceCents?: Maybe<Scalars['Int']['output']>;
  sku: Sku;
  totalQuantity: Scalars['Int']['output'];
  totalWeightLb?: Maybe<Scalars['Float']['output']>;
  unitCostCents: Scalars['Float']['output'];
  unitPriceCents?: Maybe<Scalars['Float']['output']>;
  unitWeightLb?: Maybe<Scalars['Float']['output']>;
};


export type OrderLineLineLevelDeliveryIssuesArgs = {
  redelivery?: InputMaybe<Scalars['Boolean']['input']>;
  stopId: Scalars['ID']['input'];
};

export type OrderLineAllocationInput = {
  fulfillmentQuantity: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};

/**
 * A single audited event on an OrderLine or one of its line-level delivery
 * issues. Flattened so UPDATEs that touch multiple columns surface as one
 * event per column (each with its own field/before/after); CREATE and
 * DESTROY events have field=null and the resource's audited row state
 * serialized into before_value or after_value.
 *
 * OrderLine CREATE events aren't surfaced (paper_trail records a no-op
 * version for every Kafka-sync OrderLine ingest). Whole-row CREATE/DESTROY
 * shapes therefore in practice only originate from LineLevelDeliveryIssue
 * events.
 */
export type OrderLineChangeEvent = {
  __typename?: 'OrderLineChangeEvent';
  /**
   * JWT subject for human actors (e.g. `auth0|abc`) or `system:<name>` for sync
   * paths. Null only when no whodunnit was set (legacy versions).
   */
  actor?: Maybe<Scalars['String']['output']>;
  /** Highest-precedence JWT role at write time, or 'system' for sync-path writes. Null when no role could be derived. */
  actorRole?: Maybe<Scalars['String']['output']>;
  /**
   * JSON-encoded value. For UPDATE: the new scalar. For CREATE: the audited row
   * state (all columns of the audited model). Null for DESTROY.
   */
  afterValue?: Maybe<Scalars['String']['output']>;
  /**
   * JSON-encoded value. For UPDATE: the prior scalar. For DESTROY: the audited row
   * state (all columns of the audited model). Null for CREATE.
   */
  beforeValue?: Maybe<Scalars['String']['output']>;
  event: ChangeEventKind;
  /** Audited column name for UPDATE events. Null for CREATE/DESTROY (which carry the row state instead). */
  field?: Maybe<Scalars['String']['output']>;
  /** GM rationale captured at write time (BaseMutation forwards the GraphQL `note:` arg into paper_trail metadata). */
  note?: Maybe<Scalars['String']['output']>;
  resource: AuditResourceKind;
  /**
   * Primary key of the audited row. For DESTROY events this row no longer exists;
   * use it to group events about the same underlying row.
   */
  resourceId: Scalars['ID']['output'];
  timestamp: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of OrderLineDeliveredQuantityUpdate */
export type OrderLineDeliveredQuantityUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Units actually delivered. Must be >= 0. */
  deliveredQuantity: Scalars['Int']['input'];
  /** GM note describing the adjustment. */
  note: Scalars['String']['input'];
  /** Order line id (UUID). */
  orderLineId: Scalars['ID']['input'];
};

/** Autogenerated return type of OrderLineDeliveredQuantityUpdate. */
export type OrderLineDeliveredQuantityUpdatePayload = {
  __typename?: 'OrderLineDeliveredQuantityUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  orderLine?: Maybe<OrderLine>;
  userErrors: Array<OrderError>;
};

/** Autogenerated input type of OrderLineFulfillmentQuantityUpdate */
export type OrderLineFulfillmentQuantityUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Units the warehouse picked. Must be >= 0. */
  fulfillmentQuantity: Scalars['Int']['input'];
  /** GM note describing the adjustment. */
  note: Scalars['String']['input'];
  /** Order line id (UUID). */
  orderLineId: Scalars['ID']['input'];
};

/** Autogenerated return type of OrderLineFulfillmentQuantityUpdate. */
export type OrderLineFulfillmentQuantityUpdatePayload = {
  __typename?: 'OrderLineFulfillmentQuantityUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  orderLine?: Maybe<OrderLine>;
  userErrors: Array<OrderError>;
};

export type OrderLineNotFound = UserErrorInterface & {
  __typename?: 'OrderLineNotFound';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type OrderLineNotOnStop = UserErrorInterface & {
  __typename?: 'OrderLineNotOnStop';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of OrderLineRecoveryQuantityUpdate */
export type OrderLineRecoveryQuantityUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** GM note describing the recovery decision. */
  note: Scalars['String']['input'];
  /** Order line id (UUID). */
  orderLineId: Scalars['ID']['input'];
  /** Units to schedule for re-delivery. 0 = decided no recovery; > 0 = recover N. */
  recoveryQuantity: Scalars['Int']['input'];
};

/** Autogenerated return type of OrderLineRecoveryQuantityUpdate. */
export type OrderLineRecoveryQuantityUpdatePayload = {
  __typename?: 'OrderLineRecoveryQuantityUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  orderLine?: Maybe<OrderLine>;
  userErrors: Array<OrderError>;
};

export type OrderLinesFulfillmentInput = {
  fulfillmentQuantity: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};

export type OrderLinesInput = {
  deliveredQuantity: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};

/** Error indicating that the order cannot be cancelled, typically because it is past the cutoff time. */
export type OrderNotCancellableError = Error & {
  __typename?: 'OrderNotCancellableError';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

export type OrderNotEligibleForReview = UserErrorInterface & {
  __typename?: 'OrderNotEligibleForReview';
  /**
   * The rejected order's delivery_method, surfaced so the UI can distinguish a
   * third-party order (doordash / roadie / metrobi / burq / shipping / vendor)
   * from a vendor-style order (warehouse_id nil with delivery_method
   * delivery/pick_up). Not necessarily the *cause* of rejection — the gate
   * requires both an Odeko warehouse and a local-delivery method, and either
   * missing one excludes the order.
   */
  deliveryMethod?: Maybe<Scalars['String']['output']>;
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** The order whose review-time mutation was rejected. */
  orderId: Scalars['ID']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type OrderNotFound = UserErrorInterface & {
  __typename?: 'OrderNotFound';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** Error indicating that a mutation failed because a free order cannot be created with a non-zero total. */
export type OrderNotFree = Error & {
  __typename?: 'OrderNotFree';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

export enum OrderPlatform {
  BaristaProShop = 'BARISTA_PRO_SHOP',
  BaristaUnderground = 'BARISTA_UNDERGROUND',
  Odeko = 'ODEKO',
  OdekoBulk = 'ODEKO_BULK'
}

/** Autogenerated input type of OrderQuantityDeliveredUpdate */
export type OrderQuantityDeliveredUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Order id. */
  orderId: Scalars['ID']['input'];
  /** Order lines containing the quantity delivered */
  orderLines: Array<OrderLinesInput>;
  redelivery?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of OrderQuantityDeliveredUpdate. */
export type OrderQuantityDeliveredUpdatePayload = {
  __typename?: 'OrderQuantityDeliveredUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  orderLines?: Maybe<Array<OrderLine>>;
  userErrors: Array<OrderError>;
};

export type OrderQueue = {
  __typename?: 'OrderQueue';
  /** Orders that need to be prepared for imminent pickup. */
  current: ConsumerOrderConnection;
  /** Order history. */
  history: ConsumerOrderConnection;
  /** Orders that need to be prepared, but not immediately. */
  scheduled: ConsumerOrderConnection;
};


export type OrderQueueCurrentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ConsumerOrderSortCriteria>;
};


export type OrderQueueHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ConsumerOrderSortCriteria>;
};


export type OrderQueueScheduledArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ConsumerOrderSortCriteria>;
};

export enum OrderReconciliationReasonEnum {
  /** The item was damaged */
  Damaged = 'DAMAGED',
  /** The item is missing from the order */
  MissingItem = 'MISSING_ITEM',
  /** There is a quality issue with the item */
  QualityIssue = 'QUALITY_ISSUE',
  /** The wrong item was delivered */
  WrongItem = 'WRONG_ITEM'
}

/** Server-derived recovery state for an order surfaced on Order.recoveryStatus. DMP renders only; never writes. */
export enum OrderRecoveryStatus {
  /**
   * Order is not subject to the DMP review flow (non-Odeko-warehouse,
   * non-local-delivery, or 3rd-party), or has no unrecovered shortfall to redeliver.
   */
  NotApplicable = 'not_applicable',
  /** A redelivery completed and the shortfall caught up (delivered_quantity >= fulfillment_quantity on every line). */
  Recovered = 'recovered',
  /** A redelivery stop exists on one of the order's Location delivery_route_stops and has not yet been completed. */
  Scheduled = 'scheduled',
  /**
   * A fulfilled≠delivered shortfall remains after the review is confirmed, with no
   * redelivery pending — either none scheduled, or a prior redelivery completed still short.
   */
  Unscheduled = 'unscheduled'
}

export type OrderReference = {
  __typename?: 'OrderReference';
  id: Scalars['ID']['output'];
  platform: OrderPlatform;
};

/** Autogenerated input type of OrderReviewConfirm */
export type OrderReviewConfirmInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** GM note describing the confirmation rationale. */
  note: Scalars['String']['input'];
  /** Order id. */
  orderId: Scalars['ID']['input'];
};

/** Autogenerated return type of OrderReviewConfirm. */
export type OrderReviewConfirmPayload = {
  __typename?: 'OrderReviewConfirmPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  userErrors: Array<OrderError>;
};

/** Server-derived review state for an order surfaced on Order.reviewStatus. DMP renders only; never writes. */
export enum OrderReviewStatus {
  /**
   * review_confirmed_at was set by the SLA sweep job (paper_trail version's
   * actor_role == 'system'). The sweep itself ships in a separate PR; this value
   * is defined-but-unreachable today and will start appearing once the sweep runs.
   */
  AutoBilled = 'auto_billed',
  /** review_confirmed_at is set and the confirmation came from a human GM via confirmOrderReview. */
  Confirmed = 'confirmed',
  /**
   * delivered_at + REVIEW_SLA_DURATION has elapsed but no confirmation has
   * happened (neither manual nor auto). Surfaces orders the SLA sweep will pick up next.
   */
  PassedDeadline = 'passed_deadline',
  /**
   * Order has not been review-confirmed and the SLA deadline has not yet passed.
   * Default state for pre-delivery orders and for orders not subject to the review
   * flow (non-Odeko-warehouse, non-local-delivery).
   */
  ReadyForReview = 'ready_for_review'
}

/**
 * Server-derived delivery-route completion state for an order surfaced on
 * Order.routeCompletionState. A pure mirror of the anchor Order#route_completed_at
 * computes for the review-by deadline, so the two can never disagree. Route-grain,
 * not order-grain, and NOT monotonic: an admin reopening a route (clearing its
 * stop_time) moves its orders back out of complete. DMP renders only; never writes.
 */
export enum OrderRouteCompletionState {
  /**
   * The order's delivery route has finished, so routeCompletedAt carries a time. A
   * route finishes at its explicit stop_time when one is set, otherwise once every
   * one of its stops is completed. An order sitting on more than one anchoring
   * route reads complete as soon as ANY of them finishes, so an order whose
   * generic route is still out reads complete once its customer-pickup bucket closes.
   */
  Complete = 'complete',
  /**
   * The order has at least one Location stop on an anchoring route (generic,
   * customer-pickup, or a third-party route a provider runs), but none of those
   * routes has finished, so nothing anchors its review deadline yet. Any
   * uncompleted stop holds the route here, including a Vendor pickup stop
   * belonging to another order.
   */
  InProgress = 'in_progress',
  /**
   * The order has no Location stop on an anchoring route (generic,
   * customer-pickup, or a third-party route a provider runs), so route completion
   * cannot anchor anything for it. Covers an order not yet scheduled onto a route,
   * an order not yet synced from Kafka, and an order whose only stops sit on a
   * provider's staging pen or a redelivery route, neither of which anchors review:
   * a pen is a queue that gets drained, not a route that completes.
   */
  NotRouteAnchored = 'not_route_anchored'
}

/** Vendor receiving record for a market-priced item */
export type OrderVendorReceiving = {
  __typename?: 'OrderVendorReceiving';
  id: Scalars['ID']['output'];
  itemId: Scalars['ID']['output'];
  nightEnd: Scalars['ISO8601Date']['output'];
  receivedQty: Scalars['Float']['output'];
  sellingPricePerUnitCents?: Maybe<Scalars['Int']['output']>;
  vendorId: Scalars['ID']['output'];
  vendorPricePerUnitCents?: Maybe<Scalars['Int']['output']>;
  vendorPriceTotalCents: Scalars['Int']['output'];
  warehouseId: Scalars['ID']['output'];
  windowClosesAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated input type of OrderWarehouseNoteUpdate */
export type OrderWarehouseNoteUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Warehouse note for the order */
  note: Scalars['String']['input'];
  /** order id. */
  orderId: Scalars['ID']['input'];
};

/** Autogenerated return type of OrderWarehouseNoteUpdate. */
export type OrderWarehouseNoteUpdatePayload = {
  __typename?: 'OrderWarehouseNoteUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  userErrors: Array<OrderError>;
};

/**
 * Whether a product is ready to sell in a market, and when it is not, why. Members name the reason a
 * product is withheld; ORDERABLE is the absence of one.
 *
 * Unrelated to stock: COMING_SOON means not released in this market yet, where out of stock means
 * released and temporarily unavailable. They read differently to a customer and must not be conflated.
 */
export enum Orderability {
  ComingSoon = 'COMING_SOON',
  Orderable = 'ORDERABLE'
}

/** Error indicating that the caller's role does not permit ordering the requested item(s). */
export type OrderingNotPermittedError = Error & {
  __typename?: 'OrderingNotPermittedError';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

export type OrderingRule = {
  __typename?: 'OrderingRule';
  itemId: Scalars['ID']['output'];
  /** Minimum quantity per order for this item */
  itemMinimumQuantity?: Maybe<Scalars['Int']['output']>;
  /** Purchase multiple for the item */
  itemPurchaseMultiple?: Maybe<Scalars['Int']['output']>;
  /** Quantity per unit for the item */
  itemQtyPerUnit?: Maybe<Scalars['Int']['output']>;
  vendor: Vendor;
  /** Vendor minimum order amount in cents for this item */
  vendorMinimumAmountCents?: Maybe<Scalars['Int']['output']>;
  /** Vendor minimum items per order for this item */
  vendorMinimumItems?: Maybe<Scalars['Int']['output']>;
};

export type OrderingRuleItemInput = {
  /** Item ID */
  id: Scalars['ID']['input'];
};

/** Error indicating that the caller's role may only order items already saved to the location. */
export type OrderingSavedItemsOnlyError = Error & {
  __typename?: 'OrderingSavedItemsOnlyError';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** The connection type for Order. */
export type OrdersConnection = {
  __typename?: 'OrdersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrderEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Order>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of records in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type OrdersInput = {
  /** Filters orders by delivery date, from_delivery_date and to_delivery_date take precedence over this filter. */
  deliveryDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Filters orders by delivery method. */
  deliveryMethods?: InputMaybe<Array<OrderDeliveryMethodEnum>>;
  /** Filters orders that have a delivery date on or after a specific date. */
  fromDeliveryDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Filters orders by the location, otherwise includes orders applicable to the user. */
  locationId?: InputMaybe<Scalars['ID']['input']>;
  /** Filters orders that have a delivery date on or before a specific date. */
  toDeliveryDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Filters orders by warehouse. */
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input for checking for out of stock items */
export type OutOfStockCheckInputItem = {
  /** Delivery date for the product check */
  deliveryDate: Scalars['ISO8601Date']['input'];
  /** Warehouse ID for the item check */
  fulfillmentWarehouseId?: InputMaybe<Scalars['ID']['input']>;
  /** Item UUID to check for out of stock */
  itemId: Scalars['ID']['input'];
  /** Quantity of the item to check */
  requestedQty: Scalars['Int']['input'];
};

/** Result of checking for out of stock items */
export type OutOfStockCheckResult = {
  __typename?: 'OutOfStockCheckResult';
  /** Available quantity of the product */
  availableQty: Scalars['Int']['output'];
  /**
   * Delivery date this result answers for. The same item can be checked for
   * several delivery dates in one request, and a result is only attributable to
   * its line by this date.
   */
  deliveryDate: Scalars['ISO8601Date']['output'];
  /** Item details */
  item: SupplyItem;
  /** Recommendation based on the out of stock check */
  recommendations?: Maybe<Array<SupplyItem>>;
};

/** One gate in the outbound pipeline, reduced to a traffic-light state. */
export type OutboundGate = {
  __typename?: 'OutboundGate';
  state: OutboundGateState;
};

export enum OutboundGateState {
  /** A deficiency was acknowledged but not fixed. */
  Acknowledged = 'ACKNOWLEDGED',
  /** All clear. */
  Clear = 'CLEAR',
  /** A deficiency was identified. */
  NeedsReview = 'NEEDS_REVIEW',
  /** Nothing to report at this gate yet. */
  Waiting = 'WAITING'
}

/** Outbound pipeline gates evaluated over a scope of orders. */
export type OutboundGates = {
  __typename?: 'OutboundGates';
  /**
   * How far the orders in scope are past their own due_at, measured against the
   * most common one. Distinct from the warehouse's recurring daily cut-off time.
   */
  orderCutoff: OutboundGate;
};

/** One in-progress customer still ready after a batch, with the error that stopped it if there was one. */
export type OutstandingOnboardingRow = {
  __typename?: 'OutstandingOnboardingRow';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyUuid?: Maybe<Scalars['ID']['output']>;
  /** Empty when the record was simply left behind rather than failed. */
  errorReason?: Maybe<Scalars['String']['output']>;
  /** The company it was matched to, where one was matched. */
  existingCompanyName?: Maybe<Scalars['String']['output']>;
  locationUuid?: Maybe<Scalars['ID']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  /** The id generated at ingest; the key this row joins on. */
  uniqueId?: Maybe<Scalars['String']['output']>;
  userEmail?: Maybe<Scalars['String']['output']>;
  userFirstName?: Maybe<Scalars['String']['output']>;
  userLastName?: Maybe<Scalars['String']['output']>;
};

export type OverrideCodeIssueConflict = UserErrorInterface & {
  __typename?: 'OverrideCodeIssueConflict';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type OverrideCodeNotFound = UserErrorInterface & {
  __typename?: 'OverrideCodeNotFound';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type OverrideVendorNotFound = UserErrorInterface & {
  __typename?: 'OverrideVendorNotFound';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PastHomepageCollectionEntry = {
  __typename?: 'PastHomepageCollectionEntry';
  collection: Collection;
  componentType: HomepageCollectionComponentType;
  configuredWarehouseCount: Scalars['Int']['output'];
  enabledWarehouseCount: Scalars['Int']['output'];
  endDate: Scalars['ISO8601Date']['output'];
  ruleId: Scalars['ID']['output'];
  startDate: Scalars['ISO8601Date']['output'];
  warehouseIds: Array<Scalars['ID']['output']>;
  warehouses: Array<CollectionsHomepageEntryWarehouse>;
};

/** Edge connecting an OdekoPaymentIntent to the resulting NetsuiteCustomerPayment. */
export type PaymentCompletion = FinancialTransactionEdgeInfo & {
  __typename?: 'PaymentCompletion';
  _?: Maybe<Scalars['String']['output']>;
};

/** Edge connecting an OdekoPaymentIntent to a specific transaction (e.g. invoice) for which some amount has been earmarked. */
export type PaymentEarmark = FinancialTransactionEdgeInfo & {
  __typename?: 'PaymentEarmark';
  _?: Maybe<Scalars['String']['output']>;
  /** Amount earmarked for use towards paying the specific transaction (e.g. invoice). */
  amount: Money;
};

export type PaymentError = {
  __typename?: 'PaymentError';
  amount: Money;
  date: Scalars['ISO8601Date']['output'];
  message?: Maybe<Scalars['String']['output']>;
  obfuscatedEmail?: Maybe<Scalars['String']['output']>;
  paymentMethodBrand?: Maybe<Scalars['String']['output']>;
  paymentMethodLast4?: Maybe<Scalars['String']['output']>;
};

/** A group that refers to a failed payment, i.e. a payment that was submitted to a payment processor (e.g. Stripe) but failed. */
export type PaymentFailed = PaymentInvoiceGroup & {
  __typename?: 'PaymentFailed';
  /**
   * Invoices in the group. This collection, although not paginated, is expressed
   * as a connection type in order to include the amount of payment associated with
   * each invoice via PaymentEarmark/PaymentUsage edge info.
   */
  invoices: FinancialTransactionConnection;
  paymentAmount: Money;
  paymentDate: Scalars['ISO8601Date']['output'];
};

/**
 * A group that refers to an upcoming, pending, successful, or failed payment. Note
 * that `upcoming` payments are a completely virtual type; these are not stored in the database.
 */
export type PaymentInvoiceGroup = {
  /**
   * Invoices in the group. This collection, although not paginated, is expressed
   * as a connection type in order to include the amount of payment associated with
   * each invoice via PaymentEarmark/PaymentUsage edge info.
   */
  invoices: FinancialTransactionConnection;
  paymentAmount: Money;
  paymentDate: Scalars['ISO8601Date']['output'];
};

/** The connection type for PaymentInvoiceGroup. */
export type PaymentInvoiceGroupConnection = {
  __typename?: 'PaymentInvoiceGroupConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PaymentInvoiceGroupEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PaymentInvoiceGroup>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PaymentInvoiceGroupEdge = {
  __typename?: 'PaymentInvoiceGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PaymentInvoiceGroup>;
};

/** Payment method values. */
export enum PaymentMethod {
  /** Free. */
  Free = 'free',
  /** Square card ID. */
  SquareCardId = 'square_card_id',
  /** Square card nonce. */
  SquareCardNonce = 'square_card_nonce',
  /** Wallet balance. */
  WalletBalance = 'wallet_balance'
}

export type PaymentMethodDefaultLocation = {
  __typename?: 'PaymentMethodDefaultLocation';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Error indicating that the payment method type does not match the default payment type for the location. */
export type PaymentMethodMismatchError = Error & {
  __typename?: 'PaymentMethodMismatchError';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Error indicating that the payment method is missing. */
export type PaymentMethodMissingError = Error & {
  __typename?: 'PaymentMethodMissingError';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Payment method types that can be used for orders */
export enum PaymentMethodTypeEnum {
  /** Direct funds transfer from bank account (ACH) */
  BankAccount = 'BANK_ACCOUNT',
  /** A "buy now pay later" installment lender, e.g. Credit Key */
  BuyNowPayLater = 'BUY_NOW_PAY_LATER',
  /** Credit card */
  CreditCard = 'CREDIT_CARD'
}

/**
 * A group that refers to a pending payment, i.e. a payment that was submitted to a
 * payment processor (e.g. Stripe) and has not yet succeeded or failed.
 */
export type PaymentPending = PaymentInvoiceGroup & {
  __typename?: 'PaymentPending';
  /**
   * Invoices in the group. This collection, although not paginated, is expressed
   * as a connection type in order to include the amount of payment associated with
   * each invoice via PaymentEarmark/PaymentUsage edge info.
   */
  invoices: FinancialTransactionConnection;
  paymentAmount: Money;
  /** Date on which payment was submitted. */
  paymentDate: Scalars['ISO8601Date']['output'];
};

export type PaymentProcessing = FeeInterface & {
  __typename?: 'PaymentProcessing';
  /** The threshold amount in cents at which the fee is applied. */
  feeThresholds: Array<FeeThreshold>;
  id: Scalars['ID']['output'];
  /** Indicates if the fee is active or not. */
  isActive: Scalars['Boolean']['output'];
  odekoUuid: Scalars['ID']['output'];
  /** The percentage of the payment processing fee. */
  warehouseFeePercent: Scalars['Float']['output'];
  /** Unique identifier of the warehouse associated with this payment processing fee. */
  warehouseId: Scalars['ID']['output'];
};

/** Error indicating that a mutation failed due to a payment processor error whose cause is unknown. */
export type PaymentProcessorGenericError = Error & {
  __typename?: 'PaymentProcessorGenericError';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Error indicating that payment settings are missing. */
export type PaymentSettingsMissingError = Error & {
  __typename?: 'PaymentSettingsMissingError';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/**
 * A group that refers to a successful payment, i.e. a payment that was submitted
 * to a payment processor (e.g. Stripe) and succeeded.
 */
export type PaymentSuccessful = PaymentInvoiceGroup & {
  __typename?: 'PaymentSuccessful';
  /**
   * Invoices in the group. This collection, although not paginated, is expressed
   * as a connection type in order to include the amount of payment associated with
   * each invoice via PaymentEarmark/PaymentUsage edge info.
   */
  invoices: FinancialTransactionConnection;
  paymentAmount: Money;
  /** Date on which payment was submitted. */
  paymentDate: Scalars['ISO8601Date']['output'];
};

/**
 * A group that refers to an upcoming payment, i.e. a payment that has not yet been
 * submitted to a payment processor (e.g. Stripe). Note that upcoming payments are
 * calculated on demand, i.e. they reflect the payments that would eventually be
 * submitted for processing given the current invoices, payment terms, etc.
 */
export type PaymentUpcoming = PaymentInvoiceGroup & {
  __typename?: 'PaymentUpcoming';
  billingStatus?: Maybe<BillingStatus>;
  /**
   * Invoices in the group. This collection, although not paginated, is expressed
   * as a connection type in order to include the amount of payment associated with
   * each invoice via PaymentEarmark/PaymentUsage edge info.
   */
  invoices: FinancialTransactionConnection;
  paymentAmount: Money;
  /** Date on which payment submission is due. */
  paymentDate: Scalars['ISO8601Date']['output'];
};

/** Edge connecting a payment-record to a transaction (e.g. invoice) on which payment was used. */
export type PaymentUsage = FinancialTransactionEdgeInfo & {
  __typename?: 'PaymentUsage';
  _?: Maybe<Scalars['String']['output']>;
  /** Amount of payment used. */
  amount: Money;
  /** Date on which payment was used. */
  date: Scalars['ISO8601Date']['output'];
};

/** Autogenerated input type of PerformOutOfStockChecksMutation */
export type PerformOutOfStockChecksMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** If true, excludes recommendations from the result */
  excludeRecommendations?: InputMaybe<Scalars['Boolean']['input']>;
  /** Location UUID */
  locationId: Scalars['ID']['input'];
  /** List of items to check if are out of stock */
  requestedItems: Array<OutOfStockCheckInputItem>;
};

/** Autogenerated return type of PerformOutOfStockChecksMutation. */
export type PerformOutOfStockChecksMutationPayload = {
  __typename?: 'PerformOutOfStockChecksMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  results?: Maybe<Array<OutOfStockCheckResult>>;
};

export enum Perishability {
  NonPerishable = 'NON_PERISHABLE',
  Perishable = 'PERISHABLE',
  SemiPerishable = 'SEMI_PERISHABLE'
}

export type PhoneNumber = {
  __typename?: 'PhoneNumber';
  afterHoursContactAllowed: Scalars['Boolean']['output'];
  number: Scalars['String']['output'];
  phoneType: PhoneTypeEnum;
};

/** Error indicating the requested phone number is already in use. */
export type PhoneNumberAlreadyTaken = Error & {
  __typename?: 'PhoneNumberAlreadyTaken';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Error indicating that a mutation failed because the provided phone number was not formatted correctly. */
export type PhoneNumberNotFormatted = Error & {
  __typename?: 'PhoneNumberNotFormatted';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Error indicating that a mutation failed because the provided phone number was not successfully verified. */
export type PhoneNumberNotVerified = Error & {
  __typename?: 'PhoneNumberNotVerified';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Error indicating a failure to start phone number verification. */
export type PhoneNumberVerificationNotStarted = Error & {
  __typename?: 'PhoneNumberVerificationNotStarted';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Result of successfully starting phone number verification. */
export type PhoneNumberVerificationStarted = {
  __typename?: 'PhoneNumberVerificationStarted';
  /** Success message. */
  message: Scalars['String']['output'];
};

/** Result of successfully reporting phone number verification. */
export type PhoneNumberVerified = {
  __typename?: 'PhoneNumberVerified';
  /**
   * ID of successful phone number verification. This should be included as an
   * argument to mutations that require proof of successful phone number verification.
   */
  phoneVerificationId: Scalars['ID']['output'];
};

export enum PhoneTypeEnum {
  /** Location phone number that can be used to resolve order issues */
  OrderContact = 'order_contact'
}

/**
 * One past warehouse-day grading the nightly pick-hours suggestion against the
 * measured actual. Grading runs on the measured-active-hours scale (overhead
 * cancels): errorRatio = suggestedActiveHours / measuredActiveHours = forecastMiss
 * × conversionDrift × paceDrift. Each row is graded on its own demandBasis — rows
 * on different bases are not comparable. Ungradeable pieces are null, never fabricated.
 */
export type PickHoursScorecardDay = {
  __typename?: 'PickHoursScorecardDay';
  /**
   * Realized pick lines: countable RF-SMART pick events in the path's channels on
   * the local floor day — the fulfillment_date_lines grading denominator.
   */
  actualLines?: Maybe<Scalars['Int']['output']>;
  /** measuredActiveHours × overheadSnapshot: the actual on the staffing scale the admin saw. */
  actualStaffingHours?: Maybe<Scalars['Float']['output']>;
  /** Realized sale units (ld-scoped orders + ecom actuals) — the delivery_date_units grading denominator. */
  actualUnits?: Maybe<Scalars['Float']['output']>;
  benchmarkErrorHours?: Maybe<Scalars['Float']['output']>;
  /** Weekday median of measured active hours over the trailing window — the naive benchmark. */
  benchmarkHours?: Maybe<Scalars['Float']['output']>;
  /** Kiosk-clocked pick-path hours — corroboration only, in no calculation. */
  clockedPickHours?: Maybe<Scalars['Float']['output']>;
  computedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * Fitted scans-per-forecast-line ÷ realizedConversion. The fit is per FORECAST
   * quantity (so a constant forecast bias cancels out of the suggestion), which
   * makes this move inversely with forecastMiss at a biased site: only their
   * product and paceDrift are separately meaningful.
   */
  conversionDrift?: Maybe<Scalars['Float']['output']>;
  date: Scalars['ISO8601Date']['output'];
  /**
   * Demand basis the suggestion was computed and graded on:
   * 'fulfillment_date_lines' (forecast pick lines keyed on the picking day, graded
   * vs actualLines) or 'delivery_date_units' (forecast sale units keyed on
   * delivery/order date, graded vs actualUnits). Never pool rows across bases.
   * Null when the day has no suggestion.
   */
  demandBasis?: Maybe<Scalars['String']['output']>;
  /** Forecast demand at each candidate offset (on demandBasis's quantity), frozen at compute time. */
  demandSnapshots?: Maybe<Scalars['JSON']['output']>;
  /** suggestedActiveHours ÷ measuredActiveHours. */
  errorRatio?: Maybe<Scalars['Float']['output']>;
  /**
   * Forecast demand at the offset ÷ realized demand, both on the row's
   * demandBasis. Anti-correlated with conversionDrift — see that field.
   */
  forecastMiss?: Maybe<Scalars['Float']['output']>;
  /** Measured active picking hours from the scan stream — the actual on the suggestion's own scale. */
  measuredActiveHours?: Maybe<Scalars['Float']['output']>;
  measuredScans?: Maybe<Scalars['Int']['output']>;
  /** Forecast day offset the suggestion was computed at (0 on the fulfillment-date basis: nothing left to guess). */
  offsetDays?: Maybe<Scalars['Int']['output']>;
  overheadSnapshot?: Maybe<Scalars['Float']['output']>;
  /** True when the admin took the cell over; false means the suggestion stood. */
  overridden?: Maybe<Scalars['Boolean']['output']>;
  /** True when the admin's number landed at least as close to the actual as the naive weekday-median benchmark. */
  overrideBeatsBenchmark?: Maybe<Scalars['Boolean']['output']>;
  /**
   * True when the admin's number landed at least as close to the actual as the
   * system's. Ranked with the row's frozen overhead on one scale, so the verdict
   * is scale-invariant.
   */
  overrideBeatsSuggestion?: Maybe<Scalars['Boolean']['output']>;
  /**
   * |targetHours − actualStaffingHours| on the staffing scale the admin typed on.
   * Null unless overridden and the row carries a frozen overheadSnapshot (no
   * snapshot, no grade — never a fallback).
   */
  overrideErrorHours?: Maybe<Scalars['Float']['output']>;
  /**
   * targetHours ÷ measuredActiveHours, shipped ONLY on overridden rows that cannot
   * be graded (no overheadSnapshot). A plausibility check against the normal
   * overhead band, not a grade.
   */
  overrideImpliedOverhead?: Maybe<Scalars['Float']['output']>;
  /** Realized pace ÷ fitted pace. */
  paceDrift?: Maybe<Scalars['Float']['output']>;
  paceSnapshot?: Maybe<Scalars['Float']['output']>;
  /**
   * Measured scans ÷ the realized demand on the row's demandBasis (actualLines or
   * actualUnits) — the realized counterpart of scansPerForecastLineSnapshot.
   */
  realizedConversion?: Maybe<Scalars['Float']['output']>;
  /** Realized scans per active picking hour. */
  realizedPace?: Maybe<Scalars['Float']['output']>;
  /**
   * The fitted conversion factor: covered scans per FORECAST line — fitted per
   * forecast quantity, never a physical warehouse constant (per forecast sale unit
   * on delivery_date_units rows).
   */
  scansPerForecastLineSnapshot?: Maybe<Scalars['Float']['output']>;
  source?: Maybe<ProcessPathCoverageTargetSource>;
  /** The suggestion on the measured-active-hours scale, recomputed from its own snapshots (before overhead). */
  suggestedActiveHours?: Maybe<Scalars['Float']['output']>;
  /** The nightly suggestion in staffing hours (baselineRequiredHours). Null when no suggestion was computed. */
  suggestedHours?: Maybe<Scalars['Float']['output']>;
  /** True when the suggestion's absolute error is no larger than the benchmark's. */
  suggestionBeatsBenchmark?: Maybe<Scalars['Boolean']['output']>;
  suggestionErrorHours?: Maybe<Scalars['Float']['output']>;
  /** What the planning grid held for the day (the admin's number under an override). */
  targetHours?: Maybe<Scalars['Float']['output']>;
};

export type PickUp = {
  __typename?: 'PickUp';
  /** The time the driver arrived at the stop */
  arrivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  attachments?: Maybe<Array<Attachment>>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  deliveryStatus: DeliveryStatus;
  /** stop status used in the DMP */
  deliveryStatusDmp: DeliveryStatusDmp;
  deliveryStatusDriver: DeliveryStatusDriver;
  /** The time the driver departed from the stop */
  departedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  issues?: Maybe<Array<Issue>>;
  orders?: Maybe<Array<Order>>;
  reminderMessage?: Maybe<Scalars['String']['output']>;
  route: Route;
  sequenceNumber?: Maybe<Scalars['String']['output']>;
  vendor: Vendor;
};

export type PickupRoutingDisabled = UserErrorInterface & {
  __typename?: 'PickupRoutingDisabled';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
  warehouseIds: Array<Scalars['ID']['output']>;
};

export type PickupSchedule = {
  __typename?: 'PickupSchedule';
  /** Time treated as current during schedule calculation. */
  asOf: Scalars['ISO8601DateTime']['output'];
  /** Pickup schedules by date. */
  byDate: Array<PickupScheduleOnDate>;
  /** Server time when schedule was calculated. */
  calculatedAt: Scalars['ISO8601DateTime']['output'];
  /** Default pickup time. This is the earliest available pickup time, or null if no available time was found. */
  defaultPickupTime?: Maybe<PickupTime>;
  /** Minimum notice required for pickup. */
  minimumNotice: RelativeTime;
  /** Time zone of date boundaries. */
  timezone: Scalars['String']['output'];
};

export type PickupScheduleOnDate = {
  __typename?: 'PickupScheduleOnDate';
  /** Time intervals describing availability or reasons for unavailability. */
  allIntervals: Array<AvailabilityInterval>;
  /** Time intervals during which pickup is available. */
  availableIntervals: Array<AvailableInterval>;
  /** Calendar date in schedule's time zone. */
  date: Scalars['ISO8601Date']['output'];
};

/** Pickup time. */
export type PickupTime = AbsoluteTime | RelativeTime;

export type PinItemAcrossMarketsInput = {
  itemId: Scalars['ID']['input'];
  /** Absolute carousel slot to pin to in every eligible market — the item becomes that slot's queue leader in each. */
  position: Scalars['Int']['input'];
  /** Mark every resulting pin as a paid (sponsored) placement; defaults off. */
  sponsored?: InputMaybe<Scalars['Boolean']['input']>;
  /** Restrict the pin to this subset of markets, intersected with the item's currently-new markets. Omit to pin every eligible market. */
  warehouseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PinItemAcrossMarketsPayload = {
  __typename?: 'PinItemAcrossMarketsPayload';
  errors: Array<NewItemPinError>;
  pins: Array<NewItemPin>;
  /** Number of those markets where an existing pin was demoted to a fallback candidate. */
  warehousesBumped: Scalars['Int']['output'];
  /** Number of markets the item was pinned in. */
  warehousesPinned: Scalars['Int']['output'];
};

export enum PlatformActions {
  Connect = 'CONNECT',
  Login = 'LOGIN',
  Signup = 'SIGNUP'
}

/** Platform entity types */
export enum PlatformEntity {
  /** Platform Account entity */
  Account = 'ACCOUNT',
  /** Account Profile entity */
  Profile = 'PROFILE'
}

/** Supported platform identifiers */
export enum PlatformIds {
  GoogleBusinessProfile = 'GOOGLE_BUSINESS_PROFILE',
  MondayBoard = 'MONDAY_BOARD',
  SquareMarketingTools = 'SQUARE_MARKETING_TOOLS',
  SquareV2 = 'SQUARE_V2'
}

/** Platform entity with microsite association */
export type PlatformMicrosite = {
  __typename?: 'PlatformMicrosite';
  /** Account ID or Profile ID of the platform entity */
  entityId: Scalars['ID']['output'];
  /** Name of the platform entity */
  entityName: Scalars['String']['output'];
  /** Type of the platform entity (ACCOUNT or PROFILE) */
  entityType: PlatformEntity;
  /** Google Place ID associated with this platform entity */
  googlePlaceId?: Maybe<Scalars['String']['output']>;
  /** Whether this is the default microsite for analytics */
  isDefault: Scalars['Boolean']['output'];
  /** Associated microsite location, if any */
  micrositeLocation?: Maybe<MicrositeLocation>;
};

export enum PlatformType {
  Mobile = 'MOBILE',
  Web = 'WEB'
}

export enum PredictabilityLevel {
  Erratic = 'ERRATIC',
  Moderate = 'MODERATE',
  NoVariation = 'NO_VARIATION',
  Predictable = 'PREDICTABLE',
  SingleOrder = 'SINGLE_ORDER'
}

/** AWS S3 service possible errors */
export type PresignerError = ServiceError;

/** Price correction indicating that a price expectation was out of date or otherwise inaccurate. */
export type PriceCorrection = Error & {
  __typename?: 'PriceCorrection';
  /** Correct price. */
  correctPrice: Money;
  /** ID of object associated with this price correction. */
  id: Scalars['ID']['output'];
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** A pricing package configuration for marketing tools subscriptions */
export type PricingPackage = {
  __typename?: 'PricingPackage';
  /** Whether to display kit option */
  displayKit: Scalars['Boolean']['output'];
  /** Whether to display subscription option */
  displaySubscription: Scalars['Boolean']['output'];
  /** UUID identifier */
  id: Scalars['ID']['output'];
  /** Human-readable kit description */
  kitDescription?: Maybe<Scalars['String']['output']>;
  /** Whether physical signage kit purchase is optional */
  kitOptional: Scalars['Boolean']['output'];
  /** Kit price in cents */
  kitPriceCents: Scalars['Int']['output'];
  /** Stripe Price ID for kit */
  kitStripePriceId: Scalars['String']['output'];
  /** Integer ID for easy reference */
  pricingPackageId: Scalars['Int']['output'];
  /** Human-readable subscription description */
  subscriptionDescription?: Maybe<Scalars['String']['output']>;
  /** Subscription period (month, year) */
  subscriptionPeriod?: Maybe<Scalars['String']['output']>;
  /** Subscription price in cents */
  subscriptionPriceCents?: Maybe<Scalars['Int']['output']>;
  /** Stripe Price ID for subscription */
  subscriptionStripePriceId?: Maybe<Scalars['String']['output']>;
  /** Package summary description */
  summary?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of PricingServicePingify */
export type PricingServicePingifyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of PricingServicePingify. */
export type PricingServicePingifyPayload = {
  __typename?: 'PricingServicePingifyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  result: Scalars['String']['output'];
};

export enum PrintingMethod {
  /** Printed by a third party vendor */
  External = 'external',
  /** Printed by our own team */
  InHouse = 'in_house'
}

export type ProcessPath = {
  __typename?: 'ProcessPath';
  /** Whether this catalog path is available at the given warehouse. */
  availableHere: Scalars['Boolean']['output'];
  category: ProcessPathCategory;
  /** Stable short code, e.g. PICK. */
  code: Scalars['String']['output'];
  /** Hex colour used for chips/bars in the UI. */
  color: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
};


export type ProcessPathAvailableHereArgs = {
  warehouseId: Scalars['ID']['input'];
};

export enum ProcessPathAgency {
  /** ProLogistix. */
  Prologistix = 'PROLOGISTIX',
  /** Wonolo. */
  Wonolo = 'WONOLO'
}

/** Autogenerated input type of ProcessPathAssign */
export type ProcessPathAssignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  employeeId: Scalars['ID']['input'];
  pathId: Scalars['ID']['input'];
  warehouseId: Scalars['ID']['input'];
};

/** Autogenerated return type of ProcessPathAssign. */
export type ProcessPathAssignPayload = {
  __typename?: 'ProcessPathAssignPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employeeDay?: Maybe<ProcessPathEmployeeDay>;
  userErrors: Array<ProcessPathError>;
};

/** Autogenerated input type of ProcessPathAssociateCreate */
export type ProcessPathAssociateCreateInput = {
  agency: ProcessPathAgency;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  warehouseId: Scalars['ID']['input'];
};

/** Autogenerated return type of ProcessPathAssociateCreate. */
export type ProcessPathAssociateCreatePayload = {
  __typename?: 'ProcessPathAssociateCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<ProcessPathEmployee>;
  userErrors: Array<ProcessPathError>;
};

/** Autogenerated input type of ProcessPathAssociateSetStatus */
export type ProcessPathAssociateSetStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  employeeId: Scalars['ID']['input'];
  status: WarehouseAssociateStatus;
};

/** Autogenerated return type of ProcessPathAssociateSetStatus. */
export type ProcessPathAssociateSetStatusPayload = {
  __typename?: 'ProcessPathAssociateSetStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<ProcessPathEmployee>;
  userErrors: Array<ProcessPathError>;
};

export enum ProcessPathCategory {
  /** Direct (hands-on the work) time. */
  Direct = 'DIRECT',
  /** Indirect time (break, cleanup, meeting, other). */
  Indirect = 'INDIRECT'
}

/** Autogenerated input type of ProcessPathClearCoverageTarget */
export type ProcessPathClearCoverageTargetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['ISO8601Date']['input'];
  pathId: Scalars['ID']['input'];
  warehouseId: Scalars['ID']['input'];
};

/** Autogenerated return type of ProcessPathClearCoverageTarget. */
export type ProcessPathClearCoverageTargetPayload = {
  __typename?: 'ProcessPathClearCoverageTargetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The reverted system row, or null when the cell is now empty. */
  coverageTarget?: Maybe<ProcessPathCoverageTarget>;
  userErrors: Array<ProcessPathError>;
};

/** Autogenerated input type of ProcessPathClockIn */
export type ProcessPathClockInInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  employeeId: Scalars['ID']['input'];
  warehouseId: Scalars['ID']['input'];
};

/** Autogenerated return type of ProcessPathClockIn. */
export type ProcessPathClockInPayload = {
  __typename?: 'ProcessPathClockInPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employeeDay?: Maybe<ProcessPathEmployeeDay>;
  userErrors: Array<ProcessPathError>;
};

/** Autogenerated input type of ProcessPathClockOut */
export type ProcessPathClockOutInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  employeeId: Scalars['ID']['input'];
  warehouseId: Scalars['ID']['input'];
};

/** Autogenerated return type of ProcessPathClockOut. */
export type ProcessPathClockOutPayload = {
  __typename?: 'ProcessPathClockOutPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employeeDay?: Maybe<ProcessPathEmployeeDay>;
  userErrors: Array<ProcessPathError>;
};

export type ProcessPathCompliance = {
  __typename?: 'ProcessPathCompliance';
  /**
   * Agency temp staff's (Wonolo/ProLogistix) kiosk self-clock
   * (ProcessPathTimecard) minutes. No payroll source exists for temps, so this is
   * self-reported, not ARMHR-grade — do not compare directly to clocked_minutes above.
   */
  agencyClockedMinutes: Scalars['Int']['output'];
  /**
   * agency_self_reported ÷ agency_clocked, %. Self-reported kiosk time versus
   * self-reported segments — both sides are self-reported, never payroll-grade.
   * Null when nothing is agency-clocked (undefined).
   */
  agencyCoveragePct?: Maybe<Scalars['Float']['output']>;
  /** agency_clocked − agency_self_reported. Positive = under-reported temp labour, by the self-reported kiosk yardstick. */
  agencyGapMinutes: Scalars['Int']['output'];
  /**
   * Person-minutes reported into process paths by agency temp staff
   * (Wonolo/ProLogistix), broken out of the coverage math since ARMHR clocked
   * minutes never include them.
   */
  agencySelfReportedMinutes: Scalars['Int']['output'];
  /** ARMHR physical clocked minutes. Partial for today (open/missed-clock-out punches have no worked minutes yet). */
  clockedMinutes: Scalars['Int']['output'];
  /** self_reported ÷ clocked, %. Null when nothing is clocked (undefined). */
  coveragePct?: Maybe<Scalars['Float']['output']>;
  endDate: Scalars['ISO8601Date']['output'];
  /** clocked − self_reported. Positive = under-reported labour. */
  gapMinutes: Scalars['Int']['output'];
  /**
   * ARMHR-sourced associates whose reported segment minutes exceed their clocked
   * punch minutes over the window — the people who can push coverage_pct above
   * 100%. Largest excess first.
   */
  overReporters: Array<ProcessPathOverReporter>;
  /**
   * Person-minutes reported into process paths (segments) by ARMHR-sourced
   * associates only. Agency temps' minutes are reported separately in
   * agency_self_reported_minutes (their sum plus this one is the same total as the By-hour tab).
   */
  selfReportedMinutes: Scalars['Int']['output'];
  startDate: Scalars['ISO8601Date']['output'];
  warehouseId: Scalars['ID']['output'];
};

export type ProcessPathCoverageTarget = {
  __typename?: 'ProcessPathCoverageTarget';
  /** The system suggestion a cleared override reverts to. */
  baselineRequiredHours?: Maybe<Scalars['Float']['output']>;
  date: Scalars['ISO8601Date']['output'];
  path: ProcessPath;
  /** Whether the value is admin-entered or system-computed. */
  source: ProcessPathCoverageTargetSource;
  /** Planned labour hours (allows half-hours). 0 is an asserted zero. */
  targetHours: Scalars['Float']['output'];
  warehouseId: Scalars['ID']['output'];
};

export enum ProcessPathCoverageTargetSource {
  /** Hand-entered by an admin; system writes never touch it. */
  Admin = 'ADMIN',
  /** Computed by the nightly baseline job. */
  System = 'SYSTEM'
}

/** Autogenerated input type of ProcessPathCreate */
export type ProcessPathCreateInput = {
  category: ProcessPathCategory;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  warehouseId: Scalars['ID']['input'];
};

/** Autogenerated return type of ProcessPathCreate. */
export type ProcessPathCreatePayload = {
  __typename?: 'ProcessPathCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  processPath?: Maybe<ProcessPath>;
  userErrors: Array<ProcessPathError>;
};

/**
 * Warehouse-level forecasted demand for one day, in SALES UNITS (as ordered — a
 * case counts as 1; the same basis as pick throughput units). Not broken down by process path.
 */
export type ProcessPathDayForecast = {
  __typename?: 'ProcessPathDayForecast';
  date: Scalars['ISO8601Date']['output'];
  /** How this day's demand is dated. Always fulfillment_date_lines (picking-day feed, same basis as the pick-hours suggestion). */
  demandBasis: Scalars['String']['output'];
  /** Forecasted ecommerce order units. */
  ecomUnits?: Maybe<Scalars['Float']['output']>;
  /** Forecasted local-delivery units picked. */
  localDeliveryUnits?: Maybe<Scalars['Float']['output']>;
  /** Forecast pick lines (LD + ecom) for the day — what the pick-hours suggestion computes from. */
  pickLines?: Maybe<Scalars['Float']['output']>;
  /** Sum of the available unit forecasts for the day. */
  totalUnits: Scalars['Float']['output'];
};

export type ProcessPathDayTotal = {
  __typename?: 'ProcessPathDayTotal';
  minutes: Scalars['Int']['output'];
  path: ProcessPath;
};

export type ProcessPathEmployee = {
  __typename?: 'ProcessPathEmployee';
  /** Staffing agency for source=agency associates (e.g. wonolo, prologistix). */
  agency?: Maybe<Scalars['String']['output']>;
  /** ARMHR employee code (identity-spine join key). */
  associateId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** ARMHR job title (homePosition), e.g. "Warehouse Associate". */
  position?: Maybe<Scalars['String']['output']>;
  positionId?: Maybe<Scalars['String']['output']>;
  shiftLabel?: Maybe<Scalars['String']['output']>;
  /** armhr (WorkforceHub-synced) or agency (manually provisioned temp staff). */
  source: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  warehouseId?: Maybe<Scalars['ID']['output']>;
};

/**
 * An associate's labour for one date. clockInAt/clockedMinutes come from the kiosk
 * self-clock; punchedInAt/untrackedMinutes/pathSelectionFlagged come from the
 * ARMHR time clock and lag it by up to ~30 min.
 */
export type ProcessPathEmployeeDay = {
  __typename?: 'ProcessPathEmployeeDay';
  accountedMinutes: Scalars['Int']['output'];
  clockInAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  clockOutAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** How the shift ended: 'system' = auto-closed by reconciliation. */
  clockOutSource?: Maybe<ProcessPathSource>;
  clockedMinutes: Scalars['Int']['output'];
  /** Open segment for today, if any (drives the live board). */
  currentSegment?: Maybe<ProcessPathSegment>;
  date: Scalars['ISO8601Date']['output'];
  employee: ProcessPathEmployee;
  /**
   * untrackedMinutes >= 30 — the supervisor's chase list. The threshold matches
   * the punch sync cadence, so polling lag alone cannot trip it.
   */
  pathSelectionFlagged: Scalars['Boolean']['output'];
  /** ARMHR punch-in for the shift in progress. Null when off shift, or for agency temps, who never have punches. */
  punchedInAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  segments: Array<ProcessPathSegment>;
  totals: Array<ProcessPathDayTotal>;
  /** max(clocked - accounted, 0). */
  unaccountedMinutes: Scalars['Int']['output'];
  /**
   * Minutes since labour was last attributed to a path, measured from the later of
   * punch-in and the last closed segment. Null when on a path or not punched in.
   */
  untrackedMinutes?: Maybe<Scalars['Int']['output']>;
};

export type ProcessPathEmployeeNotFound = UserErrorInterface & {
  __typename?: 'ProcessPathEmployeeNotFound';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type ProcessPathEmployeeThroughput = {
  __typename?: 'ProcessPathEmployeeThroughput';
  accuracy: ProcessPathThroughputAccuracy;
  /** What units/orphanUnits/ratePerHour count. Always "units"; kept for clients that read it while pick paths counted lines. */
  basis: Scalars['String']['output'];
  date: Scalars['ISO8601Date']['output'];
  /**
   * The hours `ratePerHour` divided by. clocked_hours: kiosk-clocked person-hours
   * by this employee on this path (`laborHours`).
   */
  denominator: Scalars['String']['output'];
  employee: ProcessPathEmployee;
  laborHours: Scalars['Float']['output'];
  /**
   * Output by this employee on this path with no matching same-path segment (a
   * capture-discipline signal: the work happened but was never clocked).
   */
  orphanUnits: Scalars['Float']['output'];
  path: ProcessPath;
  /** `units` per hour of `denominator`. Null (not zero) when no labour was logged. */
  ratePerHour?: Maybe<Scalars['Float']['output']>;
  sourceLabel: Scalars['String']['output'];
  /**
   * What one of `units` is: sales_units on pick paths (as ordered — a case counts
   * as 1, the demand forecast's basis); handling_units on receive (the receipt
   * line's ordering unit — a case of any size counts as 1; named from the rows'
   * frozen handling_basis); operations on putaway and count.
   */
  unit: Scalars['String']['output'];
  /**
   * Output attributed to this employee on the day, counted in `unit` — the same
   * basis the warehouse day total sums on this path.
   */
  units: Scalars['Float']['output'];
};

/** Process path possible error types */
export type ProcessPathError = ProcessPathEmployeeNotFound | ProcessPathNotFound | ProcessPathValidationError;

export type ProcessPathHourlyTotal = {
  __typename?: 'ProcessPathHourlyTotal';
  /** Person-minutes per hour of the day, index 0 = 00:00 .. 23. */
  hourlyMinutes: Array<Scalars['Int']['output']>;
  path: ProcessPath;
  totalMinutes: Scalars['Int']['output'];
};

/**
 * Units and lines picked at a warehouse on one local day, from the materialized
 * measured-pace rows (PickChannelDayMeasure), summed over the pick path's own
 * channels. The COVERED POPULATION — the pickers the confirm stream sees — which
 * measured 93.4% of total picked units across 34 days at EWR1 (86.4-98.7, stddev
 * 3.4). Read this for a fast daily series; read processPathThroughput's units for
 * the whole floor's output.
 */
export type ProcessPathMeasuredPickDay = {
  __typename?: 'ProcessPathMeasuredPickDay';
  /** Warehouse-local day. */
  date: Scalars['ISO8601Date']['output'];
  /** Pick lines (scan actions) on the day. */
  measuredLines: Scalars['Int']['output'];
  /** Idle-capped active-picking minutes behind those units. */
  measuredMinutes: Scalars['Int']['output'];
  /** Scanned sales units (as ordered — a case counts as 1), the same basis as the demand forecast. */
  measuredUnits: Scalars['Float']['output'];
};

export type ProcessPathNotFound = UserErrorInterface & {
  __typename?: 'ProcessPathNotFound';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type ProcessPathOverReporter = {
  __typename?: 'ProcessPathOverReporter';
  accountedMinutes: Scalars['Int']['output'];
  clockedMinutes: Scalars['Int']['output'];
  employee: ProcessPathEmployee;
  /** accounted − clocked. */
  excessMinutes: Scalars['Int']['output'];
};

/** Autogenerated input type of ProcessPathReorder */
export type ProcessPathReorderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Catalog path ids in the desired left-to-right order (global). */
  pathIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of ProcessPathReorder. */
export type ProcessPathReorderPayload = {
  __typename?: 'ProcessPathReorderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  processPaths: Array<ProcessPath>;
  userErrors: Array<ProcessPathError>;
};

/**
 * One warehouse-local day's whole-floor output and clocked labour for one process
 * path. The Throughput grid's basis: units here match processPathThroughput's
 * daily units for the same path; rate = units over clocked hours. The pick path
 * reads its materialized day rows; any other path reads its registered output
 * source. Days with neither scans nor clocked time are absent.
 */
export type ProcessPathScanDay = {
  __typename?: 'ProcessPathScanDay';
  /** Minutes clocked onto this path that day (kiosk/supervisor segments). */
  clockedMinutes: Scalars['Int']['output'];
  /** Warehouse-local day. */
  date: Scalars['ISO8601Date']['output'];
  /** The process path this day answers for (the request's processPathCode, or the LD/Ecomm pick path when none was named). */
  processPathCode: Scalars['String']['output'];
  /**
   * All scanned units for the day (whole floor, regardless of confirm coverage),
   * counted the way the path's output source counts them.
   */
  totalUnits: Scalars['Float']['output'];
};

export type ProcessPathSegment = {
  __typename?: 'ProcessPathSegment';
  createdAt: Scalars['ISO8601DateTime']['output'];
  employee: ProcessPathEmployee;
  endsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** Whole minutes elapsed (to now if still active). */
  minutes: Scalars['Int']['output'];
  path: ProcessPath;
  source: ProcessPathSource;
  startsAt: Scalars['ISO8601DateTime']['output'];
  unitsProcessed?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  warehouseId: Scalars['ID']['output'];
};

/** Autogenerated input type of ProcessPathSegmentCreate */
export type ProcessPathSegmentCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  employeeId: Scalars['ID']['input'];
  endsAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  pathId: Scalars['ID']['input'];
  source?: InputMaybe<ProcessPathSource>;
  startsAt: Scalars['ISO8601DateTime']['input'];
  unitsProcessed?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of ProcessPathSegmentCreate. */
export type ProcessPathSegmentCreatePayload = {
  __typename?: 'ProcessPathSegmentCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employeeDay?: Maybe<ProcessPathEmployeeDay>;
  segment?: Maybe<ProcessPathSegment>;
  userErrors: Array<ProcessPathError>;
};

/** Autogenerated input type of ProcessPathSegmentDelete */
export type ProcessPathSegmentDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  segmentId: Scalars['ID']['input'];
};

/** Autogenerated return type of ProcessPathSegmentDelete. */
export type ProcessPathSegmentDeletePayload = {
  __typename?: 'ProcessPathSegmentDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedSegmentId?: Maybe<Scalars['ID']['output']>;
  userErrors: Array<ProcessPathError>;
};

/** Autogenerated input type of ProcessPathSegmentEdit */
export type ProcessPathSegmentEditInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  endsAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  pathId?: InputMaybe<Scalars['ID']['input']>;
  segmentId: Scalars['ID']['input'];
  startsAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Autogenerated return type of ProcessPathSegmentEdit. */
export type ProcessPathSegmentEditPayload = {
  __typename?: 'ProcessPathSegmentEditPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employeeDay?: Maybe<ProcessPathEmployeeDay>;
  segment?: Maybe<ProcessPathSegment>;
  userErrors: Array<ProcessPathError>;
};

/** Autogenerated input type of ProcessPathSelfAssign */
export type ProcessPathSelfAssignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  pathId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of ProcessPathSelfAssign. */
export type ProcessPathSelfAssignPayload = {
  __typename?: 'ProcessPathSelfAssignPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employeeDay?: Maybe<ProcessPathEmployeeDay>;
  userErrors: Array<ProcessPathError>;
};

/** Autogenerated input type of ProcessPathSelfClockIn */
export type ProcessPathSelfClockInInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of ProcessPathSelfClockIn. */
export type ProcessPathSelfClockInPayload = {
  __typename?: 'ProcessPathSelfClockInPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employeeDay?: Maybe<ProcessPathEmployeeDay>;
  userErrors: Array<ProcessPathError>;
};

/** Autogenerated input type of ProcessPathSelfClockOut */
export type ProcessPathSelfClockOutInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of ProcessPathSelfClockOut. */
export type ProcessPathSelfClockOutPayload = {
  __typename?: 'ProcessPathSelfClockOutPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employeeDay?: Maybe<ProcessPathEmployeeDay>;
  userErrors: Array<ProcessPathError>;
};

/** Autogenerated input type of ProcessPathSelfUnassign */
export type ProcessPathSelfUnassignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of ProcessPathSelfUnassign. */
export type ProcessPathSelfUnassignPayload = {
  __typename?: 'ProcessPathSelfUnassignPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employeeDay?: Maybe<ProcessPathEmployeeDay>;
  userErrors: Array<ProcessPathError>;
};

/** Autogenerated input type of ProcessPathSetAvailability */
export type ProcessPathSetAvailabilityInput = {
  available: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  pathId: Scalars['ID']['input'];
  warehouseId: Scalars['ID']['input'];
};

/** Autogenerated return type of ProcessPathSetAvailability. */
export type ProcessPathSetAvailabilityPayload = {
  __typename?: 'ProcessPathSetAvailabilityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  processPath?: Maybe<ProcessPath>;
  userErrors: Array<ProcessPathError>;
};

/** Autogenerated input type of ProcessPathSetCoverageTarget */
export type ProcessPathSetCoverageTargetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['ISO8601Date']['input'];
  pathId: Scalars['ID']['input'];
  /** Target labour hours; 0 asserts an explicit zero. */
  targetHours: Scalars['Float']['input'];
  warehouseId: Scalars['ID']['input'];
};

/** Autogenerated return type of ProcessPathSetCoverageTarget. */
export type ProcessPathSetCoverageTargetPayload = {
  __typename?: 'ProcessPathSetCoverageTargetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  coverageTarget?: Maybe<ProcessPathCoverageTarget>;
  userErrors: Array<ProcessPathError>;
};

export enum ProcessPathSource {
  /** Self-reported by the associate. */
  Self = 'SELF',
  /** Recorded by a supervisor. */
  Supervisor = 'SUPERVISOR',
  /** From a system signal (scan/WMS). */
  System = 'SYSTEM'
}

export type ProcessPathThroughput = {
  __typename?: 'ProcessPathThroughput';
  accuracy: ProcessPathThroughputAccuracy;
  date: Scalars['ISO8601Date']['output'];
  /** The hours `ratePerHour` divided by. clocked_hours: kiosk-clocked person-hours on this path (`laborHours`). */
  denominator: Scalars['String']['output'];
  /** Person-hours logged on this path. */
  laborHours: Scalars['Float']['output'];
  path: ProcessPath;
  /** `units` per hour of `denominator`. Null when no hours were logged (undefined, not zero). */
  ratePerHour?: Maybe<Scalars['Float']['output']>;
  /** Human label for where the units came from. */
  sourceLabel: Scalars['String']['output'];
  /** Channel split of this row (LD / Ecomm Pick only; empty elsewhere). Sub-row units sum to the parent's. */
  subRows: Array<ProcessPathThroughputSubRow>;
  /**
   * What one of `units` is: sales_units on pick paths (as ordered — a case counts
   * as 1, the demand forecast's basis); handling_units on receive (the receipt
   * line's ordering unit — a case of any size counts as 1; named from the rows'
   * frozen handling_basis); operations on putaway and count.
   */
  unit: Scalars['String']['output'];
  /** Output processed on the day, counted in `unit`. */
  units: Scalars['Float']['output'];
};

export enum ProcessPathThroughputAccuracy {
  /** Derived from an upstream end-state signal. */
  Approximate = 'APPROXIMATE',
  /** Counted from floor-recorded data. */
  Exact = 'EXACT'
}

export type ProcessPathThroughputSubRow = {
  __typename?: 'ProcessPathThroughputSubRow';
  /** Parent labour minutes allocated by line share — an estimate. */
  allocatedLaborMinutes: Scalars['Int']['output'];
  /** How the labour figure was derived: ALLOCATED (estimate); MEASURED arrives later. */
  basis: Scalars['String']['output'];
  /** ld | ecom (labor-lens channel of the pick scans). */
  channel: Scalars['String']['output'];
  /** Equal to units on the sales-unit basis; retained for compatibility. */
  handlingUnits: Scalars['Float']['output'];
  /** Pick lines (scan actions) on the day. */
  lines: Scalars['Int']['output'];
  /** MEASURED active-picking minutes from the confirm stream. Null for a day with no measured signal. */
  measuredLaborMinutes?: Maybe<Scalars['Int']['output']>;
  /**
   * Pick lines of the covered population — same population and window as
   * measuredUnits. Lines/hour measures pick actions; units/hour measures sales units moved.
   */
  measuredLines?: Maybe<Scalars['Int']['output']>;
  /**
   * Sales units of the covered population only (pickers present in the confirm
   * stream that day) — the ONLY valid numerator over measured minutes; some pick
   * flows write no audit rows, so dividing total units by measured minutes
   * overstates pace.
   */
  measuredUnits?: Maybe<Scalars['Float']['output']>;
  /** Sales units (as ordered — a case counts as 1), same basis as the parent row's units and the demand forecast. */
  units: Scalars['Float']['output'];
};

/** Autogenerated input type of ProcessPathUnassign */
export type ProcessPathUnassignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  employeeId: Scalars['ID']['input'];
  warehouseId: Scalars['ID']['input'];
};

/** Autogenerated return type of ProcessPathUnassign. */
export type ProcessPathUnassignPayload = {
  __typename?: 'ProcessPathUnassignPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employeeDay?: Maybe<ProcessPathEmployeeDay>;
  userErrors: Array<ProcessPathError>;
};

/** Autogenerated input type of ProcessPathUpdate */
export type ProcessPathUpdateInput = {
  category?: InputMaybe<ProcessPathCategory>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of ProcessPathUpdate. */
export type ProcessPathUpdatePayload = {
  __typename?: 'ProcessPathUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  processPath?: Maybe<ProcessPath>;
  userErrors: Array<ProcessPathError>;
};

export type ProcessPathValidationError = UserErrorInterface & {
  __typename?: 'ProcessPathValidationError';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type Procurement = {
  __typename?: 'Procurement';
  procurementVendor: ProcurementVendor;
  purchasePrice: Money;
  warehouse: Warehouse;
};

export type ProcurementAiApprovalByType = {
  __typename?: 'ProcurementAiApprovalByType';
  approvedCount: Scalars['Int']['output'];
  interactionType: Scalars['String']['output'];
  /** approved / total * 100; null when there is no feedback yet. */
  ratePercent?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type ProcurementAiApprovalStats = {
  __typename?: 'ProcurementAiApprovalStats';
  approvedCount: Scalars['Int']['output'];
  byInteractionType: Array<ProcurementAiApprovalByType>;
  /** Overall percent of AI interactions approved; null when there is no feedback yet. */
  ratePercent?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type ProcurementAiFeedback = {
  __typename?: 'ProcurementAiFeedback';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** suggested_reply. */
  interactionType: Scalars['String']['output'];
  modelVersion?: Maybe<Scalars['String']['output']>;
  promptVersion?: Maybe<Scalars['String']['output']>;
  /** approved | rejected. */
  verdict: Scalars['String']['output'];
};

/** Autogenerated input type of ProcurementAiFeedbackSubmit */
export type ProcurementAiFeedbackSubmitInput = {
  /** The assessment whose output is being rated (e.g. the current assessment's suggested reply). */
  assessmentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** suggested_reply. */
  interactionType?: InputMaybe<Scalars['String']['input']>;
  trackingId: Scalars['ID']['input'];
  /** approved | rejected. */
  verdict: Scalars['String']['input'];
};

/** Autogenerated return type of ProcurementAiFeedbackSubmit. */
export type ProcurementAiFeedbackSubmitPayload = {
  __typename?: 'ProcurementAiFeedbackSubmitPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  feedback?: Maybe<ProcurementAiFeedback>;
  userErrors: Array<UserError>;
};

/** Autogenerated input type of ProcurementAssessmentSubmit */
export type ProcurementAssessmentSubmitInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** high | medium | low. */
  confidence: Scalars['String']['input'];
  derivedStatus: Scalars['String']['input'];
  exception?: InputMaybe<Scalars['String']['input']>;
  modelVersion?: InputMaybe<Scalars['String']['input']>;
  needsReply: Scalars['Boolean']['input'];
  promptVersion?: InputMaybe<Scalars['String']['input']>;
  statusRevision?: InputMaybe<Scalars['Int']['input']>;
  suggestedReply?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  supportingMessageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  trackingId: Scalars['ID']['input'];
  triggeredByGmailMessageId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ProcurementAssessmentSubmit. */
export type ProcurementAssessmentSubmitPayload = {
  __typename?: 'ProcurementAssessmentSubmitPayload';
  assessment?: Maybe<ProcurementPoStatusAssessment>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  poTracking?: Maybe<ProcurementPoTracking>;
  userErrors: Array<UserError>;
};

/** Autogenerated input type of ProcurementCorrespondenceCommand */
export type ProcurementCorrespondenceCommandInput = {
  action: Scalars['String']['input'];
  base64?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  ccAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  draftId?: InputMaybe<Scalars['ID']['input']>;
  explanation?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  profileVersion?: InputMaybe<Scalars['String']['input']>;
  replyAll?: InputMaybe<Scalars['Boolean']['input']>;
  replyMessageId?: InputMaybe<Scalars['ID']['input']>;
  reviewedRevision?: InputMaybe<Scalars['Int']['input']>;
  revision?: InputMaybe<Scalars['Int']['input']>;
  sendId?: InputMaybe<Scalars['ID']['input']>;
  session?: InputMaybe<Scalars['String']['input']>;
  signature?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  takeover?: InputMaybe<Scalars['Boolean']['input']>;
  threadId?: InputMaybe<Scalars['ID']['input']>;
  toAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
  uploadIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of ProcurementCorrespondenceCommand. */
export type ProcurementCorrespondenceCommandPayload = {
  __typename?: 'ProcurementCorrespondenceCommandPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  draft?: Maybe<ProcurementMailDraft>;
  errors: Array<ProcurementCorrespondenceError>;
  profile?: Maybe<ProcurementSenderProfile>;
  reference?: Maybe<ProcurementMailReference>;
  sendRecord?: Maybe<ProcurementMailSend>;
  thread?: Maybe<ProcurementEmailThread>;
  upload?: Maybe<ProcurementMailUpload>;
};

export type ProcurementCorrespondenceError = {
  __typename?: 'ProcurementCorrespondenceError';
  code: Scalars['String']['output'];
  current?: Maybe<Scalars['JSON']['output']>;
  message: Scalars['String']['output'];
};

export type ProcurementEmailAttachment = {
  __typename?: 'ProcurementEmailAttachment';
  contentId?: Maybe<Scalars['String']['output']>;
  disposition?: Maybe<Scalars['String']['output']>;
  filename: Scalars['String']['output'];
  gmailAttachmentId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** po_pdf | bol | order_confirmation | other. */
  kind: Scalars['String']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  sizeBytes?: Maybe<Scalars['BigInt']['output']>;
  storageError?: Maybe<Scalars['String']['output']>;
};

export type ProcurementEmailAttachmentInput = {
  filename: Scalars['String']['input'];
  gmailAttachmentId?: InputMaybe<Scalars['String']['input']>;
  /** po_pdf | bol | order_confirmation | other; the AI parser classifies at ingest. Defaults to other. */
  kind?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  s3ObjectKey?: InputMaybe<Scalars['String']['input']>;
  sizeBytes?: InputMaybe<Scalars['BigInt']['input']>;
};

export type ProcurementEmailMessage = {
  __typename?: 'ProcurementEmailMessage';
  attachments: Array<ProcurementEmailAttachment>;
  bodyHtml?: Maybe<Scalars['String']['output']>;
  bodyText?: Maybe<Scalars['String']['output']>;
  ccAddresses: Array<Scalars['String']['output']>;
  /** inbound | outbound. */
  direction: Scalars['String']['output'];
  fromAddress?: Maybe<Scalars['String']['output']>;
  gmailMessageId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  provenance: Scalars['String']['output'];
  replyToAddresses: Array<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  sentByAuth0Id?: Maybe<Scalars['String']['output']>;
  snippet?: Maybe<Scalars['String']['output']>;
  toAddresses: Array<Scalars['String']['output']>;
};

export type ProcurementEmailMessageInput = {
  attachments?: InputMaybe<Array<ProcurementEmailAttachmentInput>>;
  bodyHtml?: InputMaybe<Scalars['String']['input']>;
  bodyText?: InputMaybe<Scalars['String']['input']>;
  ccAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
  /** inbound | outbound. */
  direction: Scalars['String']['input'];
  fromAddress?: InputMaybe<Scalars['String']['input']>;
  gmailMessageId: Scalars['String']['input'];
  inReplyTo?: InputMaybe<Scalars['String']['input']>;
  rfcMessageId?: InputMaybe<Scalars['String']['input']>;
  sentAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  snippet?: InputMaybe<Scalars['String']['input']>;
  toAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProcurementEmailThread = {
  __typename?: 'ProcurementEmailThread';
  correspondenceRevision: Scalars['Int']['output'];
  draft?: Maybe<ProcurementMailDraft>;
  firstMessageAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  gmailThreadId: Scalars['String']['output'];
  /**
   * True when at least one message on the thread came from a non-Odeko sender that
   * is not a bounce notice — the per-thread form of the inbound-coverage metric. A
   * vendor autoresponder counts.
   */
  hasVendorReply: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  ingestionError?: Maybe<Scalars['String']['output']>;
  lastMessageAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  mailbox: Scalars['String']['output'];
  /** pending | matched | unmatched | dismissed | ignored. */
  matchState: Scalars['String']['output'];
  messagePage: ProcurementMailMessagePage;
  messages: Array<ProcurementEmailMessage>;
  /** Links to trackings, including AI-proposed ones awaiting confirmation. */
  poLinks: Array<ProcurementPoThreadLink>;
  processingError?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<ProcurementMailReference>;
  sends: Array<ProcurementMailSend>;
  subject?: Maybe<Scalars['String']['output']>;
  /**
   * human | ai — what caused the last triage. Null on threads not yet triaged, on
   * threads matched through a link (matching is not a triage decision), and on
   * threads predating attribution.
   */
  triageCause?: Maybe<Scalars['String']['output']>;
  /**
   * When triage last set matchState. Null on threads not yet triaged, on threads
   * matched through a link, and on threads predating attribution.
   */
  triagedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * Auth0 sub of the human who last triaged the thread. Null on the AI path, on
   * threads not yet triaged, on threads matched through a link, and on threads
   * predating attribution.
   */
  triagedByAuth0Id?: Maybe<Scalars['String']['output']>;
  /** Display name of that human, or null when there is none or the sub can't be resolved to a user. */
  triagedByName?: Maybe<Scalars['String']['output']>;
  unread: Scalars['Boolean']['output'];
  workflowHistory: Scalars['JSON']['output'];
  workflowRevision: Scalars['Int']['output'];
  workflowState: Scalars['String']['output'];
};


export type ProcurementEmailThreadMessagePageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of ProcurementEmailThreadUpsert */
export type ProcurementEmailThreadUpsertInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  firstMessageAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  gmailThreadId: Scalars['String']['input'];
  lastMessageAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  mailbox: Scalars['String']['input'];
  messages?: InputMaybe<Array<ProcurementEmailMessageInput>>;
  participants?: InputMaybe<Array<Scalars['String']['input']>>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ProcurementEmailThreadUpsert. */
export type ProcurementEmailThreadUpsertPayload = {
  __typename?: 'ProcurementEmailThreadUpsertPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Gmail ids of messages genuinely new to this upsert (empty on pure redelivery). */
  newGmailMessageIds: Array<Scalars['String']['output']>;
  thread?: Maybe<ProcurementEmailThread>;
  userErrors: Array<UserError>;
};

export type ProcurementInboundCoverageByVendor = {
  __typename?: 'ProcurementInboundCoverageByVendor';
  coveredCount: Scalars['Int']['output'];
  /** covered / total * 100; null when this vendor has no confirmed-linked threads. */
  ratePercent?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
  vendorId: Scalars['ID']['output'];
  vendorName: Scalars['String']['output'];
};

export type ProcurementInboundCoverageByWeek = {
  __typename?: 'ProcurementInboundCoverageByWeek';
  /**
   * False for the week still in progress: its threads have had days rather than a
   * week to collect a reply, so the bucket reads low for a reason that is not
   * about vendors. Chart it as provisional, never as a decline.
   */
  complete: Scalars['Boolean']['output'];
  coveredCount: Scalars['Int']['output'];
  /** covered / total * 100; null when no confirmed-linked thread opened that week. */
  ratePercent?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
  /** Monday of the week the thread's first message landed. */
  weekStart: Scalars['ISO8601Date']['output'];
};

export type ProcurementInboundCoverageStats = {
  __typename?: 'ProcurementInboundCoverageStats';
  /**
   * Per-vendor coverage, counted per (vendor, thread). Does not sum to
   * coveredCount/totalCount: a tracking with no vendor matched yet is excluded,
   * and a thread spanning two vendors' POs counts for both.
   */
  byVendor: Array<ProcurementInboundCoverageByVendor>;
  /**
   * Coverage trend over the shadow period, bucketed on the week each thread
   * opened. The newest bucket is still filling: read its complete flag before quoting it.
   */
  byWeek: Array<ProcurementInboundCoverageByWeek>;
  /**
   * Confirmed-linked threads carrying at least one message from a non-Odeko sender
   * that is not a bounce notice. Settled threads only: those whose first message
   * is at least 8 days old.
   */
  coveredCount: Scalars['Int']['output'];
  /**
   * Overall percent of settled PO threads (first message at least 8 days old) that
   * ever heard back from outside Odeko; null when nothing is linked yet.
   */
  ratePercent?: Maybe<Scalars['Float']['output']>;
  /**
   * Confirmed-linked threads in the window — the coverage denominator. Settled
   * threads only: a thread whose first message is under 8 days old is left out of
   * every count here, because it has not had time to hear back and the Phase-1
   * baseline measured settled threads.
   */
  totalCount: Scalars['Int']['output'];
};

export type ProcurementInboxPage = {
  __typename?: 'ProcurementInboxPage';
  drafts: Array<ProcurementMailDraft>;
  nextCursor?: Maybe<Scalars['String']['output']>;
  senderProfile?: Maybe<ProcurementSenderProfile>;
  sendingEnabled: Scalars['Boolean']['output'];
  sends: Array<ProcurementMailSend>;
  threads: Array<ProcurementEmailThread>;
};

export type ProcurementInput = {
  procurementVendorId: Scalars['ID']['input'];
  purchasePrice: MoneyInput;
  warehouseId: Scalars['ID']['input'];
};

export type ProcurementMailDraft = {
  __typename?: 'ProcurementMailDraft';
  body: Scalars['String']['output'];
  ccAddresses: Array<Scalars['String']['output']>;
  creatorAuth0Id: Scalars['String']['output'];
  editorAuth0Id?: Maybe<Scalars['String']['output']>;
  editorName?: Maybe<Scalars['String']['output']>;
  editorSession?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  leaseExpiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  lockVersion: Scalars['Int']['output'];
  replyMessageId?: Maybe<Scalars['ID']['output']>;
  reviewedRevision: Scalars['Int']['output'];
  subject: Scalars['String']['output'];
  submittedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  threadId?: Maybe<Scalars['ID']['output']>;
  toAddresses: Array<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  uploadIds: Array<Scalars['ID']['output']>;
  uploads: Array<ProcurementMailUpload>;
};

export type ProcurementMailMessagePage = {
  __typename?: 'ProcurementMailMessagePage';
  items: Array<ProcurementEmailMessage>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type ProcurementMailReference = {
  __typename?: 'ProcurementMailReference';
  body?: Maybe<Scalars['String']['output']>;
  failureCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  revision: Scalars['Int']['output'];
  state: Scalars['String']['output'];
};

export type ProcurementMailSend = {
  __typename?: 'ProcurementMailSend';
  acceptedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  actorAuth0Id: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  draftId: Scalars['ID']['output'];
  failureCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  snapshot: Scalars['JSON']['output'];
  state: Scalars['String']['output'];
  threadId?: Maybe<Scalars['ID']['output']>;
};

export type ProcurementMailUpload = {
  __typename?: 'ProcurementMailUpload';
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  sha256: Scalars['String']['output'];
  sizeBytes: Scalars['Int']['output'];
};

/** Autogenerated input type of ProcurementMailboxCursorSet */
export type ProcurementMailboxCursorSetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  historyId: Scalars['String']['input'];
  mailbox: Scalars['String']['input'];
};

/** Autogenerated return type of ProcurementMailboxCursorSet. */
export type ProcurementMailboxCursorSetPayload = {
  __typename?: 'ProcurementMailboxCursorSetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  lastHistoryId?: Maybe<Scalars['String']['output']>;
  mailbox?: Maybe<Scalars['String']['output']>;
  userErrors: Array<UserError>;
};

export type ProcurementPoNote = {
  __typename?: 'ProcurementPoNote';
  /** Auth0 sub of the author. */
  author: Scalars['String']['output'];
  /** Display name of the author, or null when the sub can't be resolved to a user. */
  authorName?: Maybe<Scalars['String']['output']>;
  body: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** phone_call | in_person | other. */
  noteType: Scalars['String']['output'];
  occurredAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of ProcurementPoNoteCreate */
export type ProcurementPoNoteCreateInput = {
  body: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** phone_call | in_person | other. */
  noteType: Scalars['String']['input'];
  occurredAt: Scalars['ISO8601DateTime']['input'];
  trackingId: Scalars['ID']['input'];
};

/** Autogenerated return type of ProcurementPoNoteCreate. */
export type ProcurementPoNoteCreatePayload = {
  __typename?: 'ProcurementPoNoteCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  note?: Maybe<ProcurementPoNote>;
  userErrors: Array<UserError>;
};

export type ProcurementPoStatusAssessment = {
  __typename?: 'ProcurementPoStatusAssessment';
  /** Whether this assessment moved tracking_status. */
  applied: Scalars['Boolean']['output'];
  /** high | medium | low. */
  confidence: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  derivedStatus: Scalars['String']['output'];
  exception?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  modelVersion?: Maybe<Scalars['String']['output']>;
  needsReply: Scalars['Boolean']['output'];
  promptVersion?: Maybe<Scalars['String']['output']>;
  suggestedReply?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
};

export type ProcurementPoThreadLink = {
  __typename?: 'ProcurementPoThreadLink';
  confidence?: Maybe<Scalars['Float']['output']>;
  /** Auth0 sub of the confirming human; null for auto-confirmed sources. */
  confirmedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** subject_po_number | pdf_extract | ai_inference | manual. */
  matchSource: Scalars['String']['output'];
  /** PO number (tranId) of the linked tracking's projection row. */
  poNumber?: Maybe<Scalars['String']['output']>;
  /** proposed | confirmed | rejected. */
  status: Scalars['String']['output'];
  thread: ProcurementEmailThread;
};

export type ProcurementPoTracking = {
  __typename?: 'ProcurementPoTracking';
  assignedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Auth0 sub of the assignee. */
  assignee?: Maybe<Scalars['String']['output']>;
  /** When the PO was created in NetSuite. */
  createdDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  /** Latest assessment (applied or not). */
  currentAssessment?: Maybe<ProcurementPoStatusAssessment>;
  /** pickup (Odeko-routed) | delivery (vendor-routed) | unknown. Picks the lifecycle branch. */
  deliveryType: Scalars['String']['output'];
  /** unset | vendor_default | ai | human — what set deliveryType. Precedence: human > ai > vendor_default > unset. */
  deliveryTypeSource: Scalars['String']['output'];
  dueDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** partial | oos | delayed | canceled; null when none. */
  exception?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  memo?: Maybe<Scalars['String']['output']>;
  needsReply: Scalars['Boolean']['output'];
  /** NetSuite internal id of the projected PO, for deep links. */
  netsuiteInternalId?: Maybe<Scalars['String']['output']>;
  /** NetSuite status label (e.g. "Pending Receipt"). */
  netsuiteStatus?: Maybe<Scalars['String']['output']>;
  /** Link that opens the PO in the NetSuite UI; null when this environment has no NetSuite account configured. */
  netsuiteUrl?: Maybe<Scalars['String']['output']>;
  orderDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** NetSuite tranId. */
  poNumber?: Maybe<Scalars['String']['output']>;
  /** When the PO was first sent to the vendor: the earliest awaiting_response transition, not the thread's first message. */
  sentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Capture before assessment work and submit unchanged so later corrections invalidate stale results. */
  statusRevision: Scalars['Int']['output'];
  /** ai | human | system. */
  statusSource: Scalars['String']['output'];
  statusUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  threadLinks: Array<ProcurementPoThreadLink>;
  /** Messages across confirmed-linked threads + offline notes + status transitions, time-sorted. */
  timeline: Array<ProcurementTimelineEntry>;
  total?: Maybe<Scalars['Float']['output']>;
  /**
   * pending_vendor_comms | awaiting_response | order_processed |
   * transportation_criteria_pending | transportation_scheduling |
   * vendor_scheduled_to_ship | in_transit | partially_received | received.
   * Tool-owned and monotonic; branched by deliveryType (order_processed is
   * vendor-routed, the two transportation stages are Odeko-routed).
   * partially_received is set only by NetSuite reconciliation. "Exception Review"
   * is not a status — it is a display label for needsReply/exception over whatever
   * stage the PO is actually at.
   */
  trackingStatus: Scalars['String']['output'];
  vendor?: Maybe<ProcurementTrackingVendor>;
  /** Vendor/entity name on the NetSuite PO. */
  vendorName?: Maybe<Scalars['String']['output']>;
  /**
   * Which side owes the next move. ODEKO when needsReply is set, VENDOR when we
   * reached them last and nothing has come back, NONE when closed (and needsReply
   * is false) or no vendor-facing mail has happened yet. Derived from the
   * confirmed threads; internal-only mail moves it neither way.
   */
  waitingOn: ProcurementWaitingOn;
  warehouseName?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ProcurementPoTrackingAssign */
export type ProcurementPoTrackingAssignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ProcurementPoTrackingAssign. */
export type ProcurementPoTrackingAssignPayload = {
  __typename?: 'ProcurementPoTrackingAssignPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  poTracking?: Maybe<ProcurementPoTracking>;
  userErrors: Array<UserError>;
};

/** Autogenerated input type of ProcurementPoTrackingEnsure */
export type ProcurementPoTrackingEnsureInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  poNumber: Scalars['String']['input'];
};

/** Autogenerated return type of ProcurementPoTrackingEnsure. */
export type ProcurementPoTrackingEnsurePayload = {
  __typename?: 'ProcurementPoTrackingEnsurePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  poTracking?: Maybe<ProcurementPoTracking>;
  userErrors: Array<UserError>;
};

/** Autogenerated input type of ProcurementPoTrackingUpdate */
export type ProcurementPoTrackingUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deliveryType?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  needsReply?: InputMaybe<Scalars['Boolean']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of ProcurementPoTrackingUpdate. */
export type ProcurementPoTrackingUpdatePayload = {
  __typename?: 'ProcurementPoTrackingUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  poTracking?: Maybe<ProcurementPoTracking>;
  userErrors: Array<UserError>;
};

export type ProcurementSenderProfile = {
  __typename?: 'ProcurementSenderProfile';
  displayName: Scalars['String']['output'];
  signature: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type ProcurementStatusEvent = {
  __typename?: 'ProcurementStatusEvent';
  /** Auth0 sub when cause is human_override. */
  actor?: Maybe<Scalars['String']['output']>;
  /** ai_assessment | human_override | system. */
  cause: Scalars['String']['output'];
  fromStatus: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  occurredAt: Scalars['ISO8601DateTime']['output'];
  toStatus: Scalars['String']['output'];
};

/** Autogenerated input type of ProcurementStatusOverride */
export type ProcurementStatusOverrideInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
  trackingId: Scalars['ID']['input'];
};

/** Autogenerated return type of ProcurementStatusOverride. */
export type ProcurementStatusOverridePayload = {
  __typename?: 'ProcurementStatusOverridePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  poTracking?: Maybe<ProcurementPoTracking>;
  userErrors: Array<UserError>;
};

/** Autogenerated input type of ProcurementThreadAssignToPo */
export type ProcurementThreadAssignToPoInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  threadId: Scalars['ID']['input'];
  trackingId: Scalars['ID']['input'];
};

/** Autogenerated return type of ProcurementThreadAssignToPo. */
export type ProcurementThreadAssignToPoPayload = {
  __typename?: 'ProcurementThreadAssignToPoPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  link?: Maybe<ProcurementPoThreadLink>;
  userErrors: Array<UserError>;
};

/** Autogenerated input type of ProcurementThreadLinkConfirm */
export type ProcurementThreadLinkConfirmInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  linkId: Scalars['ID']['input'];
};

/** Autogenerated return type of ProcurementThreadLinkConfirm. */
export type ProcurementThreadLinkConfirmPayload = {
  __typename?: 'ProcurementThreadLinkConfirmPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  link?: Maybe<ProcurementPoThreadLink>;
  userErrors: Array<UserError>;
};

/** Autogenerated input type of ProcurementThreadLinkCreate */
export type ProcurementThreadLinkCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  confidence?: InputMaybe<Scalars['Float']['input']>;
  evidenceGmailMessageId?: InputMaybe<Scalars['String']['input']>;
  gmailThreadId: Scalars['String']['input'];
  /** subject_po_number | pdf_extract | ai_inference. */
  matchSource: Scalars['String']['input'];
  poNumber: Scalars['String']['input'];
};

/** Autogenerated return type of ProcurementThreadLinkCreate. */
export type ProcurementThreadLinkCreatePayload = {
  __typename?: 'ProcurementThreadLinkCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  link?: Maybe<ProcurementPoThreadLink>;
  userErrors: Array<UserError>;
};

/** Autogenerated input type of ProcurementThreadTriageSet */
export type ProcurementThreadTriageSetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  gmailThreadId?: InputMaybe<Scalars['String']['input']>;
  /** unmatched | dismissed | ignored. */
  state: Scalars['String']['input'];
  threadId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of ProcurementThreadTriageSet. */
export type ProcurementThreadTriageSetPayload = {
  __typename?: 'ProcurementThreadTriageSetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  thread?: Maybe<ProcurementEmailThread>;
  userErrors: Array<UserError>;
};

export type ProcurementTimelineEntry = ProcurementEmailMessage | ProcurementPoNote | ProcurementStatusEvent;

export type ProcurementTrackingVendor = {
  __typename?: 'ProcurementTrackingVendor';
  address?: Maybe<Scalars['String']['output']>;
  aiInstructions?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  communicationStyle?: Maybe<Scalars['String']['output']>;
  contacts: Array<ProcurementVendorContact>;
  deliveryMode: Scalars['String']['output'];
  followUpSensitivity?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  leadTimeDays?: Maybe<Scalars['Int']['output']>;
  minOrderCents?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  netsuiteEntityInternalId?: Maybe<Scalars['String']['output']>;
  norms: Array<ProcurementVendorNorm>;
  notes?: Maybe<Scalars['String']['output']>;
  portalVendor: Scalars['Boolean']['output'];
  preferredChannel?: Maybe<Scalars['String']['output']>;
  responseTimeExpectation?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ProcurementTrackingVendorUpsert */
export type ProcurementTrackingVendorUpsertInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  aiInstructions?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  communicationStyle?: InputMaybe<Scalars['String']['input']>;
  contacts?: InputMaybe<Array<ProcurementVendorContactInput>>;
  deliveryMode?: InputMaybe<Scalars['String']['input']>;
  followUpSensitivity?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  leadTimeDays?: InputMaybe<Scalars['Int']['input']>;
  minOrderCents?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  norms?: InputMaybe<Array<ProcurementVendorNormInput>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  portalVendor?: InputMaybe<Scalars['Boolean']['input']>;
  preferredChannel?: InputMaybe<Scalars['String']['input']>;
  responseTimeExpectation?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ProcurementTrackingVendorUpsert. */
export type ProcurementTrackingVendorUpsertPayload = {
  __typename?: 'ProcurementTrackingVendorUpsertPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userErrors: Array<UserError>;
  vendor?: Maybe<ProcurementTrackingVendor>;
};

export type ProcurementVendor = {
  __typename?: 'ProcurementVendor';
  /** The procurement vendor UUID */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ProcurementVendorContact = {
  __typename?: 'ProcurementVendorContact';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isPrimary: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type ProcurementVendorContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type ProcurementVendorNorm = {
  __typename?: 'ProcurementVendorNorm';
  id: Scalars['ID']['output'];
  /** norm (human-authored rule) or quirk (learned behavior). */
  kind: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  rule: Scalars['String']['output'];
};

export type ProcurementVendorNormInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  /** norm (human-authored rule) or quirk (learned behavior). */
  kind: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  rule: Scalars['String']['input'];
};

export enum ProcurementWaitingOn {
  /** Nothing outstanding on either side. */
  None = 'NONE',
  /** The vendor is owed a reply from us. */
  Odeko = 'ODEKO',
  /** We reached the vendor last and nothing has come back. */
  Vendor = 'VENDOR'
}

export type ProductInventory = {
  __typename?: 'ProductInventory';
  /**
   * on hand count = amount physically on our shelves in the warehouse
   *
   * available count = on hand count - amount already committed to orders in netsuite = amount available for ordering
   */
  availableCount?: Maybe<Scalars['Int']['output']>;
  warehouse: Warehouse;
};

export type Profile = {
  __typename?: 'Profile';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PromoPageDetails = {
  __typename?: 'PromoPageDetails';
  customDescription?: Maybe<Scalars['String']['output']>;
  customName?: Maybe<Scalars['String']['output']>;
  desktopHeroImageUrl: Scalars['String']['output'];
  mobileHeroImageUrl: Scalars['String']['output'];
  shippingDesktopHeroImageUrl?: Maybe<Scalars['String']['output']>;
  shippingMobileHeroImageUrl?: Maybe<Scalars['String']['output']>;
};

export type PromotionPage = {
  __typename?: 'PromotionPage';
  collection: Collection;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sections?: Maybe<Array<Maybe<PromotionPageSection>>>;
  slug: Scalars['String']['output'];
};

/** Relay-style cursor-based pagination structure for Categories */
export type PromotionPageConnection = {
  __typename?: 'PromotionPageConnection';
  edges: Array<Maybe<PromotionPageEdge>>;
  nodes: Array<Maybe<PromotionPage>>;
  pageInfo: PageInfo;
};

export type PromotionPageEdge = {
  __typename?: 'PromotionPageEdge';
  cursor: Scalars['String']['output'];
  node: PromotionPage;
};

export type PromotionPageFiltersInput = {
  isActive?: InputMaybe<FiltersBooleanInput>;
  name?: InputMaybe<FiltersStringInput>;
  slug?: InputMaybe<FiltersStringInput>;
  warehouseId?: InputMaybe<FiltersStringInput>;
};

export type PromotionPageSection = {
  __typename?: 'PromotionPageSection';
  component: PromotionPageSectionComponent;
  content?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  section: PromotionPageSectionSection;
};

export enum PromotionPageSectionComponent {
  Description = 'DESCRIPTION',
  Headline = 'HEADLINE',
  Image = 'IMAGE',
  MobileImage = 'MOBILE_IMAGE'
}

export enum PromotionPageSectionSection {
  Hero = 'HERO'
}

export enum PromotionPageSortOrder {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

export type ProspectiveLocation = {
  __typename?: 'ProspectiveLocation';
  address?: Maybe<Scalars['String']['output']>;
  createdBy: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  odekoUuid: Scalars['ID']['output'];
  warehouseId: Scalars['ID']['output'];
};

/** The provider's order for one delivery stop on a marked route. */
export type ProviderDelivery = {
  __typename?: 'ProviderDelivery';
  /** Whether a courier is on this delivery: a courier name is known, or the provider's status is at or past driver_assigned. */
  courierAssigned: Scalars['Boolean']['output'];
  /** The assigned courier's name, when the provider has given one. */
  courierName?: Maybe<Scalars['String']['output']>;
  /** The number the provider gives the store for reaching the courier. The customer-facing number is never exposed. */
  courierPhone?: Maybe<Scalars['String']['output']>;
  /** The provider's estimate for the courier reaching the stop. */
  dropoffEta?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The provider's order id for this stop. Null while the order is still being created. */
  externalOrderId?: Maybe<Scalars['String']['output']>;
  /** Whether something only a person can resolve, in the provider's dashboard, happened to this stop. */
  needsAttention: Scalars['Boolean']['output'];
  /** Why needsAttention is set. Null when it is not. */
  needsAttentionReason?: Maybe<Scalars['String']['output']>;
  /** The provider's estimate for the courier reaching the warehouse. */
  pickupEta?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Photo and signature urls from the provider's proof of pickup and delivery. Empty until the provider sends any. */
  proofUrls: Array<Scalars['String']['output']>;
  /** The provider's delivery status for this stop, verbatim. Null until the provider has started a delivery. */
  status?: Maybe<Scalars['String']['output']>;
  /** The provider's tracking page for this delivery. */
  trackingUrl?: Maybe<Scalars['String']['output']>;
};

/**
 * A route's dispatch to a third-party provider (epic sc-66318). The DMP keys
 * presence of this field on Route.thirdPartyRoute, not on any particular status: a
 * canceled or push_failed row is still returned, with error set.
 */
export type ProviderDispatch = {
  __typename?: 'ProviderDispatch';
  /**
   * The quote the route was dispatched against, while the dispatch is dispatched,
   * in_progress or completed. Null before dispatch and after a refused dispatch.
   * For a dispatch made outside the DMP, only id is known.
   */
  chosenQuote?: Maybe<ProviderQuote>;
  /**
   * When the status poll sent the no-courier alert for this route. Set as the
   * alert is posted and cleared if no channel took it, so a value read during a
   * failed post can be gone on the next read. Null again after a rerouted delivery
   * re-arms the alert. A courier being assigned does not clear it.
   */
  courierAlertSentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Why the last push, quote or dispatch failed, or that the provider canceled the route. Null when nothing went wrong. */
  error?: Maybe<Scalars['String']['output']>;
  /** The provider's own id for the route created there. Null until the push has created it. */
  externalRouteId?: Maybe<Scalars['String']['output']>;
  /** When the courier was asked to collect, in the route's warehouse time zone. Null means ASAP. */
  pickupAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The quotes the provider returned for the route. Empty until the dispatch is quoted. */
  quotes: Array<ProviderQuote>;
  status: ProviderDispatchStatus;
};

/** Lifecycle status of a third_party_route_dispatches row (epic sc-66318). */
export enum ProviderDispatchStatus {
  /** Unmarked, or canceled upstream. */
  Canceled = 'canceled',
  /** Every stop on the dispatch reached a final outcome that LDS acted on: delivered, or failed with a delivery issue raised. */
  Completed = 'completed',
  /** A GM dispatched against a chosen quote and the provider has not confirmed yet; locked from further edits. */
  Dispatched = 'dispatched',
  /** The provider confirmed the dispatch: its route is underway. */
  InProgress = 'in_progress',
  /** The push failed and was compensated; the route is editable again. */
  PushFailed = 'push_failed',
  /** The push worker is creating the provider's orders and route. */
  Pushing = 'pushing',
  /** Quoting failed. */
  QuoteFailed = 'quote_failed',
  /** Quotes are in; waiting on a GM to dispatch against one. */
  Quoted = 'quoted',
  /** The provider's route exists; waiting on its quotes. */
  Quoting = 'quoting'
}

export type ProviderNotAvailable = UserErrorInterface & {
  __typename?: 'ProviderNotAvailable';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** One provider's price for a whole marked route, as the provider returned it. */
export type ProviderQuote = {
  __typename?: 'ProviderQuote';
  /** The courier's price in cents, excluding the provider's own fee. */
  cost?: Maybe<Scalars['Int']['output']>;
  /** When the quote stops being dispatchable. Null means the provider states no expiry. */
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The provider's own fee in cents. */
  fee?: Maybe<Scalars['Int']['output']>;
  /** The provider's own id for this quote; dispatching names it. */
  id: Scalars['String']['output'];
  /** Which courier network quoted, as the provider names it. */
  provider?: Maybe<Scalars['String']['output']>;
};

export type ProviderRejected = UserErrorInterface & {
  __typename?: 'ProviderRejected';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type ProviderRouteGuarded = UserErrorInterface & {
  __typename?: 'ProviderRouteGuarded';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export enum PsLocationMembershipStatusTier {
  /** Required minimum spend, no discounts, standard order cut-off time */
  Basic = 'basic',
  /** No minimum spend, no discounts, standard order cut-off time */
  Bronze = 'bronze',
  /** Displays spend tracker. No minimum spend, no discounts, standarded cut-off time. */
  ConsideringMembership = 'considering_membership',
  /** Excluded from the Membership Tier rules */
  Exclude = 'exclude',
  /** No minimum spend, higher discount, later order cut-off time */
  Gold = 'gold',
  /** No minimum spend, lower discount, standard order cut-off time */
  Silver = 'silver'
}

export type PublicDockArrival = {
  __typename?: 'PublicDockArrival';
  carrierName?: Maybe<Scalars['String']['output']>;
  /** When the truck currently on site for this appointment checked in. Null if nothing is currently checked in against it. */
  checkedInAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Appointment reference for confirmations. */
  confirmationNumber?: Maybe<Scalars['String']['output']>;
  /** Contact person for the delivery. */
  contactName?: Maybe<Scalars['String']['output']>;
  freightType: FreightType;
  /** Source warehouse a transfer order is arriving from, matched by reference number; null for non-transfer bookings. */
  originName?: Maybe<Scalars['String']['output']>;
  /** Number of pallets on the shipment. */
  palletCount?: Maybe<Scalars['Int']['output']>;
  referenceNumber: Scalars['String']['output'];
  /** Standard Carrier Alpha Code. */
  scacCode?: Maybe<Scalars['String']['output']>;
  slotEndsAt: Scalars['ISO8601DateTime']['output'];
  /** Slot start in warehouse-local time. */
  slotLabel: Scalars['String']['output'];
  slotStartsAt: Scalars['ISO8601DateTime']['output'];
  /** Truck or trailer number. */
  truckNumber?: Maybe<Scalars['String']['output']>;
  /** Vendor/entity on the PO matched by reference number, if any. */
  vendorName?: Maybe<Scalars['String']['output']>;
  /** Shipment weight in pounds. */
  weightLbs?: Maybe<Scalars['Float']['output']>;
};

export type PublicDockBooking = {
  __typename?: 'PublicDockBooking';
  /** Open slots on `date` for the chosen `freightType`. */
  availableSlots: Array<PublicDockSlot>;
  /** Weekdays the warehouse takes no bookings (Ruby wday: 0=Sunday..6=Saturday, warehouse-local); empty means open every day. */
  blockedBookingWeekdays: Array<Scalars['Int']['output']>;
  carrierName?: Maybe<Scalars['String']['output']>;
  /** Notes or special instructions for the delivery. */
  comments?: Maybe<Scalars['String']['output']>;
  /** Email the booking confirmation is sent to. */
  confirmationEmail?: Maybe<Scalars['String']['output']>;
  /** Appointment reference for confirmations. */
  confirmationNumber?: Maybe<Scalars['String']['output']>;
  /** Contact email for the delivery. */
  contactEmail?: Maybe<Scalars['String']['output']>;
  /** Contact person for the delivery. */
  contactName?: Maybe<Scalars['String']['output']>;
  /** Contact phone for the delivery. */
  contactPhone?: Maybe<Scalars['String']['output']>;
  /** How the delivery is prioritized. */
  deliveryType?: Maybe<DeliveryType>;
  /** Assigned dock door, set once booked. */
  dockName?: Maybe<Scalars['String']['output']>;
  expectedDate?: Maybe<Scalars['ISO8601Date']['output']>;
  freightType?: Maybe<FreightType>;
  /** Source warehouse a transfer order is arriving from; null for non-transfer bookings. */
  originName?: Maybe<Scalars['String']['output']>;
  /** Number of pallets on the shipment. */
  palletCount?: Maybe<Scalars['Int']['output']>;
  /** Carrier PRO (tracking) number. */
  proNumber?: Maybe<Scalars['String']['output']>;
  referenceNumber: Scalars['String']['output'];
  /**
   * Reference of the booking that already rebooked this missed/cancelled delivery;
   * set once recovered so the portal can hide the rebook action. Null when not yet recovered.
   */
  rescheduledToReference?: Maybe<Scalars['String']['output']>;
  /** Standard Carrier Alpha Code. */
  scacCode?: Maybe<Scalars['String']['output']>;
  /** Date the freight ships (distinct from the appointment date). */
  shipDate?: Maybe<Scalars['ISO8601Date']['output']>;
  slotEndsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  slotLabel?: Maybe<Scalars['String']['output']>;
  slotStartsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: DockBookingStatus;
  /** Truck or trailer number. */
  truckNumber?: Maybe<Scalars['String']['output']>;
  /**
   * Id of the warehouse the delivery is going to; set for override bookings so the
   * vendor portal can show the delivery's fixed warehouse when amending.
   */
  warehouseId?: Maybe<Scalars['ID']['output']>;
  warehouseName: Scalars['String']['output'];
  /** IANA zone; all labels are in this zone. */
  warehouseTimeZone: Scalars['String']['output'];
  /** Shipment weight in pounds. */
  weightLbs?: Maybe<Scalars['Float']['output']>;
  /** Slot length in minutes once booked (null until a freight type is set). */
  windowMinutes?: Maybe<Scalars['Int']['output']>;
};


export type PublicDockBookingAvailableSlotsArgs = {
  date: Scalars['ISO8601Date']['input'];
  freightType: FreightType;
  scacCode?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of PublicDockBookingCancel */
export type PublicDockBookingCancelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  referenceNumber: Scalars['String']['input'];
};

/** Autogenerated return type of PublicDockBookingCancel. */
export type PublicDockBookingCancelPayload = {
  __typename?: 'PublicDockBookingCancelPayload';
  booking?: Maybe<PublicDockBooking>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userErrors: Array<DockBookingError>;
};

/** Autogenerated input type of PublicDockBookingSubmit */
export type PublicDockBookingSubmitInput = {
  /** Carrier name (display). */
  carrierName?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Notes or special instructions for the delivery. */
  comments?: InputMaybe<Scalars['String']['input']>;
  /** Email the booking confirmation is sent to. */
  confirmationEmail?: InputMaybe<Scalars['String']['input']>;
  /** Contact email for the delivery. */
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  /** Contact person for the delivery. */
  contactName?: InputMaybe<Scalars['String']['input']>;
  /** Contact phone for the delivery. */
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  /** How the delivery is prioritized. */
  deliveryType?: InputMaybe<DeliveryType>;
  /** Chosen by the scheduler; drives the slot length. */
  freightType: FreightType;
  /** Number of pallets on the shipment. */
  palletCount: Scalars['Int']['input'];
  /** Carrier PRO (tracking) number. */
  proNumber?: InputMaybe<Scalars['String']['input']>;
  referenceNumber: Scalars['String']['input'];
  /** Standard Carrier Alpha Code (carrier/vendor id). */
  scacCode: Scalars['String']['input'];
  /** Date the freight ships (distinct from the appointment date). */
  shipDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  slotStartsAt: Scalars['ISO8601DateTime']['input'];
  /** Truck or trailer number. */
  truckNumber?: InputMaybe<Scalars['String']['input']>;
  /** Shipment weight in pounds. */
  weightLbs: Scalars['Float']['input'];
};

/** Autogenerated return type of PublicDockBookingSubmit. */
export type PublicDockBookingSubmitPayload = {
  __typename?: 'PublicDockBookingSubmitPayload';
  booking?: Maybe<PublicDockBooking>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userErrors: Array<DockBookingError>;
};

/** Autogenerated input type of PublicDockCheckIn */
export type PublicDockCheckInInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The kiosk's own dock, from its URL. Mutually exclusive with warehouseId. */
  dockId?: InputMaybe<Scalars['ID']['input']>;
  /** Confirmation number from the driver's email, or the delivery's PO number. */
  reference: Scalars['String']['input'];
  /** Trailer the driver actually arrived with. Optional; falls back to what the carrier declared. */
  truckNumber?: InputMaybe<Scalars['String']['input']>;
  /** The warehouse placard's own warehouse, from its URL. Mutually exclusive with dockId. */
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of PublicDockCheckIn. */
export type PublicDockCheckInPayload = {
  __typename?: 'PublicDockCheckInPayload';
  booking?: Maybe<PublicDockBooking>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userErrors: Array<DockBookingError>;
  visit?: Maybe<PublicDockVisit>;
};

/** Autogenerated input type of PublicDockDepart */
export type PublicDockDepartInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The kiosk's own dock, from its URL. Mutually exclusive with warehouseId. */
  dockId?: InputMaybe<Scalars['ID']['input']>;
  /** Confirmation number from the delivery's email, or its PO number. */
  reference: Scalars['String']['input'];
  /** The warehouse placard's own warehouse, from its URL. Mutually exclusive with dockId. */
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of PublicDockDepart. */
export type PublicDockDepartPayload = {
  __typename?: 'PublicDockDepartPayload';
  booking?: Maybe<PublicDockBooking>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userErrors: Array<DockBookingError>;
  visit?: Maybe<PublicDockVisit>;
};

export type PublicDockDisplay = {
  __typename?: 'PublicDockDisplay';
  dockName: Scalars['String']['output'];
  /** Next upcoming booked arrivals for this dock, soonest first. */
  upcomingArrivals: Array<PublicDockArrival>;
  warehouseName: Scalars['String']['output'];
  warehouseTimeZone: Scalars['String']['output'];
};

export type PublicDockSlot = {
  __typename?: 'PublicDockSlot';
  endsAt: Scalars['ISO8601DateTime']['output'];
  /** Start time in warehouse-local time. */
  label: Scalars['String']['output'];
  startsAt: Scalars['ISO8601DateTime']['output'];
};

export type PublicDockVisit = {
  __typename?: 'PublicDockVisit';
  /** The delivery this visit was opened against. */
  booking?: Maybe<PublicDockVisitBooking>;
  /** When the driver checked in. */
  checkedInAt: Scalars['ISO8601DateTime']['output'];
  /** When ops marked the truck away. Null while it is still on site. */
  departedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * The dock the truck is physically at, deliberately decoupled from the booking's
   * own (live, schedule-facing) dock — today an amend can drift the booking's dock
   * without this one moving, and this is also the right field for a future
   * ops-directed reassignment (e.g. redirecting a driver by text) to update,
   * without touching what was originally scheduled.
   */
  dockName?: Maybe<Scalars['String']['output']>;
  /** Time on site. Null until both ends are observed — never estimated. */
  dwellSeconds?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** Trailer number recorded at check-in. */
  truckNumber?: Maybe<Scalars['String']['output']>;
};

export type PublicDockVisitBooking = {
  __typename?: 'PublicDockVisitBooking';
  carrierName?: Maybe<Scalars['String']['output']>;
  /** Appointment reference for confirmations. */
  confirmationNumber?: Maybe<Scalars['String']['output']>;
  referenceNumber: Scalars['String']['output'];
};

export type PublicDockWarehouse = {
  __typename?: 'PublicDockWarehouse';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Autogenerated input type of PublicOverrideBookingAmend */
export type PublicOverrideBookingAmendInput = {
  carrierName?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The vendor's override code (soft-login credential). */
  code: Scalars['String']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  deliveryType?: InputMaybe<DeliveryType>;
  /** Drives the slot length. */
  freightType: FreightType;
  /** Number of pallets on the shipment. */
  palletCount: Scalars['Int']['input'];
  proNumber?: InputMaybe<Scalars['String']['input']>;
  /** The generated reference of the delivery being changed. */
  referenceNumber: Scalars['String']['input'];
  /** Standard Carrier Alpha Code (carrier/vendor id). */
  scacCode: Scalars['String']['input'];
  shipDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  slotStartsAt: Scalars['ISO8601DateTime']['input'];
  truckNumber?: InputMaybe<Scalars['String']['input']>;
  /** Shipment weight in pounds. */
  weightLbs: Scalars['Float']['input'];
};

/** Autogenerated return type of PublicOverrideBookingAmend. */
export type PublicOverrideBookingAmendPayload = {
  __typename?: 'PublicOverrideBookingAmendPayload';
  booking?: Maybe<PublicDockBooking>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userErrors: Array<DockBookingError>;
};

/** Autogenerated input type of PublicOverrideBookingCancel */
export type PublicOverrideBookingCancelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The vendor's override code (soft-login credential). */
  code: Scalars['String']['input'];
  /** The generated reference of the delivery being cancelled. */
  referenceNumber: Scalars['String']['input'];
};

/** Autogenerated return type of PublicOverrideBookingCancel. */
export type PublicOverrideBookingCancelPayload = {
  __typename?: 'PublicOverrideBookingCancelPayload';
  booking?: Maybe<PublicDockBooking>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userErrors: Array<DockBookingError>;
};

/** Autogenerated input type of PublicOverrideBookingCreate */
export type PublicOverrideBookingCreateInput = {
  carrierName?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The vendor's override code (soft-login credential). */
  code: Scalars['String']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  deliveryType?: InputMaybe<DeliveryType>;
  /** Drives the slot length. */
  freightType: FreightType;
  /** Number of pallets on the shipment. */
  palletCount: Scalars['Int']['input'];
  proNumber?: InputMaybe<Scalars['String']['input']>;
  /**
   * Reference number of a missed or cancelled delivery this booking rebooks;
   * grants the 12-hour recovery lead-time instead of the 24-hour new-booking rule.
   * Must be the vendor's own booking at the same warehouse and not already rebooked.
   */
  recoveringFrom?: InputMaybe<Scalars['String']['input']>;
  /** Standard Carrier Alpha Code (carrier/vendor id). */
  scacCode: Scalars['String']['input'];
  shipDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  slotStartsAt: Scalars['ISO8601DateTime']['input'];
  truckNumber?: InputMaybe<Scalars['String']['input']>;
  /** The warehouse the delivery is going to. */
  warehouseId: Scalars['ID']['input'];
  /** Shipment weight in pounds. */
  weightLbs: Scalars['Float']['input'];
};

/** Autogenerated return type of PublicOverrideBookingCreate. */
export type PublicOverrideBookingCreatePayload = {
  __typename?: 'PublicOverrideBookingCreatePayload';
  booking?: Maybe<PublicDockBooking>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userErrors: Array<DockBookingError>;
};

export type PublicOverrideVendor = {
  __typename?: 'PublicOverrideVendor';
  /**
   * This vendor's dock deliveries across all warehouses, newest first. Upcoming
   * deliveries are always returned; `historyDays` bounds how many days of
   * already-past deliveries come back (0 = today and future only).
   */
  bookings: Array<PublicDockBooking>;
  vendorName: Scalars['String']['output'];
};


export type PublicOverrideVendorBookingsArgs = {
  historyDays?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of PublishReviewResponseGbpMutation */
export type PublishReviewResponseGbpMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  googleLocationName: Scalars['String']['input'];
  responseText: Scalars['String']['input'];
  reviewId: Scalars['String']['input'];
};

/** Autogenerated input type of PublishReviewResponseMutation */
export type PublishReviewResponseMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationUuid: Scalars['ID']['input'];
  responseText: Scalars['String']['input'];
  reviewId: Scalars['String']['input'];
};

export type PunchOutCartItemInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  price: Scalars['Decimal']['input'];
  quantity: Scalars['Int']['input'];
};

export type PunchOutOrderMessage = {
  __typename?: 'PunchOutOrderMessage';
  /** URL to which the cXML document must be POSTed */
  browserFormPostUrl?: Maybe<Scalars['String']['output']>;
  /** String containing the cXML-encoded PunchOutOrderMessage */
  cxmlDocument?: Maybe<Scalars['String']['output']>;
};

export type PurchaseHistoryFeedbackError = {
  __typename?: 'PurchaseHistoryFeedbackError';
  message: Scalars['String']['output'];
};

export type PurchaseHistoryRecommendation = {
  __typename?: 'PurchaseHistoryRecommendation';
  avgDaysBetweenOrders?: Maybe<Scalars['Float']['output']>;
  avgQtyPerOrder: Scalars['Float']['output'];
  coefficientOfVariation: Scalars['Float']['output'];
  daysSinceLastOrder: Scalars['Int']['output'];
  distinctMonthsOrdered: Scalars['Int']['output'];
  firstOrderDate: Scalars['ISO8601DateTime']['output'];
  isRefillDue: Scalars['Boolean']['output'];
  item: SupplyItem;
  lastOrderDate: Scalars['ISO8601DateTime']['output'];
  medianQtyPerOrder: Scalars['Float']['output'];
  predictabilityLevel: PredictabilityLevel;
  stddevQtyPerOrder?: Maybe<Scalars['Float']['output']>;
  totalOrders: Scalars['Int']['output'];
};

export type PurchaseHistoryRecommendationConnection = {
  __typename?: 'PurchaseHistoryRecommendationConnection';
  edges: Array<Maybe<PurchaseHistoryRecommendationEdge>>;
  nodes: Array<Maybe<PurchaseHistoryRecommendation>>;
  pageInfo: PageInfo;
};

export type PurchaseHistoryRecommendationEdge = {
  __typename?: 'PurchaseHistoryRecommendationEdge';
  cursor: Scalars['String']['output'];
  node: PurchaseHistoryRecommendation;
};

export type PutawayAction = {
  __typename?: 'PutawayAction';
  destination: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  movedAt: Scalars['ISO8601DateTime']['output'];
  movedBaseQuantity: Scalars['Float']['output'];
  movedOn: Scalars['ISO8601Date']['output'];
};

/** Why an associate couldn't put a task away, as picked in the putaway companion. */
export enum PutawayExceptionReason {
  /** Bin doesn't physically exist; its record should be deactivated. */
  BinDoesNotExist = 'bin_does_not_exist',
  /** Bin is at capacity. */
  BinFull = 'bin_full',
  /** Inventory cannot be reached. */
  BinInaccessible = 'bin_inaccessible',
  /** Item is not present. */
  ItemNotFound = 'item_not_found',
  /** Free form; the note carries the description. */
  Other = 'other',
  /** The destination is not the expected bin type. */
  WrongBinType = 'wrong_bin_type'
}

/** Feedback an associate sent when a putaway task couldn't be completed, kept for review. */
export type PutawayExceptionReport = {
  __typename?: 'PutawayExceptionReport';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
};

export type PutawayExpiration = {
  __typename?: 'PutawayExpiration';
  conflict: Scalars['Boolean']['output'];
  effectiveDate?: Maybe<Scalars['ISO8601Date']['output']>;
  lotDerivedDate?: Maybe<Scalars['ISO8601Date']['output']>;
  recordedDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** recorded, lot_number, or unknown. */
  source: Scalars['String']['output'];
};

export type PutawayItem = {
  __typename?: 'PutawayItem';
  displayName?: Maybe<Scalars['String']['output']>;
  netsuiteInternalId?: Maybe<Scalars['String']['output']>;
};

export enum PutawayMovementClassification {
  FullPallet = 'FULL_PALLET',
  HalfPalletOrLess = 'HALF_PALLET_OR_LESS',
  MoreThanHalfPallet = 'MORE_THAN_HALF_PALLET'
}

export type PutawayObservedMovement = {
  __typename?: 'PutawayObservedMovement';
  destination: Scalars['String']['output'];
  movedOn: Scalars['ISO8601Date']['output'];
};

export type PutawayPalletBreakdown = {
  __typename?: 'PutawayPalletBreakdown';
  caseQuantity: Scalars['Float']['output'];
  configuration: PutawayPalletConfiguration;
  fullPalletCaseQuantity: Scalars['Float']['output'];
  fullPalletCount: Scalars['Int']['output'];
  remainderCaseQuantity: Scalars['Float']['output'];
};

export type PutawayPalletBreakdownError = {
  __typename?: 'PutawayPalletBreakdownError';
  code: PutawayPalletBreakdownErrorCode;
  message: Scalars['String']['output'];
};

export enum PutawayPalletBreakdownErrorCode {
  CasesPerPalletInvalid = 'cases_per_pallet_invalid',
  InvalidReceiptQuantity = 'invalid_receipt_quantity',
  InvalidStockUnitConversion = 'invalid_stock_unit_conversion',
  InventoryItemMissing = 'inventory_item_missing',
  NonInventoryItem = 'non_inventory_item',
  PalletConfigurationMissing = 'pallet_configuration_missing',
  ReceiptQuantityMissing = 'receipt_quantity_missing',
  StockUnitConversionMissing = 'stock_unit_conversion_missing'
}

export type PutawayPalletBreakdownResult = PutawayPalletBreakdown | PutawayPalletBreakdownError;

/** A pallet build correction reported in the putaway companion but not written to IMS, kept for review. */
export type PutawayPalletBuildReport = {
  __typename?: 'PutawayPalletBuildReport';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
};

export type PutawayPalletConfiguration = {
  __typename?: 'PutawayPalletConfiguration';
  casesPerLayer?: Maybe<Scalars['Int']['output']>;
  casesPerPallet: Scalars['Int']['output'];
  layersPerPallet?: Maybe<Scalars['Int']['output']>;
  stockUnitConversion: Scalars['Float']['output'];
};

export enum PutawayPickZoneGroup {
  Ambient = 'AMBIENT',
  ChilledFrozen = 'CHILLED_FROZEN'
}

/** The connection type for PutawayReportRow. */
export type PutawayPriorityConnection = {
  __typename?: 'PutawayPriorityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PutawayReportRowEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PutawayReportRow>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of records in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type PutawayProgress = {
  __typename?: 'PutawayProgress';
  actions: Array<PutawayAction>;
  availableBaseQuantity?: Maybe<Scalars['Float']['output']>;
  blockingCommands: Array<WarehouseBinTransferCommand>;
  commands: Array<WarehouseBinTransferCommand>;
  issues: Array<PutawayProgressIssue>;
  movedBaseQuantity: Scalars['Float']['output'];
  receivedBaseQuantity?: Maybe<Scalars['Float']['output']>;
  remainingBaseQuantity?: Maybe<Scalars['Float']['output']>;
  reservedBaseQuantity: Scalars['Float']['output'];
  status: PutawayProgressStatus;
};

export type PutawayProgressIssue = {
  __typename?: 'PutawayProgressIssue';
  code: PutawayProgressIssueCode;
  message: Scalars['String']['output'];
};

export enum PutawayProgressIssueCode {
  AmbiguousReceiptAssignment = 'AMBIGUOUS_RECEIPT_ASSIGNMENT',
  InvalidMovementQuantity = 'INVALID_MOVEMENT_QUANTITY',
  InvalidReceivedQuantity = 'INVALID_RECEIVED_QUANTITY',
  MovementQuantityExceedsRemaining = 'MOVEMENT_QUANTITY_EXCEEDS_REMAINING',
  SourceIdentityMissing = 'SOURCE_IDENTITY_MISSING'
}

export enum PutawayProgressStatus {
  Complete = 'COMPLETE',
  NeedsReview = 'NEEDS_REVIEW',
  NotStarted = 'NOT_STARTED',
  Partial = 'PARTIAL'
}

export enum PutawayQuantityUnit {
  Cases = 'CASES',
  Eaches = 'EACHES'
}

export enum PutawayRefrigerationState {
  Frozen = 'FROZEN',
  Refrigerated = 'REFRIGERATED',
  RoomTemperature = 'ROOM_TEMPERATURE',
  Unknown = 'UNKNOWN'
}

export type PutawayReport = {
  __typename?: 'PutawayReport';
  assignmentCount: Scalars['Int']['output'];
  endDate: Scalars['ISO8601Date']['output'];
  latestSyncedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  receiptCount: Scalars['Int']['output'];
  rows: PutawayReportRowConnection;
  startDate: Scalars['ISO8601Date']['output'];
  warehouseId: Scalars['ID']['output'];
  warehouseName: Scalars['String']['output'];
  /** @deprecated Use independent feature results on each report row. */
  warnings: Array<Scalars['String']['output']>;
};


export type PutawayReportRowsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PutawayReportRow = {
  __typename?: 'PutawayReportRow';
  /**
   * Movement date of the latest active staging-origin putaway action.
   * @deprecated Use putawayProgress.actions.
   */
  actualMovedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  /**
   * Destination of the latest active staging-origin putaway action.
   * @deprecated Use putawayProgress.actions.
   */
  actualToBinName?: Maybe<Scalars['String']['output']>;
  caseQuantity?: Maybe<Scalars['Float']['output']>;
  casesPerLayer?: Maybe<Scalars['Int']['output']>;
  casesPerPallet?: Maybe<Scalars['Int']['output']>;
  expiration: PutawayExpiration;
  expirationConflict: Scalars['Boolean']['output'];
  expirationDate?: Maybe<Scalars['ISO8601Date']['output']>;
  expirationSource: Scalars['String']['output'];
  fullPalletCaseQuantity?: Maybe<Scalars['Float']['output']>;
  fullPalletCount?: Maybe<Scalars['Int']['output']>;
  /** Unique receipt line assignment row id. */
  id: Scalars['ID']['output'];
  inventoryItem?: Maybe<InventoryItem>;
  /** @deprecated Use inventoryItem and itemName. */
  item: PutawayItem;
  /** NetSuite item internal id. */
  itemInternalId?: Maybe<Scalars['String']['output']>;
  /** Item display name recorded on the receipt. */
  itemName?: Maybe<Scalars['String']['output']>;
  layersPerPallet?: Maybe<Scalars['Int']['output']>;
  lotExpirationDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Lot/serial display value. */
  lotNumber?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use putawayProgress.actions. */
  observedMovement?: Maybe<PutawayObservedMovement>;
  palletBreakdown: PutawayPalletBreakdownResult;
  /** Source purchase order NetSuite internal id, when known. */
  purchaseOrderInternalId?: Maybe<Scalars['String']['output']>;
  /** Source purchase order transaction id, when known. */
  purchaseOrderTranId?: Maybe<Scalars['String']['output']>;
  putawayProgress: PutawayProgress;
  /** NetSuite base-unit quantity received for this assignment. */
  quantity?: Maybe<Scalars['Float']['output']>;
  /** Receipt/staging bin recorded on the Item Receipt. */
  receiptBinName?: Maybe<Scalars['String']['output']>;
  /** NetSuite transactionLine id on the Item Receipt. */
  receiptLineId?: Maybe<Scalars['String']['output']>;
  /** NetSuite transactionLine unique key for rejoining decisions. */
  receiptLineUniqueKey?: Maybe<Scalars['String']['output']>;
  /** NetSuite internal id for the Item Receipt. */
  receiptNetsuiteInternalId: Scalars['String']['output'];
  /** Item Receipt transaction id, e.g. IR17. */
  receiptTranId?: Maybe<Scalars['String']['output']>;
  /** Persisted recommendation reason, or why no recommendation was made. */
  recommendationReason?: Maybe<Scalars['String']['output']>;
  /** Persisted point-in-time recommended destination bin. */
  recommendedBinName?: Maybe<Scalars['String']['output']>;
  recordedExpirationDate?: Maybe<Scalars['ISO8601Date']['output']>;
  refrigerationState: Scalars['String']['output'];
  remainderCaseQuantity?: Maybe<Scalars['Float']['output']>;
  stockUnitConversion?: Maybe<Scalars['Float']['output']>;
  suggestedBin?: Maybe<PutawaySuggestedBin>;
  /** When this receipt last synced from Kafka. */
  syncedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Item Receipt transaction date. */
  tranDate?: Maybe<Scalars['ISO8601Date']['output']>;
};

/** The connection type for PutawayReportRow. */
export type PutawayReportRowConnection = {
  __typename?: 'PutawayReportRowConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PutawayReportRowEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PutawayReportRow>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of records in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PutawayReportRowEdge = {
  __typename?: 'PutawayReportRowEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PutawayReportRow>;
};

export type PutawaySuggestedBin = {
  __typename?: 'PutawaySuggestedBin';
  destination?: Maybe<Scalars['String']['output']>;
  generatedAt: Scalars['ISO8601DateTime']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type PutawayTask = WarehouseTask & {
  __typename?: 'PutawayTask';
  /** Current NetSuite base-unit balance less submitted moves. */
  currentQuantity: Scalars['Float']['output'];
  expiration: PutawayExpiration;
  id: Scalars['ID']['output'];
  inventoryItem?: Maybe<InventoryItem>;
  inventoryNumber?: Maybe<WarehouseTaskInventoryNumber>;
  item: WarehouseTaskItem;
  movement?: Maybe<PutawayTaskMovement>;
  palletBreakdown: PutawayTaskPalletBreakdownResult;
  priority: PutawayTaskPriority;
  quantityDetails?: Maybe<PutawayTaskQuantityDetails>;
  /** Oldest compatible Item Receipt time, used only as FIFO context. */
  receivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  sourceBin: WarehouseTaskBin;
  state: WarehouseTaskState;
  statusReason?: Maybe<WarehouseTaskStatusReason>;
  /** Latest persisted destination-planning result; missing results are reported as updating. */
  suggestion: PutawayTaskSuggestion;
  taskType: WarehouseTaskType;
  /** Distinct purchase and stock units resolved against their shared base unit. */
  unitConfiguration?: Maybe<PutawayTaskUnitConfiguration>;
  workstream: WarehouseTaskWorkstream;
};

export type PutawayTaskAllocation = {
  __typename?: 'PutawayTaskAllocation';
  destinationBin: WarehouseTaskBin;
  /** Human-readable planning evidence for this allocation. */
  explanation?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  movement: PutawayTaskMovement;
  palletConfiguration?: Maybe<PutawayTaskPalletConfiguration>;
  palletFootprint?: Maybe<PutawayTaskPalletFootprint>;
  quantityDetails: PutawayTaskQuantityDetails;
  unitConfiguration?: Maybe<PutawayTaskUnitConfiguration>;
};

export type PutawayTaskConfigurationReview = {
  __typename?: 'PutawayTaskConfigurationReview';
  code: WarehouseTaskStatusReasonCode;
  message: Scalars['String']['output'];
};

export type PutawayTaskMovement = {
  __typename?: 'PutawayTaskMovement';
  classification: PutawayMovementClassification;
  /** Base-unit quantity for the next movement. */
  quantity: Scalars['Float']['output'];
  quantityDetails: PutawayTaskQuantityDetails;
  refrigerationState: PutawayRefrigerationState;
  stockUnit?: Maybe<PutawayTaskUnit>;
  /** Exact movement quantity in the NetSuite stock unit. */
  stockUnitQuantity?: Maybe<Scalars['String']['output']>;
};

export type PutawayTaskPalletBreakdown = {
  __typename?: 'PutawayTaskPalletBreakdown';
  configuration?: Maybe<PutawayTaskPalletConfiguration>;
  /** One pallet expressed in purchase, base, and stock units. */
  footprint?: Maybe<PutawayTaskPalletFootprint>;
  fullPalletCaseQuantity?: Maybe<Scalars['String']['output']>;
  fullPalletCount: Scalars['Int']['output'];
  quantityDetails: PutawayTaskQuantityDetails;
  remainderQuantityDetails: PutawayTaskQuantityDetails;
};

export type PutawayTaskPalletBreakdownResult = PutawayTaskConfigurationReview | PutawayTaskPalletBreakdown;

export type PutawayTaskPalletConfiguration = {
  __typename?: 'PutawayTaskPalletConfiguration';
  casesPerLayer?: Maybe<Scalars['Int']['output']>;
  casesPerPallet: Scalars['Int']['output'];
  eachesPerCase: Scalars['String']['output'];
  layersPerPallet?: Maybe<Scalars['Int']['output']>;
};

export type PutawayTaskPalletFootprint = {
  __typename?: 'PutawayTaskPalletFootprint';
  baseUnitQuantity: Scalars['String']['output'];
  casesPerLayer?: Maybe<Scalars['Int']['output']>;
  layersPerPallet?: Maybe<Scalars['Int']['output']>;
  purchaseUnit: PutawayTaskUnit;
  purchaseUnitsPerPallet: Scalars['Int']['output'];
  stockUnit: PutawayTaskUnit;
  stockUnitQuantity: Scalars['String']['output'];
};

export enum PutawayTaskPriority {
  Blocked = 'BLOCKED',
  FullPallet = 'FULL_PALLET',
  HalfPalletOrLess = 'HALF_PALLET_OR_LESS',
  MoreThanHalfPallet = 'MORE_THAN_HALF_PALLET',
  NeedsReview = 'NEEDS_REVIEW'
}

export type PutawayTaskPurchaseUnitGrouping = {
  __typename?: 'PutawayTaskPurchaseUnitGrouping';
  looseBaseUnitQuantity: Scalars['String']['output'];
  quantity: Scalars['String']['output'];
  unit: PutawayTaskUnit;
  wholeUnitQuantity: Scalars['String']['output'];
};

export type PutawayTaskQuantityDetails = {
  __typename?: 'PutawayTaskQuantityDetails';
  baseUnitQuantity: Scalars['String']['output'];
  /** Server-computed case quantity rounded to six decimal places. */
  caseQuantity?: Maybe<Scalars['String']['output']>;
  eachQuantity: Scalars['String']['output'];
  eachesPerCase?: Maybe<Scalars['String']['output']>;
  looseEachQuantity?: Maybe<Scalars['String']['output']>;
  /** Purchase-unit grouping when stock is kept in base units and purchase units contain several base units. */
  purchaseUnitGrouping?: Maybe<PutawayTaskPurchaseUnitGrouping>;
  stockUnit?: Maybe<PutawayTaskUnit>;
  /** Exact quantity in the NetSuite stock unit for the same base-unit quantity. */
  stockUnitQuantity?: Maybe<Scalars['String']['output']>;
  unit: PutawayQuantityUnit;
  wholeCaseQuantity?: Maybe<Scalars['String']['output']>;
};

export type PutawayTaskSuggestion = {
  __typename?: 'PutawayTaskSuggestion';
  /** The singular current movement directive; retained while an existing result is updating. */
  allocation?: Maybe<PutawayTaskAllocation>;
  /** When the current or retained result was calculated. */
  generatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether the retained movement directive is being refreshed. */
  outOfDate: Scalars['Boolean']['output'];
  state: PutawayTaskSuggestionState;
  /** Why planning is updating or no safe destination is available. */
  statusReason?: Maybe<WarehouseTaskStatusReason>;
};

export enum PutawayTaskSuggestionState {
  Suggested = 'SUGGESTED',
  Unavailable = 'UNAVAILABLE',
  Updating = 'UPDATING'
}

export type PutawayTaskUnit = {
  __typename?: 'PutawayTaskUnit';
  baseUnitId: Scalars['ID']['output'];
  baseUnitName?: Maybe<Scalars['String']['output']>;
  conversionToBaseUnit: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type PutawayTaskUnitConfiguration = {
  __typename?: 'PutawayTaskUnitConfiguration';
  purchaseUnit: PutawayTaskUnit;
  stockUnit: PutawayTaskUnit;
};

export type QrScanAnalyticsData = {
  __typename?: 'QrScanAnalyticsData';
  byDayOfWeek: Array<DayOfWeekQrScanCount>;
  byHourOfDay: Array<HourOfDayQrScanCount>;
  totalScanCount: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  /** Fetch an account creation session by ID or email */
  accountCreationSession?: Maybe<AccountCreationSession>;
  /** Valid collections status values for the AR dashboard */
  accountsReceivableCollectionsStatuses: Array<Scalars['String']['output']>;
  /** AR collections dashboard grouped by company */
  accountsReceivableCompanyDashboard: AccountsReceivableCompanyDashboard;
  /** @deprecated Use accountsReceivableLocationDashboard or accountsReceivableCompanyDashboard instead */
  accountsReceivableDashboard: AccountsReceivableDashboard;
  /** AR collections dashboard grouped by location */
  accountsReceivableLocationDashboard: AccountsReceivableLocationDashboard;
  /** The names of distributor companies Odeko has merged/acquired. The source of truth for these is NetSuite. */
  acquisitionConversions: Array<AcquisitionConversion>;
  activeMasterHomepage?: Maybe<ActiveMasterHomepage>;
  /** Returns a list of active zipcodes matches the passed zipcodes */
  activeZipcodes?: Maybe<Array<Zipcode>>;
  /** List allowance recipients */
  allowanceRecipients: AllowanceRecipientConnection;
  /** List rewards applicable at checkout. */
  applicableRewards: Array<Reward>;
  approvedCutoffDiscrepancies: Array<CutoffDiscrepancyApproval>;
  arAssignableUsers: Array<ArAssignableUser>;
  /** Returns a presigned url to upload artwork to */
  artworkUploadUrl: ArtworkUpload;
  /**
   * Locations the current user may grant when creating or editing a user.
   * Owner/Admin actors: all company locations. Other roles: only the actor's own locations.
   */
  assignableLocations: Array<Location>;
  /**
   * Roles the current user may assign (equal-or-below rank, customer-facing only,
   * Owner omitted for Owner actors), ordered by rank, highest assignable first.
   */
  assignableRoles: Array<Role>;
  associateBadgePayloads: Array<AssociateBadgePayload>;
  auditReputation: AuditReputation;
  auditReputationGbp: AuditReputation;
  /** Authorized version of micrositeLocation query requiring proper roles and microsite access */
  authorizedMicrositeLocation: MicrositeLocation;
  /** Returns a single base branded item */
  baseBrandedItem: BaseBrandedItem;
  /** Returns base branded items for given filters */
  baseBrandedItems: Array<BaseBrandedItem>;
  /** List batched deposits */
  batchedDeposits: BatchedDepositConnection;
  /** Returns a single branded item deal */
  brandedItemDeal: BrandedItemDeal;
  /** Returns all branded item deals for a location */
  brandedItemDeals: Array<BrandedItemDeal>;
  /**
   * Calculate a full consumer refund. This provides a preview of the refund
   * info that would result from executing the createFullConsumerRefund
   * mutation.
   */
  calculateFullConsumerRefund: ConsumerRefundInfoResult;
  /**
   * Calculate a partial consumer refund. This provides a preview of the refund
   * info that would result from executing the createPartialConsumerRefund
   * mutation.
   */
  calculatePartialConsumerRefund: ConsumerRefundInfoResult;
  /** Shopping cart */
  cart: Cart;
  catalogFilters?: Maybe<CatalogFilter>;
  catalogHomepageContent: Array<CatalogHomepageEntry>;
  catalogHomepageRows: Array<CollectionsHomepageRow>;
  categories: Array<Category>;
  categoryBannerForEdit?: Maybe<CategoryBannerForEdit>;
  categoryById?: Maybe<Category>;
  categoryByName?: Maybe<Category>;
  /** Download check-in entries as CSV */
  checkInEntriesCsv: Scalars['String']['output'];
  /** Get statistics for check-in entries */
  checkInStats: CheckInStats;
  /** Check if an email has already checked in today */
  checkInStatus: CheckInStatus;
  collection?: Maybe<Collection>;
  collectionBySlug?: Maybe<Collection>;
  collectionSetupForEdit?: Maybe<CollectionSetupForEdit>;
  collectionsPage: Array<CollectionsPageEntry>;
  /** Returns all color options */
  colors: Array<Color>;
  /**
   * If a value for name is provided, Returns a list of existing companies,
   * filtered by that value. PLEASE NOTE: This query returns no results if an empty
   * or blank argument for name.
   */
  companies: CompanyConnection;
  /** Returns a single top-level company, identified by ID. */
  company: Company;
  /** Get the config that's current as of a given datetime */
  config: Config;
  /** List configs in reverse chronological order */
  configs: ConfigConnection;
  /** Consumer app referral link. */
  consumerAppReferralLink?: Maybe<ConsumerAppReferralLink>;
  /** Fetches a consumer order by ID */
  consumerOrder?: Maybe<ConsumerOrder>;
  /** Info about consumer post-order survey. */
  consumerPostOrderSurvey?: Maybe<ConsumerPostOrderSurvey>;
  conversionMetrics: ConversionMetrics;
  conversionMetricsGbp: ConversionMetrics;
  /** Current ConsumerAppUser. Null unless logged into a consumer account. */
  currentConsumerAppUser?: Maybe<ConsumerAppUser>;
  /**
   * Returns locations with pagination. This query is meant for ops use cases and is only available admins.
   *     At least one of the arguments 'first' or 'last' is required.
   *     Raises an error if either 'first' or 'last' argument is not provided.
   *     Additionally, an error is raised if the value provided for 'first' or 'last' argument is greater than 100.
   */
  customerLocations: CustomerLocationsConnection;
  /** A bulk customer-tag CSV upload and how far it has got. Polled while one runs. */
  customerTagImport?: Maybe<CustomerTagImport>;
  /** The customer tag vocabulary, independent of any location. */
  customerTags: CustomerTagConnection;
  /** Returns delivery type for a google address */
  deliveryForAddress: DeliveryForAddress;
  deliveryInstructionReviewStatus?: Maybe<DeliveryInstructionReviewStatus>;
  /** Every order (and standing delivery) a delivery-override block on this date would affect. */
  deliveryOverrideAffectedDeliveries: DeliveryOverrideAffectedDeliveries;
  /** The locations a delivery override described this way would currently reach. */
  deliveryOverrideLocations: LocationConnection;
  /** What a delivery override would reach if it were created as described. */
  deliveryOverridePreview: DeliveryOverridePreview;
  /**
   * Delivery overrides, soonest delivery date first, optionally narrowed to one
   * market. Upcoming ones unless `from` asks for a date already past. Paginated:
   * either `first` or `last` is required, and neither may exceed 100.
   */
  deliveryOverrideRules: DeliveryOverrideRulesConnection;
  /** Calculate prices and discounts on a delivery. */
  deliveryPrice: DeliveryPriceResult;
  dockBooking?: Maybe<DockBooking>;
  dockBookingByReference?: Maybe<DockBooking>;
  dockBookings: Array<DockBooking>;
  dockBookingsRange: Array<DockBooking>;
  dockOpenVisits?: Maybe<Array<DockVisit>>;
  dockOverrideCodes: Array<DockOverrideCode>;
  dockWarehouseCapacity?: Maybe<WarehouseDockCapacity>;
  dockWarehouseClosedDays: Array<Scalars['Int']['output']>;
  docks: Array<Dock>;
  /** Returns a route's ordered driver location breadcrumb trail, optionally bounded to a time window. */
  driverLocationTrail: Array<DriverLocationPing>;
  /** Returns all driver safety acknowledgements */
  driverSafetyAcknowledgements: Array<DriverSafetyAcknowledgement>;
  expectedPurchaseOrders: Array<ExpectedPurchaseOrder>;
  expectedTransferOrders: Array<ExpectedTransferOrder>;
  externalSupplier?: Maybe<ExternalSupplier>;
  externalSuppliers: ExternalSupplierConnection;
  /** Lists favorite consumer orders */
  favoriteConsumerOrders: Array<FavoriteConsumerOrder>;
  /** Whether a Flipper flag is on for the signed-in user. What the admin tool reads to decide which experience to render. */
  featureFlagEnabled: Scalars['Boolean']['output'];
  /** Field Service zipcodes served by the given warehouse. */
  fieldServiceZipcodes: Array<FieldServiceZipcode>;
  /** Find games */
  games: Array<Game>;
  generatePunchOutOrderMessage?: Maybe<PunchOutOrderMessage>;
  /** Gets a list of chat messages for the current user ordered by most recent first */
  getChatHistory?: Maybe<Array<Maybe<ChatMessage>>>;
  getChatMessage?: Maybe<ChatMessage>;
  /** Fetch a pricing package by its integer ID */
  getPricingPackage?: Maybe<PricingPackage>;
  /** Returns a single InProgressCustomer, by id. */
  inProgressCustomer: InProgressCustomer;
  /**
   * Where one acquisition's in-progress customers stand right now: counts by
   * state, and the active and most recently finished batch runs.
   */
  inProgressCustomerAcquisitionSummary: InProgressCustomerAcquisitionSummary;
  /**
   * Returns a list of InProgressCustomer, according to the specified filters.
   *       NOTE: business-portal's implementation of connection types for pagination is not fully compliant with ADR 28,
   *       so currently you can make queries without including 'first' or 'last' arguments. You should not do this however,
   *       and always include 'first' or 'last' arguments in your queries. In the
   * future we can they make these required as per ADR 28.
   */
  inProgressCustomers: InProgressCustomerConnection;
  /** PROTOTYPE inventory-service-2 - for a given LocationStockCount session LocationItem, return the current count. */
  inventoryCurrentCount?: Maybe<CurrentCount>;
  /** PROTOTYPE inventory-service-2 LocationItem (different than IMS LocationItem). */
  inventoryLocationItem?: Maybe<InventoryLocationItem>;
  /** PROTOTYPE inventory-service-2 - obtain a LocationStockCount by id. */
  inventoryStockCountById?: Maybe<LocationStockCount>;
  /** Purpose-built candidate search for invoice line matching. */
  invoiceMatchCandidates: InvoiceMatchCandidatesResult;
  /** Returns a true if the specified input time is past the cutoff time */
  isPastWarehouseCutOffTime: Scalars['Boolean']['output'];
  /** Determines if route synchronization is allowed for the given warehouse and night end */
  isRoutesSyncEnabled: Scalars['Boolean']['output'];
  itemBrands: ItemBrandConnection;
  items: ItemConnection;
  /** The task's most recent replenishment trip that has not been undone, or null when there is none. */
  lastReplenishmentTrip?: Maybe<ReplenishmentTrip>;
  /** Find leaderboard entries */
  leaderboardEntries: Array<LeaderboardEntry>;
  /** Get leaderboard rankings for a specified time period */
  leaderboardRankings: Array<LeaderboardEntry>;
  /** Find leaderboards */
  leaderboards: Array<Leaderboard>;
  listingImpressions: ListingImpressions;
  listingImpressionsGbp: ListingImpressions;
  /** Get a location by id, odeko UUID, or encrypted id. */
  location?: Maybe<Location>;
  /** query's location-item associations for catalog whitelisting by location (`locationitem` Table) */
  locationItemsByItemId?: Maybe<Array<Maybe<LocationItem>>>;
  /**
   * Returns all orders with quantities for a given location with pagination.
   *     At least one of the arguments 'first' or 'last' is required.
   *     Raises an error if either 'first' or 'last' argument is not provided.
   *     Additionally, an error is raised if the value provided for 'first' or 'last' argument is greater than 100.
   */
  locationOrders: LocationOrdersConnection;
  /**
   * Returns past orders for a given location with pagination.
   *     At least one of the arguments 'first' or 'last' is required.
   *     Raises an error if either 'first' or 'last' argument is not provided.
   *     Additionally, an error is raised if the value provided for 'first' or 'last' argument is greater than 100.
   */
  locationPastOrders: LocationPastOrdersConnection;
  locationPrices: Array<ItemLocationCustomPrice>;
  /** Returns upcoming orders for a given location */
  locationUpcomingOrders: Array<Order>;
  /** Download mailing list submissions as CSV */
  mailingListSubmissionsCsv: Scalars['String']['output'];
  marketingQrCodes: MarketingQrCodeConnection;
  marketingQrCodesAvailable: Scalars['Int']['output'];
  /** Get marketing tools users associated with a microsite location */
  marketingToolsUsers: Array<User>;
  masterHomepageForEdit?: Maybe<MasterHomepage>;
  masterHomepages: Array<MasterHomepageListItem>;
  /** Returns the current authenticated user */
  me: User;
  /** Fetches a merchant given its ID */
  merchant?: Maybe<Merchant>;
  /** Information about the currently logged-in merchant app viewer. */
  merchantAppViewer: MerchantAppUser;
  /** Fetches a merchant given its databaseId */
  merchantByDatabaseId?: Maybe<Merchant>;
  /** Fetches a merchant given its uuid */
  merchantByUuid?: Maybe<Merchant>;
  /** List merchants */
  merchants: MerchantConnection;
  micrositeAdminLocations: MicrositeLocationAdminConnection;
  /**
   * PROTOTYPE (marketing-tools-service) Return the data for the MicrositeLocation.
   * Note, this is separate from a traditional Odeko (supply) Location.
   */
  micrositeLocation: MicrositeLocation;
  micrositeScans: MicrositeScansData;
  /**
   * PROTOTYPE (marketing-tools-service) Return the list of avaliable time zones,
   * as a list of options suitable for use in select list/dropdown.
   */
  micrositeTimeZones: Array<MicrositeTimeZoneOption>;
  /**
   * Every market where an item is currently eligible as new, alongside that market's current queue
   * leader at `position` (if any) — a preview for cross-market pinning.
   */
  newItemMarketsForItem: Array<NewItemMarketEligibility>;
  /**
   * All New Items pins for a market, ordered by (position, subrank). Includes stale pins (item out of
   * stock or aged out of the 60-day new window) that the shopper-facing carousel excludes, so the
   * merchandising studio can surface and clean them up.
   */
  newItemPins: Array<NewItemPin>;
  /** Fetches an object given its ID. */
  node?: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  nonInventoryVendors: Array<NonInventoryVendor>;
  /** Get an order by ID */
  order?: Maybe<Order>;
  /** Get ordering rules for a list of items at a location */
  orderingRules: Array<OrderingRule>;
  /** Returns a list of orders based on the provided filters. */
  orders: OrdersConnection;
  outboundGates: OutboundGates;
  pastHomepageCollections: Array<PastHomepageCollectionEntry>;
  /** Returns pending published driver safety acknowledgements for the current driver */
  pendingDriverSafetyAcknowledgements: Array<DriverSafetyAcknowledgement>;
  pickHoursScorecard: Array<PickHoursScorecardDay>;
  /** Pickup schedule for specified merchant and menu items. */
  pickupSchedule: PickupSchedule;
  pingBraavos: Scalars['String']['output'];
  /**
   * PROTOTYPE (marketing-tools-service) Obtain an "authorize" url. Directing a
   * user's client to this url initiates an OAuth flow.
   */
  platformAuthorizeUrl: AuthorizeUrl;
  /**
   * PROTOTYPE (marketing-tools-service) Return the platform connection for the
   * given platform. In the initial version we return the full connection for the
   * user. We'll update this to return location specific locations pretty soon.
   */
  platformConnection: Connection;
  /** List account profiles for the current user's platform connection */
  platformProfiles: Array<AccountProfile>;
  pricingServicePing: Scalars['String']['output'];
  processPathCatalog: Array<ProcessPath>;
  processPathCompliance: ProcessPathCompliance;
  processPathCoverageTargets: Array<ProcessPathCoverageTarget>;
  processPathEmployeeDay?: Maybe<ProcessPathEmployeeDay>;
  processPathEmployeeThroughput: Array<ProcessPathEmployeeThroughput>;
  processPathFloor: Array<ProcessPathEmployeeDay>;
  processPathHourlyTotals: Array<ProcessPathHourlyTotal>;
  processPathMeasuredPickDays: Array<ProcessPathMeasuredPickDay>;
  processPathRoster: Array<ProcessPathEmployee>;
  /**
   * Whole-floor daily units + clocked minutes for one process path — the
   * Throughput grid's fast basis. Answers for the LD/Ecomm pick path unless
   * processPathCode names another.
   */
  processPathScanDays: Array<ProcessPathScanDay>;
  /**
   * First day processPathScanDays can answer for at a warehouse, for the path
   * processPathCode names (the LD/Ecomm pick path by default); earlier days are
   * unmeasured, not empty. Null if never measured.
   */
  processPathScanHistoryStart?: Maybe<Scalars['ISO8601Date']['output']>;
  processPathSelfContext?: Maybe<ProcessPathEmployeeDay>;
  processPathThroughput: Array<ProcessPathThroughput>;
  processPathWeeklyActuals: Array<ProcessPathEmployeeDay>;
  processPathWeeklyForecast: Array<ProcessPathDayForecast>;
  processPaths: Array<ProcessPath>;
  /**
   * Aggregate human approval of AI outputs — overall and by interaction type. The
   * initiative's 'percent of AI interactions approved' metric.
   */
  procurementAiApprovalRate: ProcurementAiApprovalStats;
  procurementCorrespondence?: Maybe<ProcurementEmailThread>;
  /**
   * Inbound coverage — the share of settled (8+ days old) confirmed-linked PO
   * threads that ever heard back from outside Odeko (bounce notices excluded).
   * Read next to procurementAiApprovalRate: the approval rate is not interpretable
   * while coverage is unknown.
   */
  procurementInboundCoverage: ProcurementInboundCoverageStats;
  procurementInbox: ProcurementInboxPage;
  procurementMailDownload: Scalars['JSON']['output'];
  /** Last processed Gmail historyId for a mailbox; null before the first ingest pass (the poller then backfills). */
  procurementMailboxCursor?: Maybe<Scalars['String']['output']>;
  /** One PO tracking row, by id or by PO number (NetSuite tranId). */
  procurementPoTracking?: Maybe<ProcurementPoTracking>;
  /** PO tracking rows (tool-owned correspondence state joined to the NetSuite PO projection), newest first. */
  procurementPoTrackings: Array<ProcurementPoTracking>;
  /** One procurement vendor by id. */
  procurementTrackingVendor?: Maybe<ProcurementTrackingVendor>;
  /** Procurement vendors (PO counterparties with AI context), name-ordered. */
  procurementTrackingVendors: Array<ProcurementTrackingVendor>;
  /**
   * Threads triaged as PO-like but not confidently linked — the human queue
   * (includes any AI-proposed links awaiting confirmation), oldest first.
   */
  procurementUnmatchedThreads: Array<ProcurementEmailThread>;
  /** Returns all procurement vendors */
  procurementVendors: Array<ProcurementVendor>;
  /** Returns the current inventory for a product */
  productInventory: Array<ProductInventory>;
  publicDockBooking?: Maybe<PublicDockBooking>;
  publicDockCheckInLookup?: Maybe<PublicDockBooking>;
  publicDockDisplay?: Maybe<PublicDockDisplay>;
  publicDockOpenVisits?: Maybe<Array<PublicDockVisit>>;
  publicDockWarehouses: Array<PublicDockWarehouse>;
  publicOverrideSlots: Array<PublicDockSlot>;
  publicOverrideVendor?: Maybe<PublicOverrideVendor>;
  putawayPriority: PutawayPriorityConnection;
  putawayReport: PutawayReport;
  qrScanAnalytics: QrScanAnalyticsData;
  receivableNotes: Array<ReceivableNote>;
  /**
   * The most recent manual transaction syncs across all locations, newest first,
   * including syncs still in flight. Bounded and unpaginated: manual syncs are
   * rare and this answers a recent-activity list, not a browsable history.
   */
  recentTransactionSyncs: Array<TransactionSyncAttempt>;
  /** Returns a single redelivery stop */
  redeliveryStop: Redelivery;
  rfsmartCredentials: Array<RfsmartCredential>;
  rfsmartPendingRemovals: Array<RfsmartCredential>;
  rfsmartPooledCredentials: Array<RfsmartCredential>;
  /** Returns a single route */
  route: Route;
  /** Returns all routes for a warehouse */
  routes: Array<Route>;
  /** Returns the routing import plan */
  routingImportPlan: RoutingImportPlan;
  salesPriorityList: Array<SalesPriorityLocation>;
  salesRepAdmins: Array<Admin>;
  scoringKey: Scalars['JSON']['output'];
  searchTermImpressions: Array<SearchTermImpression>;
  searchTermImpressionsGbp: Array<SearchTermImpression>;
  /** Fetch the current sign product and its price */
  signProduct?: Maybe<SignProduct>;
  /** Get signage orders with optional filtering */
  signageOrders: SignageOrderConnection;
  /** Check if the current user has any signage orders */
  signageOrdersExist: Scalars['Boolean']['output'];
  signedUploadImageByKey?: Maybe<UploadItemImageByKey>;
  signedUploadImageUrl?: Maybe<UploadItemImage>;
  /** Get Square location details for a profile */
  squareLocation?: Maybe<SquareLocation>;
  /** List paired Square terminals for a location */
  squareTerminals: Array<SquareTerminal>;
  standingAppointmentCandidateWindows: Array<CandidateDockWindow>;
  standingAppointmentDirectory: Array<StandingAppointmentDirectoryEntry>;
  standingAppointmentGapDates: Array<Scalars['ISO8601Date']['output']>;
  standingAppointmentHistory: Array<StandingAppointment>;
  standingAppointmentVendors: Array<NetsuiteVendor>;
  /** Returns a single stop */
  stop: DeliveryStop;
  /** Return the in-progress SubscriptionSession during the Sign Up flow. */
  subscriptionSession: SubscriptionSession;
  supplierInvoiceComparison?: Maybe<SupplierInvoiceComparison>;
  supplierInvoiceComparisons: Array<SupplierInvoiceComparison>;
  /** Returns the authenticated user's supply cart at the given location, or null if none exists. */
  supplyCart?: Maybe<SupplyCart>;
  topSubcategoriesPerWarehouse: Array<WarehouseTopSubcategory>;
  /**
   * Locations matching a transaction-sync search term. Bounded and unpaginated: it
   * answers a type-ahead picker, so it returns a short best-effort list rather
   * than every match.
   */
  transactionSyncLocationSearch: Array<Location>;
  unitById?: Maybe<Unit>;
  unitByName?: Maybe<Unit>;
  units: Array<Unit>;
  /** Get all microsite locations associated with the current user */
  userMicrositeLocations: Array<UserMicrositeLocation>;
  /** Returns platform connection status and associated microsites for the user */
  userPlatformConnection: UserPlatformConnection;
  /** Get the current user's pricing package */
  userPricingPackage?: Maybe<PricingPackage>;
  /** The list of users. */
  users?: Maybe<Array<Maybe<User>>>;
  /** Validate email availability for marketing tools signup */
  validateEmailForSignup: EmailValidationResult;
  /** Validate microsite URL availability for signup */
  validateMicrositeUrl: MicrositeUrlValidationResult;
  vehicleInspectionReport: VehicleInspectionReport;
  vehicleInspectionReports: Array<VehicleInspectionReport>;
  vehicleInspectionStatus: VehicleInspectionStatus;
  vehicleInspectionTruckStatuses: Array<VehicleInspectionTruckStatus>;
  /** Get a vendor by ID */
  vendor?: Maybe<Vendor>;
  /** Returns all Vendor Orders for a given warehouse and night end */
  vendorOrders: Array<Order>;
  /** Returns the consolidated check-in view for a vendor: items aggregated across all customer orders */
  vendorReceivingCheckin: Array<VendorReceivingCheckinItem>;
  /** Returns vendors with open market-priced orders for a given warehouse and night end */
  vendorReceivingList: Array<VendorReceivingSummary>;
  /** Returns all vendors */
  vendors: Array<Vendor>;
  /** The currently authenticated user. */
  viewer?: Maybe<User>;
  /** Find warehouse by id */
  warehouse: Warehouse;
  warehouseBinLayout: WarehouseBinLayout;
  warehouseBinTransferCommand?: Maybe<WarehouseBinTransferCommand>;
  /** Get all items designated as bulk picked for a given warehouse */
  warehouseBulkPickedItems: WarehouseBulkPickedItemsConnection;
  warehouseCategoryMedians: Array<WarehouseCategoryMedian>;
  warehouseCommitmentDiscrepancies: WarehouseCommitmentDiscrepancyReport;
  warehouseCommitmentDiscrepancyLines: WarehouseCommitmentDiscrepancyLinesReport;
  warehouseCommitmentSummary: WarehouseCommitmentSummary;
  warehouseCutoffDiscrepancies: CutoffDiscrepancyReport;
  warehouseFulfillmentDiscrepancyLines: WarehouseFulfillmentDiscrepancyLinesReport;
  warehouseFulfillmentSummary: WarehouseFulfillmentSummary;
  warehouseItemTask?: Maybe<WarehouseItemTask>;
  warehouseItemTasks: WarehouseItemTaskConnection;
  warehouseLayoutBuilder: WarehouseLayoutBuilder;
  /** When 'Sync routes' last completed for the given warehouse and night end. */
  warehouseRoutesSyncStatus: WarehouseRoutesSyncStatus;
  /** Finds the source bin for a manual transfer. Null when no active bin in the warehouse has this label. */
  warehouseSourceBin?: Maybe<WarehouseSourceBin>;
  warehouseStageGateOrderLines: StageGateOrderLinesReport;
  warehouseSubcategoryThresholds: Array<WarehouseSubcategoryThreshold>;
  warehouseTasks: WarehouseTaskConnection;
  warehouseTrends: Array<WarehouseTrendDay>;
  /** Returns all warehouses */
  warehouses: Array<Warehouse>;
  workThread?: Maybe<WorkThread>;
  workThreads: Array<WorkThread>;
};


export type QueryAccountCreationSessionArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAccountsReceivableCompanyDashboardArgs = {
  arAssigneeUuid?: InputMaybe<Scalars['String']['input']>;
  asOf?: InputMaybe<Scalars['ISO8601Date']['input']>;
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAccountsReceivableDashboardArgs = {
  arAssigneeUuid?: InputMaybe<Scalars['String']['input']>;
  asOf?: InputMaybe<Scalars['ISO8601Date']['input']>;
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  groupBy?: InputMaybe<AccountsReceivableGroupBy>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAccountsReceivableLocationDashboardArgs = {
  arAssigneeUuid?: InputMaybe<Scalars['String']['input']>;
  asOf?: InputMaybe<Scalars['ISO8601Date']['input']>;
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
};


export type QueryActiveMasterHomepageArgs = {
  filter: MasterHomepageFilterInput;
};


export type QueryActiveZipcodesArgs = {
  zipcodes: Array<Scalars['String']['input']>;
};


export type QueryAllowanceRecipientsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AllowanceRecipientOrderBy>;
};


export type QueryApplicableRewardsArgs = {
  onDate: Scalars['ISO8601Date']['input'];
};


export type QueryApprovedCutoffDiscrepanciesArgs = {
  deliveryDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  warehouseId: Scalars['ID']['input'];
};


export type QueryArtworkUploadUrlArgs = {
  filename: Scalars['String']['input'];
};


export type QueryAssignableLocationsArgs = {
  companyOdekoUuid?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAssociateBadgePayloadsArgs = {
  employeeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  warehouseId: Scalars['ID']['input'];
};


export type QueryAuditReputationArgs = {
  locationUuid: Scalars['ID']['input'];
};


export type QueryAuditReputationGbpArgs = {
  googleLocationName: Scalars['String']['input'];
};


export type QueryAuthorizedMicrositeLocationArgs = {
  urlId: Scalars['ID']['input'];
};


export type QueryBaseBrandedItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBaseBrandedItemsArgs = {
  category?: InputMaybe<Scalars['ID']['input']>;
  printingMethod?: InputMaybe<PrintingMethod>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['ID']['input']>;
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBatchedDepositsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forDateRange?: InputMaybe<DateRangeInput>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BatchedDepositOrderBy>;
  totalCentsRange?: InputMaybe<IntRangeInput>;
};


export type QueryBrandedItemDealArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBrandedItemDealsArgs = {
  locationUuid: Scalars['ID']['input'];
};


export type QueryCalculateFullConsumerRefundArgs = {
  consumerOrderId: Scalars['ID']['input'];
  lockVersion: Scalars['Int']['input'];
};


export type QueryCalculatePartialConsumerRefundArgs = {
  consumerOrderId: Scalars['ID']['input'];
  lockVersion: Scalars['Int']['input'];
  refundItemInputs: Array<ConsumerRefundItemInput>;
  refundModifierInputs: Array<ConsumerRefundModifierInput>;
};


export type QueryCatalogFiltersArgs = {
  itemCountFilters?: InputMaybe<ItemsFiltersInput>;
  selected?: InputMaybe<CatalogFilterSelectedInput>;
};


export type QueryCatalogHomepageContentArgs = {
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  warehouseId: Scalars['ID']['input'];
};


export type QueryCatalogHomepageRowsArgs = {
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type QueryCategoriesArgs = {
  filter?: InputMaybe<CategoriesFilter>;
  forType?: InputMaybe<CategoryType>;
  sortOrder?: InputMaybe<Array<InputMaybe<CategoriesSortOrder>>>;
  warehouses?: InputMaybe<Array<ItemsWarehouseInput>>;
};


export type QueryCategoryBannerForEditArgs = {
  categoryId: Scalars['ID']['input'];
};


export type QueryCategoryByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCategoryByNameArgs = {
  name: Scalars['String']['input'];
};


export type QueryCheckInEntriesCsvArgs = {
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  micrositeLocationId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};


export type QueryCheckInStatsArgs = {
  micrositeLocationId: Scalars['ID']['input'];
};


export type QueryCheckInStatusArgs = {
  email: Scalars['String']['input'];
  micrositeLocationId: Scalars['ID']['input'];
};


export type QueryCollectionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCollectionBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryCollectionSetupForEditArgs = {
  collectionId: Scalars['ID']['input'];
};


export type QueryCompaniesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCompanyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryConfigArgs = {
  asOf?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};


export type QueryConfigsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ConfigOrderBy>;
};


export type QueryConsumerOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryConversionMetricsArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  locationUuid: Scalars['ID']['input'];
  startDate: Scalars['ISO8601Date']['input'];
};


export type QueryConversionMetricsGbpArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  googleLocationName: Scalars['String']['input'];
  startDate: Scalars['ISO8601Date']['input'];
};


export type QueryCustomerLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: CustomerLocationsInput;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCustomerTagImportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCustomerTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<CustomerTagCategoryEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<CustomerTagSortInput>;
  source?: InputMaybe<CustomerTagSourceEnum>;
};


export type QueryDeliveryForAddressArgs = {
  address: Scalars['String']['input'];
};


export type QueryDeliveryInstructionReviewStatusArgs = {
  instructionRevision: Scalars['String']['input'];
  redelivery?: InputMaybe<Scalars['Boolean']['input']>;
  stopId: Scalars['ID']['input'];
};


export type QueryDeliveryOverrideAffectedDeliveriesArgs = {
  audience?: InputMaybe<DeliveryOverrideAudienceInput>;
  deliveryDate: Scalars['ISO8601Date']['input'];
  locationId?: InputMaybe<Scalars['ID']['input']>;
  reachMode?: InputMaybe<DeliveryOverrideReachModeEnum>;
  scope?: InputMaybe<DeliveryOverrideScopeEnum>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryDeliveryOverrideLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters: DeliveryOverrideLocationFiltersInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDeliveryOverridePreviewArgs = {
  audience?: InputMaybe<DeliveryOverrideAudienceInput>;
  dayAction?: InputMaybe<DeliveryOverrideDayActionEnum>;
  deliveryDate: Scalars['ISO8601Date']['input'];
  leadTime?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  orderDeadline?: InputMaybe<Scalars['String']['input']>;
  reachMode?: InputMaybe<DeliveryOverrideReachModeEnum>;
  scope?: InputMaybe<DeliveryOverrideScopeEnum>;
  substituteDeliveryDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryDeliveryOverrideRulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['ISO8601Date']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['ISO8601Date']['input']>;
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryDeliveryPriceArgs = {
  deliveryPriceInput: DeliveryPriceInput;
};


export type QueryDockBookingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDockBookingByReferenceArgs = {
  referenceNumber: Scalars['String']['input'];
};


export type QueryDockBookingsArgs = {
  date: Scalars['ISO8601Date']['input'];
  warehouseId: Scalars['ID']['input'];
};


export type QueryDockBookingsRangeArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  startDate: Scalars['ISO8601Date']['input'];
  warehouseId: Scalars['ID']['input'];
};


export type QueryDockOpenVisitsArgs = {
  dockId?: InputMaybe<Scalars['ID']['input']>;
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryDockWarehouseCapacityArgs = {
  warehouseId: Scalars['ID']['input'];
};


export type QueryDockWarehouseClosedDaysArgs = {
  warehouseId: Scalars['ID']['input'];
};


export type QueryDocksArgs = {
  warehouseId: Scalars['ID']['input'];
};


export type QueryDriverLocationTrailArgs = {
  input: DriverLocationTrailInput;
};


export type QueryExpectedPurchaseOrdersArgs = {
  warehouseId: Scalars['ID']['input'];
};


export type QueryExpectedTransferOrdersArgs = {
  warehouseId: Scalars['ID']['input'];
};


export type QueryExternalSupplierArgs = {
  odekoUuid: Scalars['ID']['input'];
};


export type QueryExternalSuppliersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFeatureFlagEnabledArgs = {
  flagName: Scalars['String']['input'];
};


export type QueryFieldServiceZipcodesArgs = {
  warehouseId: Scalars['ID']['input'];
};


export type QueryGamesArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryGeneratePunchOutOrderMessageArgs = {
  cart: Array<PunchOutCartItemInput>;
};


export type QueryGetChatMessageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetPricingPackageArgs = {
  integerPricingPackageId: Scalars['Int']['input'];
};


export type QueryInProgressCustomerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInProgressCustomerAcquisitionSummaryArgs = {
  acquisitionConversionId: Scalars['ID']['input'];
};


export type QueryInProgressCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<InProgressCustomersSearchInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryInventoryCurrentCountArgs = {
  locationItemId: Scalars['ID']['input'];
  stockCountId: Scalars['ID']['input'];
};


export type QueryInventoryLocationItemArgs = {
  locationId: Scalars['ID']['input'];
  odekoItemId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryInventoryStockCountByIdArgs = {
  stockCountId: Scalars['ID']['input'];
};


export type QueryInvoiceMatchCandidatesArgs = {
  input: InvoiceMatchCandidatesInput;
};


export type QueryIsPastWarehouseCutOffTimeArgs = {
  input: IsPastWarehouseCutOffTimeInput;
};


export type QueryIsRoutesSyncEnabledArgs = {
  input: IsRoutesSyncEnabledInput;
};


export type QueryItemBrandsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ItemBrandsFiltersInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<Array<InputMaybe<ItemBrandsSortOrder>>>;
};


export type QueryItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  analyticsTags?: InputMaybe<AlgoliaAnalyticsTagInput>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ItemsFiltersInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Array<InputMaybe<ItemsSortOrder>>>;
};


export type QueryLastReplenishmentTripArgs = {
  taskId: Scalars['ID']['input'];
};


export type QueryLeaderboardEntriesArgs = {
  leaderboardId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  ranked?: InputMaybe<Scalars['Boolean']['input']>;
  recent?: InputMaybe<Scalars['Boolean']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLeaderboardRankingsArgs = {
  gameSlug?: InputMaybe<Scalars['String']['input']>;
  leaderboardId?: InputMaybe<Scalars['ID']['input']>;
  leaderboardSlug?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  micrositeLocationId?: InputMaybe<Scalars['ID']['input']>;
  period: RankingPeriodEnum;
};


export type QueryLeaderboardsArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  gameId?: InputMaybe<Scalars['ID']['input']>;
  gameSlug?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  leaderboardType?: InputMaybe<LeaderboardTypeEnum>;
};


export type QueryListingImpressionsArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  locationUuid: Scalars['ID']['input'];
  startDate: Scalars['ISO8601Date']['input'];
};


export type QueryListingImpressionsGbpArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  googleLocationName: Scalars['String']['input'];
  startDate: Scalars['ISO8601Date']['input'];
};


export type QueryLocationArgs = {
  encryptedLocationId?: InputMaybe<Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  odekoUuid?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryLocationItemsByItemIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLocationOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: LocationOrdersInput;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLocationPastOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: LocationPastOrdersInput;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLocationPricesArgs = {
  locationId: Scalars['ID']['input'];
};


export type QueryLocationUpcomingOrdersArgs = {
  input: LocationUpcomingOrdersInput;
};


export type QueryMailingListSubmissionsCsvArgs = {
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  micrositeLocationId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};


export type QueryMarketingQrCodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assigned?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMarketingToolsUsersArgs = {
  micrositeLocationId: Scalars['ID']['input'];
};


export type QueryMasterHomepageForEditArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMerchantArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMerchantByDatabaseIdArgs = {
  databaseId: Scalars['Int']['input'];
};


export type QueryMerchantByUuidArgs = {
  uuid: Scalars['ID']['input'];
};


export type QueryMerchantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  business?: InputMaybe<BusinessSearchInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  near?: InputMaybe<GeospatialCircle>;
};


export type QueryMicrositeAdminLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasSignageOrder?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<MicrositesSortDirection>;
  sortKey?: InputMaybe<MicrositesSortKey>;
};


export type QueryMicrositeLocationArgs = {
  urlId: Scalars['ID']['input'];
};


export type QueryMicrositeScansArgs = {
  googleLocationName?: InputMaybe<Scalars['String']['input']>;
  urlSlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNewItemMarketsForItemArgs = {
  itemId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
};


export type QueryNewItemPinsArgs = {
  warehouseId: Scalars['ID']['input'];
};


export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryNonInventoryVendorsArgs = {
  search: Scalars['String']['input'];
};


export type QueryOrderArgs = {
  orderId: Scalars['ID']['input'];
};


export type QueryOrderingRulesArgs = {
  items: Array<OrderingRuleItemInput>;
  locationId: Scalars['ID']['input'];
};


export type QueryOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: OrdersInput;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOutboundGatesArgs = {
  deliveryDate: Scalars['ISO8601Date']['input'];
  warehouseId: Scalars['ID']['input'];
};


export type QueryPastHomepageCollectionsArgs = {
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type QueryPickHoursScorecardArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  startDate: Scalars['ISO8601Date']['input'];
  warehouseId: Scalars['ID']['input'];
};


export type QueryPickupScheduleArgs = {
  asOf?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  menuItemIds: Array<Scalars['ID']['input']>;
  merchantId: Scalars['ID']['input'];
};


export type QueryPlatformAuthorizeUrlArgs = {
  action: PlatformActions;
  platformId: PlatformIds;
  redirectUri: Scalars['String']['input'];
};


export type QueryPlatformConnectionArgs = {
  locationUuid: Scalars['ID']['input'];
  platformId: PlatformIds;
};


export type QueryPlatformProfilesArgs = {
  platformId: Scalars['String']['input'];
};


export type QueryProcessPathCatalogArgs = {
  warehouseId: Scalars['ID']['input'];
};


export type QueryProcessPathComplianceArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  startDate: Scalars['ISO8601Date']['input'];
  warehouseId: Scalars['ID']['input'];
};


export type QueryProcessPathCoverageTargetsArgs = {
  warehouseId: Scalars['ID']['input'];
  weekStart: Scalars['ISO8601Date']['input'];
};


export type QueryProcessPathEmployeeDayArgs = {
  date: Scalars['ISO8601Date']['input'];
  employeeId: Scalars['ID']['input'];
  warehouseId: Scalars['ID']['input'];
};


export type QueryProcessPathEmployeeThroughputArgs = {
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  endDate: Scalars['ISO8601Date']['input'];
  startDate: Scalars['ISO8601Date']['input'];
  warehouseId: Scalars['ID']['input'];
};


export type QueryProcessPathFloorArgs = {
  warehouseId: Scalars['ID']['input'];
};


export type QueryProcessPathHourlyTotalsArgs = {
  date: Scalars['ISO8601Date']['input'];
  warehouseId: Scalars['ID']['input'];
};


export type QueryProcessPathMeasuredPickDaysArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  startDate: Scalars['ISO8601Date']['input'];
  warehouseId: Scalars['ID']['input'];
};


export type QueryProcessPathRosterArgs = {
  statuses?: InputMaybe<Array<WarehouseAssociateStatus>>;
  warehouseId: Scalars['ID']['input'];
};


export type QueryProcessPathScanDaysArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  processPathCode?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['ISO8601Date']['input'];
  warehouseId: Scalars['ID']['input'];
};


export type QueryProcessPathScanHistoryStartArgs = {
  processPathCode?: InputMaybe<Scalars['String']['input']>;
  warehouseId: Scalars['ID']['input'];
};


export type QueryProcessPathSelfContextArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryProcessPathThroughputArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  startDate: Scalars['ISO8601Date']['input'];
  warehouseId: Scalars['ID']['input'];
};


export type QueryProcessPathWeeklyActualsArgs = {
  warehouseId: Scalars['ID']['input'];
  weekStart: Scalars['ISO8601Date']['input'];
};


export type QueryProcessPathWeeklyForecastArgs = {
  warehouseId: Scalars['ID']['input'];
  weekStart: Scalars['ISO8601Date']['input'];
};


export type QueryProcessPathsArgs = {
  warehouseId: Scalars['ID']['input'];
};


export type QueryProcurementCorrespondenceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProcurementInboundCoverageArgs = {
  since?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};


export type QueryProcurementInboxArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProcurementMailDownloadArgs = {
  id: Scalars['ID']['input'];
  kind: Scalars['String']['input'];
};


export type QueryProcurementMailboxCursorArgs = {
  mailbox: Scalars['String']['input'];
};


export type QueryProcurementPoTrackingArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProcurementPoTrackingsArgs = {
  needsReply?: InputMaybe<Scalars['Boolean']['input']>;
  trackingStatus?: InputMaybe<Scalars['String']['input']>;
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProcurementTrackingVendorArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProcurementTrackingVendorsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductInventoryArgs = {
  productId: Scalars['ID']['input'];
};


export type QueryPublicDockBookingArgs = {
  referenceNumber: Scalars['String']['input'];
};


export type QueryPublicDockCheckInLookupArgs = {
  reference: Scalars['String']['input'];
};


export type QueryPublicDockDisplayArgs = {
  dockId: Scalars['ID']['input'];
};


export type QueryPublicDockOpenVisitsArgs = {
  dockId?: InputMaybe<Scalars['ID']['input']>;
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPublicDockWarehousesArgs = {
  code: Scalars['String']['input'];
};


export type QueryPublicOverrideSlotsArgs = {
  code: Scalars['String']['input'];
  date: Scalars['ISO8601Date']['input'];
  freightType: FreightType;
  scacCode?: InputMaybe<Scalars['String']['input']>;
  warehouseId: Scalars['ID']['input'];
};


export type QueryPublicOverrideVendorArgs = {
  code: Scalars['String']['input'];
};


export type QueryPutawayPriorityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sourcePickZoneGroup?: InputMaybe<PutawayPickZoneGroup>;
  warehouseId: Scalars['ID']['input'];
};


export type QueryPutawayReportArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['ISO8601Date']['input'];
  warehouseId: Scalars['ID']['input'];
};


export type QueryQrScanAnalyticsArgs = {
  qrCodeId: Scalars['ID']['input'];
};


export type QueryReceivableNotesArgs = {
  locationUuid: Scalars['String']['input'];
};


export type QueryRecentTransactionSyncsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRedeliveryStopArgs = {
  input: RedeliveryStopInput;
};


export type QueryRfsmartCredentialsArgs = {
  employeeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  warehouseId: Scalars['ID']['input'];
};


export type QueryRfsmartPendingRemovalsArgs = {
  warehouseId: Scalars['ID']['input'];
};


export type QueryRfsmartPooledCredentialsArgs = {
  assigned?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseId: Scalars['ID']['input'];
};


export type QueryRouteArgs = {
  input: RouteInput;
};


export type QueryRoutesArgs = {
  input: RoutesInput;
};


export type QueryRoutingImportPlanArgs = {
  input: RoutingImportPlanInput;
};


export type QuerySalesPriorityListArgs = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  includeSuppressed?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  maxSpendCents?: InputMaybe<Scalars['Int']['input']>;
  minCompositeScore?: InputMaybe<Scalars['Int']['input']>;
  onlyDeprioritized?: InputMaybe<Scalars['Boolean']['input']>;
  repId?: InputMaybe<Scalars['ID']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SalesPrioritySortByEnum>;
  suggestedActions?: InputMaybe<Array<SuggestedActionEnum>>;
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySearchTermImpressionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationUuid: Scalars['ID']['input'];
};


export type QuerySearchTermImpressionsGbpArgs = {
  googleLocationName: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySignageOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subscriptionSessionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySignedUploadImageByKeyArgs = {
  key: Scalars['String']['input'];
};


export type QuerySignedUploadImageUrlArgs = {
  extension: Scalars['String']['input'];
};


export type QuerySquareLocationArgs = {
  profileId: Scalars['String']['input'];
};


export type QuerySquareTerminalsArgs = {
  accountProfileId: Scalars['ID']['input'];
  squareLocationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryStandingAppointmentCandidateWindowsArgs = {
  date: Scalars['ISO8601Date']['input'];
  standingAppointmentId: Scalars['ID']['input'];
};


export type QueryStandingAppointmentDirectoryArgs = {
  warehouseId: Scalars['ID']['input'];
};


export type QueryStandingAppointmentGapDatesArgs = {
  standingAppointmentId: Scalars['ID']['input'];
};


export type QueryStandingAppointmentHistoryArgs = {
  netsuiteInternalId: Scalars['String']['input'];
  warehouseId: Scalars['ID']['input'];
};


export type QueryStandingAppointmentVendorsArgs = {
  search: Scalars['String']['input'];
};


export type QueryStopArgs = {
  input: StopInput;
};


export type QuerySubscriptionSessionArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySupplierInvoiceComparisonArgs = {
  odekoUuid: Scalars['ID']['input'];
};


export type QuerySupplyCartArgs = {
  locationId: Scalars['ID']['input'];
};


export type QueryTopSubcategoriesPerWarehouseArgs = {
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTransactionSyncLocationSearchArgs = {
  term: Scalars['String']['input'];
};


export type QueryUnitByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUnitByNameArgs = {
  name: Scalars['String']['input'];
};


export type QueryUnitsArgs = {
  sortOrder?: InputMaybe<Array<InputMaybe<UnitSortOrder>>>;
  unitType?: InputMaybe<UnitType>;
};


export type QueryUserPlatformConnectionArgs = {
  platformId: PlatformIds;
};


export type QueryUsersArgs = {
  role: Scalars['String']['input'];
};


export type QueryValidateEmailForSignupArgs = {
  email: Scalars['String']['input'];
};


export type QueryValidateMicrositeUrlArgs = {
  url: Scalars['String']['input'];
};


export type QueryVehicleInspectionReportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVehicleInspectionReportsArgs = {
  from: Scalars['ISO8601DateTime']['input'];
  to: Scalars['ISO8601DateTime']['input'];
  truckId: Scalars['ID']['input'];
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryVehicleInspectionStatusArgs = {
  deliveryRouteId: Scalars['ID']['input'];
};


export type QueryVehicleInspectionTruckStatusesArgs = {
  from: Scalars['ISO8601DateTime']['input'];
  to: Scalars['ISO8601DateTime']['input'];
  warehouseId: Scalars['ID']['input'];
};


export type QueryVendorArgs = {
  vendorId: Scalars['ID']['input'];
};


export type QueryVendorOrdersArgs = {
  input: VendorOrdersInput;
};


export type QueryVendorReceivingCheckinArgs = {
  input: VendorReceivingCheckinInput;
};


export type QueryVendorReceivingListArgs = {
  input: VendorReceivingListInput;
};


export type QueryWarehouseArgs = {
  warehouseId: Scalars['ID']['input'];
};


export type QueryWarehouseBinLayoutArgs = {
  warehouseId: Scalars['ID']['input'];
};


export type QueryWarehouseBinTransferCommandArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWarehouseBulkPickedItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: WarehouseBulkPickedItemsInput;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWarehouseCategoryMediansArgs = {
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryWarehouseCommitmentDiscrepanciesArgs = {
  deliveryDate: Scalars['ISO8601Date']['input'];
  warehouseId: Scalars['ID']['input'];
};


export type QueryWarehouseCommitmentDiscrepancyLinesArgs = {
  deliveryDate: Scalars['ISO8601Date']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  warehouseId: Scalars['ID']['input'];
};


export type QueryWarehouseCommitmentSummaryArgs = {
  deliveryDate: Scalars['ISO8601Date']['input'];
  warehouseId: Scalars['ID']['input'];
};


export type QueryWarehouseCutoffDiscrepanciesArgs = {
  deliveryDate: Scalars['ISO8601Date']['input'];
  warehouseId: Scalars['ID']['input'];
};


export type QueryWarehouseFulfillmentDiscrepancyLinesArgs = {
  deliveryDate: Scalars['ISO8601Date']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  warehouseId: Scalars['ID']['input'];
};


export type QueryWarehouseFulfillmentSummaryArgs = {
  deliveryDate: Scalars['ISO8601Date']['input'];
  warehouseId: Scalars['ID']['input'];
};


export type QueryWarehouseItemTaskArgs = {
  itemNetsuiteId: Scalars['String']['input'];
  taskTypes: Array<WarehouseTaskType>;
  warehouseId: Scalars['ID']['input'];
  workstreams?: InputMaybe<Array<WarehouseTaskWorkstream>>;
};


export type QueryWarehouseItemTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<WarehouseItemTaskFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  taskTypes: Array<WarehouseTaskType>;
  warehouseId: Scalars['ID']['input'];
};


export type QueryWarehouseLayoutBuilderArgs = {
  warehouseId: Scalars['ID']['input'];
};


export type QueryWarehouseRoutesSyncStatusArgs = {
  nightEnd: Scalars['ISO8601Date']['input'];
  warehouseId: Scalars['ID']['input'];
};


export type QueryWarehouseSourceBinArgs = {
  binName: Scalars['String']['input'];
  warehouseId: Scalars['ID']['input'];
};


export type QueryWarehouseStageGateOrderLinesArgs = {
  deliveryDate: Scalars['ISO8601Date']['input'];
  step: StageGateStep;
  warehouseId: Scalars['ID']['input'];
};


export type QueryWarehouseSubcategoryThresholdsArgs = {
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryWarehouseTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<WarehouseTaskFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  taskTypes: Array<WarehouseTaskType>;
  warehouseId: Scalars['ID']['input'];
};


export type QueryWarehouseTrendsArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  startDate: Scalars['ISO8601Date']['input'];
  warehouseId: Scalars['ID']['input'];
};


export type QueryWorkThreadArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWorkThreadsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Different time periods for leaderboard rankings */
export enum RankingPeriodEnum {
  /** All-time rankings */
  AllTime = 'ALL_TIME',
  /** Current day rankings */
  Daily = 'DAILY',
  /** Current month rankings */
  Monthly = 'MONTHLY',
  /** Current week rankings */
  Weekly = 'WEEKLY'
}

export type Rating = {
  __typename?: 'Rating';
  allTime?: Maybe<Scalars['Float']['output']>;
  current?: Maybe<Scalars['Float']['output']>;
};

/** An edge in a connection. */
export type ReachedLocationEdge = {
  __typename?: 'ReachedLocationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Location>;
};

/** The connection type for Location. */
export type ReachedLocationsConnection = {
  __typename?: 'ReachedLocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ReachedLocationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Location>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of records in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** Autogenerated input type of RebuildCartFromPastOrder */
export type RebuildCartFromPastOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Opaque token identifying a specific version of the cart. */
  fingerprint: Scalars['String']['input'];
  /** The order's primary key from the database. */
  orderDatabaseId: Scalars['Int']['input'];
};

/** Autogenerated return type of RebuildCartFromPastOrder */
export type RebuildCartFromPastOrderPayload = {
  __typename?: 'RebuildCartFromPastOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to rebuild cart from past order. */
  result: CartResult;
};

/** Autogenerated input type of RecalculateCartPrices */
export type RecalculateCartPricesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Opaque token identifying a specific version of the cart. */
  fingerprint: Scalars['String']['input'];
  /** Intended payment method. This affects service fee. */
  paymentMethod: PaymentMethod;
};

/** Autogenerated return type of RecalculateCartPrices */
export type RecalculateCartPricesPayload = {
  __typename?: 'RecalculateCartPricesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to set tip. */
  result: CartResult;
};

export type ReceivableNote = {
  __typename?: 'ReceivableNote';
  authorEmail: Scalars['String']['output'];
  authorId: Scalars['String']['output'];
  body: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  invoiceUuid?: Maybe<Scalars['String']['output']>;
  locationUuid: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type RecentDeliveriesPresent = UserErrorInterface & {
  __typename?: 'RecentDeliveriesPresent';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  offenders: Array<RecentDeliveryLocation>;
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** A location that recently took a delivery on a driven route, and the evidence. */
export type RecentDeliveryLocation = {
  __typename?: 'RecentDeliveryLocation';
  lastNightEnd?: Maybe<Scalars['ISO8601Date']['output']>;
  locationId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  stopCount: Scalars['Int']['output'];
};

export type Recipe = {
  __typename?: 'Recipe';
  id: Scalars['ID']['output'];
  ingredients: Array<RecipeIngredient>;
  menuItemSizeUuid: Scalars['ID']['output'];
  menuItemUuid: Scalars['ID']['output'];
};

export type RecipeIngredient = {
  __typename?: 'RecipeIngredient';
  id: Scalars['ID']['output'];
  ingredientId: Scalars['ID']['output'];
  ingredientType: IngredientTypeEnum;
  quantity: Scalars['Float']['output'];
  unit: Unit;
};

export type RecipeIngredientInput = {
  /** ID of ingredient */
  ingredientId: Scalars['ID']['input'];
  /** Type of ingredient */
  ingredientType: IngredientTypeEnum;
  /** Quantity portion of how much was used of ingredient */
  quantity: Scalars['Float']['input'];
  /** ID of unit portion of how much was used of ingredient */
  unit: Scalars['ID']['input'];
};

export enum RecipientPhoneAvailability {
  /** The recipient number is available to contact. */
  Available = 'AVAILABLE',
  /** The recipient has not allowed after-hours contact. */
  HiddenAfterHours = 'HIDDEN_AFTER_HOURS',
  /** No recipient number has been provided. */
  NotProvided = 'NOT_PROVIDED'
}

export type RecipientPhoneNumber = {
  __typename?: 'RecipientPhoneNumber';
  availability: RecipientPhoneAvailability;
  number?: Maybe<Scalars['String']['output']>;
};

export enum RecommendationFeedbackReason {
  DifferentSupplier = 'DIFFERENT_SUPPLIER',
  DontCarry = 'DONT_CARRY',
  NotRunningLow = 'NOT_RUNNING_LOW',
  Other = 'OTHER',
  PriceTooHigh = 'PRICE_TOO_HIGH'
}

export enum RecommendationFeedbackType {
  Permanent = 'PERMANENT',
  Temporary = 'TEMPORARY'
}

export type ReconciledOrderLine = {
  __typename?: 'ReconciledOrderLine';
  id: Scalars['ID']['output'];
  imageUrls?: Maybe<Array<Scalars['String']['output']>>;
  oosOrderUnitQuantity?: Maybe<Scalars['Int']['output']>;
  reasons?: Maybe<Array<Scalars['String']['output']>>;
  updatedOrderUnitQuantity?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of RecordDriverLocationPings */
export type RecordDriverLocationPingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Route the fixes were recorded on. */
  deliveryRouteId: Scalars['ID']['input'];
  /** Batch of location fixes drained from the device's offline queue. */
  pings: Array<DriverLocationPingInput>;
};

/** Autogenerated return type of RecordDriverLocationPings. */
export type RecordDriverLocationPingsPayload = {
  __typename?: 'RecordDriverLocationPingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Number of new pings persisted (duplicates from offline-queue replay are skipped). */
  recordedCount: Scalars['Int']['output'];
  userErrors: Array<UserError>;
};

/** Autogenerated input type of RecordManualBinTransfer */
export type RecordManualBinTransferInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Destination bin display name, as printed on the bin label. */
  destinationBinName: Scalars['String']['input'];
  idempotencyKey: Scalars['ID']['input'];
  /** InventoryItem id the lot was listed for, as passed to warehouseSourceBin.lots. */
  inventoryItemId: Scalars['ID']['input'];
  /** Lot id from warehouseSourceBin.lots. */
  lotId: Scalars['ID']['input'];
  /** Quantity to move, in the item's NetSuite stock unit, as a decimal string such as "15.0". */
  stockUnitQuantity: Scalars['String']['input'];
};

/** Autogenerated return type of RecordManualBinTransfer. */
export type RecordManualBinTransferPayload = {
  __typename?: 'RecordManualBinTransferPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  command?: Maybe<WarehouseBinTransferCommand>;
  userErrors: Array<UserError>;
};

/** Autogenerated input type of RecordReplenishmentPick */
export type RecordReplenishmentPickInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Destination bin NetSuite internal id. Provide this or destinationBinName, not both. */
  destinationBinInternalId?: InputMaybe<Scalars['String']['input']>;
  /** Destination bin display name, as printed on the bin label. Provide this or destinationBinInternalId, not both. */
  destinationBinName?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey: Scalars['ID']['input'];
  /** Lot of the chosen source option. Required when the bin holds more than one lot of the item. */
  inventoryNumberNetsuiteId?: InputMaybe<Scalars['String']['input']>;
  /** NetSuite id of the reserve bin the stock is pulled from, one of the task's source options. */
  sourceBinNetsuiteId: Scalars['String']['input'];
  /** Quantity to move, in the item's NetSuite stock unit (not purchase cases or eaches), as a decimal string such as "15.0". */
  stockUnitQuantity: Scalars['String']['input'];
  /** ReplenTask id from the warehouseTasks query. */
  taskId: Scalars['ID']['input'];
};

/** Autogenerated return type of RecordReplenishmentPick. */
export type RecordReplenishmentPickPayload = {
  __typename?: 'RecordReplenishmentPickPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  command?: Maybe<WarehouseBinTransferCommand>;
  userErrors: Array<UserError>;
};

export type RecoveryQuantityOutOfRange = UserErrorInterface & {
  __typename?: 'RecoveryQuantityOutOfRange';
  /** The recovery_quantity value the client tried to write. */
  attempted: Scalars['Int']['output'];
  errorCode: Scalars['String']['output'];
  /** Inclusive upper bound of the valid range. The valid range for recovery_quantity is [0, maxAllowed]. */
  maxAllowed: Scalars['Int']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** The order line whose recovery_quantity write was rejected. */
  orderLineId: Scalars['ID']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type Redelivery = {
  __typename?: 'Redelivery';
  /** The time the driver arrived at the stop */
  arrivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  attachments?: Maybe<Array<Attachment>>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  compostCollectedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  compostCollectionRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Every geofence enter/exit crossing recorded for the stop, oldest first (admin only; empty list for other callers). */
  crossingEvents: Array<StopCrossingEvent>;
  deliveryNote?: Maybe<Scalars['String']['output']>;
  /** Redelivery stop status used in the driver app. Compares delivered quantity to ordered quantity. */
  deliveryStatus: DeliveryStatus;
  /** stop status used in the DMP */
  deliveryStatusDmp: DeliveryStatusDmp;
  /** Redelivery stop status used in the driver app. Compares delivered quantity to fulfilled quantity. */
  deliveryStatusDriver: DeliveryStatusDriver;
  deliveryStop: Delivery;
  /** The time the driver departed from the stop */
  departedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  donationCollectedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  donationRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Seconds the driver was stopped (departed_at - arrived_at), or null if either is missing */
  dwellSeconds?: Maybe<Scalars['Int']['output']>;
  hasRepeatedAccessIssues: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  issues?: Maybe<Array<Issue>>;
  location?: Maybe<Location>;
  orders?: Maybe<Array<Order>>;
  /**
   * This redelivery stop's order on a third-party provider, from the newest
   * dispatch that has a row for it. Null for a stop no provider has been given.
   */
  providerDelivery?: Maybe<ProviderDelivery>;
  reminderMessage?: Maybe<Scalars['String']['output']>;
  /** Repeated access issue descriptions */
  repeatedAccessIssues: Array<Scalars['String']['output']>;
  /** The latest time the driver was detected leaving the stop again after completion, if they returned */
  returnedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** How many times the driver returned to the stop after completing it */
  revisitCount: Scalars['Int']['output'];
  route: Route;
  sequenceNumber?: Maybe<Scalars['String']['output']>;
  upsellNote?: Maybe<Scalars['String']['output']>;
  viewedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Enter/exit crossings paired into visits with per-visit dwell, oldest first (admin only; empty list for other callers). */
  visits: Array<StopVisit>;
};

/** Autogenerated input type of RedeliveryStopCreate */
export type RedeliveryStopCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Redelivery night end. */
  nightEnd: Scalars['ISO8601Date']['input'];
  /** ID of the stops to create redeliveries. */
  stopIds: Array<Scalars['ID']['input']>;
  /** Warehouse id. */
  warehouseId: Scalars['ID']['input'];
};

/** Autogenerated return type of RedeliveryStopCreate. */
export type RedeliveryStopCreatePayload = {
  __typename?: 'RedeliveryStopCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  redeliveryStops?: Maybe<Array<Redelivery>>;
  userErrors: Array<RedeliveryStopError>;
};

/** Autogenerated input type of RedeliveryStopDelete */
export type RedeliveryStopDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Redelivery stop id. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RedeliveryStopDelete. */
export type RedeliveryStopDeletePayload = {
  __typename?: 'RedeliveryStopDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userErrors: Array<DeliveryRouteStopError>;
};

/** Redelivery stop possible error types */
export type RedeliveryStopError = InvalidNightEnd | StopWithProvider | StopsBusy;

export type RedeliveryStopInput = {
  id: Scalars['ID']['input'];
};

export enum RefrigerationState {
  Frozen = 'FROZEN',
  Refrigerated = 'REFRIGERATED',
  RoomTemp = 'ROOM_TEMP'
}

/** Error indicating a request attempted to refund too many items. */
export type RefundingTooManyItems = Error & {
  __typename?: 'RefundingTooManyItems';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Error indicating a request attempted to refund too many modifiers. */
export type RefundingTooManyModifiers = Error & {
  __typename?: 'RefundingTooManyModifiers';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

export type RelativeTime = {
  __typename?: 'RelativeTime';
  /** Seconds. */
  seconds: Scalars['Int']['output'];
};

export type RelativeTimeInput = {
  /** Seconds. */
  seconds: Scalars['Int']['input'];
};

/** Autogenerated input type of RemoveAllFromCart */
export type RemoveAllFromCartInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Opaque token identifying a specific version of the cart. */
  fingerprint: Scalars['String']['input'];
};

/** Autogenerated return type of RemoveAllFromCart */
export type RemoveAllFromCartPayload = {
  __typename?: 'RemoveAllFromCartPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to remove items from the cart. */
  result: CartResult;
};

/** Input for removing an item from the cart. */
export type RemoveCartItemInput = {
  /** CartItem ID */
  cartItemId: Scalars['ID']['input'];
};

/** Autogenerated input type of RemoveCustomerTagMutation */
export type RemoveCustomerTagMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Odeko UUID of the location to remove the tag from. */
  locationId: Scalars['ID']['input'];
  /** Id of the tag to remove, as returned by CustomerTag.id. */
  tagId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveCustomerTagMutation. */
export type RemoveCustomerTagMutationPayload = {
  __typename?: 'RemoveCustomerTagMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  location?: Maybe<Location>;
};

/** Autogenerated input type of RemoveFavoriteConsumerOrder */
export type RemoveFavoriteConsumerOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Favorite consumer order ID. */
  favoriteConsumerOrderId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveFavoriteConsumerOrder */
export type RemoveFavoriteConsumerOrderPayload = {
  __typename?: 'RemoveFavoriteConsumerOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to remove the favorite. */
  result: FavoriteConsumerOrderResult;
};

/** Autogenerated input type of RemoveItemsFromCart */
export type RemoveItemsFromCartInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Opaque token identifying a specific version of the cart. */
  fingerprint: Scalars['String']['input'];
  /** Input describing which items to remove. */
  removals: Array<RemoveCartItemInput>;
};

/** Autogenerated return type of RemoveItemsFromCart */
export type RemoveItemsFromCartPayload = {
  __typename?: 'RemoveItemsFromCartPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to remove items from the cart. */
  result: CartResult;
};

export type RemoveNewItemPinInput = {
  itemId: Scalars['ID']['input'];
  warehouseId: Scalars['ID']['input'];
};

/** Autogenerated input type of RemoveReward */
export type RemoveRewardInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Opaque token identifying a specific version of the cart. */
  fingerprint: Scalars['String']['input'];
};

/** Autogenerated return type of RemoveReward */
export type RemoveRewardPayload = {
  __typename?: 'RemoveRewardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to remove reward. */
  result: CartResult;
};

export type RemoveSubstitutionOverrideInput = {
  id: Scalars['ID']['input'];
};

export type ReorderNewItemPinInput = {
  itemId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
};

export type ReorderNewItemPinsInput = {
  /** The full replacement set; subrank is auto-sequenced by order within each position. */
  pins: Array<ReorderNewItemPinInput>;
  warehouseId: Scalars['ID']['input'];
};

/** Task counts for one cohort over the whole cover-days window, before any cohort, zone or task filter. */
export type ReplenCohortCount = {
  __typename?: 'ReplenCohortCount';
  cohort: ReplenTaskCohort;
  /** Actionable tasks with nothing still short. A blocked task is never counted as covered. */
  coveredCount: Scalars['Int']['output'];
  /**
   * Tasks in the cohort whose item has no usable cases per pallet. Blocked tasks
   * are never counted. A covered task with missing pallet info is counted in both
   * coveredCount and missingInfoCount.
   */
  missingInfoCount: Scalars['Int']['output'];
  /** Blocked tasks in the cohort. */
  needsReviewCount: Scalars['Int']['output'];
  /** Every task in the cohort, covered or blocked included. */
  totalCount: Scalars['Int']['output'];
};

export type ReplenTask = WarehouseTask & {
  __typename?: 'ReplenTask';
  cohort: ReplenTaskCohort;
  destinationBinNames: Array<Scalars['String']['output']>;
  destinationBins: Array<ReplenTaskDestinationBin>;
  /**
   * Eaches in one purchase case, as a decimal string; 1 for an each-only item.
   * Null when the item's unit configuration is missing or invalid. Present on
   * every task, including blocked ones.
   */
  eachesPerCase?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Federated entity reference; name, UPC codes and refrigeration state resolve in the owning subgraph. */
  inventoryItem?: Maybe<InventoryItem>;
  isBulk: Scalars['Boolean']['output'];
  item?: Maybe<WarehouseTaskItem>;
  /**
   * Null when the footprint could not be computed. See statusReason, which may
   * name a different blocker first. Present, with casesPerPallet null, when only
   * the item's pallet setup is missing.
   */
  palletFootprint?: Maybe<ReplenTaskPalletFootprint>;
  /**
   * The item has no usable cases per pallet. Informational: the task stays
   * actionable, since a move never needs pallets. False for a blocked task, whose
   * statusReason is what needs review.
   */
  palletInfoMissing: Scalars['Boolean']['output'];
  /** Already covered by bin transfers in progress. In the item's stock unit, as a decimal string. */
  quantityInFlight: Scalars['String']['output'];
  /** On-hand in the routed zones. In the item's stock unit, as a decimal string. */
  quantityOnhand: Scalars['String']['output'];
  /** Demand still to be met. In the item's stock unit, as a decimal string. */
  quantityRemaining: Scalars['String']['output'];
  /** Quantity to replenish. In the item's stock unit, as a decimal string. */
  quantityReplen: Scalars['String']['output'];
  /**
   * Quantity to replenish. In NetSuite base units (the stock-unit figure times the
   * item's stock-unit conversion), as a decimal string. Null when the item has no
   * valid stock-unit conversion.
   */
  quantityReplenBaseUnits?: Maybe<Scalars['String']['output']>;
  /** Quantity to replenish less what is in flight, never below zero. In the item's stock unit, as a decimal string. */
  quantityStillShort: Scalars['String']['output'];
  /**
   * Quantity still short. In NetSuite base units (the stock-unit figure times the
   * item's stock-unit conversion), as a decimal string. Null when the item has no
   * valid stock-unit conversion.
   */
  quantityStillShortBaseUnits?: Maybe<Scalars['String']['output']>;
  routedZoneNetsuiteIds: Array<Scalars['String']['output']>;
  /** Reserve bins to pick from, in the calculation's FEFO order. */
  sourceOptions: Array<ReplenTaskSourceOption>;
  state: WarehouseTaskState;
  statusReason?: Maybe<WarehouseTaskStatusReason>;
  /**
   * Base units in one stock unit, as a decimal string. Null when the item has no
   * valid conversion. Present on every task, including blocked ones, unlike
   * palletFootprint.
   */
  stockUnitConversion?: Maybe<Scalars['String']['output']>;
  taskType: WarehouseTaskType;
  workstream: WarehouseTaskWorkstream;
};

export enum ReplenTaskCohort {
  Bulk = 'BULK',
  EcomBulk = 'ECOM_BULK',
  Pallet = 'PALLET',
  Standard = 'STANDARD'
}

export type ReplenTaskDestinationBin = {
  __typename?: 'ReplenTaskDestinationBin';
  /**
   * On-hand of this item in the bin, in stock units, as a decimal string. Null
   * when the bin did not resolve, so the on-hand is unknown.
   */
  currentQuantity?: Maybe<Scalars['String']['output']>;
  /**
   * True when the bin holds no on-hand of this item. Also true when the bin did
   * not resolve and its on-hand is unknown, so check netsuiteInternalId to tell the two apart.
   */
  empty: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Null when the destination name did not resolve to an active bin; the destination is still listed. */
  netsuiteInternalId?: Maybe<Scalars['String']['output']>;
};

/**
 * Informational only: how the task's full shortage (quantityReplen) breaks into
 * pallets. It is not part of the shortage arithmetic, and it ignores what is
 * already in flight: the connection's remainingPalletCount counts pallets of
 * quantityStillShort, so the two differ for a partly covered task. A case is the
 * item's purchase unit, as in putaway.
 */
export type ReplenTaskPalletFootprint = {
  __typename?: 'ReplenTaskPalletFootprint';
  /** The full shortage (quantityReplen), in base units. */
  baseUnitQuantity: Scalars['String']['output'];
  /** The full shortage (quantityReplen), in purchase cases. */
  caseQuantity: Scalars['String']['output'];
  /** Purchase cases per layer. Null when not configured. */
  casesPerLayer?: Maybe<Scalars['Int']['output']>;
  /**
   * Purchase cases per pallet. Null for an each-only item, which has no pallet
   * configuration, and when the item's pallet setup is missing.
   */
  casesPerPallet?: Maybe<Scalars['Int']['output']>;
  /** Eaches in one purchase case; 1 for an each-only item. */
  eachesPerCase: Scalars['String']['output'];
  /** Purchase cases on the whole pallets. */
  fullPalletCaseQuantity: Scalars['String']['output'];
  /** Whole pallets in the quantity; 0 for an each-only item or when the pallet setup is missing. */
  fullPalletCount: Scalars['Int']['output'];
  /** Layers per pallet. Null when not configured. */
  layersPerPallet?: Maybe<Scalars['Int']['output']>;
  /** Purchase cases left after the whole pallets; the whole quantity for an each-only item or when the pallet setup is missing. */
  remainderCaseQuantity: Scalars['String']['output'];
  /** Base units in one stock unit. */
  stockUnitConversion: Scalars['String']['output'];
};

export type ReplenTaskSourceOption = {
  __typename?: 'ReplenTaskSourceOption';
  binName?: Maybe<Scalars['String']['output']>;
  binNetsuiteId: Scalars['String']['output'];
  expirationDate?: Maybe<Scalars['ISO8601Date']['output']>;
  inventoryNumberNetsuiteId?: Maybe<Scalars['String']['output']>;
  lotNumber?: Maybe<Scalars['String']['output']>;
  /** Stock units in this bin and lot, as a decimal string. */
  quantity: Scalars['String']['output'];
};

/** A replenishment trip that can be shown on a task's Edit sheet. */
export type ReplenishmentTrip = {
  __typename?: 'ReplenishmentTrip';
  /**
   * False while the trip is still being confirmed or replenishment transfers are
   * off for the warehouse. True does not guarantee the undo: it can still be
   * refused, for example when the stock has already left the destination bin.
   */
  canUndo: Scalars['Boolean']['output'];
  command: WarehouseBinTransferCommand;
};

/** Autogenerated input type of ReportPhoneNumberVerification */
export type ReportPhoneNumberVerificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Phone number in E.164 format, but without the "+" prefix. E.g. "15551231234". */
  phoneNumber: Scalars['String']['input'];
  /** Phone verification code. */
  phoneVerificationCode: Scalars['String']['input'];
};

/** Autogenerated return type of ReportPhoneNumberVerification */
export type ReportPhoneNumberVerificationPayload = {
  __typename?: 'ReportPhoneNumberVerificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to report phone number verification. */
  result: ReportPhoneNumberVerificationResult;
};

/** Result of attempting to report phone number verification. */
export type ReportPhoneNumberVerificationResult = ErrorsResult | PhoneNumberVerified;

/** Autogenerated input type of ReportPutawayException */
export type ReportPutawayExceptionInput = {
  /** Recommended destination bin name, recorded verbatim. */
  binName?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** NetSuite item internal id, recorded verbatim for reviewers. */
  itemInternalId?: InputMaybe<Scalars['String']['input']>;
  /** Item display title, recorded verbatim. */
  itemTitle?: InputMaybe<Scalars['String']['input']>;
  /** Lot number, recorded verbatim. */
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  /** Free-form description; required when the reason is other. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Why the putaway failed. */
  reasonCode: PutawayExceptionReason;
  /** WarehouseTask id from the warehouseTasks query, recorded verbatim. */
  taskId: Scalars['ID']['input'];
  /** Warehouse where the exception was reported. */
  warehouseId: Scalars['ID']['input'];
};

/** Autogenerated return type of ReportPutawayException. */
export type ReportPutawayExceptionPayload = {
  __typename?: 'ReportPutawayExceptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  report?: Maybe<PutawayExceptionReport>;
  userErrors: Array<UserError>;
};

/** Autogenerated input type of ReportPutawayPalletBuildCorrection */
export type ReportPutawayPalletBuildCorrectionInput = {
  /** Corrected cases per pallet layer. */
  casesPerLayer: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Inventory item id (IMS item uuid). */
  itemId: Scalars['ID']['input'];
  /** NetSuite item internal id, recorded verbatim for reviewers. */
  itemInternalId?: InputMaybe<Scalars['String']['input']>;
  /** Corrected layers per pallet. */
  layersPerPallet: Scalars['Int']['input'];
  /** Warehouse where the correction was reported. */
  warehouseId: Scalars['ID']['input'];
};

/** Autogenerated return type of ReportPutawayPalletBuildCorrection. */
export type ReportPutawayPalletBuildCorrectionPayload = {
  __typename?: 'ReportPutawayPalletBuildCorrectionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  report?: Maybe<PutawayPalletBuildReport>;
  userErrors: Array<UserError>;
};

/** Autogenerated input type of RequestS3Upload */
export type RequestS3UploadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The full path of the file to be uploaded to S3, like 'path/to/file.jpg'. It should not start with a slash. */
  filePath: Scalars['String']['input'];
  /** The ID of the microsite location this image belongs to */
  micrositeLocationId: Scalars['ID']['input'];
};

/** Autogenerated return type of RequestS3Upload. */
export type RequestS3UploadPayload = {
  __typename?: 'RequestS3UploadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  fileUrl: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

/** Autogenerated input type of RequestSampleMutation */
export type RequestSampleMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The requested delivery date for the sample */
  deliveryDate: Scalars['ISO8601Date']['input'];
  /** UUID of the catalog item whose sample is requested */
  itemId: Scalars['ID']['input'];
  /** UUID of the location requesting the sample */
  locationId: Scalars['ID']['input'];
};

/** Autogenerated return type of RequestSampleMutation. */
export type RequestSampleMutationPayload = {
  __typename?: 'RequestSampleMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RequestSupplierInvoiceReadUrl */
export type RequestSupplierInvoiceReadUrlInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  supplierInvoiceId: Scalars['ID']['input'];
};

/** Autogenerated return type of RequestSupplierInvoiceReadUrl. */
export type RequestSupplierInvoiceReadUrlPayload = {
  __typename?: 'RequestSupplierInvoiceReadUrlPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  file?: Maybe<SupplierInvoiceFile>;
  readUrl?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of RequoteProviderRoute */
export type RequoteProviderRouteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** When the courier should collect, on the route's night. Omitted or null means ASAP. */
  pickupAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** The marked route to re-quote. */
  routeId: Scalars['ID']['input'];
};

/** Autogenerated return type of RequoteProviderRoute. */
export type RequoteProviderRoutePayload = {
  __typename?: 'RequoteProviderRoutePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  route?: Maybe<Route>;
  userErrors: Array<ThirdPartyDispatchError>;
};

/** Autogenerated input type of RestoreLocation */
export type RestoreLocationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['ID']['input'];
};

/** Autogenerated return type of RestoreLocation. */
export type RestoreLocationPayload = {
  __typename?: 'RestoreLocationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  success: Scalars['Boolean']['output'];
};

export type Review = {
  __typename?: 'Review';
  author?: Maybe<Scalars['String']['output']>;
  authorReviewsUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Google Reviews API resource id (e.g. 'ABCdefGHIjkl') */
  id: Scalars['ID']['output'];
  profilePhotoUrl?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  response?: Maybe<Scalars['String']['output']>;
  /** suggested vs. published, depending on which response is shown */
  responseType: Scalars['String']['output'];
  review?: Maybe<Scalars['String']['output']>;
  sentiment?: Maybe<Scalars['String']['output']>;
};

export type ReviewConfirmationMismatch = UserErrorInterface & {
  __typename?: 'ReviewConfirmationMismatch';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /**
   * Lines whose recovery_quantity exceeds the recoverable shortfall (more marked
   * for recovery than was left undelivered). Caller should highlight these in the DMP UI.
   */
  mismatchedLines: Array<MismatchedOrderLine>;
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type ReviewResponse = {
  __typename?: 'ReviewResponse';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  replyId: Scalars['String']['output'];
  responseText: Scalars['String']['output'];
  reviewId: Scalars['String']['output'];
  /** Google's update time for the review response */
  updateTime: Scalars['ISO8601DateTime']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type ReviewSentiments = {
  __typename?: 'ReviewSentiments';
  negative: Array<Scalars['String']['output']>;
  positive: Array<Scalars['String']['output']>;
};

/** Reward. */
export type Reward = Node & {
  __typename?: 'Reward';
  /** Whether reward should be applied automatically upon visiting checkout. */
  autoApply: Scalars['Boolean']['output'];
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID']['output'];
  /** Scope the reward applies to. */
  scope: RewardScope;
  /** Title. */
  title: Scalars['String']['output'];
};

/** Error indicating a reward could not be claimed because the user has already claimed it. */
export type RewardAlreadyClaimed = Error & {
  __typename?: 'RewardAlreadyClaimed';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Error indicating a reward could not be applied because the user has already used it. */
export type RewardAlreadyUsed = Error & {
  __typename?: 'RewardAlreadyUsed';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Error indicating that no reward was found with the provided reward code. */
export type RewardCodeNotFound = Error & {
  __typename?: 'RewardCodeNotFound';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Error indicating the a reward is not applicable. */
export type RewardNotApplicable = Error & {
  __typename?: 'RewardNotApplicable';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Reward mutation result. */
export type RewardResult = ErrorsResult | RewardSuccess;

/** The possible reward scopes. */
export enum RewardScope {
  /** Reward can be applied to the entire cart. */
  Cart = 'cart',
  /** Reward can be applied to a single item. */
  Item = 'item',
  /** Reward, when claimed, increases wallet balance. */
  Wallet = 'wallet'
}

/** Result of a successful reward mutation. */
export type RewardSuccess = {
  __typename?: 'RewardSuccess';
  /** Reward. */
  reward: Reward;
};

export type RfsmartCredential = {
  __typename?: 'RfsmartCredential';
  /** Holder's ARMHR employee code (identity-spine join key). */
  associateId?: Maybe<Scalars['String']['output']>;
  /** Current holder (WarehouseAssociate id); null for an unassigned pool account. */
  employeeId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  kind: RfsmartCredentialKind;
  /** RF-SMART login; today the employee's NetSuite email. */
  login: Scalars['String']['output'];
  /** Holder's full name. */
  name?: Maybe<Scalars['String']['output']>;
  /** Optional reason recorded with the removal request or completion. */
  removalNote?: Maybe<Scalars['String']['output']>;
  /** When an admin flagged this credential for manual removal in RF-SMART; null when not pending. */
  removalRequestedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Auth0 sub of the admin who flagged it. */
  removalRequestedBy?: Maybe<Scalars['String']['output']>;
  /** When the password was last set or changed. */
  rotatedAt: Scalars['ISO8601DateTime']['output'];
  /** Auth0 sub of the last admin to change the row. */
  updatedBy?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of RfsmartCredentialAssign */
export type RfsmartCredentialAssignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  credentialId: Scalars['ID']['input'];
  employeeId: Scalars['ID']['input'];
  /**
   * Rotates the account's password with the assignment. Without one, every badge
   * previously printed for this account stays valid.
   */
  password?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RfsmartCredentialAssign. */
export type RfsmartCredentialAssignPayload = {
  __typename?: 'RfsmartCredentialAssignPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  credential?: Maybe<RfsmartCredential>;
  userErrors: Array<ProcessPathError>;
};

export enum RfsmartCredentialKind {
  /** One employee's own account, never reassigned. */
  Individual = 'individual',
  /** A warehouse account reassigned between agency temps — the only kind that can be unassigned. */
  Pool = 'pool'
}

/** Autogenerated input type of RfsmartCredentialRemovalCancel */
export type RfsmartCredentialRemovalCancelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The credential itself. Required when the account has no holder. Provide exactly one of employeeId or credentialId. */
  credentialId?: InputMaybe<Scalars['ID']['input']>;
  /** The associate holding the credential. Provide exactly one of employeeId or credentialId. */
  employeeId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of RfsmartCredentialRemovalCancel. */
export type RfsmartCredentialRemovalCancelPayload = {
  __typename?: 'RfsmartCredentialRemovalCancelPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  credential?: Maybe<RfsmartCredential>;
  userErrors: Array<ProcessPathError>;
};

/** Autogenerated input type of RfsmartCredentialRemovalComplete */
export type RfsmartCredentialRemovalCompleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The credential itself. Required when the account has no holder. Provide exactly one of employeeId or credentialId. */
  credentialId?: InputMaybe<Scalars['ID']['input']>;
  /** The associate holding the credential. Provide exactly one of employeeId or credentialId. */
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  /** Optional completion note; replaces the request's note when given. */
  note?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RfsmartCredentialRemovalComplete. */
export type RfsmartCredentialRemovalCompletePayload = {
  __typename?: 'RfsmartCredentialRemovalCompletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  credential?: Maybe<RfsmartCredential>;
  userErrors: Array<ProcessPathError>;
};

/** Autogenerated input type of RfsmartCredentialRemovalRequest */
export type RfsmartCredentialRemovalRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The credential itself. Required when the account has no holder. Provide exactly one of employeeId or credentialId. */
  credentialId?: InputMaybe<Scalars['ID']['input']>;
  /** The associate holding the credential. Provide exactly one of employeeId or credentialId. */
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  /** Optional reason; shown on the pending queue and recorded on the audit version. */
  note?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RfsmartCredentialRemovalRequest. */
export type RfsmartCredentialRemovalRequestPayload = {
  __typename?: 'RfsmartCredentialRemovalRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  credential?: Maybe<RfsmartCredential>;
  userErrors: Array<ProcessPathError>;
};

/** Autogenerated input type of RfsmartCredentialSet */
export type RfsmartCredentialSetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  employeeId: Scalars['ID']['input'];
  login: Scalars['String']['input'];
  /** Required when creating; optional on update, so a login correction is not a rotation. */
  password?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RfsmartCredentialSet. */
export type RfsmartCredentialSetPayload = {
  __typename?: 'RfsmartCredentialSetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  credential?: Maybe<RfsmartCredential>;
  userErrors: Array<ProcessPathError>;
};

/** Autogenerated input type of RfsmartCredentialSetPool */
export type RfsmartCredentialSetPoolInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The pool account to edit. Required when correcting a login. */
  credentialId?: InputMaybe<Scalars['ID']['input']>;
  /** The RF-SMART login. Required when adding an account; omitting it leaves the stored login unchanged. */
  login?: InputMaybe<Scalars['String']['input']>;
  /** The RF-SMART password. Required when adding an account; omitting it leaves the stored password unchanged. */
  password?: InputMaybe<Scalars['String']['input']>;
  warehouseId: Scalars['ID']['input'];
};

/** Autogenerated return type of RfsmartCredentialSetPool. */
export type RfsmartCredentialSetPoolPayload = {
  __typename?: 'RfsmartCredentialSetPoolPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  credential?: Maybe<RfsmartCredential>;
  userErrors: Array<ProcessPathError>;
};

/** Autogenerated input type of RfsmartCredentialUnassign */
export type RfsmartCredentialUnassignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  credentialId: Scalars['ID']['input'];
};

/** Autogenerated return type of RfsmartCredentialUnassign. */
export type RfsmartCredentialUnassignPayload = {
  __typename?: 'RfsmartCredentialUnassignPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  credential?: Maybe<RfsmartCredential>;
  userErrors: Array<ProcessPathError>;
};

export type Role = {
  __typename?: 'Role';
  /** Design-sourced one-line role summary */
  descriptionSummary?: Maybe<Scalars['String']['output']>;
  /** Human-readable role name */
  displayName: Scalars['String']['output'];
  /** The role identifier (e.g. 'store-owner') */
  key: Scalars['String']['output'];
  /** Discrete permission items for this role */
  permissions: Array<Scalars['String']['output']>;
};

export type Route = {
  __typename?: 'Route';
  /**
   * Boolean to indicate whether this is a system-created holding pen rather than a
   * route anyone drives: the Lobby, the customer-pickup bucket, or a provider's
   * staging pen. Per-route totals are reported as 0 for these.
   */
  bucketRoute: Scalars['Boolean']['output'];
  color?: Maybe<Scalars['String']['output']>;
  /**
   * Boolean to indicate whether this is the never-optimized customer-pickup bucket
   * route, holding orders the customer collects at the warehouse. True indicates a
   * customer-pickup route.
   */
  customerPickupRoute: Scalars['Boolean']['output'];
  /** The driver associated with this route */
  driver?: Maybe<Driver>;
  /** The driver associated with this route */
  driverUser?: Maybe<User>;
  /** The helper driver associated with this route */
  helperDriver?: Maybe<Driver>;
  /** The helper driver user associated with this route */
  helperDriverUser?: Maybe<User>;
  id: Scalars['ID']['output'];
  /** Boolean to indicate whether this is a lobby route. True indicates a lobby route. */
  isLobby: Scalars['Boolean']['output'];
  /**
   * Actual miles driven along the driver's location breadcrumb trail. Null until
   * the route is completed and metrics are computed, or when the trail is too sparse.
   */
  milesDriven?: Maybe<Scalars['Float']['output']>;
  /** Delivery route name */
  name: Scalars['String']['output'];
  nightEnd: Scalars['ISO8601Date']['output'];
  /**
   * True when this route's night_end has passed (in the route's own warehouse time
   * zone, falling back to the app's default time zone for a route with no
   * warehouse) and route_night_end_lock is on, meaning
   * DeliveryRouteAssignmentService will reject moving stops off this route. False
   * for a route with no night_end.
   */
  nightEndLocked: Scalars['Boolean']['output'];
  /** Percent of volume data available for this route */
  percentItemsWithVolume?: Maybe<Scalars['Float']['output']>;
  /** Percent of weight data available for this route */
  percentItemsWithWeight?: Maybe<Scalars['Float']['output']>;
  /**
   * Planned road distance in miles for the dispatched stop sequence, computed via
   * Google Maps Directions API. Null until computed.
   */
  plannedDistanceMiles?: Maybe<Scalars['Float']['output']>;
  /**
   * The route's newest dispatch to a third-party provider, by creation time,
   * regardless of status. Present after a mark even once canceled or failed; the
   * DMP keys on thirdPartyRoute for presence, not on this field's status.
   */
  providerDispatch?: Maybe<ProviderDispatch>;
  /** Boolean to indicate whether this is a redelivery route. True indicates a redelivery route. */
  redeliveryRoute: Scalars['Boolean']['output'];
  /** Redelivery route stops */
  redeliveryStops: Array<Redelivery>;
  /** Delivery route cohort name, set by automated routing. Temporary field to support routing cohorts */
  routeCohort?: Maybe<Scalars['String']['output']>;
  /** Delivery route origin. Temporary field to support routing cohorts */
  routeOrigin?: Maybe<Scalars['String']['output']>;
  /** Represent route predictive metrics based on route optimization. */
  routingEstimates?: Maybe<RouteEstimates>;
  /** The time the route was started. Set by Drivers. Returned in the warehouse time zone. */
  startTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The time the route was completed. Set by Drivers. Returned in the warehouse time zone. */
  stopTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Delivery route stops, a stop denotes the action of either picking up item(s) or delivering items. */
  stops?: Maybe<Array<DeliveryStop>>;
  /** Which external provider delivers this route. Null unless thirdPartyRoute is true. */
  thirdPartyProvider?: Maybe<ThirdPartyProvider>;
  /**
   * Boolean to indicate whether an external provider delivers this route rather
   * than an Odeko truck. True for both a route a provider runs and a provider's
   * staging pen; read thirdPartyProvider for which provider and bucketRoute to
   * tell the two apart.
   */
  thirdPartyRoute: Scalars['Boolean']['output'];
  /**
   * Actual time on the road in seconds, derived from the driver's location
   * breadcrumb trail. Null until the route is completed and metrics are computed,
   * or when unknowable.
   */
  timeOnRoad?: Maybe<Scalars['Int']['output']>;
  /** Total volume of this route */
  totalVolume?: Maybe<Scalars['Float']['output']>;
  /** Total weight of this route */
  totalWeight?: Maybe<Scalars['Float']['output']>;
  /** Truck associated with this route */
  truck?: Maybe<Truck>;
  warehouse: Warehouse;
  /**
   * The time the driver returned to the warehouse, set automatically when the
   * phone re-enters the warehouse geofence. Returned in the warehouse time zone.
   */
  warehouseArrivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * The time the driver departed the warehouse, set automatically when the phone
   * first exits the warehouse geofence after the vehicle scan. Returned in the
   * warehouse time zone.
   */
  warehouseDepartedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated input type of RouteDetailsUpdate */
export type RouteDetailsUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Delivery route id. */
  deliveryRouteId: Scalars['ID']['input'];
  /** Driver id. */
  driverId?: InputMaybe<Scalars['String']['input']>;
  /** Driver name. */
  driverName?: InputMaybe<Scalars['String']['input']>;
  /** Helper driver id. */
  helperDriverId?: InputMaybe<Scalars['String']['input']>;
  /** Helper driver name. */
  helperDriverName?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RouteDetailsUpdate. */
export type RouteDetailsUpdatePayload = {
  __typename?: 'RouteDetailsUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  route?: Maybe<Route>;
  userErrors: Array<RouteError>;
};

export type RouteEnded = UserErrorInterface & {
  __typename?: 'RouteEnded';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** Route possible error types */
export type RouteError = AutomatedRoutingPending | BulkUpdateDeprecated | InvalidNightEnd | ProviderRouteGuarded | RouteEnded;

export type RouteEstimates = {
  __typename?: 'RouteEstimates';
  /** Estimated time in minutes spent at breaks. */
  breakTime?: Maybe<Scalars['Int']['output']>;
  /** Total estimated distance in miles for the route. */
  distance?: Maybe<Scalars['Float']['output']>;
  /** Raw HH:MM string for the estimated finish time in 24 hour rolling windows (may exceed '23:59'). */
  finish?: Maybe<Scalars['String']['output']>;
  /** Date/time representing the estimated finish using delivery date as reference point. */
  finishDatetime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Estimated time in minutes spent at stops based on each location's configured service time. */
  serviceTime?: Maybe<Scalars['Int']['output']>;
  /** Raw HH:MM string for the estimated start time in 24 hour rolling windows (may exceed '23:59'). */
  start?: Maybe<Scalars['String']['output']>;
  /** Date/time representing the estimated start using delivery date as reference point. */
  startDatetime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Estimated number of stops optimized for the route. */
  stopsCount?: Maybe<Scalars['Int']['output']>;
  /**
   * Total estimated travel time in minutes, calculated as: total working time -
   * service time - break times. This represents the actual time spent driving between stops.
   */
  travelTime?: Maybe<Scalars['Int']['output']>;
};

export type RouteInput = {
  id: Scalars['ID']['input'];
};

export type RouteNotFound = UserErrorInterface & {
  __typename?: 'RouteNotFound';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type RouteNotMarkable = UserErrorInterface & {
  __typename?: 'RouteNotMarkable';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of RouteOriginUpdate */
export type RouteOriginUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Delivery route id. */
  deliveryRouteId: Scalars['ID']['input'];
  /** Route origin identifier. */
  routeOrigin?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RouteOriginUpdate. */
export type RouteOriginUpdatePayload = {
  __typename?: 'RouteOriginUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  route?: Maybe<Route>;
  userErrors: Array<RouteError>;
};

/** Autogenerated input type of RouteReopen */
export type RouteReopenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Delivery route id. */
  deliveryRouteId: Scalars['ID']['input'];
};

/** Autogenerated return type of RouteReopen. */
export type RouteReopenPayload = {
  __typename?: 'RouteReopenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  route?: Maybe<Route>;
  userErrors: Array<RouteError>;
};

export type RouteSummary = {
  __typename?: 'RouteSummary';
  /** Cubic utilization percentage for this vehicle */
  cubicUtilizationPercent?: Maybe<Scalars['Float']['output']>;
  /** Estimated driver hours for this vehicle */
  estimatedHours?: Maybe<Scalars['Float']['output']>;
  /** Total distance for this route in miles */
  miles: Scalars['Float']['output'];
  /** Stop count for this route, excluding depot markers */
  stops: Scalars['Int']['output'];
};

/** Autogenerated input type of RouteTruckUpdate */
export type RouteTruckUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Delivery route id. */
  deliveryRouteId: Scalars['ID']['input'];
  /** Vehicle tag assigned by the warehouse. */
  vehicleTag: Scalars['String']['input'];
  /** Unique 17-character code that identifies a vehicle. */
  vehicleVin: Scalars['String']['input'];
};

/** Autogenerated return type of RouteTruckUpdate. */
export type RouteTruckUpdatePayload = {
  __typename?: 'RouteTruckUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  route?: Maybe<Route>;
  userErrors: Array<RouteError>;
};

export type RoutesInput = {
  nightEnd?: InputMaybe<Scalars['ISO8601Date']['input']>;
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};

export enum RoutificRunFailureDimension {
  /**
   * The selected trucks cannot cover the stop count (count * per-truck max_stops <
   * stops): a pinned cohort's reserved trucks, or the vehicle-count pool.
   */
  StopCap = 'stop_cap',
  /**
   * The selected trucks cannot carry the weight/volume demand even using the
   * largest available types: a pinned cohort's reserved trucks, or the
   * vehicle-count pool.
   */
  WeightVolume = 'weight_volume'
}

export type RoutificRunFailureReason = {
  __typename?: 'RoutificRunFailureReason';
  /** The offending cohort (route type), when the failure is cohort-specific. */
  cohortName?: Maybe<Scalars['String']['output']>;
  /** Which capacity dimension was exceeded — stop_cap or weight_volume — when known. */
  dimension?: Maybe<RoutificRunFailureDimension>;
  /** The failure class: PinnedFleetInfeasible or VehicleCountInfeasible. */
  type: Scalars['String']['output'];
};

export enum RoutificRunStatus {
  Error = 'error',
  Finished = 'finished',
  Pending = 'pending',
  Processing = 'processing',
  Reoptimize = 'reoptimize',
  /**
   * The run never reached a terminal Routific status and was given up on. Distinct
   * from error: nothing failed, it simply never finished. No solution is available
   * and it will not resume.
   */
  Timeout = 'timeout'
}

export type RoutificRunSummary = {
  __typename?: 'RoutificRunSummary';
  /**
   * Stops omitted because automated routing was disabled at input-build time.
   * Empty means eligibility was evaluated with no exclusions; null means this run
   * has no recorded evidence.
   */
  automatedRoutingExclusions?: Maybe<Array<AutomatedRoutingExclusion>>;
  /** Average volume utilization per truck as a percentage */
  avgCubicUtilizationPercent?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Deliveries per route hour (total stops / driver hours) */
  dprh?: Maybe<Scalars['Float']['output']>;
  /** Sum of driver working time across all vehicles in hours */
  estimatedDriverHours?: Maybe<Scalars['Float']['output']>;
  /** Sum of driver working time across all vehicles in minutes */
  estimatedTotalMinutes?: Maybe<Scalars['Float']['output']>;
  /**
   * Why this run failed, when the failure is a structured fleet infeasibility.
   * PinnedFleetInfeasible carries the offending cohort and the capacity dimension
   * it exceeded (sc-66091); VehicleCountInfeasible carries the dimension the
   * vehicle-count cap could not cover, with no cohort (sc-66269). Null for runs
   * that succeeded or failed without a recorded structured reason.
   */
  failureReason?: Maybe<RoutificRunFailureReason>;
  id: Scalars['ID']['output'];
  /** Fleet mode and cohort parameters used to generate this run */
  inputSnapshot?: Maybe<Scalars['JSON']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  /** GM-supplied, editable display name for a scenario run. Null until named. */
  name?: Maybe<Scalars['String']['output']>;
  /** Encoded polyline strings keyed by vehicle ID */
  polylines?: Maybe<Scalars['JSON']['output']>;
  /** Vehicles with at least one stop (excludes idle vehicles in ceiling mode) */
  routeCount?: Maybe<Scalars['Int']['output']>;
  /**
   * Per-vehicle stop and distance summary, excluding idle vehicles; a
   * fully-Metrobi vehicle's miles are zero (third-party delivered)
   */
  routes?: Maybe<Array<RouteSummary>>;
  /**
   * How this run was produced: an auto run (standard / reoptimization), a
   * GM-triggered manual run (etas_only recalculates estimates without moving
   * stops; re_sequence reorders stops), or a scenario. Drives mode-specific
   * labeling on the optimization timeline.
   */
  runType: Scalars['String']['output'];
  status: RoutificRunStatus;
  /** Number of stops in this run's 3PD Marked group, or null when the run did not separate 3PD. */
  thirdPartyMarkedStopCount?: Maybe<Scalars['Int']['output']>;
  /**
   * The 3PD (Metrobi) "Marked" group (sc-67116): the location stops already parked
   * in the Metrobi staging pen — actually marked Metrobi in production — when this
   * scenario run was built, returned as delivery stops so callers reuse the same
   * location/geo shape as routed stops. These are displayed but not routed on
   * Odeko trucks. Null when the run did not separate 3PD (Auto-Mark override off);
   * an empty list means it did but the pen was empty. Snapshotted per run —
   * distinct from the plan-level live bucket.
   */
  thirdPartyMarkedStops?: Maybe<Array<DeliveryStop>>;
  /** Number of stops in this run's 3PD separation preview group, or null when the run did not preview it. */
  thirdPartyPreviewStopCount?: Maybe<Scalars['Int']['output']>;
  /**
   * The 3PD (Metrobi) separation preview (sc-65971): the location stops this
   * scenario run computed as 3PD-eligible and held out of the native routes,
   * returned as delivery stops so callers reuse the same location/geo shape as
   * routed stops. Null when the run did not preview 3PD separation
   * (third_party_enabled override off); an empty list means it did but found none
   * eligible. Nothing is marked or bucketed — this is a non-destructive preview,
   * distinct from the native routes.
   */
  thirdPartyPreviewStops?: Maybe<Array<DeliveryStop>>;
  /** Total road distance across all vehicles in miles, excluding vehicles whose every delivery stop is Metrobi (third-party) */
  totalDistanceMiles?: Maybe<Scalars['Float']['output']>;
  /** Total stops across all vehicles, excluding depot markers */
  totalStops?: Maybe<Scalars['Int']['output']>;
  truckCount: Scalars['Int']['output'];
  /** Number of stops Routific could not assign to a vehicle */
  unservedCount?: Maybe<Scalars['Int']['output']>;
  /**
   * Maps each vehicle key to the warehouseShiftId it ran on, keyed identically to
   * vehicleStopIds. Null for runs not built from a fleet shift assignment. Join
   * against warehouse.warehouseShifts to label each route with its shift.
   */
  vehicleShifts?: Maybe<Scalars['JSON']['output']>;
  /** Maps each vehicle key to its ordered stop IDs for client-side route matching */
  vehicleStopIds?: Maybe<Scalars['JSON']['output']>;
  /**
   * Maps each vehicle key to the fleet vehicle type that served it (e.g. van, box
   * truck), keyed identically to vehicleStopIds. Null for runs built without a
   * fleet composition.
   */
  vehicleTypes?: Maybe<Scalars['JSON']['output']>;
};

export type RoutingCohort = {
  __typename?: 'RoutingCohort';
  /** A deterministic color based on the cohort name */
  color?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the routing cohort */
  id: Scalars['ID']['output'];
  /** The per-cohort stop cap, or null when none is set (the cohort falls back to the default). */
  maxStops?: Maybe<Scalars['Int']['output']>;
  /** The name of the routing cohort */
  name: Scalars['String']['output'];
  /**
   * The warehouse shift assigned to this cohort, or null (the cohort then defaults
   * to the warehouse's first shift by start time).
   */
  warehouseShift?: Maybe<WarehouseShift>;
};

/** Input type for defining routing truck cohort information */
export type RoutingCohortInput = {
  /** When false, pool this cohort's stops into the shared fleet instead of routing it on its own trucks. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Routing cohort identifier */
  id: Scalars['ID']['input'];
  /** Per-cohort stop cap. Positive integer to cap, null to clear back to the default. */
  maxStops?: InputMaybe<Scalars['Int']['input']>;
  /** Desired truck count for the cohort. Omit to leave it unchanged. */
  truckCount?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of RoutingCohortShiftAssign */
export type RoutingCohortShiftAssignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  cohortId: Scalars['ID']['input'];
  /**
   * A warehouse shift id to assign, or null to clear (the cohort then falls back
   * to the warehouse's first shift by start time).
   */
  warehouseShiftId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of RoutingCohortShiftAssign. */
export type RoutingCohortShiftAssignPayload = {
  __typename?: 'RoutingCohortShiftAssignPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  routingCohort?: Maybe<RoutingCohort>;
};

export type RoutingConfiguration = {
  __typename?: 'RoutingConfiguration';
  /** Whether Routific routes around toll roads. The warehouse's persisted value, defaulting to false. */
  avoidTolls: Scalars['Boolean']['output'];
  /** Whether Routific balances workload across vehicles. The warehouse's persisted value, defaulting to false. */
  balance: Scalars['Boolean']['output'];
  /**
   * Length of each placed break in minutes. Null when the current breaks do not
   * share one length, or when the placed lunch break is ambiguous — no single
   * value reproduces them.
   */
  breakDurationMinutes?: Maybe<Scalars['Int']['output']>;
  /** How much of each truck's max capacity the plan routes against. The warehouse's persisted value, defaulting to 100. */
  capacityPercent: Scalars['Int']['output'];
  /**
   * Shift length in hours on the rolling >24:00 axis. Null when the plan's cohorts
   * run shifts of differing length: an override sets every vehicle's shift, so no
   * single value could be reset to without flattening the others.
   */
  driverShiftHours?: Maybe<Scalars['Float']['output']>;
  /**
   * Whether a cohort with no per-cohort stop cap falls back to 25 stops per
   * vehicle. The warehouse's persisted value, defaulting to true. False routes
   * uncapped cohorts without a stop limit.
   */
  maxStopsPerVehicle: Scalars['Boolean']['output'];
  /** Whether Routific minimizes the number of vehicles used. The warehouse's persisted value, defaulting to false. */
  minVehicles: Scalars['Boolean']['output'];
  /** Allowed overtime in minutes. The warehouse's persisted value, defaulting to 0. */
  overtimeMinutes: Scalars['Int']['output'];
  /** Whether Routific optimizes for shortest distance rather than time. The warehouse's persisted value. */
  shortestDistance: Scalars['Boolean']['output'];
  /**
   * Whether the nightly 3PD (Metrobi) auto-marking sweep runs for this warehouse.
   * The warehouse's persisted value, defaulting to the
   * sc_65483_third_party_auto_marking flag.
   */
  thirdPartyEnabled: Scalars['Boolean']['output'];
  /** Total trucks across the plan's cohorts. Null when no cohort has a count set. */
  truckCount?: Maybe<Scalars['Int']['output']>;
  /** Routific visit-balance coefficient. The warehouse's persisted value. */
  visitBalanceCoefficient: Scalars['Float']['output'];
};

/** Apply routing configuration possible errors */
export type RoutingConfigurationError = InvalidFleetComposition | InvalidParameterOverrides | InvalidRules | RoutingConfigurationNotEnabled | RoutingConfigurationNotFound;

export type RoutingConfigurationNotEnabled = UserErrorInterface & {
  __typename?: 'RoutingConfigurationNotEnabled';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type RoutingConfigurationNotFound = UserErrorInterface & {
  __typename?: 'RoutingConfigurationNotFound';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type RoutingImportPlan = {
  __typename?: 'RoutingImportPlan';
  /** Aggregate metrics for the manually edited dispatched plan */
  actualRoutesSummary?: Maybe<ActualRoutesSummary>;
  /** The applied (non-scenario) Routific run for this plan */
  appliedRoutificRun?: Maybe<RoutificRunSummary>;
  /** The number of cohorts & trucks for the routing import plan */
  cohorts?: Maybe<Array<RoutingPlanCohort>>;
  /**
   * The current value of the routing parameters and engine options — the baseline
   * the Configure Scenario UI resets to and diffs proposed runs against.
   */
  currentRoutingConfiguration: RoutingConfiguration;
  /**
   * The currently dispatched plan: the latest finished etas_only run, which holds
   * the live dispatched stop layout with freshly calculated ETAs and its route
   * geometry. Null when ETAs have never been calculated for this plan — see
   * etasStatus. This is the run the etas_status staleness check measures against,
   * so the two always agree.
   */
  dispatchedRoutificRun?: Maybe<RoutificRunSummary>;
  /**
   * Whether the applied ETAs are stale relative to the current dispatched stop
   * layout, and why — drives the Plan vs. Dispatch stale-ETA warning.
   */
  etasStatus: EtasStatus;
  fileFound: Scalars['Boolean']['output'];
  /**
   * The warehouse's persisted fleet composition — the vehicle types it routes
   * with, how many of each, and each type's per-truck capacity. Empty when no
   * fleet is configured.
   */
  fleetConfig: Array<FleetVehicle>;
  id: Scalars['ID']['output'];
  /** GM-triggered manual runs (etas_only / re_sequence) for this plan, newest first */
  manualRoutificRuns: Array<RoutificRunSummary>;
  /**
   * Why the most recent Routific optimization attempt failed to build its input,
   * or null when it built successfully (or none has run). A non-null value means
   * the night produced no routes for a pinned-fleet reason the operator can fix in Optimization.
   */
  optimizationFailureReason?: Maybe<RoutingImportPlanOptimizationFailureReason>;
  /**
   * The routing rules in effect for this plan, keyed by rule id, with each rule's
   * options resolved from the warehouse's configuration over the rule's defaults.
   * A scenario run's rules argument layers over this.
   */
  rulesConfig: Scalars['JSON']['output'];
  /** Scenario runs for this routing import plan, newest first */
  scenarios: Array<RoutificRunSummary>;
  /**
   * The warehouse's persisted per-shift fleet assignment — how many trucks route
   * on each shift (sc-66834). Empty when no assignment is configured. The
   * deliveries Edit Truck Count card seeds its per-shift pool inputs from this.
   */
  shiftAssignment: Array<ShiftAssignmentEntry>;
  status: RoutingImportPlanStatus;
  /**
   * The location stops parked in the Metrobi staging pen for this plan's warehouse
   * and night, the never-routed 3PD holding route. Returned as delivery stops so
   * callers reuse the same location/geo shape as routed stops. Excludes routes a
   * provider is already running.
   */
  thirdPartyBucketStops: Array<DeliveryStop>;
  /**
   * Number of location stops parked in the Metrobi staging pen for this plan's
   * warehouse and night. These stops are delivered by a third-party carrier, are
   * never routed on Odeko trucks, and so are excluded from the fleet metrics.
   * Stops on a route a provider is already running are not counted.
   */
  thirdPartyStopCount: Scalars['Int']['output'];
  truckCount?: Maybe<Scalars['Int']['output']>;
  /**
   * The warehouse's LDS-owned shift definitions, ordered by start time. The
   * scenario builder lists these to let a GM assign a truck count per shift
   * (sc-66833). Empty when the warehouse has no shifts defined.
   */
  warehouseShifts: Array<WarehouseShift>;
};

/** Routing import plan possible errors */
export type RoutingImportPlanError = InvalidNightEnd | InvalidParameterOverrides | InvalidRules | RoutingImportPlanNotConfigured | RoutingImportPlanNotFound | ScenarioLimitReached | ScenarioNotFound | ScenarioRunsNotEnabled | TruckCountInvalid;

export type RoutingImportPlanInput = {
  nightEnd: Scalars['ISO8601Date']['input'];
  warehouseId: Scalars['ID']['input'];
};

export type RoutingImportPlanNotConfigured = UserErrorInterface & {
  __typename?: 'RoutingImportPlanNotConfigured';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type RoutingImportPlanNotFound = UserErrorInterface & {
  __typename?: 'RoutingImportPlanNotFound';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** Machine-readable reason the most recent Routific optimization attempt failed to build its input. */
export enum RoutingImportPlanOptimizationFailureReason {
  /** The pinned cohorts reserve more trucks than the fleet holds. Reduce a cohort's truck count. */
  PinnedFleetContention = 'PINNED_FLEET_CONTENTION',
  /**
   * A pinned cohort's demand can't fit its reserved trucks (stop cap or
   * weight/volume). Adjust the cohort's truck count or max stops.
   */
  PinnedFleetInfeasible = 'PINNED_FLEET_INFEASIBLE',
  /** The plan's total truck count can't carry the pooled demand (stop cap or weight/volume). Increase the truck count. */
  VehicleCountInfeasible = 'VEHICLE_COUNT_INFEASIBLE'
}

export enum RoutingImportPlanStatus {
  Completed = 'completed',
  InProgress = 'in_progress',
  Pending = 'pending',
  Unstarted = 'unstarted'
}

/** Autogenerated input type of RoutingImportPlanTruckCountUpdate */
export type RoutingImportPlanTruckCountUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** List of cohorts with their associated truck count. */
  cohorts?: InputMaybe<Array<RoutingCohortInput>>;
  /** Routing import plan night end. */
  nightEnd: Scalars['ISO8601Date']['input'];
  /**
   * Per-shift truck counts to persist as the warehouse's standing shift
   * assignment. Omit to leave it unchanged; an empty list clears it.
   */
  shifts?: InputMaybe<Array<RoutingShiftAssignmentInput>>;
  /** Warehouse id. */
  warehouseId: Scalars['ID']['input'];
};

/** Autogenerated return type of RoutingImportPlanTruckCountUpdate. */
export type RoutingImportPlanTruckCountUpdatePayload = {
  __typename?: 'RoutingImportPlanTruckCountUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  routingImportPlan?: Maybe<RoutingImportPlan>;
  userErrors: Array<RoutingImportPlanError>;
};

export type RoutingPlanCohort = {
  __typename?: 'RoutingPlanCohort';
  /** A deterministic color based on the cohort id */
  color?: Maybe<Scalars['String']['output']>;
  /** When false, this cohort's stops are pooled into the shared fleet instead of routed on its own trucks. */
  enabled: Scalars['Boolean']['output'];
  /** An identifier for the routing plan cohort entry */
  id: Scalars['ID']['output'];
  /** The per-cohort stop cap, or null when none is set (the cohort falls back to the default). */
  maxStops?: Maybe<Scalars['Int']['output']>;
  /** The name of the routing cohort */
  name: Scalars['String']['output'];
  /** The number of trucks in the routing cohort */
  truckCount?: Maybe<Scalars['Int']['output']>;
};

/** Input type for assigning a truck count to a warehouse shift in a scenario run. */
export type RoutingShiftAssignmentInput = {
  /** How many trucks route on this shift. 0 keeps the shift in the assignment but routes no trucks on it. */
  truckCount: Scalars['Int']['input'];
  /** Id of an existing WarehouseShift on this warehouse. */
  warehouseShiftId: Scalars['Int']['input'];
};

/** Autogenerated input type of RunTransactionSyncAudit */
export type RunTransactionSyncAuditInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The location's odeko UUID, as federated on Location.id. */
  locationId: Scalars['ID']['input'];
};

/** Autogenerated return type of RunTransactionSyncAudit. */
export type RunTransactionSyncAuditPayload = {
  __typename?: 'RunTransactionSyncAuditPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  /**
   * The location the audit was requested for, so its transactionSync can be
   * re-read in the same round trip. Null when nothing was requested.
   */
  location?: Maybe<Location>;
};

/** Autogenerated input type of RunTransactionSync */
export type RunTransactionSyncInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The location's odeko UUID, as federated on Location.id. */
  locationId: Scalars['ID']['input'];
};

/** Autogenerated return type of RunTransactionSync. */
export type RunTransactionSyncPayload = {
  __typename?: 'RunTransactionSyncPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  /**
   * The location the sync was started for, so its transactionSync can be re-read
   * in the same round trip. Null when nothing was started.
   */
  location?: Maybe<Location>;
};

export type SalesOutreachLog = {
  __typename?: 'SalesOutreachLog';
  adminId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  locationId: Scalars['ID']['output'];
  loggedAt: Scalars['ISO8601DateTime']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  outcome: Scalars['String']['output'];
};

export type SalesPriorityLocation = {
  __typename?: 'SalesPriorityLocation';
  assignedRep?: Maybe<Admin>;
  avgOrderCadenceDays?: Maybe<Scalars['Float']['output']>;
  categoriesPurchasedCount?: Maybe<Scalars['Int']['output']>;
  categorySpendDetails?: Maybe<Array<CategorySpendDetail>>;
  churnRiskCents?: Maybe<Scalars['Int']['output']>;
  churnScore: Scalars['Int']['output'];
  city?: Maybe<Scalars['String']['output']>;
  compositeScore: Scalars['Int']['output'];
  daysSinceLastOrder?: Maybe<Scalars['Int']['output']>;
  deprioritizeReason?: Maybe<Scalars['String']['output']>;
  deprioritizedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  deprioritizedBy?: Maybe<Scalars['String']['output']>;
  dollarOpportunityCents?: Maybe<Scalars['Int']['output']>;
  expansionOpportunityCents?: Maybe<Scalars['Int']['output']>;
  expansionScore: Scalars['Int']['output'];
  hubspotCompanyId?: Maybe<Scalars['String']['output']>;
  hubspotLead?: Maybe<HubspotLead>;
  /** Mirrored from HubSpot Company.Industry. HubSpot is source of truth; values refresh nightly. */
  industry?: Maybe<Scalars['String']['output']>;
  /**
   * The Location entity for this row. Federated — use to query fields owned by
   * other services (e.g. `signedUpForSupply` from business_portal).
   */
  location?: Maybe<Location>;
  /** @deprecated Use `location { keyId }`. Reachable through the federated `location` field. */
  locationId: Scalars['ID']['output'];
  /** @deprecated Use `location { businessName }`. Reachable through the federated `location` field. */
  locationName: Scalars['String']['output'];
  /** @deprecated Use `location { id }`. Reachable through the federated `location` field. */
  locationUuid?: Maybe<Scalars['ID']['output']>;
  mostRecentOutcome?: Maybe<Scalars['String']['output']>;
  mostRecentOutcomeAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  scoreSignals?: Maybe<Scalars['JSON']['output']>;
  scoredAt: Scalars['ISO8601DateTime']['output'];
  /**
   * 13 weekly spend totals (cents) for the prior ~90 days, oldest → newest. Drives
   * the comparison line on the spend trend chart.
   */
  spendPrevWeeklyCents?: Maybe<Array<Scalars['Int']['output']>>;
  /**
   * 13 weekly spend totals (cents) for the recent ~90 days, oldest → newest.
   * Bucketed by delivery_date. Drives the spend trend chart on the Sales Priority detail view.
   */
  spendWeeklyCents?: Maybe<Array<Scalars['Int']['output']>>;
  suggestedAction?: Maybe<Scalars['String']['output']>;
  /**
   * Action types currently suppressed for this location. Recent_contact /
   * not_interested suppress all three. Recent or upcoming orders only suppress
   * churn_risk and winback (expansion never appears here from order rules). Churn
   * override: churn_risk is dropped from this list when 90d spend is down ≥20% vs prior 90d.
   */
  suppressedActions: Array<SuggestedActionEnum>;
  /** Timestamp when the strongest suppression window blocking this row's `suggestedAction` expires. */
  suppressedUntil?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * Strongest reason this row's `suggestedAction` is currently suppressed. Null
   * when the row's action isn't blocked. Priority: NOT_INTERESTED > RECENT_CONTACT
   * > RECENT_ORDER. See `suppressedActions` for per-action membership.
   */
  suppressionReason?: Maybe<SuppressionReasonEnum>;
  /** Timestamp of the triggering record (outreach log or order) for the strongest reason blocking this row's `suggestedAction`. */
  suppressionTriggeredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * Top 4 subcategory opportunities for this location, ranked by dollar gap,
   * regardless of parent category. Null when no warehouse subcategory medians
   * exist; empty array when the location already meets or exceeds expected for
   * every subcategory.
   */
  topSubcategorySpendDetails?: Maybe<Array<SubcategorySpendDetail>>;
  warehouseId?: Maybe<Scalars['ID']['output']>;
  warehouseName?: Maybe<Scalars['String']['output']>;
  weightedOpportunityCents?: Maybe<Scalars['Int']['output']>;
  winbackOpportunityCents?: Maybe<Scalars['Int']['output']>;
  winbackScore: Scalars['Int']['output'];
};

export enum SalesPrioritySortByEnum {
  /** Sort by composite behavioral score */
  CompositeScore = 'COMPOSITE_SCORE',
  /** Sort by dollar opportunity (highest revenue impact first) */
  DollarOpportunity = 'DOLLAR_OPPORTUNITY'
}

export type SalesTaxEstimate = {
  __typename?: 'SalesTaxEstimate';
  date: Scalars['ISO8601Date']['output'];
  id: Scalars['ID']['output'];
  locationUuid: Scalars['ID']['output'];
  totalTax: Money;
  vendorUuid: Scalars['ID']['output'];
};

export type SalesTaxEstimateInput = {
  /** Sales tax estimate ID */
  id: Scalars['ID']['input'];
  /** Vendor UUID for the sales tax estimate */
  vendorUuid: Scalars['ID']['input'];
};

export type SalesTaxLineInput = {
  /** Total amount (in cents) for this line. */
  amountCents: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  /**
   * Code identifying the item. Currently, this will be a product UUID in all
   * cases. Adding support for other types of line-items (e.g. discounts, fees,
   * shipping charges) would involve assigning codes to identify them.
   */
  itemCode: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

/** Autogenerated input type of SaveConsumerAppReferralLink */
export type SaveConsumerAppReferralLinkInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Referral link URL */
  url: Scalars['String']['input'];
};

/** Autogenerated return type of SaveConsumerAppReferralLink */
export type SaveConsumerAppReferralLinkPayload = {
  __typename?: 'SaveConsumerAppReferralLinkPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to save consumer app referral link */
  result: SaveConsumerAppReferralLinkResult;
};

/** Result of attempting to save consumer app referral link. */
export type SaveConsumerAppReferralLinkResult = ConsumerAppReferralLinkSuccess | ErrorsResult;

export type SaveMasterHomepageRowInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  structureType: MasterHomepageRowStructureType;
};

export type SaveMasterHomepageRowsInput = {
  id: Scalars['ID']['input'];
  rows: Array<SaveMasterHomepageRowInput>;
};

export type SaveMasterHomepageRowsPayload = {
  __typename?: 'SaveMasterHomepageRowsPayload';
  errors: Array<MasterHomepageError>;
};

/** Autogenerated input type of SaveRoutificScenario */
export type SaveRoutificScenarioInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** GM-supplied display name to set on the scenario. */
  name: Scalars['String']['input'];
  /** Id of the scenario run to name. */
  scenarioId: Scalars['ID']['input'];
};

/** Autogenerated return type of SaveRoutificScenario. */
export type SaveRoutificScenarioPayload = {
  __typename?: 'SaveRoutificScenarioPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The named scenario run. Null on error. */
  scenario?: Maybe<RoutificRunSummary>;
  userErrors: Array<RoutingImportPlanError>;
};

/** Autogenerated input type of SaveVendorAllocation */
export type SaveVendorAllocationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nightEnd: Scalars['ISO8601Date']['input'];
  orders: Array<OrderAllocationInput>;
  vendorId: Scalars['ID']['input'];
  warehouseId: Scalars['ID']['input'];
};

/** Autogenerated return type of SaveVendorAllocation. */
export type SaveVendorAllocationPayload = {
  __typename?: 'SaveVendorAllocationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  userErrors: Array<UserError>;
};

/** Autogenerated input type of ScanMarketingQrCodeMutation */
export type ScanMarketingQrCodeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID (UUID) of the QR code being scanned */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ScanMarketingQrCodeMutation. */
export type ScanMarketingQrCodeMutationPayload = {
  __typename?: 'ScanMarketingQrCodeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  qrScan: MarketingQrScan;
};

export type ScenarioLimitReached = UserErrorInterface & {
  __typename?: 'ScenarioLimitReached';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type ScenarioNotFound = UserErrorInterface & {
  __typename?: 'ScenarioNotFound';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type ScenarioRunsNotEnabled = UserErrorInterface & {
  __typename?: 'ScenarioRunsNotEnabled';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type ScheduledDeliveryTime = {
  __typename?: 'ScheduledDeliveryTime';
  /**
   * The earliest time the order is expected to be delivered, represented as a
   * local date and time without a time zone offset (e.g., "2025-07-01T08:00:00").
   * This time should be interpreted in the context of the delivery location's time zone.
   */
  earliest: Scalars['String']['output'];
  /**
   * The latest time the order is expected to be delivered, represented as a local
   * date and time without a time zone offset (e.g., "2025-07-01T20:00:00"). This
   * time should be interpreted in the context of the delivery location's time zone.
   */
  latest: Scalars['String']['output'];
  /**
   * The IANA time zone identifier (e.g., "America/New_York") specifying the time
   * zone in which the scheduled delivery times should be interpreted.
   */
  timeZone: Scalars['String']['output'];
};

export enum ScheduledDeliveryTimeSourceEnum {
  /** Delivery time based on delivery window */
  DeliveryWindow = 'DELIVERY_WINDOW',
  /** Delivery time based on store hours */
  StoreHours = 'STORE_HOURS'
}

/** Error indicating that a mutation failed because the requested pickup time is too far in the future. */
export type ScheduledTooFarOut = Error & {
  __typename?: 'ScheduledTooFarOut';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** How scores are aggregated in leaderboards */
export enum ScoreOperatorEnum {
  /** Keep the latest score */
  Latest = 'LATEST',
  /** Keep the maximum score */
  Maximum = 'MAXIMUM',
  /** Keep the minimum score */
  Minimum = 'MINIMUM',
  /** Sum all scores */
  Sum = 'SUM'
}

export type SearchTermImpression = {
  __typename?: 'SearchTermImpression';
  /** Number of impressions for this search term, nullable if threshold is set */
  impressions?: Maybe<Scalars['Int']['output']>;
  /** Indicates if the search term is an exact match or threshold term */
  isExact: Scalars['Boolean']['output'];
  /** Inclusive start date of the aggregration period */
  startDate: Scalars['ISO8601Date']['output'];
  /** The search keyword that triggered the impression */
  term: Scalars['String']['output'];
  /** Threshold for the search term. Nullable if impressions are present */
  threshold?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of SendAlignmentMessage */
export type SendAlignmentMessageInput = {
  body: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  triggerAgent?: InputMaybe<Scalars['Boolean']['input']>;
  waitForEvents?: InputMaybe<Scalars['Boolean']['input']>;
  workThreadId: Scalars['ID']['input'];
};

/** Autogenerated return type of SendAlignmentMessage. */
export type SendAlignmentMessagePayload = {
  __typename?: 'SendAlignmentMessagePayload';
  agentRun?: Maybe<AgentRun>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  commandId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  event?: Maybe<WorkThreadEvent>;
};

/** Autogenerated input type of SendBrandedPaperQuestionEmailMutation */
export type SendBrandedPaperQuestionEmailMutationInput = {
  /** The Auth0 User id of the user posing the question. */
  auth0UserId: Scalars['String']['input'];
  /** The body of the email. */
  body: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The email given by the user when posing the question. May be different than
   * the user's recorded email address. The from header of the email.
   */
  email: Scalars['String']['input'];
  /** The subject of the email. */
  subject: Scalars['String']['input'];
};

/** Autogenerated return type of SendBrandedPaperQuestionEmailMutation. */
export type SendBrandedPaperQuestionEmailMutationPayload = {
  __typename?: 'SendBrandedPaperQuestionEmailMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  emailScheduled: Scalars['Boolean']['output'];
  errors: Array<Scalars['String']['output']>;
};

/** Input for sending a chat message */
export type SendChatMessageInput = {
  /** The message body for a chat message, this will typically be from a user `What is my name?` */
  body: Scalars['String']['input'];
  /**
   * The metadata for a chat message, this may be system relevant information you
   * believed to be relevant to the conversation at a given point in time. i.e during sending the message.
   *
   * This may be along the lines of "The user is current viewing the item Oat Milk with uuid 123"
   */
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of SendEquipmentCheckoutEmailMutation */
export type SendEquipmentCheckoutEmailMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The user's email. */
  email: Scalars['String']['input'];
  /** True if the user requested financing for the order. */
  financingRequested: Scalars['Boolean']['input'];
  /** The location selected by the user when ordering. */
  locationUuid: Scalars['String']['input'];
  /** The list of equipment ordered. */
  orderLines: Array<EquipmentOrderLineInput>;
};

/** Autogenerated return type of SendEquipmentCheckoutEmailMutation. */
export type SendEquipmentCheckoutEmailMutationPayload = {
  __typename?: 'SendEquipmentCheckoutEmailMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  emailScheduled: Scalars['Boolean']['output'];
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of SendEquipmentQuestionEmailMutation */
export type SendEquipmentQuestionEmailMutationInput = {
  /** The Auth0 User id of the user posing the question. */
  auth0UserId: Scalars['String']['input'];
  /** The body of the email. */
  body: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The email given by the user when posing the question. May be different than
   * the user's recorded email address. The from header of the email.
   */
  email: Scalars['String']['input'];
  /** The subject of the email. */
  subject: Scalars['String']['input'];
};

/** Autogenerated return type of SendEquipmentQuestionEmailMutation. */
export type SendEquipmentQuestionEmailMutationPayload = {
  __typename?: 'SendEquipmentQuestionEmailMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  emailScheduled: Scalars['Boolean']['output'];
  errors: Array<Scalars['String']['output']>;
};

export type ServiceError = UserErrorInterface & {
  __typename?: 'ServiceError';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type ServiceFee = FeeInterface & {
  __typename?: 'ServiceFee';
  /** The threshold amount in cents at which the fee is applied. */
  feeThresholds: Array<FeeThreshold>;
  id: Scalars['ID']['output'];
  /** Indicates if the fee is active or not. */
  isActive: Scalars['Boolean']['output'];
  odekoUuid: Scalars['ID']['output'];
  /** The amount of the service fee in cents. */
  warehouseFeeAmountCents: Scalars['Int']['output'];
  /** Unique identifier of the warehouse associated with this service fee. */
  warehouseId: Scalars['ID']['output'];
};

/** Autogenerated input type of SetDefaultPaymentMethodForLocationsMutation */
export type SetDefaultPaymentMethodForLocationsMutationInput = {
  /** If true, also sets default payment method for all other eligible locations the user has access to */
  applyToEligibleLocations?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** UUID for the location to set default payment method */
  locationUuid: Scalars['String']['input'];
  /** Stripe payment method ID */
  paymentMethodId: Scalars['String']['input'];
  /** Payment method type (CREDIT_CARD or BANK_ACCOUNT). If omitted, will be determined from Stripe. */
  paymentMethodType?: InputMaybe<PaymentMethodTypeEnum>;
};

/** Autogenerated return type of SetDefaultPaymentMethodForLocationsMutation. */
export type SetDefaultPaymentMethodForLocationsMutationPayload = {
  __typename?: 'SetDefaultPaymentMethodForLocationsMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  /** List of locations that were set */
  locations: Array<Location>;
};

/** Autogenerated input type of SetFinancialStatementPreferencesMutation */
export type SetFinancialStatementPreferencesMutationInput = {
  /** Whether or not to apply these preferences to all user locations */
  applyToAllLocations?: InputMaybe<Scalars['Boolean']['input']>;
  /** The list of billing contact emails (up to 10 are allowed) */
  billingContactEmails: Array<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The frequency at which statements must be emailed */
  emailFrequency: FinancialStatementEmailFrequencyTypeEnum;
  /** The current location UUID */
  locationUuid: Scalars['String']['input'];
};

/** Autogenerated return type of SetFinancialStatementPreferencesMutation. */
export type SetFinancialStatementPreferencesMutationPayload = {
  __typename?: 'SetFinancialStatementPreferencesMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  locations?: Maybe<Array<Location>>;
};

/** Autogenerated input type of SetFleetComposition */
export type SetFleetCompositionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The fleet: one entry per vehicle type with its truck count. An empty list
   * clears the composition. Capacities are not caller-set — they come from the
   * warehouse's vehicle types.
   */
  vehicles: Array<FleetVehicleInput>;
  /** Warehouse whose fleet composition to write. */
  warehouseId: Scalars['ID']['input'];
};

/** Autogenerated return type of SetFleetComposition. */
export type SetFleetCompositionPayload = {
  __typename?: 'SetFleetCompositionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** True when the fleet composition was persisted. */
  saved: Scalars['Boolean']['output'];
  userErrors: Array<FleetCompositionError>;
};

/** Autogenerated input type of SetFundApplicationExclusions */
export type SetFundApplicationExclusionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  exclusions: Array<FundApplicationExclusionInput>;
};

/** Autogenerated return type of SetFundApplicationExclusions. */
export type SetFundApplicationExclusionsPayload = {
  __typename?: 'SetFundApplicationExclusionsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  locations?: Maybe<Array<Location>>;
};

/** Autogenerated input type of SetInvoiceExternalSupplier */
export type SetInvoiceExternalSupplierInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  externalSupplierId?: InputMaybe<Scalars['ID']['input']>;
  externalSupplierName?: InputMaybe<Scalars['String']['input']>;
  supplierInvoiceId: Scalars['ID']['input'];
};

/** Autogenerated return type of SetInvoiceExternalSupplier. */
export type SetInvoiceExternalSupplierPayload = {
  __typename?: 'SetInvoiceExternalSupplierPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  externalSupplier?: Maybe<ExternalSupplier>;
  supplierInvoice?: Maybe<SupplierInvoice>;
};

export type SetItemInactiveError = {
  __typename?: 'SetItemInactiveError';
  message: Scalars['String']['output'];
};

export type SetItemInactivePayload = {
  __typename?: 'SetItemInactivePayload';
  errors: Array<SetItemInactiveError>;
  item?: Maybe<SupplyItem>;
};

/** Autogenerated input type of SetMerchantOperatingHours */
export type SetMerchantOperatingHoursInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Hours of operation in merchant's time zone. */
  friday: MerchantOperatingHoursForDayOfWeekInput;
  /** Merchant ID. */
  merchantId: Scalars['ID']['input'];
  /** Hours of operation in merchant's time zone. */
  monday: MerchantOperatingHoursForDayOfWeekInput;
  /** Hours of operation in merchant's time zone. */
  saturday: MerchantOperatingHoursForDayOfWeekInput;
  /** Hours of operation in merchant's time zone. */
  sunday: MerchantOperatingHoursForDayOfWeekInput;
  /** Hours of operation in merchant's time zone. */
  thursday: MerchantOperatingHoursForDayOfWeekInput;
  /** Hours of operation in merchant's time zone. */
  tuesday: MerchantOperatingHoursForDayOfWeekInput;
  /** Hours of operation in merchant's time zone. */
  wednesday: MerchantOperatingHoursForDayOfWeekInput;
};

/** Autogenerated return type of SetMerchantOperatingHours */
export type SetMerchantOperatingHoursPayload = {
  __typename?: 'SetMerchantOperatingHoursPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to set the merchant's schedule. */
  result: MerchantResult;
};

/** Autogenerated input type of SetTip */
export type SetTipInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Opaque token identifying a specific version of the cart. */
  fingerprint: Scalars['String']['input'];
  /** Tip expressed as a percent of subtotal. */
  tipPercent?: InputMaybe<Scalars['Int']['input']>;
  /** Tip expressed as a fixed value. */
  tipValue?: InputMaybe<MoneyInput>;
};

/** Autogenerated return type of SetTip */
export type SetTipPayload = {
  __typename?: 'SetTipPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to set tip. */
  result: CartResult;
};

export type ShiftAssignmentEntry = {
  __typename?: 'ShiftAssignmentEntry';
  /** How many trucks route on this shift. 0 keeps the shift in the assignment but routes no trucks on it. */
  truckCount: Scalars['Int']['output'];
  /** Id of the WarehouseShift this entry assigns trucks to. */
  warehouseShiftId: Scalars['Int']['output'];
};

export type ShiftNotFound = UserErrorInterface & {
  __typename?: 'ShiftNotFound';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type ShipDateRequired = UserErrorInterface & {
  __typename?: 'ShipDateRequired';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type ShippingEstimate = {
  __typename?: 'ShippingEstimate';
  /** Cost of shipping only; does not include the cost of items. */
  costCents: Scalars['Int']['output'];
  deliveryRange: ShippingEstimateDeliveryRange;
  shippingMethod: ShippingMethodEnum;
  weight: Scalars['Float']['output'];
};


export type ShippingEstimateDeliveryRangeArgs = {
  orderDate: Scalars['ISO8601Date']['input'];
};

export type ShippingEstimateDeliveryRange = {
  __typename?: 'ShippingEstimateDeliveryRange';
  earliest: Scalars['ISO8601Date']['output'];
  latest: Scalars['ISO8601Date']['output'];
};

export type ShippingInstructions = {
  __typename?: 'ShippingInstructions';
  appointmentNeeded: Scalars['Boolean']['output'];
  deliveryNotes?: Maybe<Scalars['String']['output']>;
  hoursOfOperation: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  liftgateNeeded: Scalars['Boolean']['output'];
  /** @deprecated Deprecated - use phone_numbers on Location */
  phoneNumber: Scalars['String']['output'];
  rearDockDelivery: Scalars['Boolean']['output'];
  residentialAddress: Scalars['Boolean']['output'];
};

export type ShippingInstructionsInput = {
  appointmentNeeded?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryNotes?: InputMaybe<Scalars['String']['input']>;
  hoursOfOperation?: InputMaybe<Scalars['String']['input']>;
  liftgateNeeded?: InputMaybe<Scalars['Boolean']['input']>;
  rearDockDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  residentialAddress?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ShippingMethodEnum {
  /** Shipped via pallet (for heavier orders) */
  Pallet = 'pallet',
  /** Shipped via parcel (for lighter orders) */
  Parcel = 'parcel'
}

/** A purchasable sign product */
export type SignProduct = {
  __typename?: 'SignProduct';
  /** Human-readable description */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the sign product */
  id: Scalars['ID']['output'];
  /** Sign price in cents */
  priceCents: Scalars['Int']['output'];
};

/** A signage order tracking Monday.com production tickets */
export type SignageOrder = {
  __typename?: 'SignageOrder';
  /** Business name associated with this signage order */
  businessName: Scalars['String']['output'];
  /** Timestamp when SignageOrder was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Customer-visible production status */
  currentStatus?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the SignageOrder */
  id: Scalars['ID']['output'];
  /** Last time status was synced from Monday.com */
  lastStatusCheck?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Physical location address for signage installation */
  locationAddress?: Maybe<Scalars['String']['output']>;
  /** Timestamp when Monday.com production ticket was created */
  mondayCreatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Monday.com ticket ID for tracking production */
  mondayTicketId?: Maybe<Scalars['String']['output']>;
  /** Customer-facing order number */
  orderNumber: Scalars['Int']['output'];
  /** QR codes associated with this signage order */
  qrCodes: Array<MarketingQrCode>;
  /** Description of signage quantities ordered */
  quantityText: Scalars['String']['output'];
  /** Color of the signage requested */
  signColor: Scalars['String']['output'];
  /** Type of signage material requested */
  signMaterial: Scalars['String']['output'];
  /** SubscriptionSession that generated this signage order (deprecated: use sourceable) */
  subscriptionSession?: Maybe<SubscriptionSession>;
  /** Shipping tracking number for order delivery */
  trackingNumber?: Maybe<Scalars['String']['output']>;
  /** Timestamp when SignageOrder was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for SignageOrder. */
export type SignageOrderConnection = {
  __typename?: 'SignageOrderConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SignageOrderEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SignageOrder>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of records in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SignageOrderEdge = {
  __typename?: 'SignageOrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SignageOrder>;
};

export type SigninAuthorization = {
  __typename?: 'SigninAuthorization';
  clientID: Scalars['String']['output'];
  domain: Scalars['String']['output'];
  redirectUri: Scalars['String']['output'];
  responseType: Scalars['String']['output'];
};

export type SigninCredentials = {
  __typename?: 'SigninCredentials';
  email: Scalars['String']['output'];
  realm: Scalars['String']['output'];
};

export type SignupAnalytics = {
  __typename?: 'SignupAnalytics';
  anonymousId?: Maybe<Scalars['String']['output']>;
  event: Scalars['String']['output'];
  properties: Scalars['String']['output'];
  propertires?: Maybe<Scalars['JSON']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of SignupMutation */
export type SignupMutationInput = {
  /** The type of account e.g. distributor */
  accountType?: InputMaybe<Scalars['String']['input']>;
  /** The address provided from google places api */
  address: Scalars['String']['input'];
  /** The anonymous id used for tracking */
  anonymousId?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The company name provided the customer */
  companyName: Scalars['String']['input'];
  /** The email provided by the customer */
  email: Scalars['String']['input'];
  /** The first name provided by the customer */
  firstName: Scalars['String']['input'];
  /** How the customer heard about us */
  howDidYouHearAboutUs: Scalars['String']['input'];
  /** The last name provided by the customer */
  lastName: Scalars['String']['input'];
  /** The size of the location provided by the customer */
  locationSize: Scalars['String']['input'];
  /** Meta advertising identifiers from the browser. Signup succeeds without them. */
  metaTracking?: InputMaybe<MetaTrackingInput>;
  /** The ordering size (pallet etc) by the customer */
  orderingSize?: InputMaybe<Scalars['String']['input']>;
  /** The password supplied by the customer */
  password: Scalars['String']['input'];
  /** The phone number supplied by the customer */
  phone: Scalars['String']['input'];
  /** The truck size supplied by the customer */
  truckSize?: InputMaybe<Scalars['String']['input']>;
  /** Indicates the vendor's name when "How did you hear about us?" is answered with "Vendor Referral". */
  vendorReferral?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SignupMutation. */
export type SignupMutationPayload = {
  __typename?: 'SignupMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  signupResponse: SignupResponse;
};

export type SignupResponse = {
  __typename?: 'SignupResponse';
  accountCreated: Scalars['Boolean']['output'];
  analytics: Array<SignupAnalytics>;
  authorization?: Maybe<SigninAuthorization>;
  credentials?: Maybe<SigninCredentials>;
  nextUrl?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
};

export type SizeInput = {
  quantity: Scalars['Float']['input'];
  unit: Scalars['ID']['input'];
};

export type Sku = {
  __typename?: 'Sku';
  categoryName: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /**
   * PROTOTYPE The skus' inventory information.
   * @deprecated Prefer 'inventoryLocationItem' instead, since it includes an id field, while this does not.
   */
  inventoryInfo?: Maybe<InventoryInfo>;
  /** PROTOTYPE The inventory LocationItem for corresponding to this sku. */
  inventoryLocationItem?: Maybe<InventoryLocationItem>;
  /** Item if not a sample */
  item?: Maybe<SupplyItem>;
  name: Scalars['String']['output'];
  priceCents: Scalars['Int']['output'];
  /** @deprecated legacy, use refrigeration_state instead */
  refrigerationRequired: Scalars['Boolean']['output'];
  refrigerationState: Scalars['String']['output'];
  /** @deprecated legacy, use categoryName instead */
  skuCategory?: Maybe<SkuCategory>;
  subcategoryName: Scalars['String']['output'];
};

export type SkuCategory = {
  __typename?: 'SkuCategory';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** Sort direction values. */
export enum SortDirection {
  /** Ascending, nulls last. */
  Asc = 'ASC',
  /** Descending, nulls first. */
  Desc = 'DESC'
}

export enum SortDirectionEnum {
  /** Smallest or earliest first. */
  Asc = 'ASC',
  /** Largest or latest first. */
  Desc = 'DESC'
}

/** Sort order for leaderboards */
export enum SortOrderEnum {
  /** Sort in ascending order (lowest to highest) */
  Ascending = 'ASCENDING',
  /** Sort in descending order (highest to lowest) */
  Descending = 'DESCENDING'
}

/** A device code for pairing a Square Terminal */
export type SquareDeviceCode = {
  __typename?: 'SquareDeviceCode';
  /** The pairing code to enter on the terminal */
  code: Scalars['String']['output'];
  /** Creation timestamp */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Device code ID */
  id: Scalars['ID']['output'];
  /** Square location ID */
  locationId: Scalars['String']['output'];
  /** Code expiration time */
  pairBy?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Code status (UNPAIRED, PAIRED, EXPIRED) */
  status: Scalars['String']['output'];
};

/** A Square location (storefront) synced from the merchant's account */
export type SquareLocation = {
  __typename?: 'SquareLocation';
  /** Street address line 1 */
  addressLine1?: Maybe<Scalars['String']['output']>;
  /** Street address line 2 */
  addressLine2?: Maybe<Scalars['String']['output']>;
  /** State/Province */
  administrativeDistrictLevel1?: Maybe<Scalars['String']['output']>;
  /** Business name */
  businessName?: Maybe<Scalars['String']['output']>;
  /** ISO 3166-1 alpha-2 country code */
  country?: Maybe<Scalars['String']['output']>;
  /** ISO 4217 currency code */
  currency?: Maybe<Scalars['String']['output']>;
  /** Internal location record ID */
  id: Scalars['ID']['output'];
  /** City */
  locality?: Maybe<Scalars['String']['output']>;
  /** Location display name */
  name?: Maybe<Scalars['String']['output']>;
  /** Contact phone number */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Postal code */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** Square's location ID */
  squareId: Scalars['String']['output'];
  /** Location type (PHYSICAL, MOBILE, WAREHOUSE) */
  squareType?: Maybe<Scalars['String']['output']>;
  /** Location status (ACTIVE, INACTIVE) */
  status?: Maybe<Scalars['String']['output']>;
  /** Terminals paired to this location */
  terminals: Array<SquareTerminal>;
  /** IANA timezone identifier */
  timezone?: Maybe<Scalars['String']['output']>;
};

/** A Square order */
export type SquareOrder = {
  __typename?: 'SquareOrder';
  /** Order creation timestamp */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Square order ID */
  id: Scalars['String']['output'];
  /** Order line items */
  lineItems: Array<Scalars['JSON']['output']>;
  /** Square location ID */
  locationId: Scalars['String']['output'];
  /** Customer note */
  note?: Maybe<Scalars['String']['output']>;
  /** Order state (OPEN, COMPLETED, CANCELED) */
  state: Scalars['String']['output'];
  /** Total amount with currency */
  totalMoney?: Maybe<Scalars['JSON']['output']>;
};

/** A suggested order parsed from voice transcript */
export type SquareOrderSuggestion = {
  __typename?: 'SquareOrderSuggestion';
  /** Terminal checkout attempts */
  checkouts: Array<SquareTerminalCheckout>;
  /** Creation timestamp */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Currency code */
  currency: Scalars['String']['output'];
  /** Suggestion ID */
  id: Scalars['ID']['output'];
  /** Suggested line items */
  lineItems: Array<SquareOrderSuggestionLineItem>;
  /** Special requests extracted from transcript */
  note?: Maybe<Scalars['String']['output']>;
  /** Suggestion status (pending, confirmed, canceled) */
  status: Scalars['String']['output'];
  /** Total amount in cents */
  totalCents: Scalars['Int']['output'];
  /** Original voice transcript */
  transcript: Scalars['String']['output'];
  /** Items mentioned but not found in menu */
  unmatchedLineItems: Array<UnmatchedItem>;
};

/** A line item in a Square order suggestion */
export type SquareOrderSuggestionLineItem = {
  __typename?: 'SquareOrderSuggestionLineItem';
  /** Currency code (e.g., USD) */
  currency: Scalars['String']['output'];
  /** POS modifiers applied to this item (e.g., Oat Milk, Half Vanilla) */
  modifiers?: Maybe<Array<SquareOrderSuggestionLineItemModifier>>;
  /** Item name */
  name: Scalars['String']['output'];
  /** Item-specific customization not in POS (e.g., 'extra hot') */
  note?: Maybe<Scalars['String']['output']>;
  /** Unit price in cents */
  priceCents: Scalars['Int']['output'];
  /** Item quantity */
  quantity: Scalars['Int']['output'];
  /** Square catalog variation ID */
  variationId: Scalars['String']['output'];
  /** Variation name (e.g., Large, Small) */
  variationName?: Maybe<Scalars['String']['output']>;
};

/** Input for a line item in an order suggestion */
export type SquareOrderSuggestionLineItemInput = {
  /** Currency code (defaults to USD) */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Modifiers applied to this line item (omit to preserve existing) */
  modifiers?: InputMaybe<Array<SquareOrderSuggestionLineItemModifierInput>>;
  /** Item name for display (resolved from catalog if omitted) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Item-specific modifier or request (e.g., 'no foam', 'extra hot') */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Unit price in cents (resolved from catalog if omitted) */
  priceCents?: InputMaybe<Scalars['Int']['input']>;
  /** Item quantity (must be positive) */
  quantity: Scalars['Int']['input'];
  /** Square catalog variation ID */
  variationId: Scalars['String']['input'];
  /** Variation name (resolved from catalog if omitted) */
  variationName?: InputMaybe<Scalars['String']['input']>;
};

/** A modifier applied to a line item in a Square order suggestion */
export type SquareOrderSuggestionLineItemModifier = {
  __typename?: 'SquareOrderSuggestionLineItemModifier';
  /** Square catalog modifier ID */
  id: Scalars['String']['output'];
  /** Modifier name (e.g., 'Oat Milk', 'Half Vanilla') */
  name: Scalars['String']['output'];
  /** Price adjustment in cents */
  priceCents: Scalars['Int']['output'];
};

/** Input for a modifier on a line item in an order suggestion */
export type SquareOrderSuggestionLineItemModifierInput = {
  /** Square catalog modifier ID */
  id: Scalars['String']['input'];
  /** Modifier name (e.g., 'Oat Milk', 'Half Vanilla') */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Price adjustment in cents */
  priceCents?: InputMaybe<Scalars['Int']['input']>;
};

/** A paired Square Terminal device */
export type SquareTerminal = {
  __typename?: 'SquareTerminal';
  /** Creation timestamp */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Square device ID (manufacturers_id) */
  deviceId: Scalars['String']['output'];
  /** Device type (e.g., TERMINAL) */
  deviceType?: Maybe<Scalars['String']['output']>;
  /** Terminal record ID */
  id: Scalars['ID']['output'];
  /** Device manufacturer */
  manufacturer?: Maybe<Scalars['String']['output']>;
  /** Device model */
  model?: Maybe<Scalars['String']['output']>;
  /** Terminal display name */
  name?: Maybe<Scalars['String']['output']>;
  /** Associated Square location ID */
  squareLocationId: Scalars['ID']['output'];
  /** Pairing status (PAIRED, UNPAIRED) */
  status: Scalars['String']['output'];
  /** Device status category from Square (e.g., AVAILABLE, NEEDS_ATTENTION) */
  statusCategory?: Maybe<Scalars['String']['output']>;
  /** Last sync timestamp from Square API */
  syncedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Last update timestamp */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Device software version */
  version?: Maybe<Scalars['String']['output']>;
};

/** A Square Terminal checkout tracking record */
export type SquareTerminalCheckout = {
  __typename?: 'SquareTerminalCheckout';
  /** Total amount in cents */
  amountCents?: Maybe<Scalars['Int']['output']>;
  /** When checkout was canceled */
  canceledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Square checkout ID */
  checkoutId: Scalars['String']['output'];
  /** When checkout was completed */
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Creation timestamp */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Currency code */
  currency?: Maybe<Scalars['String']['output']>;
  /** Checkout record ID */
  id: Scalars['ID']['output'];
  /** Payment IDs from completed checkout */
  paymentIds: Array<Scalars['String']['output']>;
  /** Checkout status (PENDING, IN_PROGRESS, COMPLETED, CANCELED) */
  status: Scalars['String']['output'];
  /** Last updated timestamp */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** One order line in the Stage Gate drill-down: item plus its four stage quantities. */
export type StageGateOrderLineDetail = {
  __typename?: 'StageGateOrderLineDetail';
  /** Units NetSuite committed (order_lines.committed_quantity; null committed = 0). */
  committedUnits: Scalars['Int']['output'];
  /** Units delivered (order_lines.delivered_quantity; null until delivered). */
  deliveredUnits?: Maybe<Scalars['Int']['output']>;
  /** Units fulfilled (order_lines.fulfillment_quantity; null until fulfilled). */
  fulfillmentUnits?: Maybe<Scalars['Int']['output']>;
  /** The line item's name (nil when the item is unknown). */
  itemName?: Maybe<Scalars['String']['output']>;
  /** Units ordered (order_lines.unit_quantity). */
  orderedUnits: Scalars['Int']['output'];
};

/**
 * Route-grouped, per-order-line detail for a warehouse + delivery date + Stage
 * Gate step. See Resolvers::WarehouseStageGateOrderLines.
 */
export type StageGateOrderLinesReport = {
  __typename?: 'StageGateOrderLinesReport';
  /** Routes with at least one stop with order lines after step filtering, in route order. */
  routes: Array<StageGateRoute>;
  /**
   * Orders for the warehouse + delivery date that are not on any route, with order
   * lines after step filtering. Empty ones are omitted.
   */
  unroutedOrders: Array<StageGateUnroutedOrder>;
};

/** A delivery route in the Stage Gate drill-down, holding its non-empty stops. */
export type StageGateRoute = {
  __typename?: 'StageGateRoute';
  /** The delivery route's id. */
  routeId: Scalars['ID']['output'];
  /** The delivery route's name (nil when unnamed). */
  routeName?: Maybe<Scalars['String']['output']>;
  /** The route's stops that have order lines after step filtering, in stop sequence. */
  stops: Array<StageGateStop>;
};

/** A Stage Gate step whose per-order-line drill-down is being requested. */
export enum StageGateStep {
  /** Commitment step. Returns only lines where committed units differ from ordered units. */
  Commitment = 'COMMITMENT',
  /** Delivered step. Not yet filtered — returns all order lines. */
  Delivered = 'DELIVERED',
  /** Fulfilled step. Returns only lines where fulfilled units differ from committed units. */
  Fulfilled = 'FULFILLED',
  /** Picked step. Not yet filtered — returns all order lines. */
  Picked = 'PICKED',
  /** Sync step. Not yet filtered — returns all order lines. */
  Sync = 'SYNC'
}

/**
 * One order at a stop in the Stage Gate drill-down. A stop with several orders
 * yields one entry per order, all sharing the same stopNumber.
 */
export type StageGateStop = {
  __typename?: 'StageGateStop';
  /** The order location's business name (nil when the order has no location). */
  locationName?: Maybe<Scalars['String']['output']>;
  /** The order's lines relevant to the requested step. */
  orderLines: Array<StageGateOrderLineDetail>;
  /** The order's id. */
  orderNumber: Scalars['ID']['output'];
  /** The stop's 1-indexed sequence position (sequence_number + 1). */
  stopNumber: Scalars['Int']['output'];
};

/**
 * An order for the warehouse + delivery date that is not on any route, so it has
 * no stop. Surfaced alongside routes so the drill-down covers the same orders the
 * gate card counts.
 */
export type StageGateUnroutedOrder = {
  __typename?: 'StageGateUnroutedOrder';
  /** The order location's business name (nil when the order has no location). */
  locationName?: Maybe<Scalars['String']['output']>;
  /** The order's lines relevant to the requested step. */
  orderLines: Array<StageGateOrderLineDetail>;
  /** The order's id. */
  orderNumber: Scalars['ID']['output'];
};

/** Error indicating a cart fingerprint mismatch. */
export type StaleCartError = Error & {
  __typename?: 'StaleCartError';
  /** Current cart info. */
  currentCart: Cart;
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Error indicating a config edition mismatch */
export type StaleConfigError = {
  __typename?: 'StaleConfigError';
  /** Current config info */
  currentConfig: Config;
  /** A description of the error */
  message: Scalars['String']['output'];
};

/** Error indicating a request was made using outdated refund info. */
export type StaleConsumerRefundInfoError = Error & {
  __typename?: 'StaleConsumerRefundInfoError';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Error indicating an object lock version mismatch. */
export type StaleObjectError = Error & {
  __typename?: 'StaleObjectError';
  /** Object ID. */
  id: Scalars['ID']['output'];
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Catch-all error type. */
export type StandardError = Error & {
  __typename?: 'StandardError';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

export type StandingAppointment = {
  __typename?: 'StandingAppointment';
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Warehouse-local wall clock, e.g. "10:00". */
  earliestTime: Scalars['String']['output'];
  effectiveFrom: Scalars['ISO8601Date']['output'];
  effectiveUntil: Scalars['ISO8601Date']['output'];
  freightType: FreightType;
  id: Scalars['ID']['output'];
  /** Warehouse-local wall clock, e.g. "13:00". */
  latestTime: Scalars['String']['output'];
  netsuiteInternalId: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  vendorName: Scalars['String']['output'];
  warehouse: Warehouse;
  /** Ruby Date#wday values (0=Sunday..6=Saturday). */
  weekdays: Array<Scalars['Int']['output']>;
};

export type StandingAppointmentAlreadyResolved = UserErrorInterface & {
  __typename?: 'StandingAppointmentAlreadyResolved';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of StandingAppointmentCreate */
export type StandingAppointmentCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Warehouse-local wall clock, e.g. "10:00". */
  earliestTime: Scalars['String']['input'];
  effectiveFrom: Scalars['ISO8601Date']['input'];
  effectiveUntil: Scalars['ISO8601Date']['input'];
  freightType: FreightType;
  /** Warehouse-local wall clock, e.g. "13:00". */
  latestTime: Scalars['String']['input'];
  netsuiteInternalId: Scalars['String']['input'];
  vendorName: Scalars['String']['input'];
  warehouseId: Scalars['ID']['input'];
  weekdays: Array<Scalars['Int']['input']>;
};

/** Autogenerated return type of StandingAppointmentCreate. */
export type StandingAppointmentCreatePayload = {
  __typename?: 'StandingAppointmentCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  createdBookings: Array<DockBooking>;
  failedDates: Array<Scalars['ISO8601Date']['output']>;
  standingAppointment?: Maybe<StandingAppointment>;
  userErrors: Array<StandingAppointmentError>;
};

export type StandingAppointmentDirectoryEntry = {
  __typename?: 'StandingAppointmentDirectoryEntry';
  standingAppointment: StandingAppointment;
  status: StandingAppointmentDirectoryStatus;
};

export enum StandingAppointmentDirectoryStatus {
  /** Currently effective, no unresolved gaps, not expiring soon. */
  Active = 'ACTIVE',
  /** effectiveUntil has already passed. */
  Ended = 'ENDED',
  /** effectiveUntil falls within the next 14 days. */
  Expiring = 'EXPIRING',
  /** At least one of the rule's own occurrence dates has no booking at all — a materialization failure ops hasn't resolved yet. */
  Gaps = 'GAPS'
}

/** Standing appointment possible error types */
export type StandingAppointmentError = DockBookingWarehouseNotFound | DockWindowNotFound | StandingAppointmentAlreadyResolved | StandingAppointmentIdNotFound | StandingAppointmentInvalidDate | StandingAppointmentNotAllowed | StandingAppointmentNotFound | StandingAppointmentUnresolvable;

export type StandingAppointmentIdNotFound = UserErrorInterface & {
  __typename?: 'StandingAppointmentIdNotFound';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type StandingAppointmentInvalidDate = UserErrorInterface & {
  __typename?: 'StandingAppointmentInvalidDate';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type StandingAppointmentNotAllowed = UserErrorInterface & {
  __typename?: 'StandingAppointmentNotAllowed';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type StandingAppointmentNotFound = UserErrorInterface & {
  __typename?: 'StandingAppointmentNotFound';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of StandingAppointmentResolveFailedDate */
export type StandingAppointmentResolveFailedDateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['ISO8601Date']['input'];
  /** Pick a specific candidate window instead of the least-over-cap default. */
  dockWindowId?: InputMaybe<Scalars['ID']['input']>;
  standingAppointmentId: Scalars['ID']['input'];
};

/** Autogenerated return type of StandingAppointmentResolveFailedDate. */
export type StandingAppointmentResolveFailedDatePayload = {
  __typename?: 'StandingAppointmentResolveFailedDatePayload';
  booking?: Maybe<DockBooking>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userErrors: Array<StandingAppointmentError>;
};

export type StandingAppointmentUnresolvable = UserErrorInterface & {
  __typename?: 'StandingAppointmentUnresolvable';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of StandingAppointmentUpdateEffectiveUntil */
export type StandingAppointmentUpdateEffectiveUntilInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  effectiveUntil: Scalars['ISO8601Date']['input'];
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of StandingAppointmentUpdateEffectiveUntil. */
export type StandingAppointmentUpdateEffectiveUntilPayload = {
  __typename?: 'StandingAppointmentUpdateEffectiveUntilPayload';
  cancelledBookings: Array<DockBooking>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  createdBookings: Array<DockBooking>;
  failedDates: Array<Scalars['ISO8601Date']['output']>;
  standingAppointment?: Maybe<StandingAppointment>;
  userErrors: Array<StandingAppointmentError>;
};

export enum StandingOrderBehavior {
  Available = 'AVAILABLE',
  NotAvailable = 'NOT_AVAILABLE'
}

/** A SKU with its standing order information for a specific day */
export type StandingOrderSku = {
  __typename?: 'StandingOrderSku';
  /** The day name (e.g., "Monday", "Tuesday") */
  dayName: Scalars['String']['output'];
  /** The day of the week as an integer (0=Sunday, 1=Monday, ..., 6=Saturday) */
  dayOfWeek: Scalars['Int']['output'];
  /** Standing order quantity (unit quantity) */
  quantity: Scalars['Int']['output'];
  /** The SKU that has a standing order amount */
  sku: Sku;
};

/** Autogenerated input type of StartCustomerTagImportMutation */
export type StartCustomerTagImportMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customerTagImportId: Scalars['ID']['input'];
  /** The value createCustomerTagImport returned, after the PUT succeeded. */
  signedBlobId: Scalars['String']['input'];
};

/** Autogenerated return type of StartCustomerTagImportMutation. */
export type StartCustomerTagImportMutationPayload = {
  __typename?: 'StartCustomerTagImportMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  customerTagImport?: Maybe<CustomerTagImport>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of StartPhoneNumberVerification */
export type StartPhoneNumberVerificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Phone number in E.164 format, but without the "+" prefix. E.g. "15551231234". */
  phoneNumber: Scalars['String']['input'];
  /** Phone verification application key. */
  phoneVerificationKey?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of StartPhoneNumberVerification */
export type StartPhoneNumberVerificationPayload = {
  __typename?: 'StartPhoneNumberVerificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to start phone number verification. */
  result: StartPhoneNumberVerificationResult;
};

/** Result of attempting to start phone number verification. */
export type StartPhoneNumberVerificationResult = ErrorsResult | PhoneNumberVerificationStarted;

/** Autogenerated input type of StartRouteTimeUpdate */
export type StartRouteTimeUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Delivery route id. */
  deliveryRouteId: Scalars['ID']['input'];
};

/** Autogenerated return type of StartRouteTimeUpdate. */
export type StartRouteTimeUpdatePayload = {
  __typename?: 'StartRouteTimeUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  route?: Maybe<Route>;
  userErrors: Array<RouteError>;
};

/** Autogenerated input type of StopBatchOnboardRunMutation */
export type StopBatchOnboardRunMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  runId: Scalars['ID']['input'];
};

/** Autogenerated return type of StopBatchOnboardRunMutation. */
export type StopBatchOnboardRunMutationPayload = {
  __typename?: 'StopBatchOnboardRunMutationPayload';
  batchOnboardRun?: Maybe<BatchOnboardRun>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type StopCrossingEvent = {
  __typename?: 'StopCrossingEvent';
  /** Whether the driver entered or exited the stop geofence. */
  kind: StopCrossingKind;
  /** Client-reported time of the crossing (the driver-app occurredAt). */
  occurredAt: Scalars['ISO8601DateTime']['output'];
  /** True when the stop was already completed as this crossing fired — a post-completion revisit. */
  postCompletion: Scalars['Boolean']['output'];
};

/** Direction of a geofence stop crossing. */
export enum StopCrossingKind {
  /** The driver crossed into the stop geofence (an arrival). */
  Enter = 'ENTER',
  /** The driver crossed out of the stop geofence (a departure). */
  Exit = 'EXIT'
}

export type StopEstimates = {
  __typename?: 'StopEstimates';
  /** Estimated distance in miles for the stop from previous way point. */
  distance?: Maybe<Scalars['Float']['output']>;
  /** Raw HH:MM string for the estimated finish time in 24 hour rolling windows (may exceed '23:59'). */
  finish?: Maybe<Scalars['String']['output']>;
  /** Date/time representing the estimated finish using delivery date as reference point. */
  finishDatetime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Route number the stop is assigned to. */
  routeNumber?: Maybe<Scalars['Int']['output']>;
  /** Sequence number of the stop in the route. */
  sequenceNumber?: Maybe<Scalars['Int']['output']>;
  /** Raw HH:MM string for the estimated start time in 24 hour rolling windows (may exceed '23:59'). */
  start?: Maybe<Scalars['String']['output']>;
  /** Date/time representing the estimated start using delivery date as reference point. */
  startDatetime?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type StopHasNoFulfilledLines = UserErrorInterface & {
  __typename?: 'StopHasNoFulfilledLines';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type StopHasNoOrderLines = UserErrorInterface & {
  __typename?: 'StopHasNoOrderLines';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type StopInput = {
  id: Scalars['ID']['input'];
};

/** Autogenerated input type of StopRouteTimeUpdate */
export type StopRouteTimeUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Delivery route id. */
  deliveryRouteId: Scalars['ID']['input'];
};

/** Autogenerated return type of StopRouteTimeUpdate. */
export type StopRouteTimeUpdatePayload = {
  __typename?: 'StopRouteTimeUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  route?: Maybe<Route>;
  userErrors: Array<RouteError>;
};

export type StopVisit = {
  __typename?: 'StopVisit';
  /** Seconds on site for this visit (exited_at - entered_at), or null if either end is missing. */
  dwellSeconds?: Maybe<Scalars['Int']['output']>;
  /** When the driver entered the geofence for this visit; null if the ENTER crossing was never recorded. */
  enteredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the driver left the geofence for this visit; null if still on site or the EXIT crossing was never recorded. */
  exitedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** True when this visit occurred after the stop was completed — a revisit. */
  postCompletion: Scalars['Boolean']['output'];
};

export type StopWithProvider = UserErrorInterface & {
  __typename?: 'StopWithProvider';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type StopsBusy = UserErrorInterface & {
  __typename?: 'StopsBusy';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type StopsNotEscalatable = UserErrorInterface & {
  __typename?: 'StopsNotEscalatable';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** Represents a stream of messages for a specific account or account-profile on a platform. */
export type Stream = {
  __typename?: 'Stream';
  /** Timestamp of when the stream was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Cursor used by the sync system to determine the approxiamte starting point for
   * the data to sync in the next synchronization attempt
   */
  dataStartingAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Identifier for the entity (e.g., account ID or profile ID) */
  entityId: Scalars['String']['output'];
  /** Type of entity the stream is associated with (e.g., 'account', 'profile') */
  entityType: Scalars['String']['output'];
  /** Reason for halting the stream, if applicable */
  haltedReason?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the stream */
  id: Scalars['ID']['output'];
  /** Timestamp of the last successful synchronization */
  lastSucceededAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Timestamp for the next synchronization attempt */
  nextSyncOn: Scalars['ISO8601DateTime']['output'];
  /** Current status of the stream (e.g., 'ready', 'halted') */
  status: Scalars['String']['output'];
  /** Timestamp of when the stream was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** A Stripe checkout session for subscription payments */
export type StripeCheckoutSession = {
  __typename?: 'StripeCheckoutSession';
  /** Creation timestamp */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Customer email from Stripe checkout session */
  customerEmail?: Maybe<Scalars['String']['output']>;
  /** Customer first name from Stripe checkout session */
  customerFirstName?: Maybe<Scalars['String']['output']>;
  /** Customer last name from Stripe checkout session */
  customerLastName?: Maybe<Scalars['String']['output']>;
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** Local status tracking */
  status: Scalars['String']['output'];
  /** Stripe checkout session ID */
  stripeSessionId: Scalars['String']['output'];
  /** Status from Stripe webhook/API */
  stripeStatus?: Maybe<Scalars['String']['output']>;
  /** Last update timestamp */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type SubcategorySpendDetail = {
  __typename?: 'SubcategorySpendDetail';
  /** Projected subcategory spend for this location (= location.spend_90d × warehouse subcategory_share_pct / 100). */
  expectedSpendCents: Scalars['Int']['output'];
  /** Opportunity dollars: max(expected_spend_cents - location_spend_cents, 0). */
  gapCents: Scalars['Int']['output'];
  locationSpendCents: Scalars['Int']['output'];
  parentCategoryId?: Maybe<Scalars['ID']['output']>;
  parentCategoryName?: Maybe<Scalars['String']['output']>;
  subcategoryId: Scalars['ID']['output'];
  subcategoryName?: Maybe<Scalars['String']['output']>;
  /**
   * 90-day median location spend for this subcategory across the warehouse.
   * Retained for sales context alongside expected_spend_cents.
   */
  warehouseMedianCents: Scalars['Int']['output'];
};

/** Submenu. */
export type Submenu = Node & {
  __typename?: 'Submenu';
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID']['output'];
  /** Submenu's current lock version, providing concurrency control and protection against stale updates. */
  lockVersion: Scalars['Int']['output'];
  /** Menu items. */
  menuItems: Array<MenuItem>;
  /** Name. */
  name: Scalars['String']['output'];
  /**
   * Hours the submenu is available, in merchant's time zone. Order pickup times
   * cannot be outside the bounds described by these hours when ordering from this submenu.
   */
  operatingHours: Array<OperatingHoursForDayOfWeek>;
  /** The order of the submenu in the UI. */
  sortOrder: Scalars['Int']['output'];
  /** Visibility. */
  visibility: Visibility;
};

/** Submenu mutation result. */
export type SubmenuResult = ErrorsResult | SubmenuSuccess;

/** Result of a successful submenu mutation. */
export type SubmenuSuccess = {
  __typename?: 'SubmenuSuccess';
  /** Resulting submenu. */
  submenu: Submenu;
};

/** Result of mutating a list of submenus. */
export type SubmenusResult = ErrorsResult | SubmenusSuccess;

/** Result of successfully mutating a list of submenus. */
export type SubmenusSuccess = {
  __typename?: 'SubmenusSuccess';
  /** Resulting submenus. */
  submenus: Array<Submenu>;
};

/** Autogenerated input type of SubmitCheckInMutation */
export type SubmitCheckInMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Email address of the guest */
  email: Scalars['String']['input'];
  /** ID of the microsite location */
  micrositeLocationId: Scalars['ID']['input'];
};

/** Autogenerated return type of SubmitCheckInMutation. */
export type SubmitCheckInMutationPayload = {
  __typename?: 'SubmitCheckInMutationPayload';
  /** The created check-in entry */
  checkInEntry?: Maybe<CheckInEntry>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']['output']>;
  /** When the user can next check in (returned when already checked in today) */
  nextCheckInAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated input type of SubmitMailingListMutation */
export type SubmitMailingListMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Guest's email address */
  email: Scalars['String']['input'];
  /** Guest's first name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Guest's last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** ID of the microsite location */
  micrositeLocationId: Scalars['ID']['input'];
  /** Guest's phone number (optional) */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SubmitMailingListMutation. */
export type SubmitMailingListMutationPayload = {
  __typename?: 'SubmitMailingListMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The newly added guest with their contact information */
  guest?: Maybe<MailingListGuest>;
  /** Mailing list metadata including Google Sheet URL */
  mailingList?: Maybe<MicrositeMailingList>;
};

export type SubmitPurchaseHistoryFeedbackInput = {
  itemId: Scalars['ID']['input'];
  locationId: Scalars['ID']['input'];
  reason: RecommendationFeedbackReason;
};

export type SubmitPurchaseHistoryFeedbackPayload = {
  __typename?: 'SubmitPurchaseHistoryFeedbackPayload';
  errors: Array<PurchaseHistoryFeedbackError>;
  responseType?: Maybe<RecommendationFeedbackType>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SubmitScoreMutation */
export type SubmitScoreMutationInput = {
  /** When the score was achieved (defaults to now) */
  achievedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Email address for the player (optional, private) */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Slug of the game */
  gameSlug: Scalars['String']['input'];
  /** Slug of the leaderboard within the game */
  leaderboardSlug: Scalars['String']['input'];
  /** Additional entry metadata */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** ID of the microsite location */
  micrositeLocationId?: InputMaybe<Scalars['ID']['input']>;
  /** The player's score */
  score: Scalars['Int']['input'];
  /** Secondary score for tiebreaking */
  subscore?: InputMaybe<Scalars['Int']['input']>;
  /** Display name for the player */
  username: Scalars['String']['input'];
};

/** Autogenerated return type of SubmitScoreMutation. */
export type SubmitScoreMutationPayload = {
  __typename?: 'SubmitScoreMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']['output']>;
  /** The created leaderboard entry */
  leaderboardEntry?: Maybe<LeaderboardEntry>;
};

/** Autogenerated input type of SubmitStockCountMutation */
export type SubmitStockCountMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** PROTOTYPE id of the LocationStockCount session to submit. */
  stockCountId: Scalars['ID']['input'];
};

/** Autogenerated return type of SubmitStockCountMutation. */
export type SubmitStockCountMutationPayload = {
  __typename?: 'SubmitStockCountMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  /** PROTOTYPE the location Stock Count submitted by this mutation. */
  submittedStockCount?: Maybe<LocationStockCount>;
};

/** Autogenerated input type of SubmitSuggestionMutation */
export type SubmitSuggestionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Email of the submitter (optional) */
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  /** Name of the submitter (optional) */
  contactName?: InputMaybe<Scalars['String']['input']>;
  /** The feedback text (max 1000 characters) */
  feedback: Scalars['String']['input'];
  /** ID of the microsite location */
  micrositeLocationId: Scalars['ID']['input'];
};

/** Autogenerated return type of SubmitSuggestionMutation. */
export type SubmitSuggestionMutationPayload = {
  __typename?: 'SubmitSuggestionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']['output']>;
  /** Whether to prompt for Google review (true for positive sentiment) */
  showGoogleReviewPrompt: Scalars['Boolean']['output'];
  /** The created suggestion entry */
  suggestionEntry?: Maybe<MicrositeSuggestionEntry>;
};

/** A subscription session for marketing tools signup */
export type SubscriptionSession = {
  __typename?: 'SubscriptionSession';
  /** Business name from Google Places */
  businessName?: Maybe<Scalars['String']['output']>;
  /** Creation timestamp */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Customer first name from Stripe checkout session */
  customerFirstName?: Maybe<Scalars['String']['output']>;
  /** Customer last name from Stripe checkout session */
  customerLastName?: Maybe<Scalars['String']['output']>;
  /** User email address (may be null in multi-step flows) */
  email?: Maybe<Scalars['String']['output']>;
  /** Auth0 user ID if existing user */
  existingAuth0UserId?: Maybe<Scalars['String']['output']>;
  /** Google Places API place ID */
  googlePlaceId: Scalars['String']['output'];
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** Whether this is a new user signup */
  newUser: Scalars['Boolean']['output'];
  /** Associated pricing package for this subscription */
  pricingPackage?: Maybe<PricingPackage>;
  /** Frontend origin URL for return navigation */
  returnOrigin: Scalars['String']['output'];
  /** Context of session creation */
  sessionContext: Scalars['String']['output'];
  /** Physical sign color preference */
  signColor?: Maybe<Scalars['String']['output']>;
  /** Physical sign material preference (optional if kit not purchased) */
  signMaterial?: Maybe<Scalars['String']['output']>;
  /** Associated signage order for sign production tracking */
  signageOrder?: Maybe<SignageOrder>;
  /** Session status */
  status: Scalars['String']['output'];
  /** Associated Stripe checkout session */
  stripeCheckoutSession?: Maybe<StripeCheckoutSession>;
  /** Last update timestamp */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** URL-friendly slug for microsite */
  urlSlug: Scalars['String']['output'];
};

/**
 * A curated substitution override — a human-picked substitute for a source item that ranks above the
 * rule engine's dynamic recommendations. Managed by Procurement.
 */
export type SubstitutionOverride = {
  __typename?: 'SubstitutionOverride';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Higher sorts first; ties break by creation order. */
  priority: Scalars['Int']['output'];
  /** Optional free-text note on why this override exists (e.g. audit-preserve). */
  reason?: Maybe<Scalars['String']['output']>;
  /**
   * Where this override came from. Read-only — set when the row is created and never rewritten, so a
   * bulk-imported pair stays distinguishable from a deliberate one.
   */
  source: SubstitutionOverrideSource;
  /** The substitute item this override points to. */
  substituteItem: SupplyItem;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** A validation error on a substitution override mutation. */
export type SubstitutionOverrideError = {
  __typename?: 'SubstitutionOverrideError';
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Result of an override mutation: the affected override (null on validation failure) plus any errors. */
export type SubstitutionOverridePayload = {
  __typename?: 'SubstitutionOverridePayload';
  errors: Array<SubstitutionOverrideError>;
  override?: Maybe<SubstitutionOverride>;
};

/**
 * Provenance of a substitution override. `LEGACY_HASH_IMPORT` pairs were carried over wholesale from
 * the retired hardcoded OOS substitution list and were never individually reviewed, so they may not
 * satisfy the dietary or refrigeration constraints the rule engine enforces on its own candidates.
 */
export enum SubstitutionOverrideSource {
  Human = 'HUMAN',
  LegacyHashImport = 'LEGACY_HASH_IMPORT'
}

export enum SuggestedActionEnum {
  /** Location at risk of churning */
  ChurnRisk = 'CHURN_RISK',
  /** Location with expansion opportunity */
  Expansion = 'EXPANSION',
  /** Location eligible for win-back */
  Winback = 'WINBACK'
}

export type SupplierInvoice = {
  __typename?: 'SupplierInvoice';
  externalSupplier?: Maybe<ExternalSupplier>;
  file?: Maybe<SupplierInvoiceFile>;
  id: Scalars['ID']['output'];
  invoiceDate?: Maybe<Scalars['ISO8601Date']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  odekoUuid: Scalars['ID']['output'];
  prospectiveLocation: ProspectiveLocation;
  status: Scalars['String']['output'];
  uploadedBy: Scalars['String']['output'];
  warehouseId: Scalars['ID']['output'];
};

export type SupplierInvoiceComparison = {
  __typename?: 'SupplierInvoiceComparison';
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  odekoUuid: Scalars['ID']['output'];
  prospectiveLocation: ProspectiveLocation;
  status: Scalars['String']['output'];
  supplierInvoiceComparisonInvoices: Array<SupplierInvoiceComparisonInvoice>;
  supplierInvoiceComparisonRows: SupplierInvoiceComparisonRowConnection;
  supplierInvoices: Array<SupplierInvoice>;
  warehouseId: Scalars['ID']['output'];
};


export type SupplierInvoiceComparisonSupplierInvoiceComparisonRowsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SupplierInvoiceComparisonInvoice = {
  __typename?: 'SupplierInvoiceComparisonInvoice';
  position?: Maybe<Scalars['Int']['output']>;
  supplierInvoice: SupplierInvoice;
};

export type SupplierInvoiceComparisonParsedRowInput = {
  clientRowId: Scalars['String']['input'];
  invoicePackItemSizeUnit?: InputMaybe<Scalars['String']['input']>;
  invoicePackItemSizeValue?: InputMaybe<Scalars['Decimal']['input']>;
  invoicePackSaleUnit?: InputMaybe<Scalars['String']['input']>;
  invoicePackUnitsPerSale?: InputMaybe<Scalars['Decimal']['input']>;
  invoiceQty: Scalars['Decimal']['input'];
  invoiceUnitPriceCents: Scalars['Int']['input'];
  rawName: Scalars['String']['input'];
  rawSku?: InputMaybe<Scalars['String']['input']>;
  supplierInvoiceId?: InputMaybe<Scalars['ID']['input']>;
  vendorName?: InputMaybe<Scalars['String']['input']>;
};

export type SupplierInvoiceComparisonRow = {
  __typename?: 'SupplierInvoiceComparisonRow';
  clientRowId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invoicePackItemSizeUnit?: Maybe<Scalars['String']['output']>;
  invoicePackItemSizeValue?: Maybe<Scalars['QuantityDecimal']['output']>;
  invoicePackSaleUnit: Scalars['String']['output'];
  invoicePackUnitsPerSale: Scalars['QuantityDecimal']['output'];
  invoiceQty: Scalars['QuantityDecimal']['output'];
  invoiceUnitPriceCents: Scalars['Int']['output'];
  odekoUuid: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  rawName: Scalars['String']['output'];
  rawSku: Scalars['String']['output'];
  supplierInvoice?: Maybe<SupplierInvoice>;
  vendorName: Scalars['String']['output'];
};

/** The connection type for SupplierInvoiceComparisonRow. */
export type SupplierInvoiceComparisonRowConnection = {
  __typename?: 'SupplierInvoiceComparisonRowConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SupplierInvoiceComparisonRowEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SupplierInvoiceComparisonRow>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SupplierInvoiceComparisonRowEdge = {
  __typename?: 'SupplierInvoiceComparisonRowEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SupplierInvoiceComparisonRow>;
};

export type SupplierInvoiceComparisonRowMapping = {
  __typename?: 'SupplierInvoiceComparisonRowMapping';
  clientRowId: Scalars['String']['output'];
  supplierInvoiceComparisonRow: SupplierInvoiceComparisonRow;
};

export type SupplierInvoiceFile = {
  __typename?: 'SupplierInvoiceFile';
  byteSize: Scalars['Int']['output'];
  contentType?: Maybe<Scalars['String']['output']>;
  filename: Scalars['String']['output'];
};

/** User's supply cart at a specific location */
export type SupplyCart = {
  __typename?: 'SupplyCart';
  cartItems: Array<SupplyCartItem>;
  /** Cart UUID */
  id: Scalars['ID']['output'];
  /** Number of distinct (itemUuid, deliveryDate) rows on the cart */
  itemCount: Scalars['Int']['output'];
  location: Location;
};

/** An item in a supply cart; identity is (itemUuid, deliveryDate, vendor) within parent SupplyCart */
export type SupplyCartItem = {
  __typename?: 'SupplyCartItem';
  createdAt: Scalars['ISO8601DateTime']['output'];
  deliveryDate: Scalars['ISO8601Date']['output'];
  /** Item identifier from IMS */
  itemUuid: Scalars['ID']['output'];
  /** Next available delivery date for this row's vendor. Null when the saved deliveryDate is today or later. */
  nextAvailableDeliveryDate?: Maybe<Scalars['ISO8601Date']['output']>;
  quantity: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Vendor that owns this cart row. Null for legacy rows written before vendor scoping. */
  vendor?: Maybe<Vendor>;
};

/** Platform that last modified the supply cart */
export enum SupplyCartPlatformEnum {
  /** Cart modified via Android mobile app */
  MobileAndroid = 'MOBILE_ANDROID',
  /** Cart modified via iOS mobile app */
  MobileIos = 'MOBILE_IOS',
  /** Cart modified via web portal */
  WebPortal = 'WEB_PORTAL'
}

/** Autogenerated input type of SupplyClearCart */
export type SupplyClearCartInput = {
  channel?: InputMaybe<SupplyCartPlatformEnum>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['ID']['input'];
};

/** Autogenerated return type of SupplyClearCart. */
export type SupplyClearCartPayload = {
  __typename?: 'SupplyClearCartPayload';
  cart?: Maybe<SupplyCart>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
};

/**
 * An interface is used to represent items to mandate what fields are needed for
 * items. Having a single object with all fields was rejected because that would
 * remove the ability to ensure a type of item has all of its required fields.
 */
export type SupplyItem = {
  brand?: Maybe<ItemBrand>;
  /** @deprecated Use brand */
  brandName: Scalars['String']['output'];
  /** (Package Height x Package Width x Package Length)/DIM factor */
  caseDimensionalWeightLbs?: Maybe<Scalars['Float']['output']>;
  caseHeightInches?: Maybe<Scalars['Float']['output']>;
  caseLengthInches?: Maybe<Scalars['Float']['output']>;
  caseVolumeCuInches?: Maybe<Scalars['Float']['output']>;
  caseWeightLbs?: Maybe<Scalars['Float']['output']>;
  caseWidthInches?: Maybe<Scalars['Float']['output']>;
  casesPerLayer?: Maybe<Scalars['Int']['output']>;
  casesPerPallet?: Maybe<Scalars['Int']['output']>;
  catalogStatus: CatalogStatus;
  category: Category;
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Drives pricing with carriers like FedEx.
   * This data is uploaded from Cubiscan dimensioning device to optimize shipping costs.
   */
  dimensionalFactor?: Maybe<Scalars['Float']['output']>;
  dimensioned?: Maybe<Scalars['Boolean']['output']>;
  /** (Package Height x Package Width x Package Length)/DIM factor */
  eachDimensionalWeightLbs?: Maybe<Scalars['Float']['output']>;
  eachHeightInches?: Maybe<Scalars['Float']['output']>;
  eachLengthInches?: Maybe<Scalars['Float']['output']>;
  eachVolumeCuInches?: Maybe<Scalars['Float']['output']>;
  eachWeightLbs?: Maybe<Scalars['Float']['output']>;
  eachWidthInches?: Maybe<Scalars['Float']['output']>;
  /** True if the item has its own image. When false and imgUrl is present, the image is a fallback from the category icon. */
  hasOwnImage: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  imgUrl?: Maybe<Scalars['String']['output']>;
  /** When the item was marked inactive; null when active. An inactive item is a deliberately retired SKU — hidden by default from customer-facing and admin catalog/search surfaces (and inactive in NetSuite). */
  inactivatedOn?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * True when a shipping location can't order this item: it is refrigerated or frozen, or its
   * category or subcategory is Pastry or Baked Goods.
   */
  isShippingRestricted: Scalars['Boolean']['output'];
  /** @deprecated Use size */
  itemSize?: Maybe<Scalars['String']['output']>;
  layersPerPallet?: Maybe<Scalars['Int']['output']>;
  /**
   * The most units, in the sale unit, that one location may order of this item across all its orders.
   * Null means no limit.
   */
  maxQuantityPerLocation?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  nmfc?: Maybe<Scalars['String']['output']>;
  palletWeightLbs?: Maybe<Scalars['Float']['output']>;
  /**
   * True when this item is currently a leading New Items pin — i.e. it won its slot in the resolved
   * result set. Reflects what shoppers see: an item filtered out of the result reads as not pinned.
   * Flag-gated; false when the new-item-pinning flag is off or the item isn't pinned.
   */
  pinned: Scalars['Boolean']['output'];
  /** The absolute carousel slot this item actually rendered at when pinned; null when not pinned. */
  pinnedPosition?: Maybe<Scalars['Int']['output']>;
  /**
   * Drives the storefront's "Sponsored" label. True for Algolia rule-promoted results and — behind the
   * new-item-pinning flag — for a sponsored New Items pin. A sponsored pin is distinguishable from an
   * Algolia promo by `pinned` (a sponsored pin is `promoted && pinned`).
   */
  promoted: Scalars['Boolean']['output'];
  purchasePrice: Money;
  refrigerationState?: Maybe<RefrigerationState>;
  saleUnit: Unit;
  /** The most of this item's sample one location may ever order. Null means no limit, or no sample. */
  sampleMaxQuantityPerLocation?: Maybe<Scalars['Int']['output']>;
  sampleUnit?: Maybe<Unit>;
  size?: Maybe<ItemSize>;
  /**
   * The product-level standing-order setting. Read `standingOrderBehavior` on the warehouse
   * association instead, at all times: this value is not market-scoped, so once any market is
   * given a setting of its own it stops answering for that market.
   */
  standingOrderBehavior: StandingOrderBehavior;
  subcategory?: Maybe<Category>;
  /**
   * The item's curated substitution overrides (source-side), highest priority first. Procurement's
   * editable layer that ranks above the rule engine's dynamic recommendations.
   */
  substitutionOverrides: Array<SubstitutionOverride>;
  /**
   * Procurement preview of ranked substitutes for this item. With no `warehouseId`, ranks by
   * attribute/dietary match quality only (availability ignored) — the "are these good substitutes?"
   * view. With a `warehouseId`, returns the in-stock list a customer in that market would actually get.
   * Curated overrides rank first. Procurement surface — the customer path uses `InventoryWarehouseAssociation.substitutionCandidates`.
   */
  substitutionPreview: Array<SupplyItem>;
  tags: Array<ItemTag>;
  transitMethod?: Maybe<TransitMethod>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  vendorCode?: Maybe<Scalars['String']['output']>;
};


/**
 * An interface is used to represent items to mandate what fields are needed for
 * items. Having a single object with all fields was rejected because that would
 * remove the ability to ensure a type of item has all of its required fields.
 */
export type SupplyItemSubstitutionPreviewArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * An interface is used to represent items to mandate what fields are needed for
 * items. Having a single object with all fields was rejected because that would
 * remove the ability to ensure a type of item has all of its required fields.
 */
export type SupplyItemTagsArgs = {
  withDiscardedAt?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An edge in a connection. */
export type SupplyItemEdge = {
  __typename?: 'SupplyItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SupplyItem>;
};

/** Autogenerated input type of SupplyRemoveCartItem */
export type SupplyRemoveCartItemInput = {
  channel?: InputMaybe<SupplyCartPlatformEnum>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deliveryDate: Scalars['ISO8601Date']['input'];
  itemUuid: Scalars['ID']['input'];
  locationId: Scalars['ID']['input'];
  /**
   * Scopes the delete to the vendor's row. When omitted, removes all rows matching
   * (itemUuid, deliveryDate) regardless of vendor.
   */
  vendorUuid?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of SupplyRemoveCartItem. */
export type SupplyRemoveCartItemPayload = {
  __typename?: 'SupplyRemoveCartItemPayload';
  cart?: Maybe<SupplyCart>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
};

/** Autogenerated input type of SupplyUpsertCartItem */
export type SupplyUpsertCartItemInput = {
  channel?: InputMaybe<SupplyCartPlatformEnum>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deliveryDate: Scalars['ISO8601Date']['input'];
  itemUuid: Scalars['ID']['input'];
  locationId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  /** Vendor that owns this cart row. When omitted, the server resolves the vendor from the location's SKU for this item. */
  vendorUuid?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of SupplyUpsertCartItem. */
export type SupplyUpsertCartItemPayload = {
  __typename?: 'SupplyUpsertCartItemPayload';
  cart?: Maybe<SupplyCart>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  /** Machine-readable reason when an ordering role refusal is why the item was not written */
  reason?: Maybe<Scalars['String']['output']>;
};

export enum SuppressionReasonEnum {
  /** Not-interested outreach within the last 30 days */
  NotInterested = 'NOT_INTERESTED',
  /** Reached or order_placed outreach within the last 7 days */
  RecentContact = 'RECENT_CONTACT',
  /** Order created within the last 3 days */
  RecentOrder = 'RECENT_ORDER'
}

export type Survey = {
  __typename?: 'Survey';
  completed: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  responses: Array<SurveyResponse>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum SurveyLevelEnum {
  /** Survey belongs to Company */
  Company = 'company',
  /** Survey belongs to Location */
  Location = 'location'
}

export type SurveyResponse = {
  __typename?: 'SurveyResponse';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  question: Scalars['String']['output'];
  response: Scalars['JSON']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type SurveyResponseInput = {
  /** Survey question */
  question?: InputMaybe<Scalars['String']['input']>;
  /** User answer */
  response: Scalars['JSON']['input'];
};

/** Autogenerated input type of SyncMicrositeConfigMutation */
export type SyncMicrositeConfigMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the GoogleDocsStream */
  streamId: Scalars['ID']['input'];
};

/** Autogenerated return type of SyncMicrositeConfigMutation. */
export type SyncMicrositeConfigMutationPayload = {
  __typename?: 'SyncMicrositeConfigMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Stream for the config document of the microsite location */
  configDocStream?: Maybe<Stream>;
};

export type TaskAlreadyResolved = UserErrorInterface & {
  __typename?: 'TaskAlreadyResolved';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type TaskNotFound = UserErrorInterface & {
  __typename?: 'TaskNotFound';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type TaskNoteRequired = UserErrorInterface & {
  __typename?: 'TaskNoteRequired';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** A Square Terminal checkout session */
export type TerminalCheckout = {
  __typename?: 'TerminalCheckout';
  /** Amount to collect */
  amountMoney: Scalars['JSON']['output'];
  /** Creation timestamp */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Terminal device ID */
  deviceId?: Maybe<Scalars['String']['output']>;
  /** Terminal checkout ID */
  id: Scalars['String']['output'];
  /** Location ID */
  locationId?: Maybe<Scalars['String']['output']>;
  /** Associated Square order ID */
  orderId?: Maybe<Scalars['String']['output']>;
  /** Checkout status (PENDING, IN_PROGRESS, COMPLETED, CANCELED) */
  status: Scalars['String']['output'];
};

/** Mark, unmark, dispatch or re-quote a route for a third-party provider, or escalate stops to one: possible error types */
export type ThirdPartyDispatchError = DispatchNotAllowed | DispatchProfileIncomplete | ProviderNotAvailable | ProviderRejected | RouteNotFound | RouteNotMarkable | StopsNotEscalatable | UnmarkNotAllowed;

/** An external delivery provider that can execute a route. */
export enum ThirdPartyProvider {
  /** Burq. Dispatched by API from the DMP, with status and proof flowing back. */
  Burq = 'burq',
  /** Metrobi. Handed over outside the DMP: the GM downloads the route CSV and uploads it, and completion is manual. */
  Metrobi = 'metrobi'
}

export type TimePeriod = {
  __typename?: 'TimePeriod';
  countRatings: CountRatings;
  countScans: Scalars['Int']['output'];
};

export type TimeseriesEntry = {
  __typename?: 'TimeseriesEntry';
  date: Scalars['ISO8601Date']['output'];
  rating?: Maybe<Scalars['Float']['output']>;
  ratingCount: Scalars['Int']['output'];
};

/** Error indicating that tip cannot be set because merchant has not enabled tips. */
export type TipsNotEnabled = Error & {
  __typename?: 'TipsNotEnabled';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

export type TrafficCongestionFee = FeeInterface & {
  __typename?: 'TrafficCongestionFee';
  /** The threshold amount in cents at which the fee is applied. */
  feeThresholds: Array<FeeThreshold>;
  id: Scalars['ID']['output'];
  /** Indicates if the fee is active or not. */
  isActive: Scalars['Boolean']['output'];
  odekoUuid: Scalars['ID']['output'];
  /** The amount of the traffic congestion fee in cents. */
  warehouseFeeAmountCents: Scalars['Int']['output'];
  /** Unique identifier of the warehouse associated with this traffic congestion fee. */
  warehouseId: Scalars['ID']['output'];
};

/**
 * A location's transaction-sync situation: which state it is in, how old that
 * state is, what the retained audit found, and what has been synced. Reading it
 * has no side effects — no NetSuite request and no republish work.
 */
export type TransactionSync = {
  __typename?: 'TransactionSync';
  /** Whether an audit can be started: true whenever nothing is in flight. */
  auditEnabled: Scalars['Boolean']['output'];
  /** Whether an audit is running right now. Blocks starting anything else. */
  auditInFlight: Scalars['Boolean']['output'];
  /**
   * This location's sync attempts, newest first, including one still in flight.
   * Bounded and unpaginated: manual syncs for a single location are rare, so this
   * is a short list by construction rather than a browsable history.
   */
  history: Array<TransactionSyncAttempt>;
  /**
   * The sync running right now, so a viewer arriving mid-sync re-attaches to it
   * rather than seeing nothing. Null when nothing is running.
   */
  inFlightSync?: Maybe<TransactionSyncAttempt>;
  /**
   * Whether the retained audit comparison found nothing to fix. False when there
   * is no retained comparison at all, so it is a claim about what was checked
   * rather than the absence of a complaint.
   */
  inSync: Scalars['Boolean']['output'];
  /** This location's audit row, carrying its retained comparison. Null when nothing has ever been audited here. */
  latestAudit?: Maybe<TransactionSyncAudit>;
  /**
   * Whether the event this state is about happened yesterday or earlier. A
   * calendar-day comparison in the location's own zone, not an elapsed-time one,
   * so an event at 11 PM yesterday is stale at 8 AM today — and so every viewer
   * gets the same answer regardless of where they are.
   */
  stale: Scalars['Boolean']['output'];
  state: TransactionSyncState;
  /** When the event this state is about happened. Null for a location with no history, and for a sync that has not finished. */
  stateAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * Whether a sync can be started. A sync refreshes what an audit flagged, so it
   * needs a comparison made today that found something to fix, and nothing else running.
   */
  syncEnabled: Scalars['Boolean']['output'];
  /**
   * The zone staleness was evaluated in. Displayed times belong in the viewer's
   * zone; this is the zone the stale flag was decided in.
   */
  timeZone: Scalars['String']['output'];
};


/**
 * A location's transaction-sync situation: which state it is in, how old that
 * state is, what the retained audit found, and what has been synced. Reading it
 * has no side effects — no NetSuite request and no republish work.
 */
export type TransactionSyncHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * One manual refresh of a location's NetSuite records. Describes the attempt
 * itself, not the location's current audit or sync situation.
 */
export type TransactionSyncAttempt = {
  __typename?: 'TransactionSyncAttempt';
  /** Identifies the republish work this sync asked for. The value to quote when escalating a sync that did not converge. */
  batchUuid: Scalars['ID']['output'];
  /** Null while the sync is in flight. */
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** How long the sync took. Null while it is in flight. */
  durationSeconds?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  /**
   * The location that was refreshed. Resolves even when this service holds no
   * local copy of it, so display fields still come from the subgraph that owns them.
   */
  location: Location;
  /** How far the sync has got. Still reported after it is over, as the record of what happened. */
  progress: TransactionSyncProgress;
  /** How many records the sync asked NetSuite to republish. */
  recordCount: Scalars['Int']['output'];
  /** The records the sync asked NetSuite to publish again, in the order they were requested. */
  records: Array<TransactionSyncRecord>;
  startedAt: Scalars['ISO8601DateTime']['output'];
  status: TransactionSyncStatus;
  /** The user who started the sync. Null when that user record is no longer present. */
  triggeredBy?: Maybe<ArAssignableUser>;
};

/**
 * A location's retained comparison against NetSuite, plus the state of the most
 * recent run. One per location: each successful run replaces the last.
 */
export type TransactionSyncAudit = {
  __typename?: 'TransactionSyncAudit';
  /** Why the most recent run could not be completed. Present alongside a retained comparison from an earlier successful run. */
  failureMessage?: Maybe<Scalars['String']['output']>;
  /** The records the retained comparison found wrong. Empty when there is no retained comparison. */
  flaggedRecords: Array<TransactionSyncFlaggedRecord>;
  id: Scalars['ID']['output'];
  /** Whether the retained comparison found nothing to fix. False when there is none. */
  inSync: Scalars['Boolean']['output'];
  /**
   * When the retained comparison was made. Null when there is no retained
   * comparison, which is what distinguishes "never successfully compared" from
   * "compared and found nothing wrong".
   */
  ranAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the most recent run was asked for. */
  requestedAt: Scalars['ISO8601DateTime']['output'];
  /** Where the most recent run got to. Describes the run, not the retained comparison. */
  status: TransactionSyncAuditStatus;
  /** Per-record-kind counts, one row per kind in a fixed order. Empty when there is no retained comparison. */
  summary: Array<TransactionSyncAuditSummaryRow>;
};

/** Where the most recent audit run got to. */
export enum TransactionSyncAuditStatus {
  /** Could not be completed. Any earlier comparison is still retained and still reported, so a failed read loses nothing. */
  Failed = 'FAILED',
  /** Asked for, not started yet. */
  Requested = 'REQUESTED',
  /** Comparing against NetSuite now. */
  Running = 'RUNNING',
  /** Finished; its comparison is the retained one. */
  Succeeded = 'SUCCEEDED'
}

/** One kind of record, counted on both sides. Every kind is always present, zeros included, so the table has a fixed shape. */
export type TransactionSyncAuditSummaryRow = {
  __typename?: 'TransactionSyncAuditSummaryRow';
  /** How many NetSuite holds. */
  inNetsuite: Scalars['Int']['output'];
  /** How many this service holds. */
  inPortal: Scalars['Int']['output'];
  /** The record kind's display name. */
  label: Scalars['String']['output'];
  /** How many NetSuite holds and this service does not. */
  missing: Scalars['Int']['output'];
  /** How many both hold but disagree about. */
  outOfDate: Scalars['Int']['output'];
  recordType: TransactionSyncRecordKind;
};

/** Why the audit flagged a record. */
export enum TransactionSyncFlagReason {
  /** NetSuite has the record and the portal holds no copy of it. */
  Missing = 'MISSING',
  /** Both hold the record and they disagree. */
  OutOfDate = 'OUT_OF_DATE'
}

/** One record the audit found wrong, described as the two sides see it. This is also the set a sync refreshes. */
export type TransactionSyncFlaggedRecord = {
  __typename?: 'TransactionSyncFlaggedRecord';
  /** Signed, NetSuite minus portal, and the whole NetSuite amount when this service holds no copy. */
  differenceCents: Scalars['Int']['output'];
  /**
   * The document number, when there is one. Journal entries carry none, and
   * neither does a record this service has never stored.
   */
  documentNumber?: Maybe<Scalars['String']['output']>;
  /** When this service last received an update for the record. Null when the reason is MISSING. */
  lastUpdateReceivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  netsuiteInternalId: Scalars['ID']['output'];
  /** What NetSuite shows for the record. */
  netsuiteShows: Scalars['String']['output'];
  /** What this service currently shows for the record. Null when the reason is MISSING: there is no portal side to describe. */
  portalShows?: Maybe<Scalars['String']['output']>;
  reason: TransactionSyncFlagReason;
  recordType: TransactionSyncRecordKind;
};

/**
 * How far a sync has got. Structured facts only, no prose: it is rewritten every
 * few seconds, so any sentence stored here would make a copy change a data migration.
 */
export type TransactionSyncProgress = {
  __typename?: 'TransactionSyncProgress';
  /** How many of the requested records have come back. */
  recordsReceived: Scalars['Int']['output'];
  /**
   * How many records the refresh was recorded against. The republish derives its
   * own set from a later comparison, so this and recordsReceived can legitimately
   * differ in their denominators; both are reported as stored.
   */
  recordsTotal: Scalars['Int']['output'];
  /** All four steps, in order. */
  steps: Array<TransactionSyncStep>;
};

/** One record a sync asked NetSuite to publish again. */
export type TransactionSyncRecord = {
  __typename?: 'TransactionSyncRecord';
  /** When refreshed data for this record came back. Null while it is still outstanding. */
  arrivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * The document number, when there is one. Journal entries carry none, and
   * neither does a record this service has never stored.
   */
  documentNumber?: Maybe<Scalars['String']['output']>;
  /** The signed difference the audit found for this record when the refresh was recorded. */
  expectedDifferenceCents: Scalars['Int']['output'];
  netsuiteInternalId: Scalars['ID']['output'];
  recordType: TransactionSyncRecordKind;
};

/** A kind of NetSuite transaction the audit compares. */
export enum TransactionSyncRecordKind {
  /** Credit memos. */
  CreditMemo = 'CREDIT_MEMO',
  /** Payments. */
  CustomerPayment = 'CUSTOMER_PAYMENT',
  /** Refunds. */
  CustomerRefund = 'CUSTOMER_REFUND',
  /** Invoices. */
  Invoice = 'INVOICE',
  /** Journal entries. */
  JournalEntry = 'JOURNAL_ENTRY'
}

/**
 * The one situation a location is currently in. A running audit is reported
 * alongside this rather than as a state of its own: it does not change what is
 * known, it only blocks starting anything else.
 */
export enum TransactionSyncState {
  /** The most recent event was an audit. Check inSync for what it found. */
  Audited = 'AUDITED',
  /** The most recent event was a sync that converged. */
  CompletedSync = 'COMPLETED_SYNC',
  /** The most recent event was a sync that was given up on. */
  FailedSync = 'FAILED_SYNC',
  /** Nothing has ever been audited or synced for this location. */
  NeverAuditedOrSynced = 'NEVER_AUDITED_OR_SYNCED',
  /** A sync is running right now. */
  SyncInFlight = 'SYNC_IN_FLIGHT'
}

export enum TransactionSyncStatus {
  /** The portal's records were verified to match NetSuite. */
  Converged = 'CONVERGED',
  /** The sync is still running; it has no outcome or duration yet. */
  InFlight = 'IN_FLIGHT',
  /** The sync did not converge within its time bound and was given up on. */
  TimedOut = 'TIMED_OUT'
}

/** One step of a sync, as last observed. */
export type TransactionSyncStep = {
  __typename?: 'TransactionSyncStep';
  /**
   * How many records NetSuite accepted for republishing. Null until the republish
   * has worked out what it is sending — absent, not zero.
   */
  accepted?: Maybe<Scalars['Int']['output']>;
  /**
   * When the step reached its current state, for states that happen at an instant.
   * Null for a step that has not started and for one still running.
   */
  at?: Maybe<Scalars['ISO8601DateTime']['output']>;
  key: TransactionSyncStepKey;
  /** How many records were submitted for republishing. Null on the same terms as accepted. */
  requested?: Maybe<Scalars['Int']['output']>;
  state: TransactionSyncStepState;
  /**
   * The bound this step was judged against, present only on a failed step. Stamped
   * at the time rather than read from the current setting, which is adjustable and
   * would otherwise misdescribe an older failure.
   */
  timeoutMinutes?: Maybe<Scalars['Int']['output']>;
};

/** One of the four fixed steps a sync passes through. All four are always reported. */
export enum TransactionSyncStepKey {
  /** Waiting for the refreshed records to arrive. */
  AwaitingData = 'AWAITING_DATA',
  /** NetSuite was asked to publish the records again. */
  Republishing = 'REPUBLISHING',
  /** The refresh was recorded. */
  Requested = 'REQUESTED',
  /** Re-comparing against NetSuite to confirm the records now match. */
  Verify = 'VERIFY'
}

/** How far one step has got. */
export enum TransactionSyncStepState {
  /** Happening now. */
  Active = 'ACTIVE',
  /** Finished. */
  Done = 'DONE',
  /** This is the step the sync was given up on. */
  Failed = 'FAILED',
  /** Not started. */
  Todo = 'TODO'
}

export type TransformProductImageInput = {
  /**
   * Optional custom prompt for image adjustment.
   * Examples: "Make the product packaging brighter", "Move the product right by 10px"
   * When provided, a router LLM classifies the instruction and routes to AI/sharp/both.
   * When omitted, default transform is applied (vision check + background removal + centering).
   */
  customPrompt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Image URL - can be:
   * 1. S3 URL from signedUploadImageByKey (after upload via signedUploadImageUrl)
   * 2. Existing S3 URL from item.imgUrl
   */
  imageUrl: Scalars['String']['input'];
};

export type TransformProductImageResult = {
  __typename?: 'TransformProductImageResult';
  /** When success=false: error description. When success=true: informational message (e.g. "Image already matches catalog standards"). */
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  /** S3 URL of the transformed image */
  transformedUrl?: Maybe<Scalars['String']['output']>;
};

/** Error indicating that a mutation failed due to a transient payment processor error. */
export type TransientPaymentProcessorError = Error & {
  __typename?: 'TransientPaymentProcessorError';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

export enum TransitMethod {
  Delivered = 'DELIVERED',
  PickUp = 'PICK_UP'
}

/** Autogenerated input type of TranslateDeliveryInstructionMutation */
export type TranslateDeliveryInstructionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ISO 639-1 language code; currently only es (Spanish) is supported */
  targetLanguage?: InputMaybe<Scalars['String']['input']>;
  /** The instruction's opaque translationId */
  translationId: Scalars['ID']['input'];
};

/** Autogenerated return type of TranslateDeliveryInstructionMutation. */
export type TranslateDeliveryInstructionMutationPayload = {
  __typename?: 'TranslateDeliveryInstructionMutationPayload';
  cached: Scalars['Boolean']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<DeliveryInstructionTranslationError>;
  translation?: Maybe<DeliveryInstructionTranslation>;
};

/** Autogenerated input type of TriggerHubspotRepSync */
export type TriggerHubspotRepSyncInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of TriggerHubspotRepSync. */
export type TriggerHubspotRepSyncPayload = {
  __typename?: 'TriggerHubspotRepSyncPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of TriggerManualRoutificRun */
export type TriggerManualRoutificRunInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Run mode: etas_only or re_sequence. */
  mode: ManualRoutificRunMode;
  /** Delivery date (night end). */
  nightEnd: Scalars['ISO8601Date']['input'];
  /** Warehouse id. */
  warehouseId: Scalars['ID']['input'];
};

/** Autogenerated return type of TriggerManualRoutificRun. */
export type TriggerManualRoutificRunPayload = {
  __typename?: 'TriggerManualRoutificRunPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  triggered: Scalars['Boolean']['output'];
  userErrors: Array<RouteError>;
};

/** Autogenerated input type of TriggerRoutesSync */
export type TriggerRoutesSyncInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Night end for route synchronization. */
  nightEnd: Scalars['ISO8601Date']['input'];
  /** Warehouse id. */
  warehouseId: Scalars['ID']['input'];
};

/** Autogenerated return type of TriggerRoutesSync. */
export type TriggerRoutesSyncPayload = {
  __typename?: 'TriggerRoutesSyncPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  triggered: Scalars['Boolean']['output'];
  userErrors: Array<RouteError>;
};

/** Autogenerated input type of TriggerRoutificScenarioRun */
export type TriggerRoutificScenarioRunInput = {
  /** Whether Routific routes around toll roads. */
  avoidTolls?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether Routific balances workload across vehicles. */
  balance?: InputMaybe<Scalars['Boolean']['input']>;
  /** Length in minutes of each placed break. Placement is unchanged; only the duration varies. */
  breakDurationMinutes?: InputMaybe<Scalars['Int']['input']>;
  /** How much of each truck's max capacity to route against, 1-100. 100 is the current configuration. */
  capacityPercent?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Per-cohort truck count overrides for the proposed run (cohort mode only). Omit to run at the plan's current truck counts. */
  cohorts?: InputMaybe<Array<RoutingCohortInput>>;
  /** Driver shift length in hours. Keeps the shift start and sets the end to start + this many hours. */
  driverShiftHours?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Whether this scenario run should also route stops already bucketed as
   * third_party (Metrobi). When true, the run previews routing them. When false or
   * omitted (the default), they stay bucketed, matching automated and manual runs.
   */
  includeThirdParty?: InputMaybe<Scalars['Boolean']['input']>;
  /** GM-supplied name for the scenario, shown when comparing runs. */
  label: Scalars['String']['input'];
  /**
   * Whether to cap each vehicle at 25 stops. On enforces the cap on every vehicle;
   * off lets Routific pack vehicles without a per-vehicle stop limit.
   */
  maxStopsPerVehicle?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether Routific minimizes the number of vehicles used. */
  minVehicles?: InputMaybe<Scalars['Boolean']['input']>;
  /** Routing import plan night end. */
  nightEnd: Scalars['ISO8601Date']['input'];
  /** Allowed overtime in minutes, sent to Routific as max_vehicle_overtime. 0 means none. */
  overtimeMinutes?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Routing rule overrides for the proposed run, keyed by rule id, e.g. {
   * "frozen_items_first": { "enabled": true, "hours": 1 } }. Layers over the
   * warehouse's rules_config, which layers over the rule's defaults. Omit to run
   * at the warehouse's configured rules.
   */
  rules?: InputMaybe<Scalars['JSON']['input']>;
  /**
   * Per-shift truck counts for the proposed run, overriding the warehouse's
   * persisted shift assignment. Omit to leave it at the persisted assignment.
   */
  shifts?: InputMaybe<Array<RoutingShiftAssignmentInput>>;
  /** Whether Routific optimizes for shortest distance rather than time. */
  shortestDistance?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether this scenario run should model 3PD (Metrobi) separation
   * non-destructively: when true, the run computes the 3PD-eligible stops,
   * excludes them from the native routes (which re-optimize without them), and
   * exposes them as a separate preview group. When false or omitted (the default),
   * the native routes are unchanged. Nothing is marked or bucketed.
   */
  thirdPartyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to route per-cohort (true, default) or cohort-agnostically against a single fleet size (false). */
  useCohorts?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * How many vehicles the run may use (how many drivers are staffed). Types are
   * chosen from the fleet composition, smallest that fit demand. When useCohorts
   * is false this is the fleet size and must be positive; it may be omitted there
   * only while the deprecated totalFleetSize fallback is supplied. In cohort mode,
   * omit to let routing decide over the full fleet.
   */
  vehicleCount?: InputMaybe<Scalars['Int']['input']>;
  /** Routific visit-balance coefficient (>= 0). 0 disables balancing by coefficient. */
  visitBalanceCoefficient?: InputMaybe<Scalars['Float']['input']>;
  /** Warehouse id. */
  warehouseId: Scalars['ID']['input'];
};

/** Autogenerated return type of TriggerRoutificScenarioRun. */
export type TriggerRoutificScenarioRunPayload = {
  __typename?: 'TriggerRoutificScenarioRunPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  triggered: Scalars['Boolean']['output'];
  userErrors: Array<RoutingImportPlanError>;
};

export type Truck = {
  __typename?: 'Truck';
  id: Scalars['ID']['output'];
  /** Maximum volume in in³ */
  maxVolume: Scalars['Int']['output'];
  /** Maximum weight in lbs */
  maxWeight: Scalars['Int']['output'];
  /** Vehicle tag assigned by the warehouse */
  vehicleTag?: Maybe<Scalars['String']['output']>;
  /** Vehicle type */
  vehicleType?: Maybe<Scalars['String']['output']>;
  /** Vehicle identification number */
  vin?: Maybe<Scalars['String']['output']>;
};

export type TruckCountInvalid = UserErrorInterface & {
  __typename?: 'TruckCountInvalid';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of TurnOffLocationSupplyMutation */
export type TurnOffLocationSupplyMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Location UUID to turn supply off for */
  locationId: Scalars['ID']['input'];
};

/** Autogenerated return type of TurnOffLocationSupplyMutation. */
export type TurnOffLocationSupplyMutationPayload = {
  __typename?: 'TurnOffLocationSupplyMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  location?: Maybe<Location>;
};

/** Autogenerated input type of UnapproveCutoffDiscrepancy */
export type UnapproveCutoffDiscrepancyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationsVendorId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnapproveCutoffDiscrepancy. */
export type UnapproveCutoffDiscrepancyPayload = {
  __typename?: 'UnapproveCutoffDiscrepancyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  cutoffDiscrepancyApproval?: Maybe<CutoffDiscrepancyApproval>;
  errors: Array<UserError>;
};

/** Error indicating that the user is not authorized to perform the action. */
export type UnauthorizedError = Error & {
  __typename?: 'UnauthorizedError';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

export type UnavailableItemsInterval = AvailabilityInterval & {
  __typename?: 'UnavailableItemsInterval';
  /** Lower bound. */
  lowerBound: Scalars['ISO8601DateTime']['output'];
  /** Unavailable menu items. */
  unavailableMenuItems: Array<MenuItem>;
  /** Upper bound. */
  upperBound: Scalars['ISO8601DateTime']['output'];
};

export type UncountedLineTrackedOrders = UserErrorInterface & {
  __typename?: 'UncountedLineTrackedOrders';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  orderIds: Array<Scalars['ID']['output']>;
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
  stopIds: Array<Scalars['ID']['output']>;
};

/** Autogenerated input type of UndoReplenishmentPick */
export type UndoReplenishmentPickInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Id of the command returned by recordReplenishmentPick. */
  commandId: Scalars['ID']['input'];
  idempotencyKey: Scalars['ID']['input'];
};

/** Autogenerated return type of UndoReplenishmentPick. */
export type UndoReplenishmentPickPayload = {
  __typename?: 'UndoReplenishmentPickPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  command?: Maybe<WarehouseBinTransferCommand>;
  userErrors: Array<UserError>;
};

export type Unit = {
  __typename?: 'Unit';
  /** Short display label for compact contexts (e.g., oz, lb, g) */
  abbreviation?: Maybe<Scalars['String']['output']>;
  baseUnit?: Maybe<Unit>;
  /**
   * Answers the question: how many/much of the base unit is in this unit?
   * Conversion rate for base units should be 1
   * Example: 1 gallon = 8 pints, so a pint could be represented as
   * having a conversion rate of .125 gallons
   */
  conversionRate: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  unitType: UnitType;
};

export enum UnitSortOrder {
  ConversionRateAsc = 'CONVERSION_RATE_ASC',
  ConversionRateDesc = 'CONVERSION_RATE_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

export enum UnitType {
  Case = 'CASE',
  Mass = 'MASS',
  Pounds = 'POUNDS',
  Volume = 'VOLUME'
}

export type UnmarkNotAllowed = UserErrorInterface & {
  __typename?: 'UnmarkNotAllowed';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of UnmarkRouteProvider */
export type UnmarkRouteProviderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The route to unmark. */
  routeId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnmarkRouteProvider. */
export type UnmarkRouteProviderPayload = {
  __typename?: 'UnmarkRouteProviderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  route?: Maybe<Route>;
  userErrors: Array<ThirdPartyDispatchError>;
};

/** An item mentioned in transcript but not found in menu */
export type UnmatchedItem = {
  __typename?: 'UnmatchedItem';
  /** Number of items requested */
  quantity: Scalars['Int']['output'];
  /** Full phrase as customer said it */
  raw: Scalars['String']['output'];
  /** Closest menu item name if match exists */
  suggestedItemName?: Maybe<Scalars['String']['output']>;
  /** Price in cents for the suggested variation */
  suggestedPriceCents?: Maybe<Scalars['Int']['output']>;
  /** Square variation ID for the suggestion (looked up from catalog) */
  suggestedVariationId?: Maybe<Scalars['String']['output']>;
  /** Variation for the suggestion */
  suggestedVariationName?: Maybe<Scalars['String']['output']>;
};

export type UnresolvedTasks = UserErrorInterface & {
  __typename?: 'UnresolvedTasks';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of UnsubscribeFromBackInStockNotificationMutation */
export type UnsubscribeFromBackInStockNotificationMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Item UUID */
  itemId: Scalars['ID']['input'];
  /** Location UUID */
  locationId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnsubscribeFromBackInStockNotificationMutation. */
export type UnsubscribeFromBackInStockNotificationMutationPayload = {
  __typename?: 'UnsubscribeFromBackInStockNotificationMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<UserError>>;
  subscriptionExisted?: Maybe<Scalars['Boolean']['output']>;
  succeeded: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateArrivedAtStopTime */
export type UpdateArrivedAtStopTimeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Client-provided time the driver arrived (e.g. a geofence crossing). Defaults to server time when omitted. */
  occurredAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Indicates if the stop is a redelivery stop */
  redelivery?: InputMaybe<Scalars['Boolean']['input']>;
  /** Delivery stop id. */
  stopId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateArrivedAtStopTime. */
export type UpdateArrivedAtStopTimePayload = {
  __typename?: 'UpdateArrivedAtStopTimePayload';
  /** The time the driver arrived at the stop */
  arrivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userErrors: Array<DeliveryRouteStopError>;
};

/** Autogenerated input type of UpdateBrandedItemDealMutation */
export type UpdateBrandedItemDealMutationInput = {
  /** Branded item deal id */
  brandedItemDealId: Scalars['ID']['input'];
  /** Status of the branded item deal */
  brandedItemDealStatus: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateBrandedItemDealMutation. */
export type UpdateBrandedItemDealMutationPayload = {
  __typename?: 'UpdateBrandedItemDealMutationPayload';
  brandedItemDeal?: Maybe<BrandedItemDeal>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
};

/** Input for updating an existing cart item. */
export type UpdateCartItemInput = {
  /** ID of the CartItem to update. */
  cartItemId: Scalars['ID']['input'];
  /** ID of desired MenuItemSize. */
  menuItemSizeId: Scalars['ID']['input'];
  /**
   * Desired modifiers. This should include any previously added modifiers you wish
   * to keep as well as any modifiers you wish to add. Previously added modifiers
   * that don't appear in this list will be removed.
   */
  modifiers: Array<CartItemModifierInput>;
  /** Note. If omitted, any previously set note will be cleared. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Desired quantity. */
  quantity: Scalars['Int']['input'];
  /** Expected unit price of MenuItemSize. Item will only be updated if the desired size's price matches the expected price. */
  unitPrice: MoneyInput;
};

/** Data that was provided as mutation input. */
export type UpdateCartItemInputEcho = {
  __typename?: 'UpdateCartItemInputEcho';
  /** ID of the CartItem to update. */
  cartItemId: Scalars['ID']['output'];
  /** ID of desired MenuItemSize. */
  menuItemSizeId: Scalars['ID']['output'];
  /**
   * Desired modifiers. This should include any previously added modifiers you wish
   * to keep as well as any modifiers you wish to add. Previously added modifiers
   * that don't appear in this list will be removed.
   */
  modifiers: Array<CartItemModifierInputEcho>;
  /** Desired quantity. */
  quantity: Scalars['Int']['output'];
  /** Expected unit price of MenuItemSize. Item will only be updated if the desired size's price matches the expected price. */
  unitPrice: Money;
};

/** Autogenerated input type of UpdateCartItems */
export type UpdateCartItemsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Opaque token identifying a specific version of the cart. */
  fingerprint: Scalars['String']['input'];
  /**
   * List of desired updates. This list only needs to include updates for the items
   * it wants to modify. Any cart items not represented in the listed updates will
   * remain unchanged.
   */
  updates: Array<UpdateCartItemInput>;
};

/** Autogenerated return type of UpdateCartItems */
export type UpdateCartItemsPayload = {
  __typename?: 'UpdateCartItemsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to update cart items. */
  result: CartResult;
};

/** Autogenerated input type of UpdateConfig */
export type UpdateConfigInput = {
  /** App config attributes */
  attributes: ConfigAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Current config's edition (update is rejected if this is out of date) */
  currentEdition?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of UpdateConfig */
export type UpdateConfigPayload = {
  __typename?: 'UpdateConfigPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the "result" field instead. */
  configResult: ConfigResult;
  /** Updated config's edition */
  currentEdition?: Maybe<Scalars['Int']['output']>;
  /** Result of attempting to update the config */
  result: ConfigResult;
};

/** Autogenerated input type of UpdateCurrentConsumerAppUser */
export type UpdateCurrentConsumerAppUserInput = {
  /** Accepts promotional emails. May be omitted, but if specified, cannot be null. */
  acceptsPromotionalEmails?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Email. May be omitted, but if specified, cannot be null. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Merchant can contact. May be omitted, but if specified, cannot be null. */
  merchantCanContact?: InputMaybe<Scalars['Boolean']['input']>;
  /** Username. May be omitted, but if specified, cannot be null. */
  username?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateCurrentConsumerAppUser */
export type UpdateCurrentConsumerAppUserPayload = {
  __typename?: 'UpdateCurrentConsumerAppUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to update the consumer app user. */
  result: ConsumerAppUserResult;
};

/** Autogenerated input type of UpdateCurrentConsumerAppUserPhoneNumber */
export type UpdateCurrentConsumerAppUserPhoneNumberInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Phone number in E.164 format, but without the "+" prefix. E.g. "15551231234". */
  phoneNumber: Scalars['String']['input'];
  /** ID received when verifying phone number. */
  phoneVerificationId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateCurrentConsumerAppUserPhoneNumber */
export type UpdateCurrentConsumerAppUserPhoneNumberPayload = {
  __typename?: 'UpdateCurrentConsumerAppUserPhoneNumberPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to update the consumer app user's phone number. */
  result: ConsumerAppUserResult;
};

/** Autogenerated input type of UpdateCustomIngredientMutation */
export type UpdateCustomIngredientMutationInput = {
  /** Brand name of the ingredient */
  brand?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the custom ingredient */
  id: Scalars['ID']['input'];
  /** Name of the ingredient */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Price purchased at */
  purchasePrice?: InputMaybe<MoneyInput>;
  /** Unit purchased at */
  purchaseUnit?: InputMaybe<Scalars['ID']['input']>;
  /** Purchased from */
  purchaseVendor?: InputMaybe<Scalars['String']['input']>;
  /** Quantity portion of item size */
  sizeQuantity?: InputMaybe<Scalars['Float']['input']>;
  /** Unit portion of item size */
  sizeUnit?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateCustomIngredientMutation. */
export type UpdateCustomIngredientMutationPayload = {
  __typename?: 'UpdateCustomIngredientMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  customIngredient?: Maybe<CustomIngredient>;
  errors: Array<UserError>;
};

/** Autogenerated input type of UpdateCustomerTagMutation */
export type UpdateCustomerTagMutationInput = {
  /** Replacement kind of audience the tag describes: when a location takes delivery, where it is, or what it sells. */
  category?: InputMaybe<CustomerTagCategoryEnum>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Id of the tag to update, as returned by CustomerTag.id. */
  id: Scalars['ID']['input'];
  /** Replacement display name. The tag's slug is fixed at creation and is not affected. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateCustomerTagMutation. */
export type UpdateCustomerTagMutationPayload = {
  __typename?: 'UpdateCustomerTagMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  customerTag?: Maybe<CustomerTag>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateDepartedAtStopTime */
export type UpdateDepartedAtStopTimeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Client-provided time the driver departed (e.g. a geofence crossing). Defaults to server time when omitted. */
  occurredAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Indicates if the stop is a redelivery stop */
  redelivery?: InputMaybe<Scalars['Boolean']['input']>;
  /** Delivery stop id. */
  stopId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateDepartedAtStopTime. */
export type UpdateDepartedAtStopTimePayload = {
  __typename?: 'UpdateDepartedAtStopTimePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The time the driver departed from the stop */
  departedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  userErrors: Array<DeliveryRouteStopError>;
};

/** Autogenerated input type of UpdateExternalBaseBrandedItemMutation */
export type UpdateExternalBaseBrandedItemMutationInput = {
  /** Base item attributes */
  baseBrandedItem: BaseBrandedItemInput;
  /** Base branded item to update */
  baseBrandedItemId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deliveryPrice: MoneyInput;
  /** External item's procurement vendor */
  procurementVendor: Scalars['ID']['input'];
  /** Variants of the item that are offered */
  variants: Array<ExternalBaseBrandedItemVariantInput>;
};

/** Autogenerated return type of UpdateExternalBaseBrandedItemMutation. */
export type UpdateExternalBaseBrandedItemMutationPayload = {
  __typename?: 'UpdateExternalBaseBrandedItemMutationPayload';
  baseBrandedItem?: Maybe<BaseBrandedItem>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
};

/** Autogenerated input type of UpdateGeneratedOrderQuantitiesMutation */
export type UpdateGeneratedOrderQuantitiesMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** PROTOTYPE an array of the reified order information. */
  generatedOrderQuantitiesInput: Array<UpdateGeneratedOrderQuantityInput>;
};

/** Autogenerated return type of UpdateGeneratedOrderQuantitiesMutation. */
export type UpdateGeneratedOrderQuantitiesMutationPayload = {
  __typename?: 'UpdateGeneratedOrderQuantitiesMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  /** PROTOTYPE the GeneratedOrderQuantities updated. */
  generatedOrderQuantities: Array<GeneratedOrderQuantity>;
};

export type UpdateGeneratedOrderQuantityInput = {
  /** PROTOTYPE The inventory-service-2 id of the GeneratedOrderQuantity. */
  id: Scalars['ID']['input'];
  /** PROTOTYPE The Odeko UUID of the reified order. */
  orderId?: InputMaybe<Scalars['ID']['input']>;
  /** PROTOTYPE The Odeko UUID of the reified order line. */
  orderLineId?: InputMaybe<Scalars['ID']['input']>;
  /** PROTOTYPE The quantity of the reified order line. */
  orderedQuantity?: InputMaybe<Scalars['Float']['input']>;
};

/** Autogenerated input type of UpdateGuestUsernameMutation */
export type UpdateGuestUsernameMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the guest profile to update */
  guestProfileId: Scalars['ID']['input'];
  /** New username for the player */
  newUsername: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateGuestUsernameMutation. */
export type UpdateGuestUsernameMutationPayload = {
  __typename?: 'UpdateGuestUsernameMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']['output']>;
  /** The updated guest profile */
  guestProfile?: Maybe<GuestProfile>;
};

export type UpdateHomepageDisplayRulesInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  ruleIds: Array<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  warehouseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateHomepageDisplayRulesPayload = {
  __typename?: 'UpdateHomepageDisplayRulesPayload';
  errors: Array<HomepageDisplayRuleError>;
  updatedRuleIds: Array<Scalars['ID']['output']>;
};

/** Autogenerated input type of UpdateInHouseBaseBrandedItemMutation */
export type UpdateInHouseBaseBrandedItemMutationInput = {
  /** Base item attributes */
  baseBrandedItem: BaseBrandedItemInput;
  /** Base branded item to update */
  baseBrandedItemId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** In-house item's associated supply item */
  supplyItem: Scalars['ID']['input'];
  /** Variants of the item that are offered */
  variants: Array<InHouseBaseBrandedItemVariantInput>;
};

/** Autogenerated return type of UpdateInHouseBaseBrandedItemMutation. */
export type UpdateInHouseBaseBrandedItemMutationPayload = {
  __typename?: 'UpdateInHouseBaseBrandedItemMutationPayload';
  baseBrandedItem?: Maybe<BaseBrandedItem>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
};

/** Autogenerated input type of UpdateInProgressCustomerMutation */
export type UpdateInProgressCustomerMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID (uuid) for the InProgressCustomer */
  id: Scalars['ID']['input'];
  /** Input of the values to be updated. */
  inProgressCustomerInput: InProgressCustomerInput;
};

/** Autogenerated return type of UpdateInProgressCustomerMutation. */
export type UpdateInProgressCustomerMutationPayload = {
  __typename?: 'UpdateInProgressCustomerMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  inProgressCustomer?: Maybe<InProgressCustomer>;
};

export type UpdateItemPalletConfigurationError = {
  __typename?: 'UpdateItemPalletConfigurationError';
  /** The offending argument, when a single one can be blamed. */
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/**
 * Validation failures arrive in `errors` rather than as a thrown error, so the associate sees the actual
 * reason instead of the gateway's redacted message. `item` is null whenever `errors` is non-empty.
 */
export type UpdateItemPalletConfigurationPayload = {
  __typename?: 'UpdateItemPalletConfigurationPayload';
  errors: Array<UpdateItemPalletConfigurationError>;
  item?: Maybe<SupplyItem>;
};

/** Attributes for creating or updating landed-cost and sale-price */
export type UpdateItemPriceInput = {
  /** Item UUID */
  itemOdekoUuid: Scalars['String']['input'];
  newLandedCost?: InputMaybe<MoneyInput>;
  newSalePrice?: InputMaybe<MoneyInput>;
  previousLandedCost?: InputMaybe<MoneyInput>;
  previousSalePrice?: InputMaybe<MoneyInput>;
  /** Warehouse UUID */
  warehouseOdekoUuid: Scalars['String']['input'];
};

/** Autogenerated input type of UpdateItemPrices */
export type UpdateItemPricesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customPrices?: InputMaybe<Array<UpdateLocationPriceInput>>;
  prices: Array<UpdateItemPriceInput>;
};

/** Autogenerated return type of UpdateItemPrices. */
export type UpdateItemPricesPayload = {
  __typename?: 'UpdateItemPricesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  result?: Maybe<ItemPricesResult>;
};

/** Autogenerated input type of UpdateLocationOpeningHoursFromGoogle */
export type UpdateLocationOpeningHoursFromGoogleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Location UUID to update */
  locationUuid: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateLocationOpeningHoursFromGoogle. */
export type UpdateLocationOpeningHoursFromGooglePayload = {
  __typename?: 'UpdateLocationOpeningHoursFromGooglePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  openingHours?: Maybe<Array<OpeningHour>>;
};

/** Autogenerated input type of UpdateLocationOpeningHoursMutation */
export type UpdateLocationOpeningHoursMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Store hours have been confirmed by the user within the user interface */
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of days with opening and closing times */
  days: Array<OpeningHoursDayInput>;
  /** Location UUID to update */
  locationId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateLocationOpeningHoursMutation. */
export type UpdateLocationOpeningHoursMutationPayload = {
  __typename?: 'UpdateLocationOpeningHoursMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  openingHours?: Maybe<Array<OpeningHour>>;
  storeHoursConfirmed?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of UpdateLocationPlatformProfileMutation */
export type UpdateLocationPlatformProfileMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  destroy?: InputMaybe<Scalars['Boolean']['input']>;
  locationUuid: Scalars['String']['input'];
  platformId: PlatformIds;
  profileId: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateLocationPlatformProfileMutation. */
export type UpdateLocationPlatformProfileMutationPayload = {
  __typename?: 'UpdateLocationPlatformProfileMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  profile: Profile;
};

/** Attributes for creating or updating custom-price */
export type UpdateLocationPriceInput = {
  /** Item UUID */
  itemOdekoUuid: Scalars['String']['input'];
  /** Location UUID */
  locationOdekoUuid: Scalars['String']['input'];
  newCustomPrice?: InputMaybe<MoneyInput>;
  previousCustomPrice?: InputMaybe<MoneyInput>;
};

/** Autogenerated input type of UpdateLocationsDeliverWithinStoreHoursMutation */
export type UpdateLocationsDeliverWithinStoreHoursMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Boolean value to set for deliver_within_store_hours on all specified locations */
  deliverWithinStoreHours: Scalars['Boolean']['input'];
  /** Array of location UUIDs to update */
  locationIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateLocationsDeliverWithinStoreHoursMutation. */
export type UpdateLocationsDeliverWithinStoreHoursMutationPayload = {
  __typename?: 'UpdateLocationsDeliverWithinStoreHoursMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  updatedLocations: Array<Location>;
};

/** Autogenerated input type of UpdateLocationsRoutingCohortMutation */
export type UpdateLocationsRoutingCohortMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of routing cohort associated with the warehouse */
  cohortId: Scalars['ID']['input'];
  /** List of locations ids. */
  locationIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateLocationsRoutingCohortMutation. */
export type UpdateLocationsRoutingCohortMutationPayload = {
  __typename?: 'UpdateLocationsRoutingCohortMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateMarketingQrCodeMutation */
export type UpdateMarketingQrCodeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID (UUID) of the QR code to update */
  id: Scalars['ID']['input'];
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateMarketingQrCodeMutation. */
export type UpdateMarketingQrCodeMutationPayload = {
  __typename?: 'UpdateMarketingQrCodeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  qrCode: MarketingQrCode;
};

/** Autogenerated input type of UpdateMarketingQrCodesFromCsvMutation */
export type UpdateMarketingQrCodesFromCsvMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** CSV contents */
  csvContents: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateMarketingQrCodesFromCsvMutation. */
export type UpdateMarketingQrCodesFromCsvMutationPayload = {
  __typename?: 'UpdateMarketingQrCodesFromCsvMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  results: Array<MarketingQrCodeBulkUpdateResult>;
};

/** Autogenerated input type of UpdateMenuItemSavedVisibility */
export type UpdateMenuItemSavedVisibilityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * MenuItem's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int']['input'];
  /** MenuItem ID. */
  menuItemId: Scalars['ID']['input'];
  /**
   * Visibility value to save. This sets the menu-item's "visibility.savedValue",
   * whichi will determine its "visibility.effectiveValue" as well iff it belongs
   * to a visible submenu that belongs to a visible menu. If either the submenu or
   * its parent menu are hidden, the menu-item is effectively hidden regardless of
   * its saved visibility value.
   */
  value: VisibilityEnum;
};

/** Autogenerated return type of UpdateMenuItemSavedVisibility */
export type UpdateMenuItemSavedVisibilityPayload = {
  __typename?: 'UpdateMenuItemSavedVisibilityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to update the menu-item's saved visibility value. */
  result: MenuItemResult;
};

/** Input for updating the sort order of a menu-item. */
export type UpdateMenuItemSortOrderInput = {
  /**
   * MenuItem's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int']['input'];
  /** MenuItem ID */
  menuItemId: Scalars['ID']['input'];
};

/** Autogenerated input type of UpdateMenuItemsSortOrder */
export type UpdateMenuItemsSortOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * List describing the desired sort order of submenu's menu-items. This list must
   * be exhaustive, i.e. it should contain an element for each menu-item the
   * submenu has. The operation will be rejected if given a non-exhaustive list or
   * a list that contains duplicates. It will also be rejected if any of the list
   * elements identify menu-items that don't belong to the right submenu.
   */
  elements: Array<UpdateMenuItemSortOrderInput>;
  /** The ID of the submenu whose menu-items are being sorted. */
  submenuId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateMenuItemsSortOrder */
export type UpdateMenuItemsSortOrderPayload = {
  __typename?: 'UpdateMenuItemsSortOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to update the menu-items' sort order. */
  result: MenuItemsResult;
};

/** Autogenerated input type of UpdateMenuSavedVisibility */
export type UpdateMenuSavedVisibilityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Menu's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int']['input'];
  /** Menu ID. */
  menuId: Scalars['ID']['input'];
  /**
   * Visibility value to save. This sets the menu's "visibility.savedValue" and has
   * a cascading effect on the "visibility.effectiveValue" of its submenus and
   * their menu-items. I.e. hiding a menu also changes the effective visibility of
   * its submenus and their menu-items, hiding them from consumers regardless of
   * what the individual "visibility.savedValue" fields hold. Their individual
   * saved values are retained, and will become relevant in determining their
   * effective visibility if the menu is later unhidden.
   */
  value: VisibilityEnum;
};

/** Autogenerated return type of UpdateMenuSavedVisibility */
export type UpdateMenuSavedVisibilityPayload = {
  __typename?: 'UpdateMenuSavedVisibilityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to update the menu's saved visibility value. */
  result: MenuResult;
};

/** Input for updating the sort order of a menu. */
export type UpdateMenuSortOrderInput = {
  /**
   * Menu's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int']['input'];
  /** Menu ID */
  menuId: Scalars['ID']['input'];
};

/** Autogenerated input type of UpdateMenusSortOrder */
export type UpdateMenusSortOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * List describing the desired sort order of merchant's menus. This list must be
   * exhaustive, i.e. it should contain an element for each menu the merchant has.
   * The operation will be rejected if given a non-exhaustive list or a list that
   * contains duplicates. It will also be rejected if any of the list elements
   * identify menus that don't belong to the right merchant.
   */
  elements: Array<UpdateMenuSortOrderInput>;
  /** The ID of the merchant whose menus are being sorted. */
  merchantId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateMenusSortOrder */
export type UpdateMenusSortOrderPayload = {
  __typename?: 'UpdateMenusSortOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to update the menus' sort order. */
  result: MenusResult;
};

/** Autogenerated input type of UpdateMerchantCurbsidePickup */
export type UpdateMerchantCurbsidePickupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether curbside pickup is offered. */
  curbsidePickup: Scalars['Boolean']['input'];
  /**
   * Merchant's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int']['input'];
  /** The ID of the merchant to update. */
  merchantId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateMerchantCurbsidePickup */
export type UpdateMerchantCurbsidePickupPayload = {
  __typename?: 'UpdateMerchantCurbsidePickupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to update curbsidePickup. */
  result: MerchantResult;
};

/** Autogenerated input type of UpdateMerchantNotificationSound */
export type UpdateMerchantNotificationSoundInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Merchant's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int']['input'];
  /** The ID of the merchant to update. */
  merchantId: Scalars['ID']['input'];
  /** Audio filename to play on notifications for this merchant */
  notificationSound: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateMerchantNotificationSound */
export type UpdateMerchantNotificationSoundPayload = {
  __typename?: 'UpdateMerchantNotificationSoundPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to update notification sound. */
  result: MerchantResult;
};

/** Autogenerated input type of UpdateMerchantPickupText */
export type UpdateMerchantPickupTextInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Merchant's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int']['input'];
  /** The ID of the merchant to update. */
  merchantId: Scalars['ID']['input'];
  /** Pickup text. */
  pickupText?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateMerchantPickupText */
export type UpdateMerchantPickupTextPayload = {
  __typename?: 'UpdateMerchantPickupTextPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to update pickup text. */
  result: MerchantResult;
};

/** Autogenerated input type of UpdateMerchantStatus */
export type UpdateMerchantStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Merchant's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int']['input'];
  /** The ID of the merchant to update. */
  merchantId: Scalars['ID']['input'];
  /** Status to set. */
  status: MerchantStatusEnum;
};

/** Autogenerated return type of UpdateMerchantStatus */
export type UpdateMerchantStatusPayload = {
  __typename?: 'UpdateMerchantStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to update the merchant status. */
  result: MerchantResult;
};

/** Autogenerated input type of UpdateMicrositeAdInfo */
export type UpdateMicrositeAdInfoInput = {
  adInfo: MicrositeAdInfoInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  micrositeLocationId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateMicrositeAdInfo. */
export type UpdateMicrositeAdInfoPayload = {
  __typename?: 'UpdateMicrositeAdInfoPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  micrositeLocation?: Maybe<MicrositeLocation>;
};

/** Autogenerated input type of UpdateMicrositeModulesOrder */
export type UpdateMicrositeModulesOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the microsite location. */
  micrositeLocationId: Scalars['ID']['input'];
  /**
   * The ordered list of module types to apply to the microsite location. The order
   * of this list will determine the display order of the modules.
   */
  moduleTypesInOrder: Array<MicrositeModule>;
};

/** Autogenerated return type of UpdateMicrositeModulesOrder. */
export type UpdateMicrositeModulesOrderPayload = {
  __typename?: 'UpdateMicrositeModulesOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  micrositeLocation: MicrositeLocation;
};

/** Autogenerated input type of UpdateMicrositeMutation */
export type UpdateMicrositeMutationInput = {
  actions?: InputMaybe<MicrositeActionsInput>;
  /** Business profile details for the microsite */
  businessProfile?: InputMaybe<MicrositeBusinessProfileInput>;
  calendarEvents?: InputMaybe<MicrositeCalendarEventsInput>;
  checkIn?: InputMaybe<MicrositeCheckInInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coffeeGrind?: InputMaybe<MicrositeCoffeeGrindInput>;
  /** Contact details for the microsite */
  contact?: InputMaybe<MicrositeContactInput>;
  cuppy?: InputMaybe<MicrositeCuppyInput>;
  /** Google Places API place ID to link this microsite to a Google location */
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the microsite location to update */
  id: Scalars['ID']['input'];
  mailingList?: InputMaybe<MicrositeMailingListInput>;
  /** Media module configuration for the microsite */
  media?: InputMaybe<MicrositeMediaInput>;
  photobooth?: InputMaybe<MicrositePhotoboothInput>;
  polls?: InputMaybe<MicrositePollsInput>;
  relevantReviews?: InputMaybe<MicrositeRelevantReviewInput>;
  relevantReviewsModule?: InputMaybe<MicrositeRelevantReviewsModuleInput>;
  restroomCode?: InputMaybe<MicrositeRestroomInput>;
  socials?: InputMaybe<MicrositeSocialsInput>;
  suggestedMenu?: InputMaybe<MicrositeSuggestedMenuInput>;
  suggestion?: InputMaybe<MicrositeSuggestionConfigInput>;
  teamProfiles?: InputMaybe<MicrositeTeamProfilesInput>;
  theme?: InputMaybe<MicrositeThemeInput>;
  wifiInfo?: InputMaybe<MicrositeWifiInput>;
};

/** Autogenerated return type of UpdateMicrositeMutation. */
export type UpdateMicrositeMutationPayload = {
  __typename?: 'UpdateMicrositeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  micrositeLocation: MicrositeLocation;
};

/** Autogenerated input type of UpdateModifierGroupSavedVisibility */
export type UpdateModifierGroupSavedVisibilityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Modifier group's current lock version. If an outdated lock version is
   * provided, the operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int']['input'];
  /** Modifier Group ID. */
  modifierGroupId: Scalars['ID']['input'];
  /**
   * Visibility value to save. This sets the modifier group's
   * "visibility.savedValue" and has a cascading effect on the
   * "visibility.effectiveValue" of the options within the group. I.e. hiding a
   * modifier group also changes the effective visibility of its modifier options,
   * hiding them from consumers regardless of what their individual
   * "visibility.savedValue" fields hold. Their individual saved values are
   * retained, and will become relevant in determining their effective visibility
   * if the group is later unhidden.
   */
  value: VisibilityEnum;
};

/** Autogenerated return type of UpdateModifierGroupSavedVisibility */
export type UpdateModifierGroupSavedVisibilityPayload = {
  __typename?: 'UpdateModifierGroupSavedVisibilityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to update the modifier group's saved visibility value. */
  result: ModifierGroupResult;
};

/** Input for updating the sort order of a modifier group. */
export type UpdateModifierGroupSortOrderInput = {
  /**
   * ModifierGroup's current lock version. If an outdated lock version is provided,
   * the operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int']['input'];
  /** ModifierGroup ID */
  modifierGroupId: Scalars['ID']['input'];
};

/** Autogenerated input type of UpdateModifierGroupsSortOrder */
export type UpdateModifierGroupsSortOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * List describing the desired sort order of merchant's modifier groups. This
   * list must be exhaustive, i.e. it should contain an element for each modifier
   * group the merchant has. The operation will be rejected if given a
   * non-exhaustive list or a list that contains duplicates. It will also be
   * rejected if any of the list elements identify modifier groups that don't
   * belong to the right merchant.
   */
  elements: Array<UpdateModifierGroupSortOrderInput>;
  /** The ID of the merchant whose modifier groups are being sorted. */
  merchantId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateModifierGroupsSortOrder */
export type UpdateModifierGroupsSortOrderPayload = {
  __typename?: 'UpdateModifierGroupsSortOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to update the modifier groups' sort order. */
  result: ModifierGroupsResult;
};

/** Autogenerated input type of UpdateModifierOptionSavedVisibility */
export type UpdateModifierOptionSavedVisibilityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * ModifierOption's current lock version. If an outdated lock version is
   * provided, the operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int']['input'];
  /** ModifierOption ID. */
  modifierOptionId: Scalars['ID']['input'];
  /**
   * Visibility value to save. This sets the modifier option's
   * "visibility.savedValue". It also determines the option's effective visibility
   * if it belongs to a visible modifier group. If it belongs to a hidden modifier
   * group, the option remains effectively hidden regardless of its saved
   * visibility value.
   */
  value: VisibilityEnum;
};

/** Autogenerated return type of UpdateModifierOptionSavedVisibility */
export type UpdateModifierOptionSavedVisibilityPayload = {
  __typename?: 'UpdateModifierOptionSavedVisibilityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to update the modifier option's saved visibility value. */
  result: ModifierOptionResult;
};

/** Input for updating the sort order of a modifier option. */
export type UpdateModifierOptionSortOrderInput = {
  /**
   * ModifierOption's current lock version. If an outdated lock version is
   * provided, the operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int']['input'];
  /** ModifierOption ID */
  modifierOptionId: Scalars['ID']['input'];
};

/** Autogenerated input type of UpdateModifierOptionsSortOrder */
export type UpdateModifierOptionsSortOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * List describing the desired sort order of modifier group's options. This list
   * must be exhaustive, i.e. it should contain an element for each option in the
   * group. The operation will be rejected if given a non-exhaustive list. It will
   * also be rejected if any of the list elements identify options that don't
   * belong to the right group.
   */
  elements: Array<UpdateModifierOptionSortOrderInput>;
  /** The ID of the modifier group whose options are being sorted. */
  modifierGroupId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateModifierOptionsSortOrder */
export type UpdateModifierOptionsSortOrderPayload = {
  __typename?: 'UpdateModifierOptionsSortOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to update the modifier options' sort order. */
  result: ModifierOptionsResult;
};

/** Autogenerated input type of UpdateOdekoItemInventoryMutation */
export type UpdateOdekoItemInventoryMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** PROTOTYPE The Odeko UUID of the location. */
  locationId: Scalars['ID']['input'];
  /** PROTOTYPE The Odeko UUID of the item. */
  odekoItemId: Scalars['ID']['input'];
  /** PROTOTYPE The Inventory information to be updated. */
  odekoItemInventoryInput: OdekoItemInventoryInput;
};

/** Autogenerated return type of UpdateOdekoItemInventoryMutation. */
export type UpdateOdekoItemInventoryMutationPayload = {
  __typename?: 'UpdateOdekoItemInventoryMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  inventoryInfo?: Maybe<InventoryInfo>;
  inventoryLocationItem: InventoryLocationItem;
};

/** Autogenerated input type of UpdateOrderDeliveryMethodMutation */
export type UpdateOrderDeliveryMethodMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The new delivery method for the order(s). Omit to restore each order's own
   * pre-3PD delivery method (requires thirdPartyMarkingAllowed: false).
   */
  deliveryMethod?: InputMaybe<OrderDeliveryMethodEnum>;
  /** ID of the order(s) to update */
  orderIds: Array<Scalars['ID']['input']>;
  /** Admin-only. Set to false to exclude the order(s) from future automated third-party-delivery marking. */
  thirdPartyMarkingAllowed?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateOrderDeliveryMethodMutation. */
export type UpdateOrderDeliveryMethodMutationPayload = {
  __typename?: 'UpdateOrderDeliveryMethodMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<UserError>>;
  orders?: Maybe<Array<Order>>;
};

/** Autogenerated input type of UpdatePlatformMicrositeLocationMutation */
export type UpdatePlatformMicrositeLocationMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['String']['input'];
  micrositeLocationId: Scalars['ID']['input'];
  platformId: PlatformIds;
};

/** Autogenerated return type of UpdatePlatformMicrositeLocationMutation. */
export type UpdatePlatformMicrositeLocationMutationPayload = {
  __typename?: 'UpdatePlatformMicrositeLocationMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  platformMicrositeLocation: PlatformMicrosite;
};

/** Autogenerated input type of UpdateReceivableNote */
export type UpdateReceivableNoteInput = {
  body: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateReceivableNote. */
export type UpdateReceivableNotePayload = {
  __typename?: 'UpdateReceivableNotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  receivableNote?: Maybe<ReceivableNote>;
};

/** Autogenerated input type of UpdateSoApiRoutingImportPlanTruckCountMutation */
export type UpdateSoApiRoutingImportPlanTruckCountMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Routing import plan night end. */
  nightEnd: Scalars['ISO8601Date']['input'];
  /** Routing import plan truck count. */
  truckCount: Scalars['Int']['input'];
  /** Warehouse id. */
  warehouseId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateSoApiRoutingImportPlanTruckCountMutation. */
export type UpdateSoApiRoutingImportPlanTruckCountMutationPayload = {
  __typename?: 'UpdateSoApiRoutingImportPlanTruckCountMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
};

/** Autogenerated input type of UpdateSquareOrderSuggestionFromTranscriptMutation */
export type UpdateSquareOrderSuggestionFromTranscriptMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the order suggestion to update */
  suggestionId: Scalars['ID']['input'];
  /** Additional transcript to append and parse */
  transcript: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateSquareOrderSuggestionFromTranscriptMutation. */
export type UpdateSquareOrderSuggestionFromTranscriptMutationPayload = {
  __typename?: 'UpdateSquareOrderSuggestionFromTranscriptMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']['output']>;
  /** The updated order suggestion */
  orderSuggestion?: Maybe<SquareOrderSuggestion>;
};

/** Autogenerated input type of UpdateSquareOrderSuggestionMutation */
export type UpdateSquareOrderSuggestionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Complete list of line items (replaces existing) */
  lineItems: Array<SquareOrderSuggestionLineItemInput>;
  /** Optional note to update */
  note?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the order suggestion to update */
  suggestionId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateSquareOrderSuggestionMutation. */
export type UpdateSquareOrderSuggestionMutationPayload = {
  __typename?: 'UpdateSquareOrderSuggestionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']['output']>;
  /** The updated order suggestion */
  orderSuggestion?: Maybe<SquareOrderSuggestion>;
};

/** Autogenerated input type of UpdateSubmenuSavedVisibility */
export type UpdateSubmenuSavedVisibilityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Submenu's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int']['input'];
  /** Submenu ID. */
  submenuId: Scalars['ID']['input'];
  /**
   * Visibility value to save. This sets the submenu's "visibility.savedValue" and
   * has a cascading effect on the "visibility.effectiveValue" of its menu-items.
   * This also determines the submenu's effective visibility if it belongs to a
   * visible menu. If it belongs to a hidden menu, the submenu remains effectively
   * hidden regardless of its saved visibility value.
   */
  value: VisibilityEnum;
};

/** Autogenerated return type of UpdateSubmenuSavedVisibility */
export type UpdateSubmenuSavedVisibilityPayload = {
  __typename?: 'UpdateSubmenuSavedVisibilityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to update the submenu's saved visibility value. */
  result: SubmenuResult;
};

/** Input for updating the sort order of a submenu. */
export type UpdateSubmenuSortOrderInput = {
  /**
   * Submenu's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int']['input'];
  /** Submenu ID */
  submenuId: Scalars['ID']['input'];
};

/** Autogenerated input type of UpdateSubmenusSortOrder */
export type UpdateSubmenusSortOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * List describing the desired sort order of menu's submenus. This list must be
   * exhaustive, i.e. it should contain an element for each submenu the menu has.
   * The operation will be rejected if given a non-exhaustive list or a list that
   * contains duplicates. It will also be rejected if any of the list elements
   * identify submenus that don't belong to the right menu.
   */
  elements: Array<UpdateSubmenuSortOrderInput>;
  /** The ID of the menu whose submenus are being sorted. */
  menuId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateSubmenusSortOrder */
export type UpdateSubmenusSortOrderPayload = {
  __typename?: 'UpdateSubmenusSortOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of attempting to update the submenus' sort order. */
  result: SubmenusResult;
};

/** Autogenerated input type of UpdateSubscriptionSessionMutation */
export type UpdateSubscriptionSessionMutationInput = {
  /** Auth0 user ID for newly created user (sets existing_auth0_user_id) */
  auth0UserId?: InputMaybe<Scalars['String']['input']>;
  /** Business name */
  businessName?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Context for the subscription session */
  context?: InputMaybe<Scalars['String']['input']>;
  /** User email address */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Google Location name for linking */
  googleLocationName?: InputMaybe<Scalars['String']['input']>;
  /** Google Places API place ID */
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  /** Pricing package ID */
  pricingPackageId?: InputMaybe<Scalars['Int']['input']>;
  /** Frontend origin URL for return navigation */
  returnOrigin?: InputMaybe<Scalars['String']['input']>;
  /** Physical sign color preference */
  signColor?: InputMaybe<Scalars['String']['input']>;
  /** Physical sign material preference */
  signMaterial?: InputMaybe<Scalars['String']['input']>;
  /** ID of the subscription session to update */
  subscriptionSessionId: Scalars['ID']['input'];
  /** URL-friendly slug for microsite */
  urlSlug?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateSubscriptionSessionMutation. */
export type UpdateSubscriptionSessionMutationPayload = {
  __typename?: 'UpdateSubscriptionSessionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']['output']>;
  /** Updated subscription session */
  subscriptionSession?: Maybe<SubscriptionSession>;
};

/** Autogenerated input type of UpdateUserMutation */
export type UpdateUserMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Required for admin actors; ignored for customer-role actors. */
  companyOdekoUuid?: InputMaybe<Scalars['ID']['input']>;
  /** Updated email address */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Updated first name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Updated last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Full desired set of location UUIDs (replace semantics). Omit to leave unchanged. */
  locationOdekoUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Updated phone number */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Updated role */
  role?: InputMaybe<Scalars['String']['input']>;
  /** Auth0 user ID of the user to update */
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateUserMutation. */
export type UpdateUserMutationPayload = {
  __typename?: 'UpdateUserMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  user?: Maybe<User>;
};

/** Autogenerated input type of UpdateUserNotificationPreferencesMutation */
export type UpdateUserNotificationPreferencesMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether the user is subscribed to app updates and news email notifications */
  notifAppUpdatesNewsEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the user is subscribed to app updates and news push notifications */
  notifAppUpdatesNewsPush?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the user is subscribed to new products email notifications */
  notifNewProductsEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the user is subscribed to new products push notifications */
  notifNewProductsPush?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the user is subscribed to order cancelled email notifications. */
  notifOrderCancelledEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the user is subscribed to order cancelled push notifications. */
  notifOrderCancelledPush?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the user is subscribed to order confirmed email notifications. */
  notifOrderConfirmedEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the user is subscribed to order confirmed push notifications. */
  notifOrderConfirmedPush?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the user is subscribed to order delivered email notifications. */
  notifOrderDeliveredEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the user is subscribed to order delivered push notifications. */
  notifOrderDeliveredPush?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the user is subscribed to order issue email notifications. */
  notifOrderIssueEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the user is subscribed to order issue push notifications. */
  notifOrderIssuePush?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the user is subscribed to order shipped email notifications. */
  notifOrderShippedEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the user is subscribed to order shipped push notifications. */
  notifOrderShippedPush?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the user is subscribed to order updated email notifications. */
  notifOrderUpdatedEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the user is subscribed to order updated push notifications. */
  notifOrderUpdatedPush?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the user is subscribed to product back in stock email notifications. */
  notifProductBackInStockEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the user is subscribed to product back in stock push notifications. */
  notifProductBackInStockPush?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the user is subscribed to promotions and discounts email notifications */
  notifPromotionsDiscountsEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the user is subscribed to promotions and discounts push notifications */
  notifPromotionsDiscountsPush?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the user is subscribed to redelivery email notifications. */
  notifRedeliveryEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the user is subscribed to redelivery push notifications. */
  notifRedeliveryPush?: InputMaybe<Scalars['Boolean']['input']>;
  /** UUID of the user whose notification preferences to update. Defaults to the current user. */
  userUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateUserNotificationPreferencesMutation. */
export type UpdateUserNotificationPreferencesMutationPayload = {
  __typename?: 'UpdateUserNotificationPreferencesMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  user?: Maybe<User>;
};

/** Autogenerated input type of UpdateWarehouseArrivedAtRouteTime */
export type UpdateWarehouseArrivedAtRouteTimeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Delivery route id. */
  deliveryRouteId: Scalars['ID']['input'];
  /** Client-provided time the driver returned to the warehouse (a geofence crossing). Defaults to server time when omitted. */
  occurredAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Autogenerated return type of UpdateWarehouseArrivedAtRouteTime. */
export type UpdateWarehouseArrivedAtRouteTimePayload = {
  __typename?: 'UpdateWarehouseArrivedAtRouteTimePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  route?: Maybe<Route>;
  userErrors: Array<RouteError>;
};

/** Autogenerated input type of UpdateWarehouseDepartedAtRouteTime */
export type UpdateWarehouseDepartedAtRouteTimeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Delivery route id. */
  deliveryRouteId: Scalars['ID']['input'];
  /** Client-provided time the driver departed the warehouse (a geofence crossing). Defaults to server time when omitted. */
  occurredAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Autogenerated return type of UpdateWarehouseDepartedAtRouteTime. */
export type UpdateWarehouseDepartedAtRouteTimePayload = {
  __typename?: 'UpdateWarehouseDepartedAtRouteTimePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  route?: Maybe<Route>;
  userErrors: Array<RouteError>;
};

/** Autogenerated input type of UpdateWarehousesLeadTimeMutation */
export type UpdateWarehousesLeadTimeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  warehouses: Array<WarehouseLeadTimeInput>;
};

/** Autogenerated return type of UpdateWarehousesLeadTimeMutation. */
export type UpdateWarehousesLeadTimeMutationPayload = {
  __typename?: 'UpdateWarehousesLeadTimeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UploadArtworkForItemMutation */
export type UploadArtworkForItemMutationInput = {
  /** The S3 object key for the uploaded artwork */
  artworkS3Key?: InputMaybe<Scalars['String']['input']>;
  /** The artwork to apply to the custom item */
  brandedItemArtworkId?: InputMaybe<Scalars['ID']['input']>;
  /** The deal the artwork is being uploaded to */
  brandedItemDeal: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Any notes about the colors in the deal */
  colorNotes?: InputMaybe<Scalars['String']['input']>;
  /** The company the artwork would belong to */
  company?: InputMaybe<Scalars['ID']['input']>;
  /** The custom branded item the artwork is being uploaded to */
  customBrandedItemId: Scalars['ID']['input'];
  /** Any misc notes about the deal */
  notes?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UploadArtworkForItemMutation. */
export type UploadArtworkForItemMutationPayload = {
  __typename?: 'UploadArtworkForItemMutationPayload';
  brandedItemDeal?: Maybe<BrandedItemDeal>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
};

/** Autogenerated input type of UploadArtworkMutation */
export type UploadArtworkMutationInput = {
  /** The S3 object key for the uploaded artwork */
  artworkS3Key: Scalars['String']['input'];
  /** The deal the artwork is being uploaded to */
  brandedItemDeal: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Any notes about the colors in the deal */
  colorNotes?: InputMaybe<Scalars['String']['input']>;
  /** The company the artwork would belong to */
  company: Scalars['ID']['input'];
  /** Any misc notes about the deal */
  notes?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UploadArtworkMutation. */
export type UploadArtworkMutationPayload = {
  __typename?: 'UploadArtworkMutationPayload';
  brandedItemDeal?: Maybe<BrandedItemDeal>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
};

export type UploadItemImage = {
  __typename?: 'UploadItemImage';
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type UploadItemImageByKey = {
  __typename?: 'UploadItemImageByKey';
  url: Scalars['String']['output'];
};

/** Autogenerated input type of UpsertAccountCreationSession */
export type UpsertAccountCreationSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Session data for create or update */
  session: AccountCreationSessionInput;
};

/** Autogenerated return type of UpsertAccountCreationSession. */
export type UpsertAccountCreationSessionPayload = {
  __typename?: 'UpsertAccountCreationSessionPayload';
  /** The created or updated account creation session */
  accountCreationSession?: Maybe<AccountCreationSession>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpsertAdminOrderItemMutation */
export type UpsertAdminOrderItemMutationInput = {
  /** The channel from which the order is being created */
  channel?: InputMaybe<OrderChannelEnum>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the item to add to an order */
  itemUuid: Scalars['ID']['input'];
  /** ID of the location for the order */
  locationUuid: Scalars['ID']['input'];
  /** Quantity of item to order */
  quantity: Scalars['Int']['input'];
  /**
   * Optional delivery date for the order. If provided, the system will attempt to
   * place the order for the next available delivery starting from this date. If
   * not provided, the system will calculate the next available delivery date based
   * on the location and vendor.
   */
  requestedDeliveryDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

/** Autogenerated return type of UpsertAdminOrderItemMutation. */
export type UpsertAdminOrderItemMutationPayload = {
  __typename?: 'UpsertAdminOrderItemMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<UserError>>;
  order?: Maybe<Order>;
};

/** Autogenerated input type of UpsertArAssignment */
export type UpsertArAssignmentInput = {
  assigneeUuid: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyUuid: Scalars['String']['input'];
};

/** Autogenerated return type of UpsertArAssignment. */
export type UpsertArAssignmentPayload = {
  __typename?: 'UpsertArAssignmentPayload';
  arAssignment?: Maybe<ArAssignment>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpsertBackInStockSubscriptionMutation */
export type UpsertBackInStockSubscriptionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Notify the user once this quantity is available to purchase */
  desiredQuantity: Scalars['Int']['input'];
  /** Item UUID */
  itemId: Scalars['ID']['input'];
  /** Location UUID */
  locationId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpsertBackInStockSubscriptionMutation. */
export type UpsertBackInStockSubscriptionMutationPayload = {
  __typename?: 'UpsertBackInStockSubscriptionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<UserError>>;
  /** If true, mutation created a new subscription rather than update an existing one. */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  subscription?: Maybe<BackInStockSubscription>;
};

export type UpsertCategoryBannerInput = {
  /** The category or subcategory this banner is configured on. */
  categoryId: Scalars['ID']['input'];
  /**
   * The creative every market inherits unless it carries its own. Unlike
   * `warehouses` it is not a full set a caller resends: omit it and whatever is
   * stored stays, because a call naming only per-market creative says nothing about
   * the default. Send null to remove it.
   */
  defaultCreative?: InputMaybe<CategoryBannerDefaultInput>;
  /**
   * One entry per market that departs from `defaultCreative`, by carrying its own creative or by
   * being hidden. Markets left out are reset to inheriting the default, so a caller must send back
   * every market it means to keep — leaving one out is not how it is made to show nothing, which is
   * what `hidden` is for. May be empty when the banner has a default; use `deleteCategoryBanner` to
   * remove it outright.
   */
  warehouses: Array<CategoryBannerWarehouseInput>;
};

/** Autogenerated input type of UpsertDeliveryDatePoNumbersMutation */
export type UpsertDeliveryDatePoNumbersMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deliveryDatePoNumbers: Array<DeliveryDatePoNumberInput>;
  /** UUID for the Location */
  locationId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpsertDeliveryDatePoNumbersMutation. */
export type UpsertDeliveryDatePoNumbersMutationPayload = {
  __typename?: 'UpsertDeliveryDatePoNumbersMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deliveryDatePoNumbers?: Maybe<Array<DeliveryDatePoNumber>>;
  errors: Array<UserError>;
};

/** Autogenerated input type of UpsertExternalDeliveryMutation */
export type UpsertExternalDeliveryMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Order id denoting the order that should be delivered via the 3rd party delivery partner. */
  orderId: Scalars['ID']['input'];
  /** The number of containers used to pack the order. */
  totalContainers: Scalars['Int']['input'];
};

/** Autogenerated return type of UpsertExternalDeliveryMutation. */
export type UpsertExternalDeliveryMutationPayload = {
  __typename?: 'UpsertExternalDeliveryMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<UserError>>;
  externalDelivery?: Maybe<ExternalDelivery>;
};

/** Autogenerated input type of UpsertExternalSupplier */
export type UpsertExternalSupplierInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** Autogenerated return type of UpsertExternalSupplier. */
export type UpsertExternalSupplierPayload = {
  __typename?: 'UpsertExternalSupplierPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  externalSupplier?: Maybe<ExternalSupplier>;
};

/** Autogenerated input type of UpsertLocationAccountsReceivableCollectionsStatus */
export type UpsertLocationAccountsReceivableCollectionsStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationUuid: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

/** Autogenerated return type of UpsertLocationAccountsReceivableCollectionsStatus. */
export type UpsertLocationAccountsReceivableCollectionsStatusPayload = {
  __typename?: 'UpsertLocationAccountsReceivableCollectionsStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  locationArCollectionsStatus?: Maybe<AccountsReceivableCollectionsStatus>;
};

/** Autogenerated input type of UpsertLocationOrdersMutation */
export type UpsertLocationOrdersMutationInput = {
  /** When true, skip the cutoff time check for authorized users (can_modify_order_after_cutoff). */
  bypassCutoff?: InputMaybe<Scalars['Boolean']['input']>;
  /** Submission channel (e.g. WEB_PORTAL) */
  channel?: InputMaybe<OrderChannelEnum>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the location placing the orders */
  locationId: Scalars['ID']['input'];
  /** One entry per delivery date, each containing one or more vendor orders */
  orders: Array<LocationOrderDateInput>;
  /** Payment method type for the orders. Must match the location's configured payment method. */
  paymentMethodType?: InputMaybe<PaymentMethodTypeEnum>;
};

/** Autogenerated return type of UpsertLocationOrdersMutation. */
export type UpsertLocationOrdersMutationPayload = {
  __typename?: 'UpsertLocationOrdersMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<LocationOrderError>;
  results: Array<LocationOrderResult>;
};

/** Autogenerated input type of UpsertLocationPhoneNumberMutation */
export type UpsertLocationPhoneNumberMutationInput = {
  /** Allow drivers to contact the recipient between 6 PM and 6 AM in the location's time zone */
  afterHoursContactAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** UUID for the Location */
  locationUuid: Scalars['String']['input'];
  /** A phone number in E.164 format */
  phoneNumber: Scalars['String']['input'];
  /** Type of the phone number */
  phoneType: LocationPhoneTypeEnum;
};

/** Autogenerated return type of UpsertLocationPhoneNumberMutation. */
export type UpsertLocationPhoneNumberMutationPayload = {
  __typename?: 'UpsertLocationPhoneNumberMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneType?: Maybe<LocationPhoneTypeEnum>;
};

export type UpsertMasterHomepageInput = {
  endDate: Scalars['ISO8601Date']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  startDate: Scalars['ISO8601Date']['input'];
};

export type UpsertMasterHomepagePayload = {
  __typename?: 'UpsertMasterHomepagePayload';
  errors: Array<MasterHomepageError>;
  masterHomepage?: Maybe<MasterHomepageListItem>;
};

/** Autogenerated input type of UpsertMicrositeGuestbookMessageMutation */
export type UpsertMicrositeGuestbookMessageMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ip?: InputMaybe<Scalars['String']['input']>;
  /** ID of the microsite location */
  locationId: Scalars['ID']['input'];
  /** Content of the guestbook message */
  message: Scalars['String']['input'];
  /** ID of the existing message to update (if any) */
  messageId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpsertMicrositeGuestbookMessageMutation. */
export type UpsertMicrositeGuestbookMessageMutationPayload = {
  __typename?: 'UpsertMicrositeGuestbookMessageMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The upserted or updated guestbook message */
  micrositeGuestbookMessage?: Maybe<MicrositeMessage>;
};

/** Autogenerated input type of UpsertMicrositeMenuItem */
export type UpsertMicrositeMenuItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuItem: MicrositeMenuItemInput;
  micrositeLocationId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpsertMicrositeMenuItem. */
export type UpsertMicrositeMenuItemPayload = {
  __typename?: 'UpsertMicrositeMenuItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  micrositeMenuItem?: Maybe<MicrositeMenuItem>;
};

export type UpsertNewItemPinInput = {
  itemId: Scalars['ID']['input'];
  /** Absolute carousel slot to pin to; appended to the end of that slot's succession queue. */
  position: Scalars['Int']['input'];
  /** Mark this pin as a paid (sponsored) placement; defaults off. Internal merchandising/seasonal pins stay unlabeled. */
  sponsored?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseId: Scalars['ID']['input'];
};

export type UpsertOrderItemInput = {
  /** Item ID */
  id: Scalars['ID']['input'];
  /** Quantity for the item */
  quantity: Scalars['Int']['input'];
};

/** Autogenerated input type of UpsertOrderMutation */
export type UpsertOrderMutationInput = {
  /** The channel from which the order is being created or updated (e.g., web_portal, mobile_ios, mobile_android) */
  channel?: InputMaybe<OrderChannelEnum>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** List of coupon codes to apply. */
  couponCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The requested delivery for the items */
  deliveryDate: Scalars['ISO8601Date']['input'];
  /** List of items the caller is requesting */
  items: Array<UpsertOrderItemInput>;
  /** ID of the location for the order */
  locationId: Scalars['ID']['input'];
  /**
   * The payment method type for the order. Used to determine the payment
   * processing fee. Must match the location's payment method type.
   */
  paymentMethodType?: InputMaybe<PaymentMethodTypeEnum>;
  /** List of sales tax estimates to apply. */
  salesTaxEstimates?: InputMaybe<Array<SalesTaxEstimateInput>>;
};

/** Autogenerated return type of UpsertOrderMutation. */
export type UpsertOrderMutationPayload = {
  __typename?: 'UpsertOrderMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  orders?: Maybe<Array<Order>>;
};

/** Autogenerated input type of UpsertRecipeMutation */
export type UpsertRecipeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Ingredients */
  ingredients: Array<RecipeIngredientInput>;
  /** UUID for the Location */
  locationId: Scalars['ID']['input'];
  /** ID for the MenuItemSize */
  menuItemSizeUuid: Scalars['ID']['input'];
  /** ID for the MenuItem */
  menuItemUuid: Scalars['ID']['input'];
};

/** Autogenerated return type of UpsertRecipeMutation. */
export type UpsertRecipeMutationPayload = {
  __typename?: 'UpsertRecipeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  recipe?: Maybe<Recipe>;
};

/** Autogenerated input type of UpsertShippingInstructionsMutation */
export type UpsertShippingInstructionsMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** UUID for the Location */
  locationId: Scalars['ID']['input'];
  shippingInstructions: ShippingInstructionsInput;
};

/** Autogenerated return type of UpsertShippingInstructionsMutation. */
export type UpsertShippingInstructionsMutationPayload = {
  __typename?: 'UpsertShippingInstructionsMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  shippingInstructions?: Maybe<ShippingInstructions>;
};

export type UpsertSubstitutionOverrideInput = {
  priority?: InputMaybe<Scalars['Int']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  sourceItemId: Scalars['ID']['input'];
  substituteItemId: Scalars['ID']['input'];
};

/** Autogenerated input type of UpsertSurveyMutation */
export type UpsertSurveyMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Is survey fully completed */
  completed: Scalars['Boolean']['input'];
  /** Location UUID */
  locationId: Scalars['ID']['input'];
  /** Survey name */
  name: Scalars['String']['input'];
  /** User answers */
  responses: Array<SurveyResponseInput>;
  /** Survey belongs to a Company or Location */
  surveyLevel: SurveyLevelEnum;
};

/** Autogenerated return type of UpsertSurveyMutation. */
export type UpsertSurveyMutationPayload = {
  __typename?: 'UpsertSurveyMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  survey?: Maybe<Survey>;
};

/** Autogenerated input type of UpsertWarehouseZipcodes */
export type UpsertWarehouseZipcodesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  warehouseId: Scalars['ID']['input'];
  zipcodes: Array<Scalars['String']['input']>;
};

/** Autogenerated return type of UpsertWarehouseZipcodes. */
export type UpsertWarehouseZipcodesPayload = {
  __typename?: 'UpsertWarehouseZipcodesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  zipcodes: Array<Zipcode>;
};

/** Autogenerated input type of UpsertZipcodeDeliveryRule */
export type UpsertZipcodeDeliveryRuleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Delivery rule day, 0-6, 0 is Sunday */
  deliveryDay: Scalars['Int']['input'];
  /** Lead time for delivery in days, 1-365 */
  leadTime: Scalars['Int']['input'];
  /** Deadline for ordering to be submitted in format HH:MM */
  orderDeadline: Scalars['String']['input'];
  /** The Zipcode to upsert a delivery rule for */
  zipcode: Scalars['String']['input'];
};

/** Autogenerated return type of UpsertZipcodeDeliveryRule. */
export type UpsertZipcodeDeliveryRulePayload = {
  __typename?: 'UpsertZipcodeDeliveryRulePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deliveryRule?: Maybe<DeliveryRule>;
  errors: Array<UserError>;
};

/** Autogenerated input type of UpsertZipcodeDeliveryWindow */
export type UpsertZipcodeDeliveryWindowInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** End time in the format of HH:MM */
  endTime: Scalars['String']['input'];
  /** Start time in the format of HH:MM */
  startTime: Scalars['String']['input'];
  /** The Zipcode to upsert a delivery window */
  zipcode: Scalars['String']['input'];
};

/** Autogenerated return type of UpsertZipcodeDeliveryWindow. */
export type UpsertZipcodeDeliveryWindowPayload = {
  __typename?: 'UpsertZipcodeDeliveryWindowPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deliveryWindow?: Maybe<ZipcodeDeliveryWindow>;
  errors: Array<UserError>;
};

/**
 * A user is an individual's account on Odeko that can access services according to
 * their roles and permissions.
 */
export type User = {
  __typename?: 'User';
  /**
   * Locations assigned to this user (the target), scoped to the viewer's own
   * location access. Admin viewers see all of the target's locations; every other
   * viewer sees only the intersection of the target's locations and the locations
   * the viewer can themselves access. Unlike `locations`, this is resolved against
   * the target user, not the viewer.
   */
  assignedLocations: Array<Location>;
  auditLogs: AuditLogConnection;
  /**
   * The Auth0 user ID associated with this user. Usually you can rely on the `id`
   * field instead, but in cases where you need to access the Auth0 ID
   * specifically, this field is provided.
   */
  auth0UserId?: Maybe<Scalars['String']['output']>;
  availableItemBarcodeMatch?: Maybe<ItemBarcodeMatch>;
  availableItemById?: Maybe<SupplyItem>;
  availableItemByName?: Maybe<SupplyItem>;
  availableItemByUpcCode?: Maybe<SupplyItem>;
  /** Extended fields */
  availableItems: ItemConnection;
  /** Unacknowledged back-in-stock notifications for one of a user's locations, oldest first. */
  backInStockNotifications: Array<BackInStockNotification>;
  /** Link to the Business Portal admin interface for this user */
  bpAdminLink?: Maybe<Scalars['String']['output']>;
  /**
   * The user's email from business-portal database. Use this instead of the
   * federated `email` field when querying users through location.users due to
   * federation key mismatch.
   */
  bpEmail?: Maybe<Scalars['String']['output']>;
  /** Whether the user is permitted to submit orders after the cutoff time. */
  canModifyOrderAfterCutoff: Scalars['Boolean']['output'];
  /** Client applications available to the user */
  clientApps: Array<Scalars['String']['output']>;
  /** Whether the current viewer can edit this user, and why not if they can't. */
  editPermissionForViewer: EditPermissionForViewerEnum;
  /** The user's email. */
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** The user's unique identifier. */
  id: Scalars['ID']['output'];
  itemTags: ItemTagConnection;
  lastName?: Maybe<Scalars['String']['output']>;
  /** An item's location assignment history, collapsed into runs by user and paged by run, newest first */
  locationChangeGroups: LocationChangeGroupConnection;
  locations: LocationConnection;
  /** Number of locations assigned to this user. */
  locationsCount: Scalars['Int']['output'];
  /** The user's name. */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * Admin/preview entry point into the shared New Items ordering for an explicit
   * market. Unlike Location.newItems — which derives the market from a shopper's
   * location — this takes warehouseId directly, so internal tooling (the
   * merchandising studio's View All) can render true carousel order for any market,
   * search within it, and pin in context. Delegates to the same shared resolution as
   * Location.newItems, so the admin view can never drift from what shoppers see.
   * searchQuery runs against the catalog directly (no Algolia), so admin results are
   * deterministic. Returns plain SupplyItems; pin state is overlaid client-side from
   * newItemPins.
   */
  newItems: ItemConnection;
  /** Whether the user is subscribed to app updates and news email notifications */
  notifAppUpdatesNewsEmail: Scalars['Boolean']['output'];
  /** Whether the user is subscribed to app updates and news push notifications */
  notifAppUpdatesNewsPush: Scalars['Boolean']['output'];
  /** Whether the user is subscribed to new products email notifications */
  notifNewProductsEmail: Scalars['Boolean']['output'];
  /** Whether the user is subscribed to new products push notifications */
  notifNewProductsPush: Scalars['Boolean']['output'];
  /** Whether the user is subscribed to order cancelled email notifications. */
  notifOrderCancelledEmail: Scalars['Boolean']['output'];
  /** Whether the user is subscribed to order cancelled push notifications. */
  notifOrderCancelledPush: Scalars['Boolean']['output'];
  /** Whether the user is subscribed to order confirmed email notifications. */
  notifOrderConfirmedEmail: Scalars['Boolean']['output'];
  /** Whether the user is subscribed to order confirmed push notifications. */
  notifOrderConfirmedPush: Scalars['Boolean']['output'];
  /** Whether the user is subscribed to order delivered email notifications. */
  notifOrderDeliveredEmail: Scalars['Boolean']['output'];
  /** Whether the user is subscribed to order delivered push notifications. */
  notifOrderDeliveredPush: Scalars['Boolean']['output'];
  /** Whether the user is subscribed to order issue email notifications. */
  notifOrderIssueEmail: Scalars['Boolean']['output'];
  /** Whether the user is subscribed to order issue push notifications. */
  notifOrderIssuePush: Scalars['Boolean']['output'];
  /** Whether the user is subscribed to order shipped email notifications. */
  notifOrderShippedEmail: Scalars['Boolean']['output'];
  /** Whether the user is subscribed to order shipped push notifications. */
  notifOrderShippedPush: Scalars['Boolean']['output'];
  /** Whether the user is subscribed to order updated email notifications. */
  notifOrderUpdatedEmail: Scalars['Boolean']['output'];
  /** Whether the user is subscribed to order updated push notifications. */
  notifOrderUpdatedPush: Scalars['Boolean']['output'];
  /** Whether the user is subscribed to product back in stock email notifications. */
  notifProductBackInStockEmail: Scalars['Boolean']['output'];
  /** Whether the user is subscribed to product back in stock push notifications. */
  notifProductBackInStockPush: Scalars['Boolean']['output'];
  /** Whether the user is subscribed to promotions and discounts email notifications */
  notifPromotionsDiscountsEmail: Scalars['Boolean']['output'];
  /** Whether the user is subscribed to promotions and discounts push notifications */
  notifPromotionsDiscountsPush: Scalars['Boolean']['output'];
  /** Whether the user is subscribed to redelivery email notifications. */
  notifRedeliveryEmail: Scalars['Boolean']['output'];
  /** Whether the user is subscribed to redelivery push notifications. */
  notifRedeliveryPush: Scalars['Boolean']['output'];
  /** The user's payroll identifier (assigned in ARMhr), if one is set. */
  payrollId?: Maybe<Scalars['String']['output']>;
  /** The user's phone number in ###-###-#### format. */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** The user's role with display name, summary, and permissions. */
  role?: Maybe<Role>;
  uuid: Scalars['String']['output'];
};


/**
 * A user is an individual's account on Odeko that can access services according to
 * their roles and permissions.
 */
export type UserAuditLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  excludeObjectTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  itemId?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  objects?: InputMaybe<Array<InputMaybe<AuditLogObjectInput>>>;
  sortOrder?: InputMaybe<Array<InputMaybe<AuditLogSortOrder>>>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};


/**
 * A user is an individual's account on Odeko that can access services according to
 * their roles and permissions.
 */
export type UserAvailableItemBarcodeMatchArgs = {
  code: Scalars['String']['input'];
};


/**
 * A user is an individual's account on Odeko that can access services according to
 * their roles and permissions.
 */
export type UserAvailableItemByIdArgs = {
  id: Scalars['ID']['input'];
};


/**
 * A user is an individual's account on Odeko that can access services according to
 * their roles and permissions.
 */
export type UserAvailableItemByNameArgs = {
  name: Scalars['String']['input'];
};


/**
 * A user is an individual's account on Odeko that can access services according to
 * their roles and permissions.
 */
export type UserAvailableItemByUpcCodeArgs = {
  upcCode: Scalars['String']['input'];
};


/**
 * A user is an individual's account on Odeko that can access services according to
 * their roles and permissions.
 */
export type UserAvailableItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<InputMaybe<ItemsCategoryInput>>>;
  filters?: InputMaybe<ItemsFiltersInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  itemTypes?: InputMaybe<Array<InputMaybe<ItemType>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Array<InputMaybe<ItemsSortOrder>>>;
  subcategories?: InputMaybe<Array<InputMaybe<ItemsSubcategoryInput>>>;
  vendors?: InputMaybe<Array<InputMaybe<ItemsVendorInput>>>;
  warehouses?: InputMaybe<Array<InputMaybe<ItemsWarehouseInput>>>;
};


/**
 * A user is an individual's account on Odeko that can access services according to
 * their roles and permissions.
 */
export type UserBackInStockNotificationsArgs = {
  locationId: Scalars['ID']['input'];
};


/**
 * A user is an individual's account on Odeko that can access services according to
 * their roles and permissions.
 */
export type UserItemTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ItemTagFiltersInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Array<InputMaybe<ItemTagSortOrder>>>;
};


/**
 * A user is an individual's account on Odeko that can access services according to
 * their roles and permissions.
 */
export type UserLocationChangeGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  itemId: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * A user is an individual's account on Odeko that can access services according to
 * their roles and permissions.
 */
export type UserLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<LocationsFilter>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<LocationSearchFiltersInput>;
};


/**
 * A user is an individual's account on Odeko that can access services according to
 * their roles and permissions.
 */
export type UserNewItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<NewItemsFiltersInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  warehouseId: Scalars['ID']['input'];
};

/** User-readable error */
export type UserError = Error & {
  __typename?: 'UserError';
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** UserError interface to allow to return one or multiple types of errors. */
export type UserErrorInterface = {
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** A UserMicrositeLocation. Represents a user's association with a microsite location. */
export type UserMicrositeLocation = {
  __typename?: 'UserMicrositeLocation';
  /** ID of the UserMicrositeAssociation */
  id: Scalars['ID']['output'];
  /** Whether this is the user's first microsite */
  isFirstMicrosite: Scalars['Boolean']['output'];
  /** The microsite location associated with the user */
  micrositeLocation: MicrositeLocation;
  /** The Auth0 user id associated with the microsite */
  userId: Scalars['ID']['output'];
};

/** User platform connection with platform entities (accounts/profiles) and their microsites */
export type UserPlatformConnection = {
  __typename?: 'UserPlatformConnection';
  /** The user's default microsite (the first microsite they created) */
  defaultMicrositeLocation?: Maybe<MicrositeLocation>;
  /** The user's email for their identity on the connected platform. */
  email?: Maybe<Scalars['String']['output']>;
  /** Whether the user has connected to the platform */
  isConnected: Scalars['Boolean']['output'];
  /** The platform identifier */
  platformId: PlatformIds;
  /** List of platform entities (accounts/profiles) with their microsite associations */
  platformMicrosites: Array<PlatformMicrosite>;
};

/** Autogenerated input type of ValidateAndCompleteSubscriptionSessionMutation */
export type ValidateAndCompleteSubscriptionSessionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Stripe checkout session ID to validate and complete */
  stripeCheckoutSessionId: Scalars['String']['input'];
};

/** Autogenerated return type of ValidateAndCompleteSubscriptionSessionMutation. */
export type ValidateAndCompleteSubscriptionSessionMutationPayload = {
  __typename?: 'ValidateAndCompleteSubscriptionSessionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']['output']>;
  /** Completed subscription session */
  subscriptionSession?: Maybe<SubscriptionSession>;
};

/** Autogenerated input type of ValidateSubscriptionSessionCheckoutMutation */
export type ValidateSubscriptionSessionCheckoutMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Stripe checkout session ID to validate */
  stripeCheckoutSessionId: Scalars['String']['input'];
};

/** Autogenerated return type of ValidateSubscriptionSessionCheckoutMutation. */
export type ValidateSubscriptionSessionCheckoutMutationPayload = {
  __typename?: 'ValidateSubscriptionSessionCheckoutMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']['output']>;
  /** Updated subscription session */
  subscriptionSession?: Maybe<SubscriptionSession>;
};

export type VehicleInspectionPhaseStatus = {
  __typename?: 'VehicleInspectionPhaseStatus';
  reportId?: Maybe<Scalars['ID']['output']>;
  submitted: Scalars['Boolean']['output'];
  submittedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type VehicleInspectionPhoto = {
  __typename?: 'VehicleInspectionPhoto';
  contentType?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type VehicleInspectionReport = {
  __typename?: 'VehicleInspectionReport';
  deliveryRouteId: Scalars['ID']['output'];
  driver?: Maybe<Driver>;
  hasIssues: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  inspectionType: Scalars['String']['output'];
  issueCount: Scalars['Int']['output'];
  photos: Array<VehicleInspectionPhoto>;
  responses: Scalars['JSON']['output'];
  schemaVersion: Scalars['Int']['output'];
  submittedAt: Scalars['ISO8601DateTime']['output'];
  /** Display name captured at submission; legacy reports fall back to responses or the associated driver. */
  submittedByName?: Maybe<Scalars['String']['output']>;
  /** Authenticated user id captured at submission; legacy reports fall back to the associated driver. */
  submittedByUserId?: Maybe<Scalars['String']['output']>;
  truck: Truck;
  warehouse: Warehouse;
};

/** Autogenerated input type of VehicleInspectionReportCreate */
export type VehicleInspectionReportCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deliveryRouteId: Scalars['ID']['input'];
  inspectionType: Scalars['String']['input'];
  responses: Scalars['JSON']['input'];
  schemaVersion: Scalars['Int']['input'];
  submittedAt: Scalars['ISO8601DateTime']['input'];
  /** Authenticated submitter's display name. */
  submittedByName?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of VehicleInspectionReportCreate. */
export type VehicleInspectionReportCreatePayload = {
  __typename?: 'VehicleInspectionReportCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  report?: Maybe<VehicleInspectionReport>;
  userErrors: Array<UserError>;
};

export type VehicleInspectionStatus = {
  __typename?: 'VehicleInspectionStatus';
  deliveryRouteId: Scalars['ID']['output'];
  post: VehicleInspectionPhaseStatus;
  pre: VehicleInspectionPhaseStatus;
};

export type VehicleInspectionTruckStatus = {
  __typename?: 'VehicleInspectionTruckStatus';
  hasIssues: Scalars['Boolean']['output'];
  inspected: Scalars['Boolean']['output'];
  issueCount: Scalars['Int']['output'];
  latestSubmittedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  reportCount: Scalars['Int']['output'];
  truck: Truck;
};

export type Vendor = {
  __typename?: 'Vendor';
  address?: Maybe<Address>;
  id: Scalars['ID']['output'];
  isWarehouse: Scalars['Boolean']['output'];
  itemLevelTracking: Scalars['Boolean']['output'];
  /**
   * Legal vendor name — only use on internal-facing surfaces where the distinction
   * from the display name matters (e.g. driver and ops tooling)
   */
  legalName: Scalars['String']['output'];
  /** Display name — returns display_name when set, otherwise the legal name */
  name: Scalars['String']['output'];
  numericId: Scalars['Int']['output'];
  vendorAccessInstruction?: Maybe<VendorAccessInstruction>;
  vendorItemInstruction?: Maybe<VendorItemInstruction>;
  warehouse?: Maybe<Warehouse>;
};

export type VendorAccessInstruction = {
  __typename?: 'VendorAccessInstruction';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  imageUrls?: Maybe<Array<Scalars['String']['output']>>;
  note?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  videoUrls?: Maybe<Array<Scalars['String']['output']>>;
};

export type VendorItemInstruction = {
  __typename?: 'VendorItemInstruction';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  imageUrls?: Maybe<Array<Scalars['String']['output']>>;
  note?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  videoUrls?: Maybe<Array<Scalars['String']['output']>>;
};

export type VendorOrdersInput = {
  nightEnd: Scalars['ISO8601Date']['input'];
  vendorId?: InputMaybe<Scalars['ID']['input']>;
  warehouseId: Scalars['ID']['input'];
};

export type VendorReceivingCheckinInput = {
  nightEnd: Scalars['ISO8601Date']['input'];
  vendorId: Scalars['ID']['input'];
  warehouseId: Scalars['ID']['input'];
};

/** Aggregated item data for vendor receiving check-in view */
export type VendorReceivingCheckinItem = {
  __typename?: 'VendorReceivingCheckinItem';
  /** List of customer location names that ordered this item */
  customerNames: Array<Scalars['String']['output']>;
  itemId: Scalars['ID']['output'];
  itemName: Scalars['String']['output'];
  /** Item markup percentage from IMS */
  markupPercentage?: Maybe<Scalars['Float']['output']>;
  /** Total ordered quantity across all customers */
  orderedQty: Scalars['Int']['output'];
  receivedQty?: Maybe<Scalars['Float']['output']>;
  sellingPricePerUnitCents?: Maybe<Scalars['Int']['output']>;
  /** The underlying supply item */
  supplyItem?: Maybe<SupplyItem>;
  vendorPricePerUnitCents?: Maybe<Scalars['Int']['output']>;
  vendorPriceTotalCents?: Maybe<Scalars['Int']['output']>;
  /** When the receiving window expires for this session */
  windowClosesAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type VendorReceivingListInput = {
  nightEnd: Scalars['ISO8601Date']['input'];
  warehouseId: Scalars['ID']['input'];
};

export enum VendorReceivingStatus {
  /** All market-priced lines are fully allocated */
  Allocated = 'ALLOCATED',
  /** Some market-priced lines have been allocated but not all */
  Allocating = 'ALLOCATING',
  /** Check-in data exists but no lines have been allocated */
  CheckedIn = 'CHECKED_IN',
  /** No check-in saved and no lines allocated yet */
  Pending = 'PENDING',
  /** All market-priced lines are allocated but at least one is short */
  Shortage = 'SHORTAGE'
}

/** Summary of a vendor's market-priced orders for a given delivery date */
export type VendorReceivingSummary = {
  __typename?: 'VendorReceivingSummary';
  orderCount: Scalars['Int']['output'];
  /** Total units short across all allocated market-priced lines */
  shortageCount?: Maybe<Scalars['Int']['output']>;
  /** Current receiving state for this vendor */
  status: VendorReceivingStatus;
  totalOrderedQty: Scalars['Int']['output'];
  vendor?: Maybe<Vendor>;
  vendorId: Scalars['ID']['output'];
  vendorName?: Maybe<Scalars['String']['output']>;
  /**
   * Receiving window close time for this vendor's session at the given
   * warehouse/night_end. Nil if no check-in has started (window not open). Past =
   * window closed (UI should disable edits and show a view-only state). Reflects
   * state at response time; the API still enforces the window on submit.
   */
  windowClosesAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type Visibility = {
  __typename?: 'Visibility';
  /** Effective value, accounting for saved value and the visibility of parent objects. */
  effectiveValue: VisibilityEnum;
  /**
   * Saved value. This does not account for the visibility of parent objects, which
   * could mask an otherwise visible object. See effectiveValue.
   */
  savedValue: VisibilityEnum;
};

/** The possible visibility values. */
export enum VisibilityEnum {
  /** Hidden. */
  Hidden = 'hidden',
  /** Visible. */
  Visible = 'visible'
}

/** Autogenerated input type of VoteMicrositePollMutation */
export type VoteMicrositePollMutationInput = {
  /** ID of the answer to vote for (new frontend) */
  answerId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  micrositePollId: Scalars['ID']['input'];
};

/** Autogenerated return type of VoteMicrositePollMutation. */
export type VoteMicrositePollMutationPayload = {
  __typename?: 'VoteMicrositePollMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  poll: MicrositePoll;
};

/** Wallet. */
export type Wallet = {
  __typename?: 'Wallet';
  /** Square default card id. */
  squareDefaultCardId?: Maybe<Scalars['String']['output']>;
};

/** Error indicating that a mutation failed because the wallet balance is insufficient. */
export type WalletBalanceInsufficient = Error & {
  __typename?: 'WalletBalanceInsufficient';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Wallet mutation result. */
export type WalletResult = ErrorsResult | WalletSuccess;

/** Error indicating that a mutation failed because the wallet's squareUserId is blank. */
export type WalletSquareUserIdBlank = Error & {
  __typename?: 'WalletSquareUserIdBlank';
  /** A description of the error. */
  message: Scalars['String']['output'];
};

/** Result of a successful wallet mutation. */
export type WalletSuccess = {
  __typename?: 'WalletSuccess';
  /** Resulting wallet. */
  wallet: Wallet;
};

export type Warehouse = {
  __typename?: 'Warehouse';
  brandedPaperLeadTime?: Maybe<Scalars['Int']['output']>;
  categories: Array<Category>;
  currentNightEnd?: Maybe<Scalars['ISO8601DateTime']['output']>;
  fees: Array<FeeInterface>;
  /**
   * Delivery geofence radius in meters, used for stop/warehouse arrive-depart
   * detection in the driver app and the geofence circles drawn in
   * logistics-web-app. Note: iOS OS region monitoring is unreliable below ~150m,
   * so values under 150m may silently degrade arrival detection.
   */
  geofenceRadiusMeters: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /**
   * A prefill for the mark-time pickup field (epic D8), as a 24-hour "HH:MM" time
   * of day in this warehouse's own time zone, never a date: the newest marked
   * route's pickup time for this provider at this warehouse, or the dispatch
   * profile's default_pickup_time when none has one yet.
   */
  lastThirdPartyPickupTime?: Maybe<Scalars['String']['output']>;
  /** WGS84 latitude of the warehouse address. Null if the address is not geocoded. */
  latitude?: Maybe<Scalars['Float']['output']>;
  locations?: Maybe<Array<Location>>;
  /** WGS84 longitude of the warehouse address. Null if the address is not geocoded. */
  longitude?: Maybe<Scalars['Float']['output']>;
  membershipProgramEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pkId?: Maybe<Scalars['ID']['output']>;
  /** Current routing cohorts associated with the warehouse */
  routingCohorts: Array<RoutingCohort>;
  spendTiers: Array<WarehouseSpendTier>;
  /**
   * The external delivery providers this warehouse can currently be offered, in
   * registry order. A provider Odeko hands over manually (Metrobi) is always
   * listed. A provider Odeko dispatches by API (Burq) is listed only once it could
   * actually be pushed to: its per-warehouse flag is on, its store id is set, and
   * the warehouse has a phone number a courier can reach. Empty is never expected,
   * since Metrobi is always listed.
   */
  thirdPartyProviders: Array<ThirdPartyProvider>;
  timeZone: Scalars['String']['output'];
  /** Trucks belonging to this warehouse (the per-warehouse roster) */
  trucks: Array<Truck>;
  vendor?: Maybe<Array<Vendor>>;
  /** LDS-owned shift definitions for this warehouse, ordered by start time. */
  warehouseShifts: Array<WarehouseShift>;
  zipcodes?: Maybe<Array<Zipcode>>;
};


export type WarehouseCategoriesArgs = {
  filter?: InputMaybe<CategoriesFilter>;
  forType?: InputMaybe<CategoryType>;
  sortOrder?: InputMaybe<Array<InputMaybe<CategoriesSortOrder>>>;
};


export type WarehouseLastThirdPartyPickupTimeArgs = {
  provider: ThirdPartyProvider;
};


export type WarehouseZipcodesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of WarehouseAssociateBadgeRevoke */
export type WarehouseAssociateBadgeRevokeInput = {
  associateId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of WarehouseAssociateBadgeRevoke. */
export type WarehouseAssociateBadgeRevokePayload = {
  __typename?: 'WarehouseAssociateBadgeRevokePayload';
  associateId?: Maybe<Scalars['ID']['output']>;
  badgeVersion?: Maybe<Scalars['Int']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export enum WarehouseAssociateStatus {
  /** Currently employed. */
  Active = 'ACTIVE',
  /** Disabled in ARMHR. */
  Disabled = 'DISABLED',
  /** No longer active (e.g. terminated). */
  Inactive = 'INACTIVE'
}

export type WarehouseBaseBrandedItem = {
  __typename?: 'WarehouseBaseBrandedItem';
  catalogStatus: BrandedItemCatalogStatus;
  id: Scalars['ID']['output'];
  warehouse: Warehouse;
};

export type WarehouseBaseBrandedItemInput = {
  catalogStatus: BrandedItemCatalogStatus;
  warehouse: Scalars['ID']['input'];
};

/** Interpreted bins for a warehouse, grouped for Layout Builder consumption. */
export type WarehouseBinLayout = {
  __typename?: 'WarehouseBinLayout';
  groups: Array<BinGroup>;
  /** Bins whose names didn't match the grammar, surfaced so coverage gaps stay visible. */
  unrecognized: Array<InterpretedBin>;
  warehouseId: Scalars['ID']['output'];
};

export type WarehouseBinTransferCommand = {
  __typename?: 'WarehouseBinTransferCommand';
  baseUnitQuantity: Scalars['String']['output'];
  confirmedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  destinationBinInternalId: Scalars['String']['output'];
  destinationBinName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  netSuiteInternalId?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  requestedAt: Scalars['ISO8601DateTime']['output'];
  sourceBinName?: Maybe<Scalars['String']['output']>;
  status: BinTransferCommandStatus;
  statusMessage?: Maybe<Scalars['String']['output']>;
  statusReasonCode?: Maybe<Scalars['String']['output']>;
  stockUnitQuantity: Scalars['String']['output'];
};

/** The connection type for SupplyItem. */
export type WarehouseBulkPickedItemsConnection = {
  __typename?: 'WarehouseBulkPickedItemsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SupplyItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SupplyItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of records in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type WarehouseBulkPickedItemsInput = {
  warehouseId: Scalars['ID']['input'];
};

export type WarehouseCategoryMedian = {
  __typename?: 'WarehouseCategoryMedian';
  categoryId: Scalars['ID']['output'];
  categoryName: Scalars['String']['output'];
  /**
   * This category's share of the warehouse's total 90d spend across all locations
   * (0-100). Denominator includes all categorized + uncategorized order lines.
   * Nullable for warehouses where the nightly job has not yet populated the column.
   */
  categorySharePct?: Maybe<Scalars['Float']['output']>;
  computedAt: Scalars['ISO8601DateTime']['output'];
  locationCount: Scalars['Int']['output'];
  medianSpend90dCents: Scalars['Int']['output'];
  warehouseId: Scalars['ID']['output'];
};

/**
 * One commitment-discrepancy order line: NetSuite committed a different quantity
 * than was ordered. The ordered vs committed numbers convey the discrepancy type
 * (under / not / over committed).
 */
export type WarehouseCommitmentDiscrepancyLine = {
  __typename?: 'WarehouseCommitmentDiscrepancyLine';
  /** Units NetSuite committed (order_lines.committed_quantity; null = not yet committed, reported as 0). */
  committedUnits: Scalars['Int']['output'];
  /** The line item's name (nil when the item is unknown). */
  itemName?: Maybe<Scalars['String']['output']>;
  /**
   * The order location's name (nil when the order has no location).
   * @deprecated Use `order.location.businessName`. Kept until the old LWA operation drains from prod.
   */
  locationName?: Maybe<Scalars['String']['output']>;
  /**
   * The line's order, as a federated reference. so-api resolves the human order
   * number, ERP record URL, and location (business name + id) the Commitment
   * drill-down links to.
   */
  order: Order;
  /**
   * The line's order id.
   * @deprecated Use `order.orderNumber` (this is the order id, not the human number). Kept until the old LWA operation drains from prod.
   */
  orderNumber: Scalars['ID']['output'];
  /** Units ordered (order_lines.unit_quantity). */
  orderedUnits: Scalars['Int']['output'];
  /**
   * Name of the route the order is on — the Lobby bucket (or a pickup /
   * third-party bucket) until it's routed onto a driven route. Nil only when the
   * order has no stop at all.
   */
  routeName?: Maybe<Scalars['String']['output']>;
  /**
   * The order's 1-indexed stop position on that route (sequence_number + 1). For a
   * bucket this is a position within the bucket, not a driven-stop sequence. Nil
   * only when the order has no stop at all.
   */
  stopNumber?: Maybe<Scalars['Int']['output']>;
};

/**
 * Flat, offset-paginated list of every commitment-discrepancy order line for a
 * warehouse + delivery date (under-, not-, and over-committed). See
 * Resolvers::WarehouseCommitmentDiscrepancyLines.
 */
export type WarehouseCommitmentDiscrepancyLinesReport = {
  __typename?: 'WarehouseCommitmentDiscrepancyLinesReport';
  /** The current page of discrepancy lines, in a stable order. */
  orderLines: Array<WarehouseCommitmentDiscrepancyLine>;
  /** Total discrepancy lines matching the query, unpaginated — for page counts. */
  totalCount: Scalars['Int']['output'];
};

/** An order NetSuite committed short of what was ordered, aggregated to order grain. */
export type WarehouseCommitmentDiscrepancyOrder = {
  __typename?: 'WarehouseCommitmentDiscrepancyOrder';
  /** Total units NetSuite committed, including any over-commitment (a not-yet-committed line counts as 0). */
  committedUnits: Scalars['Int']['output'];
  /** The order location's name (nil when the order has no location). */
  locationName?: Maybe<Scalars['String']['output']>;
  /** The order's id. */
  orderNumber: Scalars['ID']['output'];
  /** Total units ordered across the order's lines. */
  orderedUnits: Scalars['Int']['output'];
  /**
   * Units committed short, summed from positive per-line deficits. Over-committed
   * and not-yet-committed lines contribute 0, so this is never negative and is not
   * simply orderedUnits - committedUnits.
   */
  shortfall: Scalars['Int']['output'];
};

/**
 * Commitment stage-gate report for a warehouse + delivery date: how many orders
 * were committed short of what was ordered, plus those orders. See
 * Resolvers::WarehouseCommitmentDiscrepancies.
 */
export type WarehouseCommitmentDiscrepancyReport = {
  __typename?: 'WarehouseCommitmentDiscrepancyReport';
  /** Orders with any short-committed line (committed_quantity < ordered). */
  discrepancyCount: Scalars['Int']['output'];
  /** The short-committed orders. */
  orders: Array<WarehouseCommitmentDiscrepancyOrder>;
  /**
   * Non-discrepant orders with a line NetSuite hasn't committed yet (null
   * committed_quantity). Waiting on the Commit Orders run, not short.
   */
  pendingCount: Scalars['Int']['output'];
  /** Total (non-canceled) orders for the warehouse + delivery date. */
  totalOrderCount: Scalars['Int']['output'];
};

/**
 * Ordered-vs-committed unit totals for a warehouse + delivery date. Raw totals
 * only; the clear/needs_review/waiting decision is composed on the frontend.
 */
export type WarehouseCommitmentSummary = {
  __typename?: 'WarehouseCommitmentSummary';
  /**
   * Σ COALESCE(order_lines.committed_quantity, 0). A not-yet-committed line
   * contributes 0 committed units, so post-Sync it reads as a shortfall.
   */
  committedUnits: Scalars['Int']['output'];
  /** Number of (non-canceled) orders in scope, for tile context. */
  orderCount: Scalars['Int']['output'];
  /** Σ order_lines.unit_quantity across the scope. */
  orderedUnits: Scalars['Int']['output'];
};

export type WarehouseDockCapacity = {
  __typename?: 'WarehouseDockCapacity';
  /** Admin minimum the FTL daily ceiling cannot be set below. */
  ftlMinPerDay: Scalars['Int']['output'];
  /** Declared daily FTL truck ceiling; window ftl_max values sum up to this. */
  ftlTrucksPerDay: Scalars['Int']['output'];
  /** Admin minimum the LTL daily ceiling cannot be set below. */
  ltlMinPerDay: Scalars['Int']['output'];
  /** Declared daily LTL truck ceiling; window ltl_max values sum up to this. */
  ltlTrucksPerDay: Scalars['Int']['output'];
};

/**
 * One fulfillment-discrepancy order line: the warehouse fulfilled a different
 * quantity than NetSuite committed. The committed vs fulfilled numbers convey the
 * discrepancy (under / over fulfilled).
 */
export type WarehouseFulfillmentDiscrepancyLine = {
  __typename?: 'WarehouseFulfillmentDiscrepancyLine';
  /** Units NetSuite committed (order_lines.committed_quantity; null = not yet committed, reported as 0). */
  committedUnits: Scalars['Int']['output'];
  /** Units the warehouse fulfilled (order_lines.fulfillment_quantity; null = not yet fulfilled, reported as 0). */
  fulfillmentUnits: Scalars['Int']['output'];
  /** The line item's name (nil when the item is unknown). */
  itemName?: Maybe<Scalars['String']['output']>;
  /**
   * The line's order, as a federated reference. so-api resolves the human order
   * number, ERP record URL, and location (business name + id) the Fulfillment
   * drill-down links to.
   */
  order: Order;
  /** Units ordered (order_lines.unit_quantity). */
  orderedUnits: Scalars['Int']['output'];
  /**
   * Name of the route the order is on — the Lobby bucket (or a pickup /
   * third-party bucket) until it's routed onto a driven route. Nil only when the
   * order has no stop at all.
   */
  routeName?: Maybe<Scalars['String']['output']>;
  /**
   * The order's 1-indexed stop position on that route (sequence_number + 1). For a
   * bucket this is a position within the bucket, not a driven-stop sequence. Nil
   * only when the order has no stop at all.
   */
  stopNumber?: Maybe<Scalars['Int']['output']>;
};

/**
 * Flat, offset-paginated list of every fulfillment-discrepancy order line for a
 * warehouse + delivery date (fulfilled quantity differs from committed). See
 * Resolvers::WarehouseFulfillmentDiscrepancyLines.
 */
export type WarehouseFulfillmentDiscrepancyLinesReport = {
  __typename?: 'WarehouseFulfillmentDiscrepancyLinesReport';
  /** The current page of discrepancy lines, in a stable order. */
  orderLines: Array<WarehouseFulfillmentDiscrepancyLine>;
  /** Total discrepancy lines matching the query, unpaginated — for page counts. */
  totalCount: Scalars['Int']['output'];
};

/**
 * Committed-vs-fulfilled unit totals for a warehouse + delivery date. Raw totals
 * only; the waiting/needs_attention/clear decision is composed on the frontend.
 */
export type WarehouseFulfillmentSummary = {
  __typename?: 'WarehouseFulfillmentSummary';
  /** Σ COALESCE(order_lines.committed_quantity, 0) across the scope. */
  committedUnits: Scalars['Int']['output'];
  /**
   * Σ COALESCE(order_lines.fulfillment_quantity, 0). A not-yet-fulfilled line
   * contributes 0 fulfilled units, so post-fulfillment it reads as a shortfall.
   */
  fulfilledUnits: Scalars['Int']['output'];
  /** Number of (non-canceled) orders in scope, for tile context. */
  orderCount: Scalars['Int']['output'];
};

export type WarehouseItemTask = {
  __typename?: 'WarehouseItemTask';
  /**
   * Total current base-unit balance less submitted moves across this item's source
   * tasks in the selected warehouse and workstreams, regardless of category.
   */
  currentQuantity: Scalars['Float']['output'];
  /** Inventory item shared by every source task in this group. */
  inventoryItem?: Maybe<InventoryItem>;
  item: WarehouseTaskItem;
  lotCount: Scalars['Int']['output'];
  /** Catalog pallet configuration shared by every source task in this group. */
  palletConfiguration?: Maybe<PutawayTaskPalletConfiguration>;
  /** Catalog pallet configuration error shared by every source task in this group. */
  palletConfigurationReview?: Maybe<PutawayTaskConfigurationReview>;
  /** One catalog pallet expressed in purchase, base, and stock units when shared by every source task. */
  palletFootprint?: Maybe<PutawayTaskPalletFootprint>;
  sourceBinCount: Scalars['Int']['output'];
  /** All current source tasks for this item in the selected warehouse and workstreams, regardless of category. */
  tasks: WarehouseTaskConnection;
  unitConfiguration?: Maybe<PutawayTaskUnitConfiguration>;
};


export type WarehouseItemTaskTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for WarehouseItemTask. */
export type WarehouseItemTaskConnection = {
  __typename?: 'WarehouseItemTaskConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WarehouseItemTaskEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<WarehouseItemTask>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of records in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WarehouseItemTaskEdge = {
  __typename?: 'WarehouseItemTaskEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<WarehouseItemTask>;
};

export type WarehouseItemTaskFilterInput = {
  /** Find items with a task resolved to this inventory item ID. */
  inventoryItemId?: InputMaybe<Scalars['ID']['input']>;
  /** Find items with a matching source task without restricting their summaries or child tasks. */
  putawayCategory?: InputMaybe<WarehouseTaskPutawayCategory>;
  /** Find items with a task whose item, lot, source bin, or exposed suggested destination bin contains this text. */
  search?: InputMaybe<Scalars['String']['input']>;
  workstreams?: InputMaybe<Array<WarehouseTaskWorkstream>>;
};

/**
 * Everything the Layout Builder needs for a warehouse in one load: the current
 * interpreted bin catalog and the saved layout draft (if any).
 */
export type WarehouseLayoutBuilder = {
  __typename?: 'WarehouseLayoutBuilder';
  /** Current interpreted bin catalog (sc-65273). Group membership/order is always re-derived here, never stored on the draft. */
  catalog: WarehouseBinLayout;
  /** Saved layout draft, or null when none exists yet (fall back to the deterministic default arrangement). */
  draft?: Maybe<WarehouseLayoutDraft>;
};

/** A warehouse's saved layout draft (epic 65270, sc-65275). One draft per warehouse (MVP). */
export type WarehouseLayoutDraft = {
  __typename?: 'WarehouseLayoutDraft';
  /**
   * Canvas grid width in cells. Null when the draft predates the control bar; the
   * builder falls back to its auto-size / default.
   */
  gridCols?: Maybe<Scalars['Int']['output']>;
  /**
   * Canvas grid height in cells. Null when the draft predates the control bar; the
   * builder falls back to its auto-size / default.
   */
  gridRows?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  placements: Array<WarehouseLayoutPlacement>;
  /** Optimistic-concurrency key. Send this revision back on save; a stale value is rejected. */
  revision: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

/** A placed element in a saved layout draft — a source-backed bin group or a facility shape. */
export type WarehouseLayoutPlacement = {
  __typename?: 'WarehouseLayoutPlacement';
  /** source_group only: bin arrangement. */
  arrangement?: Maybe<LayoutArrangement>;
  /** source_group only: per-bay offsets that nudge individual bays off their computed run cells. */
  bayOffsets?: Maybe<Array<BayOffset>>;
  /** source_group only: bay numbering direction (low_high | high_low). */
  bayOrder?: Maybe<LayoutBayOrder>;
  /** source_group only: blank grid cells between the odd and even lanes (Odd-Even arrangement). */
  columnGap?: Maybe<Scalars['Int']['output']>;
  /** facility only: shape kind. */
  facilityType?: Maybe<FacilityElementType>;
  /** source_group only: interpreted bin family. */
  family?: Maybe<BinFamily>;
  /** source_group only: interpretation key (aisle letter, ABULK, DOCK, ...). */
  groupKey?: Maybe<Scalars['String']['output']>;
  /** facility only: shape height in grid units. */
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  kind: LayoutPlacementKind;
  /** facility only: free text label. */
  label?: Maybe<Scalars['String']['output']>;
  /** Rotation in degrees. */
  orientation: Scalars['Int']['output'];
  /** facility only: shape width in grid units. */
  width?: Maybe<Scalars['Int']['output']>;
  /** Grid x position. */
  x: Scalars['Int']['output'];
  /** Grid y position. */
  y: Scalars['Int']['output'];
};

/** A placement to persist. Provide the source_group fields for a bin group, or the facility fields for a shape. */
export type WarehouseLayoutPlacementInput = {
  arrangement?: InputMaybe<LayoutArrangement>;
  /** Per-bay offsets nudging individual bays off their computed run cells; omitted = none. */
  bayOffsets?: InputMaybe<Array<BayOffsetInput>>;
  /** Bay numbering direction; omitted = low_high. */
  bayOrder?: InputMaybe<LayoutBayOrder>;
  /** Blank grid cells between the odd and even lanes (Odd-Even arrangement); omitted = null (treated as 0). */
  columnGap?: InputMaybe<Scalars['Int']['input']>;
  facilityType?: InputMaybe<FacilityElementType>;
  family?: InputMaybe<BinFamily>;
  /** Interpretation key (aisle letter, ABULK, DOCK, ...). */
  groupKey?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  kind: LayoutPlacementKind;
  label?: InputMaybe<Scalars['String']['input']>;
  /** Rotation in degrees; omitted = 0. */
  orientation?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
  x: Scalars['Int']['input'];
  y: Scalars['Int']['input'];
};

/** A recoverable error from saving a layout draft (e.g. a stale revision the client can retry). */
export type WarehouseLayoutSaveError = {
  __typename?: 'WarehouseLayoutSaveError';
  /** Machine-readable error reason. */
  code: LayoutSaveErrorCode;
  /** Human-readable description of the error. */
  message: Scalars['String']['output'];
};

/** Autogenerated input type of WarehouseLayoutSave */
export type WarehouseLayoutSaveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Canvas grid width in cells. Persisted wholesale with the draft; null clears it. */
  gridCols?: InputMaybe<Scalars['Int']['input']>;
  /** Canvas grid height in cells. Persisted wholesale with the draft; null clears it. */
  gridRows?: InputMaybe<Scalars['Int']['input']>;
  placements: Array<WarehouseLayoutPlacementInput>;
  /** The revision the client loaded (0 when no draft existed). A stale value is rejected. */
  revision: Scalars['Int']['input'];
  warehouseId: Scalars['ID']['input'];
};

/** Autogenerated return type of WarehouseLayoutSave. */
export type WarehouseLayoutSavePayload = {
  __typename?: 'WarehouseLayoutSavePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  draft?: Maybe<WarehouseLayoutDraft>;
  userErrors: Array<WarehouseLayoutSaveError>;
};

export type WarehouseLeadTimeInput = {
  /** lead time for base braned paper, set after proof approved */
  brandedPaperLeadTime: Scalars['Int']['input'];
  /** Warehouse UUID */
  warehouseUuid: Scalars['String']['input'];
};

export type WarehouseNotFound = UserErrorInterface & {
  __typename?: 'WarehouseNotFound';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** Whether/when 'Sync routes' last completed for a warehouse + night_end. */
export type WarehouseRoutesSyncStatus = {
  __typename?: 'WarehouseRoutesSyncStatus';
  /**
   * True when a planner changed stop composition/order after the last sync, so
   * routes need re-syncing. Regresses the Sync card clear -> needs_sync.
   */
  planChangedSinceSync: Scalars['Boolean']['output'];
  /** Last successful sync completion; null if never synced. */
  syncedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type WarehouseShift = {
  __typename?: 'WarehouseShift';
  breaks: Array<WarehouseShiftBreak>;
  /** Warehouse-local wall clock, e.g. "06:00". */
  endTime: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Shift label, e.g. "night_time". */
  shiftType: Scalars['String']['output'];
  /** Warehouse-local wall clock, e.g. "20:00". */
  startTime: Scalars['String']['output'];
};

export type WarehouseShiftBreak = {
  __typename?: 'WarehouseShiftBreak';
  /** Whether the break may be taken while in transit. */
  allowInTransit: Scalars['Boolean']['output'];
  /** Break length in minutes. */
  duration: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type WarehouseShiftBreakInput = {
  /** Whether the break may be taken while in transit; omitted/null = false. */
  allowInTransit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Break length in minutes; must be greater than 0. */
  duration: Scalars['Int']['input'];
  label: Scalars['String']['input'];
};

/** Autogenerated input type of WarehouseShiftCreate */
export type WarehouseShiftCreateInput = {
  breaks?: InputMaybe<Array<WarehouseShiftBreakInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Warehouse-local wall clock, e.g. "06:00". */
  endTime: Scalars['String']['input'];
  shiftType: Scalars['String']['input'];
  /** Warehouse-local wall clock, e.g. "20:00". */
  startTime: Scalars['String']['input'];
  warehouseId: Scalars['ID']['input'];
};

/** Autogenerated return type of WarehouseShiftCreate. */
export type WarehouseShiftCreatePayload = {
  __typename?: 'WarehouseShiftCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userErrors: Array<WarehouseShiftError>;
  warehouseShift?: Maybe<WarehouseShift>;
};

/** Autogenerated input type of WarehouseShiftDelete */
export type WarehouseShiftDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  shiftId: Scalars['ID']['input'];
};

/** Autogenerated return type of WarehouseShiftDelete. */
export type WarehouseShiftDeletePayload = {
  __typename?: 'WarehouseShiftDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedWarehouseShiftId?: Maybe<Scalars['ID']['output']>;
  userErrors: Array<WarehouseShiftError>;
};

/** Warehouse shift possible error types */
export type WarehouseShiftError = InvalidShift | ShiftNotFound | WarehouseNotFound;

/** Autogenerated input type of WarehouseShiftUpdate */
export type WarehouseShiftUpdateInput = {
  /** When given, replaces the full set of breaks. Omit to leave breaks unchanged. */
  breaks?: InputMaybe<Array<WarehouseShiftBreakInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Warehouse-local wall clock, e.g. "06:00". */
  endTime?: InputMaybe<Scalars['String']['input']>;
  shiftId: Scalars['ID']['input'];
  shiftType?: InputMaybe<Scalars['String']['input']>;
  /** Warehouse-local wall clock, e.g. "20:00". */
  startTime?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of WarehouseShiftUpdate. */
export type WarehouseShiftUpdatePayload = {
  __typename?: 'WarehouseShiftUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userErrors: Array<WarehouseShiftError>;
  warehouseShift?: Maybe<WarehouseShift>;
};

/** An active bin an associate scanned as the source of a manual transfer. */
export type WarehouseSourceBin = {
  __typename?: 'WarehouseSourceBin';
  /** The item's lots with usable stock in this bin, earliest expiry first. Empty when the bin holds none of the item. */
  lots: Array<WarehouseSourceBinLot>;
  name: Scalars['String']['output'];
  netsuiteInternalId: Scalars['String']['output'];
};


/** An active bin an associate scanned as the source of a manual transfer. */
export type WarehouseSourceBinLotsArgs = {
  inventoryItemId: Scalars['ID']['input'];
};

/** One lot of an item in a source bin, with a positive balance and an available inventory status. */
export type WarehouseSourceBinLot = {
  __typename?: 'WarehouseSourceBinLot';
  expiration: PutawayExpiration;
  /** Bin inventory balance id for this lot. */
  id: Scalars['ID']['output'];
  inventoryNumber?: Maybe<WarehouseTaskInventoryNumber>;
  /** Balance in the item's stock unit. Null when the item's units can't be resolved. */
  quantityDetails?: Maybe<PutawayTaskQuantityDetails>;
  /** Why quantityDetails is missing. */
  statusReason?: Maybe<WarehouseTaskStatusReason>;
};

export type WarehouseSpendTier = {
  __typename?: 'WarehouseSpendTier';
  minOrderAmountDollars: Scalars['Int']['output'];
  thresholdAmountDollars: Scalars['Int']['output'];
  tierName: Scalars['String']['output'];
};

export type WarehouseSubcategoryThreshold = {
  __typename?: 'WarehouseSubcategoryThreshold';
  computedAt: Scalars['ISO8601DateTime']['output'];
  medianPenetrationPct: Scalars['Float']['output'];
  medianRevenueSharePct: Scalars['Float']['output'];
  warehouseId: Scalars['ID']['output'];
};

export type WarehouseTask = {
  id: Scalars['ID']['output'];
  state: WarehouseTaskState;
  statusReason?: Maybe<WarehouseTaskStatusReason>;
  taskType: WarehouseTaskType;
  workstream: WarehouseTaskWorkstream;
};

export type WarehouseTaskBin = {
  __typename?: 'WarehouseTaskBin';
  name?: Maybe<Scalars['String']['output']>;
  netsuiteInternalId: Scalars['String']['output'];
};

/** The connection type for WarehouseTask. */
export type WarehouseTaskConnection = {
  __typename?: 'WarehouseTaskConnection';
  /**
   * REPLEN only: counts for every cohort, unaffected by the filters, from the same
   * calculation as the list. Empty for other task types.
   */
  cohortCounts: Array<ReplenCohortCount>;
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WarehouseTaskEdge>>>;
  needsReviewCount: Scalars['Int']['output'];
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<WarehouseTask>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /**
   * Pallets of work still to move. REPLEN: whole pallets plus one for any
   * leftover, over actionable tasks only. A task missing pallet info is left out
   * because its pallet size is unknown (its cases can still be worked;
   * ReplenCohortCount.missingInfoCount says how many there are), and a blocked
   * task is counted in needsReviewCount instead.
   */
  remainingPalletCount: Scalars['Int']['output'];
  /** The total count of records in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WarehouseTaskEdge = {
  __typename?: 'WarehouseTaskEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<WarehouseTask>;
};

export type WarehouseTaskFilterInput = {
  /** REPLEN only. Finds the tasks for this inventory item, as resolved from a scanned barcode. */
  inventoryItemId?: InputMaybe<Scalars['ID']['input']>;
  /** PUTAWAY only; ignored for other task types. */
  putawayCategory?: InputMaybe<WarehouseTaskPutawayCategory>;
  /** REPLEN only. Omitted returns every cohort; an empty list returns none. */
  replenCohorts?: InputMaybe<Array<ReplenTaskCohort>>;
  /** REPLEN only. true returns only tasks missing pallet info, false only the others, omitted both. */
  replenMissingInfo?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * REPLEN only. NetSuite pick-zone ids (3 PICK-A, 8 PICK-B, 9 CHILLED, 6 BULK, 14
   * ECOM); a task matches when any of its routed zones is listed. Omitted returns
   * every zone; an empty list returns none.
   */
  replenPickZoneNetsuiteIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * REPLEN only. BLOCKED returns the tasks that need review, ACTIONABLE the ones
   * that can be worked. Omitted returns both; an empty list returns none.
   */
  replenStates?: InputMaybe<Array<WarehouseTaskState>>;
  /**
   * REPLEN only. Finds tasks whose item name or NetSuite id, reserve bin, lot or
   * pick-face bin contains this text, ignoring case. PUTAWAY search is on
   * warehouseItemTasks.
   */
  search?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
  /** REPLEN only. Demand lookahead in days, 3 to 7; defaults to 3 when omitted. */
  windowDays?: InputMaybe<Scalars['Int']['input']>;
  /** PUTAWAY only; ignored for other task types. Replenishment tasks are all AMBIENT. */
  workstreams?: InputMaybe<Array<WarehouseTaskWorkstream>>;
};

export type WarehouseTaskInventoryNumber = {
  __typename?: 'WarehouseTaskInventoryNumber';
  name?: Maybe<Scalars['String']['output']>;
  netsuiteInternalId?: Maybe<Scalars['String']['output']>;
};

export type WarehouseTaskItem = {
  __typename?: 'WarehouseTaskItem';
  displayName?: Maybe<Scalars['String']['output']>;
  netsuiteInternalId: Scalars['String']['output'];
};

export enum WarehouseTaskPutawayCategory {
  Loose = 'LOOSE',
  MissingInfo = 'MISSING_INFO',
  Pallets = 'PALLETS'
}

export enum WarehouseTaskState {
  Actionable = 'ACTIONABLE',
  Blocked = 'BLOCKED'
}

export type WarehouseTaskStatusReason = {
  __typename?: 'WarehouseTaskStatusReason';
  code: WarehouseTaskStatusReasonCode;
  message: Scalars['String']['output'];
};

export enum WarehouseTaskStatusReasonCode {
  CasesPerPalletInvalid = 'CASES_PER_PALLET_INVALID',
  CurrentQuantityMissing = 'CURRENT_QUANTITY_MISSING',
  ExpirationConflict = 'EXPIRATION_CONFLICT',
  InvalidCurrentQuantity = 'INVALID_CURRENT_QUANTITY',
  InvalidReceiptQuantity = 'INVALID_RECEIPT_QUANTITY',
  InvalidStockUnitConversion = 'INVALID_STOCK_UNIT_CONVERSION',
  InventoryItemAmbiguous = 'INVENTORY_ITEM_AMBIGUOUS',
  InventoryItemMissing = 'INVENTORY_ITEM_MISSING',
  InventoryStatusNotAvailable = 'INVENTORY_STATUS_NOT_AVAILABLE',
  ItemUnitConfigurationAmbiguous = 'ITEM_UNIT_CONFIGURATION_AMBIGUOUS',
  ItemUnitConfigurationInvalid = 'ITEM_UNIT_CONFIGURATION_INVALID',
  ItemUnitConfigurationMissing = 'ITEM_UNIT_CONFIGURATION_MISSING',
  NonInventoryItem = 'NON_INVENTORY_ITEM',
  NoEligibleDestination = 'NO_ELIGIBLE_DESTINATION',
  NoReserveStock = 'NO_RESERVE_STOCK',
  PalletConfigurationMissing = 'PALLET_CONFIGURATION_MISSING',
  ReceiptQuantityMissing = 'RECEIPT_QUANTITY_MISSING',
  StockUnitConfigurationMissing = 'STOCK_UNIT_CONFIGURATION_MISSING',
  StockUnitConversionMissing = 'STOCK_UNIT_CONVERSION_MISSING',
  SuggestionsDisabled = 'SUGGESTIONS_DISABLED',
  SuggestionUpdating = 'SUGGESTION_UPDATING'
}

export enum WarehouseTaskType {
  Putaway = 'PUTAWAY',
  Replen = 'REPLEN'
}

export enum WarehouseTaskWorkstream {
  Ambient = 'AMBIENT',
  ChilledFrozen = 'CHILLED_FROZEN'
}

export type WarehouseTopSubcategory = {
  __typename?: 'WarehouseTopSubcategory';
  computedAt: Scalars['ISO8601DateTime']['output'];
  netRevenueCents90d: Scalars['Int']['output'];
  orderingCompanyCount: Scalars['Int']['output'];
  parentCategoryName: Scalars['String']['output'];
  parentCompanyCount: Scalars['Int']['output'];
  parentCompanyPenetrationPct: Scalars['Float']['output'];
  revenueSharePct: Scalars['Float']['output'];
  subcategoryId: Scalars['ID']['output'];
  subcategoryName: Scalars['String']['output'];
  warehouseId: Scalars['ID']['output'];
};

/** Available measurements, not necessarily complete warehouse totals. Display each value with its route coverage. */
export type WarehouseTrendAvailableMetrics = {
  __typename?: 'WarehouseTrendAvailableMetrics';
  coverage: WarehouseTrendCoverage;
  /** DPRH for only routes with known positive hours; null when no routes qualify. */
  dprh?: Maybe<Scalars['Float']['output']>;
  /** Delivery count from exactly the routes contributing dprhDriverHours; zero when no routes qualify. */
  dprhDeliveries: Scalars['Int']['output'];
  /** Unrounded positive hours paired with dprhDeliveries. Sum this pair across dates for weighted DPRH. */
  dprhDriverHours?: Maybe<Scalars['Float']['output']>;
  /**
   * Sum of routes with known nonnegative hours. Original and dispatch series use
   * planned times; only actual hours require GPS-backed distance.
   */
  driverHours?: Maybe<Scalars['Float']['output']>;
  /** Sum of routes with known nonnegative distance; null when no routes are measured. */
  miles?: Maybe<Scalars['Float']['output']>;
};

/** Changes between the original Routific plan and final dispatched routes. */
export type WarehouseTrendChanges = {
  __typename?: 'WarehouseTrendChanges';
  /** Routes assessed for breadcrumb coverage; denominator for low_breadcrumb_routes. */
  breadcrumbTrackedRoutes: Scalars['Int']['output'];
  /** Per-route detail for the routes counted in low_breadcrumb_routes. */
  lowBreadcrumbRouteDetails: Array<WarehouseTrendLowBreadcrumbRoute>;
  /** Routes that ran a real workload but recorded almost no GPS trail (phone barely reported breadcrumbs). */
  lowBreadcrumbRoutes: Scalars['Int']['output'];
  recoveryStopsCompleted: Scalars['Int']['output'];
  recoveryStopsTotal: Scalars['Int']['output'];
  routesAdded?: Maybe<Scalars['Int']['output']>;
  routesRemoved?: Maybe<Scalars['Int']['output']>;
  /** Delivered stops completed out of their dispatched sequence order. */
  stopsDeliveredOutOfOrder: Scalars['Int']['output'];
  /** Total stops delivered (completed); denominator for stops_delivered_out_of_order. */
  stopsDeliveredTotal: Scalars['Int']['output'];
  stopsReordered: Scalars['Int']['output'];
  /** Routes added + routes removed + stops reordered; recovery is reported separately. */
  totalChanges?: Maybe<Scalars['Int']['output']>;
};

/**
 * Route coverage for one series on one date. Missing or unstarted routes remain in
 * totalRoutes, never silently treated as measured zeros.
 */
export type WarehouseTrendCoverage = {
  __typename?: 'WarehouseTrendCoverage';
  /** Routes with known positive hours contributing both the DPRH numerator and denominator. */
  dprhRoutes: Scalars['Int']['output'];
  /** Routes contributing known nonnegative hours, including measured zero. */
  driverHoursRoutes: Scalars['Int']['output'];
  /** Routes contributing known nonnegative mileage. */
  milesRoutes: Scalars['Int']['output'];
  /** All routes in this series, including routes without measurements; zero when the series has no routes or baseline. */
  totalRoutes: Scalars['Int']['output'];
};

/** Original-plan, dispatch-plan, and actual metrics for one warehouse delivery date. */
export type WarehouseTrendDay = {
  __typename?: 'WarehouseTrendDay';
  /**
   * Measured execution across regular and recovery routes: driven miles,
   * GPS-backed driver hours, and completed delivery/recovery stops. Miles are null
   * if any route lacks measured distance. Hours require both persisted distance
   * and time for every route to exclude legacy lifecycle fallbacks. This is
   * distinct from actualRoutesSummary's dispatched-stop/lifecycle-time metrics.
   */
  actual: WarehouseTrendMetrics;
  changes: WarehouseTrendChanges;
  date: Scalars['ISO8601Date']['output'];
  dispatchPlan: WarehouseTrendMetrics;
  /**
   * Dispatch routes whose delivery stops are all Metrobi (third-party). Excluded
   * from every route count and rate metric in the other series.
   */
  metrobiRoutes: Scalars['Int']['output'];
  originalRoutificPlan: WarehouseTrendMetrics;
};

/** A route counted in low_breadcrumb_routes: it ran a real workload but recorded almost no GPS trail. */
export type WarehouseTrendLowBreadcrumbRoute = {
  __typename?: 'WarehouseTrendLowBreadcrumbRoute';
  /** Measured driven distance for the route; null when no trail was recorded. */
  drivenDistanceMiles?: Maybe<Scalars['Float']['output']>;
  /** DeliveryRoute id. */
  id: Scalars['ID']['output'];
  /** Dispatched route number. */
  routeNo?: Maybe<Scalars['Int']['output']>;
};

/** One plan or execution series for a warehouse trend day. */
export type WarehouseTrendMetrics = {
  __typename?: 'WarehouseTrendMetrics';
  /** Opt-in measured-route aggregates with coverage. Existing scalar fields remain strict full-series totals. */
  available: WarehouseTrendAvailableMetrics;
  deliveries?: Maybe<Scalars['Int']['output']>;
  /** Deliveries divided by driver hours for this series. */
  dprh?: Maybe<Scalars['Float']['output']>;
  driverHours?: Maybe<Scalars['Float']['output']>;
  miles?: Maybe<Scalars['Float']['output']>;
};

/** Autogenerated input type of WarehouseUpdateClosedDays */
export type WarehouseUpdateClosedDaysInput = {
  /** Weekdays closed for booking (Ruby wday: 0=Sunday..6=Saturday). Replaces the full set. */
  blockedWeekdays: Array<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  warehouseId: Scalars['ID']['input'];
};

/** Autogenerated return type of WarehouseUpdateClosedDays. */
export type WarehouseUpdateClosedDaysPayload = {
  __typename?: 'WarehouseUpdateClosedDaysPayload';
  blockedWeekdays?: Maybe<Array<Scalars['Int']['output']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userErrors: Array<DockBookingError>;
};

/** Autogenerated input type of WarehouseUpdateDailyCapacity */
export type WarehouseUpdateDailyCapacityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Declared daily FTL truck ceiling. */
  ftlTrucksPerDay: Scalars['Int']['input'];
  /** Declared daily LTL truck ceiling. */
  ltlTrucksPerDay: Scalars['Int']['input'];
  warehouseId: Scalars['ID']['input'];
};

/** Autogenerated return type of WarehouseUpdateDailyCapacity. */
export type WarehouseUpdateDailyCapacityPayload = {
  __typename?: 'WarehouseUpdateDailyCapacityPayload';
  capacity?: Maybe<WarehouseDockCapacity>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userErrors: Array<DockBookingError>;
};

export type WithinLeadTime = UserErrorInterface & {
  __typename?: 'WithinLeadTime';
  errorCode: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type WorkThread = {
  __typename?: 'WorkThread';
  agentBranch?: Maybe<Scalars['String']['output']>;
  agentRuns: Array<AgentRun>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  events: Array<WorkThreadEvent>;
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  metadata: Scalars['JSON']['output'];
  repoSlug?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type WorkThreadAgentRunsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type WorkThreadEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkThreadEvent = {
  __typename?: 'WorkThreadEvent';
  agentRunId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  details: Scalars['JSON']['output'];
  eventType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  occurredAt: Scalars['ISO8601DateTime']['output'];
  source: Scalars['String']['output'];
  summary: Scalars['String']['output'];
};

export type Zipcode = {
  __typename?: 'Zipcode';
  active: Scalars['Boolean']['output'];
  deliveryRules?: Maybe<Array<DeliveryRule>>;
  deliveryWindow?: Maybe<ZipcodeDeliveryWindow>;
  id: Scalars['ID']['output'];
  warehouseId?: Maybe<Scalars['ID']['output']>;
  warehouseName?: Maybe<Scalars['String']['output']>;
  zipCode: Scalars['String']['output'];
};

/** A single per-weekday delivery rule to apply to a zipcode */
export type ZipcodeDeliveryRuleInput = {
  /** Delivery rule day, 0-6, 0 is Sunday */
  deliveryDay: Scalars['Int']['input'];
  /** Lead time for delivery in days */
  leadTime: Scalars['Int']['input'];
  /** Deadline for ordering to be submitted in format HH:MM */
  orderDeadline: Scalars['String']['input'];
};

export type ZipcodeDeliveryWindow = {
  __typename?: 'ZipcodeDeliveryWindow';
  /** End time in HH:MM format. */
  endTime: Scalars['String']['output'];
  /** Start time in HH:MM format. */
  startTime: Scalars['String']['output'];
};

/** A delivery window to apply to a zipcode */
export type ZipcodeDeliveryWindowInput = {
  /** End time in the format of HH:MM */
  endTime: Scalars['String']['input'];
  /** Start time in the format of HH:MM */
  startTime: Scalars['String']['input'];
};

export type GetBrandedExtrasQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBrandedExtrasQuery = { __typename?: 'Query', warehouses: Array<{ __typename?: 'Warehouse', id: string, name: string }>, categories: Array<{ __typename?: 'Category', id: string, name: string, position?: number | null, subcategories: Array<{ __typename?: 'Category', id: string, name: string, position?: number | null }> }>, procurementVendors: Array<{ __typename?: 'ProcurementVendor', id: string, name: string }>, units: Array<{ __typename?: 'Unit', id: string, name: string, abbreviation?: string | null, conversionRate: number, unitType: UnitType, baseUnit?: { __typename?: 'Unit', id: string, name: string, conversionRate: number, unitType: UnitType } | null }>, colors: Array<{ __typename?: 'Color', id: string, name: string, hexCode: string, position: number }> };

export type GetBaseBrandedItemQueryVariables = Exact<{
  itemId: Scalars['ID']['input'];
}>;


export type GetBaseBrandedItemQuery = { __typename?: 'Query', baseBrandedItem: { __typename?: 'ExternalBaseBrandedItem', id: string, name: string, imageUrls: Array<string>, description?: string | null, minOrderQty: number, maxOrderQty?: number | null, purchaseMultiple: number, printingMethod: PrintingMethod, deliveryPrice: { __typename?: 'Money', cents: number, currency: Currency }, procurementVendor: { __typename?: 'ProcurementVendor', id: string, name: string }, variants: Array<{ __typename?: 'ExternalBaseBrandedItemVariant', startQuantity: number, endQuantity?: number | null, warehouse: { __typename?: 'Warehouse', id: string }, color?: { __typename?: 'Color', id: string, hexCode: string, name: string, position: number } | null, salesPrice: { __typename?: 'Money', cents: number, currency: Currency }, setupFee: { __typename?: 'Money', cents: number, currency: Currency } }>, salesUnit: { __typename?: 'Unit', id: string, name: string }, category: { __typename?: 'Category', id: string, name: string }, subcategory: { __typename?: 'Category', id: string, name: string }, warehouseBaseBrandedItems: Array<{ __typename?: 'WarehouseBaseBrandedItem', id: string, catalogStatus: BrandedItemCatalogStatus, warehouse: { __typename?: 'Warehouse', id: string } }>, baseBrandedItemColors: Array<{ __typename?: 'BaseBrandedItemColor', centsPerSaleUnit?: number | null, color: { __typename?: 'Color', id: string, hexCode: string, name: string, position: number } }>, baseBrandedItemQuantityRanges: Array<{ __typename?: 'BaseBrandedItemQuantityRange', startQuantity: number, endQuantity?: number | null }> } | { __typename?: 'InHouseBaseBrandedItem', id: string, name: string, imageUrls: Array<string>, description?: string | null, minOrderQty: number, maxOrderQty?: number | null, purchaseMultiple: number, printingMethod: PrintingMethod, supplyItem: { __typename?: 'InventoryItem', id: string, name: string, imgUrl?: string | null } | { __typename?: 'NonInventoryItem', id: string, name: string, imgUrl?: string | null }, variants: Array<{ __typename?: 'InHouseBaseBrandedItemVariant', warehouse: { __typename?: 'Warehouse', id: string }, salesPrice: { __typename?: 'Money', cents: number, currency: Currency } }>, salesUnit: { __typename?: 'Unit', id: string, name: string }, category: { __typename?: 'Category', id: string, name: string }, subcategory: { __typename?: 'Category', id: string, name: string }, warehouseBaseBrandedItems: Array<{ __typename?: 'WarehouseBaseBrandedItem', id: string, catalogStatus: BrandedItemCatalogStatus, warehouse: { __typename?: 'Warehouse', id: string } }>, baseBrandedItemColors: Array<{ __typename?: 'BaseBrandedItemColor', centsPerSaleUnit?: number | null, color: { __typename?: 'Color', id: string, hexCode: string, name: string, position: number } }>, baseBrandedItemQuantityRanges: Array<{ __typename?: 'BaseBrandedItemQuantityRange', startQuantity: number, endQuantity?: number | null }> } };

export type GetBaseBrandedItemCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBaseBrandedItemCategoriesQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', id: string, name: string, position?: number | null, parentCategory?: { __typename?: 'Category', id: string } | null, subcategories: Array<{ __typename?: 'Category', id: string, name: string, position?: number | null }> }> };

export type GetBaseBrandedItemsQueryVariables = Exact<{
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<Scalars['ID']['input']>;
  subcategory?: InputMaybe<Scalars['ID']['input']>;
  printingMethod?: InputMaybe<PrintingMethod>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBaseBrandedItemsQuery = { __typename?: 'Query', baseBrandedItems: Array<{ __typename?: 'ExternalBaseBrandedItem', id: string, name: string, imageUrls: Array<string>, printingMethod: PrintingMethod, salesUnit: { __typename?: 'Unit', id: string, name: string }, category: { __typename?: 'Category', id: string, name: string }, subcategory: { __typename?: 'Category', id: string, name: string } } | { __typename?: 'InHouseBaseBrandedItem', id: string, name: string, imageUrls: Array<string>, printingMethod: PrintingMethod, salesUnit: { __typename?: 'Unit', id: string, name: string }, category: { __typename?: 'Category', id: string, name: string }, subcategory: { __typename?: 'Category', id: string, name: string } }> };

export type CreateInHouseBaseBrandedItemMutationVariables = Exact<{
  input: CreateInHouseBaseBrandedItemMutationInput;
}>;


export type CreateInHouseBaseBrandedItemMutation = { __typename?: 'Mutation', createInHouseBaseBrandedItem?: { __typename?: 'CreateInHouseBaseBrandedItemMutationPayload', baseBrandedItem?: { __typename?: 'ExternalBaseBrandedItem', id: string, name: string } | { __typename?: 'InHouseBaseBrandedItem', id: string, name: string } | null, errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type CreateExternalBaseBrandedItemMutationVariables = Exact<{
  input: CreateExternalBaseBrandedItemMutationInput;
}>;


export type CreateExternalBaseBrandedItemMutation = { __typename?: 'Mutation', createExternalBaseBrandedItem?: { __typename?: 'CreateExternalBaseBrandedItemMutationPayload', baseBrandedItem?: { __typename?: 'ExternalBaseBrandedItem', id: string, name: string } | { __typename?: 'InHouseBaseBrandedItem', id: string, name: string } | null, errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type UpdateInHouseBaseBrandedItemMutationVariables = Exact<{
  input: UpdateInHouseBaseBrandedItemMutationInput;
}>;


export type UpdateInHouseBaseBrandedItemMutation = { __typename?: 'Mutation', updateInHouseBaseBrandedItem?: { __typename?: 'UpdateInHouseBaseBrandedItemMutationPayload', baseBrandedItem?: { __typename?: 'ExternalBaseBrandedItem', id: string, name: string } | { __typename?: 'InHouseBaseBrandedItem', id: string, name: string } | null, errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type UpdateExternalBaseBrandedItemMutationVariables = Exact<{
  input: UpdateExternalBaseBrandedItemMutationInput;
}>;


export type UpdateExternalBaseBrandedItemMutation = { __typename?: 'Mutation', updateExternalBaseBrandedItem?: { __typename?: 'UpdateExternalBaseBrandedItemMutationPayload', baseBrandedItem?: { __typename?: 'ExternalBaseBrandedItem', id: string, name: string } | { __typename?: 'InHouseBaseBrandedItem', id: string, name: string } | null, errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type GetAssociatedSupplyItemsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ItemsFiltersInput>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  itemTypes?: InputMaybe<Array<InputMaybe<ItemType>> | InputMaybe<ItemType>>;
}>;


export type GetAssociatedSupplyItemsQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', availableItems: { __typename?: 'ItemConnection', edges: Array<{ __typename?: 'ItemEdge', cursor: string, node: { __typename?: 'InventoryItem', name: string, id: string, brandName: string, imgUrl?: string | null, updatedAt: Date } | { __typename?: 'NonInventoryItem', name: string, id: string, brandName: string, imgUrl?: string | null, updatedAt: Date } } | null>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } } | null };

export type UpsertMasterHomepageMutationVariables = Exact<{
  input: UpsertMasterHomepageInput;
}>;


export type UpsertMasterHomepageMutation = { __typename?: 'Mutation', upsertMasterHomepage?: { __typename?: 'UpsertMasterHomepagePayload', masterHomepage?: { __typename?: 'MasterHomepageListItem', id: string, name: string, startDate: Date, endDate: Date } | null, errors: Array<{ __typename?: 'MasterHomepageError', field?: string | null, message: string }> } | null };

export type DuplicateMasterHomepageMutationVariables = Exact<{
  input: DuplicateMasterHomepageInput;
}>;


export type DuplicateMasterHomepageMutation = { __typename?: 'Mutation', duplicateMasterHomepage?: { __typename?: 'DuplicateMasterHomepagePayload', masterHomepage?: { __typename?: 'MasterHomepageListItem', id: string, name: string, startDate: Date, endDate: Date } | null, errors: Array<{ __typename?: 'MasterHomepageError', field?: string | null, message: string }> } | null };

export type DeleteMasterHomepageMutationVariables = Exact<{
  input: DeleteMasterHomepageInput;
}>;


export type DeleteMasterHomepageMutation = { __typename?: 'Mutation', deleteMasterHomepage?: { __typename?: 'DeleteMasterHomepagePayload', errors: Array<{ __typename?: 'MasterHomepageError', field?: string | null, message: string }> } | null };

export type SaveMasterHomepageRowsMutationVariables = Exact<{
  input: SaveMasterHomepageRowsInput;
}>;


export type SaveMasterHomepageRowsMutation = { __typename?: 'Mutation', saveMasterHomepageRows?: { __typename?: 'SaveMasterHomepageRowsPayload', errors: Array<{ __typename?: 'MasterHomepageError', field?: string | null, message: string }> } | null };

export type CreateItemBrandMutationVariables = Exact<{
  input: ItemBrandCreateInput;
}>;


export type CreateItemBrandMutation = { __typename?: 'Mutation', createItemBrand?: { __typename?: 'ItemBrandCreatePayload', created: boolean, errors: Array<{ __typename?: 'ItemBrandError', message: string }>, itemBrand?: { __typename?: 'ItemBrand', id: string, name: string } | null } | null };

export type DeleteItemBrandMutationVariables = Exact<{
  input: ItemBrandDeleteInput;
}>;


export type DeleteItemBrandMutation = { __typename?: 'Mutation', deleteItemBrand?: { __typename?: 'ItemBrandDeletePayload', errors: Array<{ __typename?: 'ItemBrandError', message: string }> } | null };

export type UpdateItemBrandMutationVariables = Exact<{
  input: ItemBrandUpdateInput;
}>;


export type UpdateItemBrandMutation = { __typename?: 'Mutation', updateItemBrand?: { __typename?: 'ItemBrandUpdatePayload', errors: Array<{ __typename?: 'ItemBrandError', message: string }>, itemBrand?: { __typename?: 'ItemBrand', id: string, name: string } | null } | null };

export type CreateInventoryItemMutationVariables = Exact<{
  item: InventoryItemInput;
}>;


export type CreateInventoryItemMutation = { __typename?: 'Mutation', createInventoryItem?: { __typename?: 'InventoryItem', id: string, name: string } | { __typename?: 'NonInventoryItem', id: string, name: string } | null };

export type CreateNonInventoryItemMutationVariables = Exact<{
  item: NonInventoryItemInput;
}>;


export type CreateNonInventoryItemMutation = { __typename?: 'Mutation', createNonInventoryItem?: { __typename?: 'InventoryItem', id: string, name: string } | { __typename?: 'NonInventoryItem', id: string, name: string } | null };

export type DiscontinueItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: Array<InputMaybe<DiscontinueWarehouseInput>> | InputMaybe<DiscontinueWarehouseInput>;
}>;


export type DiscontinueItemMutation = { __typename?: 'Mutation', discontinueWarehouseItem?: { __typename?: 'InventoryItem', id: string, name: string } | { __typename?: 'NonInventoryItem', id: string, name: string } | null };

export type SetItemInactiveMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  inactive: Scalars['Boolean']['input'];
}>;


export type SetItemInactiveMutation = { __typename?: 'Mutation', setItemInactive: { __typename?: 'SetItemInactivePayload', item?: { __typename?: 'InventoryItem', id: string, inactivatedOn?: Date | null } | { __typename?: 'NonInventoryItem', id: string, inactivatedOn?: Date | null } | null, errors: Array<{ __typename?: 'SetItemInactiveError', message: string }> } };

export type ImportPriceRulesCsvMutationVariables = Exact<{
  input: ImportPriceRulesCsvInput;
}>;


export type ImportPriceRulesCsvMutation = { __typename?: 'Mutation', importPriceRulesCsv: { __typename?: 'ImportPriceRulesCsvPayload', clientMutationId?: string | null, errors?: Array<string> | null } };

export type ImportProcurementRecordsMutationVariables = Exact<{
  input: Array<ImportProcurementInput> | ImportProcurementInput;
}>;


export type ImportProcurementRecordsMutation = { __typename?: 'Mutation', importProcurementRecords?: boolean | null };

export type UpdateInventoryItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  item: InventoryItemInput;
}>;


export type UpdateInventoryItemMutation = { __typename?: 'Mutation', updateInventoryItem?: { __typename?: 'InventoryItem', id: string, name: string, imgUrl?: string | null } | { __typename?: 'NonInventoryItem', id: string, name: string, imgUrl?: string | null } | null };

export type UpdateNonInventoryItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  item: NonInventoryItemInput;
}>;


export type UpdateNonInventoryItemMutation = { __typename?: 'Mutation', updateNonInventoryItem?: { __typename?: 'InventoryItem', id: string, name: string, imgUrl?: string | null } | { __typename?: 'NonInventoryItem', id: string, name: string, imgUrl?: string | null } | null };

export type UpsertLocationItemMutationVariables = Exact<{
  input: LocationItemInput;
}>;


export type UpsertLocationItemMutation = { __typename?: 'Mutation', upsertLocationItem?: { __typename?: 'LocationItem', locationId: string, itemId: string } | null };

export type RemoveLocationItemMutationVariables = Exact<{
  input: LocationItemInput;
}>;


export type RemoveLocationItemMutation = { __typename?: 'Mutation', removeLocationItem?: boolean | null };

export type UpdateItemPricesMutationVariables = Exact<{
  input: UpdateItemPricesInput;
}>;


export type UpdateItemPricesMutation = { __typename?: 'Mutation', updateItemPrices: { __typename?: 'UpdateItemPricesPayload', result?: { __typename?: 'ErrorsResult', errors: { __typename?: 'Errors', head: { __typename?: 'AmbiguousCartItemUpdates', message: string } | { __typename?: 'BadPaymentProcessorRequestError', message: string } | { __typename?: 'CartCheckoutInFlightError', message: string } | { __typename?: 'CartItemModifierGroupNotFound', message: string } | { __typename?: 'CartItemModifierOptionNotFound', message: string } | { __typename?: 'CartItemNotAdded', message: string } | { __typename?: 'CartItemNotAvailable', message: string } | { __typename?: 'CartItemNotUpdated', message: string } | { __typename?: 'CartItemSizeNotFound', message: string } | { __typename?: 'CartMenuItemNotFound', message: string } | { __typename?: 'CartMerchantMismatchError', message: string } | { __typename?: 'CartNotSaved', message: string } | { __typename?: 'CartPickupUnavailableError', message: string } | { __typename?: 'ConsumerAppReferralInvalid', message: string } | { __typename?: 'ConsumerAppReferralLinkInvalid', message: string } | { __typename?: 'ConsumerAppReferralLinkNotFound', message: string } | { __typename?: 'ConsumerAppReferralLinkNotSaved', message: string } | { __typename?: 'ConsumerAppReferralNotSaved', message: string } | { __typename?: 'ConsumerAppUserInvalid', message: string } | { __typename?: 'ConsumerAppUserNotSaved', message: string } | { __typename?: 'ConsumerOrderAlreadyRefunded', message: string } | { __typename?: 'CreditKeyAccountNotFound', message: string } | { __typename?: 'CreditKeyAccountNotUsable', message: string } | { __typename?: 'CurbsidePickupNotEnabled', message: string } | { __typename?: 'DeliveryDateUnavailableError', message: string } | { __typename?: 'DeliveryInstructionsMissingError', message: string } | { __typename?: 'DeliveryPriceError', message: string } | { __typename?: 'DuplicateInputError', message: string } | { __typename?: 'EmailAlreadyTaken', message: string } | { __typename?: 'EmptyCartError', message: string } | { __typename?: 'ErrorUpdatingItemPrices', message: string } | { __typename?: 'InvalidCartInputError', message: string } | { __typename?: 'LocationOrderingIneligibleError', message: string } | { __typename?: 'LocationOrderingNotEnabledError', message: string } | { __typename?: 'MerchantClosureError', message: string } | { __typename?: 'MerchantNotActive', message: string } | { __typename?: 'ModifierBoundsViolation', message: string } | { __typename?: 'MustRecalculateCartPrices', message: string } | { __typename?: 'NotEnoughNotice', message: string } | { __typename?: 'NothingToRefund', message: string } | { __typename?: 'ObjectFromOutsideCollection', message: string } | { __typename?: 'ObjectNotFound', message: string } | { __typename?: 'ObjectNotSaved', message: string } | { __typename?: 'ObjectOmittedFromCollection', message: string } | { __typename?: 'OrderNotCancellableError', message: string } | { __typename?: 'OrderNotFree', message: string } | { __typename?: 'OrderingNotPermittedError', message: string } | { __typename?: 'OrderingSavedItemsOnlyError', message: string } | { __typename?: 'PaymentMethodMismatchError', message: string } | { __typename?: 'PaymentMethodMissingError', message: string } | { __typename?: 'PaymentProcessorGenericError', message: string } | { __typename?: 'PaymentSettingsMissingError', message: string } | { __typename?: 'PhoneNumberAlreadyTaken', message: string } | { __typename?: 'PhoneNumberNotFormatted', message: string } | { __typename?: 'PhoneNumberNotVerified', message: string } | { __typename?: 'PhoneNumberVerificationNotStarted', message: string } | { __typename?: 'PriceCorrection', message: string } | { __typename?: 'RefundingTooManyItems', message: string } | { __typename?: 'RefundingTooManyModifiers', message: string } | { __typename?: 'RewardAlreadyClaimed', message: string } | { __typename?: 'RewardAlreadyUsed', message: string } | { __typename?: 'RewardCodeNotFound', message: string } | { __typename?: 'RewardNotApplicable', message: string } | { __typename?: 'ScheduledTooFarOut', message: string } | { __typename?: 'StaleCartError', message: string } | { __typename?: 'StaleConsumerRefundInfoError', message: string } | { __typename?: 'StaleObjectError', message: string } | { __typename?: 'StandardError', message: string } | { __typename?: 'TipsNotEnabled', message: string } | { __typename?: 'TransientPaymentProcessorError', message: string } | { __typename?: 'UnauthorizedError', message: string } | { __typename?: 'UserError', message: string } | { __typename?: 'WalletBalanceInsufficient', message: string } | { __typename?: 'WalletSquareUserIdBlank', message: string }, tail: Array<{ __typename?: 'AmbiguousCartItemUpdates', message: string } | { __typename?: 'BadPaymentProcessorRequestError', message: string } | { __typename?: 'CartCheckoutInFlightError', message: string } | { __typename?: 'CartItemModifierGroupNotFound', message: string } | { __typename?: 'CartItemModifierOptionNotFound', message: string } | { __typename?: 'CartItemNotAdded', message: string } | { __typename?: 'CartItemNotAvailable', message: string } | { __typename?: 'CartItemNotUpdated', message: string } | { __typename?: 'CartItemSizeNotFound', message: string } | { __typename?: 'CartMenuItemNotFound', message: string } | { __typename?: 'CartMerchantMismatchError', message: string } | { __typename?: 'CartNotSaved', message: string } | { __typename?: 'CartPickupUnavailableError', message: string } | { __typename?: 'ConsumerAppReferralInvalid', message: string } | { __typename?: 'ConsumerAppReferralLinkInvalid', message: string } | { __typename?: 'ConsumerAppReferralLinkNotFound', message: string } | { __typename?: 'ConsumerAppReferralLinkNotSaved', message: string } | { __typename?: 'ConsumerAppReferralNotSaved', message: string } | { __typename?: 'ConsumerAppUserInvalid', message: string } | { __typename?: 'ConsumerAppUserNotSaved', message: string } | { __typename?: 'ConsumerOrderAlreadyRefunded', message: string } | { __typename?: 'CreditKeyAccountNotFound', message: string } | { __typename?: 'CreditKeyAccountNotUsable', message: string } | { __typename?: 'CurbsidePickupNotEnabled', message: string } | { __typename?: 'DeliveryDateUnavailableError', message: string } | { __typename?: 'DeliveryInstructionsMissingError', message: string } | { __typename?: 'DeliveryPriceError', message: string } | { __typename?: 'DuplicateInputError', message: string } | { __typename?: 'EmailAlreadyTaken', message: string } | { __typename?: 'EmptyCartError', message: string } | { __typename?: 'ErrorUpdatingItemPrices', message: string } | { __typename?: 'InvalidCartInputError', message: string } | { __typename?: 'LocationOrderingIneligibleError', message: string } | { __typename?: 'LocationOrderingNotEnabledError', message: string } | { __typename?: 'MerchantClosureError', message: string } | { __typename?: 'MerchantNotActive', message: string } | { __typename?: 'ModifierBoundsViolation', message: string } | { __typename?: 'MustRecalculateCartPrices', message: string } | { __typename?: 'NotEnoughNotice', message: string } | { __typename?: 'NothingToRefund', message: string } | { __typename?: 'ObjectFromOutsideCollection', message: string } | { __typename?: 'ObjectNotFound', message: string } | { __typename?: 'ObjectNotSaved', message: string } | { __typename?: 'ObjectOmittedFromCollection', message: string } | { __typename?: 'OrderNotCancellableError', message: string } | { __typename?: 'OrderNotFree', message: string } | { __typename?: 'OrderingNotPermittedError', message: string } | { __typename?: 'OrderingSavedItemsOnlyError', message: string } | { __typename?: 'PaymentMethodMismatchError', message: string } | { __typename?: 'PaymentMethodMissingError', message: string } | { __typename?: 'PaymentProcessorGenericError', message: string } | { __typename?: 'PaymentSettingsMissingError', message: string } | { __typename?: 'PhoneNumberAlreadyTaken', message: string } | { __typename?: 'PhoneNumberNotFormatted', message: string } | { __typename?: 'PhoneNumberNotVerified', message: string } | { __typename?: 'PhoneNumberVerificationNotStarted', message: string } | { __typename?: 'PriceCorrection', message: string } | { __typename?: 'RefundingTooManyItems', message: string } | { __typename?: 'RefundingTooManyModifiers', message: string } | { __typename?: 'RewardAlreadyClaimed', message: string } | { __typename?: 'RewardAlreadyUsed', message: string } | { __typename?: 'RewardCodeNotFound', message: string } | { __typename?: 'RewardNotApplicable', message: string } | { __typename?: 'ScheduledTooFarOut', message: string } | { __typename?: 'StaleCartError', message: string } | { __typename?: 'StaleConsumerRefundInfoError', message: string } | { __typename?: 'StaleObjectError', message: string } | { __typename?: 'StandardError', message: string } | { __typename?: 'TipsNotEnabled', message: string } | { __typename?: 'TransientPaymentProcessorError', message: string } | { __typename?: 'UnauthorizedError', message: string } | { __typename?: 'UserError', message: string } | { __typename?: 'WalletBalanceInsufficient', message: string } | { __typename?: 'WalletSquareUserIdBlank', message: string }> } } | { __typename?: 'ItemPricesSuccess', updatedItemsCount: number, updatedWarehouseItemsCount: number } | null } };

export type UpdateWarehousesLeadTimeMutationVariables = Exact<{
  input: UpdateWarehousesLeadTimeMutationInput;
}>;


export type UpdateWarehousesLeadTimeMutation = { __typename?: 'Mutation', updateWarehousesLeadTime?: { __typename?: 'UpdateWarehousesLeadTimeMutationPayload', clientMutationId?: string | null } | null };

export type GenerateItemDescriptionMutationVariables = Exact<{
  input: GenerateItemDescriptionInput;
}>;


export type GenerateItemDescriptionMutation = { __typename?: 'Mutation', generateItemDescription: { __typename?: 'GenerateItemDescriptionResult', success: boolean, description?: string | null, message?: string | null } };

export type TransformProductImageMutationVariables = Exact<{
  input: TransformProductImageInput;
}>;


export type TransformProductImageMutation = { __typename?: 'Mutation', transformProductImage: { __typename?: 'TransformProductImageResult', success: boolean, transformedUrl?: string | null, message?: string | null } };

export type CreateHomepageComponentMutationVariables = Exact<{
  input: CreateHomepageComponentInput;
}>;


export type CreateHomepageComponentMutation = { __typename?: 'Mutation', createHomepageComponent?: { __typename?: 'CreateHomepageComponentPayload', componentId?: string | null, componentType?: HomepageCollectionComponentType | null, ruleId?: string | null, errors: Array<{ __typename?: 'HomepageComponentError', message: string, field?: string | null, code?: string | null }> } | null };

export type DeleteMasterHomepageRowComponentMutationVariables = Exact<{
  input: DeleteMasterHomepageRowComponentInput;
}>;


export type DeleteMasterHomepageRowComponentMutation = { __typename?: 'Mutation', deleteMasterHomepageRowComponent?: { __typename?: 'DeleteMasterHomepageRowComponentPayload', errors: Array<{ __typename?: 'MasterHomepageError', field?: string | null, message: string }> } | null };

export type CreateHomepageDisplayRuleMutationVariables = Exact<{
  input: CreateHomepageDisplayRuleInput;
}>;


export type CreateHomepageDisplayRuleMutation = { __typename?: 'Mutation', createHomepageDisplayRule?: { __typename?: 'CreateHomepageDisplayRulePayload', ruleId?: string | null, errors: Array<{ __typename?: 'HomepageDisplayRuleError', message: string, field?: string | null, code?: string | null }> } | null };

export type UpdateHomepageDisplayRulesMutationVariables = Exact<{
  input: UpdateHomepageDisplayRulesInput;
}>;


export type UpdateHomepageDisplayRulesMutation = { __typename?: 'Mutation', updateHomepageDisplayRules?: { __typename?: 'UpdateHomepageDisplayRulesPayload', updatedRuleIds: Array<string>, errors: Array<{ __typename?: 'HomepageDisplayRuleError', message: string, field?: string | null, code?: string | null }> } | null };

export type DeleteCollectionPromoSetupMutationVariables = Exact<{
  input: DeleteCollectionPromoSetupInput;
}>;


export type DeleteCollectionPromoSetupMutation = { __typename?: 'Mutation', deleteCollectionPromoSetup?: { __typename?: 'DeleteCollectionPromoSetupPayload', errors: Array<{ __typename?: 'CollectionPromoSetupError', message: string }> } | null };

export type UpsertSubstitutionOverrideMutationVariables = Exact<{
  input: UpsertSubstitutionOverrideInput;
}>;


export type UpsertSubstitutionOverrideMutation = { __typename?: 'Mutation', upsertSubstitutionOverride: { __typename?: 'SubstitutionOverridePayload', override?: { __typename?: 'SubstitutionOverride', id: string } | null, errors: Array<{ __typename?: 'SubstitutionOverrideError', message: string }> } };

export type RemoveSubstitutionOverrideMutationVariables = Exact<{
  input: RemoveSubstitutionOverrideInput;
}>;


export type RemoveSubstitutionOverrideMutation = { __typename?: 'Mutation', removeSubstitutionOverride: { __typename?: 'SubstitutionOverridePayload', override?: { __typename?: 'SubstitutionOverride', id: string } | null, errors: Array<{ __typename?: 'SubstitutionOverrideError', message: string }> } };

export type UpsertCategoryBannerMutationVariables = Exact<{
  input: UpsertCategoryBannerInput;
}>;


export type UpsertCategoryBannerMutation = { __typename?: 'Mutation', upsertCategoryBanner?: { __typename?: 'CategoryBannerPayload', categoryBannerId?: string | null, errors: Array<{ __typename?: 'CategoryBannerError', message: string, field?: string | null, code?: string | null }> } | null };

export type DeleteCategoryBannerMutationVariables = Exact<{
  input: DeleteCategoryBannerInput;
}>;


export type DeleteCategoryBannerMutation = { __typename?: 'Mutation', deleteCategoryBanner?: { __typename?: 'CategoryBannerPayload', categoryBannerId?: string | null, errors: Array<{ __typename?: 'CategoryBannerError', message: string }> } | null };

export type NewItemPinsQueryVariables = Exact<{
  warehouseId: Scalars['ID']['input'];
}>;


export type NewItemPinsQuery = { __typename?: 'Query', newItemPins: Array<{ __typename?: 'NewItemPin', id: string, position: number, subrank: number, sponsored: boolean, isActive: boolean, daysRemainingAsNew?: number | null, item: { __typename?: 'InventoryItem', id: string, name: string, imgUrl?: string | null, brandName: string } | { __typename?: 'NonInventoryItem', id: string, name: string, imgUrl?: string | null, brandName: string } }> };

export type ViewerNewItemsQueryVariables = Exact<{
  warehouseId: Scalars['ID']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<NewItemsFiltersInput>;
  inventoryWarehouseAssociationFilters?: InputMaybe<InventoryWarehouseAssociationFiltersInput>;
  nonInventoryWarehouseAssociationFilters?: InputMaybe<NonInventoryWarehouseAssociationFiltersInput>;
}>;


export type ViewerNewItemsQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', id: string, newItems: { __typename?: 'ItemConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename?: 'ItemEdge', cursor: string, node: { __typename?: 'InventoryItem', id: string, name: string, imgUrl?: string | null, brandName: string, warehouseAssociation?: Array<{ __typename?: 'InventoryWarehouseAssociation', customerFacingOutOfStock: boolean, daysRemainingAsNew?: number | null } | null> | null } | { __typename?: 'NonInventoryItem', id: string, name: string, imgUrl?: string | null, brandName: string, warehouseAssociation?: Array<{ __typename?: 'NonInventoryWarehouseAssociation', customerFacingOutOfStock: boolean, daysRemainingAsNew?: number | null } | null> | null } } | null> } } | null };

export type UpsertNewItemPinMutationVariables = Exact<{
  input: UpsertNewItemPinInput;
}>;


export type UpsertNewItemPinMutation = { __typename?: 'Mutation', upsertNewItemPin: { __typename?: 'NewItemPinPayload', newItemPin?: { __typename?: 'NewItemPin', id: string, position: number, subrank: number, sponsored: boolean, isActive: boolean, daysRemainingAsNew?: number | null, item: { __typename?: 'InventoryItem', id: string, name: string, imgUrl?: string | null, brandName: string } | { __typename?: 'NonInventoryItem', id: string, name: string, imgUrl?: string | null, brandName: string } } | null, errors: Array<{ __typename?: 'NewItemPinError', field?: string | null, message: string }> } };

export type ReorderNewItemPinsMutationVariables = Exact<{
  input: ReorderNewItemPinsInput;
}>;


export type ReorderNewItemPinsMutation = { __typename?: 'Mutation', reorderNewItemPins: { __typename?: 'NewItemPinsPayload', newItemPins: Array<{ __typename?: 'NewItemPin', id: string, position: number, subrank: number, sponsored: boolean, isActive: boolean, daysRemainingAsNew?: number | null, item: { __typename?: 'InventoryItem', id: string, name: string, imgUrl?: string | null, brandName: string } | { __typename?: 'NonInventoryItem', id: string, name: string, imgUrl?: string | null, brandName: string } }>, errors: Array<{ __typename?: 'NewItemPinError', field?: string | null, message: string }> } };

export type RemoveNewItemPinMutationVariables = Exact<{
  input: RemoveNewItemPinInput;
}>;


export type RemoveNewItemPinMutation = { __typename?: 'Mutation', removeNewItemPin: { __typename?: 'NewItemPinPayload', newItemPin?: { __typename?: 'NewItemPin', id: string } | null, errors: Array<{ __typename?: 'NewItemPinError', field?: string | null, message: string }> } };

export type NewItemMarketsForItemQueryVariables = Exact<{
  itemId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
}>;


export type NewItemMarketsForItemQuery = { __typename?: 'Query', newItemMarketsForItem: Array<{ __typename?: 'NewItemMarketEligibility', currentPosition?: number | null, warehouse: { __typename?: 'Warehouse', id: string, name: string }, existingPin?: { __typename?: 'NewItemPin', id: string, item: { __typename?: 'InventoryItem', id: string, name: string } | { __typename?: 'NonInventoryItem', id: string, name: string } } | null }> };

export type PinItemAcrossMarketsMutationVariables = Exact<{
  input: PinItemAcrossMarketsInput;
}>;


export type PinItemAcrossMarketsMutation = { __typename?: 'Mutation', pinItemAcrossMarkets: { __typename?: 'PinItemAcrossMarketsPayload', warehousesPinned: number, warehousesBumped: number, pins: Array<{ __typename?: 'NewItemPin', id: string, position: number, subrank: number, sponsored: boolean, isActive: boolean, daysRemainingAsNew?: number | null, item: { __typename?: 'InventoryItem', id: string, name: string, imgUrl?: string | null, brandName: string } | { __typename?: 'NonInventoryItem', id: string, name: string, imgUrl?: string | null, brandName: string } }>, errors: Array<{ __typename?: 'NewItemPinError', field?: string | null, message: string }> } };

export type GetItemAuditLogExtrasQueryVariables = Exact<{
  itemId: Scalars['ID']['input'];
}>;


export type GetItemAuditLogExtrasQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', id: string, name: string }>, procurementVendors: Array<{ __typename?: 'ProcurementVendor', id: string, name: string }>, units: Array<{ __typename?: 'Unit', id: string, name: string }>, vendors: Array<{ __typename?: 'Vendor', id: string, name: string, legalName: string }>, warehouses: Array<{ __typename?: 'Warehouse', id: string, name: string }>, viewer?: { __typename?: 'User', availableItemById?: { __typename?: 'InventoryItem', substitutionOverrides: Array<{ __typename?: 'SubstitutionOverride', id: string, substituteItem: { __typename?: 'InventoryItem', id: string, name: string } | { __typename?: 'NonInventoryItem', id: string, name: string } }> } | { __typename?: 'NonInventoryItem', substitutionOverrides: Array<{ __typename?: 'SubstitutionOverride', id: string, substituteItem: { __typename?: 'InventoryItem', id: string, name: string } | { __typename?: 'NonInventoryItem', id: string, name: string } }> } | null } | null };

export type GetReadOnlyItemExtrasQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReadOnlyItemExtrasQuery = { __typename?: 'Query', warehouses: Array<{ __typename?: 'Warehouse', id: string, name: string }>, procurementVendors: Array<{ __typename?: 'ProcurementVendor', id: string, name: string }> };

export type GetUpsertItemExtrasQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUpsertItemExtrasQuery = { __typename?: 'Query', warehouses: Array<{ __typename?: 'Warehouse', id: string, name: string }>, categories: Array<{ __typename?: 'Category', id: string, name: string, position?: number | null, subcategories: Array<{ __typename?: 'Category', id: string, name: string, position?: number | null }> }>, procurementVendors: Array<{ __typename?: 'ProcurementVendor', id: string, name: string }>, vendors: Array<{ __typename?: 'Vendor', id: string, name: string, legalName: string, warehouse?: { __typename?: 'Warehouse', name: string } | null }>, units: Array<{ __typename?: 'Unit', id: string, name: string, abbreviation?: string | null, conversionRate: number, unitType: UnitType, baseUnit?: { __typename?: 'Unit', id: string, name: string, conversionRate: number, unitType: UnitType } | null }> };

export type GetItemForEditQueryVariables = Exact<{
  itemId: Scalars['ID']['input'];
  warehouseIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GetItemForEditQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', availableItemById?: { __typename: 'InventoryItem', manufacturedType?: ManufacturedType | null, marketPrice: boolean, perishability?: Perishability | null, upcCodes?: Array<string | null> | null, locationShelfLifeDays?: number | null, shelfLifeDays?: number | null, inventoryCheckBehavior?: InventoryCheckBehavior | null, isSerialized: boolean, sampleUpcCodes?: Array<string | null> | null, id: string, name: string, brandName: string, description?: string | null, catalogStatus: CatalogStatus, inactivatedOn?: Date | null, imgUrl?: string | null, itemSize?: string | null, updatedAt: Date, vendorCode?: string | null, dimensionalFactor?: number | null, eachHeightInches?: number | null, eachLengthInches?: number | null, eachWeightLbs?: number | null, eachWidthInches?: number | null, caseHeightInches?: number | null, caseLengthInches?: number | null, caseWeightLbs?: number | null, caseWidthInches?: number | null, casesPerPallet?: number | null, casesPerLayer?: number | null, layersPerPallet?: number | null, palletWeightLbs?: number | null, dimensioned?: boolean | null, nmfc?: string | null, refrigerationState?: RefrigerationState | null, transitMethod?: TransitMethod | null, hasOwnImage: boolean, standingOrderBehavior: StandingOrderBehavior, maxQuantityPerLocation?: number | null, sampleMaxQuantityPerLocation?: number | null, stockUnit?: { __typename?: 'Unit', id: string, name: string, unitType: UnitType, baseUnit?: { __typename?: 'Unit', name: string, id: string } | null } | null, purchaseUnit: { __typename?: 'Unit', id: string, name: string, unitType: UnitType, baseUnit?: { __typename?: 'Unit', name: string } | null }, procurementRecords: Array<{ __typename?: 'Procurement', procurementVendor: { __typename?: 'ProcurementVendor', id: string }, warehouse: { __typename?: 'Warehouse', id: string }, purchasePrice: { __typename?: 'Money', amount?: Decimal | null } }>, warehouseAssociation?: Array<{ __typename?: 'InventoryWarehouseAssociation', orderability: Orderability, customOrderabilityMessage?: string | null, standingOrderBehavior: StandingOrderBehavior, inventoryCheckBehavior: InventoryCheckBehavior, hasSample?: boolean | null, customerFacingOutOfStock: boolean, outOfStockSince?: Date | null, procurementVendor?: { __typename?: 'ProcurementVendor', id: string } | null, salePrice?: { __typename?: 'Money', cents: number, currency: Currency } | null, warehouse: { __typename?: 'Warehouse', id: string }, sample?: { __typename?: 'InventoryItem', id: string, name: string } | { __typename?: 'NonInventoryItem', id: string, name: string } | null, configuredFulfillmentWarehouses: Array<{ __typename?: 'ConfigureFulfillmentWarehouse', warehouse: { __typename?: 'Warehouse', id: string, name: string } }> } | null> | null, sampleUnit?: { __typename?: 'Unit', name: string, id: string } | null, brand?: { __typename?: 'ItemBrand', id: string, name: string } | null, size?: { __typename?: 'ItemSize', quantity: number, unit: { __typename?: 'Unit', id: string, name: string } } | null, category: { __typename?: 'Category', id: string, name: string }, subcategory?: { __typename?: 'Category', id: string, name: string } | null, tags: Array<{ __typename?: 'ItemTag', badgeUrl?: string | null, displayAs: string, id: string, name: string, parentTag?: { __typename?: 'ItemTag', badgeUrl?: string | null, displayAs: string, id: string, name: string } | null }>, purchasePrice: { __typename?: 'Money', amount?: Decimal | null, cents: number, currency: Currency }, saleUnit: { __typename?: 'Unit', id: string, unitType: UnitType, name: string, conversionRate: number } } | { __typename: 'NonInventoryItem', marketPrice: boolean, markupPercentage?: number | null, minItemsPerOrder?: number | null, purchaseMultiple: number, discontinuedOn?: Date | null, id: string, name: string, brandName: string, description?: string | null, catalogStatus: CatalogStatus, inactivatedOn?: Date | null, imgUrl?: string | null, itemSize?: string | null, updatedAt: Date, vendorCode?: string | null, dimensionalFactor?: number | null, eachHeightInches?: number | null, eachLengthInches?: number | null, eachWeightLbs?: number | null, eachWidthInches?: number | null, caseHeightInches?: number | null, caseLengthInches?: number | null, caseWeightLbs?: number | null, caseWidthInches?: number | null, casesPerPallet?: number | null, casesPerLayer?: number | null, layersPerPallet?: number | null, palletWeightLbs?: number | null, dimensioned?: boolean | null, nmfc?: string | null, refrigerationState?: RefrigerationState | null, transitMethod?: TransitMethod | null, hasOwnImage: boolean, standingOrderBehavior: StandingOrderBehavior, maxQuantityPerLocation?: number | null, sampleMaxQuantityPerLocation?: number | null, warehouseAssociation?: Array<{ __typename?: 'NonInventoryWarehouseAssociation', orderability: Orderability, customOrderabilityMessage?: string | null, standingOrderBehavior: StandingOrderBehavior, hasSample?: boolean | null, customerFacingOutOfStock: boolean, outOfStockSince?: Date | null, vendor?: { __typename?: 'Vendor', id: string } | null, salePrice?: { __typename?: 'Money', cents: number, currency: Currency } | null, warehouse: { __typename?: 'Warehouse', id: string }, sample?: { __typename?: 'InventoryItem', id: string, name: string } | { __typename?: 'NonInventoryItem', id: string, name: string } | null, configuredFulfillmentWarehouses: Array<{ __typename?: 'ConfigureFulfillmentWarehouse', warehouse: { __typename?: 'Warehouse', id: string, name: string } }> } | null> | null, sampleUnit?: { __typename?: 'Unit', name: string, id: string } | null, brand?: { __typename?: 'ItemBrand', id: string, name: string } | null, size?: { __typename?: 'ItemSize', quantity: number, unit: { __typename?: 'Unit', id: string, name: string } } | null, category: { __typename?: 'Category', id: string, name: string }, subcategory?: { __typename?: 'Category', id: string, name: string } | null, tags: Array<{ __typename?: 'ItemTag', badgeUrl?: string | null, displayAs: string, id: string, name: string, parentTag?: { __typename?: 'ItemTag', badgeUrl?: string | null, displayAs: string, id: string, name: string } | null }>, purchasePrice: { __typename?: 'Money', amount?: Decimal | null, cents: number, currency: Currency }, saleUnit: { __typename?: 'Unit', id: string, unitType: UnitType, name: string, conversionRate: number } } | null } | null };

export type GetSignedUploadImageByKeyQueryVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type GetSignedUploadImageByKeyQuery = { __typename?: 'Query', signedUploadImageByKey?: { __typename?: 'UploadItemImageByKey', url: string } | null };

export type GetSignedUploadImageUrlQueryVariables = Exact<{
  extension: Scalars['String']['input'];
}>;


export type GetSignedUploadImageUrlQuery = { __typename?: 'Query', signedUploadImageUrl?: { __typename?: 'UploadItemImage', url: string, key: string } | null };

export type GetCategoriesForWarehouseQueryVariables = Exact<{
  warehouseId: Scalars['ID']['input'];
}>;


export type GetCategoriesForWarehouseQuery = { __typename?: 'Query', warehouse: { __typename?: 'Warehouse', categories: Array<{ __typename?: 'Category', id: string, name: string, position?: number | null, parentCategory?: { __typename?: 'Category', id: string } | null, subcategories: Array<{ __typename?: 'Category', id: string, name: string, position?: number | null }> }> } };

export type GetWarehousesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWarehousesQuery = { __typename?: 'Query', warehouses: Array<{ __typename?: 'Warehouse', id: string, name: string }> };

export type GetWarehouseLocationsQueryVariables = Exact<{
  warehouseId: Scalars['ID']['input'];
}>;


export type GetWarehouseLocationsQuery = { __typename?: 'Query', warehouse: { __typename?: 'Warehouse', locations?: Array<{ __typename?: 'Location', id: string }> | null } };

export type GetWarehousesWithLeadTimeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWarehousesWithLeadTimeQuery = { __typename?: 'Query', warehouses: Array<{ __typename?: 'Warehouse', id: string, name: string, brandedPaperLeadTime?: number | null }> };

export type GetProcurementVendorsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProcurementVendorsQuery = { __typename?: 'Query', procurementVendors: Array<{ __typename?: 'ProcurementVendor', id: string }> };

export type FindItemReadOnlyQueryVariables = Exact<{
  itemId: Scalars['ID']['input'];
  warehouseIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  withDiscardedAtItemTags?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FindItemReadOnlyQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', availableItemById?: { __typename: 'InventoryItem', manufacturedType?: ManufacturedType | null, marketPrice: boolean, perishability?: Perishability | null, upcCodes?: Array<string | null> | null, locationShelfLifeDays?: number | null, shelfLifeDays?: number | null, inventoryCheckBehavior?: InventoryCheckBehavior | null, isSerialized: boolean, sampleUpcCodes?: Array<string | null> | null, erpRecordUrl?: string | null, id: string, name: string, description?: string | null, catalogStatus: CatalogStatus, inactivatedOn?: Date | null, createdAt: Date, createdBy: string, imgUrl?: string | null, updatedAt: Date, vendorCode?: string | null, brandName: string, standingOrderBehavior: StandingOrderBehavior, maxQuantityPerLocation?: number | null, sampleMaxQuantityPerLocation?: number | null, refrigerationState?: RefrigerationState | null, transitMethod?: TransitMethod | null, dimensionalFactor?: number | null, eachHeightInches?: number | null, eachLengthInches?: number | null, eachWeightLbs?: number | null, eachWidthInches?: number | null, caseHeightInches?: number | null, caseLengthInches?: number | null, caseWeightLbs?: number | null, caseWidthInches?: number | null, casesPerLayer?: number | null, casesPerPallet?: number | null, palletWeightLbs?: number | null, dimensioned?: boolean | null, nmfc?: string | null, layersPerPallet?: number | null, itemSize?: string | null, stockUnit?: { __typename?: 'Unit', name: string, unitType: UnitType, baseUnit?: { __typename?: 'Unit', name: string } | null } | null, purchaseUnit: { __typename?: 'Unit', name: string, unitType: UnitType, baseUnit?: { __typename?: 'Unit', name: string } | null }, procurementRecords: Array<{ __typename?: 'Procurement', procurementVendor: { __typename?: 'ProcurementVendor', id: string }, warehouse: { __typename?: 'Warehouse', id: string }, purchasePrice: { __typename?: 'Money', amount?: Decimal | null } }>, warehouseAssociation?: Array<{ __typename?: 'InventoryWarehouseAssociation', hasSample?: boolean | null, orderability: Orderability, standingOrderBehavior: StandingOrderBehavior, inventoryCheckBehavior: InventoryCheckBehavior, customerFacingOutOfStock: boolean, outOfStockSince?: Date | null, procurementVendor?: { __typename?: 'ProcurementVendor', id: string, name: string } | null, salePrice?: { __typename?: 'Money', cents: number, currency: Currency } | null, warehouse: { __typename?: 'Warehouse', id: string, name: string }, sample?: { __typename?: 'InventoryItem', id: string, name: string } | { __typename?: 'NonInventoryItem', id: string, name: string } | null, configuredFulfillmentWarehouses: Array<{ __typename?: 'ConfigureFulfillmentWarehouse', warehouse: { __typename?: 'Warehouse', id: string, name: string } }> } | null> | null, sampleUnit?: { __typename?: 'Unit', name: string, id: string } | null, brand?: { __typename?: 'ItemBrand', id: string, name: string } | null, category: { __typename?: 'Category', name: string }, subcategory?: { __typename?: 'Category', name: string } | null, size?: { __typename?: 'ItemSize', label: string } | null, tags: Array<{ __typename?: 'ItemTag', badgeUrl?: string | null, displayAs: string, id: string, name: string, parentTag?: { __typename?: 'ItemTag', badgeUrl?: string | null, displayAs: string, id: string, name: string, position: number } | null, pivot?: Array<{ __typename?: 'ItemTagPivot', itemId: string, discardedAt?: Date | null }> | null }>, purchasePrice: { __typename?: 'Money', amount?: Decimal | null, cents: number, currency: Currency }, saleUnit: { __typename?: 'Unit', unitType: UnitType, name: string, conversionRate: number } } | { __typename: 'NonInventoryItem', marketPrice: boolean, markupPercentage?: number | null, minItemsPerOrder?: number | null, purchaseMultiple: number, erpRecordUrl?: string | null, id: string, name: string, description?: string | null, catalogStatus: CatalogStatus, inactivatedOn?: Date | null, createdAt: Date, createdBy: string, imgUrl?: string | null, updatedAt: Date, vendorCode?: string | null, brandName: string, standingOrderBehavior: StandingOrderBehavior, maxQuantityPerLocation?: number | null, sampleMaxQuantityPerLocation?: number | null, refrigerationState?: RefrigerationState | null, transitMethod?: TransitMethod | null, dimensionalFactor?: number | null, eachHeightInches?: number | null, eachLengthInches?: number | null, eachWeightLbs?: number | null, eachWidthInches?: number | null, caseHeightInches?: number | null, caseLengthInches?: number | null, caseWeightLbs?: number | null, caseWidthInches?: number | null, casesPerLayer?: number | null, casesPerPallet?: number | null, palletWeightLbs?: number | null, dimensioned?: boolean | null, nmfc?: string | null, layersPerPallet?: number | null, itemSize?: string | null, warehouseAssociation?: Array<{ __typename?: 'NonInventoryWarehouseAssociation', hasSample?: boolean | null, orderability: Orderability, standingOrderBehavior: StandingOrderBehavior, customerFacingOutOfStock: boolean, outOfStockSince?: Date | null, vendor?: { __typename?: 'Vendor', id: string, name: string, legalName: string, warehouse?: { __typename?: 'Warehouse', name: string } | null } | null, salePrice?: { __typename?: 'Money', cents: number, currency: Currency } | null, warehouse: { __typename?: 'Warehouse', id: string, name: string }, sample?: { __typename?: 'InventoryItem', id: string, name: string } | { __typename?: 'NonInventoryItem', id: string, name: string } | null, configuredFulfillmentWarehouses: Array<{ __typename?: 'ConfigureFulfillmentWarehouse', warehouse: { __typename?: 'Warehouse', id: string, name: string } }> } | null> | null, sampleUnit?: { __typename?: 'Unit', name: string, id: string } | null, brand?: { __typename?: 'ItemBrand', id: string, name: string } | null, category: { __typename?: 'Category', name: string }, subcategory?: { __typename?: 'Category', name: string } | null, size?: { __typename?: 'ItemSize', label: string } | null, tags: Array<{ __typename?: 'ItemTag', badgeUrl?: string | null, displayAs: string, id: string, name: string, parentTag?: { __typename?: 'ItemTag', badgeUrl?: string | null, displayAs: string, id: string, name: string, position: number } | null, pivot?: Array<{ __typename?: 'ItemTagPivot', itemId: string, discardedAt?: Date | null }> | null }>, purchasePrice: { __typename?: 'Money', amount?: Decimal | null, cents: number, currency: Currency }, saleUnit: { __typename?: 'Unit', unitType: UnitType, name: string, conversionRate: number } } | null } | null, productInventory: Array<{ __typename?: 'ProductInventory', availableCount?: number | null, warehouse: { __typename?: 'Warehouse', id: string, name: string } }> };

export type IndexTableItemsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ItemsFiltersInput>;
  sortOrder?: InputMaybe<Array<InputMaybe<ItemsSortOrder>> | InputMaybe<ItemsSortOrder>>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
}>;


export type IndexTableItemsQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', availableItems: { __typename?: 'ItemConnection', edges: Array<{ __typename?: 'ItemEdge', cursor: string, node: { __typename?: 'InventoryItem', name: string, id: string, brandName: string, catalogStatus: CatalogStatus, imgUrl?: string | null, updatedAt: Date, brand?: { __typename?: 'ItemBrand', id: string, name: string } | null, category: { __typename?: 'Category', name: string, id: string, position?: number | null }, saleUnit: { __typename?: 'Unit', name: string } } | { __typename?: 'NonInventoryItem', name: string, id: string, brandName: string, catalogStatus: CatalogStatus, imgUrl?: string | null, updatedAt: Date, brand?: { __typename?: 'ItemBrand', id: string, name: string } | null, category: { __typename?: 'Category', name: string, id: string, position?: number | null }, saleUnit: { __typename?: 'Unit', name: string } } } | null>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } } | null };

export type IndexTableBrandsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ItemBrandsFiltersInput>;
  sortOrder?: InputMaybe<Array<InputMaybe<ItemBrandsSortOrder>> | InputMaybe<ItemBrandsSortOrder>>;
}>;


export type IndexTableBrandsQuery = { __typename?: 'Query', itemBrands: { __typename?: 'ItemBrandConnection', edges: Array<{ __typename?: 'ItemBrandEdge', cursor: string, node: { __typename?: 'ItemBrand', name: string, id: string } } | null>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type FindBrandByNameQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ItemBrandsFiltersInput>;
  sortOrder?: InputMaybe<Array<InputMaybe<ItemBrandsSortOrder>> | InputMaybe<ItemBrandsSortOrder>>;
}>;


export type FindBrandByNameQuery = { __typename?: 'Query', itemBrands: { __typename?: 'ItemBrandConnection', edges: Array<{ __typename?: 'ItemBrandEdge', cursor: string, node: { __typename?: 'ItemBrand', name: string, id: string } } | null>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type ItemTagsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ItemTagFiltersInput>;
  sortOrder?: InputMaybe<Array<InputMaybe<ItemTagSortOrder>> | InputMaybe<ItemTagSortOrder>>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
}>;


export type ItemTagsQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', itemTags: { __typename?: 'ItemTagConnection', edges: Array<{ __typename?: 'ItemTagEdge', cursor: string, node: { __typename?: 'ItemTag', id: string, name: string, badgeUrl?: string | null, position: number, displayAs: string, parentTag?: { __typename?: 'ItemTag', id: string, name: string, position: number } | null } } | null>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } } | null };

export type AuditLogsForObjectQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  excludeObjectTypes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  itemId?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  objects?: InputMaybe<Array<InputMaybe<AuditLogObjectInput>> | InputMaybe<AuditLogObjectInput>>;
  sortOrder?: InputMaybe<Array<InputMaybe<AuditLogSortOrder>> | InputMaybe<AuditLogSortOrder>>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}>;


export type AuditLogsForObjectQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', auditLogs: { __typename?: 'AuditLogConnection', edges: Array<{ __typename?: 'AuditLogEdge', cursor: string, node: { __typename?: 'AuditLog', causedBy: AuditLogCausedBy, changeType: AuditLogChangeType, date: Date, field: string, itemId?: string | null, newValue: string, objectId: string, oldValue: string, objectType: string, user?: { __typename?: 'User', email?: string | null, id: string, name?: string | null } | null } } | null>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } } | null };

export type LocationChangeGroupsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  itemId: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LocationChangeGroupsQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', locationChangeGroups: { __typename?: 'LocationChangeGroupConnection', edges: Array<{ __typename?: 'LocationChangeGroupEdge', cursor: string, node: { __typename?: 'LocationChangeGroup', changeType: AuditLogChangeType, endedAt: Date, locationIds: Array<string>, startedAt: Date, user?: { __typename?: 'User', email?: string | null, id: string, name?: string | null } | null } } | null>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } } | null };

export type GetLandedCostForItemQueryVariables = Exact<{
  itemId: Scalars['ID']['input'];
  warehouseIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GetLandedCostForItemQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', availableItemById?: { __typename?: 'InventoryItem', name: string, warehouseAssociation?: Array<{ __typename?: 'InventoryWarehouseAssociation', landedCost?: { __typename?: 'Money', cents: number, currency: Currency } | null } | null> | null, purchasePrice: { __typename?: 'Money', amount?: Decimal | null, cents: number, currency: Currency } } | { __typename?: 'NonInventoryItem', name: string, warehouseAssociation?: Array<{ __typename?: 'NonInventoryWarehouseAssociation', landedCost?: { __typename?: 'Money', cents: number, currency: Currency } | null } | null> | null, purchasePrice: { __typename?: 'Money', amount?: Decimal | null, cents: number, currency: Currency } } | null } | null };

export type GetItemNameByUuidQueryVariables = Exact<{
  itemId: Scalars['ID']['input'];
}>;


export type GetItemNameByUuidQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', availableItemById?: { __typename?: 'InventoryItem', name: string, catalogStatus: CatalogStatus } | { __typename?: 'NonInventoryItem', name: string, catalogStatus: CatalogStatus } | null } | null };

export type LocationQueryVariables = Exact<{
  odekoUuid?: InputMaybe<Scalars['ID']['input']>;
}>;


export type LocationQuery = { __typename?: 'Query', location?: { __typename?: 'Location', businessName: string } | null };

export type LocationItemsByItemIdQueryVariables = Exact<{
  locationItemsByItemId: Scalars['ID']['input'];
}>;


export type LocationItemsByItemIdQuery = { __typename?: 'Query', locationItemsByItemId?: Array<{ __typename?: 'LocationItem', locationId: string } | null> | null };

export type LocationsSearchQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  name: Scalars['String']['input'];
}>;


export type LocationsSearchQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', locations: { __typename?: 'LocationConnection', nodes?: Array<{ __typename?: 'Location', id: string, businessName: string, warehouse: { __typename?: 'Warehouse', id: string, name: string } } | null> | null } } | null };

export type CreateCollectionPromoSetupMutationVariables = Exact<{
  input: CreateCollectionPromoSetupInput;
}>;


export type CreateCollectionPromoSetupMutation = { __typename?: 'Mutation', createCollectionPromoSetup?: { __typename?: 'CreateCollectionPromoSetupPayload', collectionId?: string | null, promoPageId?: string | null, errors: Array<{ __typename?: 'CollectionPromoSetupError', field?: string | null, message: string }> } | null };

export type GetCollectionQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCollectionQuery = { __typename?: 'Query', collection?: { __typename?: 'Collection', id?: string | null, name?: string | null, description?: string | null, promoName?: string | null, slug?: string | null, type?: CollectionType | null, aggregation?: CollectionAggregationType | null, reference?: CollectionReference | null, referenceId?: string | null } | null };

export type GetCollectionItemsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ItemsFiltersInput>;
}>;


export type GetCollectionItemsQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', availableItems: { __typename?: 'ItemConnection', edges: Array<{ __typename?: 'ItemEdge', node: { __typename: 'InventoryItem', id: string, name: string, brandName: string, imgUrl?: string | null, warehouseAssociation?: Array<{ __typename?: 'InventoryWarehouseAssociation', warehouse: { __typename?: 'Warehouse', name: string } } | null> | null } | { __typename: 'NonInventoryItem', id: string, name: string, brandName: string, imgUrl?: string | null, warehouseAssociation?: Array<{ __typename?: 'NonInventoryWarehouseAssociation', warehouse: { __typename?: 'Warehouse', name: string } } | null> | null } } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } | null };

export type GetCollectionSetupForEditQueryVariables = Exact<{
  collectionId: Scalars['ID']['input'];
}>;


export type GetCollectionSetupForEditQuery = { __typename?: 'Query', collectionSetupForEdit?: { __typename?: 'CollectionSetupForEdit', itemIds: Array<string>, collection: { __typename?: 'Collection', id?: string | null, name?: string | null, description?: string | null, promoName?: string | null, slug?: string | null }, promoPageWarehouses: Array<{ __typename?: 'CollectionSetupPromoPageWarehouseAttributes', desktopHeroImage?: string | null, mobileHeroImage?: string | null, warehouse: { __typename?: 'CollectionsHomepageEntryWarehouse', id: string, name: string } }>, homepageComponents: Array<{ __typename?: 'CollectionSetupHomepageComponent', componentId: string, componentType: HomepageCollectionComponentType, warehouseAttributes: Array<{ __typename?: 'CollectionSetupHomepageComponentWarehouseAttributes', desktopImage?: string | null, mobileImage?: string | null, image?: string | null, fontStyle?: string | null, enabled?: boolean | null, warehouse: { __typename?: 'CollectionsHomepageEntryWarehouse', id: string, name: string } }> }>, displayRules: Array<{ __typename?: 'CollectionSetupDisplayRule', ruleId: string, componentId: string, componentType: HomepageCollectionComponentType, position: string, startDate: Date, endDate: Date, warehouseIds: Array<string> }> } | null };

export type GetCatalogHomepageRowsQueryVariables = Exact<{
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
}>;


export type GetCatalogHomepageRowsQuery = { __typename?: 'Query', catalogHomepageRows: Array<{ __typename?: 'CollectionsHomepageRow', position: string, activeNow: Array<{ __typename?: 'CollectionsHomepageEntry', ruleId: string, startDate: Date, endDate: Date, enabledWarehouseCount: number, configuredWarehouseCount: number, warehouseIds: Array<string>, collection: { __typename?: 'Collection', id?: string | null, name?: string | null }, warehouses: Array<{ __typename?: 'CollectionsHomepageEntryWarehouse', id: string, name: string }> }>, scheduled: Array<{ __typename?: 'CollectionsHomepageEntry', ruleId: string, startDate: Date, endDate: Date, enabledWarehouseCount: number, configuredWarehouseCount: number, warehouseIds: Array<string>, collection: { __typename?: 'Collection', id?: string | null, name?: string | null }, warehouses: Array<{ __typename?: 'CollectionsHomepageEntryWarehouse', id: string, name: string }> }> }> };

export type GetPastHomepageCollectionsQueryVariables = Exact<{
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
}>;


export type GetPastHomepageCollectionsQuery = { __typename?: 'Query', pastHomepageCollections: Array<{ __typename?: 'PastHomepageCollectionEntry', ruleId: string, componentType: HomepageCollectionComponentType, startDate: Date, endDate: Date, enabledWarehouseCount: number, configuredWarehouseCount: number, warehouseIds: Array<string>, collection: { __typename?: 'Collection', id?: string | null, name?: string | null }, warehouses: Array<{ __typename?: 'CollectionsHomepageEntryWarehouse', id: string, name: string }> }> };

export type GetMasterHomepagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMasterHomepagesQuery = { __typename?: 'Query', masterHomepages: Array<{ __typename?: 'MasterHomepageListItem', id: string, name: string, startDate: Date, endDate: Date }> };

export type GetMasterHomepageForEditQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetMasterHomepageForEditQuery = { __typename?: 'Query', masterHomepageForEdit?: { __typename?: 'MasterHomepage', id: string, name: string, startDate: Date, endDate: Date, rows: Array<{ __typename?: 'MasterHomepageRow', id: string, sortOrder: number, structureType: MasterHomepageRowStructureType, components: Array<{ __typename?: 'MasterHomepageRowComponent', id: string, catalogComponentId: string, collectionId: string, componentType: MasterHomepageRowStructureType, sortOrder: number, startDate: Date, endDate: Date, warehouseIds: Array<string>, desktopImage?: string | null, mobileImage?: string | null, fontStyle?: string | null, image?: string | null }> }> } | null };

export type GetCollectionsPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCollectionsPageQuery = { __typename?: 'Query', collectionsPage: Array<{ __typename?: 'CollectionsPageEntry', configuredWarehouseCount: number, warehouseIds: Array<string>, collection: { __typename?: 'Collection', id?: string | null, name?: string | null, slug?: string | null }, warehouses: Array<{ __typename?: 'CollectionsHomepageEntryWarehouse', id: string, name: string }> }> };

export type ItemIssuesTableItemsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ItemsFiltersInput>;
  sortOrder?: InputMaybe<Array<InputMaybe<ItemsSortOrder>> | InputMaybe<ItemsSortOrder>>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
}>;


export type ItemIssuesTableItemsQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', availableItems: { __typename?: 'ItemConnection', totalCount: number, edges: Array<{ __typename?: 'ItemEdge', cursor: string, node: { __typename: 'InventoryItem', upcCodes?: Array<string | null> | null, id: string, name: string, description?: string | null, hasOwnImage: boolean, imgUrl?: string | null, updatedAt: Date, warehouseAssociation?: Array<{ __typename?: 'InventoryWarehouseAssociation', warehouse: { __typename?: 'Warehouse', id: string, name: string } } | null> | null, brand?: { __typename?: 'ItemBrand', id: string, name: string } | null, category: { __typename?: 'Category', name: string, id: string } } | { __typename: 'NonInventoryItem', id: string, name: string, description?: string | null, hasOwnImage: boolean, imgUrl?: string | null, updatedAt: Date, warehouseAssociation?: Array<{ __typename?: 'NonInventoryWarehouseAssociation', warehouse: { __typename?: 'Warehouse', id: string, name: string } } | null> | null, brand?: { __typename?: 'ItemBrand', id: string, name: string } | null, category: { __typename?: 'Category', name: string, id: string } } } | null>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } } | null };

export type ItemOosSubstitutesQueryVariables = Exact<{
  itemId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ItemOosSubstitutesQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', availableItemById?: { __typename?: 'InventoryItem', id: string, substitutionPreview: Array<{ __typename?: 'InventoryItem', id: string, name: string, brandName: string, imgUrl?: string | null } | { __typename?: 'NonInventoryItem', id: string, name: string, brandName: string, imgUrl?: string | null }>, substitutionOverrides: Array<{ __typename?: 'SubstitutionOverride', id: string, source: SubstitutionOverrideSource, substituteItem: { __typename?: 'InventoryItem', id: string } | { __typename?: 'NonInventoryItem', id: string } }> } | { __typename?: 'NonInventoryItem', id: string, substitutionPreview: Array<{ __typename?: 'InventoryItem', id: string, name: string, brandName: string, imgUrl?: string | null } | { __typename?: 'NonInventoryItem', id: string, name: string, brandName: string, imgUrl?: string | null }>, substitutionOverrides: Array<{ __typename?: 'SubstitutionOverride', id: string, source: SubstitutionOverrideSource, substituteItem: { __typename?: 'InventoryItem', id: string } | { __typename?: 'NonInventoryItem', id: string } }> } | null } | null };

export type ItemSubstitutesManagementQueryVariables = Exact<{
  itemId: Scalars['ID']['input'];
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ItemSubstitutesManagementQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', availableItemById?: { __typename?: 'InventoryItem', id: string, name: string, substitutionPreview: Array<{ __typename?: 'InventoryItem', id: string, name: string, brandName: string, imgUrl?: string | null } | { __typename?: 'NonInventoryItem', id: string, name: string, brandName: string, imgUrl?: string | null }>, substitutionOverrides: Array<{ __typename?: 'SubstitutionOverride', id: string, priority: number, reason?: string | null, source: SubstitutionOverrideSource, substituteItem: { __typename?: 'InventoryItem', id: string, name: string, brandName: string, imgUrl?: string | null } | { __typename?: 'NonInventoryItem', id: string, name: string, brandName: string, imgUrl?: string | null } }> } | { __typename?: 'NonInventoryItem', id: string, name: string, substitutionPreview: Array<{ __typename?: 'InventoryItem', id: string, name: string, brandName: string, imgUrl?: string | null } | { __typename?: 'NonInventoryItem', id: string, name: string, brandName: string, imgUrl?: string | null }>, substitutionOverrides: Array<{ __typename?: 'SubstitutionOverride', id: string, priority: number, reason?: string | null, source: SubstitutionOverrideSource, substituteItem: { __typename?: 'InventoryItem', id: string, name: string, brandName: string, imgUrl?: string | null } | { __typename?: 'NonInventoryItem', id: string, name: string, brandName: string, imgUrl?: string | null } }> } | null } | null };

export type GetCategoryTreeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCategoryTreeQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', id: string, name: string, position?: number | null, hasBannerDefaultCreative: boolean, activeWarehouses: Array<{ __typename?: 'CollectionsHomepageEntryWarehouse', id: string, name: string }>, bannerWarehouses: Array<{ __typename?: 'CollectionsHomepageEntryWarehouse', id: string, name: string }>, subcategories: Array<{ __typename?: 'Category', id: string, name: string, position?: number | null, hasBannerDefaultCreative: boolean, activeWarehouses: Array<{ __typename?: 'CollectionsHomepageEntryWarehouse', id: string, name: string }>, bannerWarehouses: Array<{ __typename?: 'CollectionsHomepageEntryWarehouse', id: string, name: string }> }> }> };

export type GetCategoryBannerForEditQueryVariables = Exact<{
  categoryId: Scalars['ID']['input'];
}>;


export type GetCategoryBannerForEditQuery = { __typename?: 'Query', categoryBannerForEdit?: { __typename?: 'CategoryBannerForEdit', categoryBannerId?: string | null, category: { __typename?: 'Category', id: string, name: string, activeWarehouses: Array<{ __typename?: 'CollectionsHomepageEntryWarehouse', id: string, name: string }>, subcategories: Array<{ __typename?: 'Category', id: string, name: string }> }, defaultCreative?: { __typename?: 'CategoryBannerDefaultAttributes', desktopImage?: string | null, mobileImage?: string | null, shippingBehavior?: CategoryBannerShippingBehavior | null, shippingDesktopImage?: string | null, shippingMobileImage?: string | null, destinationType?: CategoryBannerDestinationType | null, destinationRef?: string | null } | null, warehouses: Array<{ __typename?: 'CategoryBannerWarehouseAttributes', hidden: boolean, desktopImage?: string | null, mobileImage?: string | null, shippingBehavior?: CategoryBannerShippingBehavior | null, shippingDesktopImage?: string | null, shippingMobileImage?: string | null, destinationType?: CategoryBannerDestinationType | null, destinationRef?: string | null, warehouse: { __typename?: 'CollectionsHomepageEntryWarehouse', id: string, name: string } }> } | null };


export const GetBrandedExtrasDocument = gql`
    query getBrandedExtras {
  warehouses {
    id
    name
  }
  categories(filter: TOP_LEVEL, forType: BRANDED) {
    id
    name
    position
    subcategories {
      id
      name
      position
    }
  }
  procurementVendors {
    id
    name
  }
  units {
    id
    name
    abbreviation
    conversionRate
    baseUnit {
      id
      name
      conversionRate
      unitType
    }
    unitType
  }
  colors {
    id
    name
    hexCode
    position
  }
}
    `;

export function useGetBrandedExtrasQuery(options?: Omit<Urql.UseQueryArgs<GetBrandedExtrasQueryVariables>, 'query'>) {
  return Urql.useQuery<GetBrandedExtrasQuery>({ query: GetBrandedExtrasDocument, ...options });
};
export const GetBaseBrandedItemDocument = gql`
    query getBaseBrandedItem($itemId: ID!) {
  baseBrandedItem(id: $itemId) {
    id
    name
    imageUrls
    description
    minOrderQty
    maxOrderQty
    purchaseMultiple
    printingMethod
    salesUnit {
      id
      name
    }
    category {
      id
      name
    }
    subcategory {
      id
      name
    }
    warehouseBaseBrandedItems {
      id
      warehouse {
        id
      }
      catalogStatus
    }
    baseBrandedItemColors {
      centsPerSaleUnit
      color {
        id
        hexCode
        name
        position
      }
    }
    baseBrandedItemQuantityRanges {
      startQuantity
      endQuantity
    }
    ... on InHouseBaseBrandedItem {
      supplyItem {
        id
        name
        imgUrl
      }
      variants {
        warehouse {
          id
        }
        salesPrice {
          cents
          currency
        }
      }
    }
    ... on ExternalBaseBrandedItem {
      deliveryPrice {
        cents
        currency
      }
      procurementVendor {
        id
        name
      }
      variants {
        warehouse {
          id
        }
        color {
          id
          hexCode
          name
          position
        }
        startQuantity
        endQuantity
        salesPrice {
          cents
          currency
        }
        setupFee {
          cents
          currency
        }
      }
    }
  }
}
    `;

export function useGetBaseBrandedItemQuery(options: Omit<Urql.UseQueryArgs<GetBaseBrandedItemQueryVariables>, 'query'>) {
  return Urql.useQuery<GetBaseBrandedItemQuery>({ query: GetBaseBrandedItemDocument, ...options });
};
export const GetBaseBrandedItemCategoriesDocument = gql`
    query getBaseBrandedItemCategories {
  categories(forType: BRANDED) {
    parentCategory {
      id
    }
    id
    name
    position
    subcategories {
      id
      name
      position
    }
  }
}
    `;

export function useGetBaseBrandedItemCategoriesQuery(options?: Omit<Urql.UseQueryArgs<GetBaseBrandedItemCategoriesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetBaseBrandedItemCategoriesQuery>({ query: GetBaseBrandedItemCategoriesDocument, ...options });
};
export const GetBaseBrandedItemsDocument = gql`
    query getBaseBrandedItems($warehouseId: ID, $category: ID, $subcategory: ID, $printingMethod: PrintingMethod, $searchQuery: String) {
  baseBrandedItems(
    warehouseId: $warehouseId
    category: $category
    subcategory: $subcategory
    printingMethod: $printingMethod
    searchQuery: $searchQuery
  ) {
    id
    name
    imageUrls
    salesUnit {
      id
      name
    }
    category {
      id
      name
    }
    subcategory {
      id
      name
    }
    printingMethod
  }
}
    `;

export function useGetBaseBrandedItemsQuery(options?: Omit<Urql.UseQueryArgs<GetBaseBrandedItemsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetBaseBrandedItemsQuery>({ query: GetBaseBrandedItemsDocument, ...options });
};
export const CreateInHouseBaseBrandedItemDocument = gql`
    mutation CreateInHouseBaseBrandedItem($input: CreateInHouseBaseBrandedItemMutationInput!) {
  createInHouseBaseBrandedItem(input: $input) {
    baseBrandedItem {
      id
      name
    }
    errors {
      message
      path
    }
  }
}
    `;

export function useCreateInHouseBaseBrandedItemMutation() {
  return Urql.useMutation<CreateInHouseBaseBrandedItemMutation, CreateInHouseBaseBrandedItemMutationVariables>(CreateInHouseBaseBrandedItemDocument);
};
export const CreateExternalBaseBrandedItemDocument = gql`
    mutation CreateExternalBaseBrandedItem($input: CreateExternalBaseBrandedItemMutationInput!) {
  createExternalBaseBrandedItem(input: $input) {
    baseBrandedItem {
      id
      name
    }
    errors {
      message
      path
    }
  }
}
    `;

export function useCreateExternalBaseBrandedItemMutation() {
  return Urql.useMutation<CreateExternalBaseBrandedItemMutation, CreateExternalBaseBrandedItemMutationVariables>(CreateExternalBaseBrandedItemDocument);
};
export const UpdateInHouseBaseBrandedItemDocument = gql`
    mutation UpdateInHouseBaseBrandedItem($input: UpdateInHouseBaseBrandedItemMutationInput!) {
  updateInHouseBaseBrandedItem(input: $input) {
    baseBrandedItem {
      id
      name
    }
    errors {
      message
      path
    }
  }
}
    `;

export function useUpdateInHouseBaseBrandedItemMutation() {
  return Urql.useMutation<UpdateInHouseBaseBrandedItemMutation, UpdateInHouseBaseBrandedItemMutationVariables>(UpdateInHouseBaseBrandedItemDocument);
};
export const UpdateExternalBaseBrandedItemDocument = gql`
    mutation UpdateExternalBaseBrandedItem($input: UpdateExternalBaseBrandedItemMutationInput!) {
  updateExternalBaseBrandedItem(input: $input) {
    baseBrandedItem {
      id
      name
    }
    errors {
      message
      path
    }
  }
}
    `;

export function useUpdateExternalBaseBrandedItemMutation() {
  return Urql.useMutation<UpdateExternalBaseBrandedItemMutation, UpdateExternalBaseBrandedItemMutationVariables>(UpdateExternalBaseBrandedItemDocument);
};
export const GetAssociatedSupplyItemsDocument = gql`
    query getAssociatedSupplyItems($first: Int, $after: String, $filters: ItemsFiltersInput, $searchQuery: String, $itemTypes: [ItemType]) {
  viewer {
    availableItems(
      first: $first
      after: $after
      filters: $filters
      searchQuery: $searchQuery
      itemTypes: $itemTypes
    ) {
      edges {
        node {
          name
          id
          brandName
          imgUrl
          updatedAt
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    `;

export function useGetAssociatedSupplyItemsQuery(options?: Omit<Urql.UseQueryArgs<GetAssociatedSupplyItemsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAssociatedSupplyItemsQuery>({ query: GetAssociatedSupplyItemsDocument, ...options });
};
export const UpsertMasterHomepageDocument = gql`
    mutation upsertMasterHomepage($input: UpsertMasterHomepageInput!) {
  upsertMasterHomepage(input: $input) {
    masterHomepage {
      id
      name
      startDate
      endDate
    }
    errors {
      field
      message
    }
  }
}
    `;

export function useUpsertMasterHomepageMutation() {
  return Urql.useMutation<UpsertMasterHomepageMutation, UpsertMasterHomepageMutationVariables>(UpsertMasterHomepageDocument);
};
export const DuplicateMasterHomepageDocument = gql`
    mutation duplicateMasterHomepage($input: DuplicateMasterHomepageInput!) {
  duplicateMasterHomepage(input: $input) {
    masterHomepage {
      id
      name
      startDate
      endDate
    }
    errors {
      field
      message
    }
  }
}
    `;

export function useDuplicateMasterHomepageMutation() {
  return Urql.useMutation<DuplicateMasterHomepageMutation, DuplicateMasterHomepageMutationVariables>(DuplicateMasterHomepageDocument);
};
export const DeleteMasterHomepageDocument = gql`
    mutation deleteMasterHomepage($input: DeleteMasterHomepageInput!) {
  deleteMasterHomepage(input: $input) {
    errors {
      field
      message
    }
  }
}
    `;

export function useDeleteMasterHomepageMutation() {
  return Urql.useMutation<DeleteMasterHomepageMutation, DeleteMasterHomepageMutationVariables>(DeleteMasterHomepageDocument);
};
export const SaveMasterHomepageRowsDocument = gql`
    mutation saveMasterHomepageRows($input: SaveMasterHomepageRowsInput!) {
  saveMasterHomepageRows(input: $input) {
    errors {
      field
      message
    }
  }
}
    `;

export function useSaveMasterHomepageRowsMutation() {
  return Urql.useMutation<SaveMasterHomepageRowsMutation, SaveMasterHomepageRowsMutationVariables>(SaveMasterHomepageRowsDocument);
};
export const CreateItemBrandDocument = gql`
    mutation CreateItemBrand($input: ItemBrandCreateInput!) {
  createItemBrand(input: $input) {
    created
    errors {
      message
    }
    itemBrand {
      id
      name
    }
  }
}
    `;

export function useCreateItemBrandMutation() {
  return Urql.useMutation<CreateItemBrandMutation, CreateItemBrandMutationVariables>(CreateItemBrandDocument);
};
export const DeleteItemBrandDocument = gql`
    mutation DeleteItemBrand($input: ItemBrandDeleteInput!) {
  deleteItemBrand(input: $input) {
    errors {
      message
    }
  }
}
    `;

export function useDeleteItemBrandMutation() {
  return Urql.useMutation<DeleteItemBrandMutation, DeleteItemBrandMutationVariables>(DeleteItemBrandDocument);
};
export const UpdateItemBrandDocument = gql`
    mutation UpdateItemBrand($input: ItemBrandUpdateInput!) {
  updateItemBrand(input: $input) {
    errors {
      message
    }
    itemBrand {
      id
      name
    }
  }
}
    `;

export function useUpdateItemBrandMutation() {
  return Urql.useMutation<UpdateItemBrandMutation, UpdateItemBrandMutationVariables>(UpdateItemBrandDocument);
};
export const CreateInventoryItemDocument = gql`
    mutation CreateInventoryItem($item: InventoryItemInput!) {
  createInventoryItem(item: $item) {
    id
    name
  }
}
    `;

export function useCreateInventoryItemMutation() {
  return Urql.useMutation<CreateInventoryItemMutation, CreateInventoryItemMutationVariables>(CreateInventoryItemDocument);
};
export const CreateNonInventoryItemDocument = gql`
    mutation CreateNonInventoryItem($item: NonInventoryItemInput!) {
  createNonInventoryItem(item: $item) {
    id
    name
  }
}
    `;

export function useCreateNonInventoryItemMutation() {
  return Urql.useMutation<CreateNonInventoryItemMutation, CreateNonInventoryItemMutationVariables>(CreateNonInventoryItemDocument);
};
export const DiscontinueItemDocument = gql`
    mutation DiscontinueItem($id: ID!, $input: [DiscontinueWarehouseInput]!) {
  discontinueWarehouseItem(id: $id, input: $input) {
    id
    name
  }
}
    `;

export function useDiscontinueItemMutation() {
  return Urql.useMutation<DiscontinueItemMutation, DiscontinueItemMutationVariables>(DiscontinueItemDocument);
};
export const SetItemInactiveDocument = gql`
    mutation SetItemInactive($id: ID!, $inactive: Boolean!) {
  setItemInactive(id: $id, inactive: $inactive) {
    item {
      id
      inactivatedOn
    }
    errors {
      message
    }
  }
}
    `;

export function useSetItemInactiveMutation() {
  return Urql.useMutation<SetItemInactiveMutation, SetItemInactiveMutationVariables>(SetItemInactiveDocument);
};
export const ImportPriceRulesCsvDocument = gql`
    mutation ImportPriceRulesCsv($input: ImportPriceRulesCsvInput!) {
  importPriceRulesCsv(input: $input) {
    clientMutationId
    errors
  }
}
    `;

export function useImportPriceRulesCsvMutation() {
  return Urql.useMutation<ImportPriceRulesCsvMutation, ImportPriceRulesCsvMutationVariables>(ImportPriceRulesCsvDocument);
};
export const ImportProcurementRecordsDocument = gql`
    mutation ImportProcurementRecords($input: [ImportProcurementInput!]!) {
  importProcurementRecords(input: $input)
}
    `;

export function useImportProcurementRecordsMutation() {
  return Urql.useMutation<ImportProcurementRecordsMutation, ImportProcurementRecordsMutationVariables>(ImportProcurementRecordsDocument);
};
export const UpdateInventoryItemDocument = gql`
    mutation UpdateInventoryItem($id: ID!, $item: InventoryItemInput!) {
  updateInventoryItem(id: $id, item: $item) {
    id
    name
    imgUrl
  }
}
    `;

export function useUpdateInventoryItemMutation() {
  return Urql.useMutation<UpdateInventoryItemMutation, UpdateInventoryItemMutationVariables>(UpdateInventoryItemDocument);
};
export const UpdateNonInventoryItemDocument = gql`
    mutation UpdateNonInventoryItem($id: ID!, $item: NonInventoryItemInput!) {
  updateNonInventoryItem(id: $id, item: $item) {
    id
    name
    imgUrl
  }
}
    `;

export function useUpdateNonInventoryItemMutation() {
  return Urql.useMutation<UpdateNonInventoryItemMutation, UpdateNonInventoryItemMutationVariables>(UpdateNonInventoryItemDocument);
};
export const UpsertLocationItemDocument = gql`
    mutation UpsertLocationItem($input: LocationItemInput!) {
  upsertLocationItem(input: $input) {
    locationId
    itemId
  }
}
    `;

export function useUpsertLocationItemMutation() {
  return Urql.useMutation<UpsertLocationItemMutation, UpsertLocationItemMutationVariables>(UpsertLocationItemDocument);
};
export const RemoveLocationItemDocument = gql`
    mutation RemoveLocationItem($input: LocationItemInput!) {
  removeLocationItem(input: $input)
}
    `;

export function useRemoveLocationItemMutation() {
  return Urql.useMutation<RemoveLocationItemMutation, RemoveLocationItemMutationVariables>(RemoveLocationItemDocument);
};
export const UpdateItemPricesDocument = gql`
    mutation UpdateItemPrices($input: UpdateItemPricesInput!) {
  updateItemPrices(input: $input) {
    result {
      ... on ItemPricesSuccess {
        updatedItemsCount
        updatedWarehouseItemsCount
      }
      ... on ErrorsResult {
        errors {
          head {
            message
          }
          tail {
            message
          }
        }
      }
    }
  }
}
    `;

export function useUpdateItemPricesMutation() {
  return Urql.useMutation<UpdateItemPricesMutation, UpdateItemPricesMutationVariables>(UpdateItemPricesDocument);
};
export const UpdateWarehousesLeadTimeDocument = gql`
    mutation UpdateWarehousesLeadTime($input: UpdateWarehousesLeadTimeMutationInput!) {
  updateWarehousesLeadTime(input: $input) {
    clientMutationId
  }
}
    `;

export function useUpdateWarehousesLeadTimeMutation() {
  return Urql.useMutation<UpdateWarehousesLeadTimeMutation, UpdateWarehousesLeadTimeMutationVariables>(UpdateWarehousesLeadTimeDocument);
};
export const GenerateItemDescriptionDocument = gql`
    mutation GenerateItemDescription($input: GenerateItemDescriptionInput!) {
  generateItemDescription(input: $input) {
    success
    description
    message
  }
}
    `;

export function useGenerateItemDescriptionMutation() {
  return Urql.useMutation<GenerateItemDescriptionMutation, GenerateItemDescriptionMutationVariables>(GenerateItemDescriptionDocument);
};
export const TransformProductImageDocument = gql`
    mutation TransformProductImage($input: TransformProductImageInput!) {
  transformProductImage(input: $input) {
    success
    transformedUrl
    message
  }
}
    `;

export function useTransformProductImageMutation() {
  return Urql.useMutation<TransformProductImageMutation, TransformProductImageMutationVariables>(TransformProductImageDocument);
};
export const CreateHomepageComponentDocument = gql`
    mutation CreateHomepageComponent($input: CreateHomepageComponentInput!) {
  createHomepageComponent(input: $input) {
    componentId
    componentType
    ruleId
    errors {
      message
      field
      code
    }
  }
}
    `;

export function useCreateHomepageComponentMutation() {
  return Urql.useMutation<CreateHomepageComponentMutation, CreateHomepageComponentMutationVariables>(CreateHomepageComponentDocument);
};
export const DeleteMasterHomepageRowComponentDocument = gql`
    mutation DeleteMasterHomepageRowComponent($input: DeleteMasterHomepageRowComponentInput!) {
  deleteMasterHomepageRowComponent(input: $input) {
    errors {
      field
      message
    }
  }
}
    `;

export function useDeleteMasterHomepageRowComponentMutation() {
  return Urql.useMutation<DeleteMasterHomepageRowComponentMutation, DeleteMasterHomepageRowComponentMutationVariables>(DeleteMasterHomepageRowComponentDocument);
};
export const CreateHomepageDisplayRuleDocument = gql`
    mutation CreateHomepageDisplayRule($input: CreateHomepageDisplayRuleInput!) {
  createHomepageDisplayRule(input: $input) {
    ruleId
    errors {
      message
      field
      code
    }
  }
}
    `;

export function useCreateHomepageDisplayRuleMutation() {
  return Urql.useMutation<CreateHomepageDisplayRuleMutation, CreateHomepageDisplayRuleMutationVariables>(CreateHomepageDisplayRuleDocument);
};
export const UpdateHomepageDisplayRulesDocument = gql`
    mutation UpdateHomepageDisplayRules($input: UpdateHomepageDisplayRulesInput!) {
  updateHomepageDisplayRules(input: $input) {
    updatedRuleIds
    errors {
      message
      field
      code
    }
  }
}
    `;

export function useUpdateHomepageDisplayRulesMutation() {
  return Urql.useMutation<UpdateHomepageDisplayRulesMutation, UpdateHomepageDisplayRulesMutationVariables>(UpdateHomepageDisplayRulesDocument);
};
export const DeleteCollectionPromoSetupDocument = gql`
    mutation DeleteCollectionPromoSetup($input: DeleteCollectionPromoSetupInput!) {
  deleteCollectionPromoSetup(input: $input) {
    errors {
      message
    }
  }
}
    `;

export function useDeleteCollectionPromoSetupMutation() {
  return Urql.useMutation<DeleteCollectionPromoSetupMutation, DeleteCollectionPromoSetupMutationVariables>(DeleteCollectionPromoSetupDocument);
};
export const UpsertSubstitutionOverrideDocument = gql`
    mutation UpsertSubstitutionOverride($input: UpsertSubstitutionOverrideInput!) {
  upsertSubstitutionOverride(input: $input) {
    override {
      id
    }
    errors {
      message
    }
  }
}
    `;

export function useUpsertSubstitutionOverrideMutation() {
  return Urql.useMutation<UpsertSubstitutionOverrideMutation, UpsertSubstitutionOverrideMutationVariables>(UpsertSubstitutionOverrideDocument);
};
export const RemoveSubstitutionOverrideDocument = gql`
    mutation RemoveSubstitutionOverride($input: RemoveSubstitutionOverrideInput!) {
  removeSubstitutionOverride(input: $input) {
    override {
      id
    }
    errors {
      message
    }
  }
}
    `;

export function useRemoveSubstitutionOverrideMutation() {
  return Urql.useMutation<RemoveSubstitutionOverrideMutation, RemoveSubstitutionOverrideMutationVariables>(RemoveSubstitutionOverrideDocument);
};
export const UpsertCategoryBannerDocument = gql`
    mutation UpsertCategoryBanner($input: UpsertCategoryBannerInput!) {
  upsertCategoryBanner(input: $input) {
    categoryBannerId
    errors {
      message
      field
      code
    }
  }
}
    `;

export function useUpsertCategoryBannerMutation() {
  return Urql.useMutation<UpsertCategoryBannerMutation, UpsertCategoryBannerMutationVariables>(UpsertCategoryBannerDocument);
};
export const DeleteCategoryBannerDocument = gql`
    mutation DeleteCategoryBanner($input: DeleteCategoryBannerInput!) {
  deleteCategoryBanner(input: $input) {
    categoryBannerId
    errors {
      message
    }
  }
}
    `;

export function useDeleteCategoryBannerMutation() {
  return Urql.useMutation<DeleteCategoryBannerMutation, DeleteCategoryBannerMutationVariables>(DeleteCategoryBannerDocument);
};
export const NewItemPinsDocument = gql`
    query newItemPins($warehouseId: ID!) {
  newItemPins(warehouseId: $warehouseId) {
    id
    position
    subrank
    sponsored
    isActive
    daysRemainingAsNew
    item {
      id
      name
      imgUrl
      brandName
    }
  }
}
    `;

export function useNewItemPinsQuery(options: Omit<Urql.UseQueryArgs<NewItemPinsQueryVariables>, 'query'>) {
  return Urql.useQuery<NewItemPinsQuery>({ query: NewItemPinsDocument, ...options });
};
export const ViewerNewItemsDocument = gql`
    query viewerNewItems($warehouseId: ID!, $searchQuery: String, $first: Int, $after: String, $filters: NewItemsFiltersInput, $inventoryWarehouseAssociationFilters: InventoryWarehouseAssociationFiltersInput, $nonInventoryWarehouseAssociationFilters: NonInventoryWarehouseAssociationFiltersInput) {
  viewer {
    id
    newItems(
      warehouseId: $warehouseId
      searchQuery: $searchQuery
      first: $first
      after: $after
      filters: $filters
    ) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        cursor
        node {
          id
          name
          imgUrl
          brandName
          ... on InventoryItem {
            warehouseAssociation(filters: $inventoryWarehouseAssociationFilters) {
              customerFacingOutOfStock
              daysRemainingAsNew
            }
          }
          ... on NonInventoryItem {
            warehouseAssociation(filters: $nonInventoryWarehouseAssociationFilters) {
              customerFacingOutOfStock
              daysRemainingAsNew
            }
          }
        }
      }
    }
  }
}
    `;

export function useViewerNewItemsQuery(options: Omit<Urql.UseQueryArgs<ViewerNewItemsQueryVariables>, 'query'>) {
  return Urql.useQuery<ViewerNewItemsQuery>({ query: ViewerNewItemsDocument, ...options });
};
export const UpsertNewItemPinDocument = gql`
    mutation upsertNewItemPin($input: UpsertNewItemPinInput!) {
  upsertNewItemPin(input: $input) {
    newItemPin {
      id
      position
      subrank
      sponsored
      isActive
      daysRemainingAsNew
      item {
        id
        name
        imgUrl
        brandName
      }
    }
    errors {
      field
      message
    }
  }
}
    `;

export function useUpsertNewItemPinMutation() {
  return Urql.useMutation<UpsertNewItemPinMutation, UpsertNewItemPinMutationVariables>(UpsertNewItemPinDocument);
};
export const ReorderNewItemPinsDocument = gql`
    mutation reorderNewItemPins($input: ReorderNewItemPinsInput!) {
  reorderNewItemPins(input: $input) {
    newItemPins {
      id
      position
      subrank
      sponsored
      isActive
      daysRemainingAsNew
      item {
        id
        name
        imgUrl
        brandName
      }
    }
    errors {
      field
      message
    }
  }
}
    `;

export function useReorderNewItemPinsMutation() {
  return Urql.useMutation<ReorderNewItemPinsMutation, ReorderNewItemPinsMutationVariables>(ReorderNewItemPinsDocument);
};
export const RemoveNewItemPinDocument = gql`
    mutation removeNewItemPin($input: RemoveNewItemPinInput!) {
  removeNewItemPin(input: $input) {
    newItemPin {
      id
    }
    errors {
      field
      message
    }
  }
}
    `;

export function useRemoveNewItemPinMutation() {
  return Urql.useMutation<RemoveNewItemPinMutation, RemoveNewItemPinMutationVariables>(RemoveNewItemPinDocument);
};
export const NewItemMarketsForItemDocument = gql`
    query newItemMarketsForItem($itemId: ID!, $position: Int!) {
  newItemMarketsForItem(itemId: $itemId, position: $position) {
    warehouse {
      id
      name
    }
    existingPin {
      id
      item {
        id
        name
      }
    }
    currentPosition
  }
}
    `;

export function useNewItemMarketsForItemQuery(options: Omit<Urql.UseQueryArgs<NewItemMarketsForItemQueryVariables>, 'query'>) {
  return Urql.useQuery<NewItemMarketsForItemQuery>({ query: NewItemMarketsForItemDocument, ...options });
};
export const PinItemAcrossMarketsDocument = gql`
    mutation pinItemAcrossMarkets($input: PinItemAcrossMarketsInput!) {
  pinItemAcrossMarkets(input: $input) {
    pins {
      id
      position
      subrank
      sponsored
      isActive
      daysRemainingAsNew
      item {
        id
        name
        imgUrl
        brandName
      }
    }
    warehousesPinned
    warehousesBumped
    errors {
      field
      message
    }
  }
}
    `;

export function usePinItemAcrossMarketsMutation() {
  return Urql.useMutation<PinItemAcrossMarketsMutation, PinItemAcrossMarketsMutationVariables>(PinItemAcrossMarketsDocument);
};
export const GetItemAuditLogExtrasDocument = gql`
    query getItemAuditLogExtras($itemId: ID!) {
  categories {
    id
    name
  }
  procurementVendors {
    id
    name
  }
  units {
    id
    name
  }
  vendors {
    id
    name
    legalName
  }
  warehouses {
    id
    name
  }
  viewer {
    availableItemById(id: $itemId) {
      substitutionOverrides {
        id
        substituteItem {
          id
          name
        }
      }
    }
  }
}
    `;

export function useGetItemAuditLogExtrasQuery(options: Omit<Urql.UseQueryArgs<GetItemAuditLogExtrasQueryVariables>, 'query'>) {
  return Urql.useQuery<GetItemAuditLogExtrasQuery>({ query: GetItemAuditLogExtrasDocument, ...options });
};
export const GetReadOnlyItemExtrasDocument = gql`
    query getReadOnlyItemExtras {
  warehouses {
    id
    name
  }
  procurementVendors {
    id
    name
  }
}
    `;

export function useGetReadOnlyItemExtrasQuery(options?: Omit<Urql.UseQueryArgs<GetReadOnlyItemExtrasQueryVariables>, 'query'>) {
  return Urql.useQuery<GetReadOnlyItemExtrasQuery>({ query: GetReadOnlyItemExtrasDocument, ...options });
};
export const GetUpsertItemExtrasDocument = gql`
    query getUpsertItemExtras {
  warehouses {
    id
    name
  }
  categories(filter: TOP_LEVEL) {
    id
    name
    position
    subcategories {
      id
      name
      position
    }
  }
  procurementVendors {
    id
    name
  }
  vendors {
    id
    name
    legalName
    warehouse {
      name
    }
  }
  units {
    id
    name
    abbreviation
    conversionRate
    baseUnit {
      id
      name
      conversionRate
      unitType
    }
    unitType
  }
}
    `;

export function useGetUpsertItemExtrasQuery(options?: Omit<Urql.UseQueryArgs<GetUpsertItemExtrasQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUpsertItemExtrasQuery>({ query: GetUpsertItemExtrasDocument, ...options });
};
export const GetItemForEditDocument = gql`
    query getItemForEdit($itemId: ID!, $warehouseIds: [ID!]) {
  viewer {
    availableItemById(id: $itemId) {
      __typename
      id
      name
      brandName
      brand {
        id
        name
      }
      description
      catalogStatus
      inactivatedOn
      imgUrl
      itemSize
      size {
        quantity
        unit {
          id
          name
        }
      }
      updatedAt
      vendorCode
      dimensionalFactor
      eachHeightInches
      eachLengthInches
      eachWeightLbs
      eachWidthInches
      caseHeightInches
      caseLengthInches
      caseWeightLbs
      caseWidthInches
      casesPerPallet
      casesPerLayer
      layersPerPallet
      palletWeightLbs
      dimensioned
      nmfc
      refrigerationState
      transitMethod
      hasOwnImage
      category {
        id
        name
      }
      subcategory {
        id
        name
      }
      standingOrderBehavior
      maxQuantityPerLocation
      sampleMaxQuantityPerLocation
      tags {
        badgeUrl
        displayAs
        id
        name
        parentTag {
          badgeUrl
          displayAs
          id
          name
        }
      }
      ... on InventoryItem {
        manufacturedType
        marketPrice
        perishability
        upcCodes
        locationShelfLifeDays
        shelfLifeDays
        inventoryCheckBehavior
        isSerialized
        stockUnit {
          id
          name
          unitType
          baseUnit {
            name
            id
          }
        }
        purchaseUnit {
          id
          name
          unitType
          baseUnit {
            name
          }
        }
        procurementRecords {
          procurementVendor {
            id
          }
          warehouse {
            id
          }
          purchasePrice {
            amount
          }
        }
        warehouseAssociation(warehouseIds: $warehouseIds) {
          orderability
          customOrderabilityMessage
          standingOrderBehavior
          inventoryCheckBehavior
          procurementVendor {
            id
          }
          salePrice {
            cents
            currency
          }
          warehouse {
            id
          }
          sample {
            id
            name
          }
          hasSample
          customerFacingOutOfStock
          outOfStockSince
          configuredFulfillmentWarehouses {
            warehouse {
              id
              name
            }
          }
        }
        sampleUnit {
          name
          id
        }
        sampleUpcCodes
      }
      ... on NonInventoryItem {
        marketPrice
        markupPercentage
        minItemsPerOrder
        purchaseMultiple
        discontinuedOn
        warehouseAssociation(warehouseIds: $warehouseIds) {
          orderability
          customOrderabilityMessage
          standingOrderBehavior
          vendor {
            id
          }
          salePrice {
            cents
            currency
          }
          warehouse {
            id
          }
          sample {
            id
            name
          }
          hasSample
          customerFacingOutOfStock
          outOfStockSince
          configuredFulfillmentWarehouses {
            warehouse {
              id
              name
            }
          }
        }
        sampleUnit {
          name
          id
        }
      }
      purchasePrice {
        amount
        cents
        currency
      }
      saleUnit {
        id
        unitType
        name
        conversionRate
      }
    }
  }
}
    `;

export function useGetItemForEditQuery(options: Omit<Urql.UseQueryArgs<GetItemForEditQueryVariables>, 'query'>) {
  return Urql.useQuery<GetItemForEditQuery>({ query: GetItemForEditDocument, ...options });
};
export const GetSignedUploadImageByKeyDocument = gql`
    query getSignedUploadImageByKey($key: String!) {
  signedUploadImageByKey(key: $key) {
    url
  }
}
    `;

export function useGetSignedUploadImageByKeyQuery(options: Omit<Urql.UseQueryArgs<GetSignedUploadImageByKeyQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSignedUploadImageByKeyQuery>({ query: GetSignedUploadImageByKeyDocument, ...options });
};
export const GetSignedUploadImageUrlDocument = gql`
    query getSignedUploadImageUrl($extension: String!) {
  signedUploadImageUrl(extension: $extension) {
    url
    key
  }
}
    `;

export function useGetSignedUploadImageUrlQuery(options: Omit<Urql.UseQueryArgs<GetSignedUploadImageUrlQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSignedUploadImageUrlQuery>({ query: GetSignedUploadImageUrlDocument, ...options });
};
export const GetCategoriesForWarehouseDocument = gql`
    query getCategoriesForWarehouse($warehouseId: ID!) {
  warehouse(warehouseId: $warehouseId) {
    categories {
      parentCategory {
        id
      }
      id
      name
      position
      subcategories {
        id
        name
        position
      }
    }
  }
}
    `;

export function useGetCategoriesForWarehouseQuery(options: Omit<Urql.UseQueryArgs<GetCategoriesForWarehouseQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCategoriesForWarehouseQuery>({ query: GetCategoriesForWarehouseDocument, ...options });
};
export const GetWarehousesDocument = gql`
    query getWarehouses {
  warehouses {
    id
    name
  }
}
    `;

export function useGetWarehousesQuery(options?: Omit<Urql.UseQueryArgs<GetWarehousesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetWarehousesQuery>({ query: GetWarehousesDocument, ...options });
};
export const GetWarehouseLocationsDocument = gql`
    query getWarehouseLocations($warehouseId: ID!) {
  warehouse(warehouseId: $warehouseId) {
    locations {
      id
    }
  }
}
    `;

export function useGetWarehouseLocationsQuery(options: Omit<Urql.UseQueryArgs<GetWarehouseLocationsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetWarehouseLocationsQuery>({ query: GetWarehouseLocationsDocument, ...options });
};
export const GetWarehousesWithLeadTimeDocument = gql`
    query getWarehousesWithLeadTime {
  warehouses {
    id
    name
    brandedPaperLeadTime
  }
}
    `;

export function useGetWarehousesWithLeadTimeQuery(options?: Omit<Urql.UseQueryArgs<GetWarehousesWithLeadTimeQueryVariables>, 'query'>) {
  return Urql.useQuery<GetWarehousesWithLeadTimeQuery>({ query: GetWarehousesWithLeadTimeDocument, ...options });
};
export const GetProcurementVendorsDocument = gql`
    query getProcurementVendors {
  procurementVendors {
    id
  }
}
    `;

export function useGetProcurementVendorsQuery(options?: Omit<Urql.UseQueryArgs<GetProcurementVendorsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetProcurementVendorsQuery>({ query: GetProcurementVendorsDocument, ...options });
};
export const FindItemReadOnlyDocument = gql`
    query findItemReadOnly($itemId: ID!, $warehouseIds: [ID!], $withDiscardedAtItemTags: Boolean) {
  viewer {
    availableItemById(id: $itemId) {
      __typename
      id
      name
      description
      catalogStatus
      inactivatedOn
      createdAt
      createdBy
      imgUrl
      updatedAt
      vendorCode
      brandName
      brand {
        id
        name
      }
      category {
        name
      }
      subcategory {
        name
      }
      standingOrderBehavior
      maxQuantityPerLocation
      sampleMaxQuantityPerLocation
      refrigerationState
      transitMethod
      dimensionalFactor
      eachHeightInches
      eachLengthInches
      eachWeightLbs
      eachWidthInches
      caseHeightInches
      caseLengthInches
      caseWeightLbs
      caseWidthInches
      casesPerLayer
      casesPerPallet
      palletWeightLbs
      dimensioned
      nmfc
      layersPerPallet
      itemSize
      size {
        label
      }
      tags(withDiscardedAt: $withDiscardedAtItemTags) {
        badgeUrl
        displayAs
        id
        name
        parentTag {
          badgeUrl
          displayAs
          id
          name
          position
        }
        pivot {
          itemId
          discardedAt
        }
      }
      ... on InventoryItem {
        manufacturedType
        marketPrice
        perishability
        upcCodes
        locationShelfLifeDays
        shelfLifeDays
        inventoryCheckBehavior
        isSerialized
        stockUnit {
          name
          unitType
          baseUnit {
            name
          }
        }
        purchaseUnit {
          name
          unitType
          baseUnit {
            name
          }
        }
        procurementRecords {
          procurementVendor {
            id
          }
          warehouse {
            id
          }
          purchasePrice {
            amount
          }
        }
        warehouseAssociation(warehouseIds: $warehouseIds) {
          procurementVendor {
            id
            name
          }
          salePrice {
            cents
            currency
          }
          warehouse {
            id
            name
          }
          sample {
            id
            name
          }
          hasSample
          orderability
          standingOrderBehavior
          inventoryCheckBehavior
          customerFacingOutOfStock
          outOfStockSince
          configuredFulfillmentWarehouses {
            warehouse {
              id
              name
            }
          }
        }
        sampleUnit {
          name
          id
        }
        sampleUpcCodes
        erpRecordUrl
      }
      ... on NonInventoryItem {
        marketPrice
        markupPercentage
        minItemsPerOrder
        purchaseMultiple
        warehouseAssociation(warehouseIds: $warehouseIds) {
          vendor {
            id
            name
            legalName
            warehouse {
              name
            }
          }
          salePrice {
            cents
            currency
          }
          warehouse {
            id
            name
          }
          sample {
            id
            name
          }
          hasSample
          orderability
          standingOrderBehavior
          customerFacingOutOfStock
          outOfStockSince
          configuredFulfillmentWarehouses {
            warehouse {
              id
              name
            }
          }
        }
        sampleUnit {
          name
          id
        }
        erpRecordUrl
      }
      purchasePrice {
        amount
        cents
        currency
      }
      saleUnit {
        unitType
        name
        conversionRate
      }
    }
  }
  productInventory(productId: $itemId) {
    availableCount
    warehouse {
      id
      name
    }
  }
}
    `;

export function useFindItemReadOnlyQuery(options: Omit<Urql.UseQueryArgs<FindItemReadOnlyQueryVariables>, 'query'>) {
  return Urql.useQuery<FindItemReadOnlyQuery>({ query: FindItemReadOnlyDocument, ...options });
};
export const IndexTableItemsDocument = gql`
    query IndexTableItems($first: Int, $after: String, $filters: ItemsFiltersInput, $sortOrder: [ItemsSortOrder], $searchQuery: String) {
  viewer {
    availableItems(
      first: $first
      after: $after
      filters: $filters
      sortOrder: $sortOrder
      searchQuery: $searchQuery
    ) {
      edges {
        node {
          name
          id
          name
          brandName
          brand {
            id
            name
          }
          catalogStatus
          category {
            name
            id
            position
          }
          imgUrl
          saleUnit {
            name
          }
          updatedAt
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    `;

export function useIndexTableItemsQuery(options?: Omit<Urql.UseQueryArgs<IndexTableItemsQueryVariables>, 'query'>) {
  return Urql.useQuery<IndexTableItemsQuery>({ query: IndexTableItemsDocument, ...options });
};
export const IndexTableBrandsDocument = gql`
    query IndexTableBrands($first: Int, $after: String, $filters: ItemBrandsFiltersInput, $sortOrder: [ItemBrandsSortOrder]) {
  itemBrands(
    first: $first
    after: $after
    filters: $filters
    sortOrder: $sortOrder
  ) {
    edges {
      node {
        name
        id
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

export function useIndexTableBrandsQuery(options?: Omit<Urql.UseQueryArgs<IndexTableBrandsQueryVariables>, 'query'>) {
  return Urql.useQuery<IndexTableBrandsQuery>({ query: IndexTableBrandsDocument, ...options });
};
export const FindBrandByNameDocument = gql`
    query FindBrandByName($first: Int, $after: String, $filters: ItemBrandsFiltersInput, $sortOrder: [ItemBrandsSortOrder]) {
  itemBrands(
    first: $first
    after: $after
    filters: $filters
    sortOrder: $sortOrder
  ) {
    edges {
      node {
        name
        id
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

export function useFindBrandByNameQuery(options?: Omit<Urql.UseQueryArgs<FindBrandByNameQueryVariables>, 'query'>) {
  return Urql.useQuery<FindBrandByNameQuery>({ query: FindBrandByNameDocument, ...options });
};
export const ItemTagsDocument = gql`
    query ItemTags($first: Int, $after: String, $filters: ItemTagFiltersInput, $sortOrder: [ItemTagSortOrder], $searchQuery: String) {
  viewer {
    itemTags(
      first: $first
      after: $after
      filters: $filters
      sortOrder: $sortOrder
      searchQuery: $searchQuery
    ) {
      edges {
        node {
          id
          name
          badgeUrl
          position
          displayAs
          parentTag {
            id
            name
            position
          }
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    `;

export function useItemTagsQuery(options?: Omit<Urql.UseQueryArgs<ItemTagsQueryVariables>, 'query'>) {
  return Urql.useQuery<ItemTagsQuery>({ query: ItemTagsDocument, ...options });
};
export const AuditLogsForObjectDocument = gql`
    query AuditLogsForObject($after: String, $before: String, $endDate: ISO8601DateTime, $excludeObjectTypes: [String!], $first: Int, $itemId: ID, $last: Int, $objects: [AuditLogObjectInput], $sortOrder: [AuditLogSortOrder], $startDate: ISO8601DateTime) {
  viewer {
    auditLogs(
      after: $after
      before: $before
      endDate: $endDate
      excludeObjectTypes: $excludeObjectTypes
      first: $first
      itemId: $itemId
      last: $last
      objects: $objects
      sortOrder: $sortOrder
      startDate: $startDate
    ) {
      edges {
        cursor
        node {
          causedBy
          changeType
          date
          field
          itemId
          newValue
          objectId
          oldValue
          objectType
          user {
            email
            id
            name
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
}
    `;

export function useAuditLogsForObjectQuery(options?: Omit<Urql.UseQueryArgs<AuditLogsForObjectQueryVariables>, 'query'>) {
  return Urql.useQuery<AuditLogsForObjectQuery>({ query: AuditLogsForObjectDocument, ...options });
};
export const LocationChangeGroupsDocument = gql`
    query LocationChangeGroups($after: String, $before: String, $first: Int, $itemId: ID!, $last: Int) {
  viewer {
    locationChangeGroups(
      after: $after
      before: $before
      first: $first
      itemId: $itemId
      last: $last
    ) {
      edges {
        cursor
        node {
          changeType
          endedAt
          locationIds
          startedAt
          user {
            email
            id
            name
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
}
    `;

export function useLocationChangeGroupsQuery(options: Omit<Urql.UseQueryArgs<LocationChangeGroupsQueryVariables>, 'query'>) {
  return Urql.useQuery<LocationChangeGroupsQuery>({ query: LocationChangeGroupsDocument, ...options });
};
export const GetLandedCostForItemDocument = gql`
    query getLandedCostForItem($itemId: ID!, $warehouseIds: [ID!]) {
  viewer {
    availableItemById(id: $itemId) {
      name
      purchasePrice {
        amount
        cents
        currency
      }
      ... on InventoryItem {
        warehouseAssociation(warehouseIds: $warehouseIds) {
          landedCost {
            cents
            currency
          }
        }
      }
      ... on NonInventoryItem {
        warehouseAssociation(warehouseIds: $warehouseIds) {
          landedCost {
            cents
            currency
          }
        }
      }
    }
  }
}
    `;

export function useGetLandedCostForItemQuery(options: Omit<Urql.UseQueryArgs<GetLandedCostForItemQueryVariables>, 'query'>) {
  return Urql.useQuery<GetLandedCostForItemQuery>({ query: GetLandedCostForItemDocument, ...options });
};
export const GetItemNameByUuidDocument = gql`
    query getItemNameByUUID($itemId: ID!) {
  viewer {
    availableItemById(id: $itemId) {
      name
      catalogStatus
    }
  }
}
    `;

export function useGetItemNameByUuidQuery(options: Omit<Urql.UseQueryArgs<GetItemNameByUuidQueryVariables>, 'query'>) {
  return Urql.useQuery<GetItemNameByUuidQuery>({ query: GetItemNameByUuidDocument, ...options });
};
export const LocationDocument = gql`
    query Location($odekoUuid: ID) {
  location(odekoUuid: $odekoUuid) {
    businessName
  }
}
    `;

export function useLocationQuery(options?: Omit<Urql.UseQueryArgs<LocationQueryVariables>, 'query'>) {
  return Urql.useQuery<LocationQuery>({ query: LocationDocument, ...options });
};
export const LocationItemsByItemIdDocument = gql`
    query LocationItemsByItemId($locationItemsByItemId: ID!) {
  locationItemsByItemId(id: $locationItemsByItemId) {
    locationId
  }
}
    `;

export function useLocationItemsByItemIdQuery(options: Omit<Urql.UseQueryArgs<LocationItemsByItemIdQueryVariables>, 'query'>) {
  return Urql.useQuery<LocationItemsByItemIdQuery>({ query: LocationItemsByItemIdDocument, ...options });
};
export const LocationsSearchDocument = gql`
    query locationsSearch($first: Int!, $name: String!) {
  viewer {
    locations(first: $first, name: $name) {
      nodes {
        id
        businessName
        warehouse {
          id
          name
        }
      }
    }
  }
}
    `;

export function useLocationsSearchQuery(options: Omit<Urql.UseQueryArgs<LocationsSearchQueryVariables>, 'query'>) {
  return Urql.useQuery<LocationsSearchQuery>({ query: LocationsSearchDocument, ...options });
};
export const CreateCollectionPromoSetupDocument = gql`
    mutation createCollectionPromoSetup($input: CreateCollectionPromoSetupInput!) {
  createCollectionPromoSetup(input: $input) {
    collectionId
    promoPageId
    errors {
      field
      message
    }
  }
}
    `;

export function useCreateCollectionPromoSetupMutation() {
  return Urql.useMutation<CreateCollectionPromoSetupMutation, CreateCollectionPromoSetupMutationVariables>(CreateCollectionPromoSetupDocument);
};
export const GetCollectionDocument = gql`
    query getCollection($id: ID, $referenceId: String, $type: String) {
  collection(id: $id, referenceId: $referenceId, type: $type) {
    id
    name
    description
    promoName
    slug
    type
    aggregation
    reference
    referenceId
  }
}
    `;

export function useGetCollectionQuery(options?: Omit<Urql.UseQueryArgs<GetCollectionQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCollectionQuery>({ query: GetCollectionDocument, ...options });
};
export const GetCollectionItemsDocument = gql`
    query getCollectionItems($first: Int, $after: String, $filters: ItemsFiltersInput) {
  viewer {
    availableItems(first: $first, after: $after, filters: $filters) {
      edges {
        node {
          __typename
          id
          name
          brandName
          imgUrl
          ... on InventoryItem {
            warehouseAssociation {
              warehouse {
                name
              }
            }
          }
          ... on NonInventoryItem {
            warehouseAssociation {
              warehouse {
                name
              }
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    `;

export function useGetCollectionItemsQuery(options?: Omit<Urql.UseQueryArgs<GetCollectionItemsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCollectionItemsQuery>({ query: GetCollectionItemsDocument, ...options });
};
export const GetCollectionSetupForEditDocument = gql`
    query getCollectionSetupForEdit($collectionId: ID!) {
  collectionSetupForEdit(collectionId: $collectionId) {
    collection {
      id
      name
      description
      promoName
      slug
    }
    itemIds
    promoPageWarehouses {
      warehouse {
        id
        name
      }
      desktopHeroImage
      mobileHeroImage
    }
    homepageComponents {
      componentId
      componentType
      warehouseAttributes {
        warehouse {
          id
          name
        }
        desktopImage
        mobileImage
        image
        fontStyle
        enabled
      }
    }
    displayRules {
      ruleId
      componentId
      componentType
      position
      startDate
      endDate
      warehouseIds
    }
  }
}
    `;

export function useGetCollectionSetupForEditQuery(options: Omit<Urql.UseQueryArgs<GetCollectionSetupForEditQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCollectionSetupForEditQuery>({ query: GetCollectionSetupForEditDocument, ...options });
};
export const GetCatalogHomepageRowsDocument = gql`
    query getCatalogHomepageRows($date: ISO8601Date) {
  catalogHomepageRows(date: $date) {
    position
    activeNow {
      ruleId
      collection {
        id
        name
      }
      startDate
      endDate
      enabledWarehouseCount
      configuredWarehouseCount
      warehouseIds
      warehouses {
        id
        name
      }
    }
    scheduled {
      ruleId
      collection {
        id
        name
      }
      startDate
      endDate
      enabledWarehouseCount
      configuredWarehouseCount
      warehouseIds
      warehouses {
        id
        name
      }
    }
  }
}
    `;

export function useGetCatalogHomepageRowsQuery(options?: Omit<Urql.UseQueryArgs<GetCatalogHomepageRowsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCatalogHomepageRowsQuery>({ query: GetCatalogHomepageRowsDocument, ...options });
};
export const GetPastHomepageCollectionsDocument = gql`
    query getPastHomepageCollections($date: ISO8601Date) {
  pastHomepageCollections(date: $date) {
    ruleId
    collection {
      id
      name
    }
    componentType
    startDate
    endDate
    enabledWarehouseCount
    configuredWarehouseCount
    warehouseIds
    warehouses {
      id
      name
    }
  }
}
    `;

export function useGetPastHomepageCollectionsQuery(options?: Omit<Urql.UseQueryArgs<GetPastHomepageCollectionsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPastHomepageCollectionsQuery>({ query: GetPastHomepageCollectionsDocument, ...options });
};
export const GetMasterHomepagesDocument = gql`
    query getMasterHomepages {
  masterHomepages {
    id
    name
    startDate
    endDate
  }
}
    `;

export function useGetMasterHomepagesQuery(options?: Omit<Urql.UseQueryArgs<GetMasterHomepagesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetMasterHomepagesQuery>({ query: GetMasterHomepagesDocument, ...options });
};
export const GetMasterHomepageForEditDocument = gql`
    query getMasterHomepageForEdit($id: ID!) {
  masterHomepageForEdit(id: $id) {
    id
    name
    startDate
    endDate
    rows {
      id
      sortOrder
      structureType
      components {
        id
        catalogComponentId
        collectionId
        componentType
        sortOrder
        startDate
        endDate
        warehouseIds
        desktopImage
        mobileImage
        fontStyle
        image
      }
    }
  }
}
    `;

export function useGetMasterHomepageForEditQuery(options: Omit<Urql.UseQueryArgs<GetMasterHomepageForEditQueryVariables>, 'query'>) {
  return Urql.useQuery<GetMasterHomepageForEditQuery>({ query: GetMasterHomepageForEditDocument, ...options });
};
export const GetCollectionsPageDocument = gql`
    query getCollectionsPage {
  collectionsPage {
    collection {
      id
      name
      slug
    }
    configuredWarehouseCount
    warehouseIds
    warehouses {
      id
      name
    }
  }
}
    `;

export function useGetCollectionsPageQuery(options?: Omit<Urql.UseQueryArgs<GetCollectionsPageQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCollectionsPageQuery>({ query: GetCollectionsPageDocument, ...options });
};
export const ItemIssuesTableItemsDocument = gql`
    query ItemIssuesTableItems($first: Int, $after: String, $filters: ItemsFiltersInput, $sortOrder: [ItemsSortOrder], $searchQuery: String) {
  viewer {
    availableItems(
      first: $first
      after: $after
      filters: $filters
      sortOrder: $sortOrder
      searchQuery: $searchQuery
    ) {
      edges {
        node {
          __typename
          id
          name
          brand {
            id
            name
          }
          description
          hasOwnImage
          imgUrl
          category {
            name
            id
          }
          updatedAt
          ... on InventoryItem {
            upcCodes
            warehouseAssociation {
              warehouse {
                id
                name
              }
            }
          }
          ... on NonInventoryItem {
            warehouseAssociation {
              warehouse {
                id
                name
              }
            }
          }
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
}
    `;

export function useItemIssuesTableItemsQuery(options?: Omit<Urql.UseQueryArgs<ItemIssuesTableItemsQueryVariables>, 'query'>) {
  return Urql.useQuery<ItemIssuesTableItemsQuery>({ query: ItemIssuesTableItemsDocument, ...options });
};
export const ItemOosSubstitutesDocument = gql`
    query itemOosSubstitutes($itemId: ID!, $limit: Int) {
  viewer {
    availableItemById(id: $itemId) {
      id
      substitutionPreview(limit: $limit) {
        id
        name
        brandName
        imgUrl
      }
      substitutionOverrides {
        id
        source
        substituteItem {
          id
        }
      }
    }
  }
}
    `;

export function useItemOosSubstitutesQuery(options: Omit<Urql.UseQueryArgs<ItemOosSubstitutesQueryVariables>, 'query'>) {
  return Urql.useQuery<ItemOosSubstitutesQuery>({ query: ItemOosSubstitutesDocument, ...options });
};
export const ItemSubstitutesManagementDocument = gql`
    query itemSubstitutesManagement($itemId: ID!, $warehouseId: ID, $limit: Int) {
  viewer {
    availableItemById(id: $itemId) {
      id
      name
      substitutionPreview(warehouseId: $warehouseId, limit: $limit) {
        id
        name
        brandName
        imgUrl
      }
      substitutionOverrides {
        id
        priority
        reason
        source
        substituteItem {
          id
          name
          brandName
          imgUrl
        }
      }
    }
  }
}
    `;

export function useItemSubstitutesManagementQuery(options: Omit<Urql.UseQueryArgs<ItemSubstitutesManagementQueryVariables>, 'query'>) {
  return Urql.useQuery<ItemSubstitutesManagementQuery>({ query: ItemSubstitutesManagementDocument, ...options });
};
export const GetCategoryTreeDocument = gql`
    query getCategoryTree {
  categories(filter: TOP_LEVEL) {
    id
    name
    position
    activeWarehouses {
      id
      name
    }
    bannerWarehouses {
      id
      name
    }
    hasBannerDefaultCreative
    subcategories {
      id
      name
      position
      activeWarehouses {
        id
        name
      }
      bannerWarehouses {
        id
        name
      }
      hasBannerDefaultCreative
    }
  }
}
    `;

export function useGetCategoryTreeQuery(options?: Omit<Urql.UseQueryArgs<GetCategoryTreeQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCategoryTreeQuery>({ query: GetCategoryTreeDocument, ...options });
};
export const GetCategoryBannerForEditDocument = gql`
    query getCategoryBannerForEdit($categoryId: ID!) {
  categoryBannerForEdit(categoryId: $categoryId) {
    categoryBannerId
    category {
      id
      name
      activeWarehouses {
        id
        name
      }
      subcategories {
        id
        name
      }
    }
    defaultCreative {
      desktopImage
      mobileImage
      shippingBehavior
      shippingDesktopImage
      shippingMobileImage
      destinationType
      destinationRef
    }
    warehouses {
      warehouse {
        id
        name
      }
      hidden
      desktopImage
      mobileImage
      shippingBehavior
      shippingDesktopImage
      shippingMobileImage
      destinationType
      destinationRef
    }
  }
}
    `;

export function useGetCategoryBannerForEditQuery(options: Omit<Urql.UseQueryArgs<GetCategoryBannerForEditQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCategoryBannerForEditQuery>({ query: GetCategoryBannerForEditDocument, ...options });
};